export default {
  es: {
    alt_images: {
      logo_ajusa: "Ajusa",
      app_movil: "Aplicación móvil de Ajusa",
      google_play: "Descargar la aplicación en Google Play",
      app_store: "Descargar la aplicación en el App Store",
      telefono: "Llamar por teléfono a Ajusa",
      email: "Escribir un correo a Ajusa",
      vehiculo_electrico: "Ajusa Electric Vehicle Line",
      cerrar: "Cerrar",
      retenes: "Retenes de aceite Ajusa",
      ver_video: "Ver el vídeo",
      ajustick: "Ajustick, sellante anaeróbico de Ajusa",
    },
    cookieEyes: "045d3ec4b8d29118370163bd",
    recaptchaId: "6Lee-m8fAAAAABTeuBvigSTzmj9MGBqTtnldUAo8",
    isotag: "es-ES",
    enlaces: {
      home: "/",
      productos: "productos",
      product: "producto",
      productos_quimicos: "productos-quimicos",
      catalogo: "catalogo",
      area_tecnica: "area-tecnica",
      asesoramiento: "asesoramiento",
      ajusa: "ajusa",
      actualidad: "actualidad",
      contacto: "contacto",
      trabaja_con_nosotros: "trabaja-con-nosotros",
      donde_estamos: "contacto",
      solicite_catalogo: "contacto#catalogo",
      blog: "blog",
      blog_noticia: "blog/noticia",
      blog_categoria: "blog/categoria",
      ferias: "ferias",
      historia: "historia",
      nuestro_sector: "nuestro-sector",
      compromiso_social: "compromiso-social",
      sala_prensa: "sala-de-prensa",
      mapa_web: "mapa-web",
      politica: "politica-de-privacidad",
      politica_cookies: "politica-de-cookies",
      datos_seguros: "tus-datos-seguros",
      aviso_legal: "aviso-legal",
      aniversario50: "50-aniversario",
      vehiculo_electrico: "vehiculo-electrico",
      sobre_nosotros: "ajusa",
      productos_certificados: "/static/pdf/certificado-medio-ambiente.pdf",
      productos_certificados_calidad: "/static/pdf/certificados-calidad.pdf",
      condiciones_venta: "/static/pdf/condiciones-de-venta-es.pdf",
      catalogo_online: "https://web.tecalliance.net/ajusa/es/",
      bonos_ajusa: "bonos-ajusa",
      thank_you_page: "gracias",
      newsletter_thank: "newsletter/gracias",
      online_store: "https://ev-clientes.ajusa.online/",
      certificado_IATF_16949: "/static/pdf/IATF-16949-es.pdf",
      certificado_ISO_9001: "/static/pdf/ISO-9001-es.pdf",
      certificado_ISO_14001: "/static/pdf/ISO-14001-es.pdf",
      textos: {
        inicio: "Inicio",
        productos: "Productos",
        catalogo: "Catálogo",
        otrosCatalogos: "Otros Catálogos",
        area_tecnica: "Área Técnica",
        ajusa: "Ajusa",
        actualidad: "Actualidad",
        contacto: "Contacto",
        sala_prensa: "Sala de prensa",
        blog: "Blog",
        historia: "Historia",
        tecnologias_hidrogeno: "Tecnologías de hidrógeno",
        contacto: "Contacto",
        trabaja_con_nosotros: "Trabaja con nosotros",
        mapa_web: "Mapa Web",
        condiciones_venta: "Condiciones de venta",
        politica_privacidad: "Política de privacidad",
        datos_seguros: "Tus datos seguros",
        politica_cookies: "Política de cookies",
        aviso_legal: "Aviso legal",
        catalogo_general: "Catálogo general",
        catalogo_turbos: "Catálogo turbos",
        catalogo_juntas_compresor: "Catálogo juntas de compresor",
        catalogo_retenes: "Catálogo Retenes",
        catalogo_juegosJuntas: "Catálogo juegos especiales de juntas",
        tec_alliance: "Catálogo online",
        catalogo_impreso: "Solicitar catálogo impreso",
        newsletter: "Ajusa",
        catalogo_arandelas: "Catálogo arandelas de cobre",
        catalogo_motor_electrico: "Catálogo VE",
        catalogo_comprensorAC: "Catálogo juntas compresor A/C VE",
        catalogo_toricas: "Catálogo tóricas",
        catalogo_retenes: "Catálogo retenes de aceite",
        aniversario50: "50 aniversario",
        vehiculo_electrico: "Vehículo eléctrico",
        sobre_nosotros: "Sobre nosotros",
        online_store: "ÁREA DE CLIENTES EV",
        certificado_IATF_16949: "IATF 16949",
        certificado_ISO_9001: "ISO 9001",
        certificado_ISO_14001: "ISO 14001"
      },
      seo: {
        home: {
          title: "Juntas Ajusa | Repuestos para motores",
          description:
            "Ajusa es un proveedor líder de juntas de culata y otros componentes para el motor. Con más de 50 años de experiencia en la industria de la automoción, le garantizamos productos de calidad y confiables."
        },
        productos: {
          title: "Productos | Juntas Ajusa",
          description:
            "La mejor selección de autopartes y componentes del motor en el catálogo Ajusa. Nuestras piezas y accesorios de alta calidad están diseñados para sacar el mejor rendimiento del motor de su vehículo."
        },
        catalogo: {
          title: "Catálogo | Juntas Ajusa",
          description:
            "Compra las juntas, retenes y componentes del motor de máxima calidad que necesitas con Ajusa. Explore nuestro catálogo de piezas OEM y encuentre la pieza de repuesto perfecta para su vehículo."
        },
        area_tecnica: {
          title: "Área Técnica | Juntas Ajusa",
          description:
            "Ajusa ofrece una completa gama de opciones de juntas y soluciones para el sellado del motor. Encuentra la información necesaria sobre nuestras juntas y componentes del motor en el área técnica de nuestra web, que encontrará una guía completa de informes técnicos y vídeos de mecánica."
        },
        sobre_nosotros: {
          title: "Sobre nosotros | Calidad, servicio y equipo de Ajusa",
          description:
            "Ajusa es un proveedor líder de juntas y retenes de primera calidad para el mercado de recambios de automoción. Ofrecemos una amplia selección de juntas, retenes, tubos de engrase y otros componentes para el motor. "
        },
        aniversario50: {
          title: "Nuestra Historia | Juntas Ajusa",
          description:
            "Conozca la historia de Ajusa: cómo comenzó todo, cómo evolucionó y dónde estamos ahora. 50 años de experiencia en la industria de juntas automotrices y componentes del motor."
        },
        ajusa: {
          title: "Sobre nosotros | Juntas Ajusa",
          description:
            "Ajusa es un proveedor líder de juntas y retenes de primera calidad para el mercado de recambios de automoción. Ofrecemos una amplia selección de juntas, retenes, tubos de engrase y otros componentes para el motor."
        },
        actualidad: {
          title: "Actualidad | Juntas Ajusa",
          description:
            "Recibe las últimas noticias sobre juntas Ajusa. Cubrimos los últimos desarrollos, desde lanzamientos de productos hasta avances tecnológicos."
        },
        contacto: {
          title: "Contacto | Juntas Ajusa",
          description:
            "¿Necesita ayuda con juntas o retenes? Póngase en contacto con Ajusa para obtener el mejor servicio y soporte. Nuestro equipo experimentado está listo para responder cualquier pregunta que tenga."
        },
        blog: {
          title: "Blog | Juntas Ajusa",
          description:
            "El blog de Ajusa es un espacio para profesionales y expertos del sector de la automoción, para mecánicos y talleres en el que te contamos las últimas novedades de Ajusa y de todo lo que sucede en el sector del recambio.",
          toblog: true
        },
        sala_prensa: {
          title: "Sala de Prensa | Juntas Ajusa",
          description:
            "Manténgase actualizado sobre las últimas noticias y lanzamientos de productos de Ajusa. Explore nuestra sala de prensa para leer nuestros comunicados de prensa, descripciones de productos y más."
        },
        trabaja_con_nosotros: {
          title: "Trabaja con nosotros | Juntas Ajusa",
          description:
            "Ajusa siempre está buscando profesionales motivados y trabajadores para unirse a nuestro equipo. Te escuchamos. Envíanos tu currículum hoy."
        },
        historia: {
          title: "Historia de Ajusa | Más de 50 años en la automoción",
          description:
            "AJUSA nació en 1972 en Albacete (España). Empezó fabricando juntas de culata y actualmente desarrolla una línea completa de componentes del motor y de recambios."
        },
        mapa_web: {
          title: "Mapa web | Juntas Ajusa",
          description: "Mapa web de Ajusa: accede desde un solo índice a todos los productos, catálogos, área técnica, sala de prensa y al resto de secciones de nuestro sitio."
        },
        politica: {
          title: "Política de privacidad | Juntas Ajusa",
          description:
            "La Política de Protección de Datos de AUTO JUNTAS SAU descansa en el principio de responsabilidad proactiva, según el cual el responsable del tratamiento es responsable del cumplimiento del marco normativo y jurisprudencial que gobierna dicha Política."
        },
        politica_cookies: {
          title: "Política de Cookies | Juntas Ajusa",
          description:
            "A cookie is a small information file that is stored in your browser every time you visit our website. It saves your activity history on the website so it can identify you and configure the content based on your browsing habits and preferences."
        },
        aviso_legal: {
          title: "Aviso legal | Juntas Ajusa",
          description:
            "El acceso a las páginas Web de este sitio implica la aceptación de todas las condiciones expresadas en esta información legal. Ajusa podrá modificar la estructura y diseño del Web, así como cambiar o eliminar los contenidos y las condiciones de acceso."
        },
        datos_seguros: {
          title: "Datos seguros | Juntas Ajusa",
          description:
            "Con carácter general, sus datos personales que se faciliten a través de la web de Ajusa serán usados para poder relacionarnos con esa persona y poder prestarle mejor servicio. También pueden ser usados para enviar publicidad o promocionar nuestras actividades."
        },
        bonos_ajusa: {
          title: "Bonos Ajusa | 20% de descuento para tu taller mecánico",
          description:
            "Para beneficiarte de la promoción Bonos Ajusa 20% de descuento, puedes llamar al 967 216 212 o rellenar este formulario. En breve, nos pondremos en contacto contigo para explicarte como canjear los descuentos."
        },
        vehiculo_electrico: {
          title: "Vehículo Eléctrico",
          description:
            "Ajusa cuenta con un amplío catálogo de componentes para reparar vehículos híbridos y eléctricos. Además, te ayuda en su reparación con fichas explicativas de cada avería que puedes descargar en esta sección, y con vídeo tutoriales grabados por un especialista en reparación de vehículos eléctricos."
        },
        blog_categoria: {
          ferias: {
            title: "Ferias automoción | Juntas Ajusa",
            description:
              "Ajusa ofrece un amplío catálogo de juntas que expone anualmente en ferias y otros eventos del sector de la automoción. Nuestro equipo de expertos ofrece productos de calidad y un excelente servicio al cliente."
          },
          productos: {
            title: "Blog productos | Juntas Ajusa",
            descripcion: ""
          },
          "nuestro-sector": {
            title: "Sector automoción | Juntas Ajusa",
            description: ""
          },
          "compromiso-social": {
            title: "Compromiso Social | Juntas Ajusa",
            description:
              "En Juntas Ajusa , creemos en hacer más que fabricar productos de calidad. Explore nuestras iniciativas sociales y aprenda cómo marcamos la diferencia con nuestro programa de responsabilidad social."
          }
        },
        junta_culata: {
          title: "Juntas de culata MLS, FiberMax y caucho-metal | Ajusa",
          description:
            "Especializados en la fabricación de juntas de culata desde 1972. Encuentra más de 200.000 productos para vehículos ligeros e industriales en nuestro catálogo online.",
          keyword: "juntas de culata"
        },
        junta_motor: {
          title: "Juegos de juntas completos para motor | Juntas Ajusa",
          description:
            "Los juegos de juntas Ajusa brindan una opción de recambio completo para mecánicos y profesionales del sector de la automoción. Encuentra aquí todas las piezas que necesitas para realizar una reparación completa del motor.",
          keyword: "juegos de juntas"
        },
        tornillos: {
          title: "Tornillos de culata | Juegos completos | Juntas Ajusa",
          description:
            "Consulte nuestro amplio catálogo de tornillos de culata para motores tanto de vehículo ligero como industrial. Aumente el rendimiento de su motor con los componentes del motor Ajusa",
          keyword:
            "pernos de culata, tornillos de culata, pernos de cabeza, apriete angular de los tornillos de culata, manual de apriete tornillos de culata"
        },
        retenes: {
          title: "Retenes de aceite y retenes de válvula | Juntas Ajusa",
          description:
            "Aumente la longevidad del motor con los retenes de aceite premium de Ajusa. Consulte nuestro catálogo para obtener un rendimiento a prueba de fugas y asegure la eficiencia de su vehículo con esta pieza.",
          keyword: "retenes de aceite, sellos de aceite"
        },
        tubos_engrase: {
          title: "Tubos de engrase para turbocompresor | Juntas Ajusa",
          description:
            "Optimice el motor de su vehículo con tubos de engrase Ajusa. Maximizan su rendimiento y durabilidad.",
          keyword: "tubos de engrase, turbocompresor"
        },
        tubos_egr: {
          title: "Tubos EGR para sistemas de recirculación | Juntas Ajusa",
          description:
            "Reduce las emisiones de óxidos de nitrógeno (NOx) de combustión interna de su vehículo con tubos EGR Ajusa.",
          keyword: "tubos EGR, obstrucción"
        },
        tubos_refrigeracion: {
          title: "Tubos de refrigeración para el motor | Juntas Ajusa",
          description:
            "Optimiza el rendimiento y la durabilidad del turbocompresor con los tubos de refrigeración del turbo de Ajusa.",
          keyword: "tubos de refrigeracion, refrigeracion"
        },
        junta_turbo: {
          title: "Juegos de juntas para turbocompresor | Juntas Ajusa",
          description:
            "¡Desbloquee el verdadero potencial de su vehículo con nuestros juegos de juntas para turbo! Aumenta el rendimiento y libera la velocidad de su vehículo.",
          keyword: "kit de montaje de turbo, juego de juntas para turbo"
        },
        productos_quimicos: {
          title: "Productos químicos | Sellantes y lubricantes de Ajusa",
          description:
            "Explore nuestra amplia gama de productos químicos para vehículos. Selladores, lubricantes de motor y potentes fijadores de roscas para mantener su motor en óptimas condiciones.",
          keyword:
            "productos quimicos, sellantes, lubricantes de motor, fijadores de roscas"
        },
        taques: {
          title: "Taqués hidráulicos para motor | Recambios Juntas Ajusa",
          description:
            "En Ajusa, te ofrecemos una amplia variedad de taqués hidráulicos para que encuentres el componente que necesitas en cada ocasión. ¡Contáctanos hoy mismo!",
          keyword:
            "taques hidraulicos, buzos hidraulicos, botadores hidraulicos "
        },
        arbol_levas: {
          title: "Árboles de levas para turismos e industriales | Ajusa",
          description:
            "¡Descubre la amplia gama de árboles de levas disponibles en Ajusa! Aumenta el rendimiento de tu motor con nuestros componentes de alta calidad; somos tu mejor opción para optimizar tu vehículo.",
          keyword: "árboles de levas"
        },
        otros: {
          title: "Otros componentes de motor | Recambios Juntas Ajusa",
          description:
            "¿Estás buscando otros componentes de Ajusa? En nuestro catálogo encontrarás una amplia gama de juntas para diversas piezas del motor, como bombas de agua, válvulas EGR, termostatos y más.",
          keyword:
            "otros componentes ajusa, valvula EGR, juntas para bomba de agua, juntas para compresores de freno"
        },
        vehiculo_electrico: {
          title: "Vehículo eléctrico | Componentes EV de Juntas Ajusa",
          description:
            "Ajusa dispone de una amplia gama de componentes para coches híbridos y eléctricos. ¡Además, Ajusa también te ayuda a realizar las reparaciones dándote explicaciones de cada avería!",
          keyword:
            "componentes para coches híbridos, componentes para coches eléctricos"
        }
      }
    },
    genericos: {
      no_resultados: "No se han encontrado resultados",
      leer_mas: "LEER MÁS",
      paginador: {
        siguiente: "Siguiente",
        anterior: "Anterior"
      }
    },
    home: {
      intro: {
        titulo: "CRECEMOS <span class='bold'>JUNTOS",
        texto:
          "AJUSA fabricó su primera junta de culata en 1972. En la actualidad, tiene el <a class='bold' style='text-decoration: underline !important; cursor: pointer !important;' href='{link}' target='_blank'>catálogo de juntas</a> para el motor más amplio del sector y la gama más completa de tornillos de culata, taqués hidráulicos, árboles de levas, tubos de engrase y juegos de juntas para turbo.",
        boton: "Vídeo corporativo",
        video: "vjFYe_seVTk"
      },
      excelencia: {
        intro:
          "<h1 class='title title-52'>Ajusa</h1><h2 class='title title-52'>LA <span class='bold'>EXCELENCIA</span><br>EN LA AUTOMOCIÓN</h2>",
        texto:
          "Toda una vida cuidando de tu vehículo. Líderes en la fabricación y distribución mundial de componentes del motor para <span class='bold'>automóviles, vehículos industriales y vehículos eléctricos.</span>"
      },
      calidad: {
        titulo: {
          first: "calidad original",
          second: "MEJORADA",
          third: "en todos",
          fourth: "nuestros <strong>productos</strong>"
        },
        texto:
          "A tu disposición. El catálogo AJUSA supera ampliamente las 200.000 referencias y se actualiza permanentemente en su versión digital, y cada dos años en formato impreso."
      },
      calidad_2: {
        texto_1:
          "Innovación constante. Contamos con un <strong class='bold'>equipo de profesionales cualificados</strong> que trabajan con la última tecnología y en instalaciones dotadas con la maquinaria más sofisticada.",
        texto_2:
          "<strong class='bold'>Productos de vanguardia para clientes exigentes.</strong> Respetamos los más altos estándares de calidad en todas nuestras líneas de producto: juntas de culata, juegos de juntas para motor, tornillos de culata, tubos de engrase, juegos de juntas para turbo, taqués hidráulicos, árboles de levas, sellantes, lubricante para el motor y kits de reparación para vehículo eléctrico."
      },
      calidad_3: {
        titulo: "<h2 class='title title-36'>MARCAMOS<br>LA DIFERENCIA</h2>",
        texto:
          "Prestamos un <strong class='bold'>servicio integral</strong> a nuestros clientes, ofreciendo asesoramiento y asistencia técnica personalizada, mediante contacto directo con nuestro equipo de ingenieros, así como a través de seminarios, tanto presenciales como en <i>streaming</i>.<br>A nuestras sucursales en México, Brasil, Inglaterra, Estados Unidos y Francia, se unen más de 500 distribuidores autorizados por todo el mundo. <a class='link' href='{link}' target='_blank'>Solicita Webinar</a>"
      },
      productos: {
        titulo:
          "<h2 class='title title-26'>NUESTROS <span class='bold'>PRODUCTOS</span></h2>"
      },
      destacados: {
        titulo: "DESTACADOS"
      },
      ajusa_app: {
        title: "AJUSA MOBILE"
      },
      alt_images: {
        fabricante: "fabricante de componentes del motor",
        junta_culata: "junta de culata",
        mobile_app: "ajusa mobile APP",
        tubos_engrase: "tubos de engrase",
        junta_motor: "juntas para el motor ajusa"
      }
    },
    productos: {
      keys: {
        "junta-culata": "junta_culata",
        "junta-motor": "junta_motor",
        tornillos: "tornillos",
        retenes: "retenes",
        "tubos-engrase": "tubos_engrase",
        "tubos-egr": "tubos_egr",
        "tubos-refrigeracion": "tubos_refrigeracion",
        "junta-turbo": "junta_turbo",
        "productos-quimicos": "productos_quimicos",
        taques: "taques",
        "arbol-levas": "arbol_levas",
        otros: "otros"
      },
      intro: {
        titulo: "<h1 class='title title-52'>AJUSA productos</h1>",
        texto:
          "Especialistas en la fabricación de componentes para motores de combustión interna tanto de automóviles como de vehículos industriales. Líderes también en el desarrollo de piezas para motores con turbo."
      },
      btn_ficha_tecnica: "INFORMACIÓN TÉCNICA",
      btn_ficha_seguridad: "INFORMACIÓN DE SEGURIDAD",
      junta_culata: {
        titulo: "juntas de culata",
        texto:
          "Las juntas de culata son nuestra línea de producto tradicional. Prestamos una cobertura total tanto para turismos como para vehículos industriales y agrícolas. Juntas MLS, FiberMax y Caucho -Metal.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil.pdf",
        details: {
          intro: {
            alt: "junta culata",
            title: '<h1 class="title title-36">Juntas de culata</h1>',
            text:
              "<p>Las juntas de culata de alta calidad de Ajusa garantizan un rendimiento óptimo del motor.</p><p>Diseñadas con precisión y fabricadas con experiencia, nuestras juntas de culata están diseñadas para proporcionar un rendimiento y una fiabilidad máxima. La junta de culata es un componente crítico que sella la culata del cilindro al bloque del motor, asegurando una combustión eficiente y preservando la integridad de la cámara de combustión.</p><p>Este pieza juega un papel fundamental en la prevención de fugas de gases, aceite y refrigerante, optimizando así el rendimiento general del motor. Las piezas están meticulosamente diseñadas para soportar temperaturas extremas, diferenciales de presión y diversos entornos químicos, lo que las hace ideales para motores estándar y de alto rendimiento de vehículos ligeros e industriales.</p>",
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/junta-culata-1.webp",
                alt: "juntas de culata ajusa"
              },
              {
                img: "/static/img/products/junta-culata-2.webp",
                alt: "comprar juntas de culata"
              },
              {
                img: "/static/img/products/junta-culata-3.webp",
                alt: "juntas de culata mls"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Materiales de fabricación de las juntas de culata",
              content:
                "<p>Nuestras juntas de culata se fabrican con materiales de alta calidad, como acero multicapa (MLS), grafito o elastómero, adaptados a los requisitos específicos de cada motor. Estos materiales poseen excelentes propiedades de sellado, uniendo eficazmente la cámara de combustión y minimizando el riesgo de fugas.</p><p>Nuestras juntas están diseñadas para combinar con motores de gasolina o diésel, lo que garantiza un rendimiento y una fiabilidad óptimos.</p>"
            },
            "tip-2": {
              title: "Juntas de culata de larga duración",
              content:
                "<p>La durabilidad es una característica clave de todos nuestros productos. Entendemos las demandas que se imponen a los motores modernos y nuestras juntas de culata están diseñadas para soportar condiciones extremas. Con una resistencia excepcional al calor, la presión y la exposición química, son adecuados para mantener su integridad durante períodos prolongados, lo que reduce la necesidad de reemplazos frecuentes.</p><p>Al proporcionar un sello hermético entre la culata y el bloque del motor, nuestras juntas contribuyen a mejorar la eficiencia de la combustión, lo que se traduce en una mayor economía de combustible, emisiones reducidas y un mejor rendimiento general del motor.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "¿Cuáles son los síntomas de una mala junta de la culata?",
              content:
                "<p>Una junta de culata defectuosa puede dar lugar a una serie de síntomas que indican posibles problemas en el motor de un vehículo.</p><p>Una de las principales indicaciones de una pieza problemática es el sobrecalentamiento del motor. Cuando la junta falla, puede provocar que el refrigerante se filtre en la cámara de combustión, lo que interrumpe el sistema de enfriamiento del motor y provoca un sobrecalentamiento que puede ocasionar daños importantes si no se soluciona de inmediato.</p><p>Otro síntoma a tener en cuenta es la pérdida de refrigerante sin fugas visibles. Si necesita rellenar con frecuencia el depósito de refrigerante o nota una disminución en los niveles de refrigerante con el tiempo, puede indicar una junta de culata dañada.</p><p>Una pieza quemada también puede manifestarse como humo de escape blanco o grisáceo. Esto ocurre cuando el refrigerante se filtra en la cámara de combustión y se quema junto con el combustible. El humo resultante puede tener un olor distinto, que puede ser particularmente perceptible durante la aceleración o al arrancar el motor.</p><p>Los fallos de encendido del motor son otro síntoma importante que debe tener en cuenta. Si una junta de culata se encuentra dañada o deteriorada, el proceso de combustión puede interrumpirse y provocar un ralentí brusco o una disminución notable de la potencia del motor durante la aceleración.</p><p>Por último, fíjate también en la pérdida de compresión entre los cilindros, ya que esto puede provocar una disminución del rendimiento del motor, una reducción de la potencia e incluso fallos de encendido.</p>"
            },
            "dropdown-2": {
              title: "¿Se puede conducir con una junta de culata quemada?",
              content:
                "<p>Definitivamente, no recomendamos conducir con una junta de culata quemada porque puede tener consecuencias significativas tanto para el motor como para el rendimiento general de su vehículo. Es importante abordar el problema de inmediato para evitar daños mayores.</p><p>Una junta de culata dañada puede ocasionar problemas que afecten directamente al funcionamiento del motor. El refrigerante puede filtrarse en la cámara de combustión, causando sobrecalentamiento y potencialmente dañando los componentes del motor. El refrigerante también puede mezclarse con el aceite del motor, reduciendo sus propiedades lubricantes y causando daños potenciales a los cojinetes, pistones y otras partes vitales.</p><p>Si sospecha que una junta está rota o experimenta cualquiera de los síntomas asociados, es recomendable que un mecánico cualificado inspeccione su vehículo lo antes posible. Recomendamos totalmente evitar conducir hasta que la pieza sea reemplazada o reparada para evitar daños mayores y garantizar la longevidad de su motor.</p>"
            },
            "dropdown-3": {
              title: "¿Vale la pena cambiar una junta de culata?",
              content:
                "<p>Reemplazar una junta de culata dañada es importante para evitar fallos graves en el motor de su vehículo. Como hemos visto antes, puede causar problemas que afectarán de manera negativa al rendimiento de su vehículo.</p><p>Si bien este reemplazo implica una inversión, generalmente es más rentable que lidiar con reparaciones más graves del motor. Sustituir la junta rota desde el principio evitará daños mayores y los gastos adicionales.</p><p>Además, garantizar la seguridad de su vehículo es crucial. Una junta de culata quemada puede provocar un sobrecalentamiento del motor que, como hemos visto antes, desembocará en otras averías más graves y peligrosas. Reemplazar la pieza nada más detectar el fallo, es sinónimo de seguridad para usted y para su vehículo. </p>"
            },
            "dropdown-4": {
              title:
                "¿Cuánto tiempo dura un motor después de reemplazar la junta de la cabeza?",
              content:
                "<p>Cuando la junta de la culata se reemplaza rápidamente y las reparaciones necesarias se realizan correctamente, es posible que el vehículo continúe funcionando durante muchos años más. Sin embargo, es importante tener en cuenta que la vida útil de un vehículo está influenciada por varios factores más allá del reemplazo de esta pieza en concreto.</p><p>Si bien no hay un plazo definitivo, es posible que un automóvil dure mucho tiempo tras reemplazar la junta de culata, especialmente cuando se combina con el mantenimiento y cuidado adecuados. El mantenimiento regular del vehículo, la resolución de cualquier problema con prontitud y la práctica de buenos hábitos de conducción son claves para maximizar su vida útil.</p>"
            }
          },
          btn_more_info: {
            text: "MÁS INFORMACIÓN"
          }
        }
      },
      junta_motor: {
        titulo: "JUEGOS DE JUNTAS PARA EL MOTOR",
        texto:
          "Fiabilidad en la estanqueidad de vehículos. Desarrollamos juegos completos de juntas para el motor con más de 200.000 referencias en juntas de fibra, caucho y caucho-metal.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil2.pdf",
        details: {
          intro: {
            alt: "junta para motor",
            title:
              '<h1 class="title title-36">Juegos de juntas para motor</h1>',
            text:
              "<p>Bienvenido a nuestro completo catálogo de juegos de juntas, donde ofrecemos soluciones de sellado de motor de alta calidad para una amplia gama de vehículos. Como fabricante líder de componentes de motores, comprendemos el papel fundamental que desempeñan estas piezas para mantener el rendimiento óptimo y la longevidad de los motores.</p><p>En Ajusa, nos enorgullecemos de nuestro compromiso con la excelencia, ofreciendo piezas de motor diseñadas con precisión y fabricadas con materiales de primera calidad. Cada uno de los juegos de juntas de nuestro catálogo está meticulosamente diseñado para proporcionar un ajuste y un sellado perfecto para su motor, que garantiza un rendimiento y una durabilidad óptima.</p>",
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/junta-motor-1.webp",
                alt: "juegos de juntas ajusa"
              },
              {
                img: "/static/img/products/junta-motor-2.webp",
                alt: "juntas del motor ajusa"
              },
              {
                img: "/static/img/products/junta-motor-3.webp",
                alt: "recambios para el motor"
              },
              {
                img: "/static/img/products/junta-motor-4.webp",
                alt: "juntas para vehículos industriales"
              },
              {
                img: "/static/img/products/junta-motor-5.webp",
                alt: "piezas para reparar el motor de un coche"
              }
            ]
          },
          dropdowns: {
            "dropdown-1": {
              title: "Una amplia variedad de juegos de juntas para su motor",
              content:
                "<p>Los juegos de juntas Ajusa incluyen todos los componentes necesarios para cada motor específico, lo que agiliza el proceso de reparación o reconstrucción incluyendo todas las piezas que necesita en un único kit.</p><p>Al elegir nuestros productos, puede tener la tranquilidad de saber que está invirtiendo en soluciones de sellado de motor de primera calidad con alta durabilidad. Nos dedicamos a proporcionar productos que brinden un rendimiento, una durabilidad y un valor excepcional, que nos convierte en la opción de confianza tanto para los fabricantes de motores como para los profesionales de la automoción.</p><p>Si tiene alguna pregunta o necesita ayuda para encontrar el juego de juntas adecuado para su aplicación específica, nuestro equipo experto siempre está listo para brindarle orientación y asistencia experta.</p>"
            },
            "dropdown-2": {
              title: "Pida su juego completo de juntas de motor",
              content:
                "<p>En Ajusa desarrollamos juegos completos de juntas con más de 200.000 referencias para atender a una amplia gama de marcas y modelos de vehículos. Todos ellos están diseñados bajo un minucioso proceso y fabricados en metal, fibra, caucho y compuestos caucho-metal, que son los materiales más fuertes y efectivos para su instalación en el motor.</p><p>La precisión y la durabilidad son muy importantes para nosotros, y es por eso por lo que nuestros productos se someten a un riguroso proceso de diseño y desarrollo, siguiendo estrictos estándares de calidad. Nuestro experimentado equipo de ingenieros aprovecha su experiencia para crear juntas que brindan un rendimiento de sellado excepcional y mantienen la integridad de los componentes del motor.</p>"
            },
            "dropdown-3": {
              title: "¿Qué incluye un juego de juntas?",
              content:
                "<p>Nuestro extenso catálogo de juegos de juntas incluye juntas y tornillos de culata, retenes de aceite, junta de tapa de balancines, colectores y muchos más productos. Cada juego está cuidadosamente seleccionado para incluir todas las juntas necesarias para una revisión o reparación completa del motor.</p><p>Invierta en la fiabilidad y el rendimiento de su motor solicitando los juegos de juntas para motor de Ajusa. Si tiene alguna pregunta o necesita ayuda, nuestro experimentado equipo de atención al cliente estará siempre disponible para brindarle orientación y apoyo.</p><p>Experimente la diferencia que nuestros juegos de juntas meticulosamente desarrollados pueden marcar en el rendimiento y la longevidad de su motor.</p>"
            }
          },
          btn_more_info: {
            text: "MÁS INFORMACIÓN"
          }
        }
      },
      tornillos: {
        titulo: "TORNILLOS DE CULATA",
        texto:
          "Completamos nuestra excelente gama de juntas de culata con la línea de tornillos de culata más completa del mercado. Incluimos manual de apriete.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil3.pdf",
        details: {
          intro: {
            alt: "tornillos de culata",
            title: '<h1 class="title title-36">Tornillos de culata</h1>',
            text:
              '<p>Bienvenido a nuestra<span class="bold"> extensa colección de tornillos de culata</span> tanto para motores de vehículo ligero como industrial.</p><p>En Ajusa contamos con un <span class="bold">amplio catálogo de tornillos de culata</span> meticulosamente elaborados, diseñados para brindar un óptimo rendimiento y durabilidad de su motor. Estos componentes juegan un papel crucial en la creación de un <span class="bold">sello hermético entre la culata y el bloque del motor</span>, asegurando una compresión adecuada y evitando fugas de gases de combustión o refrigerante.</p><p>Al mantener una conexión fuerte y confiable, los tornillos de culata contribuyen a la <span class="bold">eficiencia, el rendimiento y la longevidad del motor.</span> Son componentes esenciales para mantener la integridad estructural y el funcionamiento óptimo de la cámara de combustión del motor. Las juntas de culata Ajusa incluyen el <span class="bold">manual de apriete de los tornillos de culata.</span></p>',
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/tornillos-1.webp",
                alt: "tornillos de culata ajusa"
              },
              {
                img: "/static/img/products/tornillos-2.webp",
                alt: "catalogo de tornillos de culata"
              },
              {
                img: "/static/img/products/tornillos-3.webp",
                alt: "tornillos con apriete angular"
              },
              {
                img: "/static/img/products/tornillos-4.webp",
                alt: "avería junta de culata"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "Materiales de primera calidad para una durabilidad excepcional",
              content:
                '<p>Ya sea acero de alta resistencia, aluminio forjado u otros materiales avanzados, nuestros tornillos de culata están fabricados para soportar las condiciones más exigentes.</p><p>Con estos materiales de primera calidad, puede estar seguro de que los componentes críticos de su motor permanecerán bien sujetos, evitando fugas y optimizando la compresión. Consulte nuestro <span class="bold">catálogo online de tornillos de culata</span> y solicite la versión impresa.</p>'
            },
            "tip-2": {
              title: "Tornillos de culata de alto rendimiento",
              content:
                '<p>Los tornillos de culata Ajusa se han ganado su reputación como la opción preferida tanto para profesionales como para entusiastas del motor y del sector de la automoción. Innumerables motores han sido mejorados en eficiencia y potencia, gracias al ajuste de precisión y al <span class="bold">sellado hermético proporcionado por los tornillos de culata.</span></p>'
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "¿Por qué debería reemplazar los tornillos de la culata?",
              content:
                '<p>Reemplazar los tornillos de la culata es un aspecto crítico del mantenimiento y de la reparación del motor. Con el tiempo, estas piezas pueden experimentar desgaste y y variaciones de temperatura, que provocan un desgaste y fatiga graduales. A medida que pierden su elasticidad y fuerza de sujeción, aumenta el riesgo de desarrollar problemas como <span class="bold">fugas en la junta de la culata.</span></p><p>Para garantizar la integridad y seguridad continuas de su motor, es <span class="bold">esencial reemplazar oportunamente los tornillos de la culata.</span> Ajusa recomienda <span class="bold">cambiar los tornillos de culata</span> siempre que sustituyamos la junta de culata. Es necesario para restablecer la fuerza de sujeción necesaria entre la culata y el bloque del motor, mejorando así la función de estanqueidad de estas piezas. <span class="bold">Todas las juntas de culata Ajusa incluyen el manual de apriete de los tornillos de culata.</span></p>'
            },
            "dropdown-2": {
              title: "¿Qué causa que se rompan los tornillos de culata?",
              content:
                '<p>La rotura de los tornillos de la culata se puede atribuir a varios factores, principalmente relacionados con las tensiones y condiciones que soportan durante el funcionamiento del motor. Algunas causas comunes incluyen la aplicación excesiva o desigual de la <span class="bold">torsión durante la instalación de los tornillos</span>, las fluctuaciones en la temperatura del motor, la exposición a productos químicos corrosivos o incluso el sobrecalentamiento del motor.</p><p>La inspección periódica y el <span class="bold">reemplazo de los tornillos de culata durante la reconstrucción del motor</span> o las reparaciones importantes pueden ayudar a identificar problemas potenciales y mitigar el riesgo de rotura, lo que contribuye a un rendimiento confiable y duradero del motor.</p>'
            }
          },
          btn_more_info: {
            text: "MÁS INFORMACIÓN"
          }
        }
      },
      retenes: {
        titulo: "RETENES",
        texto:
          "Amplia cobertura en retenes de aceite y de válvulas para garantizar el sellado perfecto del motor.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil4.pdf",
        details: {
          intro: {
            alt: "retenes",
            title: '<h1 class="title title-36">Retenes de aceite</h1>',
            text:
              '<p>Los <span class="bold">retenes de aceite</span> son un componente crítico que mantienen un <span class="bold">funcionamiento fluido del motor y evita fugas</span>. Los retenes crean una barrera hermética, asegurando que lubricantes y fluidos permanezcan contenidos, protegiendo las partes vitales del motor de la fricción dañina y extendiendo la vida útil general de su vehículo.</p><p>En Ajusa encontrarás una <span class="bold">amplia selección de retenes de alta calidad</span> meticulosamente diseñados para diversas aplicaciones del vehículo, que te permitirán conducir con confianza y tranquilidad. Experimente la diferencia que marcan nuestros productos premium al mejorar el rendimiento de su vehículo y proteger su inversión a largo plazo.</p>',
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/retenes-1.webp",
                alt: "retenes ajusa"
              },
              {
                img: "/static/img/products/retenes-2.webp",
                alt: "retenes de aceite ajusa"
              },
              {
                img: "/static/img/products/retenes-3.webp",
                alt: "retenes de válvula ajusa"
              },
              {
                img: "/static/img/products/retenes-4.webp",
                alt: "retenes para coches"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "Solicite los retenes de aceite correctos para su vehículo",
              content:
                '<p>Fabricados con materiales duraderos que cumplen y superan los estándares marcados por la industria de la automoción. Los <span class="bold">retenes de aceite Ajusa</span> se someten a pruebas rigurosas para resistir las condiciones más duras, lo que garantiza un funcionamiento impecable incluso bajo temperaturas y presiones extremas. Podemos garantizar que el motor de su vehículo y otros componentes críticos permanecerán protegidos y funcionarán de manera óptima.</p><p>Consulte <span class="bold">el catálogo Ajusa</span> para encontrar los retenes de aceite que necesita el motor de su vehículo, ya sea un vehículo ligero, un camión pesado o maquinaria agrícola. Somos expertos para guiarlo hacia la pieza ideal.</p>'
            },
            "tip-2": {
              title: "Mejoran el rendimiento del coche",
              content:
                '<p>No es ningún secreto que el <span class="bold">rendimiento y la durabilidad de su automóvil</span> dependen de la calidad de sus componentes esenciales. Con nuestros retenes de aceite, su motor experimentará una fricción reducida, que le permitirá conducir más suave, una mayor eficiencia de combustible y, en última instancia, un rendimiento general mejorado.</p><p>Tener un coche es una inversión importante, y protegerlo es obligatorio. Asegúrese de proteger las piezas de su vehículo contra el desgaste prematuro y los daños encontrando los <span class="bold">retenes de aceite correctos</span>, extendiendo su vida útil y evitando reparaciones costosas en el futuro.</p>'
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Descubra nuestro amplio catálogo de retenes de aceite",
              content:
                '<p>Nuestro catálogo de productos es el más amplio que podrá encontrar en el sector aftermarket, ya que contamos con <span class="bold">repuestos para todas las marcas</span> y modelos de vehículos del mercado actual. En nuestro catálogo online, localice los retenes de aceite que necesita para que siempre pueda tener una <span class="bold">pieza de repuesto a mano.</span></p><p>Respaldado por años de experiencia en la <span class="bold">industria de la automoción</span>, nuestro equipo se dedica a brindar un <span class="bold">servicio al cliente excepcional</span>. Desde la selección de los retenes de aceite correctos hasta la respuesta a sus preguntas técnicas, estamos aquí para ayudarlo en cada paso del proceso. Si es necesario, contáctenos para una atención personalizada al cliente (asistenciatecnica@ajusa.es).</p>'
            }
          },
          btn_more_info: {
            text: "MÁS INFORMACIÓN"
          }
        }
      },
      tubos_engrase: {
        titulo: "TUBOS DE ENGRASE PARA TURBO",
        texto:
          "Nos adaptamos a los nuevos motores con  turbocompresor poniendo a tu disposición la línea de tubos de engrase para turbo. Disponible el catálogo de turbos AJUSA.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "tubos de engrase",
            title: '<h1 class="title title-36">Tubos de engrase</h1>',
            text:
              '<p>Diseñados para optimizar el rendimiento, la eficiencia y la durabilidad del motor de su vehículo, los <span class="bold">tubos de engrase Ajusa</span> están diseñados con precisión y cuidado. Es el de dar la bienvenida a un flujo de trabajo más fluido e ininterrumpido.</p><p>La calidad y la innovación están totalmente garantizadas, ya que estos botos están construidos para soportar los entornos más exigentes y garantizar un suministro de aceite constante y continuo, protegiendo el turbocompresor de posibles averías. No se conforme con menos, invierta en lo mejor y libere el verdadero potencial de su conducción.</p>',
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/tubos-engrase-1.webp",
                alt: "tubos de engrase ajusa"
              },
              {
                img: "/static/img/products/tubos-engrase-2.webp",
                alt: "componentes de turbo ajusa"
              },
              {
                img: "/static/img/products/tubos-engrase-3.webp",
                alt: "turbos de engrase para turbocompresor"
              },
              {
                img: "/static/img/products/tubos-engrase-4.webp",
                alt: "como reparar el turbocompresor de un motor"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Apueste por tubos de engrase 100% eficientes",
              content:
                '<p>¿Está cansado de lidiar con reparaciones costosas debido a un <span class="bold">suministro de aceite ineficiente en su motor</span>? No busque más. Le proporcionaremos la solución definitiva para optimizar el rendimiento de su coche en la carretera.</p><p>Estos <span class="bold">tubos de engrase</span> de aceite garantizan un flujo de aceite suave y continuo a los componentes vitales, lo que reduce la fricción y el desgaste, para que pueda experimentar una mejora significativa, lo que da como resultado un mayor rendimiento y un tiempo de inactividad mínimo.</p>'
            },
            "tip-2": {
              title: "Invierta en rendimiento para su turbocompresor",
              content:
                '<p>Únase a los clientes satisfechos que ya han experimentado los notables <span class="bold">beneficios de los tubos de engrase Ajusa</span> y vea cómo nuestro producto ha transformado su conducción diaria para lograr un mejor rendimiento y un éxito a largo plazo.</p><p>Haga una inversión inteligente para el futuro de su vehículo, asegurándose de que se mantenga en óptimas condiciones en los años venideros. El flujo continuo de aceite a través de los <span class="bold">tubos de engrase Ajusa garantiza una lubricación óptima</span> y un rendimiento más suave de su turbo gracias a la fabricación confiable y probada.</p>'
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "¿Qué función tiene el tubo de retorno?",
              content:
                '<p>El <span class="bold">tubo de retorno de aceite del turbo</span> juega un papel crucial en el funcionamiento de un automóvil. En un sistema turbo, el <span class="bold">turbocompresor comprime el aire</span> y lo empuja hacia los cilindros del motor, lo que resulta en una mayor potencia y rendimiento. Pero durante este proceso, los <span class="bold">componentes del turbocompresor requieren una lubricación adecuada para evitar la fricción y el desgaste excesivos.</span></p><p>El tubo de retorno es responsable de devolver el aceite que ha lubricado el turbocompresor al cárter de aceite del motor, asegurando un <span class="bold">suministro continuo y suficiente de aceite a las piezas móviles del turbo.</span> Este mecanismo de retorno ayuda a enfriar el turbocompresor y elimina el exceso de calor generado durante el proceso de turbocompresor.</p>'
            },
            "dropdown-2": {
              title: "¿Puede funcionar un turbo sin suministro de aceite?",
              content:
                "<p>No. No puede funcionar un turbocargador sin suministro de aceite. Los tubos de engrase son esenciales para el correcto funcionamiento y la longevidad de los componentes giratorios, como las ruedas de la turbina y el compresor, que giran a velocidades extremadamente altas y pueden causar desgaste y daños rápidos si no se lubrican correctamente.</p><p>Las líneas de aceite son responsables de suministrar aceite presurizado y filtrado al turbocargador, asegurando que sus partes móviles permanezcan adecuadamente lubricadas y enfriadas durante la operación.</p>"
            }
          },
          btn_more_info: {
            text: "MÁS INFORMACIÓN"
          }
        }
      },
      tubos_egr: {
        titulo: "TUBOS EGR",
        texto:
          "Ajusa ofrece tubos EGR de alta calidad que cumplen con las especificaciones de los principales fabricantes. Nuestros productos están diseñados para garantizar una larga vida útil y un rendimiento óptimo, ayudando a mantener tu vehículo dentro de los estándares de emisiones y asegurando una conducción más limpia y eficiente.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "tubos egr",
            title: '<h1 class="title title-36">Tubos EGR</h1>',
            text:
              '<p>Ajusa ofrece <span class="bold">tubos EGR</span> de alta calidad que cumplen con las especificaciones de los principales fabricantes. Nuestros productos están diseñados para garantizar una larga vida útil y un rendimiento óptimo, ayudando a mantener tu vehículo dentro de los estándares de emisiones y asegurando una conducción más limpia y eficiente.</p>',
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/tubos-egr-1.webp",
                alt: "tubo egr ajusa"
              },
              {
                img: "/static/img/products/tubos-egr-2.webp",
                alt: "valvula egr ajusa"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "CONSERVAN LA EFICACIA DEL SISTEMA DE RECIRCULACIÓN DE GASES DE ESCAPE",
              content:
                '<p>El tubo EGR (Recirculación de Gases de Escape) es un componente clave en los sistemas de <span class="bold">reducción de emisiones</span> de los motores de combustión interna.</p> <p>Este tubo forma parte del sistema EGR, diseñado para <span class="bold">reducir las emisiones de óxidos de nitrógeno (NOx)</span> al recircular una parte de los gases de escape hacia la admisión del motor.</p>'
            },
            "tip-2": {
              title:
                "TUBOS DE ALTA CALIDAD, DISEÑADOS PARA UNA INSTALACIÓN SENCILLA",
              content:
                '<p>Un <span class="bold">tubo EGR</span> puede necesitar reemplazo cuando los depósitos de carbono son excesivos y la limpieza ya no es suficiente para restaurar su funcionamiento.</p><p> Además, un tubo agrietado o dañado puede causar fugas de gases de escape, lo cual impacta negativamente tanto en la eficiencia del motor como en el control de emisiones.</p>'
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "¿Qué es el sistema EGR?",
              content:
                "<p>El sistema EGR (Exhaust Gas Recirculation) se encarga de que parte de los gases de escape regresen a la cámara de combustión de nuevo y vuelvan a formar parte de ella consiguiendo una mejora importante en cuanto a emisiones contaminantes como los NOx.</p><p>Estos gases discurren desde el colector de escape y a través del <span class='bold'>tubo de EGR</span> hasta la admisión, el caudal es determinado por la apertura y cierre de una válvula de EGR que es gestionada por la ECU permitiendo el paso total, parcial o nulo en función de las necesidades de conducción.</p><p>Por lo tanto, el sistema EGR redirige una parte de los gases de escape de vuelta a la cámara de combustión a través del tubo EGR, que conecta el colector de escape con el de admisión. Al introducir estos gases de escape pobres en oxígeno, en el proceso de combustión, se reduce la temperatura en la cámara, disminuyendo así la formación de NOx, que es una de las principales causas de la contaminación del aire y afecta a la salud de las personas.</p>"
            },
            "dropdown-2": {
              title: "¿Por qué es importante el tubo de EGR?",
              content:
                "<p>Con el tiempo, los tubos EGR pueden acumular residuos derivados de la combustión, y otros depósitos provenientes de los gases de escape, lo que suele obstruir parcial o totalmente el tubo reduciendo la eficiencia del sistema. Además, están sometidos a fatiga térmica por las altas temperaturas de los gases y mecánica por las vibraciones del motor. Por esta razón, es importante realizar mantenimientos periódicos, que incluyan la revisión del estado de esta pieza e incluso la sustitución. Los síntomas de un tubo EGR obstruido se suelen manifestar con pérdida de potencia, aumento en el consumo de combustible y la activación de la luz de advertencia del motor (MIL).</p><p>Las principales causas de un tubo defectuoso son:</p><ol>  <li><span class='bold'>Obstrucción.</span> Los gases de escape, especialmente en motores diesel, contienen gran cantidad de elementos resultantes de la combustión como por ejemplo el hollín, que con el paso del tiempo pueden llegar incluso a taponar por completo la tubería impidiendo el paso de los gases.</li>  <li><span class='bold'>Rotura.</span> Son continuos los ciclos de arranque y parada por el uso del vehículo alcanzando muy altas temperaturas procedentes de los propios gases de escape, en combinación con las vibraciones a las que están sometidos por el propio funcionamiento del motor que pueden producir fisuras/roturas en el tubo.</li></ol><p>Un sistema de EGR no funcionará correctamente con un <span class='bold'>tubo de EGR</span> defectuoso provocando, en ese caso, no solo problemas en el correcto funcionamiento del sistema anticontaminación sino en el propio funcionamiento del motor y que podría tener consecuencias más graves si no se sustituye a tiempo.</p><p>Un tubo EGR puede necesitar reemplazo cuando los depósitos de carbono son excesivos y la limpieza ya no es suficiente para restaurar su funcionamiento. Además, un tubo agrietado o dañado puede causar fugas de gases de escape, lo cual impacta negativamente tanto en la eficiencia del motor como en el control de emisiones. Si experimentas alguno de los síntomas mencionados o si tu vehículo ha pasado muchos kilómetros sin una revisión del sistema EGR, es recomendable acudir a un profesional para su evaluación.</p><p>La instalación de un <span class='bold'>tubo de EGR</span> nuevo asegura una perfecta reparación, evitando el mal funcionamiento del sistema y otras averías provocadas por tubos defectuosos.</p>"
            },
            "dropdown-3": {
              title: "Beneficios de los Tubos EGR en buen estado",
              content:
                "<ul>  <li><span class='bold'>Reducción de Emisiones Contaminantes:</span> El correcto funcionamiento del sistema disminuye la temperatura de la combustión, reduciendo significativamente las emisiones de NOx.</li>  <li><span class='bold'>Cumplimiento con Normativas Ambientales:</span> Los vehículos modernos deben cumplir con estrictas regulaciones de emisiones. El sistema EGR ayuda a que los motores cumplan con estas normativas.</li>  <li><span class='bold'>Mejora en el Consumo de Combustible:</span> La recirculación de gases ayuda a optimizar el proceso de combustión, contribuyendo a un uso más eficiente del combustible.</li>  <li><span class='bold'>Mayor Durabilidad del Motor:</span> Al reducir la temperatura en la cámara de combustión, el sistema EGR disminuye el estrés térmico en los componentes internos del motor, lo que puede prolongar su vida útil.</li></ul>"
            }
          },
          btn_more_info: {
            text: "MÁS INFORMACIÓN"
          }
        }
      },
      tubos_refrigeracion: {
        titulo: "TUBOS DE REFRIGERACIÓN",
        texto:
          "Los tubos de refrigeración del turbo conducen el refrigerante entre el motor y el turbocompresor, en sentido de ida y retorno. La gama de tubos de refrigeración para turbocompresores de Ajusa cubre más de 40 modelos de vehículos de marcas líderes como Ford, VAG, Mercedes, Fiat/Alfa/Jeep, Nissan y Smart.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "tubos de refrigeracion",
            title: '<h1 class="title title-36">Tubos de refrigeracion</h1>',
            text:
              '<p>Los <span class="bold">turbocompresores </span>se enfrentan a un reto constante: las temperaturas extremas. En los motores modernos, estos componentes pueden alcanzar niveles de calor que someten a todas las piezas internas a un estrés térmico brutal.</p><p>Cuando la lubricación por aceite tradicional ya no es suficiente para combatir esas temperaturas, entra en juego una solución vital: la <span class="bold">refrigeración líquida externa</span> a través de tubos de refrigerante específicos.</p><p>La gama de tubos de refrigeración para turbocompresores de <span class="bold">Ajusa</span> cubre más de 40 modelos de vehículos de marcas líderes como Ford, VAG, Mercedes, Fiat/Alfa/Jeep, Nissan y Smart.</p>',
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/tubos-refrigeracion-1.webp",
                alt: "tubo refrigeracion ajusa"
              },
              {
                img: "/static/img/products/tubos-refrigeracion-2.webp",
                alt: "valvula refrigeracion ajusa"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "",
              content:
                "<p>En los vehículos modernos, los sistemas de refrigeración han evolucionado para mejorar la eficiencia térmica y controlar un número creciente de componentes, incluidos turbocompresores y sistemas anticontaminación.</p><p>La mayor complejidad del circuito incrementa el riesgo de averías difíciles de diagnosticar y costosas de reparar. Una gestión térmica deficiente puede generar daños graves, especialmente en turbos con refrigeración líquida.</p>"
            },
            "tip-2": {
              title: "",
              content:
                "<p>Los tubos de refrigeración del turbocompresor deben emplearse únicamente en aplicaciones compatibles, asegurando un trazado correcto que permita la dilatación térmica sin generar tensiones.</p><p>Es imprescindible utilizar materiales y juntas adecuadas, respetar el par de apriete especificado y mantener el circuito con refrigerante homologado. No se recomienda reutilizar tubos deteriorados o envejecidos.</p><p>Tras cualquier intervención, debe verificarse la estanqueidad y realizarse un purgado completo del sistema para garantizar un funcionamiento seguro del turbocompresor.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "¿QUÉ FUNCIÓN TIENEN LOS TUBOS DE REFRIGACIÓN?",
              content:
                "<p>Los tubos de refrigeración del turbo conducen el refrigerante entre el motor y el turbocompresor, en sentido de ida y retorno. Deben resistir altas temperaturas, presión y vibraciones, además de estar fabricados con materiales duraderos. Dependiendo de su aplicación, pueden estar fabricados en acero al carbono, acero inoxidable o combinaciones de metal y tramos flexibles, seleccionados para ofrecer una elevada resistencia mecánica y térmica.</p><p>Los tubos incorporan extremos conformados o mecanizados que permiten una conexión precisa y estanca mediante juntas, abrazaderas o racores específicos, evitando fugas de refrigerante incluso en condiciones de trabajo severas. En determinadas configuraciones, los tubos de refrigeración integrados en un circuito auxiliar con bomba eléctrica permiten mantener la circulación del refrigerante tras la parada del motor. Este sistema resulta esencial para evacuar el calor residual acumulado.</p><p>Este fenómeno, conocido como heat soak, se produce cuando el calor de la turbina se transmite al cuerpo central en ausencia de flujo refrigerante. La circulación forzada limita los picos térmicos y favorece un descenso controlado de la temperatura. Esta solución es especialmente relevante en vehículos de uso severo y en aquellos equipados con sistemas Start&Stop, ya que reduce la degradación térmica del aceite, la formación de depósitos carbonizados y el desgaste prematuro del turbocompresor.</p>"
            }
          },
          btn_more_info: {
            text: "MÁS INFORMACIÓN"
          }
        }
      },
      junta_turbo: {
        titulo: "JUEGOS DE JUNTAS PARA TURBO",
        texto:
          "Ofrecemos más de 1.000 kits de montaje diferentes para turbocompresores. Nuestros kits cubren la mayor parte de las aplicaciones de los princiaples fabricantes a nivel mundial.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil6.pdf",
        details: {
          intro: {
            alt: "kit de juntas para turbo",
            title: '<h1 class="title title-36">Kit de juntas para turbo</h1>',
            text:
              '<p>Bienvenido a todos los entusiastas de la conducción que buscan mejoras de rendimiento de primer nivel. Ingrese en un mundo de potencia y precisión con nuestros <span class="bold">juegos de juntas para turbo de última generación.</span></p><p>Diseñado para llevar su experiencia de conducción a otro nivel, este producto está fabricado con los mejores materiales para garantizar un rendimiento y una fiabilidad sin concesiones.</p><p>Este kit está disponible para una amplia gama de marcas y modelos de vehículo, optimizando la <span class="bold"></span>eficiencia del motor</span> y liberando una oleada de potencia extra. Disfrute de la emoción de la aceleración, mientras disfruta de una mejor economía de combustible.</p>',
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/junta-turbo-1.webp",
                alt: "juegos de juntas para turbo ajusa"
              },
              {
                img: "/static/img/products/junta-turbo-2.webp",
                alt: "juntas para el turbocompresor"
              },
              {
                img: "/static/img/products/junta-turbo-3.webp",
                alt: "garret turbo"
              },
              {
                img: "/static/img/products/junta-turbo-4.webp",
                alt: "kit de juntas para el turbo"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "Transforme su experiencia de conducción con los juegos de juntas para turbo",
              content:
                "<p>Diseñados para transformar su vehículo en un centro neurálgico de rendimiento y emoción, nuestros kits de montaje para turbo optimizan las capacidades de su motor brindándole una fusión de potencia y eficiencia. </p><p>Siente la confianza corriendo por tus venas mientras abordas cada giro con precisión.</p>"
            },
            "tip-2": {
              title: "Proeza y precisión de ingeniería",
              content:
                '<p>Cada elemento de nuestro <span class="bold">juego de juntas para turbo</span> está meticulosamente diseñado, desde el intrincado diseño hasta la selección de materiales de primera calidad para superar los más altos estándares de la industria de la automoción y sus expectativas más exigentes.</p><p>Las piezas que componen este kit harán rugir tu motor. Descubra y experimente de primera mano el <span class="bold">catálogo de componentes de turbo Ajusa</span> para unirse a la élite de la conducción de alto rendimiento.</p>'
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "¿Qué juego de juntas para turbo necesita mi coche?",
              content:
                '<p>¡Llegamos a cualquier turbo! El <span class="bold">catálogo juegos de juntas para turbo Ajusa</span> tiene una cobertura total para cubrir todas las necesidades de <span class="bold">vehículos europeos, asiáticos y americanos.</span> No obstante, si tienes alguna duda, te recomendamos que nos facilites datos específicos de tu coche, como marca, modelo, año y cualquier otra especificación relevante para poder ayudarte.</p><p>Con esta información, nuestros expertos automotrices pueden ayudarlo a encontrar la pieza perfecta, adaptada a las necesidades de su vehículo. No dude en ponerse en contacto con nosotros y en breve le ayudaremos a encontrar la combinación ideal para mejorar el rendimiento de su automóvil <a href="mailto:asistenciatecnica@ajusa.es">(asistenciatecnica@ajusa.es)</a>.</p>'
            },
            "dropdown-2": {
              title: "¿Qué cambios notaré en mi conducción?",
              content:
                '<p>A pesar de sus potentes capacidades, nuestros kit de juntas para turbo también impulsa una <span class="bold">conducción más ecológica.</span> Sea testigo de la armonía de la potencia y la conciencia ecológica, que reducen la huella de carbono en cada viaje.</p><p>Y no solo sentirá la diferencia en su rendimiento de manejo, sino que este kit también puede prolongar la <span class="bold">vida útil de su motor</span> al reducir el estrés y promover una combustión eficiente, lo que contribuye a la longevidad de su vehículo.</p>'
            }
          },
          btn_more_info: {
            text: "MÁS INFORMACIÓN"
          }
        }
      },
      ajusil: {
        titulo: "<strong>Ajusil</strong> Sellante de silicona",
        texto:
          "La mejor solución en cuanto al sellado de sistemas que no usan juntas de estanqueidad. Esta silicona neutra, de bajo olor y segura para el sensor de oxígeno, satisface las más altas exigencias en cuanto a fiabilidad, resistencia térmica y resistencia a los fluidos. Disponible en dos formatos: 200 ml y 75 ml."
      },
      ajusev: {
        titulo:
          "<strong>AjusEV</strong> Sellante de silicona para vehículo eléctrico",
        texto:
          "Sellante de silicona exclusivo para vehículos híbridos y eléctricos. Garantiza una correcta estanqueidad frente a agentes atmosféricos externos y protege los componentes electrónicos del vehículo. Se aconseja su uso en la zona de baterías y en la unidad de control de potencia (PCU). Disponible en envases de 310 ml. "
      },
      ajustick: {
        titulo: "<strong>Ajustick</strong> Sellante anaeróbico",
        texto:
          "Sellante anaeróbico de componentes metálicos con superficies mecanizadas. Resiste a un amplio rango de temperaturas (entre -50º y 150ºC, alcanzando 180º puntualmente). Disponible en envases de 50 ml."
      },
      ajulock: {
        titulo: "<strong>Ajulock</strong> Fijador de roscas",
        texto:
          "Producto mono componente anaeróbico de media resistencia. Diseñado para proteger las partes metálicas del motor (tuercas, tornillos, espárragos) del aflojamiento provocado por golpes y vibraciones. Disponible en envases de 50 ml."
      },
      ajulube: {
        titulo: "<strong>Ajulube</strong> Lubricante montaje de motor",
        texto:
          "Aceite de montaje que lubrica y protege del desgaste los componentes mecánicos durante el arranque inicial del motor. Evita el contacto entre metales en componentes sujetos a alta presión: árboles de levas, taqués hidráulicos, cigüeñal o pistones. Disponible en envases de 100 ml. "
      },
      productos_quimicos: {
        titulo: "Línea de productos químicos",
        texto:
          "Garantizamos una funcionalidad óptima en todo tipo de motores con nuestra gama de químicos. Estos productos satisfacen las mayores exigencias respecto a usabilidad y resistencia térmica y se adaptan a las distintas necesidades del motor.",
        ver_mas: "Ver más",
        details: {
          intro: {
            alt: "productos químicos",
            title: '<h1 class="title title-36">Productos Químicos</h1>',
            text:
              "<p>Presentamos nuestros productos químicos de primera calidad diseñados exclusivamente para profesionales de la automoción. En AJUSA, llevamos el cuidado del motor a un nivel completamente nuevo.</p><p>Si eres mecánico profesional, nuestra amplia gama de selladores, lubricantes para motores y fijadores de roscas se ha seleccionado cuidadosamente para garantizar un rendimiento máximo en sus preciados vehículos.</p>",
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/productos-quimicos/intro-main-quimicos.webp",
                alt: "sellantes y lubricantes de motor"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-0.webp",
                alt: "sellante de silicona ajusil 200ml"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-1.webp",
                alt: "sellante de silicona ajusil 75ml"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-2.webp",
                alt: "sellante de silicona ajusil"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-0.webp",
                alt: "sellante de silicona para vehículo eléctrico"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-1.webp",
                alt: "sellante de silicona para vehículo eléctrico 1"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-2.webp",
                alt: "sellante de silicona para vehículo eléctrico 2"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-0.webp",
                alt: "sellante anaeróbico"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-1.webp",
                alt: "sellante anaeróbico 1"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-2.webp",
                alt: "sellante anaeróbico 2"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-0.webp",
                alt: "fijador de roscas"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-1.webp",
                alt: "fijador de roscas 1"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-2.webp",
                alt: "fijador de roscas 2"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-0.webp",
                alt: "lubricante para el motor"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-1.webp",
                alt: "lubricante para el motor 1"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-2.webp",
                alt: "lubricante para el motor 2"
              }
            ]
          },
          dropdowns: {
            "dropdown-1": {
              title:
                "Sellantes y productos químicos para la industria del automóvil",
              content:
                '<p>Ya sea mecánico profesional, entusiasta de la automoción o el dueño de un negocio que busca soluciones de primer nivel, lo tenemos cubierto. Desde <span class="bold">selladores de alto rendimiento y fijadores de roscas</span> anaeróbicos hasta lubricantes de motor especializados, nuestra gama de productos químicos está diseñada para elevar sus proyectos automotrices.</p><p>Independientemente del alcance de su proyecto, nuestras soluciones son versátiles, están diseñadas para abordar una amplia gama de aplicaciones y están respaldadas por tecnología de punta.</p><p>Únase a los innumerables profesionales que han confiado en Ajusa sus proyectos de automoción y experimente la diferencia que pueden marcar los <span class="bold">productos químicos de máxima calidad.</span></p>'
            },
            "dropdown-2": {
              title:
                "Soluciones de estanqueidad para la industria del automóvil",
              content:
                '<p>Nuestros <span class="bold">selladores han sido seleccionados cuidadosamente</span> para crear una barrera impermeable y evitar que se deterioren en las condiciones más exigentes. Nuestro equipo de expertos ha probado meticulosamente cada producto para garantizar que cumple con los más altos estándares de la industria, brindándole tranquilidad y confianza en sus proyectos.</p><p>Estas soluciones de sellado pueden crear una unión fuerte y duradera, que evita fugas, reduce el aflojamiento inducido por vibración o soporta fluctuaciones extremas de temperatura.</p>'
            },
            "dropdown-3": {
              title: "Conceptos básicos de la lubricación del motor",
              content:
                '<p>La lubricación adecuada juega un papel vital para garantizar el buen funcionamiento, el rendimiento y la longevidad del motor de su vehículo. Sin una <span class="bold">lubricación adecuada</span>, los componentes experimentarían una mayor resistencia, que provocaría una pérdida de potencia y una disminución del rendimiento general.</p><p>Además, al crear una película protectora de aceite entre las piezas, la lubricación minimiza el contacto directo de metal con metal, <span class="bold">evitando el desgaste excesivo y la generación de calor</span>. Priorice el mantenimiento periódico, elija los lubricantes adecuados y disfrute de una conducción suave, eficiente y fiable.</p>'
            },
            "dropdown-4": {
              title: "¿Cuál es el mejor fijador de roscas para coches?",
              content:
                '<p>Cuando se trata de seleccionar el mejor <span class="bold">fijador de roscas para automóviles, Ajulock</span> destaca como opción de primer nivel tanto para los entusiastas de la automoción como para los profesionales. Este producto químico es un fijador de roscas anaeróbico mono componente de alto rendimiento que destaca por proporcionar <span class="bold">soluciones de fijación seguras</span> y confiables para una amplia gama de aplicaciones automotrices.</p><p>Además de sus excelentes propiedades de unión, Ajulock también actúa como una barrera confiable contra la humedad y la corrosión. Al sellar elementos dañinos, este fijador de roscas <span class="bold">ayuda a proteger los componentes de su automóvil</span>, prolongando su vida útil y mejorando su rendimiento general.</p>'
            }
          },
          btn_more_info: {
            text: "MÁS INFORMACIÓN"
          }
        }
      },
      nuevo_sellante: {
        titulo: "SELLANTE ANAERÓBICO",
        texto:
          "Ajusa lanza su nuevo producto AJUSTICK para el sellado de componentes metálicos con superficies mecanizadas. Sellante anaeróbico (no necesita oxígeno para su curado final) resistente a un amplio rango de temperatura (entre -50º y 150ºC, alcanzando 180ºC puntualmente). Disponible en envases de 50 ml.",
        enlace_ficha_tecnica:
          "/static/pdf/info-tecnica/info_tecnica_ajustick_es.pdf"
      },
      taques: {
        titulo: "TAQUÉS HIDRÁULICOS",
        texto:
          "Precisión y calidad en nuestra línea de taqués hidráulicos. Verificamos con tolerancia de micras al 100% todo el proceso de producción.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil9.pdf",
        details: {
          intro: {
            alt: "taques hidraulicos",
            title: '<h1 class="title title-36">Taqués Hidráulicos</h1>',
            text:
              "<p>En Ajusa, somos líderes en la <span class='bold'>industria de la automoción</span>. Uno de nuestros campos de experiencia se encuentra en nuestra avanzada sección de mecanizados, donde puedes encontrar nuestra gama de <span class='bold'>taqués hidráulicos de alta calidad</span>.</p><p>Gracias a nuestra amplia experiencia en mecanizados, tenemos la capacidad de <span class='bold'>diseñar y fabricar taqués hidráulicos </span>que superan los estándares más rigurosos en términos de calidad, rendimiento y confiabilidad.</p><p>Estas piezas del motor desempeñan un papel crítico en el funcionamiento <span class='bold'>eficiente del tren de válvulas de cualquier motor</span>. No solo garantizan una actuación precisa de las válvulas, sino que también mantienen la holgura óptima requerida y proporcionan un levantamiento hidráulico altamente efectivo.</p>",
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/taques-1.webp",
                alt: "taqués hidráulicos ajusa"
              },
              {
                img: "/static/img/products/taques-2.webp",
                alt: "taqués para reparar el motor"
              },
              {
                img: "/static/img/products/taques-3.webp",
                alt: "tipos de taqués"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Nuestro catálogo de taqués hidráulicos",
              content:
                "<p>Los <span class='bold'>taqués hidráulicos </span>son dispositivos esenciales en el <span class='bold'>mundo automotriz</span>. En Ajusa, hemos perfeccionado su diseño y fabricación para ofrecer productos de la más alta calidad.</p><p>Nuestra <span class='bold'>amplia gama de taqués hidráulicos </span>está diseñada para adaptarse a diversas aplicaciones en la industria automotriz, por ello contamos con el catálogo más amplio del sector.</p>"
            },
            "tip-2": "none"
          },
          dropdowns: {
            "dropdown-1": {
              title: "Características técnicas de los Taqués Hidráulicos",
              content:
                "<p>Los <span class='bold'>taqués hidráulicos fabricados por Ajusa </span>son reconocidos por su excelencia en diseño y rendimiento. Estas piezas esenciales del motor incorporan una serie de características técnicas clave que los distinguen:</p><p><span class='bold'>Tecnología hidráulica avanzada</span></br>Nuestros taqués hidráulicos utilizan tecnología hidráulica de última generación para garantizar un funcionamiento suave y preciso. Esto se traduce en una respuesta inmediata y un rendimiento óptimo en todo momento.</p><p><span class='bold'>Fabricación de alta calidad</span></br>Cada taqué hidráulico está construido con materiales de alta calidad que resisten las condiciones más exigentes. La durabilidad y la resistencia son elementos fundamentales de nuestra fabricación.</p><p><span class='bold'>Tolerancias precisas</span></br>Nuestros taqués hidráulicos se fabrican con tolerancias extremadamente ajustadas para garantizar un ajuste perfecto en el tren de válvulas del motor. Esto se traduce en una actuación precisa de las válvulas y un funcionamiento sin problemas.</p><p><span class='bold'>Rendimiento en diversas condiciones</span></br>Nuestros taqués hidráulicos están diseñados para funcionar de manera confiable en diversas condiciones, desde temperaturas extremas hasta entornos de alta presión. Su capacidad para mantener un rendimiento constante es una de sus características distintivas.</p><p><span class='bold'>Instalación y mantenimiento sencillos</span></br>La facilidad de instalación y mantenimiento es una prioridad en el diseño de nuestros taqués hidráulicos. Esto reduce el tiempo de inactividad del motor y garantiza un funcionamiento eficiente.</p><p><span class='bold'>Cumplimiento normativo</span></br>Todos nuestros taqués hidráulicos cumplen con las regulaciones y normas de calidad más estrictas de la industria. Esto garantiza la seguridad y la confiabilidad en cada uno de nuestros productos.</p>"
            },
            "dropdown-2": {
              title: "Cómo elegir los taqués hidráulicos adecuados",
              content:
                "<p><span class='bold'>Elegir el taque hidráulico adecuado </span>es una decisión estratégica para tu negocio y puede marcar la diferencia en términos de eficiencia operativa y seguridad. En <span class='bold'>Ajusa</span>, te proporcionamos el mejor asesoramiento profesional para que tomes decisiones informadas y precisas.</p><p>Además, todos nuestros elevadores hidráulicos cumplen con los estándares y regulaciones de la industria más rigurosos. Consulta nuestro catálogo online para saber la referencia que necesita tu vehículo. </p>"
            }
          },
          btn_more_info: {
            text: "MÁS INFORMACIÓN"
          }
        }
      },
      arbol_levas: {
        titulo: "ÁRBOLES DE LEVAS",
        texto:
          "Fabricamos árboles de levas a partir de barras de acero fundido que son modeladas en modernos centros de mecanizado y máquinas de rectificación automáticas que garantizan un nivel de calidad alto y consistente.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil10.pdf",
        details: {
          intro: {
            alt: "arboles de levas",
            title: '<h1 class="title title-36">Árboles de Levas</h1>',
            text:
              "<p>Además de nuestra amplia experiencia en la producción de taqués hidráulicos, en la sección de mecanizados de Ajusa también <span class='bold'>fabricamos árboles de levas</span> a partir de barras de acero fundido, utilizando maquinaria de rectificado de última generación para lograr niveles óptimos de precisión y eficiencia.</p><p>Los árboles de levas representan elementos críticos en el sistema de tren de válvulas de un motor, siendo responsables de regular la apertura y cierre de las válvulas de admisión y escape del motor. En consecuencia, desempeñan un papel esencial en la obtención de un rendimiento y eficiencia excepcionales del motor.</p>",
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/arbol-levas-1.webp",
                alt: "árbol de levas ajusa"
              },
              {
                img: "/static/img/products/arbol-levas-2.webp",
                alt: "componentes del motor ajusa"
              },
              {
                img: "/static/img/products/arbol-levas-3.webp",
                alt: "catálogo árboles de levas"
              },
              {
                img: "/static/img/products/arbol-levas-4.webp",
                alt: "mecanica para principiantes"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Árbol de Levas Ajusa: Potencia tu motor",
              content:
                "<p>Descubre la <span class='bold'>amplia gama de árboles de levas</span> disponibles en <span class='bold'>Ajusa</span> para aumentar el<span class='bold'> rendimiento del motor</span>. Con nuestra amplia experiencia en la fabricación de estos componentes de alta calidad, somos tu mejor opción para optimizar tu vehículo.</p><p>Para facilitar el montaje del producto, Ajusa ha desarrollado un <span class='bold'>completo manual de apriete </span>que incluye en todos sus árboles de levas junto al <span class='bold'>lubricante para el montaje el motor </span>Ajulube.</p>"
            },
            "tip-2": {
              title: "Amplio catálogo de Árboles de Leva",
              content:
                "<p>En Ajusa, entendemos que cada vehículo es único. Es por eso que ofrecemos una amplia gama de <span class='bold'>árboles de levas diseñados para adaptarse a diversas necesidades</span> y aplicaciones de rendimiento. Ya sea que busques una mejora de alto rendimiento o una pieza de calidad OEM, tenemos la solución perfecta para ti.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Ventajas de elegir nuestros árboles de levas",
              content:
                "<p>- <span class='bold'>Calidad Inigualable: </span>Todos los árboles de levas Ajusa se fabrican bajo los estándares de calidad más altos, garantizando una durabilidad y rendimiento excepcionales.</p><p>- <span class='bold'>Tecnología Innovadora: </span>Incorporamos las últimas innovaciones técnicas en el diseño y fabricación de nuestros árboles de levas para asegurarnos de que estás utilizando la mejor en tecnología.</p><p>- <span class='bold'>Rendimiento Comprobado: </span>Nuestras piezas se someten a rigurosas pruebas de rendimiento para asegurarnos de que cumplan y superen las expectativas en cuanto a potencia y eficiencia.</p><p>- <span class='bold'>Amplia Compatibilidad: </span>Ofrecemos árboles de levas para una amplia gama de marcas y modelos de vehículos, facilitando la búsqueda de la pieza perfecta para tu automóvil.</p><p>- <span class='bold'>Garantía de Confianza: </span>Respaldamos nuestros <span class='bold'>árboles de levas con una sólida garantía </span>de rendimiento, brindándote tranquilidad y confianza en tu elección.</p><p>Cuando eliges los árboles de levas de Ajusa, estás optando por la excelencia en la ingeniería del sector de la automoción. Potencia tu motor y <span class='bold'>mejora tu experiencia de conducción </span>con la calidad y el rendimiento que solo Ajusa puede ofrecer.</p>"
            },
            "dropdown-2": {
              title: "Manual de apriete del árbol de levas",
              content:
                "<p>Ajusa ha desarrollado un <span class='bold'>manual completo de apriete </span>y de <span class='bold'>sustitución del árbol de levas </span>para facilitar este proceso en motores de combustión. Este manual se incluye en todos los árboles de levas junto al <span class='bold'>lubricante de motor Ajulube</span>.</p><p><span class='bold'>Pasos detallados para el desmontaje y montaje del árbol de levas </span><br>El desmontaje y montaje del árbol de levas en un motor consta de varios pasos que deben seguirse con precisión. En primer lugar, es necesario colocar el cilindro número 1 en el <span class='bold'>Punto Muerto Superior (PMS) </span>y verificar que el árbol de levas esté en fase.</p><p>Luego, el motor debe quedar inmovilizado mediante los útiles de calado y se deben quitar la correa o cadena de distribución, la tapa de la culata y los accesorios impulsados por el árbol de levas.</p><p>Posteriormente, es necesario desmontar la polea del árbol de levas y sus soportes, seguido del desmontaje del <span class='bold'>árbol de levas </span>y de los <span class='bold'>taqués</span>. En este punto, es importante verificar el estado de los taqués hidráulicos y verificar que los apoyos del árbol de levas en la culata no estén desgastados.</p><p>Reemplazar los casquillos de culata, en caso de que la culata no disponga de ellos y sus apoyos estén en mal estado, rectificar o sustituir culata. Además, se sugiere lubricar los asientos y soportes del árbol de levas con el aceite proporcionado.</p><p>Luego, se montan <span class='bold'>los taqués y el árbol de levas </span>en sus alojamientos en la culata, aplicando el apriete proporcionado en la hoja. Posteriormente, se monta la correa o cadena de distribución, aplicando la tensión adecuada, y se verifica manualmente que el árbol de levas gire libremente cuando el cigüeñal gire.</p><p>Finalmente, se monta la tapa de la culata y los componentes en el orden inverso al desmontaje. En nuestro canal de mecánica en YouTube encontrarás diversos vídeos sobre el montaje de este componente.</p>"
            }
          },
          btn_more_info: {
            text: "MÁS INFORMACIÓN"
          }
        }
      },
      otros: {
        titulo: "OTROS COMPONENTES",
        texto:
          "Más de 80.000 referencias distintas de juntas de fibra, caucho y caucho-metal. Destaca nuestra completa línea de juntas de bombas de agua, válvulas EGR y termostatos. Aseguramos la más completa reparación de su automóvil o vehículo industrial.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil11.pdf",
        details: {
          intro: {
            alt: "otros componentes",
            title: '<h1 class="title title-36">Otros Componentes</h1>',
            text:
              "<p>Ofrecemos <span class='bold'>productos de sellado y otros componentes Ajusa </span>diseñados para garantizar el funcionamiento fluido de tu motor. En nuestro catálogo, encontrarás una <span class='bold'>amplia selección de juntas para diferentes partes del motor</span>, incluyendo bombas de agua, válvulas EGR, compresores de frenos, termostatos y mucho más.</p><p>Ya seas <span class='bold'>dueño de un taller profesional o un particular</span>, no dudes en contactarnos si necesitas comprar cualquier otro componente que hayas visto en nuestro sitio web para tu motor. Estamos aquí para responder tus preguntas y ayudarte a encontrar la pieza que necesitas.</p>",
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/otros-1.webp",
                alt: "juntas metálicas"
              },
              {
                img: "/static/img/products/otros-2.webp",
                alt: "juntas de fibra"
              },
              {
                img: "/static/img/products/otros-3.webp",
                alt: "juntas de caucho"
              },
              {
                img: "/static/img/products/otros-4.webp",
                alt: "catálogo de juntas y repuestos"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Otros Componentes y Piezas para tu Motor",
              content:
                "<p>En Ajusa entendemos que el sellado es crucial para varias partes del motor. Por eso, ofrecemos una amplia gama de soluciones de sellado y otros componentes de Ajusa que abarcan diferentes partes del motor.</p>"
            },
            "tip-2": "none"
          },
          dropdowns: {
            "dropdown-1": {
              title: "Catálogo de Componentes",
              content:
                "<p><span class='bold'></span></br></p><p><span class='bold'>Juntas para Bombas de Agua</span></br>Las juntas diseñadas para las bombas de agua son esenciales para prevenir fugas y mantener una refrigeración adecuada del motor. Nuestras juntas se fabrican con precisión para garantizar un sellado perfecto.</p><p><span class='bold'>Juntas para Válvulas EGR</span></br>Las juntas para válvulas EGR son cruciales para garantizar un flujo controlado de gases en el sistema de escape, reduciendo las emisiones y mejorando la eficiencia del motor. Puedes confiar en nuestras juntas para mantener tu motor funcionando sin problemas.</p><p><span class='bold'>Juntas para Compresores de Frenos</span></br>Otro componente de Ajusa son las juntas en el compresor de frenos, esenciales para la seguridad de tu vehículo. Nuestras juntas de alta calidad aseguran un sellado hermético, lo cual es fundamental para el funcionamiento fiable del sistema de frenos.</p><p><span class='bold'>Juntas para Termostatos</span></br>El termostato regula la temperatura del motor y nuestras juntas para termostatos garantizan que este componente funcione correctamente. Un sellado óptimo aquí es esencial para prevenir el sobrecalentamiento y daños al motor.</p><p><span class='bold'>Otros Componentes de Ajusa Disponibles</span></br>Además de las piezas mencionadas anteriormente, ofrecemos una amplia variedad de otros componentes de Ajusa para diferentes aplicaciones de motores. ¡Consulta nuestro catálogo online o contacta con nosotros! </p>"
            },
            "dropdown-2": {
              title: "Características y Beneficios de los componentes Ajusa",
              content:
                "<p>En Ajusa proporcionamos juntas y piezas de alta calidad. Nuestras piezas de sellado se distinguen por:</p><p>- <span class='bold'>Diseño preciso</span>: Cada junta se fabrica con precisión para garantizar un ajuste perfecto y un sellado óptimo.</p><p>- <span class='bold'>Calidad superior</span>: Utilizamos materiales de la más alta calidad que resisten las condiciones más exigentes y prolongan la vida de tu motor.</p><p>- <span class='bold'>Ventajas significativas</span>: Al usar nuestras soluciones de sellado, obtienes un rendimiento fiable, una mayor eficiencia y una vida útil más larga del motor.</p>"
            },
            "dropdown-3": {
              title: "Calidad y Cumplimiento Normativo",
              content:
                "<p>Estamos comprometidos con la excelencia en la <span class='bold'>fabricación de piezas de sellado </span>y otros <span class='bold'>componentes de Ajusa para tu motor</span>. Cumplimos rigurosamente con las regulaciones y estándares de calidad más exigentes de la industria automotriz.</p><p>Nuestras piezas son sinónimo de seguridad y rendimiento para tu motor.</p>"
            }
          },
          btn_more_info: {
            text: "MÁS INFORMACIÓN"
          }
        }
      },
      garantia: {
        titulo:
          "<span class='bold'>calidad garantizada</span> en todos nuestros productos",
        titulo1:
          "<h2 class='title title-36'><span class='bold'>calidad garantizada</span> en todos nuestros productos</h2>",
        texto:
          "Nuestro compromiso con la calidad supone una garantía extra para nuestros productos. Contamos con las certificaciones TUV según la normativa ISO 9001 y la IATF 16949.",
        boton: "CERTIFICADOS",
        cumplimiento:
          "En cumplimiento de las prescripciones y recomendaciones del Real Decreto 396/2006 sobre seguridad y salud aplicables a los trabajos con riesgo de exposición al amianto, AJUSA certifica que no utiliza ningún material que contenga amianto en sus productos ni en ninguno de sus procesos de producción."
      },
      shared: {
        "junta-turbo": "junta-turbo",
        ajusil: "ajusil",
        "arbol-levas": "arbol-levas",
        "junta-culata": "junta-culata",
        "junta-motor": "junta-motor",
        otros: "otros",
        retenes: "retenes",
        taques: "taques",
        tornillos: "tornillos",
        "tubos-engrase": "tubos-engrase",
        "tubos-egr": "tubos-egr",
        nuevo_sellante: "nuevo_sellante"
      },
      titulo_banner: "Selecciona idioma",
      idiomas: {
        GE: "Alemán",
        EN: "Inglés",
        ES: "Español",
        FR: "Francés",
        HU: "Húngaro",
        IT: "Italiano",
        NL: "Holandés",
        PL: "Polaco",
        PT: "Portugués",
        BG: "Búlgaro",
        CZ: "Checo",
        GR: "Griego",
        SL: "Esloveno",
        SK: "Eslovaco",
        SE: "Sueco",
        RU: "Ruso",
        RO: "Rumano",
        LT: "Lituano",
        LV: "Letón"
      },
      nav_options: {
        vehiculo_electrico: {
          title: "vehículo eléctrico",
          category: "vehiculo_electrico",
          href: "vehiculo-electrico"
        },
        junta_culata: {
          id: "junta-culata",
          title: "juntas de culata",
          category: "product"
        },
        junta_motor: {
          id: "junta-motor",
          title: "juegos de juntas",
          category: "product"
        },
        tornillos: {
          id: "tornillos",
          title: "tornillos de culata",
          category: "product"
        },
        retenes: {
          id: "retenes",
          title: "retenes",
          category: "product"
        },
        tubos_engrase: {
          id: "tubos-engrase",
          title: "tubos de engrase",
          category: "product"
        },
        tubos_egr: {
          id: "tubos-egr",
          title: "tubos EGR",
          category: "product"
        },
        tubos_refrigeracion: {
          id: "tubos-refrigeracion",
          title: "tubos de refrigeracion",
          category: "product"
        },
        junta_turbo: {
          id: "junta-turbo",
          title: "juego de juntas para turbo",
          category: "product"
        },
        productos_quimicos: {
          id: "productos-quimicos",
          title: "productos quimicos",
          category: "productos"
        },
        taques: {
          id: "taques",
          title: "taques hidráulicos",
          category: "product"
        },
        arbol_levas: {
          id: "arbol-levas",
          title: "árboles de levas",
          category: "product"
        },
        otros: {
          id: "otros",
          title: "otros componentes",
          category: "product"
        }
      },
      alt_images: {
        juntas_culata: "juntas de culata",
        tornillos: "tornillos de culata",
        tubos_engrase: "tubos de engrase para turbo",
        "junta-culata-1": "juntas de culata ajusa",
        "junta-culata-2": "comprar juntas de culata",
        "junta-culata-3": "juntas de culata mls",
        "junta-motor-1": "juegos de juntas ajusa",
        "junta-motor-2": "juntas del motor ajusa",
        "junta-motor-3": "recambios para el motor",
        "junta-motor-4": "juntas para vehículos industriales",
        "junta-motor-5": "piezas para reparar el motor de un coche",
        "tornillos-1": "tornillos de culata ajusa",
        "tornillos-2": "catalogo de tornillos de culata",
        "tornillos-3": "tornillos con apriete angular",
        "tornillos-4": "avería junta de culata",
        "retenes-1": "retenes ajusa",
        "retenes-2": "retenes de aceite ajusa",
        "retenes-3": "retenes de válvula ajusa",
        "retenes-4": "retenes para coches",
        "tubos-engrase-1": "tubos de engrase ajusa",
        "tubos-engrase-2": "componentes de turbo ajusa",
        "tubos-engrase-3": "turbos de engrase para turbocompresor",
        "tubos-engrase-4": "como reparar el turbocompresor de un motor",
        "tubos-egr-1": "tubos egr ajusa",
        "tubos-egr-2": "valvula egr ajusa",
            "tubos-refrigeracion-1": "tubos de refrigeración ajusa",
        "junta-turbo-1": "juegos de juntas para turbo ajusa",
        "junta-turbo-2": "juntas para el turbocompresor",
        "junta-turbo-3": "garret turbo",
        "junta-turbo-4": "kit de juntas para el turbo",
        sellantes_lubricantes: "sellantes y lubricantes de motor",
        sellante_silicona: "sellante de silicona ajusil",
        sellante_silicona_electrico:
          "sellante de silicona para vehículo eléctrico",
        sellante_anaerobico: "sellante anaeróbico",
        lubricante_motor: "lubricante para el motor",
        fijador_roscas: "fijador de roscas",
        "taques-1": "taqués hidráulicos ajusa",
        "taques-2": "taqués para reparar el motor",
        "taques-3": "tipos de taqués",
        "arbol-levas-1": "árbol de levas ajusa",
        "arbol-levas-2": "componentes del motor ajusa",
        "arbol-levas-3": "catálogo árboles de levas",
        "arbol-levas-4": "mecanica para principiantes",
        "otros-1": "juntas metálicas",
        "otros-2": "juntas de fibra",
        "otros-3": "juntas de caucho",
        "otros-4": "catálogo de juntas y repuestos",
        taller_electrico: "taller para vehículo eléctrico"
      }
    },
    catalogo: {
      intro: {
        titulo: "AJUSA Catálogo",
        texto:
          "Encontrarás la pieza que necesita tu vehículo en el catálogo AJUSA. El más amplio del sector de la automoción con más de 200.000 referencias a tu disposición.",
        catalogo_impreso: "catálogo <br>impreso",
        catalogo_impreso_texto:
          "Facilitamos tu trabajo. Solicita el catálogo general AJUSA en papel.",
        catalogo_impreso_boton: "Solicitar"
      },
      cat_general: {
        texto:
          "AJUSA actualiza su catálogo cada dos años para garantizar la cobertura más completa de juntas de culata, tornillos de culata, juegos de juntas del motor y otras piezas de mantenimiento como taqués hidráulicos y árboles de levas."
      },
      buscador: {
        placeholder: "Buscar por marcas de vehículos",
        titulo:
          "Utiliza el buscador más arriba o selecciona la inicial de la marca de tu interés."
      },
      cat_turbo: {
        titulo: "catálogo turbos",
        texto:
          "La más extensa gama en juegos de juntas para turbo y tubos de engrase la encontrarás en el catálogo de turbos de AJUSA. Puedes buscar la referencia por el modelo del vehículo o la marca del turbo.",
        por_vehiculo: "DESCARGAR POR MARCA DE VEHÍCULO",
        por_turbo: "descargar por marca de turbo"
      },
      cat_juntas_compresor: {
        titulo: "CATÁLOGO JUNTAS DE COMPRESOR",
        texto:
          "Consulta o descarga en pdf el catálogo de juegos de juntas para compresores de freno exclusivo para vehículo industrial. Puedes descargarlo por compresor (KNORR-BREMSE, VOITH y WABCO) o por la marca de vehículo (DAF, IVECO, MAN, MERCEDES (industrial), RVI, SCANIA y VOLVO (Industrial).",
        por_vehiculo: "DESCARGAR POR MARCA DE VEHÍCULO",
        por_turbo: "Descargar por compresor"
      },
      cat_juegoJuntas: {
        idUrl: "juntas-especiales",
        texto:
          "<strong>14 familias de juegos</strong> de juntas para diferentes partes del motor en un único catálogo. Juegos de juntas para <strong>la bomba de agua</strong>, la bomba de combustible, la bomba hidráulica, la bomba de vacío, el cárter de mando, el colector de admisión, el colector de escape, el compresor, el inyector, el radiador de aceite, el sistema de escape, el sistema EGR y <strong>la tapa de culata de cilindro</strong>. Garantizamos la cobertura más completa del mercado. Puedes consultar y descargar el catálogo completo o por el juego de juntas que necesites.",
        descarga_completo: "DESCARGAR CATÁLOGO COMPLETO",
        descarga_juegos: {
          title: "DESCARGAR POR JUEGOS DE JUNTAS",
          bombasAgua: "Bomba de agua",
          bombasAgua_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-agua-gasket-water-pump.pdf",
          bombasCombustible: "Bomba de combustible",
          bombasCombustible_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-combustible-fuel-pump.pdf",
          bombaHidraulica: "Bomba hidráulica",
          bombaHidraulica_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-hidraulica-hydraulic-pump.pdf",
          bombaInyeccion: "Bomba de inyección ",
          bombaInyeccion_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-inyeccion-injector-pump.pdf",
          bombaVacio: "Bomba de vacío ",
          bombaVacio_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-vacio-vacuum-pump.pdf",
          juntaCarter: "Cárter de mando",
          juntaCarter_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/carter-mando-timing-case.pdf",
          colectorAdminision: "Colector de admisión",
          colectorAdminision_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/colector-admision-intake-manifold.pdf",
          colectorEscape: "Colector de escape",
          colectorEscape_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/colector-escape-exhaust-manifold.pdf",
          comprensor: "Compresor",
          comprensor_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/compresor-charger.pdf",
          inyector: "Inyector",
          inyector_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/inyector-injector-nozzle.pdf",
          radiadorAceite: "Radiador de aceite",
          radiadorAceite_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/radiador-aceite-oil-cooler.pdf",
          sistemaEscape: "Sistema de escape",
          sistemaEscape_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/sistema-escape-exhaust-system.pdf",
          sistemaEGR: "Sistema EGR",
          sistemaEGR_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/sistema-juntas-EGR-System.pdf",
          tapasCulata: "Tapa de culata de cilindro",
          tapasCulata_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/tapa-culata-cilindro-cilinder-head-cover.pdf"
        }
      },
      tec_alliance: {
        intro: "acceso a catálogo online",
        titulo: "TU BÚSQUEDA ONLINE",
        texto_1:
          "Encuentra la pieza de recambio que necesitas a cualquier hora. El catálogo online AJUSA está disponible las 24 horas del día. Puedes hacer la búsqueda por vehículo, motor, VIN, número de referencia, referencia OEM o datos técnicos.",
        texto_2:
          "Todas las referencias AJUSA llevan asociadas información técnica, vídeos de montaje y fotografías 360º.",
        boton: "acceder"
      },
      ajusa_th: {
        intro: "ENERGÍAS ALTERNATIVAS",
        titulo: "FUTURO SOSTENIBLE",
        texto:
          "AJUSA ha desarrollado una línea de investigación de energías alternativas y es pionera en la fabricación de pilas de combustible PEM con hidrógeno. Descubre AJUSA Tecnologías del Hidrógeno.",
        boton: "Descubre",
        construccion: "Página en construcción. Próximamente disponible."
      },
      retenes: {
        titulo: "Catálogo juego de retenes de distribución",
        texto:
          "Ajusa lanza un catálogo específico de retenes de distribución con una amplía cobertura para realizar el cambio completo de la correa de distribución del vehículo."
      },
      motorsport: {
        titulo: "Motorsports",
        texto:
          "Consulta la guía de aplicaciones Ajusa Motorsport. Un catálogo completo de juntas de culata para motores de alto rendimiento. Estos motores necesitan piezas específicas y mejoradas debido a las condiciones extremas a las que están expuestos. Las juntas performance Ajusa aseguran un sellado perfecto en los motores deportivos y de alto rendimiento."
      },
      novedad: "Novedad",
      nav_options: {
        cat_general: {
          id: "cat-general",
          title: "catálogo general",
          category: "catalogo"
        },
        cat_turbo: {
          id: "cat-turbo",
          title: "catálogo turbos",
          category: "catalogo"
        },
        cat_ve: {
          title: "catálogo ve",
          category: "vehiculo_electrico",
          href: "vehiculo-electrico"
        },
        catalogo_online: {
          title: "catálogo online",
          redirect: "https://web.tecalliance.net/ajusa/es/home"
        },
        catalogo_impreso: {
          title: "Solicitar catálogo impreso",
          category: "catalogo",
          href: "contacto"
        }
      },
      alt_images: {
        catalog: "catalogo ajusa",
        catalog_online: "catalogo ajusa online",
        pila_hidrogeno: "pila de hidrógeno"
      }
    },
    area_tecnica: {
      intro: {
        titulo: "AJUSA área técnica",
        texto:
          "<strong class='bold'>¡Bienvenido al departamento de asistencia técnica de AJUSA!</strong> Resolvemos tus problemas y ponemos a tu disposición una amplia guía de material didáctico con <strong class='bold'>informes técnicos, vídeos de montaje y webinarios.</strong> Estamos comprometidos contigo y con la reparación de tu vehículo."
      },
      asesoramos: {
        intro: "Te asesoramos",
        texto_1:
          "Si tienes algún problema con nuestros productos, estás en el lugar adecuado. Resolvemos tus dudas y atendemos tus consultas en menos de cinco días. Envíanos tu comentario y el departamento de asistencia técnica AJUSA te ofrecerá una solución. ",
        texto_2:
          "Puedes llamarnos a este teléfono +34 619 029 273 o escribirnos por",
        boton: "Enviar"
      },
      app: {
        texto_1:
          "Descarga nuestra APP mejorada para realizar una búsqueda fácil y rápida de los componentes que necesita tu vehículo.",
        texto_2: "¡Y mucho más!"
      },
      tips: {
        titulo: "INFORMES TÉCNICOS",
        texto_1:
          "Dejarás de tener dudas y problemas con el montaje y desmontaje de los productos AJUSA. Conocerás las características de cada componente del motor y aprenderás a reconocer la pieza que necesita cada vehículo. Todo esto y mucho más es lo que te ofrece la guía de informes técnicos de AJUSA. ¡Descárgatelos! ",
        texto_2: "Publicamos un nuevo informe técnico cada 15 días.",
        filtrar: "Filtrar por categorías",
        por_keyword: "Buscar por keyword",
        resultado: "Resultados de la búsqueda:",
        mostrando: "Mostrando",
        novedades: "NOVEDADES"
      },
      webinarios: {
        titulo: "webinarios",
        texto:
          "Te formamos online. Inscríbete en nuestros webinarios y aprende de mecánica sin moverte de casa. Didácticas sesiones gratuitas de una hora, que mejorarán tus conocimientos y te harán más experto. Inglés y español. ",
        proximos: "próximos webinarios",
        no_hay: "No hay webinarios planificados en estos momentos",
        anadir_cal: "añadir a calendario",
        hasta: "19:00h hasta 21:00h",
        ultimo: "",
        btn: "Solitar Webinar"
      },
      asesoramiento: {
        intro: "asesoramiento",
        titulo: "OFRECEMOS SOLUCIONES",
        texto:
          "AJUSA te acompaña en la reparación de tu vehículo poniendo a tu disposición nuestro departamento de asistencia técnica para atender dudas y preguntas.",
        boton: "¿Te ayudamos?"
      },
      nav_options: {
        ajusa_app: {
          id: "ajusa-app",
          title: "ajusa mobile app",
          category: "area_tecnica"
        },
        tips: {
          id: "tips",
          title: "informes técnicos",
          category: "area_tecnica",
          alert: true
        },
        actualidad_videos: {
          id: "actualidad-videos",
          title: "vídeos de mecánica",
          category: "area_tecnica",
          redirect: "https://www.youtube.com/channel/UCnoYVeFbsPiOVOcf80tW6Bg"
        },
        webinars: {
          id: "webinarios",
          title: "webinarios",
          category: "area_tecnica"
        }
      },
      alt_images: {
        juntas_culata_mls: "juntas de culata mls"
      }
    },
    ajusa: {
      intro: {
        titulo: "CRECEMOS <span class='bold'>JUNTOS</span>",
        texto:
          "Somos referentes en el sector de los componentes del motor porque creemos en los que hacemos. Desde 1972, cuidamos de tu vehículo gracias a la dedicación y la tecnología aplicada en el desarrollo de componentes de motor."
      },
      enlaces: {
        calidad: "calidad original",
        servicio: "servicio",
        compromiso: "compromiso social",
        equipo: "equipo humano",
        catalogo: "catálogo"
      },
      calidad: {
        titulo: "CALIDAD ORIGINAL",
        texto:
          "Garantizamos calidad original de primer equipo en toda nuestra gama de productos y cumplimos con los máximos estándares de calidad. Disponemos de las certificaciones TÜV según la normativa ISO 9001 y la IATF 16949."
      },
      servicio: {
        titulo: "servicio",
        texto:
          "Estamos comprometidos con nuestros clientes. Estén donde estén, nuestros productos llegan siempre a tiempo. Garantizamos un ratio de servicio del 99,5%."
      },
      compromiso: {
        titulo: "compromiso<br>social y medioambiental",
        texto:
          "Contribuimos a una mejora de nuestro entorno colaborando en diferentes causas sociales y benéficas. Nuestra responsabilidad con el medio ambiente también forma parte del compromiso social de AJUSA.",
        texto_btn: "INFORME HUELLA DE CARBONO",
        pdf: "/static/pdf/Informe_Ajusa_Huella_de_carbono.pdf"
      },
      equipo: {
        titulo: "equipo humano",
        texto:
          "Inversión permanentemente en la mejora del talento profesional y en el desarrollo de nuestros empleados. Detrás de cada componente AJUSA, hay un equipo flexible y dinámico, con espíritu de mejora continua."
      },
      catalogo: {
        titulo: "catálogo",
        texto:
          "El catálogo AJUSA es nuestra principal seña de identidad, y el punto de referencia de los especialistas del motor a nivel mundial. Con más de 200.000 referencias es el más completo del mercado. Encontrarás el componente que necesitas para tu vehículo."
      },
      excelencia: {
        titulo: "EXCELENCIA, TAMBIÉN EN EL USO DE LOS RECURSOS",
        texto:
          "Alcanzamos la excelencia al mismo tiempo que cuidamos nuestro entorno. Minimizamos el impacto ambiental a través del ahorro de energía y del uso de energías renovables. Tenemos la certificación de TUV según la",
        enlace_texto: " norma ISO 14001 ",
        texto_2:
          "y más de <strong class='bold'>8.000 paneles solares que generan el 40% del consumo eléctrico anual</strong> de nuestra planta de producción.",
        boton: "VER CERTIFICADO"
      },
      historia: {
        titulo: "historia",
        texto:
          "Tenemos una historia que contar. El esfuerzo y la superación marcan los pasos de esta empresa familiar que inició su andadura en 1972 fabricando juntas de culata. Hemos crecido, hemos evolucionado… ¡Conoce nuestra historia!",
        boton: "acceder"
      },
      alt_images: {
        sede_principal: "sede principal ajusa españa",
        fabricante_tubos_engrase: "fabricante de  tubos de engrase",
        social: "ajusa compromiso social y medioambiental",
        factoria_automocion: "factoria ajusa industria automoción",
        catalog_juntas: "catálogo de juntas ajusa",
        historia: "historia de ajusa"
      }
    },
    actualidad: {
      noticias: {
        titulo: "últimas noticias",
        ir_blog: "Ir a blog"
      },
      twitter: {
        titulo: "Ajusa en las redes sociales",
        acceder: "Acceder"
      },
      videos: {
        titulo: "vídeos",
        texto:
          "Verás, paso a paso, cómo montan las piezas AJUSA en un motor real. La manera más fácil y práctica para aprender a realizar el montaje perfecto de una junta de culata y de todos los componentes del motor que fabrica AJUSA. Cada 15 días, actualizamos nuestro canal con un vehículo nuevo.",
        ultimos: "últimos vídeos",
        ver_todos: "ver todos los vídeos"
      }
    },
    blog: {
      intro: {
        titulo: "PUESTA <span>A PUNTO</span>",
        subtitulo: "El blog de"
      },
      categorias_nombres: {
        ferias: "ferias",
        productos: "productos",
        "nuestro-sector": "Nuestro sector",
        "compromiso-social": "Compromiso Social"
      },
      alt_images: {
        ajusa_blog: "ajusa blog",
        puesta_punto: "puesta a punto",
        ferias: "stand automechanika ajusa",
        productos: "juntas de culata ajusa",
        "nuestro-sector": "nuestro sector ajusa",
        "compromiso-social": "compromiso social"
      },
      ultimas: "Últimas notícias",
      dejar_comentario: "DEJAR UN COMENTARIO",
      titulo_comentarios: "COMENTARIOS RECIENTES",
      noticias_relacionadas: "Noticias Relacionadas",
      compartir: "Compartir",
      no_hay_post: "No hay post de esta categoría"
    },
    sala_prensa: {
      clipping: {
        titulo: "CLIPPING",
        texto:
          "Los medios de comunicación del sector de la automoción se hacen eco de las novedades de AJUSA. Éste es el resumen anual de las apariciones de AJUSA en prensa.",
        boton: "descargar",
        logotipo: "logotipo",
        imagenes: "imágenes"
      },
      ajusa: {
        intro: "sobre ajusa",
        titulo: "LA EXCELENCIA EN LA AUMOTOCIÓN",
        texto:
          "Fabricamos juntas de culata desde 1972. Líderes en el sellado de motores con el catálogo de juntas para el motor más amplio del sector. También expertos en la fabricación de tubos de engrase para turbo y juegos de juntas para turbo. Siempre, al servicio del automóvil."
      }
    },
    historia: {
      texto_intro:
        "Llevamos más de 45 años siendo un referente a nivel mundial. Trabajamos buscando la mejora constante tanto en nuestros productos como en nuestros servicios.",
      hoy: "Hoy",
      texto_1972_1:
        "AJUSA nace en 1972. Ese año fabricó la primera junta de culata, ¡en 3 horas y de manera totalmente manual!",
      texto_1972_2:
        "Asistimos a las primeras ferias internacionales y ampliamos instalaciones mudándonos al polígono Campollano.",
      texto_1980_1:
        "Lanzamos el primer catálogo general con 600 referencias. El catálogo actual tiene ¡20 veces más! Supera las 200.000 referencias, con cobertura completa para marcas asiáticas y europeas.",
      texto_1980_2:
        "Conseguimos fabricar por primera vez para primer equipo: junta de culata para Renault.",
      texto_1990_1:
        "Abrimos el Centro de Investigación y Ensayos (CIE), donde realizamos los más exhaustivos controles de calidad de nuestros productos.",
      texto_1990_2:
        "Lanzamiento de 3 nuevas líneas de producto: tornillos de culata, taqués hidráulicos y árboles de levas.",
      texto_2000_1:
        "Ajusa crece internacionalmente y abre sucursales en Rusia, Inglaterra, México y Brasil. Incorpora socios estratégicos en todo el mundo.",
      texto_2000_2:
        "Nos trasladamos al parque empresarial al que damos nombre: Ajusa. Con más de 40.000 m2 en la planta de producción y de 3.000 m2 en oficinas.",
      texto_2010_1:
        "Desde 2014 producimos tubos de engrase para turbo y lanzamos el catálogo de componentes de turbo con más referencias del mercado. ",
      texto_2010_2:
        "Aplicamos la última tecnología para garantizar la máxima calidad en nuestras líneas de producto."
    },
    contacto: {
      titulo: "ATENCIÓN AL CLIENTE",
      sucursales: "Sucursales",
      coords: {
        lat: 39.0034405,
        lng: -1.8193903999999748
      },
      id: "espana",
      delegaciones: {
        espana: {
          nombre: "España",
          titulo: "oficina central",
          direccion:
            "Parque Empresarial Ajusa, Calle 1, nº1 · 02008 · ALBACETE (Spain) · Apdo./P.O. Box 415 (02080)",
          telefono: "Tfno.: +34 967 216 212",
          fax: "Fax: +34 967 216 214 - 967 240 499",
          email: "Email: <a href='mailto:ajusa@ajusa.es'>ajusa@ajusa.es</a>"
        },
        // rusia: {
        //     nombre: "Rusia",
        //     titulo: "Ajusa-Rusia",
        //     direccion: "108803, Москва, п. Воскресенское, пос. Воскресенское, д. 66, а/я 1890",
        //     telefono: "Tfno. +7(499) 608-06-81 / +7(916) 060-07-24",
        //     fax: "",
        //     email: "Contacto: <a href='mailto: info@ajusa.ru'> info@ajusa.ru</a>"
        // },
        uk: {
          nombre: "Reino Unido",
          titulo: "Ajusa UK Ltd",
          direccion: "Unit 25, Hortonwood 33, Telford, TF1 7EX",
          telefono: "Tfno. +44 (0)195 2608 771",
          fax: "",
          email:
            "Contacto: <a href='mailto:info@ajusa.co.uk'>info@ajusa.co.uk</a>"
        },
        mexico: {
          nombre: "México",
          titulo: "Ajusa México S.A. de C.V",
          direccion:
            "Calle Lago Ladoga, 295-A · Col. Anahuac, Deleg. Miguel Hidalgo · Ciudad de México, D.F. CP 11320 (México)",
          telefono: "Tfno. +52-55 5254 2332",
          fax: "Fax +52-55 5254 2332",
          email:
            "Contacto: <a href='mailto:ajusamexico@ajusa.com.mx'>ajusamexico@ajusa.com.mx</a>"
        },
        brasil: {
          nombre: "Brasil",
          titulo: "Ajusa do Brasil Ltda.",
          direccion:
            "Rua Santa Francisca, 417 · Bairro Vila Jaguara, 05116-090 · SAO PAULO, SP (Brasil)",
          telefono: "Tfno. +55 11 3622-5353",
          fax: "Fax +55 11 3622-5353",
          email:
            "Contacto: <a href='mailto:ajusadobrasil@ajusa.com.br'>ajusadobrasil@ajusa.com.br</a>"
        },
        usa: {
          nombre: "USA",
          titulo: "AJUSA USA Corp.",
          direccion:
            "GABLES INTERNATIONAL PLAZA · 2655 S. LE JEUNE ROAD SUITE # 905 · CORAL GABLES, FL 33134",
          telefono: "Tfno. +1 310 625 1034",
          fax: null,
          email:
            "Contacto: <a href='mailto:ajusausa@ajusa.es'>ajusausa@ajusa.es</a>"
        },
        francia: {
          nombre: "Francia",
          titulo: "Ajusa France",
          direccion: "64, Rue Paul Claudel, 87000 | Limoges (France)",
          telefono: "Tfno. +33 587 14 71 17",
          fax: null,
          email:
            "Contacto: <a href='mailto:ajusafrance@ajusa.fr'>ajusafrance@ajusa.fr</a>"
        }
      },
      alt_images: {
        contacto_ajusa: "contacto ajusa",
        trabajar_ajusa: "trabajar en ajusa"
      },
      phone: "+34 967 216 212",
      email: "ajusa@ajusa.es"
    },
    trabaja_con_nosotros: {
      intro: {
        titulo: "<span class='bold'>trabaja</span> con nosotros",
        texto:
          "En AJUSA siempre hay un espacio reservado para el talento. Trabajamos para crecer cada día. Si deseas formar parte de nuestra gran familia, rellena este formulario y adjunta tu currículum."
      },
      texto:
        "En Ajusa trabajamos para crecer cada día, si deseas formar parte de nuestra gran familia, rellena este formulario y adjunta tu currículum.",
      boton: "enviar curriculum"
    },
    formulario: {
      nombre: "Nombre",
      nombre_apellidos: "Nombre y apellidos",
      apellidos: "Apellidos",
      email: "Email",
      mensaje: "Mensaje",
      fecha_nacimiento: "Fecha de nacimiento",
      dia: "Día",
      mes: "Mes",
      anyo: "Año",
      area_interes: "Área de su interés",
      trabaja_actualmente: "¿Trabaja actualmente?",
      motivo: "Motivo de la consulta",
      si: "Si",
      no: "No",
      carta_presentacion: "Carta de presentacion",
      tipos_contacto: {
        general: "General, contacto, sucursales",
        comercial: "Comercial",
        formacion: "Formación",
        asistencia_tecnica: "Asistencia Técnica",
        catalogo: "Solicitar catálogo en papel",
        webinar: "Solicitar Webinar"
      },
      meses: {
        Enero: "Enero",
        Febrero: "Febrero",
        Marzo: "Marzo",
        Abril: "Abril",
        Mayo: "Mayo",
        Junio: "Junio",
        Julio: "Julio",
        Agosto: "Agosto",
        Septiembre: "Septiembre",
        Octubre: "Octubre",
        Noviembre: "Noviembre",
        Diciembre: "Diciembre"
      },
      archivo_adjunto: "Adjuntar archivo",
      adjuntar_cv: "Adjuntar CV",
      empresa: "Nombre de la empresa",
      sector: "Sector",
      formulario: "Dirección completa (indique CP y localidad)",
      referencia: "Referencia de producto",
      introduce_mail: "Introduce tu email",
      tipo_catalogo: "Tipo de catálogo",
      pais: "País",
      ciudad: "Ciudad",
      direccion: "Dirección",
      telefono: "Teléfono",
      quiero_recibir: "Quiero recibir noticias y novedades de Ajusa.",
      acepto_comunicaciones:
        "Acepto recibir la newsletter u otras comunicaciones de su entidad.",
      otros_procesos:
        "Deseo ser tenido en cuenta en otros procesos de empleo de Ajusa que puedan resultar de mi interés",
      he_leido: "Consiento el uso de mis datos para los fines indicados en la",
      y_acepto: "Política de Privacidad",
      enviar_comentario: "Enviar Comentario",
      comentario_enviado: "Comentario enviado",
      texto_comentario_enviado:
        "Gracias por tu comentario. Lo revisaremos y publicaremos en el menor tiempo posible.",
      enviar: "Enviar",
      enviado: "Enviado",
      popup: {
        claim: "Pulsa aquí para consultar y aceptar la política de privacidad",
        intro: "INFORMACIÓN BÁSICA SOBRE PROTECCIÓN DE DATOS",
        textos: [
          {
            titulo: "Responsable del tratamiento",
            texto: "Auto Juntas SAU"
          },
          {
            titulo: "Dirección del responsable",
            texto:
              "Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02008, Albacete (Albacete)"
          },
          {
            titulo: "Finalidad",
            texto:
              "Sus datos serán usados para poder atender sus solicitudes y prestarle nuestros servicios."
          },
          {
            titulo: "Publicidad",
            texto:
              "Solo le enviaremos publicidad con su autorización previa, que podrá facilitarnos mediante la casilla correspondiente establecida al efecto."
          },
          {
            titulo: "Legitimación",
            texto:
              "Únicamente trataremos sus datos con su consentimiento previo, que podrá facilitarnos mediante la casilla correspondiente establecida al efecto."
          },
          {
            titulo: "Destinatarios",
            texto:
              "Con carácter general, sólo el personal de nuestra entidad que esté debidamente autorizado podrá tener conocimiento de la información que le pedimos."
          },
          {
            titulo: "Derechos",
            texto:
              "Tiene derecho a saber qué información tenemos sobre usted, corregirla y eliminarla, tal y como se explica en la información adicional disponible en nuestra página web."
          }
        ],
        boton: "Entiendo"
      },
      thank_you: {
        title: "¡ENVIADO!",
        text:
          "<p>¡Gracias! Formulario se ha enviado correctamente.</p><p>Nos pondremos en contacto contigo lo antes posible.</p>",
        btn_text: "VOLVER A LA HOME"
      }
    },
    error_404: {
      intro: "<span class='bold'>PÁGINA</span> NO ENCONTRADA",
      nombre: "Error 404",
      texto:
        "¡Lo sentimos! La página que estás intentando acceder ya no existe o se ha movido.",
      boton: "Volver al inicio"
    },
    newsletter: {
      titulo: "Suscripción newsletter",
      texto:
        "Recibe la actualidad del sector de la automoción y las últimas novedades de AJUSA.",
      suscripcion_ok:
        "¡Suscripción correcta! A partir de ahora te mantendremos informado de todas las novedades de Ajusa"
    },
    footer: {
      siguenos: "Síguenos",
      en_redes: "Síguenos en redes sociales",
      twitter: "Síguenos en X",
      facebook: "Síguenos en Facebook",
      instagram: "Síguenos en Instagram",
      canal: "Subscríbete al canal",
      selecciona_idioma: "Selecciona un idioma",
      alt_image: "ajusa certificados"
    },
    popupApp: {
      title: "Descárgate Ajusa mobile",
      description:
        "La guía más completa del sector de la automoción con toda la información de los productos AJUSA."
    },
    popupretenes: {
      title: "Nuevo catálogo<br>de retenes<br>de distribución Ajusa",
      boton: "Consúltalo y descárgalo por marcas"
    },
    popupjuntas: {
      novedades: "NOVEDAD CATÁLOGO",
      title: "JUEGOS ESPECIALES DE JUNTAS",
      texto: "para distintas partes del motor",
      boton: "VER CATÁLOGO"
    },
    popupajustick: {
      title: "NUEVO PRODUCTO",
      description: "SELLANTE ANAERÓBICO AJUSTICK",
      boton: "VER PRODUCTO"
    },
    otras_secciones: {
      catalogo: {
        titulo: "Catálogo",
        texto:
          "La manera más fácil de encontrar la pieza que necesita tu vehículo y su referencia. El catálogo AJUSA contiene las aplicaciones para todas las marcas de vehículos europeas y asiáticas. Puedes hacer la consulta online o solicitar el catálogo impreso.",
        boton_texto: "Ir a catálogo"
      },
      area_tecnica: {
        titulo: "Asesoramiento",
        texto:
          "Tienes a tu disposición el departamento <span class='bold'>de asistencia técnica AJUSA</span>. Nuestros compañeros atienden personalmente cualquier pregunta. Además, consulta nuestra <span class='bold'>guía de informes técnicos y nuestros vídeo tutoriales</span> en los que te explicamos paso a paso el montaje de nuestros productos.",
        boton_texto: "¿Necesitas ayuda?"
      },
      sala_prensa: {
        titulo: "Sala de prensa",
        texto:
          "Consulta los materiales Ajusa puestos a tu disposición así como las noticias y el resumen anual de las apariciones de AJUSA en prensa del sector de la automoción.",
        boton_texto: "VER MATERIALES"
      },
      solicite_catalogo: {
        titulo: "solicite el catálogo impreso",
        texto:
          "Hacemos fácil la reparación de vehículos. Puedes solicitar nuestro catálogo general o de turbos en papel. Envíanos una solicitud indicando en qué catálogo estás interesado. ",
        boton_texto: "solicitar"
      },
      actualidad: {
        titulo: "Actualidad",
        texto:
          "Queremos acercarte nuestro día a día y mantenerte informado de las últimas novedades. Visita nuestro blog, suscríbete a nuestra newsletter o síguenos en las redes sociales. ¡Compartimos experiencias! ",
        boton_texto: "TE ESPERAMOS"
      },
      donde_estamos: {
        titulo: "dónde estamos",
        texto:
          "Estamos donde nos necesitas. Tenemos distribuidores oficiales por todo el mundo y sucursales en México, Brasil, Rusia e Inglaterra. Nuestra factoría y sede principal, desde donde desarrollamos todo el trabajo, está en Albacete (España). ",
        boton_texto: "Contacta con nosotros"
      }
    },
    banner_cookies:
      "Una cookie es un pequeño archivo de información que se guarda en su navegador cada vez que visita nuestra web. La utilidad de las cookies es guardar el historial de su actividad en nuestra para que, cuando la visite nuevamente, pueda identificarle y configurar su contenido en base a sus hábitos de navegación, identidad y preferencias. Pueden ser aceptadas, rechazadas, bloqueadas y borradas, según desee. En caso de que las rechace no podremos asegurarle el correcto funcionamiento de nuestra web. Más información en el apartado <router-link to='/politica-de-cookies'>política de cookies</router-link>.",
    boton_aceptar: "Aceptar",
    historia_infografia: {
      celebracion50:
        '<p>Celebraci<span>ó</span>n</p><p class="second-line">50 Aniversario</p>',
      celebracion50descripcion:
        "El 11 de noviembre de 2022 reunimos a toda la plantilla de empleados en el Teatro Circo de Albacete para celebrar nuestros 50 años de historia.",
      video: "VIDEO",
      galeria: "GALERÍA DE IMÁGENES",
      noticias: "NOTICIAS",
      urlNoticias:
        "https://ajusa.online/blog/noticia/ajusa-celebra-50-aniversario",
      urlVideoIntro: "/static/img/historia_infografia/intro.mp4",
      Anios50: "<strong>50 </strong>AÑOS",
      excedencia: "de excelencia",
      enAutomocion: "EN LA AUTOMOCIÓN",
      albacete: "<strong>ALBACETE</strong>",
      laCuidad: "LA CIUDAD QUE NOS VIO",
      crecer: "crecer",
      mayorAntesDeTiempo: "MAYOR ANTES DE TIEMPO",
      textMayor:
        "<strong>Fue el quinto de seis hermanos. Con 9 años se quedó huérfano de madre y con 15 de padre, que se dedicó al mundo del transporte toda su vida. </strong>",
      eraseUnaVez: "Érase una vez…",
      textEraseUnaVez:
        "Albacete, 13 de feberero de 1950. Nace José Manuel Martínez Martínez, fundador de Ajusa. Su situación familiar le obligó a dejar los estudios y empezó a trabajar con  13 años como dependiente en una tienda de cuadros y en una charcutería de su barrio.",
      cuentameMas: "¡CUÉNTAME MÁS!",
      unGestoInolvidable: "Un gesto inolvidable",
      enEsteTrabajo:
        "En este trabajo le dieron de alta en la <strong>Seguridad Social</strong>. Aquel hecho, tan poco habitual en aquella época, fue muy importante para él.",
      aprendiendoElOficio: "Aprendiendo el oficio…",
      con14Anios:
        "Josema descubrió su verdadera vocación con 14 años cuando empezó a trabajar en el concesionario Pegaso de Albacete (COMALBASA), donde no tardaron en nombrarlo responsable del departamento de recambios.",
      granImplicacion: "Una gran implicación",
      fueronAnios:
        "Fueron años de mucha dedicación y aprendizaje, en los que compaginó el servicio militar en Sevilla con su trabajo en Auto Martínez, empresa de recambios que fundó junto a sus hermanos en 1969.",
      fueronMeses:
        "Hacía los turnos de noche en el servicio militar para gestionar Auto Martínez por el día. Tal era su implicación que gastaba al mes <strong>¡más de 50.000 pesetas en llamadas telefónicas!</strong>",
      naceAjusa: "Nace Ajusa",
      suEspiritu:
        "José Manuel Martínez decidió apostar por su propio negocio motivado por su espíritu emprendedor y por su pasión por la automoción. En 1972, abrió un pequeño establecimiento donde empezaron a fabricarse las primeras juntas de motor marca España.",
      naceLaCompania:
        "Nace así la compañía industrial Auto Juntas (actual Ajusa), empresa que preside hasta la actualidad.",
      miguelOliver:
        "Miguel Oliver fue nombrado director industrial y José Gómez responsable artesano en utillajes a la carta.",
      primeraJuntas:
        "Las primeras juntas de culata eran fabricadas de forma totalmente manual y con utillajes propios producidos también en nuestras instalaciones.",
      seTardada:
        "Se tardaba alrededor de ¡3 horas! en fabricar una junta de culata, mientras que en la actualidad podemos producir 1000 juntas de culata en 3 horas.",
      primeraEtapa:
        "En esta primera etapa se usaban materiales como el amianto. Ajusa fue el primer fabricante del mundo en dejar de utilizar este material actualmente prohibido.",
      contanciaEsfuerzo: "Constancia y esfuerzo",
      josemaRecorrio:
        "<strong>Josema recorrió casi todas las ciudades de España. Cuando llegaba a un sitio, cogía la guía telefónica y llamaba uno por uno a todos los talleres y tiendas de recambio hasta que lo atendían personalmente para presentar el catálogo Ajusa.<br>Así fue como nuestra marca empezó a darse a conocer en España.</strong>",
      edicion: "Edición",
      catalogoAjusa: "Catálogo Ajusa",
      infoCatalogo:
        "Solo un año después del nacimiento de Ajusa y con una plantilla de 10 trabajadores, se lanzó el primer catálogo de juntas para el motor. En aquella época tenía 600 referencias mientras que en la actualidad, con un equipo humano de 800 personas, supera las 200.000.",
      verPortadas: "VER PORTADAS",
      textInfo1974:
        "Y así surgió la historia de amor entre Josema y Dori, que fueron padres de tres hijos: Consuelo, José Manuel y Noelia. La esencia de Ajusa parte de los valores familiares y del compromiso.",
      amorAPrimera: "Amor a primera vista",
      descriptAmor:
        "La chica de la imagen es Adoración Sánchez, que durante un año fue empleada de Ajusa en la sección de empaquetado y en el departamento de adminstración. El mismo día que ella dejó la empresa, Josema la llamó por teléfono… ¡para pedirle una cita!",
      crecimientoImparable: "Un crecimiento imparable",
      text1crecimientoImparable:
        "Pasaban los años y con esfuerzo, sacrificio y la misma ilusión con la que nació, Ajusa continuó imparable su crecimiento trasladándose al <strong>Polígono Campollano de Albacete</strong> y ampliando su línea de producción.",
      text2crecimientoImparable:
        "Y lo más importante, Josema mantenía intacto el espíritu emprendedor de sus inicios.  Mientras se asentaba el liderazgo de la marca en el mercado nacional, su vista ya estaba puesta en la internacionalización.",
      verMas: "VER MÁS",
      title1978: "De una empresa local…<br>¡al mundo!",
      description1_1978:
        "Su temprana presencia en las principales ferias internacionales y un ambicioso plan de exportación para la década de los años 70, permitieron a la empresa abrir mercado en otros países.",
      description2_1978:
        "Josema defendió su criterio empresarial y no sucumbió a las imposiciones de grandes multinacionales. ¡Hasta llegó a rechazar contratos de millones de pesetas!",
      description3_1978:
        "En 1978, Ajusa participa en Automechanika, la <strong>feria internacional más importante del automóvil</strong> que se celebra cada dos años en Frankfurt.",
      importanteReconociento: "¡Un importante reconocimiento!",
      espirituInnovador:
        "El espíritu innovador y emprendedor que José Manuel Martínez mostró desde muy joven le permitió conseguir la <strong>Medalla de Oro a la Exportación</strong> en el año 1981.",
      title1980: "Los cimientos de una gran empresa",
      description1_1980:
        "La ampliación de los servicios ofrecidos y el aumento de la demanda hicieron necesario contar con unas instalaciones de mayor superficie.",
      description2_1980:
        "En 1980, Ajusa levanta los cimientos de su primera gran factoría ampliando las instalaciones de Campollano.  De manera sucesiva, irá sumando metros cuadrados con el único objetivo de brindar el mejor servicio a los profesionales del sector de la automoción.",
      title1992: "Expansión de negocio",
      description1_1992:
        "La junta de culata continuó siendo el producto estrella, pero 1992 fue un año estratégico en la expansión del negocio con la incorporación de <strong>juegos de juntas completos</strong> para el motor, tornillos de culata y una completa gama de <strong>juntas accesorias</strong>. Se abre también la línea de mecanizados para fabricar taqués hidráulicos y árboles de levas.",
      calidadGarantizada: "Calidad garantizada",
      ajusaEmpresaPionera:
        "Ajusa fue una de las empresas pioneras en conseguir las certificaciones de calidad AENOR según la normativa ISO 9001 y la IATF 16949 en la decáda de los 90.",
      primeraEmpresaSector:
        "También fue la <strong>primera empresa del sector</strong> en ofrecer al cliente el kit completo de juntas para un mismo motor.",
      title1996: "Abrimos sucursales",
      description1_1996:
        "La empresa se consolida y se convierte en un referente abriendo varias sedes en diferentes puntos como Los Ángeles (EEUU), Sao Paulo (Brasil), Ciudad de México (México), Birmingham (UK) y Limoges (Francia).",
      eeuuPrimeraSucursal: "EEUU, primera sucursal",
      sucursalEeuu:
        "La sucursal de Ajusa en Estados Unidos fue la primera en abrir sus puertas y, al igual que el resto de sucursales, cuenta con un almacén de más de 10.000 artículos en stock.",
      comprometidosSostenibilidad: "Comprometidos con la sostenibilidad",
      infocomprometidosSostenibilidad:
        "La empresa también aplica en toda su cadena de producción una <strong>política medioambiental</strong> para reducir al máximo el impacto sobre el medio ambiente y cuenta con una instalación fotovoltaica en la cubierta de la factoría, que proporciona el 30% del consumo de las plantas de producción con una potencia de 1500 KW.",
      title2002: "Pioneros en tecnologías del hidrógeno",
      description2002:
        "Ajusa constituyó en 2002 una sociedad dedicada a la investigación del hidrógeno como energía alternativa: <strong>Ajusa Tecnologías del Hidrógeno.</strong><br> Actualmente, aplica las tecnologías más vanguardistas en la puesta en marcha de múltiples proyectos con tecnología PEM.",
      actualizamosLogo: "Actualizamos logo",
      evolucionG: "Evolución gráfica",
      title2008: "Parque empresarial Ajusa",
      description1_2008:
        "En 2008, sin perder su arraigo local, se inauguran las instalaciones de producción ubicadas en el Parque Empresarial Ajusa.",
      description2_2008:
        "Un conjunto de 5 factorías con diferentes líneas de producción, que integra la tecnología más avanzada y garantiza la máxima fiabilidad en la gama de productos Ajusa. ",
      title2014: "Nuevas líneas de producción",
      description1_2014:
        "El afán innovador de Josema y su equipo, unido a la inversión continua de la empresa en investigación y desarrollo de producto, facilitó la puesta en marcha de la línea de producción de componentes de turbos, que incluye tanto el desarrollo de juntas como la producción de tubos de engrase para turbos.",
      description2_2014:
        "Este año también se lanzó la primera edición de catálogo de componentes para turbo. Tanto las líneas de producción como el equipo humano seguían en constante crecimiento.",
      title2022: "Crecemos juntos",
      description1_2022:
        "50 años que han aportado a la empresa <strong>nuevos valores y nuevos productos</strong>, dotándola de una identidad con un marcado sentido de responsabilidad con su entorno. Por ello, Ajusa participa anualmente en diversos proyectos para colaborar y apoyar las acciones sociales que llevan a cabo diversas asociaciones.",
      description2_2022:
        "Este año, con la historia que nos precede, celebramos con gran responsabilidad nuestro 50 aniversario, pensando que será un punto de referencia en la historia de Ajusa y de un futuro creciendo juntos.",
      verVideo: "VER VÍDEO",
      urlVideoCompl: "/static/img/historia_infografia/video-completo-es.mp4"
    },
    vehiculo_electrico: {
      intro_titulo: "VEHÍCULO ELÉCTRICO",
      descripcion_intro:
        "Ajusa cuenta con un amplío catálogo de componentes para reparar vehículos híbridos y eléctricos. Además, te ayuda en su reparación con fichas explicativas de cada avería que puedes descargar en esta sección, y con vídeo tutoriales grabados por un especialista en reparación de vehículos eléctricos.</br></br>",
      descripcion_intro2:
        "<img src='/static/img/vehiculo-electrico/triangle-exclamation-duotone.svg' style='height:20px; margin-right: 5px;' alt='icon important'/><strong>Medidas de seguridad y herramientas básicas</strong> para reparar un vehículo eléctrico. ¡Haz clic en el vídeo!",
      catalogo: {
        titulo: "CÁTALOGO REPARACIÓN DE MOTORES ELÉCTRICOS",
        descripcion:
          "En esta sección puedes consultar el <strong>catálogo de piezas de recambio Ajusa para vehículos híbridos y eléctricos</strong> buscando por la marca de automóvil. Cada ficha de producto del catálogo Ajusa incluye una descripción de las principales averías de ese modelo y el enlace a un vídeo tutorial sobre su reparación."
      },
      sellado: {
        titulo: "SOLUCIONES DE SELLADO PARA VEHÍCULO ELÉCTRICO",
        descripcion:
          "Estamos a la vanguardia de la industria automovilística como <strong>el primer fabricante mundial de componentes de recambio para vehículos híbridos y eléctricos</strong>. Nos avalan más de 50 años de experiencia como fabricantes de componentes para el sector de la automoción."
      },

      material: {
        titulo: "MATERIAL DIDÁCTICO AUDIOVISUAL",
        descripcion:
          "En la actualidad es crucial encontrar mecánicos especializados en electromecánica. El material didáctico que Ajusa ofrece a través de sus video tutoriales cumple las más <strong>exigentes necesidades de formación en vehículos híbridos y eléctricos</strong>. Aprenderás a reparar el motor/generador, las baterías o los inverters/converters de los vehículos eléctricos. Todos los vídeos están disponibles escaneando el QR que aparece en la etiqueta de cada producto."
      },
      porqueElegir: {
        titulo: "¿POR QUÉ ELEGIR UN VEHÍCULO ELÉCTRICO O UN VEHÍCULO HÍBRIDO?",
        descripcion:
          "<p> En Ajusa entendemos que elegir un vehículo eléctrico (EV) o un coche híbrido (HEV) es mucho más que una simple decisión para desplazarte de un sitio a otro. Es una declaración de compromiso con el futuro y una inversión en movilidad sostenible.</p><p> Ajusa ofrece una amplia selección de <strong>repuestos de alta calidad</strong> diseñados para componentes de vehículos eléctricos, garantizando un rendimiento óptimo y sostenibilidad.</p><p> Cada kit de componentes para vehículos eléctricos Ajusa incluye una descripción de las averías más habituales de ese modelo con un enlace a un vídeo sobre la reparación del motor.</p><p>Pero <strong>¿por qué deberías comprar uno de estos vehículos?</strong></p>"
      },
      medioAmbiente: {
        titulo: "CONTRIBUIR AL MEDIOAMBIENTE",
        descripcion:
          "<p>Optar por un EV o HEV es una forma tangible de <strong>reducir su huella de carbono</strong>. Estos vehículos producen menos emisiones nocivas y contribuyen a la preservación del medio ambiente.</p><p>Al confiar en Ajusa para la reparación de componentes de coches eléctricos e híbridos, mantienes tu vehículo ecológico en las mejores condiciones.</p>"
      },
      ahorro: {
        titulo: "AHORRO A LARGO PLAZO",
        descripcion:
          "<p>Aunque la inversión inicial puede ser ligeramente mayor, los vehículos eléctricos e híbridos ofrecen un importante ahorro a lo largo de su vida útil. Con costos de energía más bajos y menos necesidad de mantenimiento, notará una diferencia sustancial en sus gastos de conducción.</p>"
      },
      experiencia: {
        titulo: "EXPERIENCIA DE CONDUCCIÓN AVANZADA",
        descripcion:
          "<p>Los coches eléctricos e híbridos ofrecen una experiencia de conducción suave, silenciosa y libre de emisiones. La última tecnología en estos vehículos garantiza un rendimiento excepcional y un confort inigualable en la carretera.</p>"
      },
      innovacion: {
        titulo: "APOYANDO A LA INNOVACIÓN",
        descripcion:
          "<p>Al elegir un coche eléctrico o híbrido, estás apoyando la innovación en la industria del automóvil. Estos vehículos impulsan la investigación y el desarrollo de tecnologías más limpias y eficientes, allanando el camino hacia un futuro más sostenible.</p>"
      },
      catalogo_vehiculo_hibrido: "CATÁLOGO VEHÍCULO HÍBRIDO Y ELÉCTRICO",
      catalogo_vehiculo_hibrido_kits:
        "Todos nuestros kits de reparación también están disponibles sin rodamientos.",
      catalogo_juntas_compresor: "CATÁLOGO JUNTAS COMPRESOR A/C",
      renault: "RENAULT",
      modelo: "Modelo",
      ano: "Año",
      n_comprensor: "Nº de compresor",
      codigo_motor: "Código motor",
      tipo_averia: "Tipo de avería",
      referencias_disponibles: "Referencias Ajusa disponibles",
      otras_referencias: "Otras referencias",
      manual: "MANUAL DE REPARACIÓN",
      videoReparacion: "VÍDEO DE LA REPARACIÓN",
      producto: "Producto",
      commercialInfo: "SOLICITA INFORMACIÓN COMERCIAL",
      accessVideoTut: "ACCESO A TODOS LOS VIDEO TUTORIALES",
      videos: {
        video0: {
          id: "vehiculo-electrico-2",
          videoId: "svouPU4u8jY",
          text:
            "¿Sabes lo que necesitas para reparar un vehículo eléctrico? En este vídeo te explicamos las <strong>medidas de seguridad y las principales herramientas</strong> que debe tener un taller mecánico.",
          btnText: "VÍDEO"
        },
        EV001900: {
          id: "AUDI",
          modelo: "AUDI E-tron 55",
          año: "2019 - 2023",
          codigoMotor: "EASA",
          referenciasDisponibles: "EV001900",
          videoId: "aM7HnIMiV8s"
        },
        EV001400: {
          id: "BMW",
          modelo: "BMW i3",
          año: "2012 - 2022",
          codigoMotor: "IB1P25B",
          referenciasDisponibles: "EV001400",
          videoId: "_krGGRnVYtI"
        },
        EV000500: {
          id: "Hyundai | Kia",
          modelo:
            "Hyundai Kona, Hyundai Kauai, Kia Niro EV, Kia E-Soul EV (III)",
          año: "2018-2023",
          codigoMotor: "EM16",
          referenciasDisponibles: "EV000500",
          videoId: "gi1Gbs3d9NA"
        },
        EV000700: {
          id: "hyundai",
          modelo: "Hyundai Ionic EV",
          año: "2016-2019",
          codigoMotor: "EM09, 88KW, 120CV",
          referenciasDisponibles: "EV000700",
          videoId: "D5RnWWK1JXM"
        },
        EV000600: {
          id: "kia",
          modelo: "Kia Soul EV (II) 81KW, 110CV",
          año: "2014-2018",
          codigoMotor: "ZD",
          referenciasDisponibles: "EV000600",
          videoId: "YJ82wEmqP5M"
        },
        EV001300: {
          id: "nissan",
          modelo: "Nissan LEAF ZE01",
          año: "2017-2022",
          codigoMotor: "EM57",
          referenciasDisponibles: "EV001300",
          videoId: "Sz-wPyY0To8"
        },
        EV001200: {
          id: "peugeot",
          modelo: "PEUGEOT E-208",
          año: "2020-",
          codigoMotor: "ZK01",
          referenciasDisponibles: "EV001200",
          videoId: "6zXy9dBiqsY"
        },
        EV000100: {
          id: "renault",
          modelo: "Renault Zoe",
          año: "2012-2018",
          codigoMotor: "5M- 450",
          referenciasDisponibles: "EV000100",
          videoId: "cI_eu063pw4"
        },
        EV000200: {
          id: "Renault | Smart",
          modelo: "Renault Zoe, Smart Fortwo W453",
          año: "Renault (2012-2019), Smart (2016-2019)",
          codigoMotor: "Renault (5AQ-601) Smart (5AL)",
          referenciasDisponibles: "EV000200",
          videoId: "ZA93lYHO_T0"
        },
        EV000300: {
          id: "tesla",
          modelo: "Tesla Model 3, Tesla Model Y",
          año: "2017-2021",
          codigoMotor:
            "1120980-00-G / 1120980-17-J / 1120990-00-J / 1672095-00-C / 1672096-00-B /1672096-00-C",
          referenciasDisponibles: "EV000300",
          videoId: "gazCfvf3N9c"
        },
        EV000400: {
          id: "tesla",
          modelo: "Tesla Model S · Tesla Model X",
          año: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          codigoMotor: "1035000-00-J",
          referenciasDisponibles: "EV000400",
          videoId: "CK5OeOPX-sM"
        },
        EV000800: {
          id: "tesla",
          modelo:
            "Tesla Model S · Tesla Model X · Mercedes B-Class B250e · Toyota RAV4 EV",
          año:
            "Tesla Model S (2012 – 2021) · Tesla Model X (2015 – 2021) · Mercedes B-Class B250e (2014 – 2017)  · Toyota RAV4 EV (2012 – 2014)",
          codigoMotor:
            "1002633-00-U / 002633-01-U / 1002633-01-U / 1025598-01-U",
          referenciasDisponibles: "EV000800",
          videoId: "JxbTKXWBRMw"
        },
/*         EV000802: {
          id: "tesla | Mercedes | Toyota",
          producto: "Coolant bypass kit",
          modelo:
            "Tesla Model S, Tesla Model X, Mercedes B-Class, Toyota Rav4 EV",
          año:
            "Tesla Model S (2012-2021), Tesla Model X (2015-2021), Mercedes (2014-2017), Toyota (2012-2014)",
          codigoMotor: "1002633-00-U, 1002633-01-U, 1025598-01-U",
          referenciasDisponibles: "EV000802",
          videoId: "d2gj_aTYW1o"
        }, */
        EV001000: {
          id: "tesla",
          modelo: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          año: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          codigoMotor: "1037000-20-A y 1037000-00-F",
          referenciasDisponibles: "EV001000",
          videoId: "gEr97ru09VQ"
        },
        EV001100: {
          id: "tesla",
          modelo: "Tesla Model 3 (2017-2025) · Tesla Model Y (2020-2025)",
          año: "Tesla Model 3 (2017-2025) · Tesla Model Y (2020-2025)",
          codigoMotor:
            "Dual Motor con motor delantero código 3D3 (combinado con motores 3D5, 3D6 or 3D7)",
          referenciasDisponibles: "EV001100",
          videoId: "MIVazJrPxOs"
        },
        EV000901: {
          id: "volvo",
          modelo: "Volvo V60",
          año: "2011-2018",
          codigoMotor: "D82PHEV, D87PHEV, D97PHEV y B1APHEV",
          referenciasDisponibles: "EV000901",
          videoId: "0_-WLtUpgm4"
        },
        EV001500: {
          id: "volkswagen",
          modelo: "E-Golf",
          año: "2014-2021",
          codigoMotor: "EBSA",
          referenciasDisponibles: "EV001500",
          videoId: "vv8NSjXvAlk"
        }
      },
      videosComprensor: {
        EVC00100: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012-2019",
          nComprensor: "1063369-00-G",
          referenciasDisponibles: "EVC00100",
          videoId: "A_h7O2TGtEU"
        },
        EVC00200: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012-2017",
          nComprensor: "1028398-00-E",
          referenciasDisponibles: "EVC00200",
          videoId: "71wMqdMsqHg"
        },
        EVC00300: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012",
          nComprensor: "6007380-00-C",
          referenciasDisponibles: "EVC00300",
          videoId: "Ok9Q-mgfJmw"
        },
        EVC00400: {
          id: "tesla",
          modelo: "Tesla Model X",
          año: "2015-2025",
          nComprensor: "1042442-00-D",
          referenciasDisponibles: "EVC00400",
          videoId: "5gOHPBtBtbA"
        }
      },
      hazte_experto: "¡HAZTE EXPERTO!",
      reparacion_vehiculos: "EN REPARACIÓN DE VEHÍCULOS HÍBRIDOS Y ELÉCTRICOS",
      reparacion_vehiculos_descripcion:
        "Sólo un 1% de los mecánicos está especializado en la reparación de vehículos eléctricos. <strong>Puedes ser uno de ellos</strong> gracias al material didáctico que Ajusa incluye en todos sus componentes para vehículos híbridos y eléctricos.",
      reparacion_vehiculos_descripcion_2:
        " <strong>Escanea el código QR</strong> que encontrarás en la <strong>etiqueta de cada producto</strong> para acceder a un vídeo tutorial que te guiará paso a paso durante todo el proceso de reparación.",
      ajusa_te_lo_pone_facil: "AJUSA TE LO PONE FÁCIL",
      opiniones_titulo: "OPINIONES",
      opiniones: {
        opinion1: {
          cliente: "Julián Fernández | Electromecánica",
          descripcion:
            "“Una manera práctica y didáctica que me ayudó a mejorar los conocimientos sobre mecánica de vehículos eléctricos. Muy contento también con la calidad de los componentes para vehículos eléctricos fabricados por Ajusa.”"
        },
        opinion2: {
          cliente: "Juan Soler | Taller AGR",
          descripcion:
            "“Con los vídeos de Ajusa he aprendido a realizar la reparación de motores eléctricos. Recomiendo utilizar este material en todos los talleres para aprender sobre mecánica de vehículos eléctricos.”"
        },
        opinion3: {
          cliente: "Bienvenido Martínez | Talleres El Paso",
          descripcion:
            "“Sólo hay que escanear el QR de la etiqueta del producto que vas a utilizar para acceder a un interesante tutorial sobre el montaje de todas las piezas. Muy práctico y sencillo.”"
        },
        opinion4: {
          cliente: "Diego González | Garage Motor",
          descripcion:
            "“Me sorprendió la profesionalidad del mecánico que aparece en los vídeos y cómo explica paso a paso la reparación y el montaje del motor. Son vídeos muy útiles para cualquier mecánico. Los seguiré utilizando en futuras reparaciones.”"
        }
      },
      dropdowns: {
        "dropdown-1": {
          title: "COMPONENTES PARA COCHES ELÉCTRICOS",
          content:
            "<p>Cuando se trata de la reparación de componentes de vehículos eléctricos (EV), conocerlos es fundamental para garantizar un servicio eficiente y de alta calidad. En Ajusa tenemos una amplia experiencia en la reparación de todos los elementos fundamentales que hacen funcionar un coche eléctrico.</p><h3><strong>Motor eléctrico</strong></h3><p> Este componente de tu coche eléctrico requiere atención experta en caso de problemas.</p><h3><strong> Batería de tracción </strong></h3><p> La batería de tracción es un componente crítico en los coches eléctricos y su reparación es fundamental para mantener la autonomía y la eficiencia de su vehículo.</p><h3><strong> Batería auxiliar </strong></h3><p> Además de la batería principal, los vehículos eléctricos cuentan con una batería auxiliar que alimenta los sistemas críticos.</p><h3><strong>Convertidor de poder </strong></h3><p> El convertidor de potencia juega un papel importante en la gestión de energía. Cualquier problema en este componente de tu coche eléctrico puede afectar al rendimiento general.</p><h3><strong> Cargador a bordo </strong></h3><p> La carga de un vehículo eléctrico es una parte clave de su funcionamiento diario. Si tiene problemas con el cargador de a bordo, podemos ofrecerle soluciones efectivas para garantizar que su vehículo esté siempre listo para la carretera.</p><h3><strong>Transmisión</strong></h3><p> Las transmisiones de los vehículos eléctricos son diferentes a las de los vehículos de combustión interna y requieren conocimientos especializados.</p><h3><strong>Toma de carga</strong></h3><p> La toma de carga es la puerta de entrada de la energía a tu vehículo eléctrico.</p><h3><strong>Módulo electrónico</strong></h3><p>Los módulos electrónicos juegan un papel crucial en su operación.</p>"
        },
        "dropdown-2": {
          title: "COMPONENTES PARA COCHES HÍBRIDOS",
          content:
            "<p>Cuando hablamos de vehículos híbridos, es fundamental entender los elementos fundamentales que hacen posible su funcionamiento eficiente.En Ajusa acumulamos una amplia experiencia en la reparación de estos componentes, lo que nos permite ofrecer un servicio seguro y de alta calidad.</p><h3><strong>Motor de combustión</strong></h3><p>Mantener en buen estado este componente de tu coche híbrido es fundamental. En Ajusa brindamos servicios de reparación y mantenimiento para asegurar que su desempeño sea eficiente y bajo en emisiones.</p><h3><strong>Motor-generador eléctrico</strong></h3><p>El motor-generador eléctrico es un componente imprescindible en un coche híbrido, ya que convierte la energía cinética en electricidad para cargar las baterías.</p><h3><strong>Inversor</strong></h3><p>El inversor se encarga de convertir la energía eléctrica almacenada en las baterías en energía utilizable para el motor eléctrico.</p><h3><strong>Baterías</strong></h3><p>Este componente de tu coche híbrido garantiza su correcto funcionamiento.</p>"
        }
      },
      solucionesAftermarkert: "SOLUCIONES AFTERMARKET",
      subtitulo_soluciones: "PARA VEHÍCULOS HÍBRIDOS Y ELÉCTRICOS",
      descripcion_soluciones:
        "Ajusa es el <strong>primer fabricante especializado</strong> en el desarrollo y fabricación de componentes para la reparación de vehículos híbridos y eléctricos a nivel mundial. Red de distribución internacional en más de 80 países.",
      solicita_info: "SOLICITAR INFORMACIÓN",
      alt_images: {
        tag_ajusa: "etiqueta ajusa",
        juntas_electricos: "juntas para vehículos eléctricos"
      }
    },
    sobre_nosotros: {
      nav_options: {
        ajusa: {
          title: "ajusa",
          category: "sobre_nosotros",
          href: "ajusa"
        },
        historia: {
          title: "nuestra historia",
          category: "aniversario50",
          href: "50-aniversario"
        },
        blog: {
          title: "blog",
          category: "blog",
          href: "blog"
        },
        contacto: {
          title: "contacto",
          category: "contacto",
          href: "contacto"
        },
        canal_etico: {
          title: "Canal Ético",
          redirect: "https://ajusa.canales-eticos.com"
        },
        trabaja_con_nosotros: {
          title: "Trabaja con nosotros",
          href: "trabaja-con-nosotros"
        }
      }
    },
    politica_privacidad:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">POLÍTICA DE PRIVACIDAD</h1><p>La Dirección / Órgano de Gobierno de AUTO JUNTAS SAU (en adelante, el responsable del tratamiento), asume la máxima responsabilidad y compromiso con el establecimiento, implementación y mantenimiento de la presente Política de Protección de Datos, garantizando la mejora continua del responsable del tratamiento con el objetivo de alcanzar la excelencia en relación con el cumplimiento del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento general de protección de datos) (DOUE L 119/1, 04-05-2016), y de la normativa española de protección de datos de carácter personal (Ley Orgánica, legislación sectorial específica y sus normas de desarrollo).</p><br><p>La Dirección / Órgano de Gobierno de AUTO JUNTAS SAU (en adelante, el responsable del tratamiento), asume la máxima responsabilidad y compromiso con el establecimiento, implementación y mantenimiento de la presente Política de Protección de Datos, garantizando la mejora continua del responsable del tratamiento con el objetivo de alcanzar la excelencia en relación con el cumplimiento del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento general de protección de datos) (DOUE L 119/1, 04-05-2016), y de la normativa española de protección de datos de carácter personal (Ley Orgánica, legislación sectorial específica y sus normas de desarrollo).</p><br><p>La Política de Protección de Datos de AUTO JUNTAS SAU descansa en el principio de responsabilidad proactiva, según el cual el responsable del tratamiento es responsable del cumplimiento del marco normativo y jurisprudencial que gobierna dicha Política, y es capaz de demostrarlo ante las autoridades de control competentes.</p><br><p>En tal sentido, el responsable del tratamiento se regirá por los siguientes principios que deben servir a todo su personal como guía y marco de referencia en el tratamiento de datos personales:</p><p><span class="bold">1. Protección de datos desde el diseño:</span>el responsable del tratamiento aplicará, tanto en el momento de determinar los medios de tratamiento como en el momento del propio tratamiento, medidas técnicas y organizativas apropiadas, como la seudonimización, concebidas para aplicar de forma efectiva los principios de protección de datos, como la minimización de datos, e integrar las garantías necesarias en el tratamiento.</p><p><span class="bold">2. Protección de datos por defecto:</span>el responsable del tratamiento aplicará las medidas técnicas y organizativas apropiadas con miras a garantizar que, por defecto, solo sean objeto de tratamiento los datos personales que sean necesarios para cada uno de los fines específicos del tratamiento.</p><p><span class="bold">3. Protección de datos en el ciclo de vida de la información:</span>las medidas que garanticen la protección de los datos personales serán aplicables durante el ciclo completo de la vida de la información.</p><p><span class="bold">4. Licitud, lealtad y transparencia:</span>los datos personales serán tratados de manera lícita, leal y transparente en relación con el interesado.</p><p><span class="bold">5. Limitación de la finalidad:</span>los datos personales serán recogidos con fines determinados, explícitos y legítimos, y no serán tratados ulteriormente de manera incompatible con dichos fines.</p><p><span class="bold">6. Minimización de datos:</span>los datos personales serán adecuados, pertinentes y limitados a lo necesario en relación con los fines para los que son tratados.</p><p><span class="bold">7. Exactitud:</span>los datos personales serán exactos y, si fuera necesario, actualizados; se adoptarán todas las medidas razonables para que se supriman o rectifiquen sin dilación los datos personales que sean inexactos con respecto a los fines para los que se tratan.</p><p><span class="bold">8. Limitación del plazo de conservación:</span>los datos personales serán mantenidos de forma que se permita la identificación de los interesados durante no más tiempo del necesario para los fines del tratamiento de los datos personales.</p><p><span class="bold">9. Integridad y confidencialidad:</span>los datos personales serán tratados de tal manera que se garantice una seguridad adecuada de los datos personales, incluida la protección contra el tratamiento no autorizado o ilícito y contra su pérdida, destrucción o daño accidental, mediante la aplicación de medidas técnicas u organizativas apropiadas.</p><p><span class="bold">10. Información y formación:</span>una de las claves para garantizar la protección de los datos personales es la formación e información que se facilite al personal involucrado en el tratamiento de los mismos. Durante el ciclo de vida de la información, todo el personal con acceso a los datos será convenientemente formado e informado acerca de sus obligaciones en relación con el cumplimiento de la normativa de protección de datos.</p><br><p>La Política de Protección de Datos de AUTO JUNTAS SAU es comunicada a todo el personal del responsable del tratamiento y puesta a disposición de todas las partes interesadas.</p><br><p>En su consecuencia, la presente Política de Protección de Datos involucra a todo el personal del responsable del tratamiento, que debe conocerla y asumirla, considerándola como propia, siendo cada miembro responsable de aplicarla y de verificar las normas de protección de datos aplicables a su actividad, así como identificar y aportar las oportunidades de mejora que considere oportunas con el objetivo de alcanzar la excelencia en relación con su cumplimiento.</p><br><p>Esta Política será revisada por la Dirección / Órgano de Gobierno de AUTO JUNTAS SAU, tantas veces como se considere necesario, para adecuarse, en todo momento, a las disposiciones vigentes en materia de protección de datos de carácter personal.</p></div></div>',
    datos_seguros:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">TUS DATOS SEGUROS</h1><p>En Europa y en España existen normas de protección de datos pensadas para proteger su información personal de obligado cumplimiento para nuestra entidad.</p><p>Por ello, es muy importante para nosotros que entienda perfectamente qué vamos a hacer con los datos personales que le pedimos.</p><p>Así, seremos transparentes y le daremos el control de sus datos, con un lenguaje sencillo y opciones claras que le permitirán decidir qué haremos con su información personal.</p><p>Por favor, si una vez leída la presente información le queda alguna duda, no dude en preguntarnos. Muchas gracias por su colaboración.</p><p class="bold">¿Quiénes somos?</p><ul><li>Nuestra denominación:<b>AUTO JUNTAS SAU</b></li><li>Nuestro CIF / NIF:<b>A02007029</b></li><li>Nuestra actividad principal:<b>METAL</b></li><li>Nuestra dirección:<b>Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02008, Albacete (Albacete)</b></li><li>Nuestro teléfono de contacto:<b>967-216212</b></li><li>Nuestra dirección de correo electrónico de contacto:<u><b><a href="mailto:ajusa@ajusa.online">ajusa@ajusa.es</a></b></u></li><li>Nuestra página web: www.ajusa.online</li></ul><p>Para su confianza y seguridad, le informamos que somos una entidad inscrita en el siguiente Registro Mercantil /Registro Público: Registro Mercantil de Albacete.</p><p class="bold">¿Para qué vamos a usar sus datos?</p><p>Con carácter general, sus datos personales serán usados para poder relacionarnos con usted y poder prestarle nuestros servicios.</p><p>Asimismo, también pueden ser usados para otras actividades, como enviarle publicidad o promocionar nuestras actividades.</p><p class="bold">¿Por qué necesitamos usar sus datos?</p><p>Sus datos personales son necesarios para poder relacionarnos con usted y poder prestarle nuestros servicios. En este sentido, pondremos a su disposición una serie de casillas que le permitirán decidir de manera clara y sencilla sobre el uso de su información personal.</p><p class="bold">¿Quién va a conocer la información que le pedimos?</p><p>Con carácter general, sólo el personal de nuestra entidad que esté debidamente autorizado podrá tener conocimiento de la información que le pedimos.</p><p>De igual modo, podrán tener conocimiento de su información personal aquellas entidades que necesiten tener acceso a la misma para que podamos prestarle nuestros servicios. Así, por ejemplo, nuestro banco conocerá sus datos si el pago de nuestros servicios se realiza mediante tarjeta o transferencia bancaria.</p><p>Asimismo, tendrán conocimiento de su información aquellas entidades públicas o privadas a las cuales estemos obligados a facilitar sus datos personales con motivo del cumplimiento de alguna ley. Poniéndole un ejemplo, la Ley Tributaria obliga a facilitar a la Agencia Tributaria determinada información sobre operaciones económicas que superen una determinada cantidad.</p><p>En el caso de que, al margen de los supuestos comentados, necesitemos dar a conocer su información personal a otras entidades, le solicitaremos previamente su permiso a través de opciones claras que le permitirán decidir a este respecto.</p><p class="bold">¿Cómo vamos a proteger sus datos?</p><p>Protegeremos sus datos con medidas de seguridad eficaces en función de los riesgos que conlleve el uso de su información.</p><p>Para ello, nuestra entidad ha aprobado una Política de Protección de Datos y se realizan controles y auditorías anuales para verificar que sus datos personales están seguros en todo momento.</p><p class="bold">¿Enviaremos sus datos a otros países?</p><p>En el mundo hay países que son seguros para sus datos y otros que no lo son tanto. Así, por ejemplo, la Unión Europea es un entorno seguro para sus datos. Nuestra política es no enviar su información personal a ningún país que no sea seguro desde el punto de vista de la protección de sus datos.<p>En el caso de que, con motivo de prestarle el servicio, sea imprescindible enviar sus datos a un país que no sea tan seguro como España, siempre le solicitaremos previamente su permiso y aplicaremos medidas de seguridad eficaces que reduzcan los riesgos del envío de su información personal a otro país.</p><p class="bold">¿Durante cuánto tiempo vamos a conservar sus datos?</p><p>Conservaremos sus datos durante nuestra relación y mientras nos obliguen las leyes. Una vez finalizados los plazos legales aplicables, procederemos a eliminarlos de forma segura y respetuosa con el medio ambiente.</p><p class="bold">¿Cuáles son sus derechos de protección de datos?</p><p>En cualquier momento puede dirigirse a nosotros para saber qué información tenemos sobre usted, rectificarla si fuese incorrecta y eliminarla una vez finalizada nuestra relación, en el caso de que ello sea legalmente posible.</p><p>También tiene derecho a solicitar el traspaso de su información a otra entidad. Este derecho se llama “portabilidad” y puede ser útil en determinadas situaciones.</p><p>Para solicitar alguno de estos derechos, deberá realizar una solicitud escrita a nuestra dirección, junto con una fotocopia de su DNI, para poder identificarle.</p><p>En las oficinas de nuestra entidad disponemos de formularios específicos para solicitar dichos derechos y le ofrecemos nuestra ayuda para su cumplimentación.</p>Para saber más sobre sus derechos de protección de datos, puede consultar la página web de la Agencia Española de Protección de Datos (www.agpd.es).</p><p class="bold">¿Puede retirar su consentimiento si cambia de opinión en un momento posterior?</p><p>Usted puede retirar su consentimiento si cambia de opinión sobre el uso de sus datos en cualquier momento.</p><p>Así, por ejemplo, si usted en su día estuvo interesado/a en recibir publicidad de nuestros productos o servicios, pero ya no desea recibir más publicidad, puede hacérnoslo constar a través del formulario de oposición al tratamiento disponible en las oficinas de nuestra entidad.</p><p class="bold">En caso de que entienda que sus derechos han sido desatendidos, ¿dónde puede formular una reclamación?</p><p>En caso de que entienda que sus derechos han sido desatendidos por nuestra entidad, puede formular una reclamación en la Agencia Española de Protección de Datos, a través de alguno de los medios siguientes:</p><ul><li>Sede electrónica: www.agpd.es</li><li>Dirección postal: Agencia Española de Protección de Datos C/ Jorge Juan, 6 28001-Madrid</li><li>Vía telefónica:<br>Telf. 901 100 099<br>Telf. 91 266 35 17<br></li></ul><p>Formular una reclamación en la Agencia Española de Protección de Datos no conlleva ningún coste y no es necesaria la asistencia de abogado ni procurador.</p><p class="bold">¿Elaboraremos perfiles sobre usted?</p><p>Nuestra política es no elaborar perfiles sobre los usuarios de nuestros servicios. No obstante, pueden existir situaciones en las que, con fines de prestación del servicio, comerciales o de otro tipo, necesitemos elaborar perfiles de información sobre usted. Un ejemplo pudiera ser la utilización de su historial de compras o servicios para poder ofrecerle productos o servicios adaptados a sus gustos o necesidades.</p><p>En tal caso, aplicaremos medidas de seguridad eficaces que protejan su información en todo momento de personas no autorizadas que pretendan utilizarla en su propio beneficio.</p><p class="bold">¿Usaremos sus datos para otros fines?</p><p>Nuestra política es no usar sus datos para otras finalidades distintas a las que le hemos explicado. Sí, no obstante, necesitásemos usar sus datos para actividades distintas, siempre le solicitaremos previamente su permiso a través de opciones claras que le permitirán decidir al respecto.</p></div></div>',
    politica_cookies:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">POLÍTICA DE COOKIES</h1><p class="bold">Información en cumplimiento de la normativa de protección de datos personales</p><p class="bold">¿Qué son las cookies y para qué las usamos?</p><p>Una cookie o galleta informática es un pequeño archivo de información que se guarda en su navegador cada vez que visita nuestra página web.</p><p>La utilidad de las cookies es guardar el historial de su actividad en nuestra página web, de manera que, cuando la visite nuevamente, ésta pueda identificarle y configurar el contenido de la misma en base a sus hábitos de navegación, identidad y preferencias.</p><p>Una cookie es inofensiva, no contiene código malicioso o malintencionado (ej. virus, troyanos, gusanos, etc.) que pueda dañar su terminal (ordenador, smartphone, tableta, etc.), pero sí tiene cierto impacto sobre su derecho a la protección de sus datos, pues recoge determinada información concerniente a su persona (hábitos de navegación, identidad, preferencias, etc.).</p><p class="bold">¿Qué información guarda una cookie?</p><p>Las cookies no suelen recoger categorías especiales de datos personales (datos sensibles). Los datos que guardan son de carácter técnico, preferencias personales, personalización de contenidos, etc.</p><p class="bold">¿Qué tipo de cookies existen?</p><p>Con carácter general, existen cinco tipos de cookies:</p><ul><li><p class="bold">Cookies técnicas:</p><p>Son las cookies más básicas. Permiten al usuario la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan como, por ejemplo, controlar el tráfico y la comunicación de datos, identificar la sesión, acceder a partes de acceso restringido, recordar los elementos que integran un pedido, realizar el proceso de compra de un pedido, realizar la solicitud de inscripción o participación en un evento, utilizar elementos de seguridad durante la navegación, almacenar contenidos para la difusión de videos o sonido o compartir contenidos a través de redes sociales.</p></li><li><p class="bold">Cookies de personalización:</p><p>Son aquéllas que permiten al usuario acceder al servicio con algunas características de carácter general predefinidas en función de una serie de criterios en el terminal del usuario como por ejemplo serian el idioma, el tipo de navegador a través del cual accede al servicio, la configuración regional desde donde accede al servicio, etc.</p></li><li><p class="bold">Cookies de análisis:</p><p>Son aquéllas que permiten al responsable de las mismas, el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma y para la elaboración de perfiles de navegación de los usuarios de dichos sitios, aplicaciones y plataformas, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.</p></li><li><p class="bold">Cookies publicitarias:</p><p>Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el responsable haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado en base a criterios como el contenido editado o la frecuencia en la que se muestran los anuncios.</p></li><li><p class="bold">Cookies de publicidad comportamental:</p><p>Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el responsable haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado. Estas cookies almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.</p></li></ul><p class="bold">¿Qué son las cookies propias y las de terceros?</p><ul><li><p class="bold">Cookies de propias:</p><p>Las cookies propias son aquellas que se generan y gestionan por el propio responsable que presta el servicio solicitado por el usuario.</p></li><li><p class="bold">Cookies de terceros:</p><p>Son aquellas que se generan por otras entidades distintas al propio responsable (servicios o proveedores externos, como por ejemplo Google).</p></li></ul><p class="bold">¿Qué tipo de cookies guarda nuestra página web?</p><p>A continuación, procedemos a relacionar el tipo de cookies que guarda nuestra página web y la finalidad de las mismas:</p><ul><li class="no-disc"><p class="bold">- Tipo de cookie</p><p>Cookies de terceros, de análisis: Google Analytics</p></li><li class="no-disc"><p class="bold">- Finalidad</p><p>Seguimiento y análisis del comportamiento de los usuarios en la página web. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, para la elaboración de perfiles de navegación de los usuarios de dichos sitios, aplicaciones y plataformas, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.</p></li><li class="no-disc"><p class="bold">- Cuándo y cómo se guarda</p><p>La cookie registra la actividad del usuario en el tiempo real de su navegación y los datos se almacenan en la aplicación ‘Google Analytics’.</p></li></ul><p>La página web de AJUSA también trabaja con la aplicación Local Storage.</p><p class="bold">¿Qué puedo hacer con las cookies?</p><p>Las cookies pueden ser borradas, aceptadas o bloqueadas, según desee, para esto sólo debe configurar convenientemente el navegador web.</p><p>En cualquier momento, puede impedir la instalación de cookies (bloqueo) en su equipo mediante la opción correspondiente de su navegador, pero en dicho caso no podremos asegurarle el correcto funcionamiento de las distintas funcionalidades de nuestra página web.</p><p>A continuación, le facilitamos los enlaces para la gestión y bloqueo de cookies dependiendo del navegador que utilice:</p><p>Internet Explorer:<u><a href="http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10">http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10</a></u></p><p>FireFox:<u><a href="http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we">http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we</a></u></p><p>Chrome:<u><a href="https://support.google.com/chrome/answer/95647?hl=es">https://support.google.com/chrome/answer/95647?hl=es</a></u></p><p>Safari:<u><a href="https://www.apple.com/legal/privacy/es/cookies/">https://www.apple.com/legal/privacy/es/cookies/</a></u></p>También puede borrar las cookies que tenga guardadas en su navegador acudiendo a las opciones de configuración del mismo.</div></div>',
    aviso_legal:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">AVISO LEGAL</h1><p class="bold">TÉRMINOS Y CONDICIONES</p><p>I.-<span class="bold">La utilización,</span>consulta y/o contratación de los servicios que se exponen en nuestra página Web www.ajusa.online supone por parte de los usuarios y/o clientes la aceptación plena y sin reservas de las Condiciones Generales de Contratación, que regulan la relación jurídica derivada de los procesos de contratación realizados entre los usuarios y/o clientes de la página Web www.ajusa.online propiedad de Auto Juntas, S.A. (en adelante Ajusa). Los Clientes aceptan las Condiciones Generales desde el instante que utilicen o adquieran cualquier producto. Este documento puede ser impreso para ser leído y almacenado por los Clientes, previamente a su aceptación.</p><p>II.-<span class="bold">Las presentes Condiciones Generales,</span>están sujetas en lo que resulte de aplicación a lo dispuesto a la Ley 7/1998, de 13 de abril, sobre Condiciones Generales de Contratación, al Real Decreto Legislativo 1/2007, de 16 de noviembre, por el que se aprueba el Texto Refundido de la Ley General para la Defensa de Consumidores y Usuarios y otras leyes complementarias, al Real Decreto 1906/1999, de 17 de diciembre de 1999, por el que se regula la Contratación Telefónica o Electrónica con condiciones generales, la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal, y su Reglamento de desarrollo, la Ley 7/1996, de 15 de enero de Ordenación del Comercio Minorista, y a la Ley 34/2002 de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico.</p><p>III.-<span class="bold">Modificación de las Condiciones Generales.</span>Ajusa podrá modificar las Condiciones Generales notificándolo a los Clientes con antelación suficiente, con el fin de mejorar los servicios y productos ofrecidos a través de Ajusa. Mediante la modificación de las Condiciones Generales expuestas en la página Web de Ajusa se entenderá por cumplido dicho deber de notificación. En todo caso, antes de utilizar los servicios o contratar productos, se pondrán consultar las Condiciones Generales.</p><p>IV.-<span class="bold">Propiedad intelectual</span>. Todos los contenidos de esta página Web (incluyendo el código fuente, imágenes, textos, gráficos, etc.) están protegidos por la normativa nacional e internacional vigente sobre propiedad intelectual, encontrándose todos los derechos reservados. Queda terminantemente prohibida la reproducción de cualquier contenido de la Web sin el consentimiento expreso de Ajusa y de los poseedores de los derechos.</p><p>Mediante la adquisición de un producto, Ajusa no confiere al adquirente ningún derecho de alteración, explotación, reproducción, distribución o comunicación pública sobre el mismo, reservándose Ajusa todos estos derechos. La cesión de los citados derechos precisará el previo consentimiento por escrito por parte de Ajusa. La utilización no autorizada de la información contenida en esta Web, su reventa, así como la lesión de los derechos de propiedad intelectual o industrial dará lugar a las responsabilidades legalmente establecidas.</p><p>V.-<span class="bold">Uso del servicio y responsabilidades.</span>Ajusa no garantiza la disponibilidad permanente de los servicios, quedando exonerado por cualquier tipo de responsabilidad por posibles daños y perjuicios causados debido a la indisponibilidad del servicio por causas de fuerza mayor o errores en las redes telemáticas de transferencia de datos, ajenos a su voluntad. Ajusa no se hace responsable del contenido de los enlaces a otras páginas Web que no sean titularidad suya y que, por tanto, no pueden ser controladas por ésta.</p><p>VI.-<span class="bold">Protección de datos.</span>En cumplimiento de lo dispuesto en el artículo 5 de la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal, y en la Ley 34/2002, de 11 de Julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, Auto Juntas, S.A. (en adelante Ajusa) le informa de que los datos de carácter personal proporcionados en los formularios de registro electrónico contenidos en este sitio, así como aquellos datos a los que Ajusa acceda como consecuencia de su navegación; consulta, solicitud o contratación, o de cualquier transacción u operación realizada desde este sitio Web, serán recogidos en un fichero que cumple con las exigencias de la legislación vigente aplicable y cuyo responsable es: Auto Juntas, S.A., Parque Empresarial Ajusa. Ctra. De Ayora Km 2.2. 02008. Albacete. España.<u><a href="mailto:social@ajusa.es.">social@ajusa.es.</a></u></p><p>La finalidad de la recogida y tratamiento automatizado de los Datos Personales realizados a través de los formularios y contactos vía correo electrónico habilitados en este sitio Web, es para facilitar la prestación de servicios que Ajusa proporciona a través de estas páginas, así como para facilitarle información sobre las actividades y noticias que pudieran resultar de su interés.</p><p>El envío de datos personales, mediante el uso de los formularios electrónicos de esta Web o, en su caso, el envío de mensajes de correo electrónico solicitando información o servicios, supone el consentimiento expreso del Usuario al tratamiento automatizado de los datos incluidos, así como al envío de comunicaciones vía electrónica con información acerca de nuestras actividades.</p><p>Por lo tanto el Usuario expresa su consentimiento expreso para que los Datos Personales sean incorporados al Fichero de Datos Personales y sean objeto de tratamiento automatizado por parte de Ajusa con las finalidades antes indicadas. Asimismo, expresa la aceptación y autorización para que Ajusa pueda ceder los Datos Personales, a las empresas que prestan servicios a Ajusa, tales como bancos y aseguradoras.</p><p>El Usuario garantiza que los datos personales facilitados a Ajusa son veraces y se hace responsable de comunicar al mismo cualquier modificación de los mismos.</p><p>Ajusa pone a disposición de los usuarios la dirección de correo electrónico social@ajusa.es y el teléfono 967 216 212, para que éstos revoquen el consentimiento prestado. Ajusa declara que cumple la normativa vigente respecto a la protección de datos, en particular la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal y el Real Decreto 1720/2007, de 21 de diciembre, que desarrolla la citada ley orgánica, y pone a disposición de los Clientes los medios de contacto referidos en el párrafo anterior para que estos ejerzan los derechos de acceso, rectificación, cancelación y oposición garantizados por la legislación vigente.</p><p>VII.-<span class="bold">Seguridad.</span>Ajusa garantiza que ha adoptado las medidas oportunas de seguridad en sus instalaciones, sistemas y ficheros, así como el tratamiento confidencial de los Datos Personales de conformidad con la legislación vigente aplicable y le informa de que tiene implantadas las medidas de seguridad de índole técnica y organizativas necesarias para garantizar la seguridad de sus datos de carácter personal y evitar su alteración, pérdida y tratamiento y/o acceso no autorizado, habida cuenta del estado de la tecnología, la naturaleza de los datos almacenados y los riesgos a que están expuestos, ya provengan de la acción humana o del medio físico o natural. Todo ello, de conformidad con lo previsto en el artículo 9 de la LOPD y en el Real Decreto 1720/2007, de 21 de diciembre, por el que se aprueba el Reglamento de desarrollo de la Ley Orgánica y la ley 34/2002, de 11 de Julio, Ley de Servicios de la Sociedad de Información y comercio electrónico.</p><p>Ajusa se compromete a tratar de forma absolutamente confidencial los datos de carácter personal y hacer uso de los mismos exclusivamente para las finalidades indicadas.</p><p>VIII.-<span class="bold">Comunicaciones electrónicas comerciales.</span>Ajusa pone a disposición de los usuarios, que previamente lo hayan solicitado, a través de formularios de suscripción habilitados al efecto, el servicio de envío de noticias, actividades e informaciones. El Usuario podrá darse de baja de este servicio en cualquier momento que lo considere oportuno mediante el envío de un correo electrónico a:<u><a href="mailto:social@ajusa.es.">social@ajusa.es.</a></u></p><p>IX.<span class="bold">Información General.</span>De conformidad con la ley 34/2.002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, Ajusa, manifiesta que ha procedido a cumplir con el deber de información en los términos que establece esta normativa, al efecto de permitir, tanto a los destinatarios del servicio como a los órganos competentes, el acceso de forma permanente, fácil, directa y gratuita a la siguiente información: Auto Juntas, S.A., Parque Empresarial Ajusa. Ctra. De Ayora Km 2.2. 02008. Albacete. España. www.ajusa.online. Teléfono: 967 216 212 Fax: 967 216 214. Datos de inscripción en el Registro Mercantil de Albacete: Tomo: 311, FOLIO: 186 HOJA: AB-1504, Número de Identificación Fiscal: A-02007029</p><p>X.<span class="bold">Información sobre el uso de cookies.</span>Este sitio Web utiliza cookies, pequeños ficheros de datos que se generan en el ordenador del Usuario y que nos permiten obtener la siguiente información: La fecha y hora de la última vez que el Usuario visitó nuestro Web, los contenidos que el Usuario escogió en su primera visita a nuestro Web, etc. Con la finalidad de realizar estadísticas globales de acceso. El Usuario consiente el uso de estas cookies, que en ningún caso permitirán su identificación, con la exclusiva finalidad de facilitar su navegación por las diferentes páginas del presente sitio Web. En cualquier caso, el Usuario podrá denegar o impedir la instalación de estas cookies modificando la configuración de su navegador.</p><p>XI.<span class="bold">Responsabilidad.</span>El uso del Web se realizará bajo la única y exclusiva responsabilidad del Usuario. Dicha responsabilidad se extenderá al uso, por parte del usuario o de cualquier tercero, de cualesquiera contraseña o similares asignadas para el acceso al Web o a cualesquiera de sus servicios.</p><p>Ajusa no asume responsabilidad alguna derivada de los contenidos enlazados desde la Web, siempre que sean ajenos a la misma, ni garantiza la ausencia de virus u otros elementos en los mismos que puedan producir alteraciones en el sistema informático (hardware y software), en los documentos o los ficheros del usuario, excluyendo cualquier responsabilidad por los daños de cualquier clase causados al usuario por este motivo. Ajusa rechaza toda responsabilidad que se derive de la mala utilización de los contenidos expuestos en estas páginas y se reserva el derecho a actualizarlos, eliminarlos, establecer limitaciones o restringir su acceso en cualquier momento, de manera temporal o permanente.</p><p>XII.-<span class="bold">Nulidad e ineficacia de las Cláusulas.</span>Si cualquier cláusula incluida en estas Condiciones Generales fuese declarada nula o ineficaz total o parcialmente, tal nulidad o ineficacia afectará tan sólo a dicha disposición o a la parte de la misma que resulte nula o ineficaz, subsistiendo las Condiciones Generales en todo lo demás, teniéndose tal disposición, o la parte de la misma que resultase afectada, por no puesta.</p><p>XIII.-<span class="bold">Conflictos.</span>Para cualquier controversia o conflicto suscitado, será de aplicación la legislación española, siendo competentes para la resolución de todos los conflictos derivados o relacionados con ella, los Juzgados y Tribunales de Albacete.</p><p>El acceso a las páginas Web de este sitio, implica la aceptación de todas las condiciones expresadas en esta información legal. Ajusa, podrá modificar sin previo aviso, la estructura y diseño del Web, así como cambiar o eliminar, los servicios, los contenidos y las condiciones de acceso de uso del Web y adaptarla a los cambios legislativos que se produzcan.</p></div></div>',
    popupCocheElectrico: {
      title: "Y AHORA...<strong>¡COMPONENTES PARA VEHÍCULO ELÉCTRICO!</strong>",
      btnText: "VISITAR"
    }
  },
  en: {
    alt_images: {
      logo_ajusa: "Ajusa",
      app_movil: "Ajusa mobile app",
      google_play: "Download the app on Google Play",
      app_store: "Download the app on the App Store",
      telefono: "Call Ajusa by phone",
      email: "Send an email to Ajusa",
      vehiculo_electrico: "Ajusa Electric Vehicle Line",
      cerrar: "Close",
      retenes: "Ajusa oil seals",
      ver_video: "Watch the video",
      ajustick: "Ajustick, Ajusa anaerobic sealant",
    },
    cookieEyes: "045d3ec4b8d29118370163bd",
    recaptchaId: "6Lee-m8fAAAAABTeuBvigSTzmj9MGBqTtnldUAo8",
    isotag: "en-GB",
    enlaces: {
      home: "/",
      productos: "products",
      product: "product",
      productos_quimicos: "chemical-products",
      catalogo: "catalogue",
      area_tecnica: "technical-area",
      asesoramiento: "consultancy",
      ajusa: "ajusa",
      actualidad: "breaking-news",
      contacto: "contact",
      trabaja_con_nosotros: "work-with-us",
      donde_estamos: "contact",
      solicite_catalogo: "contact#catalogo",
      blog: "blog",
      blog_noticia: "blog/news",
      blog_categoria: "blog/category",
      categoria: "category",
      ferias: "trade-fairs",
      historia: "history",
      nuestro_sector: "our-sector",
      compromiso_social: "social-commitment",
      sala_prensa: "press-room",
      mapa_web: "web-map",
      politica: "privacy-policy",
      politica_cookies: "cookies-policy",
      datos_seguros: "your-data-secure",
      aviso_legal: "legal-notice",
      aniversario50: "50-anniversary",
      productos_certificados: "/static/pdf/environment-certificate.pdf",
      productos_certificados_calidad: "/static/pdf/quality-certifications.pdf",
      condiciones_venta: "/static/pdf/condiciones-de-venta-en.pdf",
      catalogo_online: "https://web.tecalliance.net/ajusa/en/",
      vehiculo_electrico: "electric-vehicle",
      sobre_nosotros: "ajusa",
      bonos_ajusa: "ajusa-bounds",
      thank_you_page: "thank-you",
      newsletter_thank: "newsletter/thank-you",
      online_store: "https://ev-customers.uk.ajusa.online/",
      certificado_IATF_16949: "/static/pdf/IATF-16949-en.pdf",
      certificado_ISO_9001: "/static/pdf/ISO-9001-en.pdf",
      certificado_ISO_14001: "/static/pdf/ISO-14001-en.pdf",
      textos: {
        inicio: "Home",
        productos: "Products",
        catalogo: "Catalogue",
        otrosCatalogos: "Other Catalogues",
        area_tecnica: "Technical Area",
        ajusa: "Ajusa",
        actualidad: "Breaking news",
        contacto: "Contact",
        sala_prensa: "Press room",
        blog: "Blog",
        historia: "History",
        tecnologias_hidrogeno: "Hydrogen Technologies ",
        contacto: "Contact",
        trabaja_con_nosotros: "Work with us",
        mapa_web: "Web Map",
        condiciones_venta: "Terms and conditions of sales",
        politica_privacidad: "Privacy policy",
        datos_seguros: "Your data secure",
        politica_cookies: "Cookies policy",
        aviso_legal: "Legal notice",
        catalogo_general: "General catalogue",
        catalogo_turbos: "Turbo components catalogue",
        catalogo_juntas_compresor: "Brake compressor gasket catalogue",
        catalogo_retenes: "Shaft Seal kits catalogue",
        catalogo_juegosJuntas: "SPECIAL GASKET SET CATALOGUE",
        tec_alliance: "online catalogue",
        catalogo_impreso: "Request a printed catalogue",
        newsletter: "Home",
        catalogo_arandelas: "COPPER WASHER CATALOGUE",
        catalogo_motor_electrico: "EV Catalogue",
        catalogo_comprensorAC: "EV A/C compressor catalog gasket set",
        catalogo_toricas: "O-RINGS CATALOGUE",
        catalogo_retenes: "OIL SEALS CATALOGUE",
        aniversario50: "50th anniversary",
        vehiculo_electrico: "Electric vehicle",
        sobre_nosotros: "About us",
        online_store: "EV CUSTOMER AREA",
        certificado_IATF_16949: "IATF 16949",
        certificado_ISO_9001: "ISO 9001",
        certificado_ISO_14001: "ISO 14001"
      },
      seo: {
        home: {
          title: "Ajusa Gaskets | Auto parts maker",
          description:
            "Ajusa is leaders in the manufacture and worldwide distribution of spare parts for passangers cars, industrial and agricultural applications."
        },
        productos: {
          title: "Products | Ajusa auto parts",
          description:
            "Ajusa auto parts is specialist in the manufacture of components for internal combustion engines for both cars and industrial vehicles. We are also leaders in the development of spare parts for turbo engines."
        },
        catalogo: {
          title: "Catalog | Ajusa auto parts",
          description:
            "You will find the spare part you need for your vehicle in the Ajusa catalogue. The widest selection in the automobile sector with over 200,000 references at your disposal."
        },
        area_tecnica: {
          title: "Technical Area | Ajusa auto parts",
          description:
            "Welcome to the Ajusa technical assistance department! We solve your problems and provide you with an extensive range of educational material with technical reports, videos and webinars. We are committed to you and to repairing your vehicle."
        },
        sobre_nosotros: {
          title: "About us | Quality, service and people behind Ajusa",
          description:
            "Ajusa auto parts are the benchmark in the automotive sector because we believe in what we do. Since 1972, we have been taking care of your vehicles thanks to our dedication and the technology we have applied to developing engine components."
        },
        aniversario50: {
          title: "Our History | Ajusa auto parts",
          description:
            "Ajusa auto parts has a story to tell. Effort and constant improvement have marked the steps of this familiy-owned business that started manufacturing cylinder head gaskets in 1972. Learn about our history!"
        },
        ajusa: {
          title: "About us | Ajusa auto parts",
          description:
            "Ajusa auto parts are the benchmark in the automotive sector because we believe in what we do. Since 1972, we have been taking care of your vehicles thanks to our dedication and the technology we have applied to developing engine components."
        },
        actualidad: {
          title: "Novelties | Ajusa auto parts",
          description:
            "Get the latest news on gaskets from Ajusa. We cover all the latest developments in our industry, from product launches to technology advancements."
        },
        contacto: {
          title: "Contact | Ajusa auto parts",
          description:
            "Need help with gaskets or seals? Reach out to Ajusa Gaskets for the best service and support. Our experienced team is ready to answer any questions you have."
        },
        blog: {
          title: "Blog | Ajusa auto parts",
          description:
            "AJUSA’s blog is a space for professionals and experts of the automotive industry, and for mechanics and workshops. Here we tell you the latest news about AJUSA and everything that is happening in the spare parts industry.",
          toblog: true
        },
        sala_prensa: {
          title: "Press Room | Ajusa auto parts",
          description:
            "Stay up-to-date on all the latest news and product launches from Ajusa. Explore our press room to read our press releases, product descriptions and more."
        },
        trabaja_con_nosotros: {
          title: "Work with us | Ajusa auto parts",
          description:
            "Work with us. Ajusa works to grow every day. If you want to form part of our ever larger family, fill in this form and attach your curriculum."
        },
        historia: {
          title: "Our history | Over 50 years in the automotive industry",
          description:
            "AJUSA was founded in 1972 in Albacete (Spain). It originally started manufacturing head gaskets and now it develops a complete range of engine components and spare parts."
        },
        bonos_ajusa: {
          title: "Ajusa vouchers | Get 20% off for your repair workshop",
          description:
            "Ajusa vouchers give your repair workshop a 20% discount on our engine components. Call us or fill in the form and we will explain how to redeem them today."
        },
        mapa_web: {
          title: "web map | Ajusa auto parts",
          description: "Ajusa web map: reach every section of our site from a single index, including all products, catalogues, technical area, press room and legal information."
        },
        politica: {
          title: "Privacy Policy | Ajusa auto parts",
          description:
            "AUTO JUNTAS SAU’s Data Protection Policy is based on the principle of proactive responsibility, according to which the controller is responsible for compliance with the regulatory and jurisprudential framework that governs said policy."
        },
        politica_cookies: {
          title: "Cookies Policy | Ajusa auto parts",
          description: "Find out which cookies the Ajusa website uses, what each of them is for and how you can configure, accept or reject them from your own browser at any time."
        },
        aviso_legal: {
          title: "Legal Notice | Ajusa auto parts",
          description:
            "Access to the web pages of this site implies acceptance of all conditions expressed in this legal information. AJUSA may modify the structure and design of the website, as well as change or remove contents and conditions for access."
        },
        datos_seguros: {
          title: "Your Data Secure | Ajusa auto parts",
          description:
            "In general, your personal data that is provided through the AJUSA website will be used to relate to that person and be able to provide a better service. It may also be used to send adverts or promote our activities."
        },
        vehiculo_electrico: {
          title: "Electric Vehicle",
          description:
            "Ajusa boasts an extensive catalogue of spare parts for hybrid and electric vehicles. Furthermore, Ajusa also helps you to carry out repairs by providing explanations of each failure that you can download here and video tutorials recorded by a vehicle repair specialist."
        },
        blog_categoria: {
          fairs: {
            title: "Automotive trade shows| Ajusa auto parts",
            description:
              "Ajusa Gaskets offers a wide range of gaskets solutions for trade fairs and other events. Our expert team provides quality products and excellent customer service."
          },
          products: {
            title: "Blog Products | Ajusa auto parts",
            descripcion: ""
          },
          "our-sector": {
            title: "Automotive Sector | Ajusa auto parts",
            description: ""
          },
          "social-commitment": {
            title: "Social Commitment | Ajusa auto parts",
            description:
              "Ajusa contributes to an improvement in our environment by collaborating with a variety of social and charitable causes. Our responsibility towards the environment is also part of AJUSA's social commitment."
          }
        },
        junta_culata: {
          title: "Cylinder head gaskets: MLS, FiberMax and rubber-metal",
          description:
            "Cylinder head gaskets are our traditional product line. Ajusa provides total coverage for cars and industrial vehicles. Gaskets in MLS, FiberMax and Metal-Rubber.",
          keyword: "cylinder head gasket"
        },
        junta_motor: {
          title: "Full gasket sets for every engine type | Ajusa parts",
          description:
            "Reliability when it comes to sealilng vehicles. We develop complete sets of engine seals with over 200,000 references for gakets in fibre, rubber and rubber-metal.",
          keyword: "gasket sets"
        },
        tornillos: {
          title: "Cylinder head bolts | Complete sets | Ajusa auto parts",
          description:
            "Discover and order online our Cylinder Head Bolts for vehicle engines of premium craftsmanship.Boost your engine's performance today with our products.",
          keyword: "cylinder head bolts"
        },
        retenes: {
          title: "Oil seals and valve stem seals for engines | Ajusa parts",
          description:
            "Boost engine longevity with our premium Oil Seals. Explore now for leak-proof performance and secure your vehicle's efficiency with this piece.",
          keyword: "oil seals"
        },
        tubos_engrase: {
          title: "Oil feed pipes for turbochargers | Ajusa auto parts",
          description:
            "Upgrade your vehicle’s machinery with high-quality Oil Feed Pipes. Maximize its performance and durability.",
          keyword: "oil feed pipes"
        },
        tubos_egr: {
          title: "EGR valve pipes for exhaust gas recirculation | Ajusa",
          description:
            "Reduce nitrogen oxide (NOx) emissions from internal combustion of your vehicle with Ajusa EGR valve pipes.",
          keyword: "EGR valve pipes, obstruction"
        },
        tubos_refrigeracion: {
          title: "Coolant pipes for engine cooling | Ajusa auto parts",
          description:
            "Enhance turbo performance and reliability with Ajusa turbo cooling pipes, designed to carry coolant between the engine and the turbocharger in both supply and return circuits.",
          keyword: "COOLANT PIPES, cooling system"
        },
        junta_turbo: {
          title: "Turbo fitting kits and gasket sets | Ajusa auto parts",
          description:
            "Unlock your vehicle's true potential with our Turbo Fitting Kit! Boost performance and unleash the speed. Shop now and experience unmatched power.",
          keyword: "turbo fitting kit"
        },
        productos_quimicos: {
          title: "Chemical products | Sealants and lubricants | Ajusa",
          description:
            "Explore our wide range of chemical products for vehicles. Sealants, engine lubricants, and powerful threadlockers to keep your engine in optimal condition.",
          keyword:
            "chemical products, sealants, engine lubricants, threadlockers"
        },
        taques: {
          title: "Hydraulic lifters and tappets for all engines | Ajusa",
          description:
            "At Ajusa we offer you a wide variety of hydraulic lifters. Accuracy and quality on our hydraulic lifters line. We verify 100% of the entire production process with micron-level tolerance.",
          keyword: "hydraulic tappets, hydraulic lifters"
        },
        arbol_levas: {
          title: "Camshafts for passenger and industrial vehicles | Ajusa",
          description:
            "Discover the full range of camshafts available at Ajusa! Increase the performance of your engine with our high quality components, we are your best choice to optimize your vehicle.",
          keyword: "camshafts"
        },
        otros: {
          title: "Other engine components and parts | Ajusa auto parts",
          description:
            "Ajusa products and sealing solutions ensure a complete repair of your engine. For this, Ajusa also include in its catalog other engine parts such as the water pump, the EGR valve, the brake compressor, the thermostat, etc.",
          keyword: "other components ajusa, gaskets"
        },
        vehiculo_electrico: {
          title: "Electric vehicle | EV components by Ajusa auto parts",
          description:
            "Ajusa has a wide range of components for hybrid and electric cars. In addition, Ajusa also helps you to carry out repairs by providing explanations of each breakdown!",
          keyword: "components for hybrid cars, components for electric cars"
        }
      }
    },
    genericos: {
      no_resultados: "No results found",
      leer_mas: "READ MORE",
      paginador: {
        siguiente: "Next",
        anterior: "Back"
      }
    },
    home: {
      intro: {
        titulo: "GROWING <span class='bold'>TOGETHER",
        texto:
          "AJUSA manufactured its first cylinder head gasket in 1972. It currently has the most extensive <a class='bold' style='text-decoration: underline !important; cursor: pointer !important;' href='{link}' target='_blank'>catalogue of engine gaskets</a> in the sector and the most complete range of oil feed pipes and turbo fitting kits.",
        boton: "Corporate video",
        video: "vjFYe_seVTk"
      },
      excelencia: {
        intro:
          "<h1 class='title title-52'>Ajusa</h1><h2 class='title title-52'>The Automotive<br><span class='bold'> Excellence</span></h2>",
        texto:
          "A lifetime looking after your vehicle. Leaders in the manufacture and worldwide distribution of spare parts for <span class='bold'>passangers cars, industrial applications and electric vehicle.</span>"
      },
      calidad: {
        titulo: {
          first: "original quality",
          second: "ENHANCED",
          third: "in all",
          fourth: "our <strong>products</strong>"
        },
        texto:
          "The AJUSA catalogue has over 200,000 references and is permanently updated in its digital version, and every two years in paper format."
      },
      calidad_2: {
        texto_1:
          "Constant innovation. We have a <strong class='bold'>team of qualified professionals</strong> working with the latest technology at facilities equipped with the most sophisticated machinery.",
        texto_2:
          "<strong class='bold'>Leading-edge products for demanding clients.</strong> We comply with the highest quality standards for all our product lines: cylinder head gaskets, gaskets sets, cylinder head bolts, oil feed pipes, hydraulic lifters, camshafts, sealants, engine assembly lube and repair kits for electric vehicles."
      },
      calidad_3: {
        titulo: "<h2 class='title title-36'>We make a<br>difference</h2>",
        texto:
          "We provide a <strong class='bold'>comprehensive service</strong> to our clients, offering consultancy services and personalized technical assistance. Branches in Mexico, Brazil, United Kingdom, USA, France and authorized distributors around the world. <a class='link' href='{link}' target='_blank'>Request Webinar</a>"
      },
      productos: {
        titulo:
          "<h2 class='title title-26'>OUR <span class='bold'>PRODUCTS</span></h2>"
      },
      destacados: {
        titulo: "HIGHLIGHTS"
      },
      ajusa_app: {
        title: "AJUSA MOBILE"
      },
      alt_images: {
        fabricante: "manufacturer spare parts",
        junta_culata: "cylinder head gasket",
        mobile_app: "ajusa mobile APP",
        tubos_engrase: "oil feed pipes",
        junta_motor: "ajusa spare parts"
      }
    },
    productos: {
      keys: {
        "cylinder-head-gaskets": "junta_culata",
        "full-gasket-sets": "junta_motor",
        "cylinder-head-bolts": "tornillos",
        "oil-seals": "retenes",
        "oil-feed-pipes": "tubos_engrase",
        "egr-pipes": "tubos_egr",
        "coolant-pipes": "tubos_refrigeracion",
        "turbo-fitting-kits": "junta_turbo",
        "chemical-products-line": "productos_quimicos",
        "hidraulic-lifters": "taques",
        camshafts: "arbol_levas",
        "other-components": "otros"
      },
      intro: {
        titulo: "<h1 class='title title-52'>AJUSA products</h1>",
        texto:
          "Specialists in the manufacture of components for internal combustion engines for both cars and industrial vehicles. We are also leaders in the development of spare parts for turbo engines."
      },
      btn_ficha_tecnica: "TECHNICAL INFORMATION",
      btn_ficha_seguridad: "SAFETY INFORMATION",
      junta_culata: {
        titulo: "cylinder head gaskets",
        texto:
          "Cylinder head gaskets are our traditional product line. We provide total coverage for cars and industrial vehicles. Gaskets in MLS, FiberMax and Metal-Rubber.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil.pdf",
        details: {
          intro: {
            alt: "junta culata",
            title: '<h1 class="title title-36">Cylinder head gaskets</h1>',
            text:
              "<p>A cylinder head gasket is a critical component of an internal combustion engine. It sits between the engine block and the cylinder head, sealing the combustion chambers and other passages to prevent leakage of gases or fluids. </p><p>The cylinder head gasket has several important functions. Sealing (its primary function is to create a reliable seal between the engine block and the cylinder head), compression (the gasket helps maintain the required compression within the cylinders by sealing off the combustion chambers) and oil passages (the gasket also seals the oil and coolant passages between the engine block and cylinder head).</p><p>Ajusa cylinder head gaskets are prepared to subject to extreme temperatures, pressure and mechanical stresses. If a cylinder head gasket fails, it is important to replace it promptly to avoid further damage to the engine.</p>",
            btn_text: "ONLINE CATALOGUE ",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/junta-culata-1.webp",
                alt: "ajusa cylinder head gasket"
              },
              {
                img: "/static/img/products/junta-culata-2.webp",
                alt: "head gaskets catalog"
              },
              {
                img: "/static/img/products/junta-culata-3.webp",
                alt: "mls cylinder head gaskets"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "The manufacturing materials of a cylinder head gasket",
              content:
                "<p>Cylinder head gaskets are manufactured using a variety of materials. The choice of materials depends on factors such as the engine design, operating conditions, and the desired performance characteristics. The high-quality materials used in Ajusa manufacturing cylinders head gaskets are multi-layer steel (MLS), graphite or elastomer.</p><p>It´s important to note that gasket materials are continously evolving, and new materials are being developed to meet the demands of modern engines. The choice of gasket material depends of modern engines.</p>"
            },
            "tip-2": {
              title: "Long-lasting cylinder head gasket",
              content:
                "<p>Ajusa manufactures cylinder head gaskets since 1972. The durability of a gasket depends on various factors, including engine design and operating conditions, choosing high-quality materials and a proper installation.</p><p>Original Equipment Manufacture (OEM) Ajusa gaskets are designed specifically for each engine. Ajusa premium aftermarket gaskets can also provide excellent durability, as they are engineered to meet or exceed OEM specifications.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "What are the symptoms of damaged cylinder gasket?",
              content:
                "<p>A damaged cylinder head gasket can lead to various symptoms and issues in an engine. Here are some common signs that may indicate a faulty or damaged cylinder head gasket:</p><ol><li>Overheating: One of the primary symptoms of a blown or damaged head gasket is engine overheating. The gasket may develop leaks between the coolant passages and the combustion chamber, allowing coolant to enter the cylinders and be burned off as exhaust. This can result in an overheating engine and potentially cause damage if not addressed promptly.</li><li>Loss of Coolant: If the cylinder head gasket has failed, it can cause coolant to leak externally or internally. You may notice a loss of coolant without any visible leaks. Keep an eye on the coolant level and check for any signs of coolant leakage, such as puddles under the vehicle or white smoke coming from the exhaust pipe.</li><li> White Smoke from Exhaust: A damaged head gasket can allow coolant to enter the combustion chamber, where it gets burned along with the fuel. This can result in white smoke coming out of the exhaust pipe, particularly at startup or during acceleration. The smoke may have a sweet smell due to the presence of coolant.</li><li>Engine Misfires: A compromised head gasket can lead to uneven compression in the cylinders, causing engine misfires. You may experience rough idling, a loss of power, or hesitation during acceleration. The misfires can also trigger the check engine light and result in diagnostic trouble codes related to misfire detection.</li><li>Oil Contamination: In some cases, a damaged head gasket can allow engine oil to mix with the coolant or leak externally. This can lead to oil contamination, causing a milky appearance in the engine oil or coolant. Check the oil dipstick and the coolant reservoir for signs of oil or coolant mixing.</li><li>Loss of Compression: A failing head gasket can cause a loss of compression between cylinders, resulting in reduced engine performance. You may notice a decrease in power, rough running, or difficulty starting the engine.</li></ol><p>It's important to note that these symptoms can also be caused by other engine issues, so a proper diagnosis by a qualified mechanic is recommended to determine the exact cause of the problem. Ignoring a damaged head gasket can lead to severe engine damage, so it's crucial to address any signs of gasket failure promptly.</p>"
            },
            "dropdown-2": {
              title: "Is it worth replacing a cylinder head gasket?",
              content:
                "<p>The decision to replace a cylinder head gasket depends on several factors, including the overall condition of the engine, the cost of repairs, and the value of the vehicle. Here are some points to consider when deciding whether it's worth replacing a cylinder head gasket:</p><ol><li>Overall Condition of the Engine: If the rest of the engine is in good condition and has been properly maintained, replacing the cylinder head gasket can be a viable option. However, if the engine has other significant issues or is showing signs of extensive wear and damage, it may not be cost-effective to replace just the gasket.</li><li>Cost of Repairs: The cost of replacing a cylinder head gasket can vary depending on the make and model of the vehicle, as well as the labor rates in your area. It's essential to obtain an accurate estimate from a qualified mechanic to determine if the cost of the repair is within your budget.</li><li>Value of the Vehicle: Consider the value of the vehicle and its overall condition. If the vehicle has significant mileage, is old, or has other mechanical issues, it may not be financially practical to invest in a costly repair like replacing the cylinder head gasket. However, if the vehicle is in good condition and has a higher value, repairing the gasket can be a reasonable investment to keep the vehicle running.</li><li>Future Plans: Think about your future plans for the vehicle. If you plan to keep the vehicle for an extended period and it meets your needs, investing in a cylinder head gasket replacement can be worthwhile. On the other hand, if you were already considering selling or upgrading the vehicle, it may not be worth the expense.</li><li>Professional Advice: Consult with a trusted mechanic or automotive professional who can assess the overall condition of the engine and provide guidance on whether replacing the cylinder head gasket is a viable option. They can offer insights based on their experience and expertise.</li></ol><p>Ultimately, the decision to replace a cylinder head gasket depends on a combination of factors, including the specific circumstances of your vehicle and your budget. Assess the overall condition of the engine, consider the cost of repairs, and weigh it against the value and future plans for the vehicle. It's always beneficial to seek professional advice to make an informed decision.</p>"
            },
            "dropdown-3": {
              title:
                "How long will a car last after replacing the head gasket?",
              content:
                "<p>The lifespan of a car after replacing the head gasket can vary significantly depending on various factors, including the overall condition of the vehicle, maintenance practices, driving habits, and the quality of the repair work. Here are some key considerations:</p><ol><li> Overall Vehicle Condition: The condition of the rest of the car, including the engine, transmission, suspension, and other components, plays a significant role in determining the overall lifespan of the vehicle. If the car is well-maintained and free from other major issues, it is more likely to have an extended lifespan after a head gasket replacement.</li><li>Maintenance and Care: Proper maintenance and regular servicing are essential for the longevity of any vehicle. Following the manufacturer's recommended maintenance schedule, including oil changes, coolant flushes, and other routine maintenance tasks, can help prolong the life of the engine and other components.</li><li>Driving Habits: Driving habits and conditions can impact the lifespan of a vehicle. Aggressive driving, frequent towing or heavy loads, and driving in extreme temperatures can put additional stress on the engine and other components, potentially reducing their lifespan. Gentle driving and responsible vehicle use can help maximize the life of the car.</li><li>Quality of Repair: The quality of the head gasket replacement and the expertise of the mechanic performing the repair can have a significant impact on the longevity of the vehicle. It's crucial to have the repair work done by a qualified and experienced professional to ensure proper installation and avoid potential issues down the line.</li><li>Future Maintenance and Repairs: While replacing the head gasket is a major repair, other components of the vehicle may require attention over time. It's important to continue with regular maintenance and address any emerging issues promptly to maintain the overall health of the vehicle.</li></ol><p>It's challenging to provide an exact lifespan estimate after replacing a head gasket, as it depends on multiple variables. However, with proper care, maintenance, and timely repairs, it is possible for a car to continue running for many more years after a head gasket replacement.</p><p>Remember that each vehicle and situation is unique, and unforeseen circumstances can arise. Regularly monitor the vehicle for any signs of trouble, promptly address any emerging issues, and consult with automotive professionals for personalized advice based on your specific vehicle and circumstances.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      junta_motor: {
        titulo: "FULL GASKET SETS",
        texto:
          "Reliability when it comes to sealing vehicles. We develop complete sets of engine seals with over 200,000 references for gaskets in fibre, rubber and rubber-metal.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil2.pdf",
        details: {
          intro: {
            alt: "junta de motor",
            title: '<h1 class="title title-36">Gasket Sets</h1>',
            text:
              '<p>Get to know the complete catalog of Ajusa gasket sets. Reliability when it comes to sealing vehicles. We develop full gasket sets with over 200,000 references for gaskets in fibre, rubber and rubber-metal.</p><p>Ajusa guarantees OE quality improved for the aftermarket in our line of <span class="bold">engine components for</span> passangers cars and industrial. We work for a constant improvement both in our products and our services guaranteed quality. We have quality certificates from prestigious institutions at our customer’s disposal.</p>',
            btn_text: "ONLINE CATALOGUE ",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/junta-motor-1.webp",
                alt: "ajusa full gasket sets"
              },
              {
                img: "/static/img/products/junta-motor-2.webp",
                alt: "gasket sets ajusa"
              },
              {
                img: "/static/img/products/junta-motor-3.webp",
                alt: "gaskets for cars"
              },
              {
                img: "/static/img/products/junta-motor-4.webp",
                alt: "gaskets for industrial vehicles"
              },
              {
                img: "/static/img/products/junta-motor-5.webp",
                alt: "auto parts for engine car repair"
              }
            ]
          },
          dropdowns: {
            "dropdown-1": {
              title: "A full catalog of gasket sets for your engine",
              content:
                "<p>AJUSA leads the manufacturing gasket sets in the world, as it offers full coverage for cars, commercial and heavy vehicles, both from European and Asian manufacturers. </p><p>Our facilities are provided with state-of-the-art technology and we count on a high trained and qualified human team. In our Research Centre we work to innovate day by day.</p><p>Ajusa helps you to solve any doubt or concern with the support of a qualified engineering team in our Customer Service department.</p>"
            },
            "dropdown-2": {
              title: "Request your full gasket set",
              content:
                "<p>At the service of aftermarket since 1972, Ajusa has been a worldwide reference. Ajusa gasket sets include all the necessary components for each specific engine.</p><p>Various materials can be used in the manufacture of the components: rubber, silicone, metal, cork, fiber or polymers. The guarantee of the sealing depends on the quality of the gasket and if the installation is professional or not. The quality of the Ajusa auto parts is international, both due to the exhaustive quality control of the materials used and their meticulous production process.</p>"
            },
            "dropdown-3": {
              title: "What does a gasket set include?",
              content:
                "<p>A sealing gasket is a piece that is located between two parts of the engine to achieve a good fit and avoid the loss or entry of fluids (oil, water, coolant, fuel, etc.). In the engine, you can find different types of gaskets: cylinder head gasket, valve cover gasket, oil seals, manifolds…</p><p>Since 1973, Ajusa manufactures cylinder head gaskets and full sets, guaranteeing OE quality and complete coverage. At present, AJUSA has the most complete catalog of the aftermarket, exceeding 200,000 references.</p><p>We bet for a constant training of our human team transmitting the acquired knowledge to our customers permanently.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      tornillos: {
        titulo: "CYLINDER HEAD BOLTS",
        texto:
          "We complement our cylinder head gasket service with the most complete line of head bolts sets in the market.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil3.pdf",
        details: {
          intro: {
            alt: "cylinder head bolts",
            title: '<h1 class="title title-36">Cylinder Head Bolts</h1>',
            text:
              '<p>Welcome to our exclusive collection of <span class="bold">Cylinder Head Bolts</span> for vehicle engines.</p><p>Cylinder head bolts are essential fasteners that secure the cylinder head to the engine block in an internal combustion engine. They play a crucial role in maintaining a tight seal between the cylinder head and the engine block, ensuring proper compression and preventing leakage of combustion gases and engine fluids. Ajusa cylinder head bolts are designed to withstand high levels of tension and torque, providing the necessary clamping force to keep the cylinder head firmly in place.</p><p>In AJUSA we count with an extensive selection of meticulously crafted bolts, designed to provide optimal performance and durability. These components play a crucial role in creating a tight seal between the cylinder head and the engine block, <span class="bold">ensuring proper compression and preventing any leaks</span> of combustion gasses or coolant.</p>',
            btn_text: "ONLINE CATALOG",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/tornillos-1.webp",
                alt: "ajusa cylinder head bolts"
              },
              {
                img: "/static/img/products/tornillos-2.webp",
                alt: "ajusa bolts"
              },
              {
                img: "/static/img/products/tornillos-3.webp",
                alt: "angular tightening of screws"
              },
              {
                img: "/static/img/products/tornillos-4.webp",
                alt: "cylinder head bolts catalog"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Premium materials for exceptional durability",
              content:
                "<p>We source our materials from trusted suppliers, selecting alloys and compositions that meet stringent industry standards. Whether it's high-strength steel, forged aluminum, or other advanced materials, our Cylinder Head Bolts are built to withstand the most demanding conditions.</p><p>With these premium materials, you can rest assured that your engine's critical components will remain securely fastened, preventing leaks and optimizing compression.</p>"
            },
            "tip-2": {
              title: "Trusted performance Cylinder Head Bolts",
              content:
                "<p>To manufacture quality cylinder head bolts, strict adherence to precise engineering standards and processes is essential. High-quality materials, such as alloy steel, are chosen for their strength and durability. Precision machining ensures accurate dimensions and threading.</p><p>Heat treatment processes, like quenching and tempering, enhance the bolts' mechanical properties. Stringent quality control throughout production guarantees consistency and adherence to specifications. Thorough testing for tensile strength, hardness, and torque capabilities ensures the bolts meet or exceed required standards.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Why should you replace cylinder head bolts?",
              content:
                "<p><span class='bold'>Cylinder head bolts</span> should be replaced for several important reasons:</p><ol><li><span class='bold'>Elastic Deformation:</span> Cylinder head bolts are designed to stretch slightly during installation, providing the necessary clamping force. However, this elastic deformation can cause the bolts to lose their elasticity over time, reducing their ability to maintain the required tension.</li><li><span class='bold'>Preventing Head Gasket Failure:</span> Properly torqued and tensioned cylinder head bolts are essential to prevent head gasket failure. A failed head gasket can result in coolant leakage, oil contamination, and potential damage to the engine.</li><li><span class='bold'>Engine Safety:</span> Replacing the cylinder head bolts during major engine overhauls or repairs ensures the engine's safety and reliability. Well-maintained bolts help maintain the structural integrity of the engine and prevent potential catastrophic failures.</li><li><span class='bold'>Manufacturer's Recommendation:</span> Some vehicle manufacturers recommend replacing cylinder head bolts whenever the cylinder head is removed, especially for modern engines that use torque-to-yield bolts, which are designed for single-use only.</li></ol></br><p>In summary, replacing cylinder head bolts is a critical maintenance practice that ensures proper clamping force, head gasket integrity, and overall engine safety and performance. It is essential to follow the manufacturer's guidelines and use high-quality bolts for optimal results. <span class='bold'></span>All cylinder head gaskets include the cylinder head bolt tightening manual.</span></p>"
            },
            "dropdown-2": {
              title: "What causes head bolts to break?",
              content:
                "<p><span class='bold'>Several factors can cause head bolts to break:</span></p><ol><li><span class='bold'>Over-torquing:</span> Applying excessive torque during the installation of the head bolts can lead to their failure. Each engine has specific torque specifications, and surpassing those limits can cause the bolts to exceed their tensile strength and break.</li><li><span class='bold'>Fatigue:</span> Over time, head bolts can experience cyclic loading from the engine's heating and cooling cycles. This can lead to metal fatigue, causing the bolts to weaken and eventually break.</li><li><span class='bold'>Corrosion:</span> If the head bolts are exposed to corrosive substances or environments, they can degrade over time, making them more susceptible to breaking.</li><li><span class='bold'>Incorrect Installation:</span> Using incorrect or damaged head bolts, or not following the proper installation procedures, can lead to uneven pressure distribution and bolt failure.</li><li><span class='bold'>Overheating:</span> Engine overheating can weaken the head bolts and reduce their strength, increasing the likelihood of breakage.</li><li><span class='bold'>Age and Wear:</span> Head bolts, like any mechanical component, have a finite lifespan. As they age and experience wear, their structural integrity can diminish, leading to potential breakage.</li><li><span class='bold'>Thermal Stress:</span> Rapid and extreme temperature changes, especially during engine operation, can subject the head bolts to thermal stress, causing them to weaken and break over time.</li><li><span class='bold'>Improper Material or Quality:</span> Low-quality or improperly manufactured head bolts may not have the necessary strength and durability, making them more prone to failure.</li></ol></br><p>It is essential to use <span class='bold'>high-quality head bolts</span> and follow the manufacturer's recommended installation procedures and torque specifications to minimize the risk of head bolt failure. Regular maintenance, such as replacing head bolts during major engine overhauls, can also help prevent potential issues related to bolt breakage.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      retenes: {
        titulo: "OIL SEALS ",
        texto:
          "Extensive range of oil and valve seals to ensure the perfect sealing of the engine.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil4.pdf",
        details: {
          intro: {
            alt: "oil seals",
            title: '<h1 class="title title-36">Oil Seals</h1>',
            text:
              "<p>Oil seals are essential mechanical devices used to prevent the leakage of fluids, typically oil or grease, from one component to another in machinery or automotive applications. These seals are used to create a barrier between the moving and stationary parts of a machine, such as a rotating shaft and housing, to retain lubricants and prevent contaminants from entering critical areas.</p><p>Oil seals typically consist of a flexible elastomeric lip (made from materials like rubber or synthetic compounds) that is pressed against the rotating shaft. The lip creates a tight seal, preventing the lubricating fluid from escaping while keeping out dust, dirt, and other contaminants that could cause damage.</p><p>At AJUSA, you'll find a wide selection of high-quality pieces, meticulously designed for various vehicle applications, allowing you to drive with confidence and peace of mind. Experience the difference our premium products make in enhancing your vehicle's performance and protecting your investment for the long haul.</p>",
            btn_text: "ONLINE CATALOGUE ",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/retenes-1.webp",
                alt: "ajusa seals"
              },
              {
                img: "/static/img/products/retenes-2.webp",
                alt: "ajusa oil seals"
              },
              {
                img: "/static/img/products/retenes-3.webp",
                alt: "valve stem seals ajusa"
              },
              {
                img: "/static/img/products/retenes-4.webp",
                alt: "oil seals for cars"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Order the right oil seals for your vehicle",
              content:
                "<p>Crafted from durable materials that meet or exceed industry standards, our seals are rigorously tested to withstand the toughest conditions, ensuring they perform flawlessly even under extreme temperatures and pressures. We can ensure that your vehicle's engine and other critical components will stay protected and function optimally.</p><p>At AJUSA, you'll find a wide selection of high-quality pieces, meticulously designed for various vehicle applications, allowing you to drive with confidence and peace of mind. </p>"
            },
            "tip-2": {
              title:
                "Use Ajusa oil seals for enhancing a long-lasting car performance",
              content:
                "<p>It’s no secret that your car's performance and durability depend on the quality of its essential components. With our seals in place, your engine will experience reduced friction, leading to smoother operation, increased fuel efficiency and, ultimately, enhanced overall performance.</p><p>Having a car is a significant investment, and protecting it is mandatory. Make sure to shield your vehicle parts from premature wear and damage finding the right oil seals, extending their lifespan and saving you from costly repairs down the road.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Discover our extensive oil seals catalogue",
              content:
                "<p>Our product inventory is the widest you can find in our area, as we have parts for all makes and models of vehicles on the market today. Simply give us all the necessary information regarding your car, and we will search for Oil Seals in stock so that you can always have a spare part on hand.</p><p>Backed by years of industry expertise, our team is dedicated to providing exceptional customer service. From selecting the right oil seals to answering your technical questions, we are here to support you at every step of the process.</p><p>Find online multiple oil seals types of different sizes to cater to various vehicle models and applications. If needed, contact us for a custom customer attention.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      tubos_engrase: {
        titulo: "OIL FEED PIPES",
        texto:
          "We adapt to the new turbocompressor engines with oil feed pipes. AJUSA turbo catalogue available.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "oil feed pipes",
            title: '<h1 class="title title-36">Oil Feed Pipes</h1>',
            text:
              "<p>The <span class='bold'>oil feed pipe</span> is a component in a <span class='bold'>turbocharged engine system responsible for supplying a continuous flow of engine oil to the turbocharger</span>. Engine oil lubricates and cools the turbocharger's rotating components, such as the turbine shaft and compressor wheel, ensuring smooth operation and preventing damage from friction and heat. The oil feed pipe connects to the engine's oil supply system and plays a vital role in maintaining the <span class='bold'>turbocharger's performance and longevity</span>.</p><p>Designed to optimize your machinery's performance, efficiency and durability, Ajusa top-of-the-line <span class='bold'>oil feed pipes</span> are engineered with precision and care.</p>",
            btn_text: "ONLINE CATALOGUE ",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/tubos-engrase-1.webp",
                alt: "ajusa oil feed pipes"
              },
              {
                img: "/static/img/products/tubos-engrase-2.webp",
                alt: "turbo components ajusa"
              },
              {
                img: "/static/img/products/tubos-engrase-3.webp",
                alt: "oil feed pipes for turbocharger"
              },
              {
                img: "/static/img/products/tubos-engrase-4.webp",
                alt: "turbocharger components"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Order highly efficient Oil Feed Pipes",
              content:
                "<p>These oil feed pipes ensure a smooth and continuous oil flow to vital components, reducing friction and wear, so that you can experience a significant improvement, resulting in enhanced output and minimized downtime.</p>"
            },
            "tip-2": {
              title: "Invest in long-lasting performance and reliability",
              content:
                "<p>Join the ranks of satisfied customers who have already experienced the remarkable benefits of this piece and see how our product has transformed their day-to-day driving for better performance and long-term success.</p><p>Make a wise investment for your vehicle's future, ensuring it remains in top-notch condition for years to come. The seamless flow of oil through these pipes guarantees optimal lubrication and the smoother performance of your turbo thanks to the reliable and tested manufacturing.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "What does the turbo oil feed pipe do?",
              content:
                "<p>The <span class='bold'>turbo oil feed pipe</span> is a crucial component in a <span class='bold'>turbocharged engine system.</span> Its primary function is to <span class='bold'>provide a continuous flow of engine oil to the turbocharger.</span></p><p>In a turbocharged engine, the turbocharger utilizes the exhaust gases to spin a turbine, which, in turn, drives the compressor. The compressor then forces air into the engine's intake manifold, resulting in increased air density and improved engine performance.</p><p>However, the high-speed rotation of the turbocharger's turbine and compressor creates a significant amount of heat and friction. To keep the <span class='bold'>turbocharger's internal components properly lubricated and cool</span>, it requires a supply of engine oil. This is where the turbo oil feed pipe comes into play.</p><p>The oil feed pipe is usually connected to the engine's oil supply system and is designed to deliver a constant flow of clean, pressurized engine oil directly to the turbocharger. The oil serves two critical purposes:</p><ol><li><span class='bold'>Lubrication:</span>Engine oil reduces friction between the rotating parts of the turbocharger, such as the turbine shaft and the compressor wheel. Proper lubrication prevents excessive wear and prolongs the life of these components.</li><li><span class='bold'>Cooling:</span>The oil also helps dissipate heat generated by the turbocharger during operation. The cooling effect prevents the turbocharger from overheating, which could otherwise lead to decreased performance and potential damage.</li></ol></br><p>Since the <span class='bold'>turbo oil feed pipe plays a vital role in maintaining the health and performance of the turbocharger</span>, it is essential to ensure that the pipe is free from leaks, blockages, or other issues that could disrupt the oil supply. Regular maintenance and inspection are necessary to prevent any potential problems that could arise from a malfunctioning turbo oil feed pipe.</p>"
            },
            "dropdown-2": {
              title: "Can you run a turbo without oil lines?",
              content:
                "<p><span class='bold'>Running a turbocharger without oil lines is not recommended</span> and can lead to severe damage and failure of the turbocharger and potentially the engine itself. Engine oil is essential for the proper operation of a turbocharger, as it serves two critical functions:</p><ol><li><span class='bold'>Lubrication:</span>The turbocharger's internal components, such as the turbine shaft and compressor wheel, rotate at very high speeds. Without proper lubrication, these parts would experience excessive friction, leading to rapid wear and potential seizing of the turbocharger.</li><li><span class='bold'>Cooling:</span>The turbocharger generates a significant amount of heat during operation due to the high-speed rotation and compression of air. Engine oil helps dissipate this heat, preventing the turbocharger from overheating and maintaining its efficiency and performance.</li></ol></br><p>If a <span class='bold'>turbocharger is run without oil lines or with insufficient oil supply</span>, it will quickly suffer from oil starvation. This can cause the following issues:</p><ol><li><span class='bold'>Premature Wear:</span>The lack of lubrication will result in increased friction and wear on the turbocharger's moving parts. This can lead to a reduced lifespan of the turbocharger and potentially catastrophic failure.</li>    <li><span class='bold'>Overheating:</span>The absence of oil for cooling can cause the turbocharger to overheat. Excessive heat can deform and damage critical components, negatively impacting performance and causing irreversible damage.</li>    <li><span class='bold'>Engine Damage:</span>In extreme cases, oil starvation can lead to complete turbocharger failure, resulting in the release of debris and metal particles into the engine's intake and exhaust systems. These particles can damage other engine components, leading to expensive repairs or engine failure.</li></ol></br><p>To ensure the longevity and proper <span class='bold'>functioning of a turbocharger</span>, it is crucial to maintain a steady supply of clean and pressurized engine oil through the appropriate oil feed and return lines. Regular maintenance and monitoring of the oil supply system are essential to prevent oil-related issues and ensure the turbocharger operates optimally.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      tubos_egr: {
        titulo: "PIPES EGR",
        texto:
          "Ajusa offers high-quality EGR valve pipes that meet the specifications of leading manufacturers. Our products are designed to ensure long service life and optimal performance, helping keep your vehicle within emission standards and ensuring cleaner and more efficient driving.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "EGR valve pipes",
            title: '<h1 class="title title-36">EGR valve pipes</h1>',
            text:
              '<p>Ajusa offers high-quality <span class="bold">EGR valve pipes </span>that meet the specifications of leading manufacturers. Our products are designed to ensure long service life and optimal performance, helping keep your vehicle within emission standards and ensuring cleaner and more efficient driving.</p>',
            btn_text: "ONLINE CATALOGUE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/tubos-egr-1.webp",
                alt: "EGR valve pipe ajusa"
              },
              {
                img: "/static/img/products/tubos-egr-2.webp",
                alt: "egr valve ajusa"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "THESE PIPES MAINTAIN THE EFFICIENCY OF THE EXHAUST GAS RECIRCULATION SYSTEM",
              content:
                '<p>The EGR valve pipe (Exhaust Gas Recirculation) is a key component in <span class="bold">emission reduction </span>systems of internal combustion engines.</p> <p>This tube is part of the EGR system, designed to <span class="bold">reduce nitrogen oxide (NOx) emissions</span> by recirculating a portion of the exhaust gases back into the engine intake.</p>'
            },
            "tip-2": {
              title: "HIGH-QUALITY PIPES, DESIGNED FOR EASY INSTALLATION",
              content:
                '<p>An <span class="bold">EGR valve pipe</span> may require replacement when carbon deposits are excessive and cleaning is no longer sufficient.</p><p> Additionally, a cracked or damaged tube can cause exhaust gas leaks, negatively affecting both engine efficiency and emissions control.</p>'
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "What is the EGR system?",
              content:
                "<p>The EGR (Exhaust Gas Recirculation) system directs part of the exhaust gases back into the combustion chamber to improve emissions, particularly reducing pollutants like NOx.  </p><p>These gases flow from the exhaust manifold, through the EGR valve pipe, and into the intake, with the flow managed by the opening and closing of an EGR valve controlled by the ECU, allowing full, partial, or no flow as needed.  </p><p>Thus, the EGR system redirects some exhaust gases back to the combustion chamber through the EGR valve pipe, which connects the exhaust and intake manifolds. Introducing these oxygen-poor exhaust gases into the combustion process lowers the combustion chamber temperature, thus reducing the formation of NOx—one of the main contributors to air pollution, which also impacts human health.</p>"
            },
            "dropdown-2": {
              title: "Why is the EGR tube important?",
              content:
                "<p>Over time, EGR valve pipes can accumulate combustion residues and other deposits from exhaust gases, often partially or fully clogging the tube and reducing system efficiency. Additionally, they endure thermal fatigue from high gas temperatures and mechanical fatigue from engine vibrations. This is why regular maintenance, including inspection and possible replacement of this part, is crucial.</p><p>Symptoms of a clogged EGR valve pipe include power loss, increased fuel consumption, and the activation of the engine warning light (MIL).</p><p>The main causes of a defective tube are:</p><ol><li><span class='bold'>Obstruction: </span>Exhaust gases, especially in diesel engines, contain many combustion by-products like soot, which can eventually clog the tube completely, blocking gas flow.</li><li><span class='bold'>Breakage: </span>Due to frequent start-stop cycles and high temperatures from exhaust gases, combined with engine-induced vibrations, cracks or breaks may form in the pipe.</li></ol><p>An EGR system cannot function properly with a defective EGR valve pipe, leading not only to malfunction in the anti-pollution system but also in the engine itself, potentially causing more serious issues if not replaced in time.</p><p>An EGR valve pipe may require replacement when carbon deposits are excessive and cleaning is no longer sufficient. Additionally, a cracked or damaged tube can cause exhaust gas leaks, negatively affecting both engine efficiency and emissions control.</p><p>If you experience any of these symptoms or if your vehicle has driven many miles without an EGR system check, it is advisable to seek a professional evaluation. Installing a new EGR valve pipe ensures a perfect repair, preventing system malfunctions and other breakdowns caused by defective tubes.</p>"
            },
            "dropdown-3": {
              title: "Benefits of Well-Maintained EGR valve pipes",
              content:
                "<ul>  <li><span class='bold'>Reduced Pollutant Emissions: </span>Proper system function lowers combustion temperatures, significantly reducing NOx emissions.</li>  <li><span class='bold'>Compliance with Environmental Regulations: </span>Modern vehicles must meet strict emissions regulations, and the EGR system helps engines comply with these standards.</li>  <li><span class='bold'>Improved Fuel Economy: </span>Gas recirculation optimizes the combustion process, contributing to more efficient fuel use.</li>  <li><span class='bold'>Extended Engine Durability: </span>By reducing combustion chamber temperatures, the EGR system decreases thermal stress on internal engine components, which can extend their lifespan.</li></ul>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      tubos_refrigeracion: {
        titulo: "COOLANT PIPES",
        texto:
          "Turbo cooling pipes carry coolant between the engine and the turbocharger, in both supply and return directions. Ajusa’s turbocharger cooling pipe range covers more than 40 vehicle models from leading brands such as Ford, VAG, Mercedes, Fiat/Alfa/Jeep, Nissan and Smart.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "coolant pipes",
            title: '<h1 class="title title-36">Coolant Pipes</h1>',
            text:
              '<p><span class="bold">Turbochargers</span> face a constant challenge: extreme temperatures. In modern engines, these components can reach heat levels that place brutal thermal stress on all internal parts.</p><p>When traditional oil lubrication is no longer enough to combat these temperatures, a vital solution comes into play: external liquid cooling via dedicated coolant pipes.</p><p>The turbocharger coolant pipes covers more than 40 vehicle models from leading brands, including Ford, VAG, Mercedes, Fiat/Alfa/Jeep, Nissan, and Smart.</p>',
            btn_text: "ONLINE CATALOGUE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/tubos-refrigeracion-1.webp",
                alt: "tubo refrigeracion ajusa"
              },
              {
                img: "/static/img/products/tubos-refrigeracion-2.webp",
                alt: "valvula refrigeracion ajusa"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "",
              content:
                "<p>In modern vehicles, cooling systems have evolved to improve thermal efficiency and manage an increasing number of components, including turbochargers and emission control systems. The greater complexity of the circuit increases the risk of faults that are difficult to diagnose and expensive to repair. Poor thermal management can cause serious damage, especially in liquid-cooled turbos.</p>"
            },
            "tip-2": {
              title: "",
              content:
                "<p>Turbocharger cooling pipes must only be used in compatible applications, ensuring correct routing that allows thermal expansion without generating stress.</p><p>It is essential to use suitable materials and gaskets, respect the specified tightening torque, and maintain the circuit with approved coolant. Reusing damaged or aged pipes is not recommended.</p><p>After any intervention, leak tightness must be verified and the system must be completely bled to ensure safe turbocharger operation.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "WHAT IS THE FUNCTION OF COOLANT PIPES?",
              content:
                "<p>Turbo cooling pipes carry coolant between the engine and the turbocharger, in both supply and return directions. They must withstand high temperatures, pressure and vibrations, and must be manufactured from durable materials. Depending on the application, they may be made of carbon steel, stainless steel or combinations of metal and flexible sections, selected to provide high mechanical and thermal resistance.</p><p>The pipes incorporate formed or machined ends that allow precise and leak-tight connections using specific gaskets, clamps or fittings, preventing coolant leaks even under severe operating conditions.</p><p>In certain configurations, cooling pipes integrated into an auxiliary circuit with an electric pump allow coolant circulation to continue after the engine is switched off. This system is essential to dissipate accumulated residual heat.</p><p>This phenomenon, known as heat soak, occurs when heat from the turbine is transferred to the center housing in the absence of coolant flow. Forced circulation limits thermal peaks and promotes a controlled temperature decrease. This solution is especially relevant in vehicles operating under severe conditions and in those equipped with Start&Stop systems, as it reduces oil thermal degradation, carbon deposit formation and premature turbocharger wear.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      junta_turbo: {
        titulo: "TURBO FITTING KITS ",
        texto:
          "We offer more than 1,000 different self-assembly kits for turbocharged. Our kits cover most of the applications for car makes.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil6.pdf",
        details: {
          intro: {
            alt: "turbo fitting kit",
            title: '<h1 class="title title-36">Turbo Fitting Kit</h1>',
            text:
              "<p>Turbo fitting kits, also known as turbo installation kits or turbocharger installation kits, are comprehensive sets of components and hardware required to properly and safely install a turbocharger in a vehicle or engine. These kits are specifically designed to simplify the process of fitting a turbocharger and ensure all necessary components are included for a successful installation.</p><p>A typical turbo fitting kit may include the following components: Gaskets, Studs and Nuts, Oil Lines, Water Lines (if applicable), Bolts and Clamps, Adapters and Flanges, Fittings and Connectors.</p><p>By providing all the necessary components in one package, turbo fitting kits help streamline the installation process and ensure that the turbocharger is properly integrated into the engine, minimizing the risk of issues related to compatibility or missing parts. These kits are often specific to particular vehicle models or engine types, ensuring a precise fit and reliable performance.</p>",
            btn_text: "ONLINE CATALOGUE ",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/junta-turbo-1.webp",
                alt: "ajusa turbo fitting kits"
              },
              {
                img: "/static/img/products/junta-turbo-2.webp",
                alt: "spare parts for turbo"
              },
              {
                img: "/static/img/products/junta-turbo-3.webp",
                alt: "turbo fitting kits"
              },
              {
                img: "/static/img/products/junta-turbo-4.webp",
                alt: "auto parts for turbocharged"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "Transform your driving experience with a Turbo Fitting Kit",
              content:
                "<p>Engineered to transform your vehicle into a powerhouse of performance and excitement, our Turbo Fitting Kit optimizes your engine's capabilities providing you a fusion of power and efficiency, propelling you to new heights of exhilaration on the open road.</p><p>Feel the confidence coursing through your veins as you tackle every twist and turn with grace and precision. It’s the right time to boost your driving experience like never before, as reduced turbo lag ensures instantaneous response to your commands.</p>"
            },
            "tip-2": {
              title: "Engineering prowess and precision",
              content:
                "<p>Every element of our Turbo Fitting Kit is meticulously engineered with a passion for perfection, from the intricate design to the selection of premium materials in order to surpass the highest industry standards and your most demanding expectations.</p><p>The pieces that make up this kit your engine will roar with a newfound vigor and each turn of the wheel will become a masterstroke. Discover and experience first hand the ultimate upgrade to join the elite ranks of high-performance driving.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "What turbo fits my car?",
              content:
                "<p>Consulting with a knowledgeable mechanic, turbo specialist, or researching reputable turbocharger manufacturers can help you find the appropriate turbo for your car. They can consider your vehicle's specifications, your performance objectives, and any necessary modifications to provide you with the best turbocharger option.</p><p>With this information, our automotive experts can assist you in finding the perfect piece, tailored to your vehicle's needs. Feel free to get in touch with us and we'll shortly help you find the ideal match for your car's performance enhancement.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      ajusil: {
        titulo: "<strong>Ajusil</strong> Silicone sealant",
        texto:
          "The best sealing solution for when gaskets are not needed. This neutral silicone, of low odour and oxygen sensor safe, satisfies the most demanding requirements in terms of reliability, thermal and fluid resistance. Available in packs of 75 ml and 200 ml."
      },
      ajusev: {
        titulo: "<strong>AjusEV</strong> Silicone sealant for electric vehicle",
        texto:
          "Silicon sealant, exclusively for hybrid and electric vehicles. Guarantees full waterproofing against external atmospheric agents and protects the vehicle’s electronic components. Advised for use in the battery zone and in the Power Control Unit (PCU). Available in 310 ml containers."
      },
      ajustick: {
        titulo: "<strong>Ajustick</strong> Anaerobic sealant",
        texto:
          "Sealant for metal components with machined surfaces. Anaerobic sealant that withstands a wide range of temperatures (from -50° to 150 °C, peaking at 180 °C momentarily). Available in 50 ml packs."
      },
      ajulock: {
        titulo: "<strong>Ajulock</strong> Thread locker",
        texto:
          "Mono-component anaerobic product with medium resistance. Designed to protect metallic motor parts (nuts, bolts, studs) from weakening caused by temperature variations and vibrations. Available in 50 ml containers."
      },
      ajulube: {
        titulo: "<strong>Ajulube</strong> Engine assembly lube",
        texto:
          "Assembly oil that lubricates and protects mechanic components against wear during initial motor startup. Avoids contact between metals in components subjected to high pressure: camshafts, hydraulic lifters, crankshaft and pistons. Available in 100 ml containers."
      },
      productos_quimicos: {
        titulo: "Chemical products line",
        texto:
          "Specialists in the manufacture of components for internal combustion engines for both cars and industrial vehicles. We are also leaders in the development of spare parts for turbo engines.",
        ver_mas: "See more",
        details: {
          intro: {
            alt: "chemical products line",
            title:
              '<h1 class="title title-36">Sealants and others chemical products</h1>',
            text:
              "<p>Introducing our top-quality <span class='bold'>chemical products</span> designed exclusively for vehicle enthusiasts. At Ajusa, we take engine care to a whole new level.</p><p><span class='bold'>Sealants and others chemical products</span> play a vital role in the automotive industry. These essential substances ensure tight, durable seals, prevent leaks, and provide protection against corrosion. From adhesives to coatings, they enhance vehicle performance and longevity, making them indispensable components in modern automotive manufacturing.</p>",
            btn_text: "ONLINE CATALOGUE ",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/productos-quimicos/intro-main-quimicos.webp",
                alt: "sealants and engine lubricants"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-0.webp",
                alt: "silicone sealant 200ml"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-1.webp",
                alt: "silicone sealant 75ml"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-2.webp",
                alt: "silicone sealant ajusil"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-0.webp",
                alt: "silicone sealant for electric vehicle"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-1.webp",
                alt: "silicone sealant for electric vehicle 1"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-2.webp",
                alt: "silicone sealant for electric vehicle 2"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-0.webp",
                alt: "anaerobic sealant"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-1.webp",
                alt: "anaerobic sealant 1"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-2.webp",
                alt: "anaerobic sealant 2"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-0.webp",
                alt: "thread locker"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-1.webp",
                alt: "thread locker 1"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-2.webp",
                alt: "thread locker 2"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-0.webp",
                alt: "engine assembly lube"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-1.webp",
                alt: "engine assembly lube 1"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-2.webp",
                alt: "engine assembly lube 2"
              }
            ]
          },
          dropdowns: {
            "dropdown-1": {
              title:
                "Sealants and chemical products for the automotive industry",
              content:
                '<p>The manufacturing of <span class="bold">sealants and other chemical products for engines</span> involves a precise and complex process. Specialized laboratories and production facilities are responsible for creating these essential components. Engineers and chemists work together to develop formulations that <span class="bold">can withstand high temperatures, pressure, and harsh conditions within engines.</span></p><p>The production typically starts with selecting raw materials, including polymers, resins, and additives, which are carefully mixed and blended. The mixture undergoes rigorous testing to ensure it meets quality and performance standards. Once the ideal composition is achieved, the sealants or chemical products are packaged in suitable containers, ready for distribution.</p><p><span class="bold">Engine sealants and chemical products</span> are designed to <span class="bold"></span>prevent oil and coolant leaks</span>, improve gasket performance, and provide a secure bond between engine parts. Their critical role in engine function and longevity makes their manufacturing a crucial aspect of the automotive industry, contributing to the efficiency and reliability of vehicles worldwide.</p>'
            },
            "dropdown-2": {
              title: "Silicone Sealing Solutions for automotive industry",
              content:
                '<p>Silicone sealing solutions have become indispensable in the automotive industry, offering a wide range of benefits and applications. Silicone, a synthetic polymer known for its versatility, <span class="bold">heat resistance, and durability</span>, has proven to be an excellent material for various sealing needs in vehicles.</p><p>One of the primary applications of <span class="bold">sealing solutions</span> is the silicont sealant. This silicone provide reliable and long-lasting seals, even in high-temperature environments typical of engine compartments. Their ability to withstand extreme heat, as well as resistance to oil, fuel, and coolant, makes them ideal for replacing critical engine components.</p><p>Additionally, silicone sealants are widely used for bonding and sealing purposes in various automotive assemblies. Their flexibility, adhesion, and resistance to weathering make them suitable for sealing gaps, gaskets, and seams, preventing water and dust ingress and increasing overall structural integrity.</p><p>As automotive technology continues to advance, silicone sealing solutions remain at the forefront of innovation, continuously improving to meet the evolving demands of the automotive industry. From engines to electrical systems and beyond, silicone-based products play a crucial role in enhancing vehicle performance, safety, and reliability. <span class="bold">Ajusil, Ajustick and AjusEV sealants</span> take care of the performance of your engine.</p>'
            },
            "dropdown-3": {
              title: "Engine Lubrication basics for vehicles",
              content:
                "<p>Engine lubrication is a fundamental aspect of vehicle maintenance, crucial for ensuring optimal engine performance and longevity. The primary purpose of engine lubrication is to <span class='bold'>reduce friction between moving parts, preventing wear and damage caused by metal-to-metal contact.</span></p><p>Engine oil, the key lubricant, forms a protective film between the engine's components, such as pistons, crankshafts, and camshafts. This film minimizes friction and heat generation, enabling smooth operation and <span class='bold'>maximizing fuel efficiency.</span></p><p>In conclusion, <span class='bold'>engine lubrication</span> is a fundamental aspect of vehicle care, providing vital protection to the engine's intricate components. <span class='bold'>Ajulube is a perfect engine assembly lube for camshafts</span>. Ajusa include a bottle of engine lubricant in all camshafts. </p>"
            },
            "dropdown-4": {
              title: "What is the best threadlocker for cars?",
              content:
                '<p><span class="bold">Threadlockers are essential</span> adhesives used in the automotive industry to <span class="bold">prevent threaded fasteners</span> from loosening due to vibration, thermal expansion, and other mechanical stresses. These anaerobic adhesives are applied to threaded parts before assembly, and they cure when confined in the absence of air.</p><p>Threadlockers like as <span class="bold">Ajulock</span> ensure the safety and reliability of automotive assemblies, reducing the risk of parts loosening and potentially causing damage or accidents. Properly using the right threadlocker helps maintain the integrity of various automotive components, contributing to the overall performance and longevity of the vehicle.</p>'
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      nuevo_sellante: {
        titulo: "ANAEROBIC SEALANT",
        texto:
          "Ajusa has launched its new product AJUSTICK for sealing metal components with machined surfaces. Anaerobic sealant: (requiring no oxygen for final curing) capable of working in a broad temperature range (between -50ºC and 150ºC, occasionally reaching 180ºC). Available in 50 ml packs.",
        enlace_ficha_tecnica:
          "/static/pdf/info-tecnica/info_tecnica_ajustick_en.pdf"
      },
      taques: {
        titulo: "HYDRAULIC LIFTERS",
        texto:
          "Accuracy and quality on our hydraulic lifters line. We verify 100% of the entire production process with micron-level tolerance.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil9.pdf",
        details: {
          intro: {
            alt: "hydraulic lifters",
            title: '<h1 class="title title-36">Hydraulic lifters</h1>',
            text:
              "<p><span class='bold'>Hydraulic lifters</span>, also known as tappets, are engine components that help maintain precise valve actuation by adjusting the clearance between the camshaft and the valves. They use hydraulic fluid pressure to automatically compensate for this clearance, ensuring smooth and efficient engine operation.</p><p>At Ajusa, we are leaders in the automotive manufacturing industry. One of our fields of expertise lies in our advanced machining section, where you can find our range of top quality <span class='bold'>hydraulic lifters</span>.</p>",
            btn_text: "ONLINE CATALOGUE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/taques-1.webp",
                alt: "ajusa hydraulic lifters"
              },
              {
                img: "/static/img/products/taques-2.webp",
                alt: "lifters for engine repair"
              },
              {
                img: "/static/img/products/taques-3.webp",
                alt: "hydraulic lifters"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Our range of hydraulic lifters",
              content:
                "<p>Hydraulic tappets are essential devices in the <span class='bold'>automotive world</span>. At Ajusa, we have perfected their design and manufacture to offer the highest quality products.</p><p>Our wide <span class='bold'>range of hydraulic lifters </span>is designed to suit various applications in the automotive industry. Our products are versatile and safe.</p>"
            },
            "tip-2": "none"
          },
          dropdowns: {
            "dropdown-1": {
              title: "Hydraulic lifters Technical Characteristics",
              content:
                "<p>Hydraulic tappets manufactured by Ajusa are recognized for their excellence in design and performance. These <span class='bold'>essential engine parts </span>incorporate a number of key technical features that set them apart:</p><p><span class='bold'>Advanced hydraulic technology</span></br>Our hydraulic tappets use state-of-the-art hydraulic technology to ensure smooth and precise operation. This translates into immediate response and optimum performance at all times.</p><p><span class='bold'>High-quality construction</span></br>Each hydraulic tappet is constructed with high quality materials that withstand the most demanding conditions. Durability and strength are fundamental elements of our manufacturing.</p><p><span class='bold'>Precise tolerances</span></br>Our hydraulic tappets are manufactured to extremely tight tolerances to ensure a perfect fit in the engine valve train. This results in precise valve actuation and trouble-free operation.</p><p><span class='bold'>Performance in a variety of conditions</span></br>Our hydraulic tappets are designed to perform reliably in a variety of conditions, from extreme temperatures to high-pressure environments. Their ability to maintain consistent performance is one of their distinguishing features.</p><p><span class='bold'>Easy installation and maintenance</span></br>Ease of installation and maintenance is a priority in the design of our hydraulic lifters. This reduces engine downtime and ensures efficient operation.</p><p><span class='bold'>Regulatory compliance</span></br>All of our hydraulic tappets comply with the most stringent industry regulations and quality standards. This ensures safety and reliability in each of our products.</p> "
            },
            "dropdown-2": {
              title: "How to choose the right hydraulic tappets?",
              content:
                "<p>Choosing <span class='bold'>the right hydraulic lifters </span>is a strategic decision for your business and can make the difference in terms of operational efficiency and safety. At Ajusa, we provide you with the best guidance and professional advice for you to make informed and accurate decisions.</p><p>In addition, all of our hydraulic lifts meet the most rigorous industry standards and regulations. Check our online catalog to find the reference your vehicle needs.</p><p>Choosing the right hydraulic lifters (tappets) involves several key considerations:</p><p><span class='bold'>1. Engine Compatibility</span>: Ensure that the hydraulic lifters are compatible with your specific engine make, model, and year. Different engines may require different lifter designs and sizes.</p><p><span class='bold'>2. Lifter Type</span>: Determine the type of lifters your engine needs, such as flat tappet or roller lifters. This choice often depends on your engine's camshaft design and intended performance.</p><p><span class='bold'>3. Quality and Brand</span>: Opt for reputable brands known for producing high-quality hydraulic lifters. Quality construction materials and manufacturing processes are essential for long-lasting performance.</p><p><span class='bold'>4. Application</span>: Consider the intended use of your vehicle. If it's a high-performance application, you may need lifters designed for increased durability and higher RPM operation.</p><p><span class='bold'>5. Valve Train Requirements</span>: Ensure the lifters are capable of maintaining the required valve clearance and actuation for your engine's valve train system.</p><p><span class='bold'>6. Expert Advice</span>: If you're unsure about which hydraulic lifters to choose, seek advice from experienced professionals or consult the manufacturer's recommendations for your specific engine.</p><p><span class='bold'>7. Warranty</span>: Check if the lifters come with a warranty like Ajusa. A warranty can give you peace of mind in case of any manufacturing defects or issues.</p><p>Ultimately, selecting the right <span class='bold'>hydraulic lifters is crucial for optimal engine performance and longevity</span>.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      arbol_levas: {
        titulo: "CAMSHAFTS",
        texto:
          " We manufacture camshafts starting from bars in our modern machining centres and automatic automatic grinding machines to ensure a consistently high level of quality.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil10.pdf",
        details: {
          intro: {
            alt: "camshafts",
            title: '<h1 class="title title-36">Camshafts</h1>',
            text:
              "<p>Camshafts are vital engine components responsible for regulating the opening and closing of an engine's valves. They determine an engine's performance characteristics, influencing power output, torque, and fuel efficiency.<span class='bold'> Different camshaft </span>profiles can optimize performance for various applications, from everyday driving to high-performance racing engines.</p><p>Ajusa´s machining section is also dedicated to the <span class='bold'>manufacture of camshafts </span>from cast steel bars, using state-of-the-art grinding machinery to achieve optimum levels of precision and efficiency.</p>",
            btn_text: "ONLINE CATALOGUE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/arbol-levas-1.webp",
                alt: "ajusa camshafts"
              },
              {
                img: "/static/img/products/arbol-levas-2.webp",
                alt: "engine components ajusa"
              },
              {
                img: "/static/img/products/arbol-levas-3.webp",
                alt: "components for engine repair"
              },
              {
                img: "/static/img/products/arbol-levas-4.webp",
                alt: "camshafts catalog"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Ajusa Camshaft: Power up your engine",
              content:
                "<p>Discover the full <span class='bold'>range of camshafts </span>available at Ajusa to boost your engine's performance. With our extensive experience in manufacturing high quality automotive components, we are your best choice to optimize your vehicle.</p><p>To facilitate the product assembly, Ajusa has developed a complete camshaft replacement manual, which is included, along with the assembly lubricant Ajulube, in all its camshafts.</p>"
            },
            "tip-2": {
              title: "Our variety of camshafts",
              content:
                "<p>At <span class='bold'>Ajusa</span>, we understand that every vehicle is unique. That's why we offer a wide range of camshafts designed to fit various performance needs and applications. Whether you're looking for a high-performance upgrade or an OEM quality part, we have the perfect solution for you.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Advantages of choosing our camshafts",
              content:
                "<p><span class='bold'></span></p><p><span class='bold'>1. Performance Enhancement</span>: Our camshafts are designed to optimize engine performance, increasing power and torque output.</p><p><span class='bold'>2. Precise Engineering</span>: We employ precise engineering techniques to ensure that our camshafts meet the highest standards of quality and reliability.</p><p><span class='bold'>3. Durability</span>: <span class='bold'>Ajusa camshafts </span>are built to withstand demanding conditions, ensuring long-lasting performance and reduced maintenance.</p><p><span class='bold'>4. Expertise</span>: With our experience and expertise, we provide valuable guidance and support to help you choose the right camshaft for your engine.</p><p><span class='bold'>5. Compliance</span>: Our camshafts meet industry regulations and standards, guaranteeing safety and performance for your engine.</p><p><span class='bold'>6. Warranty</span>: We stand behind the quality of our camshafts with a warranty, providing peace of mind for our customers.</p><p>By selecting <span class='bold'>Ajusa camshafts</span>, you can benefit from enhanced engine performance and reliability, backed by our commitment to quality and customer satisfaction.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      otros: {
        titulo: "OTHER COMPONENTS",
        texto:
          "More than 80,000 different references for fibre, rubber and metal-rubber gaskets. We guarantee the most complete repair of your car or industrial vehicle.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil10.pdf",
        details: {
          intro: {
            alt: "other engine parts",
            title: '<h1 class="title title-36">Other Engine Parts</h1>',
            text:
              "<p>We offer you sealing products and <span class='bold'>other components Ajusa </span>designed to ensure that your engine runs smoothly. In our catalog, you will find a <span class='bold'>wide selection of gaskets for different parts of the engine</span>, such as the water pump, EGR valve, brake compressor, thermostat, among others.</p><p>If you need to <span class='bold'>buy another component </span>of those you have seen on our website for your engine, do not hesitate to contact us, whether you are the owner of a professional workshop or an individual. We are here to answer your questions and help you find the part you need.</p>",
            btn_text: "ONLINE CATALOGUE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/otros-1.webp",
                alt: "ajusa spare parts"
              },
              {
                img: "/static/img/products/otros-2.webp",
                alt: "fiber gaskets"
              },
              {
                img: "/static/img/products/otros-3.webp",
                alt: "metal-caucho gaskets"
              },
              {
                img: "/static/img/products/otros-4.webp",
                alt: "gaskets catalog"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Other Components and parts for your engine",
              content:
                "<p>At Ajusa, we know that sealing is essential in a <span class='bold'>variety of engine components</span>. That's why we offer a wide range of sealing solutions and other components Ajusa covering different engine parts.</p>"
            },
            "tip-2": "none"
          },
          dropdowns: {
            "dropdown-1": {
              title: "Parts Catalog",
              content:
                "<p><span class='bold'>Water Pump Gaskets</span></br>Gaskets designed for the water pump are essential to prevent leaks and maintain proper engine cooling. Our gaskets are precision manufactured to ensure a perfect seal.</p><p><span class='bold'>EGR Valve Gaskets</span></br>EGR valve gaskets are crucial to ensure controlled gas flow in the exhaust system, reducing emissions and improving engine efficiency. Rely on our gaskets to keep your engine running smoothly!</p><p><span class='bold'>Brake Compressor Gaskets</span></br>Other component Ajusa is the gaskets in the brake compressor for the safety of your vehicle. Our high quality gaskets ensure a tight seal, which is essential for a reliable operation of the brake system.</p><p><span class='bold'>Thermostat Gaskets</span></br>The thermostat regulates the engine temperature, and our thermostat gaskets ensure that this component functions properly. An optimal seal here is essential to prevent overheating and engine damage.</p><p><span class='bold'>Other components Ajusa available</span></br>In addition to these parts mentioned above, we offer a wide variety of other components Ajusa for different engine applications.</p><p>Come and discover them!</p>"
            },
            "dropdown-2": {
              title: "Features and Benefits",
              content:
                "<p>At <span class='bold'>Ajusa</span>, we provide high quality gaskets and engineered parts. Our sealing parts are distinguished by:</p><p>- <span class='bold'>Precise design</span>: Each gasket is precision manufactured to ensure a perfect fit and optimal sealing.</p><p>- <span class='bold'>Superior quality</span>: We use the highest quality materials that withstand the most demanding conditions and extend the life of your engine.</p><p>- <span class='bold'>Significant advantages</span>: By using our sealing solutions, you get reliable performance, improved efficiency and longer engine life.</p>"
            },
            "dropdown-3": {
              title: "Quality and Regulatory Compliance",
              content:
                "<p>We are committed to excellence in the manufacture of <span class='bold'>sealing parts </span>and <span class='bold'>other components Ajusa </span>for your engine. We rigorously comply with the most demanding regulations and quality standards in the automotive industry.</p><p>Our parts are synonymous with safety and performance for your engine.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      garantia: {
        titulo:
          "<span class='bold'>guaranteed quality</span> in all our products",
        titulo1:
          "<h2 class='title title-36'><span class='bold'>guaranteed quality</span> in all our products</h2>",
        texto:
          "Our commitment to quality implies an extra guarantee for our products. We have attained TUV certification under the ISO 9001 and IATF 16949 standards.",
        boton: "Certificates",
        cumplimiento:
          "In compliance with the prescriptions and recommendations of Royal Decree 396/2006 about health and safety applicable to work with Risk of exposure to asbestos, Ajusa certifies that it does not use any material that contains asbestos in its products or in any of its production processes."
      },
      shared: {
        "junta-turbo": "turbo-fitting",
        ajusil: "ajusil-en",
        "arbol-levas": "camshafts",
        "junta-culata": "cylinder-head",
        "junta-motor": "full-gasket-sets",
        otros: "others",
        retenes: "oils-seals",
        taques: "hydraulic-lifers",
        tornillos: "cylinder-head-bolts",
        "tubos-engrase": "oil-feed-pipes",
        "tubos-egr": "egr-pipes",
        nuevo_sellante: "anaerobic-sealant"
      },
      titulo_banner: "Select language",
      idiomas: {
        GE: "German",
        EN: "English",
        ES: "Spanish",
        FR: "French",
        HU: "Hungarian",
        IT: "Italian",
        NL: "Dutch",
        PL: "Polish",
        PT: "Portuguese",
        BG: "Bulgarian",
        CZ: "Czech",
        GR: "Greek",
        LV: "Latvian",
        SL: "Slovak",
        SE: "Swedish",
        LT: "Lithuanian",
        SL: "Slovenian",
        SK: "Slovak",
        RU: "Russian",
        RO: "Romanian",
        LT: "Lithuanian"
      },
      nav_options: {
        vehiculo_electrico: {
          title: "Electric vehicle",
          category: "vehiculo_electrico",
          href: "electric-vehicle"
        },
        junta_culata: {
          id: "cylinder-head-gaskets",
          title: "cylinder head gaskets",
          category: "product"
        },
        junta_motor: {
          id: "full-gasket-sets",
          title: "FULL GASKET SETS",
          category: "product"
        },
        tornillos: {
          id: "cylinder-head-bolts",
          title: "CYLINDER HEAD BOLTS",
          category: "product"
        },
        retenes: {
          id: "oil-seals",
          title: "OIL SEALS",
          category: "product"
        },
        tubos_engrase: {
          id: "oil-feed-pipes",
          title: "OIL FEED PIPES",
          category: "product"
        },
        tubos_egr: {
          id: "egr-pipes",
          title: "EGR valve pipes",
          category: "product"
        },
        tubos_refrigeracion: {
          id: "coolant-pipes",
          title: "Coolant Pipes",
          category: "product"
        },
        junta_turbo: {
          id: "turbo-fitting-kits",
          title: "TURBO FITTING KITS",
          category: "product"
        },
        productos_quimicos: {
          id: "chemical-products-line",
          title: "Chemical products line",
          category: "productos"
        },
        taques: {
          id: "hidraulic-lifters",
          title: "HYDRAULIC LIFTERS",
          category: "product"
        },
        arbol_levas: {
          id: "camshafts",
          title: "CAMSHAFTS",
          category: "product"
        },
        otros: {
          id: "other-components",
          title: "OTHER COMPONENTS",
          category: "product"
        }
      },
      alt_images: {
        juntas_culata: "cylinders head gaskets",
        tornillos: "cylinder head bolts",
        tubos_engrase: "oil feed pipes turbo components",
        "junta-culata-1": "ajusa cylinder head gasket",
        "junta-culata-2": "head gaskets catalog",
        "junta-culata-3": "mls cylinder head gaskets",
        "junta-motor-1": "ajusa full gasket sets",
        "junta-motor-2": "gasket sets ajusa",
        "junta-motor-3": "gaskets for cars",
        "junta-motor-4": "gaskets for industrial vehicles",
        "junta-motor-5": "auto parts for engine car repair",
        "tornillos-1": "ajusa cylinder head bolts",
        "tornillos-2": "ajusa bolts",
        "tornillos-3": "angular tightening of screws",
        "tornillos-4": "cylinder head bolts catalog",
        "retenes-1": "ajusa seals",
        "retenes-2": "ajusa oil seals",
        "retenes-3": "valve stem seals ajusa",
        "retenes-4": "oil seals for cars",
        "tubos-engrase-1": "ajusa oil feed pipes",
        "tubos-engrase-2": "turbo components ajusa",
        "tubos-engrase-3": "oil feed pipes for turbocharger",
        "tubos-engrase-4": "turbocharger components",
        "tubos-egr-1": "egr egr ajusa",
        "tubos-egr-2": "egr valve ajusa",
            "tubos-refrigeracion-1": "ajusa coolant pipes",
        "junta-turbo-1": "ajusa turbo fitting kits",
        "junta-turbo-2": "spare parts for turbo",
        "junta-turbo-3": "turbo fitting kits",
        "junta-turbo-4": "auto parts for turbocharged",
        sellantes_lubricantes: "sealants and engine lubricants",
        sellante_silicona: "silicone sealant",
        sellante_silicona_electrico: "silicone sealant for electric vehicle",
        sellante_anaerobico: "anaerobic sealant",
        lubricante_motor: "engine assembly lube",
        fijador_roscas: "thread locker",
        "taques-1": "ajusa hydraulic lifters",
        "taques-2": "lifters for engine repair",
        "taques-3": "hydraulic lifters",
        "arbol-levas-1": "ajusa camshafts",
        "arbol-levas-2": "engine components ajusa",
        "arbol-levas-3": "components for engine repair",
        "arbol-levas-4": "camshafts catalog",
        "otros-1": "ajusa spare parts",
        "otros-2": "fiber gaskets",
        "otros-3": "metal-caucho gaskets",
        "otros-4": "gaskets catalog",
        taller_electrico: "electric vehicle workshop"
      }
    },
    catalogo: {
      intro: {
        titulo: "AJUSA Catalogue",
        texto:
          "You will find the spare part you need for your vehicle in the AJUSA catalogue. The widest selection in the automobile sector with over 200,000 references at your disposal.",
        catalogo_impreso: "printed<br>catalogue",
        catalogo_impreso_texto:
          "We can make your work easier. Request a hard copy of the AJUSA general catalogue.",
        catalogo_impreso_boton: "Request it now"
      },
      cat_general: {
        texto:
          "AJUSA updates its catalogue every two years to ensure the most complete coverage in cylinder head gaskets, cylinder head bolts, gaskets sets and other maintenance parts like hydraulic lifters and camshafts."
      },
      buscador: {
        placeholder: "Search by vehicle makes",
        titulo:
          "Use the search engine above or select the initial of the brand of your interest."
      },
      cat_turbo: {
        titulo: "turbocomponents catalogue",
        texto:
          "The most extensive range of turbo fitting kits and oil feed pipes can be found in the AJUSA turbo catalogue. You can search for the reference you need by vehicle model or turbo make.",
        por_vehiculo: "DOWNLOAD BY VEHICLE MAKE",
        por_turbo: "download by turbo part number"
      },
      cat_juntas_compresor: {
        titulo: "BRAKE COMPRESSOR GASKET CATALOGUE",
        texto:
          "Check and download the brake compressor gasket catalogue exclusively for industrial vehicles. You can download it by compressor (KNORR-BREMSE, VOITH and WABCO) or by vehicle brand (DAF, IVECO, MAN, MERCEDES (industrial), RVI, SCANIA and VOLVO (Industrial).",
        por_vehiculo: "DOWNLOAD BY VEHICLE MAKE",
        por_turbo: "Download by compressor"
      },
      tec_alliance: {
        intro: "access online catalogue",
        titulo: "YOUR ONLINE SEARCH",
        texto_1:
          "Find the spare part you need when you need it. The AJUSA online catalogue is available 24 hours a day. You can search by vehicle, engine, VIN, reference number, OEM reference or technical details.",
        texto_2:
          "All AJUSA references include their technical information, assembly videos and 360º photographs.",
        boton: "access"
      },
      cat_juegoJuntas: {
        idUrl: "gasket-set",
        texto:
          "<strong>14 families of gasket sets</strong> for different engine parts in a full catalogue: <strong>water pump</strong>, fuel pum, hydraulic pump, injector pump, vacuum pump, timing case, exhaust manifold, intake manifold, charger, injector nozzle, oil cooler, exhaust system, EGR system and <strong>cylinder head cover</strong>. The most complete coverage in the market. You can download the full catalogue or by the gaskets set you need.",
        descarga_completo: "DOWNLOAD FULL CATALOGUE",
        descarga_juegos: {
          title: "DOWNLOAD BY GASKET SET",
          bombasAgua: "Water pump",
          bombasAgua_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-agua-gasket-water-pump.pdf",
          bombasCombustible: "Fuel pump",
          bombasCombustible_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-combustible-fuel-pump.pdf",
          bombaHidraulica: "Hydraulic pump",
          bombaHidraulica_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-hidraulica-hydraulic-pump.pdf",
          bombaInyeccion: "Injector pump",
          bombaInyeccion_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-inyeccion-injector-pump.pdf",
          bombaVacio: "Vacuum pump",
          bombaVacio_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-vacio-vacuum-pump.pdf",
          juntaCarter: "Timing case",
          juntaCarter_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/carter-mando-timing-case.pdf",
          colectorAdminision: "Intake manifold",
          colectorAdminision_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/colector-admision-intake-manifold.pdf",
          colectorEscape: "Exhaust manifold",
          colectorEscape_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/colector-escape-exhaust-manifold.pdf",
          comprensor: "Charger",
          comprensor_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/compresor-charger.pdf",
          inyector: "Injector nozzle",
          inyector_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/inyector-injector-nozzle.pdf",
          radiadorAceite: "Oil cooler",
          radiadorAceite_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/radiador-aceite-oil-cooler.pdf",
          sistemaEscape: "Exhaust system",
          sistemaEscape_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/sistema-escape-exhaust-system.pdf",
          sistemaEGR: "EGR System",
          sistemaEGR_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/sistema-juntas-EGR-System.pdf",
          tapasCulata: "Cylinder head cover",
          tapasCulata_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/tapa-culata-cilindro-cilinder-head-cover.pdf"
        }
      },
      ajusa_th: {
        intro: "ALTERNATIVE ENERGIES",
        titulo: "SUSTAINABLE FUTURE",
        texto:
          "AJUSA has developed a research line in alternative energies and is pioneering the manufacture of hydrogen-based PEM fuel cells. Discover AJUSA Hydrogen Technologies.",
        boton: "Discover",
        construccion: "Page under construction. Available shortly."
      },
      retenes: {
        titulo: "Catalogue shaft seal kits",
        texto:
          "Ajusa is launching a specific catalogue for shaft seal kits. It has the most complete coverage of seal kits to carry out a full cambelt change on the vehicle."
      },
      motorsport: {
        titulo: "Motorsports",
        texto:
          "Check the application guide Ajusa Motorsport. A full catalogue of cylinder head gaskets for performance engines. Performance engines require unique and improved features because of the extreme conditions that these vehicles are exposed to. Ajusa performance gaskets are manufactured to ensure the required perfect seal in high output engines."
      },
      novedad: "new",
      nav_options: {
        cat_general: {
          id: "general-cat",
          title: "general catalogue",
          category: "catalogo"
        },
        cat_turbo: {
          id: "turbocharger-cat",
          title: "turbocharger catalogue",
          category: "catalogo"
        },
        cat_ve: {
          title: "ev catalogue",
          category: "electric-vehicle",
          href: "electric-vehicle"
        },
        catalogo_online: {
          title: "online catalogue",
          redirect: "https://web.tecalliance.net/ajusa/en/home"
        },
        catalogo_impreso: {
          title: "Request printed catalog",
          category: "catalogo",
          href: "contact"
        }
      },
      alt_images: {
        catalog: "ajusa catalog",
        catalog_online: "ajusa catalog online",
        pila_hidrogeno: "pem fuel cell"
      }
    },
    area_tecnica: {
      intro: {
        titulo: "AJUSA technical area",
        texto:
          "<strong class='bold'>Welcome to the AJUSA technical assistance department!</strong> We solve your problems and  provide you with an extensive range of educational material with <strong class='bold'>technical reports, videos and webinars.</strong> We are committed to you and to repairing your vehicle."
      },
      asesoramos: {
        intro: "We can advise you",
        texto_1:
          "If you have a problem with any of our products, you've come to the right place. We can answer your queries and deal with your inquiries in less than five days. Send in your comment and the AJUSA technical assistance department will find you a solution.",
        texto_2: "+34 619 029 273",
        boton: "Send"
      },
      app: {
        texto_1:
          "Download our improved APP to perform a quick and easy search for the components your vehicle needs.",
        texto_2: "And much more!"
      },
      tips: {
        titulo: "TECHNICAL REPORTS",
        texto_1:
          "You will leave your doubts and assembly or disassembly problems behind with our products. You will be able to explore the characteristics of each component in the engine and you will learn to recognize the part each vehicle needs. All this and much more on offer in our guide to AJUSA technical reports. Download them now! ",
        texto_2: "We publish a new technical report every 15 days.",
        filtrar: "Sort by category",
        por_keyword: "Search by keyword",
        resultado: "Results of your search:",
        mostrando: "Displaying",
        novedades: "NOVELTIES"
      },
      webinarios: {
        titulo: "webinars",
        texto:
          "We can train you online. Sign up for our webinars and learn mechanics from the comfort of your own home. Free educational sessions lasting one hour each to improve your knowledge and make you an even better expert. In English and Spanish. ",
        proximos: "upcoming webinars",
        no_hay: "No webinars scheduled at the moment",
        anadir_cal: "add to the calendar",
        hasta: "19:00h until 21:00h",
        ultimo: "",
        btn: "Request Webinar"
      },
      asesoramiento: {
        intro: "consultancy",
        titulo: "WE OFFER SOLUTIONS",
        texto:
          "AJUSA is with you every step of the way in the repair of your vehicle. Our technical assistance department is at your disposal to resolve your doubts and questions.",
        boton: "Can we help?"
      },
      nav_options: {
        ajusa_app: {
          id: "ajusa-app",
          title: "ajusa mobile app",
          category: "area_tecnica"
        },
        tips: {
          id: "tips",
          title: "technical reports",
          category: "area_tecnica",
          alert: true
        },
        actualidad_videos: {
          id: "mechanics-videos",
          title: "mechanics videos",
          category: "area_tecnica",
          redirect: "https://www.youtube.com/channel/UCnoYVeFbsPiOVOcf80tW6Bg"
        },
        webinars: {
          id: "webinars",
          title: "webinars",
          category: "area_tecnica"
        }
      },
      alt_images: {
        juntas_culata_mls: "mls head gaskets ajusa"
      }
    },
    ajusa: {
      intro: {
        titulo: "GROWING <span class='bold'>TOGETHER</span>",
        texto:
          "We are the benchmark in the automotive sector because we believe in what we do. Since 1972, we have been taking care of your vehicles thanks to our dedication and the technology we have applied to developing engine components."
      },
      enlaces: {
        calidad: "original quality",
        servicio: "service",
        compromiso: "social commitment",
        equipo: "human team",
        catalogo: "catalogue"
      },
      calidad: {
        titulo: "ORIGINAL QUALITY",
        texto:
          "We guarantee original equipment quality. We hold TÜV certificates as per the ISO 9001 and IATF 16949 standards."
      },
      servicio: {
        titulo: "service",
        texto:
          "We are committed to our clients. Wherever you are, our products always arrive in time. We guarantee a service ratio of 99.5%."
      },
      compromiso: {
        titulo: "social<br>commitment",
        texto:
          "We contribute to an improvement in our environment by collaborating with a variety of social and charitable causes. Our responsibility towards the environment  is also part of AJUSA's social commitment.",
        texto_btn: "CARBON FOOTPRINT REPORT",
        pdf: "/static/pdf/Ajusa_Carbon_Footprint_Report.pdf"
      },
      equipo: {
        titulo: "human team",
        texto:
          "Permanently investing in the improvement of our professional talent and in the advancement of our employees. Behind every AJUSA component, there is a flexible and dynamic team with a spirit of continuous improvement."
      },
      catalogo: {
        titulo: "catalogue",
        texto:
          "The AJUSA catalogue identifies us around the globe. With over 200,000 references, it is the most complete catalogue in the market. You will find the part you need for your vehicle."
      },
      excelencia: {
        titulo: "THE AUTOMOTIVE EXCELLENCE",
        texto:
          "We achieve excellence at the same time as we take care of our environment. We minimize our environmental impact through energy savings and the use of renewable energies. We hold energy certificates from TUV ",
        enlace_texto: "ISO 14001 standard",
        texto_2:
          " and over <strong class='bold'>8,000 solar panels generate 40% of our annual power  consumption</strong> at our production plant.",
        boton: "View report"
      },
      historia: {
        titulo: "history",
        texto:
          "We have a story to tell. Effort and constant improvement have marked the steps of this family-owned business that started manufacturing cylinder head gaskets in 1972. We have grown, we have evolved… Come and learn about our history!",
        boton: "access"
      },
      alt_images: {
        sede_principal: "ajusa headquarters",
        fabricante_tubos_engrase: "oil feed pipes manufacturer",
        social: "ajusa social and environmental commitment",
        factoria_automocion: "ajusa factory automotive industry",
        catalog_juntas: "ajusa gaskets catalog",
        historia: "ajusa history"
      }
    },
    actualidad: {
      noticias: {
        titulo: "breaking news",
        ir_blog: "Go to the blog"
      },
      twitter: {
        titulo: "Aware on social networks",
        acceder: "Access"
      },
      videos: {
        titulo: "videos",
        texto:
          "You will be able to watch, step by step, how AJUSA parts are fitted into a real engine. The easiest and most practical way to learn how to assemble a cylinder head gasket perfectly and all the other engine components manufactured by AJUSA. Every 15 days, we update our video channel with a new vehicle.",
        ultimos: "latest videos",
        ver_todos: "view all the videos"
      }
    },
    blog: {
      intro: {
        titulo: "<span>TUNING</span>",
        subtitulo: "The blog of"
      },
      categorias_nombres: {
        fairs: "Trade fairs",
        products: "Products",
        "our-sector": "Our sector",
        "social-commitment": "Social Commitment"
      },
      alt_images: {
        ajusa_blog: "ajusa blog",
        puesta_punto: "tunnig",
        ferias: "stand automechanika ajusa",
        productos: "ajusa head gaskets",
        "nuestro-sector": "our sector ajusa",
        "compromiso-social": "social commitment"
      },
      ultimas: "Breaking news",
      dejar_comentario: "LEAVE A COMMENT",
      titulo_comentarios: "RECENT COMMENTS ",
      noticias_relacionadas: "Related News",
      compartir: "Share",
      no_hay_post: "No posts in that category"
    },
    sala_prensa: {
      clipping: {
        titulo: "CLIPPINGS",
        texto:
          "The media in the automobile sector reflect the latest announcements from AJUSA. This is the annual round-up of AJUSA media appearances.",
        boton: "download",
        logotipo: "logo",
        imagenes: "images"
      },
      ajusa: {
        intro: "about ajusa",
        titulo: "THE AUTOMOTIVE EXCELLENCE",
        texto:
          "We have been manufacturing cylinder head gaskets since 1972. Leaders in engine sealings with the most extensive catalogue of engine seals in the sector. We are also experts in the production of oil feed pipes and turbo fitting kits for engine turbo. Always at the service of the automobile industry."
      }
    },
    historia: {
      texto_intro:
        "We have been a global reference for over 45 years. Working in search of constant improvement in both our products and our services.",
      hoy: "Today",
      texto_1972_1:
        "AJUSA started up in 1972. That year saw the manufacture of the first cylinder head gasket. It took 3 hours and everything was done totally by hand!",
      texto_1972_2:
        "We attended the first international trade fairs and extended our facilities by moving to the Campollano industrial estate.",
      texto_1980_1:
        "We launched our first general catalogue with 600 references. The current catalogue has 20 times more! We have surpassed 200,000 references, providing complete coverage for Asian and European makes.",
      texto_1980_2:
        "We managed to produce our first OEM-quality part: a cylinder head gasket for Renault.",
      texto_1990_1:
        "We opened our Research and Testing Centre where we perform the most exhaustive quality assurance checks on our products.",
      texto_1990_2:
        "Launch of 3 new product lines: cylinder head bolts, hydraulic lifters and camshafts.",
      texto_2000_1:
        "Ajusa grows internationally and opens branches in Russia, United Kingdom, Mexico and Brazil, incorporating strategic partners around the globe.",
      texto_2000_2:
        "We move into the business park that bears our name: Ajusa. With over 40,000 m2 in our production plant and 3,000 m2 for offices.",
      texto_2010_1:
        "Since 2014, we produce oil feed pipes and we have launched our catalogue of turbo components with the most references in the market.",
      texto_2010_2:
        "We apply the latest technology to ensure the maximum quality in our product lines."
    },
    contacto: {
      titulo: "CUSTOMER SERVICE",
      sucursales: "Branches",
      coords: {
        lat: 52.71716135415642,
        lng: -2.46484123138884
      },
      id: "uk",
      delegaciones: {
        espana: {
          nombre: "Spain",
          titulo: "head office",
          direccion:
            "Parque Empresarial Ajusa, Calle 1, nº1 · 02008 · ALBACETE (Spain) · Apdo./P.O. Box 415 (02080)",
          telefono: "Ph.: +34 967 216 212",
          fax: "Fax: +34 967 216 214 - 967 240 499",
          email: "Mail: <a href='mailto:ajusa@ajusa.es'>ajusa@ajusa.es</a>"
        },
        // rusia: {
        //     nombre: "Russia",
        //     titulo: "Ajusa-Russia",
        //     direccion: "108803, Москва, п. Воскресенское, пос. Воскресенское, д. 66, а/я 1890",
        //     telefono: "Ph. +7(499) 608-06-81 / +7(916) 060-07-24",
        //     fax: "",
        //     email: "Contact: <a href='mailto: info@ajusa.ru'> info@ajusa.ru</a>"
        // },
        uk: {
          nombre: "United Kingdom",
          titulo: "Ajusa United Kingdom",
          direccion: "Unit 25, Hortonwood 33, Telford, TF1 7EX",
          telefono: "Ph. +44 (0)195 2608 771",
          fax: "",
          email:
            "Contact: <a href='mailto:info@ajusa.co.uk'>info@ajusa.co.uk</a>"
        },
        mexico: {
          nombre: "Mexico",
          titulo: "Ajusa México S.A. de C.V",
          direccion:
            "Calle Lago Ladoga, 295-A · Col. Anahuac, Deleg. Miguel Hidalgo · Ciudad de México, D.F. CP 11320 (Mexico)",
          telefono: "Ph. +52-55 5254 2332",
          fax: "Fax +52-55 5254 2332",
          email:
            "Contact: <a href='mailto:ajusamexico@ajusa.com.mx'>ajusamexico@ajusa.com.mx</a>"
        },
        brasil: {
          nombre: "Brazil",
          titulo: "Ajusa do Brasil Ltda.",
          direccion:
            "Rua Santa Francisca, 417 · Bairro Vila Jaguara, 05116-090 · SÃO PAULO, SP (Brazil)",
          telefono: "Ph. +55 11 3622-5353",
          fax: "Fax +55 11 3622-5353",
          email:
            "Contact: <a href='mailto:ajusadobrasil@ajusa.com.br'>ajusadobrasil@ajusa.com.br</a>"
        },
        usa: {
          nombre: "USA",
          titulo: "AJUSA USA Corp.",
          direccion:
            "GABLES INTERNATIONAL PLAZA · 2655 S. LE JEUNE ROAD SUITE # 905 · CORAL GABLES, FL 33134",
          telefono: "Ph. +1 310 625 1034",
          fax: null,
          email:
            "Contact: <a href='mailto:ajusausa@ajusa.es'>ajusausa@ajusa.es</a>"
        },
        francia: {
          nombre: "France",
          titulo: "Ajusa France",
          direccion: "64, Rue Paul Claudel, 87000 | Limoges (France)",
          telefono: "Ph. +33 587 14 71 17",
          fax: null,
          email:
            "Contact: <a href='mailto:ajusafrance@ajusa.fr'>ajusafrance@ajusa.fr</a>"
        }
      },
      alt_images: {
        contacto_ajusa: "ajusa contact",
        trabajar_ajusa: "work with us ajusa"
      },
      phone: "+44 (0)195 2608 771",
      email: "info@ajusa.co.uk"
    },
    trabaja_con_nosotros: {
      intro: {
        titulo: "<span class='bold'>work</span> with us",
        texto:
          "We work to grow every day. If you want to form part of our ever larger family, fill in this form and attach your curriculum."
      },
      texto:
        "At Ajusa, we work to grow every day, if you want to form part of our ever larger family, fill in this form and attach your curriculum.",
      boton: "submit curriculum"
    },
    formulario: {
      nombre: "Given name(s)",
      nombre_apellidos: "First and last name",
      apellidos: "Surname(s)",
      email: "Email",
      mensaje: "Message",
      fecha_nacimiento: "Date of birth",
      dia: "Day",
      mes: "Month",
      anyo: "Year",
      area_interes: "Area of interest",
      trabaja_actualmente: "Are you currently employed?",
      motivo: "Choose one of the following",
      si: "Yes",
      no: "No",
      carta_presentacion: "Covering letter",
      tipos_contacto: {
        general: "General, contact, branches",
        comercial: "Commercial",
        formacion: "Training",
        asistencia_tecnica: "Technical Assistance",
        catalogo: "Request a printed catalogue",
        webinar: "Request Webinar"
      },
      meses: {
        enero: "January",
        febrero: "February",
        marzo: "March",
        abril: "April",
        mayo: "May",
        junio: "June",
        julio: "July",
        agosto: "August",
        septiembre: "September",
        octubre: "October",
        noviembre: "November",
        diciembre: "December"
      },
      archivo_adjunto: "Attach file",
      adjuntar_cv: "Attach CV",
      empresa: "Company name",
      sector: "Sector",
      formulario: "Complete address (indicate town and postcode)",
      referencia: "Product reference ",
      introduce_mail: "Indicate your email address",
      tipo_catalogo: "Type of catalogue",
      pais: "Country",
      ciudad: "City",
      telefono: "Telephone",
      direccion: "Address",
      quiero_recibir:
        "I would like to receive news and information about Ajusa.",
      acepto_comunicaciones:
        "I agree to receive the newsletter or other communications from your company.",
      otros_procesos:
        "I would like to be kept in mind for other selection processes at Ajusa that might be of interest",
      he_leido:
        "I consent to the use my data for the purposes indicated in the",
      y_acepto: "Privacy Policy",
      enviar_comentario: "Send your comment",
      comentario_enviado: "Comment sent",
      enviar: "Send",
      enviado: "Sent",
      popup: {
        claim: "Click here to view and agree to the privacy policy",
        intro: "BASIC DATA PROTECTION INFORMATION",
        textos: [
          {
            titulo: "Data controller",
            texto: "Auto Juntas SAU"
          },
          {
            titulo: "Address of the data controller",
            texto:
              "Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02008, Albacete (Albacete)"
          },
          {
            titulo: "Purpose",
            texto:
              "Your details will be used to process your requests and provide you with our services."
          },
          {
            titulo: "Advertising",
            texto:
              "We will only send you advertising if you authorize it in advance. You can do this by marking the corresponding box on the form."
          },
          {
            titulo: "Legal Authority",
            texto:
              "We will only process your details with your prior consent. You can do this by marking the corresponding box on the form."
          },
          {
            titulo: "Intended recipients",
            texto:
              "Generally speaking, only duly authorized personnel at our company will be able to access the information we request from you."
          },
          {
            titulo: "Rights",
            texto:
              "You are entitled to know what information we hold about you, correct it and have it deleted, as explained in the additional information available on our web site."
          },
          {
            titulo: "Additional Information",
            texto:
              "Further information is available in the “YOUR DATA SECURE” section of our web site."
          }
        ],
        boton: "Understood"
      },
      thank_you: {
        title: "SENT!",
        text:
          "<p>Thank you! Form has been successfully submitted.</p><p>We will contact you as soon as possible.</p>",
        btn_text: "BACK TO HOME"
      }
    },
    error_404: {
      intro: "<span class='bold'>PAGE</span> NOT FOUND",
      nombre: "Error 404",
      texto:
        "Sorry! The page you are trying to access is no longer available or has been moved.",
      boton: "Back to home page"
    },
    newsletter: {
      titulo: "Subscribe to our newsletter",
      texto:
        "Receive all the latest news about the automobile sector and AJUSA's announcements.",
      suscripcion_ok:
        "You have been signed up correctly! From now on you will be kept up to date with all the latest news from Ajusa"
    },
    footer: {
      siguenos: "Follow us",
      en_redes: "Follow us on social media",
      twitter: "Follow us on X",
      facebook: "Follow us on Facebook",
      instagram: "Follow us on Instagram",
      canal: "Sign up for our channel",
      selecciona_idioma: "Select a language",
      alt_image: "ajusa certificates"
    },
    popupApp: {
      title: "Download AJUSA Mobile",
      description: "All information about our products."
    },
    popupretenes: {
      title: "New catalogue shaft seal kits",
      boton: "Download it!  "
    },
    popupjuntas: {
      novedades: "NOVELTY",
      title: "SPECIAL GASKET SET CATALOGUE",
      texto: "for different engine parts",
      boton: "CATALOGUE"
    },
    popupajustick: {
      title: "NEW PRODUCT",
      description: "ANAEROBIC SEALANT AJUSTICK",
      boton: "PRODUCT"
    },
    otras_secciones: {
      catalogo: {
        titulo: "catalogue",
        texto:
          "The easiest way to find the part you need for your vehicle and its reference. The AJUSA catalogue contains applications for all European and Asian vehicles manufacturers. You can consult it online or request a printed catalogue.",
        boton_texto: "Go to the catalogue"
      },
      area_tecnica: {
        titulo: "Consultancy",
        texto:
          "The <span class='bold'>AJUSA technical assistance</span> department is waiting to hear from you. Our colleagues handle all your questions personally. In addition, you can consult our <span class='bold'>technical report guides and our video tutorials</span> to see step-by-step explanations on how to fit our products.",
        boton_texto: "Need some help?"
      },
      sala_prensa: {
        titulo: "Press room",
        texto:
          "Consult the materials Ajusa has placed at your disposal as well as the latest news and the annual round-up of AJUSA's media appearances in the automobile sector.",
        boton_texto: "VIEW MATERIALS"
      },
      solicite_catalogo: {
        titulo: "Request a printed catalogue",
        texto:
          "We make vehicle repair easy. You can request hard copies of our general catalogue or our turbo catalogue. Send in your request indicating which catalogue you are interested in.",
        boton_texto: "request"
      },
      actualidad: {
        titulo: "Latest news",
        texto:
          "We want to keep you up to date with our news and keep you informed about the latest novelties. Visit our blog, sign up for our newsletter or follow us on the social media. We share our experiences!",
        boton_texto: "LOOKING FORWARD TO SEEING YOU"
      },
      donde_estamos: {
        titulo: "where to find us",
        texto:
          "We are wherever you need us. We have official distributors located around the globe and branch offices in Mexico, Brazil, Russia and Great Britain. Our factory and main headquarters, where we carry out all the development work, is in Albacete (Spain). ",
        boton_texto: "Contact us"
      }
    },
    banner_cookies:
      "A cookie is a small data file that is stored in your browser each time you visit our website. Cookies are useful to save the history of your activity on our website so that when you visit it again, it can identify you and display its content based on your browsing habits, identity and preferences. Cookies can be accepted, rejected, blocked and deleted as desired. If you decide to reject them, we cannot guarantee the correct operation of our website. More information in the section <router-link to='/cookies-policy'>cookies policy</router-link>.",
    boton_aceptar: "Allow",
    historia_infografia: {
      celebracion50:
        '<p>50th Anniversary</p><p class="second-line">Celebration </p>',
      celebracion50descripcion:
        "On November 11th, 2022, we gathered all our employees in the Teatro Circo of Albacete to celebrate our 50 years of history.",
      video: "VIDEO",
      galeria: "IMAGE GALLERY",
      noticias: "NEWS",
      urlNoticias:
        "https://ajusa.online/en/blog/news/ajusa-celebrates-50-anniversary",
      urlVideoIntro: "/static/img/historia_infografia/intro.mp4",
      Anios50: "<strong>50 </strong> YEARS",
      excedencia: "excellence",
      enAutomocion: "of automotive",
      albacete: "<strong>ALBACETE,</strong>",
      laCuidad: "the city that saw ",
      crecer: "us thrive",
      mayorAntesDeTiempo: "Old before his time",
      textMayor:
        "<strong>He was the fifth of six siblings. At the age of 9 he lost his mother and at 15 his father, a lorry driver by profession.</strong>",
      eraseUnaVez: "Once upon a time…",
      textEraseUnaVez:
        "Albacete, February 13, 1950. José Manuel Martínez Martínez, founder of Ajusa was born. His family situation forced him to drop out of school and he started working at the age of 13 as a sales assistant in a picture store and in a delicatessen in his neighbourhood.",
      cuentameMas: "TELL ME MORE!",
      unGestoInolvidable: "An unforgettable gesture",
      enEsteTrabajo:
        "In this job he was registered with the <strong>Social Security</strong>. This fact, something so unusual at that time, was very important for him.",
      aprendiendoElOficio: "Learning the trade…",
      con14Anios:
        "Josema discovered his true vocation at the age of 14 when he started working at the Pegaso dealership in Albacete (COMALBASA), where he was soon appointed head of the spare parts department.",
      granImplicacion: "A great commitment",
      fueronAnios:
        "These were years entailed a great deal of dedication and learning, in which he combined his military service in Seville with his work at Auto Martínez, spare parts company than he founded with his brothers.",
      fueronMeses:
        "In Seville he worked night shifts to dedicate time to Auto Martínez during the day. Such was his involvement that he spent over than <strong>50,000 pesetas a month on phone calls!</strong>",
      naceAjusa: "Ajusa is founded",
      suEspiritu:
        "His entrepreneurial spirit was fostered by his passion for the automotive industry and he decided to go that one step further by starting his own business. In 1972, he opened a small establishment where he started to manufacture the first engine gaskets of the Marca España (Brand Spain) trademark. ",
      naceLaCompania:
        "And just like that the industrial company (now Ajusa) was founded, a company that José Manuel Martínez presides until today.",
      miguelOliver:
        "Miguel Oliver was appointed industrial director and José Gómez the head of custom tooling craftsmanship.",
      primeraJuntas:
        "The first cylinder head gaskets were manufactured entirely by hand and with our own tooling also produced in our facilities.",
      seTardada:
        "It took approximately 3 hours to manufacture a cylinder head gasket, while nowadays approximately 1000 cylinder head gaskets can be produced in 3 hours.",
      primeraEtapa:
        "During this first stage, materials such as asbestos were used. Ajusa was the first manufacturer in the world to stop using this now banned material.",
      contanciaEsfuerzo: "Perseverance and hard work",
      josemaRecorrio:
        "<strong>Josema visited practically every city in Spain. Upon his arrival somewhere he would pick up the telephone directory and call all the workshops and spare parts stores one by one until he could personally present the Ajusa catalogue.<br>This is how our brand became known in Spain.</strong>",
      edicion: "Edition",
      catalogoAjusa: "Ajusa Catalog",
      infoCatalogo:
        "Just one year after the founding of Ajusa and with a staff of 10 workers, the first engine gaskets catalogue was launched. At that time the catalogue only had 600 product references while today, with a staff of 800 people, it has over 200,000. ",
      verPortadas: "SEE COVERS",
      textInfo1974:
        "And just like that began the love story of Josema and Dori, who were the parents of three children: Consuelo, José Manuel y Noelia. The essence of Ajusa is based on family values and commitment.",
      amorAPrimera: "Love at first sight",
      descriptAmor:
        "The woman of this picture is Adoración Sánchez, who worked for a year in the packaging section and in the administration department. The same day she left the company, Josema called her on the phone... to ask her out on a date!",
      crecimientoImparable: "An unstoppable growth",
      text1crecimientoImparable:
        "Years went by and with hard work, sacrifice and the same enthusiasm with which it was founded, Ajusa continued its unstoppable growth, relocating to the <strong>Polígono Campollano (Campollano Industrial Estate) in Albacete</strong> and expanding its production line.",
      text2crecimientoImparable:
        "And more importantly, Josema kept intact the entrepreneurial spirit of his beginnings. While the brand's leadership in the nationa market was being established, his sights were alreadyset on internationalisation.",
      verMas: "SEE MORE",
      title1978: "From a local company...<br>to the world stage!",
      description1_1978:
        "Its early presence in the main international trade shows and ambitious export plan for the 70s enabled the company to open markets in other countries.",
      description2_1978:
        "Josema advocated and upheld his business judgement and criteria and did not succumb to the dictates of major multinationals, even turning down contracts worth millions of pesetas!",
      description3_1978:
        "In 1978, Ajusa participated in Automechanika, <strong>the most important international automobile trade show</strong> which is held every two years in Frankfurt.",
      importanteReconociento: "Major recognition!",
      espirituInnovador:
        "The innovative and entrepreneurial spirit which José Manuel Martínez showed from an incredibly young age resulted in obtaining the <strong>Gold Medal for Exports</strong> in 1981. ",
      title1980: "The cornerstones of a great company",
      description1_1980:
        "The expansion of the services offered and the increase in demand resulted in the need to have larger facilities.",
      description2_1980:
        "In 1980, Ajusa laid the foundations of its first major factory by expanding the Campollano facilities. Successively, adding square metres with the sole objective of providing the best service to professionals in the automotive sector.",
      title1992: "Business expansion",
      description1_1992:
        "The cylinder head gasket continued to be the star product, but 1992 was a strategic year in the expansion of the business with the incorporation of <strong>complete gasket sets</strong> for engines, cylinder head bolts and a comprehensive <strong>range of accessory gaskets</strong>. The machining line was also launched to manufacture hydraulic tappets and camshafts. ",
      calidadGarantizada: "Guaranteed quality",
      ajusaEmpresaPionera:
        "Ajusa was one of the pioneering companies to obtain AENOR quality certifications as per the ISO 9001 and IATF 16949 Standards in the 1990s.",
      primeraEmpresaSector:
        "It was likewise the <strong>first company in the sector</strong> to offer the customer a comprehensive kit of gaskets for the same engine.",
      title1996: "Opening of branches",
      description1_1996:
        "With the consolidation of the company, it became a reference benchmark and several branches were opened in various locations such as Los Angeles (USA), Sao Paulo (Brazil), Mexico City (Mexico), Birmingham (UK) and Limoges (France) .",
      eeuuPrimeraSucursal: "USA, first branch",
      sucursalEeuu:
        "Ajusa's branch in the United States was the first to open its doors and, like the other branches, has a warehouse with over 10,000 items in stock.",
      comprometidosSostenibilidad: "Committed to sustainability",
      infocomprometidosSostenibilidad:
        "Ajusa set up in 2002 a company dedicated to the research of hydrogen as an alternative energy: Ajusa Tecnologías del Hidrógeno (Ajusa Hydrogen Technologies). Currently, it applies the most cutting-edge technologies in the implementation of multiple projects using PEM technology.",
      title2002: "Pioneers in hydrogen technologies",
      description2002:
        "Ajusa set up in 2002 a company dedicated to the research of hydrogen as an alternative energy: <strong>Ajusa Tecnologías del Hidrógeno (Ajusa Hydrogen Technologies)</strong>.<br> Currently, it applies the most cutting-edge technologies in the implementation of multiple projects using PEM technology.",
      actualizamosLogo: "An updated logo",
      evolucionG: "Graphic evolution",
      title2008: "Ajusa Industrial Estate",
      description1_2008:
        "In 2008, without losing sight of its local roots, the production facilities located in Parque Empresarial Ajusa, were inaugurated. ",
      description2_2008:
        "A complex of 5 factories which include the different production lines and that facilitates the integration of the latest technology to ensure utmost reliability in the Ajusa product range.",
      title2014: "New production lines",
      description1_2014:
        "Ajusa's team innovative drive and the company's continuous investment in research and product development facilitated the start-up of the turbo components production line, which includes both the development of gaskets as well as the manufacture of turbo lubrication pipes.",
      description2_2014:
        "This year also saw the launch of the first edition of the turbo components catalogue. Both the production lines as well as the staff continued to grow steadily.",
      title2022: "Growing together",
      description1_2022:
        "50 years have brought <strong>new values and new products<strong> to the company, conferring it an identity with a keen sense of responsibility towards its environment. For this reason, Ajusa participates annually in various projects to collaborate and support social actions carried out by numerous associations.  ",
      description2_2022:
        "This year, with the history which precedes us, we celebrate with great responsibility our 50th anniversary, in the belief that it will be a point of reference in the history of Ajusa and likewise to that of growing together in the future.",
      verVideo: "SEE VIDEO",
      urlVideoCompl: "/static/img/historia_infografia/video-compl-ingles.mp4"
    },
    vehiculo_electrico: {
      intro_titulo: "ELECTRIC VEHICLE",
      descripcion_intro:
        "Ajusa boasts an extensive catalogue of spare parts for hybrid and electric vehicles. Furthermore, Ajusa also helps you to carry out repairs by providing explanations of each failure that you can download here and video tutorials recorded by a vehicle repair specialist.</br></br>",
      descripcion_intro2:
        "<img src='/static/img/vehiculo-electrico/triangle-exclamation-duotone.svg' style='height:20px; margin-right: 5px;' alt='icon important'/><strong>Safety measures and basic tools</strong> for repairing an electric vehicle. Click on the video!",
      catalogo: {
        titulo: "ELECTRIC MOTOR REPAIR CATALOGUE",
        descripcion:
          "In this section, you can browse our <strong>catalogue of Ajusa spare parts for hybrid and electric vehicles</strong> by searching for the car manufacturer. The documentation for each product in the Ajusa catalogue includes a description of the model's most common failures and a link to a video tutorial about how to carry out the repair."
      },
      sellado: {
        titulo: "RELIABLE ELECTRIC VEHICLE SOLUTIONS",
        descripcion:
          "As the <strong>first manufacturer of spare components for hybrid and electric vehicles in the world</strong>, we are at the cutting edge of the automobile industry. We have more than 50 years of experience as component manufacturers for the automotive industry."
      },

      material: {
        titulo: "AUDIOVISUAL TRAINING MATERIALS",
        descripcion:
          "Currently, it is not easy to find mechanics who specialise in electro-mechanics. The training materials and video tutorials that Ajusa offers will address even the <strong>most demanding training needs when it comes to hybrid and electric vehicles</strong>. With these materials, you will learn how to repair the engine/generator, battery pack or inverter/converter. All videos are available by scanning the QR code that appears on the product label."
      },
      porqueElegir: {
        titulo: "WHY AN ELECTRIC VEHICLE OR A HYBRID VEHICLE?",
        descripcion:
          "<p>There are several compelling reasons to consider <strong>electric vehicles</strong> (EV) or <strong>hybrid vehicles</strong> (HEV) when <strong>choosing a mode of transportation</strong>. Here are some key advantages of both types: </p>"
      },
      medioAmbiente: {
        titulo: "Environmental Benefits",
        descripcion:
          "<p>EVs and HEV produce zero tailpipe emissions, reducing air pollution and greenhouse gas emissions. This helps combat climate change and improve air quality.</p>"
      },
      ahorro: {
        titulo: "Lower Operating Costs",
        descripcion:
          "<p>Electricity is generally cheaper than gasoline, resulting in lower fueling costs. Additionally, EVs have fewer moving parts, which means lower maintenance expenses over time. </p><p>Hybrid vehicles combine an internal combustion engine with an electric motor, resulting in better fuel efficiency compared to traditional gasoline-only vehicles. This can lead to significant fuel savings.</p>"
      },
      experiencia: {
        titulo: "Quiet Operation",
        descripcion:
          "<p>Electric and hybric vehicles are known for their quiet and smooth operation, contributing to reduced noise pollution in urban areas.</p>"
      },
      innovacion: {
        titulo: "Range Improvements",
        descripcion:
          "<p>As battery technology advances, the range of EVs continues to increase, making them more practical for longer trips.</p>"
      },
      catalogo_vehiculo_hibrido: "HYBRID AND ELECTRIC VEHICLE CATALOGUE",
      catalogo_vehiculo_hibrido_kits:
        "All our repair kits are also available without bearings.",
      catalogo_juntas_compresor: "EV A/C COMPRESSOR CATALOG GASKET SET",
      renault: "RENAULT",
      modelo: "Model",
      ano: "Year",
      codigo_motor: "Engine Code",
      n_comprensor: "Compressor No",
      tipo_averia: "Type of Failure",
      referencias_disponibles: "Available Ajusa References",
      otras_referencias: "Other references",
      manual: "REPAIR MANUAL",
      videoReparacion: "REPAIR VIDEO",
      commercialInfo: "REQUEST COMMERCIAL INFORMATION",
      accessVideoTut: "ACCESS TO ALL VIDEO TUTORIALS",
      videos: {
        video0: {
          id: "vehiculo-electrico-2",
          videoId: "svouPU4u8jY",
          text:
            "Do you know what you need to repair an electric vehicle? In this video, we explain <strong>the safety measures and the main tools</strong> that a mechanic's workshop should have.",
          btnText: "VIDEO"
        },
        EV001900: {
          id: "AUDI",
          modelo: "AUDI E-tron 55",
          año: "2019 - 2023",
          codigoMotor: "EASA",
          referenciasDisponibles: "EV001900",
          videoId: "aM7HnIMiV8s"
        },
        EV001400: {
          id: "BMW",
          modelo: "BMW i3",
          año: "2012 - 2022",
          codigoMotor: "IB1P25B",
          referenciasDisponibles: "EV001400",
          videoId: "_krGGRnVYtI"
        },
        EV000500: {
          id: "Hyundai | Kia",
          modelo:
            "Hyundai Kona, Hyundai Kauai, Kia Niro EV, Kia E-Soul EV (III)",
          año: "2018-2023",
          codigoMotor: "EM16",
          referenciasDisponibles: "EV000500",
          videoId: "gi1Gbs3d9NA"
        },
        EV000700: {
          id: "hyundai",
          modelo: "Hyundai Ionic EV",
          año: "2016-2019",
          codigoMotor: "EM09, 88KW, 120CV",
          referenciasDisponibles: "EV000700",
          videoId: "D5RnWWK1JXM"
        },
        EV000600: {
          id: "kia",
          modelo: "Kia Soul EV (II) 81KW, 110CV",
          año: "2014-2018",
          codigoMotor: "ZD",
          referenciasDisponibles: "EV000600",
          videoId: "YJ82wEmqP5M"
        },
        EV001300: {
          id: "nissan",
          modelo: "Nissan LEAF ZE01",
          año: "2017-2022",
          codigoMotor: "EM57",
          referenciasDisponibles: "EV001300",
          videoId: "Sz-wPyY0To8"
        },
        EV001200: {
          id: "peugeot",
          modelo: "PEUGEOT E-208",
          año: "2020-",
          codigoMotor: "ZK01",
          referenciasDisponibles: "EV001200",
          videoId: "6zXy9dBiqsY"
        },
        EV000100: {
          id: "renault",
          modelo: "Renault Zoe",
          año: "2012-2018",
          codigoMotor: "5M- 450",
          referenciasDisponibles: "EV000100",
          videoId: "cI_eu063pw4"
        },
        EV000200: {
          id: "Renault | Smart",
          modelo: "Renault Zoe, Smart Fortwo W453",
          año: "Renault (2012-2019), Smart (2016-2019)",
          codigoMotor: "Renault (5AQ-601) Smart (5AL)",
          referenciasDisponibles: "EV000200",
          videoId: "ZA93lYHO_T0"
        },
        EV000300: {
          id: "tesla",
          modelo: "Tesla Model 3, Tesla Model Y",
          año: "2017-2021",
          codigoMotor:
            "1120980-00-G / 1120980-17-J / 1120990-00-J / 1672095-00-C / 1672096-00-B /1672096-00-C",
          referenciasDisponibles: "EV000300",
          videoId: "gazCfvf3N9c"
        },
        EV000400: {
          id: "tesla",
          modelo: "Tesla Model S · Tesla Model X",
          año: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          codigoMotor: "1035000-00-J",
          referenciasDisponibles: "EV000400",
          videoId: "CK5OeOPX-sM"
        },
        EV000800: {
          id: "tesla",
          modelo:
            "Tesla Model S · Tesla Model X · Mercedes B-Class B250e · Toyota RAV4 EV",
          año:
            "Tesla Model S (2012 – 2021) · Tesla Model X (2015 – 2021) · Mercedes B-Class B250e (2014 – 2017)  · Toyota RAV4 EV (2012 – 2014)",
          codigoMotor:
            "1002633-00-U / 002633-01-U / 1002633-01-U / 1025598-01-U",
          referenciasDisponibles: "EV000800",
          videoId: "JxbTKXWBRMw"
        },
/*         EV000802: {
          id: "tesla | Mercedes | Toyota",
          producto: "Coolant bypass kit",
          modelo:
            "Tesla Model S, Tesla Model X, Mercedes B-Class, Toyota Rav4 EV",
          año:
            "Tesla Model S (2012-2021), Tesla Model X (2015-2021), Mercedes (2014-2017), Toyota (2012-2014)",
          codigoMotor: "1002633-00-U, 1002633-01-U, 1025598-01-U",
          referenciasDisponibles: "EV000802",
          videoId: "d2gj_aTYW1o"
        }, */
        EV001000: {
          id: "tesla",
          modelo: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          año: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          codigoMotor: "1037000-20-A y 1037000-00-F",
          referenciasDisponibles: "EV001000",
          videoId: "gEr97ru09VQ"
        },
        EV001100: {
          id: "tesla",
          modelo: "Tesla Model 3 (2017-2025) · Tesla Model Y (2020-2025)",
          año: "Tesla Model 3 (2017-2025) · Tesla Model Y (2020-2025)",
          codigoMotor:
            "Dual Motor versions with front motor code 3D3 (also combined with 3D5, 3D6 or 3D7)",
          referenciasDisponibles: "EV001100",
          videoId: "MIVazJrPxOs"
        },
        EV000901: {
          id: "volvo",
          modelo: "Volvo V60",
          año: "2011-2018",
          codigoMotor: "D82PHEV, D87PHEV, D97PHEV y B1APHEV",
          referenciasDisponibles: "EV000901",
          videoId: "0_-WLtUpgm4"
        },
        EV001500: {
          id: "volkswagen",
          modelo: "E-Golf",
          año: "2014-2021",
          codigoMotor: "EBSA",
          referenciasDisponibles: "EV001500",
          videoId: "vv8NSjXvAlk"
        }
      },
      videosComprensor: {
        EVC00100: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012-2019",
          nComprensor: "1063369-00-G",
          referenciasDisponibles: "EVC00100",
          videoId: "A_h7O2TGtEU"
        },
        EVC00200: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012-2017",
          nComprensor: "1028398-00-E",
          referenciasDisponibles: "EVC00200",
          videoId: "71wMqdMsqHg"
        },
        EVC00300: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012",
          nComprensor: "6007380-00-C",
          referenciasDisponibles: "EVC00300",
          videoId: "Ok9Q-mgfJmw"
        },
        EVC00400: {
          id: "tesla",
          modelo: "Tesla Model X",
          año: "2015-2025",
          nComprensor: "1042442-00-D",
          referenciasDisponibles: "EVC00400",
          videoId: "5gOHPBtBtbA"
        }
      },
      hazte_experto: "BECOME AN EXPERT",
      reparacion_vehiculos: "IN HYBRID AND ELECTRIC VEHICLE REPAIR!",
      reparacion_vehiculos_descripcion:
        "Only 1% of mechanics specialise in electric vehicle repair. <strong>You can become one of them</strong> thanks to the training material that Ajusa includes with all of its components for hybrid and electric vehicles.",
      reparacion_vehiculos_descripcion_2:
        "<strong>Scan the QR code</strong> that appears on the <strong>label of each product</strong> to access a video tutorial that will guide you through the entire repair process step by step.",
      ajusa_te_lo_pone_facil: "AJUSA MAKES IT EASY FOR YOU",
      opiniones_titulo: "OPINIONS",
      opiniones: {
        opinion1: {
          cliente: "Julián Fernández | Electromecánica",
          descripcion:
            "“A practical, instructional method that helped improve my knowledge about electric vehicle mechanics. I'm also very happy with the quality of the electric vehicle components that Ajusa manufactures.”"
        },
        opinion2: {
          cliente: "Juan Soler | Taller AGR",
          descripcion:
            "“With Ajusa's video tutorials, I've learnt to carry out repairs on electric motors. I recommend these training materials to any workshop looking to learn about electric vehicle mechanics.”"
        },
        opinion3: {
          cliente: "Bienvenido Martínez | Talleres El Paso",
          descripcion:
            "“All you need to do is scan the QR code on the product label and you can access an interesting tutorial that explains how the parts are assembled. It's very simple and practical.”"
        },
        opinion4: {
          cliente: "Diego González | Garage Motor",
          descripcion:
            "“I was surprised by the professionalism of the mechanic that appears in the videos and how he was able to easily explain the motor repair and assembly step by step. These videos are very useful for any mechanic, and I will use them again for future repairs.”"
        }
      },
      dropdowns: {
        "dropdown-1": {
          title: "COMPONENTS FOR ELECTRIC CARS",
          content:
            "<p><strong>Components for electric cars</strong> include a range of specialized parts and systems designed to power and operate these vehicles. Some of the key components for electric cars are:</p><p> These components work together to make <strong>electric cars efficient</strong>, eco-friendly, and capable of providing a smooth and reliable driving experience. Advances in technology and manufacturing continue to improve these components, making electric vehicles more accessible and practical for consumers.</p><h3><strong>Electric Motor</strong></h3><p> The electric motor is the heart of an electric vehicle, responsible for converting electrical energy from the battery into mechanical power to drive the wheels. There are different types of electric motors, including AC and DC motors, each with its advantages.</p><h3><strong>Battery Pack</strong></h3><p> The battery pack stores electrical energy and supplies it to the electric motor. Lithium-ion batteries are commonly used due to their high energy density and rechargeable capabilities.</p><h3><strong>Charging System</strong></h3><p> Electric cars require a charging system to replenish the battery's energy. This includes onboard chargers and charging ports for connecting to charging stations or home chargers.</p><h3><strong>Power Electronics</strong></h3><p> Power electronics components, like inverters and converters, manage the flow of electricity between the battery and the motor. They convert DC electricity from the battery to the AC power needed by the motor.</p><h3><strong>Thermal Management System</strong></h3><p> Electric cars often have complex thermal management systems to regulate the temperature of the battery and other components, ensuring they operate efficiently and safely.</p><h3><strong>Regenerative Braking System</strong></h3><p> Many electric vehicles employ regenerative braking systems, which capture and store energy during braking to recharge the battery, improving overall energy efficiency.</p><h3><strong>Electric Vehicle Controller</strong></h3><p> This computerized system manages and controls various aspects of the vehicle's operation, including the motor, battery, and regenerative braking.</p><h3><strong>High-Voltage Wiring and Connectors</strong></h3><p> Electric cars use high-voltage wiring and connectors to transmit electrical power safely and efficiently between components.</p><h3><strong>Electric Vehicle Charging Infrastructure</strong></h3><p> Charging infrastructure, including charging stations and networks, is essential for recharging electric vehicles when away from home.</p><h3><strong>Electric Vehicle Transmission</strong></h3><p> While some electric vehicles use single-speed transmissions, others have multi-speed transmissions to optimize performance and efficiency.</p><h3><strong>Electric Vehicle In-Car Systems</strong></h3><p> Electric cars often feature specialized in-car systems and displays to provide information about battery status, range, and energy usage.</p><h3><strong>Safety Systems</strong></h3><p> Electric vehicles have safety systems designed to protect against electric shock, fire, and other potential hazards unique to electric propulsion.</p><h3><strong>Electric Vehicle Body and Frame</strong></h3><p> The body and frame of an electric car may be designed differently from traditional vehicles to accommodate the battery and electric components while maintaining safety and aerodynamics.</p><h3><strong>Tires and Suspension</strong></h3><p> Electric vehicles may have specially designed tires and suspension systems to optimize energy efficiency and handling.</p><h3><strong>Interior Components</strong></h3><p> The interior of an electric car may include unique components related to electric vehicle control and monitoring systems.</p>"
        },
        "dropdown-2": {
          title: "COMPONENTS FOR HYBRID CARS",
          content:
            "<p> <strong>Components for hybrid cars</strong> encompass a range of specialized parts and systems that enable the operation of these vehicles, combining both internal combustion engines and electric propulsion. Here are key components for hybrid cars:</p><p> These components work together to achieve improved fuel efficiency, reduced emissions, and a smoother driving experience in hybrid cars. The combination of internal combustion and electric power allows hybrid vehicles to operate efficiently in various driving conditions while reducing their environmental impact.</p><h3><strong>Internal Combustion Engine (ICE)</strong></h3><p> Hybrid vehicles are equipped with a traditional internal combustion engine (usually gasoline) to provide power when needed, particularly during high-speed driving or heavy loads.</p><h3><strong>Electric Motor</strong></h3><p> Hybrid cars feature an electric motor that works in conjunction with the internal combustion engine, providing additional power, improving fuel efficiency, and enabling electric-only operation at low speeds.</p><h3><strong>Battery Pack</strong></h3><p> A hybrid car has a smaller battery pack compared to pure electric vehicles, which stores electrical energy to power the electric motor. These batteries are typically nickel-metal hydride (NiMH) or lithium-ion.</p><h3><strong>Transmission</strong></h3><p> Hybrids often incorporate a specialized transmission, such as a continuously variable transmission (CVT) or dual-clutch transmission, to seamlessly manage power from both the engine and electric motor.</p><h3><strong>Power Electronics</strong></h3><p> Power electronics components, like inverters and converters, control the flow of electricity between the battery, electric motor, and internal combustion engine.</p><h3><strong>Regenerative Braking System</strong></h3><p> Hybrid vehicles use regenerative braking to capture and store energy during deceleration, which is then used to recharge the battery.</p><h3><strong>Hybrid Controller</strong></h3>This onboard computer system manages the coordination between the internalcombustion engine and the electric motor, ensuring efficient power distribution.<h3><strong>High-Voltage Wiring and Connectors</strong></h3><p> High-voltage electrical components require specialized wiring and connectors to transmit electricity safely and efficiently.</p><h3><strong>Electric Vehicle (EV) Mode Selector</strong></h3><p> Many hybrid cars offer a driver-selectable EV mode that allows the vehicle to operate purely on electric power for short distances.</p><h3><strong>Hybrid Battery Cooling System</strong></h3><p> To maintain optimal battery performance, a cooling system is often integrated into the hybrid vehicle's design.</p><h3><strong>Fuel Tank</strong></h3><p> Hybrid cars retain a fuel tank to store gasoline for the internal combustion engine.</p><h3><strong>Electric Vehicle Charging Port</strong></h3><p> Some hybrid models are plug-in hybrids (PHEVs), which can be charged externally to extend their electric-only range.</p><h3><strong>Exhaust System</strong></h3><p> A traditional exhaust system is included to manage emissions when the internal combustion engine is in use.</p><h3><strong>Suspension and Chassis</strong></h3><p> Hybrid vehicles may have specialized suspension and chassis components to accommodate the added weight of the battery and ensure a smooth ride.</p><h3><strong>Instrument Cluster and Displays</strong></h3><p> The dashboard often includes hybrid-specific displays to provide information on energy usage, battery charge, and efficiency.</p>"
        }
      },
      solucionesAftermarkert: "AFTERMARKET SOLUTIONS",
      subtitulo_soluciones: "FOR HYBRID AND ELECTRIC VEHICLES",
      descripcion_soluciones:
        "Ajusa is the <strong>first manufacturer in the world to specialise</strong> in the development and manufacture of spare parts for hybrid and electric vehicles. International distribution network covering more than 80 countries.",
      solicita_info: "REQUEST MORE INFORMATION",
      alt_images: {
        tag_ajusa: "ajusa label",
        juntas_electricos: "gaskets for electric vehicles"
      }
    },
    sobre_nosotros: {
      nav_options: {
        ajusa: {
          title: "ajusa",
          category: "sobre_nosotros",
          href: "ajusa"
        },
        historia: {
          title: "our history",
          category: "aniversario50",
          href: "50-anniversary"
        },
        blog: {
          title: "blog",
          category: "blog",
          href: "blog"
        },
        contacto: {
          title: "contact",
          category: "contacto",
          href: "contact"
        },
        canal_etico: {
          title: "Ethical Channel",
          redirect: "https://ajusa.canales-eticos.com"
        },
        trabaja_con_nosotros: {
          title: "work with us",
          href: "work-with-us"
        }
      }
    },
    politica_privacidad:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">DATA PROTECTION POLICY</h1><p>The Direction / Governing Body of AUTO JUNTAS SAU (hereinafter, the person responsible for the treatment), assumes the maximum responsibility and commitment to the establishment, implementation and maintenance of this Data Protection Policy, guaranteeing the continuous improvement of the data controller. the objective of achieving excellence in relation to compliance with Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and the free circulation of these data and repealing Directive 95/46 / EC (General Data Protection Regulation) (OJEU L 119/1, 04-05-2016), and Spanish legislation on the protection of personal data (Organic Law, specific sector legislation and its development regulations).</p><br><p>The Data Protection Policy of AUTO JUNTAS SAU relies on the principle of proactive responsibility, according to which the controller is responsible for compliance with the regulatory and jurisprudential framework that governs said Policy and is able to demonstrate it to the competent control authorities.</p><br><p>In this sense, the person responsible for the treatment will be governed by the following principles that should serve all its personnel as a guide and frame of reference in the processing of personal data:</p><p>1. Protection of data the design: the controller will apply, both at the time of determining the means of treatment and at the time of the treatment itself, appropriate technical and organizational measures, such as pseudonymization, designed to effectively apply the principles of data protection, such as data minimization, and integrate the necessary guarantees in the treatment.</p><p>2. Protection of data by default: the data controller will apply the appropriate technical and organizational measures in order to guarantee that, by default, only the personal data necessary for each of the specific purposes of the processing will be processed.</p><p>3. Data protection in the information life cycle: the measures that guarantee the protection of personal data will be applicable during the entire life cycle of the information.</p><p>4. Lawfulness, loyalty and transparency: personal data will be treated in a lawful, fair and transparent manner in relation to the interested party.</p><p>5. Limitation of the purpose: personal data will be collected for specific, explicit and legitimate purposes, and will not be further processed in a manner incompatible with said purposes.</p><p>6. Minimization of data: personal data will be adequate, relevant and limited to what is necessary in relation to the purposes for which they are treated.</p><p>7. Accuracy: personal data will be accurate and, if necessary, d; All reasonable measures shall be taken so that personal data that are inaccurate with respect to the purposes for which they are treated are d or rectified without delay.</p><p>8. Limitation of the conservation period: the personal data will be maintained in a way that allows the identification of the interested parties during no more time than necessary for the purposes of processing personal data.</p><p>9. Integrity and confidentiality: personal data will be treated in such a way as to ensure adequate security of personal data, including protection against unauthorized or illegal treatment and against loss, destruction or accidental damage, through the application of measures appropriate technical or organizational.</p><p>10. Information and training: one of the keys to guarantee the protection of personal data is the training and information provided to the personnel involved in their treatment. During the information life cycle, all personnel with access to data will be properly trained and informed about their obligations in relation to compliance with data protection regulations.</p><br><p>The Data Protection Policy of AUTO JUNTAS SAU is communicated to all the personnel of the data controller and made available to all interested parties.</p><br><p>As a consequence, this Data Protection Policy involves all the personnel of the data controller, who must know and assume it, considering it as their own, with each member responsible for applying it and verifying the data protection rules applicable to their activity, as well as identifying and contributing the improvement opportunities that it deems appropriate with the objective of achieving excellence in relation to compliance.</p><br><p>This Policy will be reviewed by the Directorate / Governing Body of AUTO JUNTAS SAU, as many times as deemed necessary, to adapt, at all times, to the current provisions on the protection of personal data.</p></div></div>',
    datos_seguros:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">YOUR DATA IS SECURE</h1><p class="bold">Information in compliance with the regulation of personal data protection</p><p>In Europe and Spain there are data protection rules designed to protect your personal information that is mandatory for our entity.</p><p>For this reason, it is very important for us that understand perfectly what we are going to do with the personal data we ask for.</p><p>Thus, we will be transparent and we will give you control of your data, with a simple language and clear options that will allow you to decide what we will do with your personal information.</p><p>Please, if after reading this information you have any questions, do not hesitate to ask us.</p><p>Thank you very much for your collaboration</p><p class="bold">Who are we?</p><ul><li>Legal name:<b>AUTO JUNTAS SAU</b></li><li>VAT:<b>A02007029</b></li><li>Main activity:<b>METAL</b></li><li>Our address:<b>Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02008, Albacete (Albacete)</b></li><li>Telephone:<b>967-216212</b></li><li>Email:<u><b><a href="mailto:ajusa@ajusa.es">ajusa@ajusa.es</a></b></u></li><li>Web site: www.ajusa.online</li></ul><p>For your confidence and security, we inform you that we are an entity registered in the following Commercial Register / Public Registry.</p><p>Our main activity is subject to a regime of prior administrative authorization. For your confidence and security, we provide you with the data related to this authorization and the identification of the competent body of our supervision.</p><p class="bold">What are we going to use your data for?</p><p>In general, your personal data will be used to be able to relate to you and be able to provide you with our services.</p><p>Likewise, they can also be used for other activities, such as advertising or promoting our activities.</p><p class="bold">Why do we need your data?</p><p>Your personal data is necessary to be able to relate to you and be able to provide our services. In this sense, we will put at your disposal a series of boxes that will allow you to decide in a clear and simple way about the use of your personal information.</p><p class="bold">Who Will know the information we ask?</p><p>In general, only the personnel of our entity that is duly authorized may have knowledge of the information that we request.</p><p>Similarly, may be aware of your personal information those entities that need to have access to it so that we can provide our services. For example, our bank will know your data if the payment of our services is made by card or bank transfer.</p><p>Likewise, your information will be known by public or private entities to which we are obliged to provide your personal data due to compliance with any law. To give you an example, the Tax Law requires to provide the Tax Agency with certain information about economic operations that exceed a certain amount.</p><p>In the event that, regardless of the aforementioned assumptions, we need to disclose your personal information to other entities, we will request your permission in advance through clear options that will allow you to decide in this regard.</p><p class="bold">How are we going to protect your data?</p><p>We will protect your data with effective security measures based on the risks involved in the use of your information.</p><p>For this, our entity has approved a Data Protection Policy and annual controls and audits are carried out to verify that your personal data is safe at all times.</p><p class="bold">Will we send your data to other countries?</p><p>In the world there are countries that are safe for their data and others that are not so secure. For example, the European Union is a secure environment for your data. Our policy is not to send your personal information to any country that is not safe the point of view of protecting your data.<p>In the event that, in order to provide the service, it is essential to send your data to a country that is not as safe as Spain, we will always request your permission and apply effective security measures that reduce the risks of sending your information. personal to another country.</p><p class="bold">For how long are we going to keep your data?</p><p>We will keep your data during our relationship and as long as the laws force us. Once the applicable legal deadlines have been finalized, we will proceed to eliminate them in a safe and environmentally friendly manner.</p><p class="bold">What are your data protection rights?</p><p>At any time you can contact us to know what information we have about you, rectify it if it is incorrect and eliminate it once our relationship is finished, in case this is legally possible.</p><p>You also have the right to request the transfer of your information to another entity. This right is called "portability" and may be useful in certain situations.</p><p>To request any of these rights, you must make a written request to our address, along with a photocopy of your ID, to be able to identify you.</p><p>In the offices of our entity we have specific forms to request these rights and we offer our help to complete them.</p><p>To learn more about your data protection rights, you can consult the website of the Spanish Agency for Data Protection (www.agpd.es).</p><p class="bold">Can you withdraw your consent if you change your mind at a later time?</p><p>You can withdraw your consent if you change your mind about the use of your data at any time.</p><p>For example, if you were interested in receiving advertising for our products or services, but no longer wish to receive more publicity, you can let us know through the form of opposition to the treatment available in the offices of our entity.</p><p class="bold">In case you understand that your rights have been neglected, can you file a claim?</p><p>In case you understand that your rights have been ignored by our entity, you can file a claim with the Spanish Agency for Data Protection, through one of the following means:</p><ul><li>Electronic office: www.agpd.es</li><li>Postal address: Agencia Española de Protección de Datos C/ Jorge Juan, 6 28001-Madrid</li><li>Telephone::<br>Telf. 901 100 099<br>Telf. 91 266 35 17<br></li></ul><p>To file a claim in the Spanish Agency for Data Protection does not entail any cost and the assistance of lawyer or attorney is not necessary.</p><p class="bold">Will we elaborate profiles about you?</p><p>Our policy is not to profiles about the users of our services. However, there may be situations in which, for the purpose of providing the service, commercial or otherwise, we need to develop profiles of information about you. An example could be the use of your purchase or service history to be able to offer you products or services adapted to your tastes or needs.</p><p>In this case, we will apply effective security measures that protect your information at all times unauthorized persons who intend to use it for their own benefit.</p><p class="bold">Will we use your data for other purposes?</p><p>Our policy is not to use your data for other purposes than those we have explained to you. If, however, we need to use your data for different activities, we will always request your permission in advance through clear options that will allow you to decide about it.</p></div></div>',
    politica_cookies:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">COOKIE POLICY</h1><p class="bold">Information in compliance with personal data protection regulations</p><p class="bold">- What are cookies and what do we use them for?</p><p>A cookie is a small data file that is stored in your browser every time you visit our website.</p><p>La utilidad de las cookies es guardar el historial de su actividad en nuestra página web, de manera que, cuando la visite nuevamente, ésta pueda identificarle y configurar el contenido de la misma en base a sus hábitos de navegación, identidad y preferencias.</p><p>Cookies are useful for keeping track of your activity on our website so that when you visit it again, it can identify you and set the content of your visit based on your browsing habits, identity and preferences.<br>A cookie is harmless, it does not contain any malware or malicious code (e.g. viruses, Trojans, worms, etc.) that could damage your terminal (computer, smartphone, tablet, etc.), but it does have some impact on your right to data protection, as it collects certain information concerning you (browsing habits, identity, preferences, etc.).</p><p class="bold">What information does a cookie store?</p><p>Cookies do not usually collect special categories of personal data (sensitive data). The data they store is of a technical nature, personal preferences, personalization of contents, etc.</p><p class="bold">What kind of cookies are there?</p><p>Generally speaking, there are five types of cookies:</p><ul><li><p class="bold">Technical Cookies:</p><p>These are the most basic cookies. They allow the user to navigate through a web page, platform or application and use the different options or services available, such as, for example, controlling traffic and data communication, identifying the session, accessing restricted areas, remembering the items making up an order, processing the purchase of an order, requesting registration or participation in an event, using security elements during navigation, storing content for the dissemination of videos or sound or sharing content through social media.</p></li><li><p class="bold">Customization Cookies:</p><p>These are cookies that allow the user to access the service with certain general characteristics predefined according to a series of criteria in the user\'s terminal, such as the language, the type of browser used to access the service, the regional configuration from which the service is accessed, etc.</p></li><li><p class="bold">Analytical Cookies:</p><p>These are cookies allowing the party responsible for them to monitor and analyse the behaviour of users on the websites they are linked to. The information collected through these cookies is used to measure the activity of the websites, application or platform, and for the preparation of browsing profiles for the users of these websites, applications and platforms, in order to introduce improvements based on the analysis of the data used by the users of the service.</p></li><li><p class="bold">Advertising Cookies:</p><p>These cookies allow the most efficient management possible of the advertising spaces, if any, that the party responsible has included on a web page, application or platform from which he or she provides the requested service based on criteria such as the content published or the frequency with which advertisements are displayed.</p></li><li><p class="bold">Behavioral advertising cookies:</p><p>These cookies allow the most efficient management possible of the advertising spaces, if any, that the party responsible has included on a web page, application or platform from which the requested service is provided. These cookies store information on the behavior of users, obtained through the continuous observation of their browsing habits, thus enabling them to develop a specific profile in order to display advertising based on it.</p></li></ul><p class="bold">What are own and third-party cookies?</p><ul><li><p class="bold">Own cookies:</p><p>Own cookies are those generated and managed by the party responsible for providing the service requested by the user.</p></li><li><p class="bold">Third Party Cookies:</p><p>These are generated by entities other than the party responsible (external services or suppliers, such as Google).</p></li></ul><p class="bold">What kind of cookies does our website store?</p><p>The following is a list of the types of cookies stored on our website and their purpose:</p><ul><li class="no-disc"><p class="bold">- Type of cookie</p><p>Third Party Cookies, Analytical Cookies: Google Analytics</p></li><li class="no-disc"><p class="bold">- Purpose</p><p>Monitoring and analysis of user behavior on the website. The information collected through this type of cookie is used to measure activity on websites, create browsing profiles for the users of these sites, applications and platforms, in order to make improvements based on the analysis of the data on how visitors use the service.</p></li><li class="no-disc"><p class="bold">- When and how it is stored</p><p>The cookie records the user\'s activity in real time while browsing and the data is stored in Google Analytics\' application.</p></li></ul><p>The AJUSA website also works with the Local Storage application.</p><p class="bold">What can I do with cookies?</p><p>Cookies can be deleted, accepted or blocked as you wish; for this you only need to set up your web browser accordingly.</p><p>At any time, you can prevent the installation of cookies on your computer by using the corresponding option on your browser, but in this case we cannot guarantee the correct operation of the various features on our website.</p><p>Below, we provide you with links to manage and block cookies depending on the browser you use:</p><p>Internet Explorer:<u><a href="http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10">http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10</a></u></p><p>FireFox:<u><a href="http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we">http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we</a></u></p><p>Chrome:<u><a href="https://support.google.com/chrome/answer/95647?hl=es">https://support.google.com/chrome/answer/95647?hl=es</a></u></p><p>Safari:<u><a href="https://www.apple.com/legal/privacy/es/cookies/">https://www.apple.com/legal/privacy/es/cookies/</a></u></p>You can also delete the cookies you have stored in your browser by going into the set-up options.</div></div>',
    aviso_legal:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">LEGAL ADVISE</h1><p class="bold">TERMS AND CONDITIONS</p><p>I.-<span class="bold">The use,</span>search and/or contracting of any service set forth in our Site www.ajusa.online implies the complete acceptance, without any reservations of these General Conditions, which regulate the legal relationship arising dealing processes made between users and/or customers of the Site www.ajusa.online property of Auto Juntas S.A. (hereinafter Ajusa). Customers accept these General Conditions the moment they use or purchase any product. This document may be printed to be read or saved by the customers before acceptance.</p><p>II.-<span class="bold">The present General Conditions,</span>are subject to the enforcement of the following Spanish legislation: Act 7/1998 on April 13 on Contractual General Conditions, Royal Decree-Law 1/2007 on November 16 passing a Rewritten Text on Consumers and Users Protection Act and other supplementary acts, Royal Decree 1906/1999 on the 17th of December 1999 regulating Telephone or Electronic Contracting with general conditions, Personal Data Protection Organic Law 15/1999 on December 13, and its Implementing Regulation, Retail Commerce Management Act 7/1996 on January 15, Information Society and Electronic Commerce Services Act 34/2002 on July 11.</p><p>III.-<span class="bold">Amendment of the General Conditions.</span>Ajusa shall amend these General Conditions upon reasonable notice to its customers for the purpose of improving the services and products offered through Ajusa. The amendment of the General Conditions set forth in Ajusas Site shall be understood as a notice. At all events, these General Conditions may be consulted before using any service or purchasing products.</p><p>IV.-<span class="bold">Intellectual Property</span>. All the content in this Site (including source code, images, texts, graphics, etc.) are protected by local and foreign legislation on intellectual property in force, being all rights reserved. It is strictly forbidden to reproduce any content on the Site without expressed authorization of Ajusa and right holders.</p><p>By means of purchasing any product, Ajusa doesn’t grant any right of alteration, exploitation, reproduction, distribution or public communication over such product, and reserve all these rights. The transfer of these rights shall require previous written authorization of Ajusa. Unauthorized use of the information within this Site, its resale, as well as the violation of rights over intellectual or industrial property will result in the legally established liabilities.</p><p>V.-<span class="bold">Use of the service and Liabilities.</span>Ajusa doesn’t guarantee the permanent availability of the services, being exempted any liability for damages arising the unavailability of the product due to force majeure or errors in transfer networks beyond its control. Ajusa won’t assume liability for the content of the links to Sites which are property of third parties and therefore are beyond its control.</p><p>VI.-<span class="bold">Data protection.</span>In accordance with section 5 of the Spanish Personal Data Protection Organic Law 15/1999 on December 13, Information Society and Electronic Commerce Service Act 34/2002 on July 11, Auto Juntas, S.A. (hereinafter Ajusa) informs that the personal data given in registration forms included in this site, as well as data accessed by Ajusa as a consequence of your browsing; search, request or contracting or any transaction or action made this Site will be collected and stored under legislation in force and the liability of: Auto Juntas, S.A., Parque Empresarial Ajusa. Ctra. De Ayora Km 2.2 02008. Albacete. Spain.<u><a href="mailto:social@ajusa.es.">social@ajusa.es.</a></u></p><p>The purpose of collecting and processing Personal Data through forms and contact by email on this site is to facilitate the provision of services by Ajusa through these sites, as well as providing you with information about activities and news which may be of interest.</p><p>The remittance of personal data through the forms on this Site or via email messages requiring information or services implies expressed consent of the User to process such data as well as electronic remittance of communications with information about our activities.</p><p>Therefore, the User shows expressed consent to the incorporation of Personal Data to Personal Data Files and these data to be processed by Ajusa for the purposes afore mentioned. User likewise expresses acceptance and authorization so that Ajusa may transfer Personal Data to those companies which provide services to Ajusa such as banks and insurance companies.</p><p>User guarantees that the personal data provided to Ajusa are real and assume liability of communicating any modification.</p><p>Ajusa makes available for Users the email address social@ajusa.es and the telephone (+34) 967 216 212 so that they revoke this consent. Ajusa confirms the enforcement of the regulation in force in relation to data protection, particularly Spanish Personal Data Protection Act 15/1999 on December 13 and Spanish Royal Decree 1720/2007 on December 21 implementing such law and Ajusa makes available of Customers the contact means mentioned on the last paragraph so that they exercise their rights of access, rectification, cancellation and opposition granted by the legislation in force.</p><p>VII.-<span class="bold">Security.</span>. Ajusa guarantees taken the appropriate security measures for its premises, systems and files as well as confidential processing of Personal Data under applicable legislation in force, and informs of the implementation of security measures of technical and organizational nature in order to guarantee the security of its personal data and to avoid their alteration, loss and unauthorized processing or access, taking into account the technology status, nature of the data stored and that they may face risks arising both human action and physical or natural environment. This is made under section 9 of the Spanish Personal Data Protection Organic Law and Spanish Royal Decree 1720/2007 on December 21 passing the Implementing Regulation of the Organic Law and the Spanish Information Society and Electronic Commerce Act 34/2002 on July 11.</p><p>Ajusa is committed to treat personal data confidentially and use it exclusively for the mentioned purposes.</p><p>VIII.-<span class="bold">Electronic Commerce Communications.</span>Ajusa makes available for Users, on their request through subscriptions forms for that purpose, the news, activities and information. The User may unsubscribe this communication service at any time by sending an email to:<u><a href="mailto:social@ajusa.es.">social@ajusa.es.</a></u></p><p>IX.<span class="bold">General Information.</span>Under Information Society and Electronic Commerce Services Act 34/2002 on July 11, Ajusa confirms the enforcement of the information duty under the terms provided in this regulation in order to enable both service purchasers and authorized bodies to access in a permanent, easy, direct and free way to the following information: Auto Juntas, S.A., Parque Empresarial Ajusa. Crta. De Ayora Km 2.2. 02008 Albacete. España. www.ajusa.online. Telephone: (+34) 967 216 212 Fax: 967 216 214. Registration Information in the Companies Registry: Book:311, FOLIO: 186, PAGE: AB-1504, FISCAL IDENTITY NUMBER: A-02007029.</p><p>X.<span class="bold">Information about the use of cookies.</span>The use of this site will be made at the sole and exclusive liability of User. Such liability will be extended to the use by the user or any third party, of any password o similar assigned to access the Site or any of its services.</p><p>Ajusa assumes no liability arising the content linked the Site, as long as they are not related to it and doesn’t guarantee the absence of virus or other elements which may produce alterations on hardware and software, on the documents or files of the user excluding any liability for damages to the user arising this reason.</p><p>Ajusa refuses any liability arising the wrong use of the content on these sites and reserves the right to them, erase them, establish restrictions or constrain access at any moment in a temporary or permanent way.</p><p>XII.-<span class="bold">Nullity and inefficacy of the clauses.</span>If any clause included in these General Conditions is declared null or ineffective totally or partially such nullity or inefficacy will only affect to such clause or the null or ineffective part, substituting the rest of General Conditions, considering such clause or part as erased.</p><p>XIII.-<span class="bold">Conflicts.</span>The Spanish legislation will apply to any dispute or conflict, being the Courts and Tribunals in Albacete authorized to solve all conflicts arising it.</p><p>The access to this site implies the acceptance of every condition expressed in this legal information. Ajusa shall modify or without prior notice the structure and design of the Site as well as changing or eliminating the services, contents and access and use conditions of the Site and adapt it to any legal change.</p></div></div>',
    popupCocheElectrico: {
      title: "AND NOW...<strong>COMPONENTS FOR ELECTRIC VEHICLES!</strong>",
      btnText: "VISIT"
    }
  },
  br: {
    alt_images: {
      logo_ajusa: "Ajusa",
      app_movil: "Aplicativo móvel da Ajusa",
      google_play: "Baixar o aplicativo no Google Play",
      app_store: "Baixar o aplicativo na App Store",
      telefono: "Ligar para a Ajusa",
      email: "Enviar um e-mail para a Ajusa",
      vehiculo_electrico: "Ajusa Electric Vehicle Line",
      cerrar: "Fechar",
      retenes: "Retentores de óleo Ajusa",
      ver_video: "Ver o vídeo",
      ajustick: "Ajustick, vedante anaeróbico da Ajusa",
    },
    cookieEyes: "045d3ec4b8d29118370163bd",
    recaptchaId: "6Lee-m8fAAAAABTeuBvigSTzmj9MGBqTtnldUAo8",
    isotag: "pt-BR",
    enlaces: {
      home: "/",
      productos: "produtos",
      product: "produto",
      productos_quimicos: "produtos-quimicos",
      catalogo: "catalogo",
      area_tecnica: "area-tecnica",
      asesoramiento: "consultoria",
      ajusa: "ajusa",
      actualidad: "ultimas-noticias",
      contacto: "contato",
      trabaja_con_nosotros: "trabalhe-conosco",
      donde_estamos: "contato",
      solicite_catalogo: "contato#catalogo",
      blog: "blog",
      blog_noticia: "blog/noticias",
      blog_categoria: "blog/categoria",
      categoria: "categoria",
      ferias: "feiras-comerciais",
      historia: "historia",
      nuestro_sector: "nosso-setor",
      compromiso_social: "compromisso-social",
      sala_prensa: "sala-de-imprensa",
      mapa_web: "mapa-da-web",
      politica: "politica-de-privacidade",
      politica_cookies: "politica-de-cookies",
      datos_seguros: "seus-dados-seguros",
      aviso_legal: "aviso-legal-pt",
      aniversario50: "50-anniversary",
      productos_certificados: "/static/pdf/environment-certificate.pdf",
      productos_certificados_calidad: "/static/pdf/quality-certifications.pdf",
      condiciones_venta: "/static/pdf/condiciones-de-venta-en.pdf",
      catalogo_online: "https://web.tecalliance.net/ajusa/pt/",
      catalogo_ideia: "https://baixecatalogo.com.br/catalogo/ajusa",
      vehiculo_electrico: "veiculo-eletrico",
      sobre_nosotros: "ajusa",
      bonos_ajusa: "titulos-da-ajusa",
      thank_you_page: "obrigado",
      newsletter_thank: "newsletter/obrigado",
      online_store: "https://ev-customers.ajusa.online/",
      certificado_IATF_16949: "/static/pdf/IATF-16949-en.pdf",
      certificado_ISO_9001: "/static/pdf/ISO-9001-en.pdf",
      certificado_ISO_14001: "/static/pdf/ISO-14001-en.pdf",
      textos: {
        inicio: "Início",
        productos: "Produtos",
        catalogo: "Catálogo",
        otrosCatalogos: "",
        area_tecnica: "Área técnica",
        ajusa: "Ajusa",
        actualidad: "Últimas Notícias",
        contacto: "Contato",
        sala_prensa: "Sala de Imprensa",
        blog: "Blog",
        historia: "Historia",
        tecnologias_hidrogeno: "Tecnologias de Hidrogênio",
        contacto: "Contato",
        trabaja_con_nosotros: "Trabalhe conosco",
        mapa_web: "Mapa da Web",
        condiciones_venta: "Condições de venda",
        politica_privacidad: "Politica de Privacidade",
        datos_seguros: "Seus dados Seguros",
        politica_cookies: "Politica de Cookies",
        aviso_legal: "Aviso Legal",
        catalogo_general: "Catálogo Geral",
        catalogo_turbos: "Catálogo de Componentes de Turbo",
        catalogo_juntas_compresor: "Catálogo de juntas de compressor",
        catalogo_retenes: "Catálogo Retenes",
        catalogo_juegosJuntas: "CATÁLOGO DE JOGOS DE JUNTAS ESPECIAIS",
        tec_alliance: "Catálogo online",
        catalogo_impreso: "Solicite um catálogo impresso",
        catalogo_arandelas: "Catálogo de arruelas de cobre",
        catalogo_motor_electrico: "Catálogo VE",
        catalogo_ideia: "BAIXAR CATÁLOGO IDEIA",
        catalogo_comprensorAC:
          "Conjunto de juntas de catálogo de compressor EV A/C",
        catalogo_toricas: "Catálogo de anéis de vedação",
        catalogo_retenes: "Catálogo de retentores de óleo",
        aniversario50: "50º aniversário",
        vehiculo_electrico: "Veículo elétrico",
        sobre_nosotros: "Sobre nós",
        online_store: "ÁREA DO CLIENTE VE",
        certificado_IATF_16949: "IATF 16949",
        certificado_ISO_9001: "ISO 9001",
        certificado_ISO_14001: "ISO 14001"
      },
      seo: {
        home: {
          title: "Auto peças Ajusa | Soluções de vedação do motor",
          description:
            "Ajusa é um fornecedor líder de juntas de cabeçote. Com mais de 50 anos de experiência no ramo, garantimos produtos de qualidade e confiabilidade."
        },
        productos: {
          title: "Produtos | Auto peças Ajusa",
          description:
            "Compre a melhor seleção de autopeças da ajusa.online. As nossas peças e acessórios de alta qualidade foram concebidos para o ajudar a tirar o máximo partido do seu veículo."
        },
        catalogo: {
          title: "Catálogo | Auto peças Ajusa",
          description:
            "Obtenha as juntas, vedações e peças de alta qualidade que você precisa com a Ajusa. Navegue pelo nosso catálogo de peças OEM e encontre a peça de reposição perfeita para o seu veículo."
        },
        area_tecnica: {
          title: "Área Técnica | Auto peças Ajusa",
          description:
            "Ajusa offers a range of gasket options and solutions for sealing. Find the perfect gasket for your needs with our technical area guides and products."
        },
        sobre_nosotros: {
          title: "Sobre nós | Qualidade, serviço e equipe da Auto peças Ajusa",
          description:
            "A Ajusa é fornecedora líder de juntas e retentores de qualidade premium para o mercado de reposição automotivo. Oferecemos uma ampla seleção de juntas e vedações."
        },
        aniversario50: {
          title: "Nossa História | Auto peças Ajusa",
          description:
            "Conheça a história da Ajusa Juntas - como tudo começou, como evoluiu e onde estamos agora. 50 anos de experiência na indústria de juntas automotivas."
        },
        ajusa: {
          title: "Sobre nós | Auto peças Ajusa",
          description:
            "A Ajusa é fornecedora líder de juntas e retentores de qualidade premium para o mercado de reposição automotivo. Oferecemos uma ampla seleção de juntas e vedações."
        },
        actualidad: {
          title: "Notícias de última hora | Auto peças Ajusa",
          description:
            "Receba as últimas notícias sobre juntas da Ajusa. Cobrimos todos os desenvolvimentos mais recentes em nosso setor, desde lançamentos de produtos até avanços tecnológicos."
        },
        contacto: {
          title: "Contato | Auto peças Ajusa",
          description:
            "Need help with gaskets or seals? Reach out to Ajusa auto peças for the best service and support. Our experienced team is ready to answer any questions you have"
        },
        blog: {
          title: "blog | Auto peças Ajusa",
          description:
            "O blog da AJUSA é um espaço para profissionais e especialistas da indústria automotiva, assim como para aplicadores diretos como mecânicos e oficinas. Aqui nós lhe dizemos as últimas notícias sobre AJUSA e tudo o que está acontecendo na indústria de peças automotivas.",
          toblog: true
        },
        sala_prensa: {
          title: "Press Room | Ajusa Auto peças",
          description:
            "Fique por dentro de todas as novidades e lançamentos de produtos da Ajusa. Explore nossa sala de imprensa para ler nossos comunicados à imprensa, descrições de produtos e muito mais"
        },
        trabaja_con_nosotros: {
          title: "Trabalhe conosco | Auto peças Ajusa",
          description:
            "Ajusa Gaskets is always looking for motivated, hardworking professionals to join our team. We want to hear from you. Send us your resume today."
        },
        historia: {
          title: "Nossa história | Mais de 50 anos no setor automotivo",
          description:
            "AJUSA foi fundada em 1972 em Albacete (Espanha). Ela originalmente começou a fabricação de juntas de cabeçote e agora ela desenvolve uma gama completa de componentes e vedaçoes para motores."
        },
        bonos_ajusa: {
          title: "Bônus Ajusa | 20% de desconto para a sua oficina mecânica",
          description:
            "Os bônus Ajusa oferecem 20% de desconto à sua oficina nos nossos componentes de motor. Ligue ou preencha o formulário e explicamos como você pode resgatar."
        },
        mapa_web: {
          title: "mapa da web |Auto peças Ajusa",
          description: "Mapa da web da Ajusa: acesse a partir de um único índice todos os produtos, catálogos, área técnica, sala de imprensa e as demais seções do nosso site."
        },
        politica: {
          title: "Política de Privacidade | Auto peças Ajusa",
          description:
            "A política de proteção de dados da AUTO JUNTAS SAU é baseada no princípio da responsabilidade pró-ativa, de acordo com o qual o responsável pela nevegação se responsabiliza pelo cumprimento da jurisprudencial que rege a referida política local."
        },
        politica_cookies: {
          title: "Política de Cookies | Auto peças Ajusa",
          description: "Saiba quais cookies o site da Ajusa utiliza, para que serve cada um deles e como você pode configurá-los, aceitá-los ou recusá-los no seu próprio navegador."
        },
        aviso_legal: {
          title: "Aviso legal | Auto peças Ajusa",
          description:
            "O acesso às páginas Web deste site implica a aceitação de todas as condições expressas nesta informação legal. A AJUSA pode modificar a estrutura e o design do site, bem como alterar ou remover conteúdos e condições de acesso"
        },
        datos_seguros: {
          title: "Seus dados seguros | Auto peças Ajusa",
          description:
            "Em geral, os seus dados pessoais que são fornecidos através do site AJUSA poderá ser usado para contato e prestação de atendimento ao consumidor para prestação de um melhor serviço. Ele também pode ser usado para envio de anúncios ou promoção de nossas atividades e atualizações."
        },
        vehiculo_electrico: {
          title: "Vehículo Eléctrico",
          description:
            "A Ajusa dispõe de um amplo catálogo de componentes para a reparação de viaturas híbridas e elétricas.Além disso, queremos ajudar os utilizadores a fazerem as suas reparações.Para isso, colocamos à sua disposição fichas explicativas de cada avaria(disponíveis para download nesta secção) e tutoriais em vídeo gravados por um especialista em reparação de veículos elétricos."
        },
        blog_categoria: {
          fairs: {
            title: "Feiras automotivas | Auto peças Ajusa",
            description:
              "Ajusa juntas oferece uma ampla gama de soluções em juntas para feiras e outros eventos. Nossa equipe especializada oferece produtos de qualidade e excelente atendimento ao cliente."
          },
          products: {
            title: "Produtos de blog | Auto peças Ajusa",
            descripcion: ""
          },
          "our-sector": {
            title: "Our Sector | Ajusa Auto peças",
            description: ""
          },
          "social-commitment": {
            title: "Compromisso Social | Auto peças Ajusa",
            description:
              "At Ajusa juntas we believe in doing more than manufacturing quality products. Explore our initiatives and learn how you can help us make a difference."
          }
        },
        junta_culata: {
          title: "Juntas de cabeçote MLS e FiberMax | Auto peças Ajusa",
          description:
            "Especializada na fabricação de juntas de cabeçotes desde 1972. Encontre mais de 200.000 produtos para veículos leves e industriais em nosso catálogo online.",
          keyword: "juntas da cabeça do cilindro"
        },
        junta_motor: {
          title: "Jogos de juntas completos para o motor | Auto peças Ajusa",
          description:
            "Nossos conjuntos de juntas fornecem uma opção de substituição completa para mecânicos e indivíduos. Encontre aqui todas as peças necessárias para realizar uma reparação completa de viaturas.",
          keyword: "conjuntos de juntas"
        },
        tornillos: {
          title: "Parafusos de cabeçote | Jogos completos | Auto peças Ajusa",
          description:
            "Descubra e encomende online nossos Parafusos de Cabeçote para motores, destinados para veículos de qualidade superior. Aumente o desempenho do seu motor hoje com nossos produtos.",
          keyword: "parafusos de cabeçote, parafusos da cabeça do cilindro"
        },
        retenes: {
          title: "Retentores de óleo e de válvula para motores | Ajusa",
          description:
            "Aumente a longevidade do motor com nossos retentores premium. Explore agora o desempenho a prova de vazamentos e garanta a eficiência do seu veículo com AJUSA.",
          keyword: "Retentores de óleo"
        },
        tubos_engrase: {
          title: "Tubos de lubrificação da turbina | Auto peças Ajusa",
          description:
            "Repare os componentes do seu veículo com um tubo de lubrificação da turbina de alta qualidade. Maximize seu desempenho e durabilidade. Encomende online para máxima eficiência!",
          keyword:
            "tubo de lubrificação da turbina, tubos de alimentação de óleo"
        },
        tubos_egr: {
          title: "Tubos EGR para recirculação dos gases de escape | Ajusa",
          description:
            "Reduza as emissões de óxidos de nitrogênio (NOx) da combustão interna do seu veículo com tubos Ajusa EGR.",
          keyword: "tubos EGR, obstrução"
        },
        tubos_refrigeracion: {
          title: "Tubos de arrefecimento para o motor | Auto peças Ajusa",
          description:
            "Melhore o desempenho e a durabilidade do sistema de sobrealimentação com os tubos de arrefecimento do turbo Ajusa.",
          keyword: "tubos de arrefecimento, arrefecimento"
        },
        junta_turbo: {
          title: "Kits de juntas para turbocompressor | Auto peças Ajusa",
          description:
            "Desbloqueie o verdadeiro potencial do seu veículo com nosso kits de juntas da turbina! Aumente o desempenho e libere a velocidade. Compre agora e experimente um poder incomparável.",
          keyword: "kits de juntas da turbina, kit de reparo do turbo"
        },
        productos_quimicos: {
          title: "Produtos químicos | Vedantes e lubrificantes da Ajusa",
          description:
            "Conheça nossa ampla linha de produtos químicos para veículos. Vedantes, lubrificantes de motor e trava-roscas eficientes para manter seu motor em ótimas condições.",
          keyword:
            "produtos químicos, vedantes, lubrificantes para motores, trava roscas"
        },
        taques: {
          title: "Tuchos hidráulicos para o motor | Auto peças da Ajusa",
          description:
            "Na Ajusa, oferecemos uma ampla variedade de tuchos hidráulicos para que você possa encontrar o dispositivo perfeito para o seu caso. Entre em contato conosco hoje mesmo!",
          keyword: "tuchos hidráulicos"
        },
        arbol_levas: {
          title: "Comando de válvulas para carros e caminhões | Ajusa",
          description:
            "Descubra a gama completa de comando de válvulas disponíveis na Ajusa! Aumente o desempenho do seu motor com os nossos componentes de alta qualidade, somos a sua melhor escolha para otimizar o seu veículo.",
          keyword: "Comando de válvulas"
        },
        otros: {
          title: "Outros componentes e peças para motor | Auto peças Ajusa",
          description:
            "Você está procurando por outros componentes Ajusa? Em nosso catálogo, você encontrará uma ampla variedade de juntas para outras peças do motor, como bomba d'água, válvula EGR, termostato, etc.",
          keyword: "outros componentes ajusa, juntas"
        },
        vehiculo_electrico: {
          title: "Veículo elétrico | Componentes EV da Auto peças Ajusa",
          description:
            "A Ajusa possui uma ampla variedade de componentes para carros híbridos e elétricos. Além disso, a Ajusa também ajuda você a realizar reparos, fornecendo explicações para cada falha!",
          keyword:
            "componentes para carros híbridos, componentes para carros elétricos"
        }
      }
    },
    genericos: {
      no_resultados: "Não foram encontrados resultados",
      leer_mas: "LEIA MAIS",
      paginador: {
        siguiente: "Próximo",
        anterior: "Anterior"
      }
    },
    home: {
      intro: {
        titulo: "CRESCENDO <span class='bold'>JUNTOS",
        texto:
          "AJUSA fabricou sua primeira junta de cabeçote em 1972. Atualmente possui o mais extenso <a class='bold' style='text-decoration: underline !important; cursor: pointer !important;' href='{link}' target='_blank'>catálogo de juntas</a> de motores do setor automobilístico e a mais completa gama de tubos de lubrificação de turbinas e kits de juntas da turbina.",
        boton: "Vídeo corporativo",
        video: "vjFYe_seVTk"
      },
      excelencia: {
        intro:
          "<h1 class='title title-52'>Ajusa</h1><h2 class='title title-52'>A EXCELÊNCIA<br><span class='bold'> AUTOMOTIVA</span></h2>",
        texto:
          "Uma vida cuidando de seu veículo. Líder na fabricação e distribuição mundial de peças para reposição de <span class='bold'>veículos de passeio, motores industriais e veículo elétrico.</span>"
      },
      calidad: {
        titulo: {
          first: "qualidade original",
          second: "garantida",
          third: "em todos",
          fourth: "os nossos <strong>produtos</strong>"
        },
        texto:
          "O catálogo AJUSA tem mais de 200.000 referências e é permanentemente atualizado em sua versão digital, e a cada dois anos em formato impresso."
      },
      calidad_2: {
        texto_1:
          "Inovação constante. Temos um <strong class='bold'> time de profissionais qualificados </strong> trabalhando com a mais recente tecnologia em instalações equipadas com os equipamentos mais sofisticados.",
        texto_2:
          "<strong class='bold'>Produtos de primeira linha para clientes exigentes. </strong> Cumprimos com os mais altos padrões de qualidade para todas as nossas linhas de produtos: juntas de cabeçote, jogos de juntas, parafusos de cabeçote, tubos de lubrificação da turbina, tuchos hidráulico, comandos de válvulas, selantes, lubricante montaje de motor e kits de reparo para veículos elétricos."
      },
      calidad_3: {
        titulo: "<h2 class='title title-36'>Nós fazemos a <br>diferença</h2>",
        texto:
          "Nós fornecemos um <strong class='bold'> abrangente serviço </strong> aos nossos clientes, oferecendo serviços de consultoria e assistência técnica personalizada. Filiais no México, Brasil, Reino Unido, Estados Unidos, França e distribuidores autorizados em todo o mundo. <a class='link' href='{link}' target='_blank'>Solicitar Webinar</a>"
      },
      productos: {
        titulo:
          "<h2 class='title title-26'>NOSSOS <span class='bold'>PRODUTOS</span></h2>"
      },
      destacados: {
        titulo: "DESTAQUES"
      },
      ajusa_app: {
        title: "AJUSA MOBILE"
      },
      alt_images: {
        fabricante: "fabricação e distribuição de peças",
        junta_culata: "junta de cabeçote",
        mobile_app: "ajusa mobile APP",
        tubos_engrase: "tubos de lubrificação da turbinas",
        junta_motor:
          "reposição de veículos de passeio, motores industriais e agrícolas"
      }
    },
    productos: {
      keys: {
        "juntas-cabeçote": "junta_culata",
        "juntas-cabecote": "junta_culata",
        "jogos-juntas": "junta_motor",
        parafusos: "tornillos",
        retentores: "retenes",
        "tubo-lubrificacao": "tubos_engrase",
        "tubo-egr": "tubos_egr",
        "tubos-arrefecimento": "tubos_refrigeracion",
        "juntas-turbina": "junta_turbo",
        "produtos-quimicos": "productos_quimicos",
        tuchos: "taques",
        "comandos-valvulas": "arbol_levas",
        outros: "otros"
      },
      intro: {
        titulo: "<h1 class='title title-52'>AJUSA produtos</h1>",
        texto:
          "Especialistas na fabricação de componentes para motores de combustão interna para carros e veículos industriais. Somos também líderes no desenvolvimento de peças acessórias para motores turbo."
      },
      btn_ficha_tecnica: "Informações técnicas",
      btn_ficha_seguridad: "Informações de segurança",
      junta_culata: {
        titulo: "juntas de cabeçote",
        texto:
          "As juntas de cabeçote são nossa linha de produtos tradicionais. Nós fornecemos a cobertura total para carros e veículos industriais. Juntas em MLS, FiberMax e metal-borracha.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil.pdf",
        details: {
          intro: {
            alt: "jogos de juntas",
            title: '<h1 class="title title-36">Juntas do cabeçote</h1>',
            text:
              "<p>Apresentando as <span class='bold'>juntas de cabeçote</span> de alta qualidade da Ajusa: liberando o desempenho ideal do motor.</p><p>Projetadas com precisão e trabalhadas com experiência, nossas juntas de cabeçote são projetadas para <span class='bold'>fornecer desempenho e confiabilidade superiores.</span> Este é um componente crítico que veda o cabeçote ao bloco do motor, garantindo uma combustão eficiente e preservando a integridade da câmara de combustão.</p><p>Essa vedação vital desempenha um papel fundamental na prevenção do vazamento de gases, óleo e refrigerante,<span class='bold'>otimizando assim o desempenho geral do motor.</span> As peças são meticulosamente trabalhadas para suportar temperaturas extremas, diferenciais de pressão e vários ambientes químicos, tornando-as ideais para motores padrão e de alto desempenho de veículos leves e industriais.</p>",
            btn_text: "CATÁLOGO ON-LINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/junta-culata-1.webp",
                alt: "juntas de cabeçote ajusa"
              },
              {
                img: "/static/img/products/junta-culata-2.webp",
                alt: "catalogo  juntas de cabeçote"
              },
              {
                img: "/static/img/products/junta-culata-3.webp",
                alt: "juntas em MLS"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Conheça mais sobre os materiais de fabricação",
              content:
                "<p>Nossas juntas de cabeçote são fabricadas com materiais de alta qualidade, como aço multicamada (MLS), grafite ou elastômero, sob medida para atender às exigências específicas de cada motor. Esses materiais possuem excelentes propriedades de vedação,<span class='bold'> vedando efetivamente a câmara de combustão</span></p><p>A compatibilidade do motor é fundamental, e é por isso que nossas juntas são projetadas para combinar com motores a gasolina ou diesel, garantindo desempenho e confiabilidade ideais.</p>"
            },
            "tip-2": {
              title: "Juntas de cabeça de cilindro de longa duração",
              content:
                "<p>A durabilidade é uma característica chave de todos os nossos produtos. Entendemos as demandas impostas aos motores modernos e nossas juntas de cabeçote são construídas para suportar condições extremas. Com <span class='bold'>excepcional resistência ao calor, pressão e exposição a produtos químicos, </span>são adequados para manter sua integridade por períodos prolongados, reduzindo a necessidade de trocas frequentes.</p><p>Ao fornecer uma vedação hermética entre o cabeçote e o bloco do motor, nossas juntas contribuem para melhorar a eficiência da combustão, o que se traduz em maior economia de combustível, emissões reduzidas e melhor desempenho geral do motor.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Quais são os sintomas de junta de cilindro ruim?",
              content:
                "<p>Uma junta de cabeçote defeituosa pode dar origem a uma série de sintomas que indicam possíveis problemas no motor de um veículo.</p><p>Uma das principais indicações de uma peça problemática é o superaquecimento do motor. Quando a junta falha, pode causar vazamento de refrigerante na câmara de combustão, interrompendo o sistema de resfriamento do motor e levando ao superaquecimento, o que pode resultar em danos significativos se não for tratado imediatamente.</p><p>Outro sintoma a ser observado é a perda de refrigerante sem vazamentos visíveis. Se você precisar frequentemente reabastecer o reservatório de refrigerante ou notar uma diminuição nos níveis de refrigerante ao longo do tempo, isso pode indicar uma junta do cabeçote comprometida.</p><p>Uma peça estourada também pode se manifestar como fumaça de escapamento branca ou acinzentada. Isso ocorre quando o refrigerante penetra na câmara de combustão e é queimado junto com o combustível. A fumaça resultante pode ter um odor adocicado distinto e pode ser particularmente perceptível durante a aceleração ou ao ligar o motor.</p><p>As falhas de ignição do motor são outro sintoma significativo que você deve cuidar. Como a integridade da junta é comprometida, o processo de combustão pode ser interrompido, levando a uma marcha lenta irregular, hesitação ou uma diminuição perceptível na potência do motor durante a aceleração.</p><p>Por último, fique de olho na perda de compressão entre os cilindros, pois isso pode levar à diminuição do desempenho do motor, redução de potência e até falhas de ignição em cilindros individuais.</p>"
            },
            "dropdown-2": {
              title: "Você pode dirigir com uma junta de cabeçote queimada?",
              content:
                "<p>Definitivamente, <span class='bold'>não recomendamos</span> a condução com uma junta da cabeça do cilindro queimada porque pode ter consequências significativas para o motor do seu veículo e para o desempenho geral. É importante resolver o problema imediatamente para evitar mais danos.</p><p>Quando uma junta do cabeçote estoura, pode ocorrer diversos problemas que podem comprometer o funcionamento do motor. O líquido de arrefecimento pode vazar para a câmara de combustão, causando superaquecimento e possivelmente danificando os componentes do motor. O refrigerante também pode se misturar com o óleo do motor, reduzindo suas propriedades lubrificantes e potencialmente causando danos aos rolamentos, pistões e outras peças vitais.</p><p>Se você suspeitar de uma junta queimada ou apresentar algum dos sintomas associados, é aconselhável que seu veículo seja inspecionado por um mecânico qualificado o mais rápido possível. Recomendamos totalmente evitar dirigir o veículo até que a peça seja substituída ou reparada para evitar maiores danos e garantir a longevidade do seu motor.</p>"
            },
            "dropdown-3": {
              title: "Vale a pena trocar a junta do cabeçote?",
              content:
                "<p>Substituir uma junta da cabeça do cilindro danificada pode ser uma decisão válida, considerando as possíveis consequências de ignorar o problema. Como vimos antes, pode causar uma série de problemas que podem afetar negativamente o desempenho e a confiabilidade do seu veículo.</p><p>Embora essa substituição envolva um investimento, geralmente é mais econômica do que lidar com reparos extensos no motor. Lidar com a junta queimada desde o início pode ajudar a evitar mais danos e as despesas associadas.</p><p>Além disso, garantir a segurança do seu veículo é crucial. Uma junta da cabeça do cilindro queimada pode levar ao superaquecimento do motor, o que pode fazer com que o motor morra ou resultar em avarias em momentos inconvenientes ou até mesmo perigosos. Ao substituir a peça, você pode restaurar o funcionamento seguro e confiável do veículo.</p>"
            },
            "dropdown-4": {
              title:
                "Quanto tempo dura um carro depois de trocar a junta do cabeçote?",
              content:
                "<p>Quando a junta do cabeçote é substituída prontamente e os reparos necessários são executados corretamente, é possível que o veículo continue rodando por muitos anos. Porém, é importante observar que a vida útil de um veículo é influenciada por diversos fatores além da simples troca dessa peça de concreto.</p><p>Embora não haja um prazo definitivo, é possível que um carro dure muito tempo após a substituição da peça queimada, principalmente quando aliado a manutenção e cuidados adequados. A manutenção regular do veículo, a resolução imediata de quaisquer problemas e a prática de bons hábitos de direção são essenciais para maximizar sua vida útil.</p>"
            }
          },
          btn_more_info: {
            text: "MAIS INFORMAÇÕES"
          }
        }
      },
      junta_motor: {
        titulo: "JOGOS DE JUNTAS",
        texto:
          "Confiabilidade quando se trata de vedação de veículos. Desenvolvemos jogos completos para vedações de motores, dispondo com mais de 200.000 referências de juntas em fibra, borracha e metal-borracha.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil1.pdf",
        details: {
          intro: {
            alt: "jogo de juntas",
            title: '<h1 class="title title-36">Jogos de juntas</h1>',
            text:
              '<p>Bem-vindo à nossa coleção abrangente de <span class="bold">jogos de juntas,</span> onde oferecemos soluções de vedação de motor de alta qualidade para uma ampla gama de veículos. Como fabricante líder de componentes de motores, entendemos o papel crítico que essas peças desempenham na manutenção do desempenho ideal e da longevidade dos motores.</p><p>Na Ajusa, nos orgulhamos de nosso compromisso com a excelência, fornecendo peças de motor projetadas com precisão e <span class="bold">fabricadas com materiais de primeira qualidade.</span> Cada um dos conjuntos de juntas da nossa coleção é meticulosamente elaborado para fornecer um ajuste e vedação perfeitos para o seu motor, garantindo desempenho e durabilidade ideais.</p>',
            btn_text: "ONLINE CATALOGUE ",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/junta-motor-1.webp",
                alt: "jogos de juntas ajusa"
              },
              {
                img: "/static/img/products/junta-motor-2.webp",
                alt: "jogos completos de juntas para vedações de motores"
              },
              {
                img: "/static/img/products/junta-motor-3.webp",
                alt: "jogos completos para vedações de motores"
              },
              {
                img: "/static/img/products/junta-motor-4.webp",
                alt: "juntas para veículos industriais"
              },
              {
                img: "/static/img/products/junta-motor-5.webp",
                alt: "peças de reposição para veículos"
              }
            ]
          },
          dropdowns: {
            "dropdown-1": {
              title: "Uma grande variedade de jogos de juntas para o seu motor",
              content:
                "<p>Nossa categoria de conjuntos de juntas abrange uma ampla gama de peças, que são cuidadosamente selecionadas para incluir todos os itens necessários para uma aplicação específica do motor, agilizando o processo de reparo ou reconstrução e garantindo que você tenha tudo o que precisa em um pacote conveniente.</p><p>Ao escolher nossos produtos, você pode ficar tranquilo sabendo que está investindo em soluções premium de vedação de motores feitas para durar. Estamos empenhados em fornecer produtos que oferecem desempenho, durabilidade e valor excepcionais, tornando-nos a escolha confiável para construtores de motores e entusiastas automotivos.</p><p>Se você tiver alguma dúvida ou precisar de ajuda para encontrar o conjunto de juntas certo para sua aplicação específica, nossa equipe experiente está sempre pronta para fornecer orientação e suporte especializados.<br/>Encomende online um conjunto completo de juntas do motor Na Ajusa desenvolvemos conjuntos completos de juntas com mais de 200.000 referências para atender as mais diversas marcas e modelos de veículos. Todos eles são projetados sob um minucioso processo e fabricados em compostos de fibra, borracha e borracha-metal, que são os materiais mais resistentes e eficazes para instalação em motores de veículos.</p><p>Precisão e durabilidade são muito importantes para nós, e é por isso que nossos produtos passam por um rigoroso processo de design e desenvolvimento, seguindo rígidos padrões de qualidade. Nossa experiente equipe de engenheiros aproveita seus conhecimentos para criar juntas que oferecem desempenho de vedação excepcional e mantêm a integridade dos componentes do motor.</p>"
            },
            "dropdown-2": {
              title: "Em que consiste um kit de juntas?",
              content:
                "<p>Nosso extenso catálogo de conjuntos de juntas abrange vários itens, incluindo juntas e parafusos de cabeçote, retentores de óleo, junta da tampa dos balancins, coletores e muitos outros produtos. Cada conjunto é cuidadosamente selecionado para incluir todas as juntas necessárias para uma revisão ou reparo completo do motor.</p><p>Invista na confiabilidade e no desempenho do seu motor encomendando um conjunto completo de juntas de motor on-line da Ajusa hoje. Se você tiver alguma dúvida ou precisar de assistência, nossa experiente equipe de suporte ao cliente estará sempre disponível para fornecer orientação e suporte.</p><p>Experimente a diferença que nossos conjuntos de juntas meticulosamente desenvolvidos podem fazer no desempenho e longevidade do seu motor.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      tornillos: {
        titulo: "PARAFUSOS DE CABEÇOTE",
        texto:
          "Complementamos nosso portfólio de juntas de cabeçote com a linha mais completa dos principais jogos de parafusos no mercado.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil2.pdf",
        details: {
          intro: {
            alt: "parafusos de cabeçote",
            title: '<h1 class="title title-36">Parafusos de Cabeçote</h1>',
            text:
              "<p>Bem-vindo à nossa coleção exclusiva de parafusos de cabeçote.</p><p>Na AJUSA contamos com uma ampla seleção de parafusos minuciosamente elaborados, projetados para proporcionar ótimo desempenho e durabilidade. Esses componentes desempenham um papel crucial na criação de uma vedação perfeita entre o cabeçote e o bloco do motor, garantindo a compressão adequada e evitando vazamentos de gases de combustão ou fluídos refrigerante.</p><p>Ao manter uma conexão forte e confiável, os parafusos de cabeçote contribuem para a eficiência geral, desempenho e longevidade do motor. São componentes essenciais para manter a integridade estrutural e o funcionamento ideal da câmara de combustão do motor.</p>",
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/tornillos-1.webp",
                alt: "jogos de parafusos ajusa"
              },
              {
                img: "/static/img/products/tornillos-2.webp",
                alt: "parafusos ajusa"
              },
              {
                img: "/static/img/products/tornillos-3.webp",
                alt: "aperto angular de parafusos"
              },
              {
                img: "/static/img/products/tornillos-4.webp",
                alt: "jogos de parafusos catálogo ajusa"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Materiais premium para durabilidade excepcional",
              content:
                "<p>Obtemos nossas matérias primas de fornecedores altamente confiáveis, selecionando ligas e composições que atendem aos rigorosos padrões de qualidade das montoras. Seja aço de alta resistência, alumínio forjado ou outros materiais avançados, nossos parafusos de cabeçote são construídos para suportar as condições mais extremas.</p><p>Com esses materiais premium, você pode ter certeza de que os componentes mais importantes do seu motor permanecerão presos com segurança, evitando vazamentos e otimizando a compressão e potência do seu motor.</p>"
            },
            "tip-2": {
              title: "Parafusos de cabeçote com um desempenho confiável",
              content:
                "<p>Apoiados por um legado de resultados comprovados e uma base de clientes fiéis, nossos produtos ganharam sua reputação como a escolha certa para os profissionais mais respeitados. Inúmeros motores foram elevados a novos patamares de eficiência e potência, tudo graças ao ajuste preciso e à vedação firme fornecida por esses parafusos excepcionais.</p><p>Experimente a tranquilidade sabendo que nossos parafusos de cabeçote são projetados para suportar longos trajetos, fornecendo a robustez necessária para a operação de pico do seu motor.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Por que você deve substituir os parafusos de cabeçote?",
              content:
                "<p>A substituição dos parafusos de cabeçote é um aspecto crítico da manutenção e reparo do motor. Com o passar do tempo, essas peças sofrem desgastes, tensões e variações de temperatura, levando a um desgaste gradual e fadiga. A medida que perdem a elasticidade e a força de fixação, aumenta o risco de desenvolver problemas como vazamentos na junta de cabeçote.</p><p>Para garantir a integridade e a segurança contínuas do seu motor, é essencial a substituição dos parafusos do cabeçote. Ao instalar novos complementos de alta qualidade em seu veículo, você restaura a força de aperto necessária entre o cabeçote e o bloco do motor, restabelecendo assim uma perfeita vedação.</p>"
            },
            "dropdown-2": {
              title: "O que causa a quebra dos parafusos do cabeçote?",
              content:
                "<p>A quebra dos parafusos do cabeçote pode ser atribuída a vários fatores, principalmente relacionados às tensões e condições que eles suportam durante a operação do motor. Algumas causas comuns incluem aplicação excessiva ou desigual de torque durante a instalação do parafuso, flutuações na temperatura do motor, exposição a produtos químicos corrosivos ou até superaquecimento do motor.</p><p>A inspeção regular e a substituição dos parafusos do cabeçote durante a reforma do motor ou grandes reparos podem ajudar a identificar possíveis problemas e reduzir o risco de quebra, contribuindo para um desempenho confiável e duradouro do motor.</p>"
            }
          },
          btn_more_info: {
            text: "MAIS INFORMAÇÕES"
          }
        }
      },
      retenes: {
        titulo: "RETENTORES DE ÓLEO",
        texto:
          "Extensa gama de retentores de óleo e de válvulas para garantir a perfeita vedação do motor.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil3.pdf",
        details: {
          intro: {
            alt: "retentores de óleo",
            title: '<h1 class="title title-36">Retentores de óleo</h1>',
            text:
              "<p>Descubra a função essencial dos retentores de óleo nos veículos, um componente crítico que mantém o bom funcionamento e evita vazamentos. Essas vedações especializadas criam uma barreira firme, garantindo que os lubrificantes e fluidos permaneçam contidos, protegendo peças vitais do motor contra fricção prejudicial e prolongando a vida útil geral do seu veículo.</p><p>Na AJUSA encontrará uma vasta seleção de produtos de elevada qualidade, criteriosamente concebidas para as diversas aplicações do veículo, permitindo-lhe conduzir com confiança e tranquilidade. Experimente a diferença que nossos produtos premium fazem para melhorar o desempenho do seu veículo e proteger seu investimento a longo prazo.</p>",
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/retenes-1.webp",
                alt: "retentores de óleo ajusa"
              },
              {
                img: "/static/img/products/retenes-2.webp",
                alt: "retentores ajusa"
              },
              {
                img: "/static/img/products/retenes-3.webp",
                alt: "comandos de válvulas ajusa"
              },
              {
                img: "/static/img/products/retenes-4.webp",
                alt: "retentores de óleo e de válvulas"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "Encomende os Retentores de Óleo certos para o seu veículo",
              content:
                "<p>Fabricadas com materiais duráveis ​​que atendem ou excedem os padrões da indústria, nossas vedações são rigorosamente testadas para suportar as condições mais difíceis, garantindo um desempenho perfeito mesmo sob temperaturas e pressões extremas. Podemos garantir que o motor do seu veículo e outros componentes críticos permaneçam protegidos e funcionem de maneira ideal.</p><p>Nossa equipe de especialistas automotivos terá prazer em ajudá-lo a encontrar os retentores de óleo perfeitos para as necessidades específicas de seu veículo. Esteja você lidando com um carro compacto, um caminhão ou qualquer outro motor, temos a experiência para orientá-lo na direção da peça ideal.</p>"
            },
            "tip-2": {
              title: "Melhore o desempenho duradouro do carro",
              content:
                "<p>Não é segredo que o desempenho e a durabilidade do seu carro dependem diretamente da qualidade de suas peças. Com nossas vedações instaladas, seu motor experimentará fricção reduzida, levando a uma operação mais suave, maior eficiência de combustível e com isso um melhor desempenho geral.</p><p>Ter um carro é um investimento significativo e protegê-lo é obrigatório. Certifique-se de proteger as peças do seu veículo contra desgaste prematuro e danos, encontrando os retentores de óleo certos, prolongando sua vida útil e evitando reparos caros no futuro.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Descubra nosso extenso catálogo de retentores de óleo",
              content:
                "<p>Nosso estoque de produtos é o mais amplo que você pode encontrar em nossa área, pois temos peças para todas as marcas e modelos de veículos do mercado atual. Basta dar-nos todas as informações necessárias sobre o seu carro e procuraremos os retentores em estoque para que você tenha sempre uma peça de reposição à mão.</p><p>Com anos de experiência no setor, nossa equipe se dedica a fornecer um atendimento excepcional ao cliente. Desde selecionar os retentores de óleo corretos até responder às suas perguntas técnicas, estamos aqui para apoiá-lo em todas as etapas do processo.</p><p>Encontre on-line os vários tipos de retentores e de todos os tamanhos para atender a vários modelos e aplicações de veículos. Se necessário, entre em contato conosco para um atendimento personalizado e suporte ao cliente.</p>"
            }
          },
          btn_more_info: {
            text: "MAIS INFORMAÇÕES"
          }
        }
      },
      tubos_engrase: {
        titulo: "TUBO DE LUBRIFICAÇÃO DA TURBINA",
        texto:
          "Desenvolvemos para os novos motores turbo aspirados os tubos de lubrificação das turbinas. Catálogo de turbo AJUSA disponível.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil4.pdf",
        details: {
          intro: {
            alt: "tubo de lubrificação da turbina",
            title:
              '<h1 class="title title-36">Tubo de lubrificação da turbina</h1>',
            text:
              "<p>Projetados para otimizar o desempenho, eficiência e a durabilidade de seu motor e turbo componentes, nossos <span class='bold'>tubos de lubrificação dos turbos compressores</span> de última geração são projetados com a máxima precisão e cuidado. É o momento certo para esquecer a manutenção frequente do sistema turbo do seu carro e dar as boas-vindas a um funcionamento mais suave e ininterrupto do seu motor e turbo componentes.</p><p>A qualidade e a inovação são totalmente garantidas, pois esses tubos são construídos para suportar os ambientes mais extremos e garantir um fornecimento contínuo e consistente de óleo, protegendo seu equipamento de possíveis danos. Não se contente com menos, invista no melhor e desbloqueie o verdadeiro potencial da sua condução.</p>",
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/tubos-engrase-1.webp",
                alt: "tubos de lubrificação da turbina ajusa"
              },
              {
                img: "/static/img/products/tubos-engrase-2.webp",
                alt: "catalogo turbos ajusa"
              },
              {
                img: "/static/img/products/tubos-engrase-3.webp",
                alt: "turbo aspirados os tubos de lubrificação das turbinas"
              },
              {
                img: "/static/img/products/tubos-engrase-4.webp",
                alt: "componentes turbo ajusa"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "Encomende tubo de lubrificação da turbina altamente eficientes",
              content:
                "<p>Você está cansado de lidar com lentidão do motor e reparos caros devido ao suprimento ineficiente de óleo? Não procure mais. Forneceremos a você a solução definitiva para otimizar o desempenho do seu carro na estrada.</p><p>Esses tubo de lubrificação da turbina garantem um fluxo de óleo suave e contínuo para componentes vitais, reduzindo o atrito e o desgaste, para que você possa experimentar uma melhoria significativa, resultando em maior rendimento e tempo de inatividade minimizado.</p>"
            },
            "tip-2": {
              title: "Invista em desempenho e confiabilidade duradouros",
              content:
                "<p>Junte-se ao grupo de clientes satisfeitos que já experimentaram os notáveis ​​benefícios dos produtos AJUSA e veja como nosso produto irá transformar sua condução diária para um melhor desempenho e sucesso a longo prazo.</p><p>Faça um investimento inteligente para o futuro do seu veículo, garantindo que ele permaneça em excelentes condições nos próximos anos. O fluxo contínuo de óleo por esses tubos garante uma lubrificação ideal e um desempenho mais suave do seu turbo, graças a nossa confiável fabricação e testes de qualidade.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "O que faz o tubo de lubrificação da turbina?",
              content:
                "<p>O tubo de lubrificação da turbina desempenha um papel crucial no funcionamento de um carro. Em um motor turbo, o turbocompressor comprime o ar e o força para dentro dos cilindros do motor, resultando em maior potência e desempenho. Porém, durante esse processo, os componentes rotativos do turbocompressor requerem uma lubrificação adequada para evitar atrito e desgaste excessivos.</p><p>O tubo de lubrificação da turbina é responsável por levar o óleo do cárter do motor para o núcleo do turbocompressor. Por isso, é de extrema importância ter a tubulação livre de cinzas, sujeiras ou quaisquer outros objetos estranhos, que possam obstruir a passagem do óleo e causar danos ao turbocompressor.</p>"
            },
            "dropdown-2": {
              title: "Você pode executar um turbo sem fluxo de óleo?",
              content:
                "<p>Não, você não pode operar um turbocompressor sem fluxo de óleo. As tubulações de alimentação de óleo são essenciais para o bom funcionamento e longevidade dos componentes rotativos, como as turbinas e as rodas do compressor, que giram em altíssimas velocidades e podem causar rápido desgaste e danos se não forem devidamente lubrificadas.</p><p>As linhas de óleo são responsáveis ​​por fornecer óleo filtrado e pressurizado ao turbocompressor, garantindo que suas partes móveis permaneçam adequadamente lubrificadas e resfriadas durante a operação.</p>"
            }
          },
          btn_more_info: {
            text: "MAIS INFORMAÇÕES"
          }
        }
      },
      tubos_egr: {
        titulo: "TUBO EGR",
        texto:
          "A Ajusa oferece tubos EGR de alta qualidade que atendem às especificações dos principais fabricantes. Nossos produtos são projetados para garantir uma longa vida útil e um desempenho ideal, ajudando a manter seu veículo dentro dos padrões de emissões e garantindo uma condução mais limpa e eficiente.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "tubos egr",
            title: '<h1 class="title title-36">Tubo EGR</h1>',
            text:
              '<p>A Ajusa oferece <span class="bold">tubos EGR</span> de alta qualidade que atendem às especificações dos principais fabricantes. Nossos produtos são projetados para garantir uma longa vida útil e um desempenho ideal, ajudando a manter seu veículo dentro dos padrões de emissões e garantindo uma condução mais limpa e eficiente.</p>',
            btn_text: "CATÁLOGO ON-LINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/tubos-egr-1.webp",
                alt: "tubo egr ajusa"
              },
              {
                img: "/static/img/products/tubos-egr-2.webp",
                alt: "valvula egr ajusa"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "MANTÊM A EFICIÊNCIA DO SISTEMA DE RECIRCULAÇÃO DE GÁS DE ESCAPE",
              content:
                '<p>O tubo EGR (Recirculação de Gases de Escape) é um componente fundamental nos sistemas de <span class="bold">redução de emissões</span> dos motores de combustão interna. </p> <p>Este tubo faz parte do sistema EGR, projetado para <span class="bold">reduzir as emissões de óxidos de nitrogênio (NOx) </span> ao recircular uma parte dos gases de escape para a admissão do motor. </p>'
            },
            "tip-2": {
              title:
                "TUBOS DE ALTA QUALIDADE, PROJETADOS PARA FÁCIL INSTALAÇÃO",
              content:
                '<p>Um <span class="bold">tubo EGR</span> pode precisar de substituição quando os depósitos de carbono forem excessivos e a limpeza não for mais suficiente para restaurar a operação.</p><p> Além disso, um tubo rachado ou danificado pode causar vazamentos de gases de escape, o que afeta negativamente a eficiência do motor, bem como o controle de emissões.</p>'
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "O que é o sistema EGR?",
              content:
                "<p>O sistema EGR (Recirculação de Gases de Escape) direciona parte dos gases de escape de volta para a câmara de combustão, melhorando as emissões e reduzindo especialmente poluentes como o NOx.</p><p>Esses gases fluem desde o coletor de escape através do tubo EGR até a admissão, com o fluxo controlado pela abertura e fechamento de uma válvula EGR, gerida pela ECU, permitindo uma passagem total, parcial ou nula, conforme necessário.</p><p>Assim, o sistema EGR redireciona parte dos gases de escape de volta para a câmara de combustão através do tubo EGR, que conecta o coletor de escape ao coletor de admissão. Ao introduzir esses gases pobres em oxigênio no processo de combustão, a temperatura na câmara de combustão é reduzida, diminuindo a formação de NOx, que é uma das principais causas de poluição atmosférica e afeta a saúde humana.</p>"
            },
            "dropdown-2": {
              title: "Por que o tubo EGR é importante?",
              content:
                "<p>Com o tempo, os tubos EGR podem acumular resíduos da combustão e outros depósitos provenientes dos gases de escape, o que pode obstruir parcial ou totalmente o tubo, reduzindo a eficiência do sistema. Além disso, eles são submetidos a fadiga térmica devido às altas temperaturas dos gases e a fadiga mecânica devido às vibrações do motor. Por isso, é importante realizar manutenções periódicas, incluindo a inspeção e, se necessário, a substituição desta peça.</p><p>Os sintomas de um tubo EGR obstruído incluem perda de potência, aumento no consumo de combustível e a ativação da luz de advertência do motor (MIL).</p><p>As principais causas de um tubo defeituoso são:</p><ol><li><span class='bold'>Obstrução: </span>Os gases de escape, especialmente em motores a diesel, contêm muitos elementos resultantes da combustão, como a fuligem, que, com o tempo, podem acabar obstruindo completamente o tubo e impedindo a passagem dos gases.</li><li><span class='bold'>Ruptura: </span>Devido aos ciclos frequentes de partida e parada durante o uso do veículo, combinados com as temperaturas muito altas dos gases de escape e as vibrações do motor, podem surgir fissuras ou rupturas no tubo.</li></ol><p>Um sistema EGR não funcionará corretamente com um tubo EGR defeituoso, causando não apenas problemas no sistema anti-poluição, mas também no próprio funcionamento do motor, podendo resultar em consequências mais graves se a substituição não for feita a tempo.</p><p>Um tubo EGR pode precisar ser substituído quando os depósitos de carbono são excessivos e a limpeza já não é suficiente para restaurar seu funcionamento. Além disso, um tubo rachado ou danificado pode causar vazamentos de gases de escape, afetando negativamente tanto a eficiência do motor quanto o controle de emissões.</p><p>Se você observar alguns dos sintomas mencionados ou se seu veículo percorreu muitos quilômetros sem uma verificação do sistema EGR, recomenda-se procurar um profissional para avaliação. A instalação de um novo tubo EGR assegura um reparo perfeito, evitando o mau funcionamento do sistema e outros problemas causados por tubos defeituosos.</p>"
            },
            "dropdown-3": {
              title: "Benefícios dos Tubos EGR em bom estado",
              content:
                "<ul><li> <span class='bold'>Redução das Emissões Poluentes: </span>O funcionamento correto do sistema reduz a temperatura da combustão, diminuindo significativamente as emissões de NOx.</li><li> <span class='bold'>Conformidade com Normas Ambientais: </span>Os veículos modernos devem cumprir rigorosas regulamentações de emissões, e o sistema EGR ajuda os motores a estarem em conformidade com essas normas.</li><li> <span class='bold'>Melhora no Consumo de Combustível: </span>A recirculação dos gases contribui para otimizar o processo de combustão, promovendo um uso mais eficiente do combustível.</li><li> <span class='bold'>Maior Durabilidade do Motor: </span>Ao reduzir a temperatura na câmara de combustão, o sistema EGR diminui o estresse térmico nos componentes internos do motor, o que pode prolongar sua vida útil.</li>"
            }
          },
          btn_more_info: {
            text: "MAIS INFORMAÇÕES"
          }
        }
      },
      tubos_refrigeracion: {
        titulo: "TUBOS DE ARREFECIMENTO",
        texto:
          "Os tubos de arrefecimento do turbo conduzem o fluido refrigerante entre o motor e o turbocompressor, nos sentidos de ida e retorno. A linha de tubos de arrefecimento para turbocompressores da Ajusa cobre mais de 40 modelos de veículos de marcas líderes como Ford, VAG, Mercedes, Fiat/Alfa/Jeep, Nissan e Smart.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "tubos de arrefecimento",
            title: '<h1 class="title title-36">Tubos de arrefecimento</h1>',
            text:
              '<p>Os <span class="bold">turbocompressores</span> enfrentam um desafio constante: temperaturas extremas. Nos motores modernos, esses componentes podem atingir níveis de calor que impõem um estresse térmico brutal a todas as peças internas.</p><p>Quando a lubrificação tradicional por óleo já não é suficiente para combater essas temperaturas, surge uma solução vital: o arrefecimento líquido externo por meio de tubos de arrefecimento dedicados.</p><p>Nossa linha de tubos de arrefecimento para turbocompressores atende a mais de 40 modelos de veículos de marcas líderes, incluindo Ford, VAG, Mercedes, Fiat/Alfa/Jeep, Nissan e Smart.</p>',
            btn_text: "CATÁLOGO ON-LINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/tubos-refrigeracion-1.webp",
                alt: "tubo refrigeracion ajusa"
              },
              {
                img: "/static/img/products/tubos-refrigeracion-2.webp",
                alt: "valvula refrigeracion ajusa"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "",
              content:
                "<p>Nos veículos modernos, os sistemas de arrefecimento evoluíram para melhorar a eficiência térmica e controlar um número crescente de componentes, incluindo turbocompressores e sistemas de controlo de emissões. A maior complexidade do circuito aumenta o risco de falhas difíceis de diagnosticar e dispendiosas de reparar. Uma gestão térmica deficiente pode provocar danos graves, especialmente em turbos com arrefecimento líquido.</p>"
            },
            "tip-2": {
              title: "",
              content:
                "<p>Los tubos de refrigeración del turbocompresor deben emplearse únicamente en aplicaciones compatibles, asegurando un trazado correcto que permita la dilatación térmica sin generar tensiones.</p><p>Es imprescindible utilizar materiales y juntas adecuadas, respetar el par de apriete especificado y mantener el circuito con refrigerante homologado. No se recomienda reutilizar tubos deteriorados o envejecidos.</p><p>Tras cualquier intervención, debe verificarse la estanqueidad y realizarse un purgado completo del sistema para garantizar un funcionamiento seguro del turbocompresor.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "QUAL É A FUNÇÃO DOS TUBOS DE ARREFECIMENTO?",
              content:
                "<p>Os tubos de arrefecimento do turbo conduzem o fluido refrigerante entre o motor e o turbocompressor, nos sentidos de ida e retorno. Devem resistir a altas temperaturas, pressão e vibrações, além de serem fabricados com materiais duráveis.</p><p>Dependendo da aplicação, podem ser fabricados em aço carbono, aço inoxidável ou combinações de metal com trechos flexíveis, selecionados para oferecer elevada resistência mecânica e térmica.</p><p>Os tubos incorporam extremidades conformadas ou usinadas que permitem uma conexão precisa e estanque por meio de juntas, abraçadeiras ou conexões específicas, evitando vazamentos de fluido refrigerante mesmo em condições severas de trabalho.</p><p>Em determinadas configurações, os tubos de arrefecimento integrados a um circuito auxiliar com bomba elétrica permitem manter a circulação do fluido após o desligamento do motor. Esse sistema é essencial para dissipar o calor residual acumulado.</p><p>Esse fenômeno, conhecido como heat soak, ocorre quando o calor da turbina é transmitido ao corpo central na ausência de fluxo de refrigerante. A circulação forçada limita os picos térmicos e favorece uma redução controlada da temperatura.</p><p>Essa solução é especialmente relevante em veículos de uso severo e naqueles equipados com sistemas Start&Stop, pois reduz a degradação térmica do óleo, a formação de depósitos carbonizados e o desgaste prematuro do turbocompressor.</p>"
            }
          },
          btn_more_info: {
            text: "MAIS INFORMAÇÕES"
          }
        }
      },
      junta_turbo: {
        titulo: "KITS DE JUNTAS DA TURBINA",
        texto:
          "Oferecemos mais de 1.000 diferentes kits para turbo compressores. Cobrimos a maior parte dos turbo compressores hoje disponíveis no mercado.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "kits de juntas da turbina",
            title: '<h1 class="title title-36">Kits de juntas da turbina</h1>',
            text:
              "<p>Bem-vindo ao nosso principal destino para entusiastas de reparação que buscam atualizações de desempenho a um alto nível. Entre em um mundo de poder e precisão com nossos kits de juntas da turbina.</p><p>Concebido para levar a sua experiência de condução a novos patamares, este produto foi concebido com atenção meticulosa aos detalhes e fabricado com os melhores materiais, garantindo desempenho e fiabilidade inflexíveis.</p><p>Este kit integra-se perfeitamente em uma ampla gama de marcas e modelos, otimizando a eficiência do motor e liberando uma onda de potência como nunca. Abrace a emoção da aceleração e torque aprimorado, enquanto desfruta de uma maior economia de combustível.</p>",
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/junta-turbo-1.webp",
                alt: "catálogo de turbo ajusa"
              },
              {
                img: "/static/img/products/junta-turbo-2.webp",
                alt: "kits para turbo compressores ajusa"
              },
              {
                img: "/static/img/products/junta-turbo-3.webp",
                alt: "kits de juntas da turbina"
              },
              {
                img: "/static/img/products/junta-turbo-4.webp",
                alt: "autopeças para turboalimentado"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "Transforme sua experiência de dirigir com um kit de juntas da turbina",
              content:
                "<p>Projetado para transformar seu veículo em uma potência de desempenho e emoção, nosso Turbo Fitting Kit otimiza as capacidades do seu motor, proporcionando uma junção de potência e eficiência, levando você a novos patamares de satisfação ao conduzir seu veículo.</p><p>Sinta a confiança correndo em suas veias enquanto enfrenta cada curva com graça e precisão. É o momento certo para aumentar sua experiência de direção como nunca, pois o turbo lag reduzido garante uma resposta instantânea aos seus comandos.</p>"
            },
            "tip-2": {
              title: "Proeza e precisão de engenharia",
              content:
                "<p>Cada elemento do nosso kit de juntas da turbina é meticulosamente projetado com paixão pela perfeição, desde o design intrincado até a seleção de materiais premium para superar os mais altos padrões da indústria e suas expectativas mais exigentes.</p><p>Com as peças que compõem este kit, seu motor rugirá com uma nova força e cada giro do volante se tornará um golpe de mestre. Descubra e experimente em primeira mão a atualização definitiva para ingressar na elite da direção de alto desempenho.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Qual turbo serve no meu carro?",
              content:
                "<p>Nosso kit de juntas da turbina foi desenvolvido para uso em veículos de diversas marcas e modelos. No entanto, se tiver alguma dúvida sobre a sua integração, recomendamos que nos forneça detalhes específicos sobre o seu carro, como marca, modelo, ano e quaisquer outras especificações relevantes.</p><p>Com essas informações, nossos especialistas automotivos podem ajudá-lo a encontrar a peça perfeita, adaptada às necessidades do seu veículo. Sinta-se à vontade para entrar em contato conosco e em breve o ajudaremos a encontrar a combinação ideal para melhorar o desempenho do seu carro.</p>"
            },
            "dropdown-2": {
              title: "Que mudanças noto na minha condução?",
              content:
                "<p>Além de suas poderosas capacidades, nosso kit de juntas da turbina também impulsiona uma direção mais ecológica. Testemunhe a harmonia de potência e consciência ecológica à cada abastecimento de combustível, reduzindo a sua emissão de carbono.</p><p>Você não apenas sentirá a diferença em seu desempenho ao dirigir, mas este kit também pode prolongar a vida útil do seu motor, reduzindo o desgaste prematuro e promovendo uma combustão eficiente, o que contribui para a longevidade do seu veículo.</p>"
            }
          },
          btn_more_info: {
            text: "MAIS INFORMAÇÕES"
          }
        }
      },
      ajusil: {
        titulo: "<strong>Ajusil</strong> Selante de silicone",
        texto:
          "A melhor solução em sistemas que não utilizam juntas de vedação. Este silicone é neutro com baixo odor e seguro para sensor de oxigênio, atende às mais altas exigências em termos de confiabilidade, resistência ao calor e resistência a fluidos. Disponível em embalagens de 200 ml e 75 ml."
      },
      ajusev: {
        titulo:
          "<strong>AjusEV</strong> Selante de silicone para veículos elétricos",
        texto:
          "Selante de silicone exclusivo para veículos híbridos e elétricos. Garante uma correta vedação frente aos agentes atmosféricos externos e protege os componentes eletrônicos do veículo. Se aconselha seu uso na região de baterias e na unidade de controle de potencia (PCU). Disponivel na embalagem de 310 ml."
      },
      ajustick: {
        titulo: "<strong>Ajustick</strong>vedante anaeróbico",
        texto:
          "Vedante de componentas metálicos com superficies mecanizadas. Vedante anaeróbico (não necesita de oxigénio para a cura final) resistente a uma vasta gama de temperaturas (entre -50º e 150º C, chegando pontualmente aos 180º C). Disponível em recipientes de 50 ml."
      },
      ajulock: {
        titulo: "<strong>Ajulock</strong> Fixador de roscas",
        texto:
          "Produto mono componente anaeróbico de resistencia mediana. Desenhado para proteção das partes metálicas do motor (porcas, parafusos) do afrouxamento provocado pelas variações de temperatura e vibrações. Disponível na embalagem de 50 ml."
      },
      ajulube: {
        titulo: "<strong>Ajulube</strong> Lubricante montaje de motor",
        texto:
          "Óleo de montagem que lubrifica e protege do desgaste dos componentes mecánicos durante o arranque inicial do motor. Evita o Contato entre metais e componentes sujeitos a alta pressão: comandos de válvulas, tuchos hidráulicos, virabrequins ou pistões. Disponivel na embalagem de 100 ml."
      },
      productos_quimicos: {
        titulo: "LINHA DE PRODUTOS QUÍMICOS",
        texto:
          "Garantimos uma ótima funcionalidade a todo tipo de motores com nossa linha de químicos. Estes produtos satisfazem as maiores exigências quanto ao uso e resistência térmica. Cada produto que se adapta a distinta necessidade de cada motor.",
        ver_mas: "ver mais",
        details: {
          intro: {
            alt: "linha de produtos químicos",
            title: '<h1 class="title title-36">Produtos Químicos</h1>',
            text:
              "<p>Apresentamos nossos produtos químicos de alta qualidade projetados exclusivamente para <span class='bold'>especialistas em reparação de veículos.</span> Na AJUSA, levamos o cuidado do motor a um nível totalmente novo.</p><p>Caso você seja um mecânico profissional, nossa ampla gama de vedantes, <span class='bold'>lubrificantes de motor e fixador de roscas</span> foi cuidadosamente projetado para garantir desempenho máximo e confiabilidade incomparável para seus veículos premium.</p><p>Entre no reino da <span class='bold'>excelência automotiva</span> e descubra as soluções perfeitas para obter todo o potencial do motor.</p>",
            btn_text: "CATÁLOGO ONLINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/productos-quimicos/intro-main-quimicos.webp",
                alt: "selantes and lubricante montaje de motor"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-0.webp",
                alt: "ajusil selante de silicone 200ml"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-1.webp",
                alt: "ajusil selante de silicone 75ml"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-2.webp",
                alt: "ajusil selante de silicone"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-0.webp",
                alt: "ajusev selante de silicone para veículos elétricos"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-1.webp",
                alt: "ajusev selante de silicone para veículos elétricos 1"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-2.webp",
                alt: "ajusev selante de silicone para veículos elétricos 2"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-0.webp",
                alt: "ajustick vedante anaeróbico"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-1.webp",
                alt: "ajustick vedante anaeróbico 1"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-2.webp",
                alt: "ajustick vedante anaeróbico 2"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-0.webp",
                alt: "ajulock fixador de roscas"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-1.webp",
                alt: "ajulock fixador de roscas 1"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-2.webp",
                alt: "ajulock fixador de roscas 2"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-0.webp",
                alt: "ajulube lubricante montaje de motor"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-1.webp",
                alt: "ajulube lubricante montaje de motor 1"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-2.webp",
                alt: "ajulube lubricante montaje de motor 2"
              }
            ]
          },
          dropdowns: {
            "dropdown-1": {
              title: "Produtos químicos para a indústria automóvil",
              content:
                '<p>Seja você um mecânico profissional, um entusiasta automotivo ou um empresário em busca de soluções de alto nível, nós o cobrimos. De <span class="bold">selantes de alto desempenho e bloqueadores de roscas</span> anaeróbicos a lubrificantes de motor especializados, nossa gama de produtos químicos foi projetada para elevar seus projetos automotivos.</p><p>Com foco na qualidade, desempenho e confiabilidade, nossas soluções têm a confiança de profissionais da indústria em todo o mundo. Não importa o escopo do seu projeto, nossas soluções são versáteis, projetadas para atender a uma ampla gama de aplicações e apoiadas por tecnologia de ponta.</p><p>Junte-se aos inúmeros profissionais que confiaram a nós seus <span class="bold">projetos automotivos</span> e experimente a diferença que produtos químicos de alta qualidade podem fazer.</p>'
            },
            "dropdown-2": {
              title: "Soluções de vedação para a indústria automotiva",
              content:
                "<p>Nossos <span class='bold'>selantes foram cuidadosamente projetados</span> para criar uma barreira à prova d'água e evitar o afrouxamento nas condições mais exigentes. Nossa equipe de especialistas testou e refinou meticulosamente cada produto para garantir que eles atendam aos mais altos padrões da indústria, proporcionando tranquilidade e confiança em seus projetos.</p><p>Essas soluções de vedação são capazes de criar uma ligação forte e duradoura, garantindo que seus <span class='bold'>componentes automotivos permaneçam firmes no lugar</span>, seja evitando vazamentos, reduzindo o afrouxamento induzido por vibração ou suportando flutuações extremas de temperatura.</p>"
            },
            "dropdown-3": {
              title: "Noções básicas de lubrificação do motor para veículos",
              content:
                "<p>A <span class='bold'>lubrificação adequada</span> desempenha um papel vital para garantir o bom funcionamento, desempenho e longevidade do motor de seus veículos. Sem lubrificação adequada, os componentes experimentariam maior resistência, levando à perda de potência e diminuição do desempenho geral.</p><p>Além disso, ao criar uma película protetora de óleo entre essas partes móveis, <span class='bold'>a lubrificação minimiza o contato direto de metal com metal</span>, evitando o desgaste excessivo e a geração de calor. Priorize a manutenção regular, escolha os lubrificantes certos e desfrute de uma condução suave, eficiente e confiável.</p>"
            },
            "dropdown-4": {
              title: "Qual é o melhor fixador de roscas para carros?",
              content:
                "<p>Quando se trata de selecionar o melhor fixador de roscas para carros, o Ajulock se destaca como uma escolha de primeira linha para entusiastas e profissionais automotivos. Este produto químico é um trava roscas anaeróbico monocomponente de alto desempenho que se destaca em fornecer soluções de fixação seguras e confiáveis ​​para uma ampla gama de aplicações automotivas.</p><p>Além de suas excelentes propriedades de adesão, o <span class='bold'>Ajulock também atua como uma barreira confiável contra umidade e corrosão</span>. Ao vedar elementos nocivos, este <span class='bold'>fixador de roscas</span> ajuda a proteger seus componentes automotivos, prolongando sua vida útil e melhorando seu desempenho geral.</p>"
            }
          },
          btn_more_info: {
            text: "MAIS INFORMAÇÕES"
          }
        }
      },
      nuevo_sellante: {
        titulo: "VEDANTE ANAERÓBICO",
        texto:
          "A Ajusa lança o seu novo produto AJUSTICK para a selagem de componentes metálicos com superfícies mecanizadas. Vedante anaeróbico (não necessita de oxigénio para a sua cura final) resistente a uma vasta gama de temperaturas (entre -50º e 150ºC, alcançando 180ºC pontualmente). Disponível em embalagens de 50 ml.",
        enlace_ficha_tecnica:
          "/static/pdf/info-tecnica/info_tecnica_ajustick_pt.pdf"
      },
      taques: {
        titulo: "TUCHOS HIDRÁULICOS",
        texto:
          "Precisão e qualidade em nossos tuchos hidráulicos. Verificamos 100% de todo o processo de produção com tolerâncias a nível micrômetro.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil8.pdf",
        details: {
          intro: {
            alt: "tuchos hidraulicos",
            title: '<h1 class="title title-36">Tuchos Hidráulicos</h1>',
            text:
              "<p>Na Ajusa, somos líderes na indústria automotiva. Uma de nossas áreas de especialização está em nossa seção de usinagem avançada, onde você pode encontrar nossa gama de <span class='bold'>tuchos hidráulicos de alta qualidade</span>.</p><p>Graças à nossa vasta experiência em usinagem, temos a capacidade de projetar e <span class='bold'>fabricar tuchos hidráulicos</span> que superam os padrões mais rigorosos em termos de qualidade, desempenho e confiabilidade.</p><p>Essas peças do motor desempenham um papel crítico na operação <span class='bold'>eficiente do conjunto de válvulas de qualquer motor</span>. Elas não apenas garantem uma atuação precisa das válvulas, mas também mantêm a folga ótima necessária e proporcionam um levante hidráulico altamente eficaz.</p>",
            btn_text: "CATÁLOGO ON-LINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/taques-1.webp",
                alt: "tuchos hidráulicos ajusa"
              },
              {
                img: "/static/img/products/taques-2.webp",
                alt: "tuchos para reparação de motores"
              },
              {
                img: "/static/img/products/taques-3.webp",
                alt: "tuchos hidráulicos"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Nossa gama de tuchos hidráulicos",
              content:
                "<p>Tuchos hidráulicos são dispositivos essenciais no <span class='bold'>mundo automotivo</span>. Na Ajusa, aperfeiçoamos seu projeto e fabricação para oferecer produtos da mais alta qualidade.</p><p>Nossa ampla <span class='bold'>gama de tuchos hidráulicos</span> é projetada para atender a várias aplicações na indústria automobilística. Nossos produtos são versáteis e seguros.</p>"
            },
            "tip-2": "none"
          },
          dropdowns: {
            "dropdown-1": {
              title: "Características Técnicas dos Tuchos Hidráulicos",
              content:
                "<p>Os tuchos hidráulicos fabricados pela Ajusa são reconhecidos por sua excelência em design e desempenho. Essas <span class='bold'>peças essenciais do motor</span> incorporam várias características técnicas-chave que os diferenciam:</p><p><span class='bold'>Tecnologia hidráulica avançada</span><br>Nossos <span class='bold'>tuchos hidráulicos</span> utilizam tecnologia hidráulica de ponta para garantir uma operação suave e precisa. Isso se traduz em resposta imediata e desempenho ótimo em todos os momentos.</p><p><span class='bold'>Construção de alta qualidade</span><br>Cada tucho hidráulico é construído com materiais de alta qualidade que resistem às condições mais exigentes. Durabilidade e resistência são elementos fundamentais de nossa fabricação.</p><p><span class='bold'>Tolerâncias precisas</span><br>Nossos <span class='bold'>tuchos hidráulicos</span> são fabricados com tolerâncias extremamente rigorosas para garantir um encaixe perfeito no trem de válvulas do motor. Isso resulta em uma atuação precisa das válvulas e operação sem problemas.</p><p><span class='bold'>Desempenho em diversas condições</span><br>Nossos tuchos hidráulicos são projetados para funcionar de forma confiável em diversas condições, desde temperaturas extremas até ambientes de alta pressão. Sua capacidade de manter um desempenho consistente é uma de suas características distintivas.</p><p><span class='bold'>Instalação e manutenção fáceis</span><br>A facilidade de instalação e manutenção é uma prioridade no design de nossos tuchos hidráulicos. Isso reduz o tempo de inatividade do motor e garante uma operação eficiente.</p><p><span class='bold'>Conformidade regulatória</span><br>Todos os nossos tuchos hidráulicos estão em conformidade com os regulamentos e padrões de qualidade mais rigorosos da indústria. Isso garante segurança e confiabilidade em cada um de nossos produtos.</p>"
            },
            "dropdown-2": {
              title: "Como escolher os tuchos hidráulicos certos?",
              content:
                "<p>Escolher os <span class='bold'>tuchos hidráulicos certos</span> é uma decisão estratégica para o seu negócio e pode fazer a diferença em termos de eficiência operacional e segurança. Na Ajusa, fornecemos o melhor orientação e aconselhamento profissional para que você possa tomar decisões informadas e precisas.</p><p>Além disso, todos os nossos tuchos hidráulicos atendem aos padrões e regulamentos mais rigorosos da indústria. Consulte nosso catálogo online para encontrar a referência que seu veículo precisa.</p>"
            }
          },
          btn_more_info: {
            text: "MAIS INFORMAÇÕES"
          }
        }
      },
      arbol_levas: {
        titulo: "COMANDOS DE VÁLVULAS",
        texto:
          "Fabricamos comandos de válvulas a partir das mais modernas bancadas de nosso centro de usinagem automática, garantindo um nível de altíssima qualidade contínua.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil9.pdf",
        details: {
          intro: {
            alt: "comando de valvulas",
            title: '<h1 class="title title-36">Comando de válvulas</h1>',
            text:
              "<p>Além da nossa vasta experiência na produção de tuchos hidráulicos, o departamento industrial da Ajusa também se dedica à <span class='bold'>fabricação de comando de válvulas</span> a partir de barras de aço fundido, utilizando maquinários de retificação de última geração para alcançar níveis ótimos de precisão e eficiência.</p><p>Os <span class='bold'>comandos de válvulas</span> representam elementos críticos no sistema de abertura de válvulas de um motor, sendo responsáveis pela regulação da abertura e fecho das válvulas de admissão e escape do motor. Como resultado, desempenham um papel essencial na obtenção de um desempenho e eficiência excepcionais do motor.</p>",
            btn_text: "CATÁLOGO ON-LINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/arbol-levas-1.webp",
                alt: "árvores de cames ajusa"
              },
              {
                img: "/static/img/products/arbol-levas-2.webp",
                alt: "componentes do motor ajusa"
              },
              {
                img: "/static/img/products/arbol-levas-3.webp",
                alt: "componentes para reparação de motores"
              },
              {
                img: "/static/img/products/arbol-levas-4.webp",
                alt: "catálogo árvores de cames"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Comandos de Válvulas Ajusa: Potencialize seu motor",
              content:
                "<p>Descubra a <span class='bold'>gama completa de comandos de válvulas</span> disponíveis na Ajusa para aumentar o desempenho do seu motor. Com a nossa vasta experiência na fabricação de componentes automotivos de alta qualidade, somos a sua melhor escolha para otimizar o seu veículo.</p><p>Para facilitar a montagem do produto, a <span class='bold'>Ajusa</span> desenvolveu um <span class='bold'>manual completo de substituição dos comandos de válvulas</span>, que é incluído, juntamente com o <span class='bold'>lubrificante de montagem Ajulube</span>, em todos os seus comandos de válvulas.</p>"
            },
            "tip-2": {
              title: "A nossa variedade de comandos de válvulas",
              content:
                "<p>Na Ajusa, compreendemos que cada veículo é único. Por isso, oferecemos uma ampla gama de comandos de válvulas projetados para atender a diversas necessidades e aplicações de desempenho. Esteja à procura de uma atualização de alto desempenho ou de uma peça de qualidade OEM, temos a solução perfeita para si.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Vantagens de escolher os nossos comandos de válvulas",
              content:
                "<p>- <span class='bold'>Qualidade Inigualável</span>: Todas os nossos comandos de válvulas são fabricados de acordo com os mais elevados padrões de qualidade, garantindo durabilidade e desempenho excecionais.</p><p>- <span class='bold'>Tecnologia Inovadora</span>: Incorporamos as mais recentes inovações técnicas no design e fabricação de nossos comandos de válvulas para garantir que irá a utilizar o melhor em tecnologia automotiva.</p><p>- <span class='bold'>Desempenho Comprovado</span>: As nossas peças são submetidas a rigorosos testes de desempenho para garantir que atendem e superam as expectativas em termos de potência e eficiência.</p><p>- <span class='bold'>Ampla Compatibilidade</span>: Oferecemos comandos de válvulas para uma ampla gama de marcas e modelos de veículos, tornando fácil encontrar a peça perfeita para o seu carro.</p><p>- <span class='bold'>Garantia de Confiança</span>: Apoiamos os nossos comandos de válvulas com uma garantia sólida de desempenho, dando-lhe tranquilidade e confiança na sua escolha.</p><p>Ao escolher os comandos de válvulas <span class='bold'>da Ajusa</span>, optará pela excelência na engenharia automotiva. Potencialize o seu motor e melhore a sua experiência de condução com a qualidade e desempenho que apenas a Ajusa pode oferecer.</p>"
            },
            "dropdown-2": {
              title: "Manual de substituição dos comandos de válvulas",
              content:
                "<p>A Ajusa desenvolveu um <span class='bold'>manual completo de substituição dos comandos de válvulas</span> para facilitar este processo em motores. Este manual é incluído, juntamente com o <span class='bold'>lubrificante de montagem Ajulube</span>, em todas os seus comandos de válvulas.</p><p><span class='bold'>Passos detalhados para a desmontagem e montagem dos comandos de válvulas</span></br>A desmontagem e montagem do comando de válvulas de um motor consiste em várias etapas que devem ser seguidas com precisão. Em primeiro lugar, é necessário colocar o cilindro nº 1 no <span class='bold'>Ponto Morto Superior (PMS)</span> e verificar se o comando de válvulas está em fase.</p><p>Depois, o motor deve ser imobilizado e a correia de distribuição ou corrente, a tampa de válvulas do cilindro e os acessórios acionados pela árvore de cames devem ser removidos.</p><p>Posteriormente, é necessário desmontar a polia do comando de válvulas e os seus suportes, seguido pela desmontagem do <span class='bold'>comando de válvulas</span> e dos <span class='bold'>tuchos hidráulicos</span>. Neste ponto, é importante descartar os tuchos hidráulicos e verificar se os assentos do comando de válvulas não estão desgastados.</p><p>Caso os assentos da cabeça do cilindro estejam em mau estado, é recomendável substituir as buchas. Além disso, sugere-se lubrificar os assentos e suportes do comando de válvulas com o óleo fornecido. *</p><p>Depois, os <span class='bold'>tuchos hidráulicos</span> e a <span class='bold'>comando de válvulas</span> são montados nos seus lugares no cabeçote, colocando a polia e apertando o parafuso de fixação de acordo com as especificações. Posteriormente, a correia de distribuição ou corrente é montada, aplicando a tensão apropriada, e verifica-se manualmente se o comando de válvulas gira livremente quando o virabrequim gira.</p><p>Finalmente, o motor é verificado novamente e a tampa de válvulas e os componentes são montados na ordem inversa à desmontagem. Visite o <span class='bold'>nosso canal de mecânica no YouTube</span>, onde encontrará alguns vídeos sobre a montagem deste componente.</p>"
            }
          },
          btn_more_info: {
            text: "MAIS INFORMAÇÕES"
          }
        }
      },
      otros: {
        titulo: "OUTROS COMPONENTES",
        texto:
          "Mais de 80.000 diferentes referências de fibras, borrachas e metais-borrachas. Garantimos o mais completo reparo para seu carro, utilitário ou linha pesada - industrial.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil10.pdf",
        details: {
          intro: {
            alt: "outros componentes",
            title: '<h1 class="title title-36">Outros Componentes</h1>',
            text:
              "<p>Oferecemos produtos de vedação e <span class='bold'>outros componentes Ajusa</span> projetados para garantir o funcionamento suave do seu motor. Em nosso catálogo, você encontrará uma <span class='bold'>ampla seleção de juntas para diferentes partes do motor</span>, como a bomba d'água, válvula EGR, compressor de freio, termostato, entre outros.</p><p>Se você precisa <span class='bold'>comprar outro componente</span> daqueles que viu em nosso site para o seu motor, não hesite em nos contatar, seja você proprietário de uma oficina profissional ou um particular. Estamos aqui para responder às suas perguntas e ajudá-lo a encontrar a peça de que precisa.</p>",
            btn_text: "CATÁLOGO ON-LINE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/otros-1.webp",
                alt: "peças de reposição ajusa"
              },
              {
                img: "/static/img/products/otros-2.webp",
                alt: "juntas FiberMax"
              },
              {
                img: "/static/img/products/otros-3.webp",
                alt: "juntas metal-borracha"
              },
              {
                img: "/static/img/products/otros-4.webp",
                alt: "catálogo de juntas"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Outros Componentes e peças para o seu motor",
              content:
                "<p>Na Ajusa, sabemos que a vedação é essencial em uma <span class='bold'>variedade de componentes do motor</span>. Por isso, oferecemos uma ampla gama de soluções de vedação e outros componentes Ajusa que abrangem diferentes partes do motor.</p> "
            },
            "tip-2": "none"
          },
          dropdowns: {
            "dropdown-1": {
              title: "Catálogo de Peças",
              content:
                "<p><span class='bold'>Juntas da Bomba d'Água</span></br>Juntas projetadas para a bomba d'água são essenciais para evitar vazamentos e manter o resfriamento adequado do motor. Nossas juntas são fabricadas com precisão para garantir uma vedação perfeita.</p><p><span class='bold'>Juntas da Válvula EGR</span></br>As juntas da válvula EGR são cruciais para garantir o fluxo controlado de gases no sistema de escapamento, reduzindo as emissões e melhorando a eficiência do motor. Conte com nossas juntas para manter o funcionamento suave do seu motor!</p><p><span class='bold'>Juntas do Compressor de Freio</span></br>Outro componente Ajusa são as juntas no compressor de freio para a segurança do seu veículo. Nossas juntas de alta qualidade garantem uma vedação eficaz, que é essencial para um funcionamento confiável do sistema de freio.</p><p><span class='bold'>Juntas do Termostato</span></br>O termostato regula a temperatura do motor, e nossas juntas do termostato garantem que este componente funcione corretamente. Uma vedação ótima aqui é essencial para evitar o superaquecimento e danos ao motor. Outros componentes Ajusa disponíveis Além dessas peças mencionadas acima, oferecemos uma ampla variedade de outros componentes Ajusa para diferentes aplicações de motor.</p><p>Venha e descubra-os!</p>"
            },
            "dropdown-2": {
              title: "Características e Benefícios",
              content:
                "<p>Na <span class='bold'>Ajusa</span>, fornecemos juntas de alta qualidade e peças projetadas. Nossas peças de vedação se destacam por:</p><p>- <span class='bold'>Design preciso</span>: Cada junta é fabricada com precisão para garantir um encaixe perfeito e vedação ótima.</p><p>- <span class='bold'>Qualidade superior</span>: Utilizamos materiais da mais alta qualidade que resistem às condições mais exigentes e prolongam a vida útil do seu motor.</p><p>- <span class='bold'>Vantagens significativas</span>: Ao usar nossas soluções de vedação, você obtém desempenho confiável, eficiência aprimorada e maior vida útil do motor.</p>"
            },
            "dropdown-3": {
              title: "Qualidade e Conformidade Regulatória",
              content:
                "<p>Estamos comprometidos com a excelência na <span class='bold'>fabricação de peças de vedação e outros componentes Ajusa</span> para o seu motor. Cumprimos rigorosamente as regulamentações mais exigentes e os padrões de qualidade na indústria automobilística.</p><p>Nossas peças são sinônimo de segurança e desempenho para o seu motor.</p>"
            }
          },
          btn_more_info: {
            text: "MAIS INFORMAÇÕES"
          }
        }
      },
      garantia: {
        titulo:
          "<span class='bold'>Padrões de qualidade</span> dos produtos químicos AJUSA",
        titulo1:
          "<h2 class='title title-36'><span class='bold'>qualidade garantida</span> em todos os produtos</h2>",
        texto:
          "Todos os Produtos Químicos da AJUSA contam com as certificações TUV de acordo com as normas ISO 9001 e IATF 16949.",
        boton: "Encontre os certificados aqui",
        cumplimiento:
          "Nosso compromisso com a saúde e a segurança são fundamentais. De acordo com as diretrizes descritas no Decreto Real 396/2006 sobre regulamentos de saúde e segurança em locais de trabalho que lidam com possível exposição ao amianto, podemos orgulhosamente confirmar que nossos selantes, lubrificantes para motores e trava-roscas são totalmente isentos de amianto."
      },
      shared: {
        "junta-turbo": "montagem-de-turbo",
        ajusil: "ajusil-br",
        "arbol-levas": "comandos-de-valvulas",
        "junta-culata": "juntas-de-cabecote",
        "junta-motor": "jogos-de-juntas-completos",
        otros: "outros",
        retenes: "retentores-de-oleo",
        taques: "tuchos-hidraulicos",
        tornillos: "parafusos-de-cabecote",
        "tubos-engrase": "tubos-de-lubrificacao-de-turbina",
        "tubos-egr": "tubos-egr",
        nuevo_sellante: "vedante-anaerobico-ajustic"
      },
      titulo_banner: "Selecionar idioma",
      idiomas: {
        GE: "Alemão",
        EN: "Inglês",
        ES: "Espanhol",
        FR: "Francês",
        HU: "Húngaro",
        IT: "Italiano",
        NL: "Holandês",
        PL: "Polonês",
        PT: "Português",
        BG: "Búlgaro",
        CZ: "Tcheco",
        GR: "Grego",
        LE: "Letão",
        SL: "Esloveno",
        SE: "Sueco",
        LV: "Letão",
        SL: "Esloveno",
        SK: "Eslovaco",
        RU: "Russo",
        RO: "Romeno",
        LT: "Lituano"
      },
      nav_options: {
        vehiculo_electrico: {
          title: "Veículo elétrico",
          category: "vehiculo_electrico",
          href: "veiculo-eletrico"
        },
        junta_culata: {
          id: "juntas-cabeçote",
          title: "juntas de cabeçote",
          category: "product"
        },
        junta_motor: {
          id: "jogos-juntas",
          title: "jogos de juntas",
          category: "product"
        },
        tornillos: {
          id: "parafusos",
          title: "PARAFUSOS DE CABEÇOTE",
          category: "product"
        },
        retenes: {
          id: "retentores",
          title: "retentores de óleo",
          category: "product"
        },
        tubos_engrase: {
          id: "tubo-lubrificacao",
          title: "TUBO DE LUBRIFICAÇÃO",
          category: "product"
        },
        tubos_egr: {
          id: "tubo-egr",
          title: "tubo EGR",
          category: "product"
        },
        tubos_refrigeracion: {
          id: "tubos-arrefecimento",
          title: "tubos de arrefecimento",
          category: "product"
        },
        junta_turbo: {
          id: "juntas-turbina",
          title: "KITS DE JUNTAS DA TURBINA",
          category: "product"
        },
        productos_quimicos: {
          id: "produtos-quimicos",
          title: "PRODUTOS QUÍMICOS",
          category: "productos"
        },
        taques: {
          id: "tuchos",
          title: "tuchos hidráulicos",
          category: "product"
        },
        arbol_levas: {
          id: "comandos-valvulas",
          title: "COMANDOS DE VÁLVULAS",
          category: "product"
        },
        otros: {
          id: "outros",
          title: "outros componentes",
          category: "product"
        }
      },
      alt_images: {
        juntas_culata: "juntas de cabeçote",
        tornillos: "parafusos de cabeçote",
        tubos_engrase: "lubrificação das turbinas ajusa",
        "junta-culata-1": "juntas de cabeçote ajusa",
        "junta-culata-2": "catalogo  juntas de cabeçote",
        "junta-culata-3": "juntas em MLS",
        "junta-motor-1": "jogos de juntas ajusa",
        "junta-motor-2": "jogos completos de juntas para vedações de motores",
        "junta-motor-3": "jogos completos para vedações de motores",
        "junta-motor-4": "juntas para veículos industriais",
        "junta-motor-5": "peças de reposição para veículos",
        "tornillos-1": "jogos de parafusos ajusa",
        "tornillos-2": "parafusos ajusa",
        "tornillos-3": "aperto angular de parafusos",
        "tornillos-4": "jogos de parafusos catálogo ajusa",
        "retenes-1": "retentores de óleo ajusa",
        "retenes-2": "retentores ajusa",
        "retenes-3": "comandos de válvulas ajusa",
        "retenes-4": "retentores de óleo e de válvulas",
        "tubos-engrase-1": "tubos de lubrificação da turbina ajusa",
        "tubos-engrase-2": "catalogo turbos ajusa",
        "tubos-engrase-3":
          "turbo aspirados os tubos de lubrificação das turbinas",
        "tubos-engrase-4": "componentes turbo ajusa",
        "tubos-egr-1": "tubos egr ajusa",
        "tubos-egr-2": "valvula egr ajusa",
            "tubos-refrigeracion-1": "tubos de arrefecimento ajusa",
        "junta-turbo-1": "catálogo de turbo ajusa",
        "junta-turbo-2": "kits para turbo compressores ajusa",
        "junta-turbo-3": "kits de juntas da turbina",
        "junta-turbo-4": "autopeças para turboalimentado",
        sellantes_lubricantes: "selantes and lubricante montaje de motor",
        sellante_silicona: "ajusil selante de silicone",
        sellante_silicona_electrico:
          "ajusev selante de silicone para veículos elétricos",
        sellante_anaerobico: "ajustick vedante anaeróbico",
        lubricante_motor: "ajulock fixador de roscas",
        fijador_roscas: "ajulube lubricante montaje de motor",
        "taques-1": "tuchos hidráulicos ajusa",
        "taques-2": "tuchos para reparação de motores",
        "taques-3": "tuchos hidráulicos",
        "arbol-levas-1": "árvores de cames ajusa",
        "arbol-levas-2": "componentes do motor ajusa",
        "arbol-levas-3": "componentes para reparação de motores",
        "arbol-levas-4": "catálogo árvores de cames",
        "otros-1": "peças de reposição ajusa",
        "otros-2": "juntas FiberMax",
        "otros-3": "juntas metal-borracha",
        "otros-4": "catálogo de juntas",
        taller_electrico: "oficina de veículos elétricos"
      }
    },
    catalogo: {
      intro: {
        titulo: "AJUSA Catálogo",
        texto:
          "Você irá encontrar a peça que precisa para seu veículo no catálogo AJUSA.A maior seleção do setor automobilístico possuindo mais de 200.000 referências a sua disposição.",
        catalogo_impreso: "catálogo<br>impresso",
        catalogo_impreso_texto:
          "Podemos facilitar seu trabalho.Solicite uma cópia impressa do catálogo geral AJUSA.",
        catalogo_impreso_boton: "Solicite agora"
      },
      cat_general: {
        texto:
          "AJUSA atualiza seu catálogo a cada dois anos a fim de garantir a mais completa cobertura em juntas de cabeçote, parafusos de cabeçote, jogos de juntas e peças acessórias, tuchos hidráulicos e comandos de válvulas."
      },
      buscador: {
        placeholder: "Busca por fabricante",
        titulo:
          "Use o motor de busca acima ou selecione a inicial da marca de seu interesse."
      },
      cat_turbo: {
        titulo: "Catálogo de Componentes de Turbo",
        texto:
          "A mais extensa gama de kits de juntas da turbina e tubos de lubrificação você encontra no catálogo de turbo AJUSA. Encontre a referência que precisa por modelo de veículo ou marca do turbo.",
        por_vehiculo: "Baixar POR MARCA DE VEÍCULO",
        por_turbo: "Baixar por numeração original do turbo"
      },
      cat_juntas_compresor: {
        titulo: "CATÁLOGO DE JUNTAS DE COMPRESSOR",
        texto:
          "Consulte ou baixe em pdf o catálogo de juntas para compressores de freio exclusivamente para veículos industriais. Você pode baixá-lo por compressor (KNORR-BREMSE, VOITH e WABCO) ou por marca de veículo (DAF, IVECO, MAN, MERCEDES (industrial), RVI, SCANIA e VOLVO (Industrial).",
        por_vehiculo: "Baixar por marca de veículo",
        por_turbo: "Baixar por compressor"
      },
      cat_juegoJuntas: {
        idUrl: "jogos-juntas",
        texto:
          "<strong>14 familias de jogos</strong> de juntas para diferentes partes do motor em um único catálogo. Garantimos a cobertura mais completos do mercado. Consulte e baixe o catálogo completo ou por jogo de juntas que precise.",
        descarga_completo: "BAIXAR CATÁLOGO COMPLETO ",
        descarga_juegos: {
          title: "BAIXAR POR JOGOS DE JUNTAS",
          bombasAgua: "Bomba de água",
          bombasAgua_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-agua-gasket-water-pump.pdf",
          bombasCombustible: "Bomba de combustivel",
          bombasCombustible_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-combustible-fuel-pump.pdf",
          bombaHidraulica: "Bomba hidráulica",
          bombaHidraulica_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-hidraulica-hydraulic-pump.pdf",
          bombaInyeccion: "Bomba injetora",
          bombaInyeccion_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-inyeccion-injector-pump.pdf",
          bombaVacio: "Bomba de vácuo",
          bombaVacio_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-vacio-vacuum-pump.pdf",
          juntaCarter: "Caixa de temporização",
          juntaCarter_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/carter-mando-timing-case.pdf",
          colectorAdminision: "Coletor de admissão",
          colectorAdminision_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/colector-admision-intake-manifold.pdf",
          colectorEscape: "Coletor de escape",
          colectorEscape_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/colector-escape-exhaust-manifold.pdf",
          comprensor: "Carregador",
          comprensor_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/compresor-charger.pdf",
          inyector: "Bico injetor",
          inyector_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/inyector-injector-nozzle.pdf",
          radiadorAceite: "Radiador de óleo",
          radiadorAceite_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/radiador-aceite-oil-cooler.pdf",
          sistemaEscape: "Sistema de exaustão",
          sistemaEscape_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/sistema-escape-exhaust-system.pdf",
          sistemaEGR: "Sistema EGR",
          sistemaEGR_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/sistema-juntas-EGR-System.pdf",
          tapasCulata: "Tampa do cabeçote do cilindro",
          tapasCulata_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/tapa-culata-cilindro-cilinder-head-cover.pdf"
        }
      },
      tec_alliance: {
        intro: "acesso ao catálogo online",
        titulo: "SUA PESQUISA ONLINE",
        texto_1:
          "Encontre a peça avulsa que precisa quando quiser. O catálogo online AJUSA esta disponível 24 horas por dia. Você pode pesquisar por veículo, motor, chassi, referência original ou detalhes técnicos. ",
        texto_2:
          "Todas as referências AJUSA incluem suas devidas informações técnicas, vídeos de montagem e fotografias em 360 º.",
        boton: "acesso"
      },
      ajusa_th: {
        intro: "ENERGIAS ALTERNATIVAS",
        titulo: "FUTURO SUSTENTÁVEL",
        texto:
          "A AJUSA desenvolveu uma linha de pesquisa em energias alternativas sendo a pioneira na fabricação de células combustíveis PEM baseadas em hidrogênio. Descubra a Tecnologia de Hidrogênio AJUSA.",
        boton: "Descubra",
        construccion: "Pagina em Construção. Disponível em breve."
      },
      retenes: {
        titulo: "Catálogo de retentores de distribuição",
        texto:
          "A Ajusa lançou um catálogo específico para os conjuntos de retentores de distribuição, com a mais completa linha de conjuntos de vedações para fazer a troca completa da correia dentada do veículo."
      },
      motorsport: {
        titulo: "Motorsports",
        texto:
          "Confira o guia de aplicação Ajusa Motorsport. Um catálogo completo de juntas de cabeçote para motores de alto desempenho. Os motores de alto desempenho exigem recursos únicos e aprimorados devido às condições extremas a que esses veículos estão expostos. As juntas de alto desempenho da Ajusa são fabricadas para garantir a perfeita vedação necessária para motores de alta potência."
      },
      novedad: "novo",
      nav_options: {
        cat_general: {
          id: "cat-geral",
          title: "catálogo geral",
          category: "catalogo"
        },
        cat_turbo: {
          id: "cat-turbo",
          title: "catálogo turbos",
          category: "catalogo"
        },
        cat_ve: {
          title: "catálogo VE",
          category: "veiculo-eletrico",
          href: "veiculo-eletrico"
        },
        catalogo_online: {
          title: "catálogo on-line",
          redirect: "https://web.tecalliance.net/ajusa/en/home"
        },
        catalogo_ideia: {
          title: "BAIXAR CATÁLOGO IDEIA",
          redirect: "https://baixecatalogo.com.br/catalogo/ajusa"
        },
        catalogo_impreso: {
          title: "Solicitar catálogo impresso",
          category: "catalogo",
          href: "contato"
        }
      },
      alt_images: {
        catalog: "catalogo ajusa",
        catalog_online: "catalogo on-line da ajusa",
        pila_hidrogeno: "célula de combustível pem"
      }
    },
    area_tecnica: {
      intro: {
        titulo: "AJUSA Área técnica",
        texto:
          "<strong class='bold'>Bem vindo ao departamento de assistência técnica AJUSA!</strong> Resolvemos os seus problemas e fornecemos uma extensa gama de materiais  educativos com relatórios técnicos, vídeos e treinamentos técnicos ao vivo.</strong> Estamos comprometidos com você e a reparação de seu veículo."
      },
      asesoramos: {
        intro: "Podemos te ajudar",
        texto_1:
          "Se tiver algum problema com algum de nosssos produtos, veio ao lugar certo. Respondemos seus questionamentos e dúvidas diversas em menos de 5 dias. Envie seu comentário e o departamento de assistência técnica AJUSA vai encontrar a melhor solução para você.",
        texto_2: "+34 619 029 273",
        boton: "Enviar"
      },
      app: {
        texto_1:
          "Baixe nosso APP melhorado e realize uma busca mais fácil e rápida de todos os componentes que precisa para seu veículo.",
        texto_2: "E muito mais!"
      },
      tips: {
        titulo: "RELATÓRIOS TÉCNICOS",
        texto_1:
          "Elimine suas dúvidas e obtenha o procedimento de montagens ou desmontagens atrás com nossos produtos. Você será capaz de explorar as características de cada componente do motor e você vai aprender a reconhecer a parte de cada veículo. Tudo isso e muito oferecido em nossos guias para os relatórios técnicos AJUSA. Baixe-os agora!",
        texto_2: "Publicamos um novo relatório técnico a cada 15 dias.",
        filtrar: "Ordene por categoria",
        por_keyword: "Procure por palavra chave",
        resultado: "Resultados da sua pesquisa:",
        mostrando: "Exibir",
        novedades: "Novidades"
      },
      webinarios: {
        titulo: "Treinamentos técnicos ao vivo",
        texto:
          "Podemos treiná-lo online. Inscreva-se para os nossos treinamentos técnicos ao vivo e saiba mais sobre aplicações mecânicas a partir do conforto de sua  casa. Sessões educativas gratuitas com duração de uma hora cada para melhorar o seu conhecimento e torná-lo um perito ainda melhor. Em inglês e espanhol.",
        proximos: "próximos treinamentos",
        no_hay: "Nenhum treinamento programado no momento",
        anadir_cal: "adicionar ao calendário",
        hasta: "19:00hrs até 21:00hrs",
        ultimo: "",
        btn: "Solitar Webinar"
      },
      asesoramiento: {
        intro: "consultoria",
        titulo: "OFERECEMOS SOLUÇÕES",
        texto:
          "AJUSA está com você a cada passo do caminho na reparação do seu veículo. O nosso departamento de assistência técnica está à sua disposição para resolver as suas dúvidas e perguntas.",
        boton: "Como podemos ajudá-lo?"
      },
      nav_options: {
        ajusa_app: {
          id: "ajusa-app",
          title: "aplicativo móvel ajusa",
          category: "area_tecnica"
        },
        tips: {
          id: "tips",
          title: "RELATÓRIOS TÉCNICOS",
          category: "area_tecnica",
          alert: true
        },
        actualidad_videos: {
          id: "atuais-videos",
          title: "vídeos sobre mecânica",
          category: "area_tecnica",
          redirect: "https://www.youtube.com/channel/UCnoYVeFbsPiOVOcf80tW6Bg"
        },
        webinars: {
          id: "webinars",
          title: "Treinamentos técnicos ao vivo",
          category: "area_tecnica"
        }
      },
      alt_images: {
        juntas_culata_mls: "junta cabeçote mls ajusa"
      }
    },
    ajusa: {
      intro: {
        titulo: "CRESCENDO <span class='bold'>JUNTOS</span>",
        texto:
          "Somos a referência no setor automotivo porque acreditamos no que fazemos. Desde 1972, temos cuidado de seus veículos, graças à nossa dedicação e tecnologia que temos aplicado ao desenvolvimento de componentes do motor."
      },
      enlaces: {
        calidad: "qualidade original",
        servicio: "serviço",
        compromiso: "compromisso social",
        equipo: "equipe",
        catalogo: "catálogo"
      },
      calidad: {
        titulo: "QUALIDADE ORIGINAL",
        texto:
          "Nós garantimos a qualidade do original. Temos a segurança e certificações TÜV de acordo com os padrões ISO 9001 e IATF 16949."
      },
      servicio: {
        titulo: "serviço",
        texto:
          "Estamos comprometidos com nossos clientes. Onde quer que esteja, os nossos produtos chegam sempre a tempo. Nós garantimos uma relação de serviço de 99,5%."
      },
      compromiso: {
        titulo: "compromisso<br>social",
        texto:
          "Contribuímos para melhorias em nossa sociedade, colaborando com uma variedade de causas sociais e caridades. Nossa responsabilidade em relação ao meio ambiente também faz parte do compromisso social da AJUSA.",
        texto_btn: "INFORMATIVO SOBRE A BOLHA DE CARBONO",
        pdf: "/static/pdf/Ajusa_Carbon_Footprint_Report.pdf"
      },
      equipo: {
        titulo: "equipe",
        texto:
          "Investir permanentemente na melhoria do nosso talento profissional e no avanço dos nossos colaboradores. Por trás de cada componente AJUSA, há uma equipe flexível e dinâmica com um espírito de melhoria contínua."
      },
      catalogo: {
        titulo: "catálogo",
        texto:
          "O catálogo da AJUSA é nossa identificação mundial. Com mais de 200.000 referências, é o catálogo mais completo do mercado. Você vai encontrar a peça que você precisa para o seu veículo."
      },
      excelencia: {
        titulo: "A EXCELÊNCIA AUTOMOTIVA",
        texto:
          "Alcançamos a excelência ao mesmo tempo que cuidamos do nosso meio ambiente. Minimizamos o nosso impacto ambiental através da economia energética e do uso de energias renováveis. Nós possuímos certificados de energia da TUV",
        enlace_texto: "ISO 14001 standard",
        texto_2:
          "e mais de <strong class='bold'>8.000 painéis solares que são responsáveis por 40% de nosso consumo anual de energia</strong> em nossa fábrica.",
        boton: "Exibir relatório"
      },
      historia: {
        titulo: "Historia",
        texto:
          "Temos uma história para contar. O esforço e a melhoria constínua marcaram as etapas deste negócio familiar que começou a fabricação de juntas de cabeçote desde 1972. Nós crescemos, nós evoluímos... Venha e conheça a nossa história!",
        boton: "acesse"
      },
      alt_images: {
        sede_principal: "sede da ajusa",
        fabricante_tubos_engrase: "fabricante de tubos de alimentação de óleo",
        social: "ajusa compromisso social e ambiental",
        factoria_automocion: "ajusa fábrica indústria automotiva",
        catalog_juntas: "catálogo de juntas ajusa",
        historia: "história de ajusa"
      }
    },
    actualidad: {
      noticias: {
        titulo: "últimas noticias",
        ir_blog: "ir para o blog"
      },
      twitter: {
        titulo: "Disponível nas redes sociais",
        acceder: "acesse"
      },
      videos: {
        titulo: "vídeos",
        texto:
          "Você será capaz de assistir, passo a passo, como as peças da AJUSA são montados em um motor em tempo real. A maneira mais fácil, prática e perfeita de aprender a montar uma junta de cabeçote e todos os outros componentes do motor fabricados pela AJUSA. A cada 15 dias, atualizamos nosso canal de vídeo com um novo veículo.",
        ultimos: "últimos vídeos",
        ver_todos: "ver todos os vídeos"
      }
    },
    blog: {
      intro: {
        titulo: "<span>TUNING</span>",
        subtitulo: "o blog do"
      },
      categorias_nombres: {
        fairs: "Feiras e eventos",
        products: "Produtos",
        "our-sector": "Nosso setor",
        "social-commitment": "Compromisso Social"
      },
      alt_images: {
        ajusa_blog: "ajusa blog",
        puesta_punto: "tunnig",
        ferias: "automechanika estande da ajusa",
        productos: "juntas de cabeçote ajusa",
        "nuestro-sector": "nosso setor ajusa",
        "compromiso-social": "compromisso social"
      },
      ultimas: "Últimas Notícias",
      dejar_comentario: "DEIXE UM COMENTÁRIO",
      titulo_comentarios: "COMENTÁRIOS RECENTES",
      noticias_relacionadas: "Notícias Relacionadas",
      compartir: "Compartilhe",
      no_hay_post: "Não há postagens nesta categoria"
    },
    sala_prensa: {
      clipping: {
        titulo: "NOTAS",
        texto:
          "A mídia no setor automobilístico compartilha as últimas notícias da AJUSA. Estas são os giros de notícias da AJUSA.",
        boton: "download",
        logotipo: "logo",
        imagenes: "imagens"
      },
      ajusa: {
        intro: "sobre a AJUSA",
        titulo: "A EXCELÊNCIA AUTOMOTIVA",
        texto:
          "Temos fabricado juntas de cebaçote desde 1972. Líderes em vedações de motores com o mais extenso catálogo de vedações de motores do setor. Somos também especialistas na produção de tubos de lubrificação e kits de montagem dos Turbo Compressores para motores turbo. Sempre a serviço da indústria automobilística."
      }
    },
    historia: {
      texto_intro:
        "Temos sido uma referência global para mais de 45 anos. Trabalhar em busca de melhoria constante nos nossos produtos e nos nossos serviços.",
      hoy: "Hoje",
      texto_1972_1:
        "AJUSA começou em 1972. Esse ano foi fabricado a primeira junta de cabeçote. Demorou 3 horas e tudo foi feito totalmente à mão!",
      texto_1972_2:
        "Frequentamos as primeiras feiras internacionais e aumentamos nossas instalações mudando para um novo pátio industrial de Campollano.",
      texto_1980_1:
        "Lançamos nosso primeiro catálogo geral com 600 referências. O catálogo atual tem 20 vezes mais! Ultrapassamos as 200.000 referências, proporcionando a cobertura mais completa para fabricantes de motores asiáticos e europeus .",
      texto_1980_2:
        "Nós conseguimos produzir a primeira peça com a qualidade original OEM: uma junta de cabeçote para Renault.",
      texto_1990_1:
        "Abrimos o nosso centro de pesquisa e testes onde realizamos os mais exaustivos controles de garantia para certificações de qualidade dos nossos produtos.",
      texto_1990_2:
        "Houve o lançamento de 3 novas linhas de produtos: parafusos de cabeçote, tuchos hidráulicos e comandos de válvulas.",
      texto_2000_1:
        "Ajusa cresceu internacionalmente e abriu filiais na Rússia, Reino Unido, México e Brasil, incorporando parceiros estratégicos em todo o mundo.",
      texto_2000_2:
        "Mudamos novamente agora para um parque industrial que leva nosso mone: AJUSA. Com mais de 40.000 m² de patio fabril e 3.000 m² de escritórios.",
      texto_2010_1:
        "Desde 2014 iniciamos a produção de tubos de lubrificação de turbinas e lançamos nosso catálogo de componentes de turbos compressores, abrangendo a maioria das referências disponíveis no mercado.",
      texto_2010_2:
        "Aplicamos o que há de mais novo em tecnologia para garantir a máxima qualidade em nossas linhas de produtos."
    },
    contacto: {
      titulo: "ATENDIMENTO AO CLIENTE",
      sucursales: "Locais de Atendimento",
      coords: {
        lat: -23.515094656909923,
        lng: -46.744552150000004
      },
      id: "brasil",
      delegaciones: {
        espana: {
          nombre: "Espanha",
          titulo: "Matriz",
          direccion:
            "Parque Empresarial Ajusa, Rua 1, nº1 · 02008 · ALBACETE (Espanha) · Apdo./P.O. Caixa 415 (02080)",
          telefono: "Tel.: +34 967 216 212",
          fax: "Fax: +34 967 216 214 - 967 240 499",
          email: "Email: <a href='mailto:ajusa@ajusa.es'>ajusa@ajusa.es</a>"
        },
        // rusia: {
        //     nombre: "Russia",
        //     titulo: "Ajusa-Russia",
        //     direccion: "108803, Москва, п. Воскресенское, пос. Воскресенское, д. 66, а/я 1890",
        //     telefono: "Tel. +7(499) 608-06-81 / +7(916) 060-07-24",
        //     fax: "",
        //     email: "Contact: <a href='mailto: info@ajusa.ru'> info@ajusa.ru</a>"
        // },
        uk: {
          nombre: "Reino Unido",
          titulo: "Ajusa Reino Unido",
          direccion: "Unit 25, Hortonwood 33, Telford, TF1 7EX",
          telefono: "Tfno. +44 (0)195 2608 771",
          fax: "",
          email:
            "Contact: <a href='mailto:info@ajusa.co.uk'>info@ajusa.co.uk</a>"
        },
        mexico: {
          nombre: "Mexico",
          titulo: "Ajusa México S.A. de C.V",
          direccion:
            "Calle Lago Ladoga, 295-A · Col. Anahuac, Deleg. Miguel Hidalgo · Ciudad de México, D.F. CP 11320 (Mexico)",
          telefono: "Tel. +52-55 5254 2332",
          fax: "Fax +52-55 5254 2332",
          email:
            "Contact: <a href='mailto:ajusamexico@ajusa.com.mx'>ajusamexico@ajusa.com.mx</a>"
        },
        brasil: {
          nombre: "Brasil",
          titulo: "Ajusa do Brasil Ltda",
          direccion:
            "Rua Santa Francisca, 417 · Bairro Vila Jaguara, 05116-090 · SÃO PAULO, SP (Brasil)",
          telefono: "Tel. +55 11 3622-5353",
          fax: "Fax +55 11 3622-5353",
          email:
            "Contact: <a href='mailto:ajusadobrasil@ajusa.com.br'>ajusadobrasil@ajusa.com.br</a>"
        },
        usa: {
          nombre: "USA",
          titulo: "AJUSA USA Corp.",
          direccion:
            "GABLES INTERNATIONAL PLAZA · 2655 S. LE JEUNE ROAD SUITE # 905 · CORAL GABLES, FL 33134",
          telefono: "Tel. +1 310 625 1034",
          fax: null,
          email:
            "Contact: <a href='mailto:ajusausa@ajusa.es'>ajusausa@ajusa.es</a>"
        },
        francia: {
          nombre: "França",
          titulo: "Ajusa France",
          direccion: "64, Rue Paul Claudel, 87000 | Limoges (France)",
          telefono: "Tel. +33 587 14 71 17",
          fax: null,
          email:
            "Contact: <a href='mailto:ajusafrance@ajusa.fr'>ajusafrance@ajusa.fr</a>"
        }
      },
      alt_images: {
        contacto_ajusa: "contato ajusa",
        trabajar_ajusa: "trabalhe conosco ajusa"
      },
      phone: "+55 11 3622-5353",
      email: "ajusadobrasil@ajusa.com.br"
    },
    trabaja_con_nosotros: {
      intro: {
        titulo: "<span class='bold'>trabalhe</span> conosco",
        texto:
          "Trabalhamos para crescer todos os dias. Se você quiser fazer parte da nossa família cada vez maior, preencha este formulário e envie o seu currículo."
      },
      texto:
        "Na Ajusa, trabalhamos para crescer todos os dias, se você quiser fazer parte da nossa família cada vez maior, preencha este formulário e envie o seu currículo.",
      boton: "anexar curriculo"
    },
    formulario: {
      nombre: "Apelido",
      nombre_apellidos: "Primeiro e último nome",
      apellidos: "Sobrenome",
      email: "Email",
      mensaje: "Mensagem",
      fecha_nacimiento: "Data de Nascimento",
      dia: "Dia",
      mes: "Mês",
      anyo: "Ano",
      area_interes: "Area de interesse",
      trabaja_actualmente: "Esta atualmente empregado?",
      motivo: "Escolha a opção",
      si: "Sim",
      no: "Não  ",
      carta_presentacion: "Carta de Apresentação",
      tipos_contacto: {
        general: "Geral, contato, filiais",
        comercial: "Comercial",
        formacion: "Treinamento ",
        asistencia_tecnica: "Área Técnica",
        catalogo: "Solicitar um catálogo impresso",
        webinar: "Solicitar Webinar"
      },
      meses: {
        enero: "Janeiro",
        febrero: "Fevereiro",
        marzo: "Março",
        abril: "Abril",
        mayo: "Maio",
        junio: "Junho",
        julio: "Julho",
        agosto: "Agosto",
        septiembre: "Setembro",
        octubre: "Outubro",
        noviembre: "Novembro",
        diciembre: "Dezembro"
      },
      archivo_adjunto: "Anexar Arquivo",
      adjuntar_cv: "Anexar Currículo",
      empresa: "Nome da empresa",
      sector: "Setor",
      formulario: "Endereço completo ( indicar cidade e cep )",
      referencia: "Referência do produto",
      introduce_mail: "Indicar seu endereço de email",
      tipo_catalogo: "Tipo do catálogo",
      pais: "País",
      ciudad: "Cidade",
      telefono: "Telefone",
      direccion: "Endereço",
      quiero_recibir:
        "Eu gostaria de receber notícias e informativos sobre a AJUSA.",
      acepto_comunicaciones:
        "Concordo em receber boletins técnicos e demais comunicações de sua companhia.",
      otros_procesos:
        "Eu gostaria de der lembrado para demais processos de seleção da AJUSA que possa ser de meu interesse",
      he_leido:
        "Autorizo ​​a utilização dos meus dados para os fins indicados na ",
      y_acepto: "política de privacidade",
      enviar_comentario: "Envie seu comentário",
      comentario_enviado: "Comentário enviado",
      enviar: "Enviar",
      enviado: "Enviado",
      popup: {
        claim: "Clique aqui para ver e concordar com a política de privacidade",
        intro: "INFORMAÇÕES BASICAS SOBRE PROTEÇÃO DE DADOS",
        textos: [
          {
            titulo: "Controlador de dados",
            texto: "Auto Juntas SAU"
          },
          {
            titulo: "Endereço do controlador de datos",
            texto:
              "Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02008, Albacete (Albacete)"
          },
          {
            titulo: "Propósito",
            texto:
              "Os seus dados serão utilizados para processar os seus pedidos e fornecer-lhe os nossos serviços."
          },
          {
            titulo: "Advertências",
            texto:
              "Nós só lhe enviaremos publicidade, se você autorizá-lo antecipadamente. Você pode fazer isso marcando a caixa correspondente no formulário."
          },
          {
            titulo: "Autoridade Legal",
            texto:
              "Só processaremos os seus dados com o seu consentimento prévio. Você pode fazer isso marcando a caixa correspondente no formulário."
          },
          {
            titulo: "Destinatários pretendidos",
            texto:
              "De um modo geral, apenas o pessoal devidamente autorizado da nossa empresa poderá acessar às informações que solicitamos."
          },
          {
            titulo: "Direitos",
            texto:
              "Você tem o direito de saber quais informações nós temos sobre você, corrigir ou excluír, como explicado na informação adicional disponível em nosso Web site."
          },
          {
            titulo: "informação Adicional",
            texto:
              "Mais informações estão disponíveis na seção 'SEUS DADOS SEGUROS' em nosso website."
          }
        ],
        boton: "Entendido"
      },
      thank_you: {
        title: "SENT!",
        text:
          "<p>Obrigado! O formulário foi enviado com sucesso.</p><p>Entraremos em contato com você assim que possível.</p>",
        btn_text: "VOLTAR PARA A PÁGINA INICIAL"
      }
    },
    error_404: {
      intro: "<span class='bold'>PÁGINA</span> NÃO ENCONTRADA",
      nombre: "Erro 404",
      texto:
        "Desculpe! A página que você está tentando acessar não está mais disponível ou foi movida.",
      boton: "Voltar a página principal"
    },
    newsletter: {
      titulo: "Inscreva-se em nossas últimas notícias",
      texto:
        "Receba todas as últimas notícias sobre o setor automobilístico e atualidades da AJUSA.",
      suscripcion_ok:
        "Você foi inscrito corretamente! De agora em diante você se manterá atualizado com todas as últimas notícias da Ajusa"
    },
    footer: {
      siguenos: "Siga-nos",
      en_redes: "Siga-nos na rede social",
      twitter: "Siga-nos no X",
      facebook: "Siga-nos no Facebook",
      instagram: "Siga-nos no Instagram",
      canal: "Siga-nos em nosso canal",
      selecciona_idioma: "Selecione um idioma",
      alt_image: "certificados de ajusa"
    },
    popupApp: {
      title: "Faça o download AJUSA MOBILE",
      description:
        "O guía mais completo do setor automobilístico, com toda a informação dos produtos AJUSA."
    },
    popupretenes: {
      title: "Disponível o novo catálogo de retentores de distribuição AJUSA.",
      boton: "Consulte e faça o download por marcas."
    },
    popupjuntas: {
      novedades: "NOVO CATÁLOGO",
      title: "JOGOS DE JUNTAS ESPECIAIS",
      texto: "para diferentes partes do motor",
      boton: "CATÁLOGO"
    },
    popupajustick: {
      title: "NOVO PRODUCTO",
      description: "VEDANTE ANAEERÓBICO AJUSTICK",
      boton: "PRODUCTO"
    },
    otras_secciones: {
      catalogo: {
        titulo: "catálogo",
        texto:
          "A maneira mais fácil de encontrar a parte que você precisa para o seu veículo e sua referência. O catálogo AJUSA contém aplicações para todos os fabricantes de veículos europeus e asiáticos. Pode consultá-lo online ou solicitar a versão do catálogo impresso.",
        boton_texto: "Ir para o catálogo"
      },
      area_tecnica: {
        titulo: "Consultoria",
        texto:
          "O <span class='bold'>departamento de assistência técnica da AJUSA</span> esta esperando por você. Nossa equipe irá tratar pessoalmente de seus questionamentos. Além disso, você pode consultar o nosso <span class='bold'>guia de informações técnicas ou videos tutoriais</span> para ver mais detalhes e passo a passo da aplicação perfeita de nossos produtos.",
        boton_texto: "Como podemos ajudá-lo?"
      },
      sala_prensa: {
        titulo: "Sala de Imprensa",
        texto:
          "Consulte os materiais que a Ajusa colocou à sua disposição, bem como as últimas notícias e o resumo geral das postagens de mídia da AJUSA no setor automobilístico.",
        boton_texto: "VER MATÉRIAS"
      },
      solicite_catalogo: {
        titulo: "Solicitar um catálogo impresso",
        texto:
          "Nós fazemos o reparo de seu veículo se tornar algo fácil. Solicite cópias impressas do nosso catálogo geral ou do nosso catálogo de Turbos componentes. Envie seu pedido indicando qual catálogo você está interessado.",
        boton_texto: "Solicitar"
      },
      actualidad: {
        titulo: "Últimas Notícias",
        texto:
          "Queremos mantê-lo atualizado com as nossas notícias e informado sobre as últimas novidades. Visite o nosso blog, Cadastre-se para receber a nosso Boletim Informativo ou siga-nos nas mídias sociais. Compartilhamos as nossas experiências!",
        boton_texto: "ESTAMOS ANSIOSOS PARA VÊ-LOS"
      },
      donde_estamos: {
        titulo: "onde nos encontrar",
        texto:
          "Nós estamos onde você precisar de nós. Temos locais de distribuição estratégicas localizados em todo o mundo e filiais p´roprias no México, Brasil, Rússia e Reino Unido. Nossa fábrica e matriz, onde realizamos todo o trabalho de desenvolvimento, está na cidade de Albacete (Espanha).",
        boton_texto: "Contate-nos"
      }
    },
    banner_cookies:
      "Um cookie é um pequeno arquivo de dados que é armazenado em seu navegador cada vez que você visita o nosso site. Os cookies são úteis para salvar o histórico de sua atividade em nosso site para que quando você visitá-lo novamente, ele pode identificá-lo e exibir seu conteúdo com base em seus hábitos de navegação, identidade e preferências para sua melhor navegação em nosso site. Os cookies podem ser aceitos, rejeitados, bloqueados e apagados como desejado. Se você decidir rejeitá-los, não podemos garantir o funcionamento correto do nosso site. Mais informações em  <router-link to='/cookies-policy'>política de cookies</router-link>.",
    boton_aceptar: "Permitir",
    historia_infografia: {
      celebracion50:
        '<p>50th Anniversary</p><p class="second-line">Celebration </p>',
      celebracion50descripcion:
        "On November 11th, 2022, we gathered all our employees in the Teatro Circo of Albacete to celebrate our 50 years of history.",
      video: "VIDEO",
      galeria: "IMAGE GALLERY",
      noticias: "NEWS",
      urlNoticias:
        "https://ajusa.online/en/blog/news/ajusa-celebrates-50-anniversary",
      urlVideoIntro: "/static/img/historia_infografia/intro.mp4",
      Anios50: "<strong>50 </strong> YEARS",
      excedencia: "excellence",
      enAutomocion: "of automotive",
      albacete: "<strong>ALBACETE,</strong>",
      laCuidad: "the city that saw ",
      crecer: "us thrive",
      mayorAntesDeTiempo: "Old before his time",
      textMayor:
        "<strong>He was the fifth of six siblings. At the age of 9 he lost his mother and at 15 his father, a lorry driver by profession.</strong>",
      eraseUnaVez: "Once upon a time…",
      textEraseUnaVez:
        "Albacete, February 13, 1950. José Manuel Martínez Martínez, founder of Ajusa was born. His family situation forced him to drop out of school and he started working at the age of 13 as a sales assistant in a picture store and in a delicatessen in his neighbourhood.",
      cuentameMas: "TELL ME MORE!",
      unGestoInolvidable: "An unforgettable gesture",
      enEsteTrabajo:
        "In this job he was registered with the <strong>Social Security</strong>. This fact, something so unusual at that time, was very important for him.",
      aprendiendoElOficio: "Learning the trade…",
      con14Anios:
        "Josema discovered his true vocation at the age of 14 when he started working at the Pegaso dealership in Albacete (COMALBASA), where he was soon appointed head of the spare parts department.",
      granImplicacion: "A great commitment",
      fueronAnios:
        "These were years entailed a great deal of dedication and learning, in which he combined his military service in Seville with his work at Auto Martínez, spare parts company than he founded with his brothers.",
      fueronMeses:
        "In Seville he worked night shifts to dedicate time to Auto Martínez during the day. Such was his involvement that he spent over than <strong>50,000 pesetas a month on phone calls!</strong>",
      naceAjusa: "Ajusa is founded",
      suEspiritu:
        "His entrepreneurial spirit was fostered by his passion for the automotive industry and he decided to go that one step further by starting his own business. In 1972, he opened a small establishment where he started to manufacture the first engine gaskets of the Marca España (Brand Spain) trademark. ",
      naceLaCompania:
        "And just like that the industrial company (now Ajusa) was founded, a company that José Manuel Martínez presides until today.",
      miguelOliver:
        "Miguel Oliver was appointed industrial director and José Gómez the head of custom tooling craftsmanship.",
      primeraJuntas:
        "The first cylinder head gaskets were manufactured entirely by hand and with our own tooling also produced in our facilities.",
      seTardada:
        "It took approximately 3 hours to manufacture a cylinder head gasket, while nowadays approximately 1000 cylinder head gaskets can be produced in 3 hours.",
      primeraEtapa:
        "During this first stage, materials such as asbestos were used. Ajusa was the first manufacturer in the world to stop using this now banned material.",
      contanciaEsfuerzo: "Perseverance and hard work",
      josemaRecorrio:
        "<strong>Josema visited practically every city in Spain. Upon his arrival somewhere he would pick up the telephone directory and call all the workshops and spare parts stores one by one until he could personally present the Ajusa catalog.<br>This is how our brand became known in Spain.</strong>",
      edicion: "Edition",
      catalogoAjusa: "Ajusa Catalog",
      infoCatalogo:
        "Just one year after the founding of Ajusa and with a staff of 10 workers, the first engine gaskets catalog was launched. At that time the catalog only had 600 product references while today, with a staff of 800 people, it has over 200,000. ",
      verPortadas: "SEE COVERS",
      textInfo1974:
        "And just like that began the love story of Josema and Dori, who were the parents of three children: Consuelo, José Manuel y Noelia. The essence of Ajusa is based on family values and commitment.",
      amorAPrimera: "Love at first sight",
      descriptAmor:
        "The woman of this picture is Adoración Sánchez, who worked for a year in the packaging section and in the administration department. The same day she left the company, Josema called her on the phone... to ask her out on a date!",
      crecimientoImparable: "An unstoppable growth",
      text1crecimientoImparable:
        "Years went by and with hard work, sacrifice and the same enthusiasm with which it was founded, Ajusa continued its unstoppable growth, relocating to the <strong>Polígono Campollano (Campollano Industrial Estate) in Albacete</strong> and expanding its production line.",
      text2crecimientoImparable:
        "And more importantly, Josema kept intact the entrepreneurial spirit of his beginnings. While the brand's leadership in the nationa market was being established, his sights were alreadyset on internationalisation.",
      verMas: "SEE MORE",
      title1978: "From a local company...<br>to the world stage!",
      description1_1978:
        "Its early presence in the main international trade shows and ambitious export plan for the 70s enabled the company to open markets in other countries.",
      description2_1978:
        "Josema advocated and upheld his business judgement and criteria and did not succumb to the dictates of major multinationals, even turning down contracts worth millions of pesetas!",
      description3_1978:
        "In 1978, Ajusa participated in Automechanika, <strong>the most important international automobile trade show</strong> which is held every two years in Frankfurt.",
      importanteReconociento: "Major recognition!",
      espirituInnovador:
        "The innovative and entrepreneurial spirit which José Manuel Martínez showed from an incredibly young age resulted in obtaining the <strong>Gold Medal for Exports</strong> in 1981. ",
      title1980: "The cornerstones of a great company",
      description1_1980:
        "The expansion of the services offered and the increase in demand resulted in the need to have larger facilities.",
      description2_1980:
        "In 1980, Ajusa laid the foundations of its first major factory by expanding the Campollano facilities. Successively, adding square metres with the sole objective of providing the best service to professionals in the automotive sector.",
      title1992: "Business expansion",
      description1_1992:
        "The cylinder head gasket continued to be the star product, but 1992 was a strategic year in the expansion of the business with the incorporation of <strong>complete gasket sets</strong> for engines, cylinder head bolts and a comprehensive <strong>range of accessory gaskets</strong>. The machining line was also launched to manufacture hydraulic tappets and camshafts. ",
      calidadGarantizada: "Guaranteed quality",
      ajusaEmpresaPionera:
        "Ajusa was one of the pioneering companies to obtain AENOR quality certifications as per the ISO 9001 and IATF 16949 Standards in the 1990s.",
      primeraEmpresaSector:
        "It was likewise the <strong>first company in the sector</strong> to offer the customer a comprehensive kit of gaskets for the same engine.",
      title1996: "Opening of branches",
      description1_1996:
        "With the consolidation of the company, it became a reference benchmark and several branches were opened in various locations such as Los Angeles (USA), Sao Paulo (Brazil), Mexico City (Mexico), Birmingham (UK) and Limoges (France)",
      eeuuPrimeraSucursal: "USA, first branch",
      sucursalEeuu:
        "Ajusa's branch in the United States was the first to open its doors and, like the other branches, has a warehouse with over 10,000 items in stock.",
      comprometidosSostenibilidad: "Committed to sustainability",
      infocomprometidosSostenibilidad:
        "Ajusa set up in 2002 a company dedicated to the research of hydrogen as an alternative energy: Ajusa Tecnologías del Hidrógeno (Ajusa Hydrogen Technologies). Currently, it applies the most cutting-edge technologies in the implementation of multiple projects using PEM technology.",
      title2002: "Pioneers in hydrogen technologies",
      description2002:
        "Ajusa set up in 2002 a company dedicated to the research of hydrogen as an alternative energy: <strong>Ajusa Tecnologías del Hidrógeno (Ajusa Hydrogen Technologies)</strong>.<br> Currently, it applies the most cutting-edge technologies in the implementation of multiple projects using PEM technology.",
      actualizamosLogo: "An updated logo",
      evolucionG: "Graphic evolution",
      title2008: "Ajusa Industrial Estate",
      description1_2008:
        "In 2008, without losing sight of its local roots, the production facilities located in Parque Empresarial Ajusa, were inaugurated. ",
      description2_2008:
        "A complex of 5 factories which include the different production lines and that facilitates the integration of the latest technology to ensure utmost reliability in the Ajusa product range.",
      title2014: "New production lines",
      description1_2014:
        "Ajusa's team innovative drive and the company's continuous investment in research and product development facilitated the start-up of the turbo components production line, which includes both the development of gaskets as well as the manufacture of turbo lubrication pipes.",
      description2_2014:
        "This year also saw the launch of the first edition of the turbo components catalog. Both the production lines as well as the staff continued to grow steadily.",
      title2022: "Growing together",
      description1_2022:
        "50 years have brought <strong>new values and new products<strong> to the company, conferring it an identity with a keen sense of responsibility towards its environment. For this reason, Ajusa participates annually in various projects to collaborate and support social actions carried out by numerous associations.  ",
      description2_2022:
        "This year, with the history which precedes us, we celebrate with great responsibility our 50th anniversary, in the belief that it will be a point of reference in the history of Ajusa and likewise to that of growing together in the future.",
      verVideo: "SEE VIDEO",
      urlVideoCompl: "/static/img/historia_infografia/video-compl-ingles.mp4"
    },
    vehiculo_electrico: {
      intro_titulo: "VEÍCULO ELÉTRICO",
      descripcion_intro:
        "A Ajusa dispõe de um amplo catálogo de componentes para a reparação de viaturas híbridas e elétricas. Além disso, queremos ajudar os utilizadores a fazerem as suas reparações. Para isso, colocamos à sua disposição fichas explicativas de cada avaria (disponíveis para download nesta secção) e tutoriais em vídeo gravados por um especialista em reparação de veículos elétricos.</br></br>",
      descripcion_intro2:
        "<img src='/static/img/vehiculo-electrico/triangle-exclamation-duotone.svg' style='height:20px; margin-right: 5px;' alt='icon important'/><strong>Medidas de segurança e ferramentas básicas</strong> para reparar um veículo elétrico. Clique no vídeo!",
      catalogo: {
        titulo: "CATÁLOGO DE REPARAÇÃO DE MOTORES ELÉTRICOS",
        descripcion:
          "Nesta secção pode consultar o <strong>catálogo de peças Ajusa para viaturas híbridas e elétricas</strong>, pesquisando a marca da viatura. Cada ficha de produto do catálogo Ajusa inclui uma descrição das principais avarias desse modelo e um link para um vídeo tutorial sobre a sua reparação."
      },
      sellado: {
        titulo: "SOLUÇÕES DE VEDAÇÃO PARA VEÍCULOS ELÉTRICOS",
        descripcion:
          "Estamos na vanguarda da indústria automóvel como <strong>fabricante líder mundial de componentes de substituição para veículos híbridos e elétricos</strong>. Contamos com mais de 50 anos de experiência como fabricantes de componentes para o setor automobilístico."
      },

      material: {
        titulo: "MATERIAL DIDÁTICO AUDIOVISUAL",
        descripcion:
          "Hoje em dia é fundamental encontrar mecânicos especializados em eletromecânica. O material didático que a Ajusa oferece através dos seus tutoriais em vídeo responde às mais <strong>exigentes necessidades de formação em veículos híbridos e elétricos</strong>. Irá aprender a reparar o motor/gerador, as baterias ou os inversores/conversores de veículos elétricos. Só tem de digitalizar o código QR que aparece na etiqueta de cada produto para aceder aos vídeos."
      },
      porqueElegir: {
        titulo: "POR QUE UM VEÍCULO ELÉTRICO OU UM VEÍCULO HÍBRIDO?",
        descripcion:
          "<p>Na Ajusa, entendemos que escolher um <strong>veículo elétrico (VE)</strong> ou um <strong>carro híbrido (HEV)</strong> é muito mais do que uma simples decisão de transporte. É uma afirmação de compromisso com o futuro e um investimento na mobilidade sustentável.</p><p>Mas por que você deveria comprar um desses veículos?</p>"
      },
      medioAmbiente: {
        titulo: "Contribuir para o meio ambiente",
        descripcion:
          "<p>Optar por um VE ou um HEV é uma maneira tangível de reduzir sua pegada de carbono. Esses veículos produzem menos emissões prejudiciais e contribuem para a preservação do meio ambiente.</p><p>Ao contar com a <strong>Ajusa</strong> para a reparação de <strong>componentes de carros elétricos e híbridos</strong>, você mantém seu veículo ecologicamente correto em ótimas condições.</p>"
      },
      ahorro: {
        titulo: "Economia a longo prazo",
        descripcion:
          "<p>Embora o investimento inicial possa ser um pouco mais alto, os veículos elétricos e híbridos oferecem economias significativas ao longo de sua vida útil. Com custos de energia mais baixos e menos necessidade de manutenção, você notará uma diferença substancial em seus gastos com a condução.</p>"
      },
      experiencia: {
        titulo: "Experiência avançada de condução",
        descripcion:
          "<p>Os carros elétricos e híbridos oferecem uma experiência de condução suave, silenciosa e livre de emissões. A tecnologia mais recente nesses veículos garante um desempenho excepcional e conforto incomparável na estrada.</p>"
      },
      innovacion: {
        titulo: "Apoio à inovação",
        descripcion:
          "<p>Ao escolher um carro elétrico ou híbrido, você está apoiando a inovação na indústria automobilística. Esses veículos impulsionam a pesquisa e o desenvolvimento de tecnologias mais limpas e eficientes, abrindo caminho para um futuro mais sustentável.</p>"
      },
      catalogo_vehiculo_hibrido: "CATÁLOGO DE VEÍCULOS HÍBRIDOS E ELÉTRICOS",
      catalogo_vehiculo_hibrido_kits:
        "Todos os nossos kits de reparo também estão disponíveis sem rolamentos.",
      catalogo_juntas_compresor:
        "CONJUNTO DE JUNTAS DE CATÁLOGO DE COMPRESSOR EV A/C ",
      renault: "RENAULT",
      modelo: "Modelo",
      ano: "Ano",
      codigo_motor: "Código motor",
      n_comprensor: "Nº do compressor",
      tipo_averia: "Tipo de avaria",
      referencias_disponibles: "Referências Ajusa disponíveis",
      otras_referencias: "Outras referências",
      manual: "MANUAL DE REPARAÇÃO",
      videoReparacion: "REPARAÇÃO DE VÍDEO",
      commercialInfo: "SOLICITA INFORMAÇÕES COMERCIAIS",
      accessVideoTut: "ACCESO A TODOS LOS VIDEO TUTORIALES",
      videos: {
        video0: {
          id: "vehiculo-electrico-2",
          videoId: "svouPU4u8jY",
          text:
            "Sabe o que precisa para reparar um veículo elétrico? Neste vídeo, explicamos as <strong>medidas de segurança e as principais ferramentas</strong> que uma oficina mecânica deve ter.",
          btnText: "VÍDEO"
        },
        EV001900: {
          id: "AUDI",
          modelo: "AUDI E-tron 55",
          año: "2019 - 2023",
          codigoMotor: "EASA",
          referenciasDisponibles: "EV001900",
          videoId: "aM7HnIMiV8s"
        },
        EV001400: {
          id: "BMW",
          modelo: "BMW i3",
          año: "2012 - 2022",
          codigoMotor: "IB1P25B",
          referenciasDisponibles: "EV001400",
          videoId: "_krGGRnVYtI"
        },
        EV000500: {
          id: "Hyundai | Kia",
          modelo:
            "Hyundai Kona, Hyundai Kauai, Kia Niro EV, Kia E-Soul EV (III)",
          año: "2018-2023",
          codigoMotor: "EM16",
          referenciasDisponibles: "EV000500",
          videoId: "gi1Gbs3d9NA"
        },
        EV000700: {
          id: "hyundai",
          modelo: "Hyundai Ionic EV",
          año: "2016-2019",
          codigoMotor: "EM09, 88KW, 120CV",
          referenciasDisponibles: "EV000700",
          videoId: "D5RnWWK1JXM"
        },
        EV000600: {
          id: "kia",
          modelo: "Kia Soul EV (II) 81KW, 110CV",
          año: "2014-2018",
          codigoMotor: "ZD",
          referenciasDisponibles: "EV000600",
          videoId: "YJ82wEmqP5M"
        },
        EV001300: {
          id: "nissan",
          modelo: "Nissan LEAF ZE01",
          año: "2017-2022",
          codigoMotor: "EM57",
          referenciasDisponibles: "EV001300",
          videoId: "Sz-wPyY0To8"
        },
        EV001200: {
          id: "peugeot",
          modelo: "PEUGEOT E-208",
          año: "2020-",
          codigoMotor: "ZK01",
          referenciasDisponibles: "EV001200",
          videoId: "6zXy9dBiqsY"
        },
        EV000100: {
          id: "renault",
          modelo: "Renault Zoe",
          año: "2012-2018",
          codigoMotor: "5M- 450",
          referenciasDisponibles: "EV000100",
          videoId: "cI_eu063pw4"
        },
        EV000200: {
          id: "Renault | Smart",
          modelo: "Renault Zoe, Smart Fortwo W453",
          año: "Renault (2012-2019), Smart (2016-2019)",
          codigoMotor: "Renault (5AQ-601) Smart (5AL)",
          referenciasDisponibles: "EV000200",
          videoId: "ZA93lYHO_T0"
        },
        EV000300: {
          id: "tesla",
          modelo: "Tesla Model 3, Tesla Model Y",
          año: "2017-2021",
          codigoMotor:
            "1120980-00-G / 1120980-17-J / 1120990-00-J / 1672095-00-C / 1672096-00-B /1672096-00-C",
          referenciasDisponibles: "EV000300",
          videoId: "gazCfvf3N9c"
        },
        EV000400: {
          id: "tesla",
          modelo: "Tesla Model S · Tesla Model X",
          año: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          codigoMotor: "1035000-00-J",
          referenciasDisponibles: "EV000400",
          videoId: "CK5OeOPX-sM"
        },
        EV000800: {
          id: "tesla",
          modelo:
            "Tesla Model S · Tesla Model X · Mercedes B-Class B250e · Toyota RAV4 EV",
          año:
            "Tesla Model S (2012 – 2021) · Tesla Model X (2015 – 2021) · Mercedes B-Class B250e (2014 – 2017)  · Toyota RAV4 EV (2012 – 2014)",
          codigoMotor:
            "1002633-00-U / 002633-01-U / 1002633-01-U / 1025598-01-U",
          referenciasDisponibles: "EV000800",
          videoId: "JxbTKXWBRMw"
        },
/*         EV000802: {
          id: "tesla | Mercedes | Toyota",
          producto: "Coolant bypass kit",
          modelo:
            "Tesla Model S, Tesla Model X, Mercedes B-Class, Toyota Rav4 EV",
          año:
            "Tesla Model S (2012-2021), Tesla Model X (2015-2021), Mercedes (2014-2017), Toyota (2012-2014)",
          codigoMotor: "1002633-00-U, 1002633-01-U, 1025598-01-U",
          referenciasDisponibles: "EV000802",
          videoId: "d2gj_aTYW1o"
        }, */
        EV001000: {
          id: "tesla",
          modelo: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          año: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          codigoMotor: "1037000-20-A y 1037000-00-F",
          referenciasDisponibles: "EV001000",
          videoId: "gEr97ru09VQ"
        },
        EV001100: {
          id: "tesla",
          modelo: "Tesla Model 3 (2017-2025) · Tesla Model Y (2020-2025)",
          año: "Tesla Model 3 (2017-2025) · Tesla Model Y (2020-2025)",
          codigoMotor:
            "Dual Motor versions with front motor code 3D3 (also combined with 3D5, 3D6 or 3D7)",
          referenciasDisponibles: "EV001100",
          videoId: "MIVazJrPxOs"
        },
        EV000901: {
          id: "volvo",
          modelo: "Volvo V60",
          año: "2011-2018",
          codigoMotor: "D82PHEV, D87PHEV, D97PHEV y B1APHEV",
          referenciasDisponibles: "EV000901",
          videoId: "0_-WLtUpgm4"
        },
        EV001500: {
          id: "volkswagen",
          modelo: "E-Golf",
          año: "2014-2021",
          codigoMotor: "EBSA",
          referenciasDisponibles: "EV001500",
          videoId: "vv8NSjXvAlk"
        }
      },
      videosComprensor: {
        EVC00100: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012-2019",
          nComprensor: "1063369-00-G",
          referenciasDisponibles: "EVC00100",
          videoId: "A_h7O2TGtEU"
        },
        EVC00200: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012-2017",
          nComprensor: "1028398-00-E",
          referenciasDisponibles: "EVC00200",
          videoId: "71wMqdMsqHg"
        },
        EVC00300: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012",
          nComprensor: "6007380-00-C",
          referenciasDisponibles: "EVC00300",
          videoId: "Ok9Q-mgfJmw"
        },
        EVC00400: {
          id: "tesla",
          modelo: "Tesla Model X",
          año: "2015-2025",
          nComprensor: "1042442-00-D",
          referenciasDisponibles: "EVC00400",
          videoId: "5gOHPBtBtbA"
        }
      },
      hazte_experto: "¡TORNE-SE ESPECIALISTA!",
      reparacion_vehiculos: "NA REPARAÇÃO DE VEÍCULOS HÍBRIDOS E ELÉTRICOS!",
      reparacion_vehiculos_descripcion:
        "Apenas 1% dos mecânicos são especializados na reparação de veículos elétricos. <strong>Você pode ser um deles</strong> graças ao material didático que a Ajusa inclui em todos os seus componentes para veículos híbridos e elétricos.",
      reparacion_vehiculos_descripcion_2:
        "<strong>Digitalize o código QR</strong> que encontrará na etiqueta de cada produto para aceder a um tutorial em vídeo que o guiará passo a passo ao longo do processo de reparação.",
      ajusa_te_lo_pone_facil: "COM A AJUSA É MUITO MAIS FÁCIL",
      opiniones_titulo: "OPINIÕES",
      opiniones: {
        opinion1: {
          cliente: "Julián Fernández | Electromecánica",
          descripcion:
            "“Uma solução prática e didática que ajudou a aprimorar os meus conhecimentos sobre mecânica de veículos elétricos. Também estou muito satisfeito com a qualidade dos componentes para veículos elétricos fabricados pela Ajusa.”"
        },
        opinion2: {
          cliente: "Juan Soler | Taller AGR",
          descripcion:
            "“Com os vídeos da Ajusa aprendi a reparar motores elétricos. Recomendo o uso deste material em todas as oficinas para aprender sobre mecânica de veículos elétricos.”"
        },
        opinion3: {
          cliente: "Bienvenido Martínez | Talleres El Paso",
          descripcion:
            "“Basta escanear o código QR da etiqueta do produto que se vai usar para ver um interessante tutorial de montagem de todas as peças. Muito prático e simples.”"
        },
        opinion4: {
          cliente: "Diego González | Garage Motor",
          descripcion:
            "“Fiquei surpreendido com o profissionalismo do mecânico que aparece nos vídeos e como explica passo a passo a reparação e montagem do motor. São vídeos muito úteis para qualquer mecânico. Vou continuar a utilizá-los nas próximas reparações.”"
        }
      },
      dropdowns: {
        "dropdown-1": {
          title: "COMPONENTES PARA CARROS ELÉTRICOS",
          content:
            "<p>Quando se trata da reparação de <strong>componentes de veículos elétricos (VE)</strong>, conhecer esses componentes é essencial para garantir um serviço eficiente e de alta qualidade. Na Ajusa, temos uma vasta experiência na reparação de todos os elementos fundamentais que fazem um carro elétrico funcionar.</p><h3><strong>Motor elétrico</strong></h3><p>Este componente do seu carro elétrico requer atenção especializada em caso de problemas. Nossos técnicos treinados estão prontos para diagnosticar e reparar qualquer falha no motor elétrico, garantindo um desempenho ótimo.</p><h3><strong>Bateria de tração</strong></h3><p>A bateria de tração é um componente crítico em carros elétricos e sua reparação é essencial para manter a autonomia e eficiência do seu veículo.</p><h3><strong>Bateria auxiliar</strong></h3><p>Além da bateria principal, os veículos elétricos possuem uma bateria auxiliar que alimenta sistemas críticos. Se precisar de assistência com a bateria auxiliar, nossa equipe está pronta para ajudar.</p><h3><strong>Conversor de energia</strong></h3><p>O conversor de energia desempenha um papel importante na gestão de energia. Problemas neste componente do seu carro elétrico podem afetar o desempenho geral.</p><h3><strong>Carregador a bordo</strong></h3><p>Carregar um veículo elétrico é uma parte fundamental de sua operação diária. Se você tiver problemas com o carregador a bordo, podemos oferecer soluções eficazes para garantir que seu veículo esteja sempre pronto para a estrada.</p><h3><strong>Transmissão</strong></h3><p>As transmissões em veículos elétricos são diferentes das de veículos de combustão interna e requerem conhecimento especializado.</p><h3><strong>Tomada de carregamento</strong></h3><p>A tomada de carregamento é a porta de entrada para a energia em seu veículo elétrico. Se você tiver problemas com a tomada de carregamento, podemos ajudá-lo a carregar seu veículo sem preocupações.</p><h3><strong>Módulo eletrônico</strong></h3><p>Módulos eletrônicos desempenham um papel crucial em sua operação.</p>"
        },
        "dropdown-2": {
          title: "COMPONENTES PARA CARROS HÍBRIDOS",
          content:
            "<p> Quando se trata de <strong>veículos híbridos</strong>, é essencial entender os elementos fundamentais que tornam seu funcionamento eficiente possível.</p><p> Na <strong>Ajusa</strong>, acumulamos uma vasta experiência na reparação desses componentes, o que nos permite oferecer um serviço de alta qualidade e seguro.</p><h3><strong>Motor de combustão</strong></h3><p> Manter este componente do seu carro híbrido em boas condições é essencial. Na Ajusa, oferecemos serviços de reparo e manutenção para garantir que seu desempenho seja eficiente e com baixas emissões.</p><h3><strong>Motor elétrico-gerador</strong></h3><p> O motor elétrico-gerador é um componente essencial em um carro híbrido, pois converte energia cinética em eletricidade para carregar as baterias.</p><h3><strong>Inversor</strong></h3><p> O inversor é responsável por converter a energia elétrica armazenada nas baterias em energia utilizável para o motor elétrico. Se você tiver problemas com o inversor, estamos preparados para oferecer uma solução para quaisquer reparos necessários.</p><h3><strong>Baterias</strong></h3><p> Este componente do seu carro híbrido garante seu correto funcionamento. Portanto, na Ajusa, oferecemos serviços de reparo e substituição para manter a autonomia do seu veículo.</p>"
        }
      },
      solucionesAftermarkert: "SOLUÇÕES AFTERMARKET",
      subtitulo_soluciones: "PARA VEÍCULOS HÍBRIDOS E ELÉTRICOS",
      descripcion_soluciones:
        "A Ajusa é o <strong>primeiro fabricante a nível mundial especializado</strong> no desenvolvimento e fabrico de componentes para a reparação de veículos híbridos e elétricos. Rede de distribuição internacional em mais de 80 países.",
      solicita_info: "PEÇA INFORMAÇÃO",
      alt_images: {
        tag_ajusa: "etiqueta ajusa",
        juntas_electricos: "juntas para veículos elétricos"
      }
    },
    sobre_nosotros: {
      nav_options: {
        ajusa: {
          title: "ajusa",
          category: "sobre_nosotros",
          href: "ajusa"
        },
        historia: {
          title: "nossa historia",
          category: "aniversario50",
          href: "50-anniversary"
        },
        blog: {
          title: "blog",
          category: "blog",
          href: "blog"
        },
        contacto: {
          title: "contato",
          category: "contacto",
          href: "contato"
        },
        canal_etico: {
          title: "Canal Ético",
          redirect: "https://ajusa.canales-eticos.com"
        },
        trabaja_con_nosotros: {
          title: "Trabalhe conosco",
          href: "trabalhe-conosco"
        }
      }
    },
    politica_privacidad:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">POLÍTICA DE PROTEÇÃO DE DADOS</h1><p>A direção/órgão diretivo da AUTO JUNTAS SAU (doravante, a pessoa responsável pelo tratamento), assume a máxima responsabilidade e compromisso com o estabelecimento, implementação e manutenção desta política de protecção de dados, garantindo a melhoria contínua do controlador de dados. O objetivo de alcançar a excelência no que respeita ao cumprimento do Regulamento (UE) 2016/679 do Parlamento Europeu e do Conselho, de 27 de abril de 2016, relativo à proteção das pessoas fisicas no que diz respeito ao tratamento de dados pessoais e à livre circulação destes dados e que revoga a Diretiva 95/46/CE (regulamento geral de proteção de dados) (OJEU L 119/1, 04-05-2016) e a legislação espanhola sobre a proteção de dados pessoais (lei orgânica, legislação setorial específica e seus regulamentos de desenvolvimento).</p><br><p>A política de proteção de dados da AUTO JUNTAS SAU conta com o princípio da responsabilidade pró-ativa, segundo o qual o responsável pelo controle é o cumprimento do quadro normativo e jurisprudencial que rege a referida política e é capaz de autoridades de controlo competentes.</p><br><p>Neste sentido, a pessoa responsável pelo tratamento será regida pelos seguintes princípios que devem servir também a todo o seu pessoal como guia e quadro de referência no tratamento de dados pessoais:</p><p>1. Proteção dos dados do projeto: o controlador será aplicado, tanto no momento da determinação dos meios de tratamento e no momento do tratamento propriamente dito, medidas técnicas e organizacionais apropriadas, como a pseudoutilização, projetada para aplicar efetivamente o princípios de proteção de dados, tais como a minimização de dados, e integrar as garantias necessárias no tratamento.</p><p>2. Proteção de dados por padrão: o controlador de dados aplicará as medidas técnicas e organizacionais apropriadas para garantir que, por padrão, somente os dados pessoais necessários para cada um dos propósitos específicos do processamento serão processados.</p><p>3. Proteção de dados no ciclo de vida da informação: as medidas que garantem a proteção dos dados pessoais serão aplicáveis durante todo o ciclo de vida das informações.</p><p>4. Legalidade, lealdade e transparência: os dados pessoais serão tratados de forma legal, justa e transparente em relação à parte interessada.</p><p>5. Limitação por objetivo: os dados pessoais serão coletados para fins específicos, explícitos e legítimos, e não serão processados de forma incompatível com os ditos propósitos.</p><p>6. Minimização dos dados: os dados pessoais serão adequados, pertinentes e limitados ao que é necessário em relação aos fins para os quais são tratados.</p><p>7. Exatidão: os dados pessoais serão exatos e somente quando necessário. Devem ser tomadas todas as medidas razoáveis para que os dados pessoais imprecisos relativamente aos fins para os quais são tratados sejam corrigidos sem demora.</p><p>8. Limitação do período de conservação: os dados pessoais serão mantidos de forma a permitir a identificação das partes interessadas durante não mais tempo do que o necessário para efeitos de tratamento de dados pessoais.</p><p>9. Integridade e confidencialidade: os dados pessoais serão tratados de forma a garantir a segurança adequada dos dados pessoais, incluindo a proteção contra o tratamento não autorizado ou ilegal e contra a perda, destruição ou danos acidentais, através da aplicação de medidas técnicas ou organizacionais de segurança adequadas.</p><p>10. Informação e formação: uma das chaves para garantir a proteção dos dados pessoais é a formação e informação prestada ao pessoal envolvido no seu tratamento. Durante o ciclo de vida da informação, todo o pessoal com acesso aos dados serão devidamente treinados e informado sobre suas obrigações em relação ao cumprimento das regulamentações de proteção de dados.</p><br><p>A política de proteção de dados da AUTO JUNTAS SAU é comunicada a todo o pessoal responsável pelo tratamento de dados e disponibilizada a todas as partes interessadas.</p><br><p>Consequentemente, esta política de proteção de dados envolve todo o pessoal responsável pelo tratamento de dados, que deve conhecê-la e assumi-la, considerando-a como sua, assim como cada membro responsável pela sua aplicação, atentando as regras de proteção de dados aplicáveis a sua atividade, bem como identificar e contribuir com as oportunidades de melhoria que julgar adequadas com o objetivo de alcançar a excelência em relação a segurança de dados.</p><br><p>Esta política será revista pela direção/órgão diretivo da AUTO JUNTAS SAU, quantas vezes a mesma julgar necessária, para adaptar, em todos os momentos, às atuais disposições relativas à proteção de dados pessoais.</p></div></div>',
    datos_seguros:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">SEUS DADOS ESTÃO SEGUROS</h1><p class="bold">Informações em conformidade com a regulamentação da proteção de dados pessoais</p><p>Na Espanha e toda Europa existem regras de proteção de dados destinadas a proteger as suas informações pessoais que são obrigatórias para a nossa entidade.</p><p>Por esta razão, é muito importante para nós que compreendam perfeitamente o que vamos fazer com os dados pessoais que pedimos.</p><p>Assim, nós seremos transparentes e nós lhe daremos o controle de seus dados, com uma língua simples e opções desbloqueadas que permitirão que você decida o que nós faremos com suas informações pessoais.</p><p>Por favor, se depois de ler esta informação você tem alguma dúvida, não hesite em nos enviar seu questionamento.</p><p>Muito obrigado por sua colaboração.</p><p class="bold">Quem somos nós?</p><ul><li>Nome legal:<b>AUTO JUNTAS SAU</b></li><li>IVA:<b>A02007029</b></li><li>Atividade principal:<b>INDUSTRIAL</b></li><li>Nosso endereço:<b>Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02008, Albacete (Albacete)</b></li><li>Telefone:<b>967-216212</b></li><li>Email:<u><b><a href="mailto:ajusa@ajusa.es">ajusa@ajusa.es</a></b></u></li><li>Web site: www.ajusa.online</li></ul><p>Para a sua confiança e segurança, informamos que somos registrados nas devidas entidades comerciais e públicas.</p><p>A nossa atividade principal está sujeita a um regime de autorização administrativa prévia. Para sua confiança e segurança, nós fornecemos-lhe os dados relacionados com esta autorização e a identificação do corpo competente de nossa supervisão.</p><p class="bold">Para que vamos usar os seus dados?</p><p>Em geral, seus dados pessoais serão usados para que possamos ter um melhor relacionamento com você e ser capaz de fornecê-lo com nossos serviços.</p><p>Da mesma forma, eles também podem ser usados para outras atividades, como a publicidade ou a promoção de nossas atividades.</p><p class="bold">Por que precisamos dos seus dados?</p><p>Seus dados pessoais são necessários para que possamos ser capazes de manter um melhor relacionamento com você e sermos capazes de fornecer os nossos serviços da maneira adequada. Neste sentido, colocaremos à sua disposição uma série de opções que permitirão que você decida de forma clara e simples sobre o uso de suas informações pessoais.</p><p class="bold">Quem vai saber a informação que pedimos?</p><p>Em geral, apenas o pessoal da nossa empresa devidamente autorizado pode ter conhecimento das informações que solicitamos.</p><p>Da mesma forma, pode estar ciente de suas informações pessoais aquelas entidades que precisam ter acesso as mesmas para que possamos fornecer nossos serviços. Por exemplo, nosso banco saberá seus dados se o pagamento de nossos serviços for feito por cartão ou transferência bancária quando e se houver esta opção de serviço em sua região.</p><p>Da mesma forma, suas informações serão conhecidas por entidades públicas ou privadas às quais somos obrigados a fornecer seus dados pessoais devido ao cumprimento de qualquer lei. Para lhe dar um exemplo, a lei tributária exige que a Agência tributária forneça certas informações sobre operações econômicas que excedam um determinado montante.</p><p>No caso de, independentemente dos pressupostos acima mencionados, precisamos divulgar suas informações pessoais para outras entidades, vamos pedir a sua permissão antecipadamente através de opções claras que lhe permitirão decidir a este respeito.</p><p class="bold">Como vamos proteger os seus dados?</p><p>Protegeremos seus dados com medidas de segurança efetivas com base nos riscos envolvidos no uso de suas informações.</p><p>Para isso, nossa entidade aprovou uma política de proteção de dados e controles anuais e auditorias que são realizadas para verificar se seus dados pessoais são seguros em todos os momentos.</p><p class="bold">Enviaremos seus dados para outros países?</p><p>No mundo existem países que são seguros para os seus dados e outros que não são tão seguros. Por exemplo, a União Europeia é um ambiente seguro para os seus dados. Nossa política não é enviar suas informações pessoais para qualquer país que não é seguro do ponto de vista para sua proteção de seus dados.</p><p>No caso de, a fim de fornecer o serviço, ser essencial enviar seus dados para um país que não é tão seguro como a Espanha, vamos sempre pedir a sua permissão e aplicar medidas de segurança eficazes que reduzam os riscos quanto ao envio de suas informações pessoaispara outro país.</p><p class="bold">Por quanto tempo vamos manter seus dados?</p><p>Manteremos seus dados durante nosso relacionamento e em conformidade com prazoa previstos legalmentes. Uma vez que os prazos legais aplicáveis forem finalizados, vamos proceder para eliminá-los de uma forma segura e ambientalmente controladas.</p><p class="bold">Quais são os seus direitos de proteção de dados?</p><p>A qualquer momento você pode entrar em contato conosco para saber quais informações temos sobre você, corrigi-lo se necessário ou eliminá-lo uma vez que o nosso relacionamento é concluído, sendo legalmente possível.</p><p>Você também tem o direito de solicitar a transferência de suas informações para outra entidade. Este direito é chamado de "portabilidade" e pode ser útil em determinadas situações.</p><p>Para solicitar qualquer um desses direitos, você deve fazer um pedido por escrito para o nosso endereço, juntamente com uma fotocópia do seu documento de identidade oficial, para ser capaz de identificá-lo.</p><p>Nos escritórios da nossa entidade temos formulários específicos para solicitar estes direitos e oferecemos a nossa ajuda para completá-los.</p><p>Para saber mais sobre seus direitos de proteção de dados, você pode consultar o site da agência espanhola de proteção de dados (www.agpd.es).</p><p class="bold">Posso retirar meu consentimento caso mude de idéia em um momento posterior?</p><p>Você pode retirar seu consentimento se você mudar de idéia sobre o uso de seus dados a qualquer momento.</p><p>Por exemplo, se você estava interessado em receber publicidade para os nossos produtos ou serviços, mas não deseja mais receber mais publicidade, você pode deixar-nos saber através da forma de oposição ao tratamento disponível nos escritórios da nossa entidade.</p><p class="bold">No caso de entender que meus direitos foram negligenciados, possoabrir uma reclamação?</p><p>No caso de você entender que seus direitos foram ignorados por nossa empresa, você pode apresentar uma reclamação com a agência espanhola de proteção de dados, através de um dos seguintes meios:</p><ul><li>Escritório eletrônico: www.agpd.es</li><li>Endereço postal: Agencia Española de Protección de Datos C/ Jorge Juan, 6 28001-Madrid</li><li>Telefone::<br>Telf. 901 100 099<br>Telf. 91 266 35 17<br></li></ul><p>Para apresentar uma reclamação na agência espanhola de proteção de dados não implica qualquer custo e a assistência jurídica por um advogado não é necessário.</p><p class="bold">Vamos elaborar perfis sobre você?</p><p>Nossa política não é para perfis sobre os usuários de nossos serviços. No entanto, pode haver situações em que, para a finalidade de fornecer o serviço, comercial ou de outra forma, precisamos desenvolver perfis de informações sobre você. Um exemplo pode ser o uso da sua compra ou histórico de serviços para poder oferecer-lhe produtos ou serviços adaptados aos seus gostos ou necessidades.</p><p>Neste caso, aplicaremos medidas de segurança efetivas que protejam suas informações em todas as vezes para que pessoas não autorizadas que possam pretender usá-las para seu próprio benefício.</p><p class="bold">Usaremos seus dados para outros propósitos?</p><p>Nossa política não é usar seus dados para outros propósitos do que aqueles que explicamos a você. Se, no entanto, precisarmos usar seus dados para diferentes atividades, nós sempre solicitaremos sua permissão antecipadamente através de opções claras que permitirão que você decida sobre isso.</p></div></div>',
    politica_cookies:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">POLITICA DE COOKIES</h1><p class="bold">Informações em conformidade com os regulamentos de proteção de dados pessoais</p><p class="bold">- O que são os cookies e para que servem?</p><p>Um cookie é um pequeño arquivo de dados que é armazenado em seu navegador de internet cada vez que você visitar nosso site.</p><p>A utilizade dos cookies são para guardar um histórico da sua atividade em nossa página web, para que quando a visite novamente se possa identificar e configurar automáticamente o conteúdo com base em seus hábitos de navegação, identificação e preferências.</p><p>Um cookie é inofensivo, não contém qualquer malware ou código malicioso (por exemplo, vírus, trojans, worms, etc) que pode danificar o seu equipamento (computador, Smartphone, Tablet, etc), mas tem algum impacto sobre o seu direito à proteção de dados, uma vez que recolhe certas informações sobre você (hábitos de navegação, identidade, preferências, etc.).</p><p class="bold">Quais informações são armazenadas por um cookie?</p><p>Normalmente, os cookies não recolhem categorias especiais de dados pessoais (dados confidenciais). Os dados que armazenam são de natureza técnica, preferências pessoais, personalização de conteúdos, etc.</p><p class="bold">Quais tipos de cookies existem?</p><p>De um modo geral,esistem cinco tipos de programas cookies:</p><ul><li><p class="bold">Cookies Técnicos:</p><p>Estes são os cookies mais básicos. Eles acompanham a nevegação do usuário por uma página da Web, plataforma ou aplicativo e aramazena as diferentes opções ou serviços disponíveis, como, por exemplo, tráfego e a comunicação de dados, identificações de sessão, acesso a áreas restritas, lembrando os itens que compõem uma escolha, processos ou solicitação de uma ordem de compra, solicitação ou registro de participação em um evento, uso de elementos de segurança durante a navegação, armazenando os conteúdos para a disseminação de vídeos, som ou compartilhamento através de mídias sociais durente a sua navegação.</p></li><li><p class="bold">Cookies de Personalização:</p><p>Estes são os cookies que permitem ao usuário acessar o serviço com determinadas características gerais predefinidas de acordo com uma série de critérios no terminal do usuário, como o idioma, o tipo de navegador usado para acessar o serviço, a configuração regional de que o serviço é acessado, etc.</p></li><li><p class="bold">Cookies Analiticos:</p><p>Estes são os cookies que permitem que a parte responsável por eles monitorem e analisem o comportamento dos usuários nos sites que estão ligados. As informações recolhidas através destes cookies são utilizadas para medir a atividade dos websites, aplicação ou plataforma, para a preparação de perfis de navegação para os utilizadores destes websites, aplicações e plataformas, possam intriduzir melhorias.</p></li><li><p class="bold">Cookies de Publicidade:</p><p>Estes cookies permitem uma gestão mais eficiente dos espaços publicitários, se houver, que o responsável pelo programa incluiu em uma página Web, aplicação ou plataforma a partir do qual o desenvolvedor fornece o serviço ou opção de compra solicitado ou recém pesquizado com base em critérios como o conteúdo publicados ou a frequência com que são apresentados anúncios nas pesquisas do usuario.</p></li><li><p class="bold">Cookie de publicidade comportamental:</p><p>Estes cookies permitem uma gestão mais eficiente dos espaços publicitários, se houver, que o responsável pelo programa incluiu em uma página Web, aplicação ou plataforma a partir da qual o serviço solicitado é prestado. Esses cookies armazenam informações sobre o comportamento dos usuários, obtidas por meio da observação contínua de seus hábitos de navegação, permitindo assim que desenvolvam um perfil específico para exibir a propaganda com base neste perfil.</p></li></ul><p class="bold">O que são cookies próprios ou de terceiros?</p><ul><li><p class="bold">Cookies próprios:</p><p>São cookies criados e controlados pelo responsável pela prestação do serviço solicitado pelo usuario.</p></li><li><p class="bold">Cookies de terceros:</p><p>São aqueles cookies gerados por entidades não responsáveis pelo site visitado ( Serviços externos ou buscadores como Google )</p></li></ul><p class="bold">Que tipo de cookies o nosso site armazena?</p><p>A seguir listamos os tipos de cookies armazenados em nosso website e sua finalidade:</p><ul><li class="no-disc"><p class="bold">- Tipo de Cookie</p><p>Cookies de terceros, analíticos Google Analytics</p></li><li class="no-disc"><p class="bold">- Propósito</p><p>Monitoramento e análise do comportamento do usuário no site. As informações coletadas através deste tipo de cookie é usado para medir a atividade em sites, criar perfis de navegação para os usuários desses sites, aplicações e plataformas, a fim de fazer melhorias com base na análise dos dados sobre como os visitantes usam o Serviço</p></li><li class="no-disc"><p class="bold">- Quando e como é feito o armazenamento</p><p>O cookie registra a atividade do usuário em tempo real durante a navegação e os dados são armazenados no aplicativo do Google Analytics.</p></li></ul><p>O site da AJUSA também funciona com o aplicativo de armazenamento local.</p><p class="bold">O que posso fazer com os cookies?</p><p>Os cookies podem ser apagados, aceitos ou bloqueados como você desejar. Para isso, você só precisa configurar o seu navegador da Web da maneira que lhe atenda.</p><p>A qualquer momento, você pode impedir a instalação de cookies em seu computador usando a opção correspondente de seu navegador, porém neste caso não podemos garantir o funcionamento correto das várias características em nosso site.</p><p>Abaixo, fornecemos links para gerenciar e bloquear cookies, dependendo do navegador que você usa:</p><p>Internet Explorer:<u><a href="http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10">http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10</a></u></p><p>FireFox:<u><a href="http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we">http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we</a></u></p><p>Chrome:<u><a href="https://support.google.com/chrome/answer/95647?hl=es">https://support.google.com/chrome/answer/95647?hl=es</a></u></p><p>Safari:<u><a href="https://www.apple.com/legal/privacy/es/cookies/">https://www.apple.com/legal/privacy/es/cookies/</a></u></p>Você também pode excluir os cookies que você armazenou no seu navegador entrand nas opções de configuração.</div></div>',
    aviso_legal:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">TERMOS E CONDIÇÕES</h1><p>I.-<span class="bold">A utilização,</span>pesquisa ou contratação de qualquer serviço estabelecido em nosso site www.ajusa.online implica a aceitação completa, sem qualquer reserva das presentes condições gerais, que regulam a relação jurídica decorrente dos processos de negociação realizados entre usuários e/ou clientes do site www.ajusa.online propriedade da auto juntas S.A. (doravante Ajusa). Os clientes aceitam estas condições gerais no momento em que utilizam ou compram qualquer produto. Este documento pode ser impresso para ser lido ou guardado pelos clientes antes de sua aceitação.</p><p>II.-<span class="bold">As presentes condições gerais,</span>estão sujeitas à aplicação da seguinte legislação espanhola: Lei 7/1998 em 13 de Abril sobre as condições gerais contratuais, Decreto-lei Real 1/2007 em 16 de novembro, editado para atendimento aos consumidores e usuários conforme lei de proteção e outros atos complementares, Decreto Real 1906/1999 em 17 de dezembro 1999 Regulamento de contratação telefônica ou eletrônica com as condições gerais, proteção de dados pessoais. Lei Orgânica 15/1999 em 13 de dezembro, regulação de execução, comércio varejista Lei de gestão 7/1996 em 15 de Janeiro, sociedade da informação e serviços de comércio eletrônico Ata 34/2002 em 11 de julho.</p><p>III.-<span class="bold">Alteração das condições gerais.</span>A Ajusa deve alterar estas condições gerais mediante aviso geral aos seus clientes com o intuito de melhorar os serviços e produtos oferecidos através da Ajusa. A alteração das condições gerais estabelecidas no site AJUSA deve ser entendida como um aviso. Em todos os casos, estas condições gerais podem ser consultadas antes de utilizar qualquer serviço ou compra de produtos.</p><p>IV.-<span class="bold">Propriedade intelectual.</span>Todo o conteúdo deste site (incluindo código fonte, imagens, textos, gráficos, etc.) está protegido pela legislação local e estrangeira sobre propriedade intelectual em vigor, sendo todos os direitos reservados. É estritamente proibida a reprodução de qualquer conteúdo no site sem autorização expressa da Ajusa e titulares de direitos.</p><p>Por meio da compra de qualquer produto, Ajusa não concede qualquer direito de alteração, exploração, reprodução, distribuição ou comunicação pública sobre tal produto, todos os direitos são reservados. A transferência desses direitos exigirá autorização prévia por escrito da detentora Ajusa. O uso não autorizado das informações dentro deste site, sua revenda, bem como a violação de direitos sobre propriedade intelectual ou industrial resultará no passivo legalmente estabelecido.</p><p>V.-<span class="bold">Utilização do serviço e passivos</span>A Ajusa não garante a disponibilidade permanente dos serviços, sendo isenta de qualquer responsabilidade por danos decorrentes da indisponibilidade do produto devido a força maior ou erros logisticos além de seu controle. Ajusa não assumirá responsabilidade pelo conteúdo dos links para sites que são propriedade de terceiros e, portanto, também estão além de seu controle.</p><p>VI.-<span class="bold">Proteção de dados.</span>EDe acordo com a seção 5 da lei orgânica de proteção de dados pessoais espanhola 15/1999 em 13 de dezembro, a sociedade da informação e o serviço de comércio eletrônico Ata 34/2002 em 11 de julho, a auto juntas, S.A. (doravante Ajusa) informa que os dados pessoais fornecidos em formulários de registro incluídos neste site, bem como dados acessados pela Ajusa como consequência de sua navegação; pesquisa, solicitação ou contratação ou qualquer transação ou ação feita neste site serão coletadas e armazenadas a legislação em vigor e a responsabilidade de: auto juntas, S.A., parque empresarial Ajusa. Ctra. De Ayora km 2,2 02008. Albacete.<u><a href="mailto:social@ajusa.es.">social@ajusa.es.</a></u></p><p>A finalidade de coletar e processar dados pessoais através dos formulários e do contato pelo email neste local é facilitar a prestação de serviços pela Ajusa através destes locais, assim como fornecer a informação sobre atividades e notícias que pode ser do interesse ao usuario.</p><p>A remessa de dados pessoais através dos formulários neste site ou por meio de mensagens de e-mail que exijam informações ou serviços implica o consentimento expresso do usuário para processar tais dados, bem como a remessa eletrônica de comunicações com informações sobre nossas atividades.</p><p>Portanto, o usuário mostra o consentimento expresso para a incorporação de dados pessoais a arquivos de dados pessoais e esses dados a serem processados pela Ajusa para os propósitos mencionados acima. O usuário igualmente expressa a aceitação e a autorização de modo que Ajusa possa transferir dados pessoais às companhias que prestam serviços a Ajusa tal como bancos e companhias de seguros.</p><p>O usuário garante que os dados pessoais fornecidos à Ajusa são reais e assumem a responsabilidade de comunicar qualquer modificação.</p><p>Ajusa disponibiliza para os usuários o endereço de e-mail social@ajusa.es e o telefone (+ 34) 967 216 212 para que eles revoguem esse consentimento. A Ajusa confirma a aplicação do regulamento em vigor em relação à proteção de dados, particularmente a lei espanhola de proteção de dados pessoais 15/1999 em 13 de dezembro e o decreto real espanhol 1720/2007 em 21 de dezembro, implementando tal lei e a Ajusa disponibiliza a seus clientes os meios de contato mencionados neste parágrafo para que exerçam os seus direitos de acesso, retificação, cancelamento e oposição concedidos pela legislação em vigor.</p><p>VII.-<span class="bold">Segurança.</span>A Ajusa garante as medidas de segurança apropriadas para as suas instalações, sistemas e ficheiros, bem como o tratamento confidencial dos dados pessoais, nos termos da legislação aplicável em vigor, e informa sobre a execução de medidas de segurança de carácter técnico e natureza organizacional, a fim de garantir a segurança dos seus dados pessoais e de evitar a sua alteração, perda e processamento ou acesso não autorizado, tendo em conta o estado da tecnologia, a natureza dos dados armazenados e que podem enfrentar os riscos decorrentes tanto ação humana e ambiente físico ou natural. Isso é feito na seção 9 da lei orgânica de proteção de dados pessoais espanhola e do decreto real espanhol 1720/2007, em 21 de dezembro, passando pelo Regulamento de implementação da lei orgânica e pela lei espanhola de sociedade da informação e comércio eletrônico 34/2002 em julho 12.</p><p>Ajusa está empenhada em tratar dados pessoais confidencialmente e utilizá-lo exclusivamente para os fins mencionados.</p><p>VIII.-<span class="bold">Comunicações de comércio electrônico</span>A Ajusa disponibiliza para os usuários, após pedido de inscrições para esse fim, as notícias, atividades e informações. O usuário pode cancelar o serviço de comunicação a qualquer momento enviando um e-mail para:<u><a href="mailto:social@ajusa.es.">social@ajusa.es.</a></u></p><p>IX.<span class="bold">Informações gerais.</span>Em 11 de julho, a Ajusa confirma a aplicação do direito de informação nos termos previstos no presente regulamento, no âmbito da sociedade da informação e dos serviços de comércio eletrónico 34/2002, a fim de permitir que os compradores de serviços e os organismos autorizados forma permanente, fácil, direta e livre para as seguintes informações: auto juntas, S.A., parque empresarial Ajusa. Crta. De Ayora km 2,2. 02008 Albacete. Espanha. www.ajusa.online. telefone: (+ 34) 967 216 212 fax: 967 216 214. Registro de informações no registro de empresas: livro: 311, folha: 186, página: AB-1504, número de identidade fiscal: A-02007029.</p><p>X.<span class="bold">Informações sobre o uso de cookies</span>EO uso deste site será feito com a responsabilidade exclusiva do usuário. Essa responsabilidade será estendida ao uso pelo usuário ou por qualquer terceiro, de qualquer senha o semelhante atribuída para acessar o site ou qualquer um dos seus serviços.. En cualquier caso, el Usuario podrá denegar o impedir la instalación de estas cookies modificando la configuración de su navegador.</p><p>A Ajusa não assume qualquer responsabilidade decorrente do conteúdo vinculado ao site, contanto que não estejam relacionadas a ele e não garanta a ausência de vírus ou outros elementos que possam produzir alterações em hardware e software, nos documentos ou arquivos do usuário, excluindo qualquer responsabilidade por danos ao usuário decorrente deste motivo.Ajusa recusa qualquer responsabilidade decorrente do uso errado do conteúdo nesses sites e reserva o direito de apagá-los, estabelecer restrições ou restringir o acesso a qualquer momento de forma temporária ou permanente.</p><p>XII.-<span class="bold">Nulidade e ineficácia das cláusulas.</span>Se qualquer cláusula incluída nestas condições gerais for declarada nula ou ineficaz, total ou parcialmente, tal nulidade ou ineficácia só afetará a tal cláusula ou a parte nula ou ineficaz, substituindo o restante das condições gerais, considerando tal cláusula ou parte como apagado.</p><p>XIII.-<span class="bold">Conflitos.</span>A legislação espanhola aplicar-se-á a qualquer disputa ou conflito, sendo os tribunais de Albacete autorizados a resolver todos os conflitos que o suscitem.</p><p>O acesso a este site implica a aceitação de todas as condições expressas nesta informação legal. Ajusa deve modificar ou sem aviso prévio a estrutura e design do site, bem como alterar ou eliminar os serviços, conteúdos e condições de acesso e uso do site e adaptá-lo a qualquer mudança legal.</p></div></div>',
    popupCocheElectrico: {
      title: "E AGORA...<strong>COMPONENTES PARA VEÍCULOS ELÉTRICOS!</strong>",
      btnText: "VISITA"
    }
  },
  fr: {
    alt_images: {
      logo_ajusa: "Ajusa",
      app_movil: "Application mobile Ajusa",
      google_play: "Télécharger l'application sur Google Play",
      app_store: "Télécharger l'application sur l'App Store",
      telefono: "Appeler Ajusa par téléphone",
      email: "Envoyer un e-mail à Ajusa",
      vehiculo_electrico: "Ajusa Electric Vehicle Line",
      cerrar: "Fermer",
      retenes: "Joints d'étanchéité Ajusa",
      ver_video: "Voir la vidéo",
      ajustick: "Ajustick, mastic anaérobie Ajusa",
    },
    cookieEyes: "045d3ec4b8d29118370163bd",
    recaptchaId: "6Lee-m8fAAAAABTeuBvigSTzmj9MGBqTtnldUAo8",
    isotag: "fr-FR",
    enlaces: {
      home: "/",
      productos: "produits",
      product: "produit",
      productos_quimicos: "produits-chimiques",
      catalogo: "catalogue",
      area_tecnica: "domaine-technique",
      asesoramiento: "conseils",
      ajusa: "ajusa",
      actualidad: "nouveautes",
      contacto: "contacter",
      trabaja_con_nosotros: "travaillez-avec-nous",
      donde_estamos: "contacter",
      solicite_catalogo: "contacter#catalogo",
      blog: "blog",
      blog_noticia: "blog/nouvelles",
      blog_categoria: "blog/categorie",
      categoria: "categorie",
      ferias: "salons",
      historia: "histoire",
      nuestro_sector: "notre-secteur",
      compromiso_social: "engagement-social",
      sala_prensa: "salle-de-presse",
      mapa_web: "plan-du-site",
      politica: "politique-de-confidentialite",
      politica_cookies: "politique-de-cookies",
      datos_seguros: "secky-consentcurite-de-vos-donnees",
      aviso_legal: "mentions-legales",
      aniversario50: "50e-anniversaire",
      vehiculo_electrico: "vehicule-electrique",
      sobre_nosotros: "ajusa",
      productos_certificados: "/static/pdf/environment-certificate.pdf",
      productos_certificados_calidad: "/static/pdf/quality-certifications.pdf",
      condiciones_venta: "/static/pdf/condiciones-de-venta-en.pdf",
      catalogo_online: "https://web.tecalliance.net/ajusa/fr/",
      bonos_ajusa: "obligations-ajusa",
      thank_you_page: "merci",
      newsletter_thank: "newsletter/merci",
      online_store: "https://ev-customers.eu.ajusa.online/fr/",
      certificado_IATF_16949: "/static/pdf/IATF-16949-en.pdf",
      certificado_ISO_9001: "/static/pdf/ISO-9001-en.pdf",
      certificado_ISO_14001: "/static/pdf/ISO-14001-en.pdf",
      textos: {
        inicio: "Page d'accueil",
        productos: "Produits",
        catalogo: "Catalogue",
        otrosCatalogos: "Autres catalogues",
        area_tecnica: "Service Technique",
        ajusa: "Ajusa",
        actualidad: "Nouveautés",
        contacto: "Contact",
        sala_prensa: "Salle de presse",
        blog: "Blog",
        historia: "Histoire",
        tecnologias_hidrogeno: "Technologies utilisant l'hydrogène",
        contacto: "Contact",
        trabaja_con_nosotros: "Travaillez avec nous",
        mapa_web: "Plan du site",
        condiciones_venta: "Conditions de vente",
        politica_privacidad: "Politique de confidentialité",
        datos_seguros: "Sécurité de vos données",
        politica_cookies: "Politique d'utilisation des cookies",
        aviso_legal: "Mentions légales",
        catalogo_general: "Catalogue général",
        catalogo_turbos: "Catalogue turbos",
        catalogo_juntas_compresor: "Catalogue joints de compresseur",
        catalogo_retenes: "Catalogue joints d'étanchéité",
        catalogo_juegosJuntas: "Catalogue jeux de joints spéciaux",
        tec_alliance: "Catalogue en ligne",
        catalogo_impreso: "Demander un catalogue imprimé",
        newsletter: "Ajusa",
        catalogo_arandelas: "Catalogue rondelles en cuivre",
        catalogo_motor_electrico: "Catalogue VE",
        catalogo_comprensorAC:
          "Catalogue de joints de compresseur de climatisation",
        catalogo_toricas: "Catalogue toriques",
        catalogo_retenes: "Catalogue de joints à huile",
        aniversario50: "50e anniversaire",
        vehiculo_electrico: "Véhicule électrique",
        sobre_nosotros: "Á propos de nous",
        online_store: "ESPACE CLIENTS VE",
        certificado_IATF_16949: "IATF 16949",
        certificado_ISO_9001: "ISO 9001",
        certificado_ISO_14001: "ISO 14001"
      },
      seo: {
        home: {
          title: "Joints Ajusa | Solutions d'étanchéité moteur",
          description:
            "Ajusa est un fournisseur leader de joints de culasse. Avec plus de 50 ans d'expérience dans l'industrie, nous vous garantissons des produits de qualité et fiables."
        },
        productos: {
          title: "Produits | Joints Ajusa",
          description:
            "Achetez la meilleure sélection de pièces automobiles sur ajusa.online. Nos pièces et accessoires de haute qualité sont conçus pour vous aider à tirer le meilleur parti de votre véhicule"
        },
        catalogo: {
          title: "Catalogue | Joints Ajusa",
          description:
            "Obtenez les joints, joints et pièces de qualité supérieure dont vous avez besoin avec Ajusa. Parcourez notre catalogue de pièces d'origine et trouvez la pièce de rechange parfaite pour votre véhicule."
        },
        area_tecnica: {
          title: "Service technique | Joints Ajusa",
          description:
            "Ajusa propose une gamme d'options de joints et de solutions d'étanchéité. Trouvez le joint parfait pour vos besoins grâce à nos guides et produits techniques."
        },
        sobre_nosotros: {
          title: "À propos de nous | Qualité, service et équipe Ajusa",
          description:
            "Ajusa est l'un des principaux fournisseurs de joints et de joints de qualité supérieure pour le marché secondaire de l'automobile. Nous vous proposons un large choix de joints et joints."
        },
        aniversario50: {
          title: "Notre histoire | Joints Ajusa",
          description:
            "Découvrez l'histoire derrière Ajusa Joints - comment tout a commencé, comment cela a évolué et où nous en sommes maintenant. 50 ans d'expérience dans l'industrie du joint automobile."
        },
        ajusa: {
          title: "À propos de nous | Joints Ajusa",
          description:
            "Ajusa est l'un des principaux fournisseurs de joints et de joints de qualité supérieure pour le marché secondaire de l'automobile. Nous vous proposons un large choix de joints et joints."
        },
        actualidad: {
          title: "Dernières nouvelles | Joints Ajusa",
          description:
            "Recevez les dernières nouvelles sur les joints d'Ajusa. Nous couvrons tous les derniers développements de notre industrie, des lancements de produits aux avancées technologiques."
        },
        contacto: {
          title: "Contactez-nous | Joints Ajusa",
          description:
            "Besoin d'aide avec des joints ou des joints? Contactez Ajusa joints pour le meilleur service et support. Notre équipe expérimentée est prête à répondre à toutes vos questions"
        },
        blog: {
          title: "Blogue | Joints Ajusa",
          description:
            "Le blog d'Ajusa est un espace pour les professionnels et les experts du secteur automobile, pour les mécaniciens et les ateliers, sur lequel nous vous informons des dernières nouvelles d'Ajusa et de tout ce qui se passe dans le secteur des pièces détachées.",
          toblog: true
        },
        sala_prensa: {
          title: "Salle de presse | Joints Ajusa",
          description:
            "Restez à jour sur toutes les dernières nouvelles et lancements de produits d'Ajusa. Explorez notre salle de presse pour lire nos communiqués de presse, les descriptions de produits et plus encore"
        },
        trabaja_con_nosotros: {
          title: "Travaillez avec nous | Joints Ajusa",
          description:
            "Ajusa Joints est toujours à la recherche de professionnels motivés et travailleurs pour rejoindre notre équipe. Nous voulons de vos nouvelles. Envoyez-nous votre CV aujourd'hui."
        },
        historia: {
          title: "Histoire d'Ajusa | Plus de 50 ans dans l'automobile",
          description:
            "La société AJUSA a vu le jour en 1972 à Albacete (Espagne). Elle a commencé par fabriquer des joints de culasse et développe maintenant une gamme complète de composants de moteur et de pièces détachées."
        },
        mapa_web: {
          title: "plan du site | Joints Ajusa",
          description: "Plan du site Ajusa : accédez depuis un seul index à tous les produits, catalogues, service technique, salle de presse et à toutes les autres rubriques."
        },
        politica: {
          title: "Politique de confidentialité | Joints Ajusa",
          description:
            "La politique de protection des données d'AUTO JUNTAS SAU est basée sur le principe de la responsabilité proactive, selon lequel le responsable du traitement des données est responsable du respect du cadre réglementaire et jurisprudentiel qui régit cette politique."
        },
        politica_cookies: {
          title: "Politique de cookies | Joints Ajusa",
          description:
            "Un cookie est un petit fichier d'information qui est stocké dans votre navigateur chaque fois que vous visitez notre site web. Il enregistre l'historique de votre activité sur le site Web afin de pouvoir vous identifier et configurer le contenu en fonction de vos habitudes et préférences de navigation."
        },
        aviso_legal: {
          title: "Avis légal | Joints Ajusa",
          description:
            "L'accès aux pages Web de ce site implique l'acceptation de toutes les conditions exprimées dans ces mentions légales. Ajusa peut modifier la structure et la conception du site Web, ainsi que modifier ou supprimer le contenu et les conditions d'accès."
        },
        datos_seguros: {
          title: "Vos données sécurisées | Joints Ajusa",
          description:
            "En général, vos données personnelles fournies par le biais du site web d'Ajusa seront utilisées afin de pouvoir entrer en relation avec cette personne et lui fournir un meilleur service. Elles peuvent également être utilisées pour envoyer des publicités ou promouvoir nos activités."
        },
        bonos_ajusa: {
          title: "Bons Ajusa | 20% de remise pour votre atelier mécanique",
          description:
            "Pour bénéficier de la promotion du bon de réduction de 20 % d'Ajusa, vous pouvez appeler le 967 216 212 ou remplir ce formulaire. Bientôt, nous vous contacterons pour vous expliquer comment utiliser les réductions."
        },
        vehiculo_electrico: {
          title: "Véhicule Électrique",
          description:
            "Ajusa dispose d'un vaste catalogue de composants pour la réparation de véhicules hybrides et électriques. De plus, elle vous accompagne dans leur réparation grâce à des fiches explicatives de chaque panne que vous pouvez télécharger à partir de cette rubrique, et grâce à des tutoriels vidéo enregistrés par un spécialiste de la réparation de véhicules électriques."
        },
        blog_categoria: {
          fairs: {
            title: "Foires commerciales | Joints Ajusa",
            description:
              "Ajusa Joints propose une large gamme de solutions de joints pour les salons et autres événements. Notre équipe d'experts fournit des produits de qualité et un excellent service client."
          },
          products: {
            title: "Blogue Produits | Joints Ajusa",
            descripcion: ""
          },
          "our-sector": {
            title: "Notre secteur | Joints Ajusa",
            description: ""
          },
          "social-commitment": {
            title: "Compromisso Social | Auto peças Ajusa",
            description:
              "Chez Ajusa joints, nous croyons qu'il faut faire plus que fabriquer des produits de qualité. Explorez nos initiatives et découvrez comment vous pouvez nous aider à faire la différence."
          }
        },
        junta_culata: {
          title: "Joints de culasse MLS, FiberMax et caoutchouc-métal",
          description:
            "Spécialisée dans la fabrication de joints de culasse depuis 1972. Retrouvez plus de 200 000 produits pour véhicules légers et industriels dans notre catalogue en ligne.",
          keyword: "joints de culasse"
        },
        junta_motor: {
          title: "Pochettes de joints complètes moteur | Joints Ajusa",
          description:
            "Nos pochettes de joints offrent une option de remplacement complète aux mécaniciens et aux particuliers. Retrouvez ici toutes les pièces dont vous avez besoin pour effectuer une réparation complète de véhicules.",
          keyword: "pochettes de joints"
        },
        tornillos: {
          title: "Boulons de culasse | Jeux complets pour moteur | Ajusa",
          description:
            "Découvrez et commandez en ligne nos Boulons de Culasse pour moteurs de véhicules de haute qualité. Boostez les performances de votre moteur dès aujourd'hui avec nos produits.",
          keyword: "boulons de culasse"
        },
        retenes: {
          title: "Joints d'étanchéité et joints de soupape | Joints Ajusa",
          description:
            "Augmentez la longévité du moteur avec nos joints d'étanchéité de qualité supérieure. Découvrez maintenant des performances uniques et renforcez grâce à cette pièce l'efficacité de votre véhicule.",
          keyword: "joints d'huile"
        },
        tubos_engrase: {
          title: "Tubes de graissage pour turbocompresseur | Joints Ajusa",
          description:
            "Améliorez les machines de votre véhicule avec des tuyaux d'alimentation en huile de haute qualité. Maximisez ses performances et sa durabilité.",
          keyword:
            "tubes de graissage pour turbo, tuyaux d'alimentation en huile"
        },
        tubos_egr: {
          title: "Tubes EGR pour recirculation des gaz | Joints Ajusa",
          description:
            "Réduisez les émissions d'oxydes d'azote (NOx) issues de la combustion interne de votre véhicule avec les tubes EGR Ajusa.",
          keyword: "tubes EGR, obstruction"
        },
        tubos_refrigeracion: {
          title: "Tuyaux de refroidissement pour moteur | Joints Ajusa",
          description:
            "Optimisez les performances et la longévité du système de suralimentation avec les conduites de refroidissement du turbo Ajusa.",
          keyword: "tuyaux de refroidissement, refroidissement"
        },
        junta_turbo: {
          title: "Jeux de joints pour turbocompresseur | Joints Ajusa",
          description:
            "Libérez le véritable potentiel de votre véhicule avec notre Jeux de joints pour turbo ! Améliorez les performances et libérez la vitesse. Achetez maintenant et profitez d'une puissance inégalée.",
          keyword: "jeux de joints pour turbo, kit de montage turbo"
        },
        productos_quimicos: {
          title: "Produits chimiques | Mastics et lubrifiants d'Ajusa",
          description:
            "Découvrez notre large gamme de produits chimiques pour véhicules. Des produits d'étanchéité, des lubrifiants moteurs et de puissants freins filets afin de maintenir votre moteur dans un état optimal.",
          keyword:
            "produits chimiques, mastics, lubrifiants moteurs, frein filets"
        },
        taques: {
          title: "Poussoirs hydrauliques et mécaniques | Joints Ajusa",
          description:
            "Chez Ajusa, nous vous proposons une large gamme de poussoirs hydrauliques afin que vous puissiez trouver le dispositif parfait pour votre cas. Contactez-nous dès aujourd'hui !",
          keyword: "poussoirs hydrauliques, poussoirs hydrauliques"
        },
        arbol_levas: {
          title: "Arbres à cames pour véhicules légers et industriels",
          description:
            "Découvrez la gamme complète des arbres à cames disponibles chez Ajusa ! Augmentez les performances de votre moteur avec nos composants de haute qualité, nous sommes votre meilleur choix pour optimiser votre véhicule.",
          keyword: "Arbres à cames"
        },
        otros: {
          title: "Autres composants et pièces pour moteur | Joints Ajusa",
          description:
            "Recherchez-vous d'autres composants Ajusa? Dans notre catalogue, vous trouverez une vaste gamme de joints pour d'autres pièces du moteur telles que la pompe à eau, la vanne EGR, le thermostat, etc.",
          keyword: "autres composants ajusa, joints"
        },
        vehiculo_electrico: {
          title: "Véhicule électrique | Composants EV de Joints Ajusa",
          description:
            "Ajusa dispose d'une large gamme de composants pour les voitures hybrides et électriques. De plus, Ajusa vous aide également à effectuer des réparations en fournissant des explications pour chaque panne!",
          keyword:
            "composants pour les voitures hybrides, composants pour les voitures électriques"
        }
      }
    },
    genericos: {
      no_resultados: "Aucun résultat trouvé",
      leer_mas: "EN SAVOIR PLUS",
      paginador: {
        siguiente: "Suivant",
        anterior: "Page précédente"
      }
    },
    home: {
      intro: {
        titulo: "ÉVOLUONS <span class='bold'>ENSEMBLE",
        texto:
          "AJUSA a fabriqué son premier joint de culasse en 1972. Aujourd'hui, elle dispose du plus large <a class='bold' style='text-decoration: underline !important; cursor: pointer !important;' href='{link}' target='_blank'>portefeuille de joints</a> de moteur de l'industrie et de la gamme la plus complète de vis de culasse, de poussoirs hydrauliques, d'arbres à cames, de tubes de graissage et de jeux de joints pour turbo.",
        boton: "Vidéo d'entreprise",
        video: "vjFYe_seVTk"
      },
      excelencia: {
        intro:
          "<h1 class='title title-52'>Ajusa</h1><h2 class='title title-52'>L' <span class='bold'>EXCELLENCE</span><br>AUTOMOBILE</h2>",
        texto:
          "Toute une vie à prendre soin de votre véhicule. Leader mondial dans la fabrication et la distribution de composants de moteurs pour les <span class='bold'>véhicules automobiles, commerciaux légers, commerciaux lourds, agricoles et véhicule électrique.</span>"
      },
      calidad: {
        titulo: {
          first: "qualité originale",
          second: "AMÉLIORÉE",
          third: "dans tous",
          fourth: "nos <strong>produits</strong>"
        },
        texto:
          "À votre disposition. Le catalogue AJUSA dépasse largement les 200 000 références et est mis à jour en permanence dans sa version numérique, et tous les deux ans sous forme imprimée."
      },
      calidad_2: {
        texto_1:
          "Innovation constante. Nous disposons d'une <strong class='bold'>équipe de professionnels qualifiés</strong> qui travaillent avec les dernières technologies et dans des locaux équipés des machines les plus sophistiquées.",
        texto_2:
          "<strong class='bold'>Des produits de pointe pour des clients exigeants.</strong> Nous respectons les normes de qualité les plus élevées dans toutes nos lignes de produits : joints de culasse, jeux de joints de moteur, vis de culasse, tubes de graissage, jeux de joints de turbo, poussoirs hydrauliques, arbres à cames, produits d'étanchéité, lubrifiants pour moteurs et kits de réparation pour véhicules électriques."
      },
      calidad_3: {
        titulo: "<h2 class='title title-36'>NOUS FAISONS<br>LA DIFFÉRENCE</h2>",
        texto:
          "Nous offrons un <strong class='bold'>servicio integral</strong> à nos clients, en leur proposant des conseils et une assistance technique personnalisée, par le biais d'un contact direct avec notre équipe d'ingénieurs, ainsi que par la tenue de séminaires, tant en présentiels que par <i>streaming</i>.<br>Plus de 500 distributeurs agréés dans le monde entier se sont joints à nos succursales au Mexique, au Brésil, en Angleterre, au Royaume-Uni, aux États-Unis et en France. <a class='link' href='{link}' target='_blank'>Demander un webinaire</a>"
      },
      productos: {
        titulo:
          "<h2 class='title title-26'>NOS <span class='bold'>PRODUITS</span></h2>"
      },
      destacados: {
        titulo: "À LA UNE"
      },
      ajusa_app: {
        title: "AJUSA MOBILE"
      },
      alt_images: {
        fabricante: "Pièces de rechange fabricant",
        junta_culata: "Joint de culasse",
        mobile_app: "ajusa mobile APP",
        tubos_engrase: "Tuyaux de graissage",
        junta_motor: "Pièces de rechange Ajusa"
      }
    },
    productos: {
      keys: {
        "joints-culasse": "junta_culata",
        "joints-moteur": "junta_motor",
        vis: "tornillos",
        etancheite: "retenes",
        "tubes-graissage": "tubos_engrase",
        "tubes-egr": "tubos_egr",
        "tuyaux-refroidissement": "tubos_refrigeracion",
        "joints-turbo": "junta_turbo",
        "produits-chimiques": "productos_quimicos",
        poussoirs: "taques",
        "arbres-cames": "arbol_levas",
        autres: "otros"
      },
      intro: {
        titulo: "<h1 class='title title-52'>AJUSA produits</h1>",
        texto:
          "AJUSA est spécialisée dans la fabrication de composants pour moteurs à combustion interne, aussi bien pour automobiles que pour véhicules industriels. Elle est leader également dans le développement de pièces pour moteurs turbo."
      },
      btn_ficha_tecnica: "INFORMATION TECHNIQUE",
      btn_ficha_seguridad: "INFORMATIONS RELATIVES À LA SÉCURITÉ",
      junta_culata: {
        titulo: "joints de culasse",
        texto:
          "Les joints de culasse sont notre ligne de produits traditionnelle. Nous offrons une couverture complète pour les voitures particulières et les véhicules industriels et agricoles. Joints MLS, FiberMax et Caoutchouc -Métal.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/application-sealant-ajusil.pdf",
        details: {
          intro: {
            alt: "joint de culasse",
            title: '<h1 class="title title-36">Joints de culasse</h1>',
            text:
              "<p>Présentation des joints de culasse de haute qualité d'Ajusa : libérant des performances optimales du moteur.</p><p>Conçus avec précision et fabriqués avec expertise, nos joints de culasse sont conçus pour offrir des performances et une fiabilité supérieures. Il s'agit d'un composant essentiel qui scelle la culasse au bloc moteur, assurant une combustion efficace et préservant l'intégrité de la chambre de combustion.</p><p>Ce joint vital joue un rôle essentiel dans la prévention des fuites de gaz, d'huile et de liquide de refroidissement, optimisant ainsi les performances globales du moteur. Les pièces sont méticuleusement conçues pour résister aux températures extrêmes, aux différences de pression et à divers environnements chimiques, ce qui les rend idéales pour les moteurs standard et hautes performances des véhicules légers et industriels.</p>",
            btn_text: "CATALOGUE IN LIGNE",
            btn_redirect: "https://web.tecalliance.net/ajusa/fr/home",
            slider: [
              {
                img: "/static/img/products/junta-culata-1.webp",
                alt: "Joint de culasse Ajusa"
              },
              {
                img: "/static/img/products/junta-culata-2.webp",
                alt: "Catalogue joints de culasse"
              },
              {
                img: "/static/img/products/junta-culata-3.webp",
                alt: "Joints de culasse mls"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "En savoir plus sur les matériaux de fabrication",
              content:
                "<p>Nos joints de culasse sont fabriqués à partir de matériaux de haute qualité, tels que l'acier multicouche (MLS), le graphite ou l'élastomère, adaptés aux exigences spécifiques de chaque moteur. Ces matériaux possèdent d'excellentes propriétés d'étanchéité, scellant efficacement la chambre de combustion et minimisant le risque de fuite.</p><p>La compatibilité des moteurs est primordiale, c'est pourquoi nos joints sont conçus pour s'adapter aux moteurs à essence ou diesel, garantissant des performances et une fiabilité optimales.</p>"
            },
            "tip-2": {
              title: "Joints de culasse longue durée",
              content:
                "<p>La durabilité est une caractéristique essentielle de tous nos produits. Nous comprenons les exigences imposées aux moteurs modernes et nos joints de culasse sont conçus pour résister à des conditions extrêmes. Avec une résistance exceptionnelle à la chaleur, à la pression et à l'exposition aux produits chimiques, ils sont adaptés pour maintenir leur intégrité sur de longues périodes, réduisant ainsi le besoin de remplacement fréquents.</p><p>En fournissant un joint hermétique entre la culasse et le bloc moteur, nos joints contribuent à améliorer l'efficacité de la combustion, ce qui se traduit par une meilleure économie de carburant, des émissions réduites et une meilleure performance globale du moteur.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Quels sont les symptômes d'un mauvais joint de cylindre?",
              content:
                "<p>Un joint de culasse défectueux peut donner lieu à une gamme de symptômes qui indiquent des problèmes potentiels dans le moteur d'un véhicule.</p><p>L'une des principales indications d'une pièce problématique est la surchauffe du moteur. Lorsque le joint tombe en panne, il peut provoquer une fuite de liquide de refroidissement dans la chambre de combustion, perturbant le système de refroidissement du moteur et entraînant une surchauffe, ce qui peut entraîner des dommages importants s'il n'est pas traité rapidement.</p><p>Un autre symptôme à surveiller est une perte de liquide de refroidissement sans aucune fuite visible. Si vous avez fréquemment besoin de remplir le réservoir de liquide de refroidissement ou si vous remarquez une diminution des niveaux de liquide de refroidissement au fil du temps, cela peut indiquer un joint de culasse compromis.</p><p>Une pièce soufflée peut également se manifester par une fumée d'échappement blanche ou grisâtre. Cela se produit lorsque le liquide de refroidissement s'infiltre dans la chambre de combustion et est brûlé avec le carburant. La fumée qui en résulte peut avoir une odeur sucrée distincte et peut être particulièrement perceptible lors de l'accélération ou lors du démarrage du moteur.</p><p>Les ratés du moteur sont un autre symptôme important dont vous devez vous occuper. Comme l'intégrité du joint est compromise, le processus de combustion peut être perturbé, entraînant un ralenti irrégulier, une hésitation ou une diminution notable de la puissance du moteur pendant l'accélération.</p><p>Enfin, faites attention à la perte de compression entre les cylindres, car cela peut entraîner une diminution des performances du moteur, une réduction de la puissance et même des ratés d'allumage dans les cylindres individuels.</p>"
            },
            "dropdown-2": {
              title: "Peut-on rouler avec un joint de culasse grillé ?",
              content:
                "<p>En définitive, nous déconseillons absolument de rouler avec un joint de culasse grillé car cela peut avoir des conséquences non négligeables sur le moteur et les performances globales de votre véhicule. Il est important de régler le problème rapidement pour éviter d'autres dommages.</p><p>Lorsqu'un joint de culasse est soufflé, cela peut entraîner plusieurs problèmes pouvant compromettre le fonctionnement du moteur. Le liquide de refroidissement peut fuir dans la chambre de combustion, provoquant une surchauffe et endommageant potentiellement les composants du moteur. Le liquide de refroidissement peut également se mélanger à l'huile moteur, réduisant ses propriétés lubrifiantes et pouvant endommager les roulements, les pistons et d'autres pièces vitales.</p><p>Si vous soupçonnez un joint soufflé ou ressentez l'un des symptômes associés, il est conseillé de faire inspecter votre véhicule par un mécanicien qualifié dès que possible. Nous recommandons totalement d'éviter de conduire le véhicule jusqu'à ce que la pièce soit remplacée ou réparée pour éviter d'autres dommages et assurer la longévité de votre moteur.</p>"
            },
            "dropdown-3": {
              title:
                "Est-ce que ça vaut le coup de changer un joint de culasse?",
              content:
                "<p>Remplacer un joint de culasse endommagé peut être une décision valable compte tenu des conséquences potentielles d'ignorer le problème. Comme nous l'avons vu précédemment, cela peut causer une série de problèmes qui peuvent nuire aux performances et à la fiabilité de votre véhicule.</p><p>Bien que ce remplacement implique un investissement, il est généralement plus rentable que de s'occuper de réparations importantes du moteur. Aborder le joint soufflé dès le début peut vous aider à éviter d'autres dommages et les dépenses associées.</p><p>De plus, assurer la sécurité de votre véhicule est très important. Un joint de culasse soufflé peut entraîner une surchauffe du moteur, ce qui peut provoquer le calage du moteur ou entraîner des pannes à des moments inappropriés voire dangereux. En remplaçant la pièce, vous pouvez restaurer un fonctionnement sûr et fiable du véhicule.</p>"
            },
            "dropdown-4": {
              title:
                "Combien de temps une voiture durera-t-elle après avoir remplacé le joint de culasse?",
              content:
                "<p>Lorsque le joint de culasse est remplacé rapidement et que les réparations nécessaires sont effectuées correctement, il est possible que le véhicule continue à fonctionner pendant de nombreuses années. Cependant, il est important de noter que la durée de vie d'un véhicule est influencée par divers facteurs au-delà du simple remplacement de cette pièce particulièrement.</p><p>Bien qu'il n'y ait pas de délai définitif, il est possible qu'une voiture dure longtemps après le remplacement de la pièce soufflée, en particulier lorsqu'elle est associée à un entretien et à des soins appropriés. L'entretien régulier du véhicule, la résolution rapide de tout problème et l'adoption de bonnes habitudes de conduite sont essentiels pour maximiser sa durée de vie.</p>"
            }
          },
          btn_more_info: {
            text: "PLUS D'INFORMATION"
          }
        }
      },
      junta_motor: {
        titulo: "JEUX DE JOINTS POUR LE MOTEUR",
        texto:
          "Fiabilité dans l'étanchéité des véhicules. Nous développons des jeux complets de joints pour moteur et comptons plus de 200 000 références dans les joints en fibre, caoutchouc et caoutchouc-métal.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/application-sealant-ajusil2.pdf",
        details: {
          intro: {
            alt: "pochettes de joints",
            title: '<h1 class="title title-36">Pochettes de joints</h1>',
            text:
              "<p>Bienvenue dans notre collection complète de pochettes de joints, où nous proposons des solutions d'étanchéité de moteur de haute qualité pour une large gamme de véhicules. En tant que fabricant leader de composants de moteur, nous comprenons le rôle essentiel que ces pièces jouent dans le maintien des performances et de la longévité optimales des moteurs.</p><p>Chez Ajusa, nous sommes fiers de notre engagement envers l'excellence, en fournissant des pièces de moteur conçues avec précision et fabriquées avec des matériaux de première qualité. Chacun des jeux de joints de notre collection est méticuleusement conçu pour fournir un ajustement et une étanchéité parfaits pour votre moteur, garantissant des performances et une durabilité optimales.</p>",
            btn_text: "CATALOGUE IN LIGNE",
            btn_redirect: "https://web.tecalliance.net/ajusa/fr/home",
            slider: [
              {
                img: "/static/img/products/junta-motor-1.webp",
                alt: "Jeux de joints complets Ajusa"
              },
              {
                img: "/static/img/products/junta-motor-2.webp",
                alt: "Jeux de joints Ajusa"
              },
              {
                img: "/static/img/products/junta-motor-3.webp",
                alt: "Pièces de rechange pour moteur"
              },
              {
                img: "/static/img/products/junta-motor-4.webp",
                alt: "Joints pour véhicules industriels"
              },
              {
                img: "/static/img/products/junta-motor-5.webp",
                alt: "Pièce pour la réparation de moteur des voitures"
              }
            ]
          },
          dropdowns: {
            "dropdown-1": {
              title:
                "Une grande variété de pochettes de joints pour votre moteur",
              content:
                "<p>Notre catégorie de pochette de joints comprend une large gamme de pièces, qui sont soigneusement sélectionnées pour inclure tous les éléments nécessaires à une application de moteur spécifique, rationalisant le processus de réparation ou de reconstruction et garantissant que vous avez tout ce dont vous avez besoin dans un seul emballage pratique.</p><p>En choisissant nos produits, vous pouvez avoir l'esprit tranquille en sachant que vous investissez dans des solutions d'étanchéité moteur haut de gamme conçues pour durer. Nous nous engageons à fournir des produits qui offrent des performances, une durabilité et une valeur exceptionnelles, ce qui fait de nous le choix de confiance pour les constructeurs de moteurs et les passionnés d'automobile.</p><p>Si vous avez des questions ou avez besoin d'aide pour trouver les pochettes de joints adapté à votre application spécifique, notre équipe compétente est toujours prête à vous fournir des conseils et une assistance d'experts.</p>"
            },
            "dropdown-2": {
              title:
                "Commandez une pochette complète de joints moteur en ligne",
              content:
                "<p>Chez Ajusa, nous développons des pochettes de joints complètes avec plus de 200 000 références pour répondre à une large gamme de marques et de modèles de véhicules. Toutes sont conçues selon un processus méticuleux et sont fabriquées en fibres, caoutchouc et composés caoutchouc-métal, qui sont les matériaux les plus solides et les plus efficaces pour l'installation dans les moteurs de véhicules.</p><p>La précision et la durabilité sont vraiment importantes pour nous, et c'est pourquoi nos produits sont soumis à un processus de conception et de développement rigoureux, respectant des normes strictes de qualité. Notre équipe d'ingénieurs expérimentés tire parti de leur expertise pour créer des joints qui offrent des performances d'étanchéité exceptionnelles et maintiennent l'intégrité des composants du moteur.</p>"
            },
            "dropdown-3": {
              title: "De quoi est composé une pochette de joints?",
              content:
                "<p>Notre vaste catalogue de pochettes de joints couvre divers articles, y compris les joints et boulons de culasse, les joints d'huile, le joint de cache-culbuteurs, les collecteurs et bien d'autres produits. Chaque ensemble est soigneusement organisé pour inclure tous les joints nécessaires pour une révision ou une réparation complète du moteur.</p><p>Investissez dans la fiabilité et les performances de votre moteur en commandant dès aujourd'hui un jeu complet de joints de moteur en ligne auprès d'Ajusa. Si vous avez des questions ou avez besoin d'aide, notre équipe d'assistance à la clientèle expérimentée sera toujours disponible pour vous fournir des conseils et un soutien.</p><p>Découvrez la différence que nos pochettes de joints minutieusement développés peuvent faire dans les performances et la longévité de votre moteur.</p>"
            }
          },
          btn_more_info: {
            text: "PLUS D'INFORMATION"
          }
        }
      },
      tornillos: {
        titulo: "VIS DE CULASSE",
        texto:
          "Nous complétons notre excellente gamme de joints de culasse avec la ligne de vis de culasse la plus complète du marché. Nous incluons un manuel de serrage.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/application-sealant-ajusil3.pdf",
        details: {
          intro: {
            alt: "vis de culasse",
            title: '<h1 class="title title-36">Vis de culasse</h1>',
            text:
              "<p>Bienvenue dans notre sélection exclusive de <span class='bold'>vis de culasse pour moteurs</span> de véhicules.</p><p>Chez Ajusa, nous comptons une vaste sélection de vis méticuleusement conçues, afin de vous offrir des performances et une durabilité optimales. Ces composants jouent un rôle crucial dans la création d'un <span class='bold'>joint étanche entre la culasse et le bloc moteur</span>, assurant une compression correcte et empêchant toute fuite de gaz de combustion ou de liquide de refroidissement.</p><p>En maintenant une connexion solide et fiable, les boulons de culasse contribuent à l'efficacité, aux performances et à la <span class='bold'>longévité du moteur</span>. Ce sont des composants essentiels pour maintenir l'intégrité structurelle et le fonctionnement optimal de la chambre de combustion du moteur.</p>",
            btn_text: "CATALOGUE EN LIGNE",
            btn_redirect: "https://web.tecalliance.net/ajusa/fr/home",
            slider: [
              {
                img: "/static/img/products/tornillos-1.webp",
                alt: "Vis de culasse Ajusa"
              },
              {
                img: "/static/img/products/tornillos-2.webp",
                alt: "Vis Ajusa"
              },
              {
                img: "/static/img/products/tornillos-3.webp",
                alt: "Vis à serrage angulaire"
              },
              {
                img: "/static/img/products/tornillos-4.webp",
                alt: "Catalogue Vis de culasse"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "Matériaux haut de gamme pour une durabilité exceptionnelle",
              content:
                "<p>Nous achetons nos matériaux auprès de fournisseurs de confiance, en sélectionnant des alliages et des compositions qui répondent aux normes strictes de l'industrie.</p><p>Qu'il s'agisse d'acier haute résistance, d'aluminium forgé ou d'autres matériaux avancés, nos <span class='bold'>vis de culasse sont conçues pour résister aux conditions les plus exigeantes.</span></p><p>Avec ces matériaux haut de gamme, vous pouvez être assurés que les composants critiques de votre moteur resteront solidement fixés, évitant les fuites et optimisant la compression.</p>"
            },
            "tip-2": {
              title: "Boulons de culasse aux performances fiables",
              content:
                "<p>Forts d'un héritage de résultats éprouvés et d'une clientèle fidèle, ces produits ont gagné leur réputation de choix incontournable pour les professionnels et les passionnés. D'innombrables moteurs ont atteint de nouveaux sommets d'efficacité et de puissance, tout cela grâce à <span class='bold'>l'ajustement de précision et à l'étanchéité fournis par ces vis exceptionnelles.</span></p><p>Faites l'expérience de la tranquillité d'esprit en sachant que nos <span class='bold'>vis de culasse</span> sont conçues pour tenir la distance, offrant la robustesse nécessaire au fonctionnement optimal de votre moteur.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Pourquoi remplacer les vis de culasse?",
              content:
                "<p>Le <span class='bold'>remplacement des vis de culasse est un aspect essentiel</span> de l'entretien et de la réparation du moteur. Au fil du temps, ces pièces peuvent subir une usure, des contraintes et des variations de température, entraînant une usure et une fatigue progressives. Au fur et à mesure qu'ils perdent leur élasticité et leur force de serrage, le risque de développer des problèmes tels que des fuites de joint de culasse augmente.</p><p>Pour assurer l'intégrité et la sécurité continue de votre moteur, le remplacement rapide des vis de culasse est essentiel. En <span class='bold'>installant de nouveaux composants de haute qualité dans votre véhicule</span>, vous rétablissez la force de serrage nécessaire entre la culasse et le bloc moteur, rétablissant ainsi l'étanchéité.</p>"
            },
            "dropdown-2": {
              title: "Qu'est-ce qui fait casser les vis à tête?",
              content:
                "<p>La <span class='bold'>rupture des vis de culasse</span> peut être attribuée à divers facteurs, principalement liés aux contraintes et aux conditions qu'ils subissent pendant le fonctionnement du moteur. Certaines pannes courantes incluent l'application excessive ou inégale du couple lors de l'installation des vis, les fluctuations de la température du moteur, l'exposition à des produits chimiques corrosifs ou même la surchauffe du moteur.</p><p><span class='bold'>L'inspection et le remplacement réguliers des vis de culasse</span> lors de la reconstruction du moteur ou des réparations majeures peuvent aider à identifier les problèmes potentiels réduisant le risque de casse, contribuant ainsi à une performance fiable et durable du moteur.</p>"
            }
          },
          btn_more_info: {
            text: "PLUS D'INFORMATION"
          }
        }
      },
      retenes: {
        titulo: "JOINTS D'ÉTANCHÉITÉ",
        texto:
          "Couverture étendue des joints à huile et des joints de soupapes pour assurer une parfaite étanchéité du moteur.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/application-sealant-ajusil4.pdf",
        details: {
          intro: {
            alt: "joints d'étanchéité",
            title: "<h1 class='title title-52'>Joints d'étanchéité</h1>",
            text:
              "<p>Découvrez la fonction essentielle des joints d'étanchéité dans les véhicules, un composant essentiel qui maintient le bon fonctionnement et prévient les fuites. Ces joints spécifiques créent une barrière étanche, garantissant que les lubrifiants et les fluides restent confinés, protégeant les pièces vitales du moteur contre les frottements nocifs et prolongeant la durée de vie globale de votre véhicule.</p><p>Chez AJUSA, vous trouverez une large sélection de pièces de haute qualité, méticuleusement conçues pour divers véhicules, vous permettant ainsi de conduire en toute confiance et tranquillité d'esprit. Découvrez la différence que nos produits hauts de gamme font en améliorant les performances de votre véhicule et en protégeant votre investissement à long terme.</p>",
            btn_text: "CATALOGUE EN LIGNE",
            btn_redirect: "https://web.tecalliance.net/ajusa/fr/home",
            slider: [
              {
                img: "/static/img/products/retenes-1.webp",
                alt: "Joints Ajusa"
              },
              {
                img: "/static/img/products/retenes-2.webp",
                alt: "Joints spi jusa"
              },
              {
                img: "/static/img/products/retenes-3.webp",
                alt: "Joints de tige de soupape Ajusa"
              },
              {
                img: "/static/img/products/retenes-4.webp",
                alt: "Joints spi pour voitures"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "Commandez les bons joints d'étanchéité pour votre véhicule",
              content:
                "<p>Fabriqués à partir de matériaux durables qui respectent ou dépassent les normes de l'industrie, nos joints sont rigoureusement testés pour résister aux conditions les plus difficiles, garantissant qu'ils fonctionnent parfaitement même sous des températures et des pressions extrêmes. Nous pouvons garantir que le moteur de votre véhicule et les autres composants critiques resteront protégés et fonctionneront de manière optimale.</p><p>Notre équipe d'experts automobiles se fera un plaisir de vous aider à trouver les joints d'huile parfaits pour les besoins spécifiques de votre véhicule. Que vous ayez affaire à une voiture citadine, un poids lourd ou quoi que ce soit entre les deux, nous avons l'expertise pour vous guider vers la pièce idéale.</p>"
            },
            "tip-2": {
              title: "Optimisez durablement les performances de votre voiture",
              content:
                "<p>Ce n'est un secret pour personne que les performances et la durabilité de votre voiture dépendent de la qualité de ses composants essentiels. Avec nos joints en place, votre moteur connaîtra une friction réduite, ce qui entraînera un fonctionnement plus fluide, une efficacité énergétique accrue et, en fin de compte, une performance globale améliorée.</p><p>Posséder une voiture est un investissement important, et la protéger est essentielle. Assurez-vous de protéger les pièces de votre véhicule contre l'usure prématurée et les dommages en trouvant les bons joints d'huile, en prolongeant leur durée de vie et en vous évitant des réparations coûteuses.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Découvrez notre vaste catalogue de joints d'étanchéité",
              content:
                "<p>Notre sélection de produits est la plus complète que vous puissiez trouver, car nous avons des pièces pour toutes les marques et tous les modèles de véhicules sur le marché aujourd'hui. Donnez-nous simplement toutes les informations nécessaires concernant votre voiture et nous rechercherons les joints spi en stock afin que vous puissiez toujours avoir une pièce de rechange à portée de main.</p><p>Soutenue par des années d'expertise dans l'industrie, notre équipe se consacre à fournir un service client exceptionnel. De la sélection des bons joints d'étanchéité à la réponse à vos questions techniques, nous sommes là pour vous aider à chaque étape du processus.</p><p>Trouvez en ligne plusieurs types de joints d'étanchéité de différentes tailles pour répondre à divers modèles de véhicules. Si besoin, contactez-nous pour un service sur mesure.</p>"
            }
          },
          btn_more_info: {
            text: "PLUS D'INFORMATION"
          }
        }
      },
      tubos_engrase: {
        titulo: "TUBES DE GRAISSAGE POUR TURBO",
        texto:
          "Nous nous adaptons aux nouveaux moteurs turbocompressés en vous proposant une gamme de tubes de graissage pour turbo. Catalogue des turbos AJUSA disponible.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/application-sealant-ajusil5.pdf",
        details: {
          intro: {
            alt: "tubes de graissage pour turbo",
            title:
              '<h1 class="title title-36">Tubes de graissage pour turbo</h1>',
            text:
              "<p>Conçus pour optimiser les performances, l'efficacité et la durabilité de vos machines, ces <span class='bold'>tubes de graissage pour turbo</span> avec une huile haut de gamme sont conçus avec précision et soin. </p><p>La qualité et l'innovation sont entièrement garanties. Ces tuyaux sont construits pour résister aux environnements les plus exigeants et assurer un approvisionnement en huile continu et constant, protégeant ainsi votre équipement de pannes potentielles.</p>",
            btn_text: "CATALOGUE EN LIGNE",
            btn_redirect: "https://web.tecalliance.net/ajusa/fr/home",
            slider: [
              {
                img: "/static/img/products/tubos-engrase-1.webp",
                alt: "Tuyaux de graissage Ajusa"
              },
              {
                img: "/static/img/products/tubos-engrase-2.webp",
                alt: "Composants turbo Ajusa"
              },
              {
                img: "/static/img/products/tubos-engrase-3.webp",
                alt: "Tuyaux de graissage pour turbocompresseur"
              },
              {
                img: "/static/img/products/tubos-engrase-4.webp",
                alt: "Composants pour turbocompresseur"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "Commandez des tuyaux d'alimentation en huile hautement efficaces",
              content:
                "<p>Êtes-vous fatigué de faire face aux ralentissements du moteur et aux réparations coûteuses dues à un approvisionnement en huile inconstant ? Ne cherchez pas plus loin. Nous vous fournirons la solution ultime pour optimiser les performances de votre voiture sur la route.</p><p>Ces conduits d'alimentation en huile assurent un flux d'huile fluide et continu vers les composants vitaux, réduisant ainsi la friction et l'usure.</p>"
            },
            "tip-2": {
              title:
                "Investissez dans des performances et une fiabilité durable",
              content:
                "<p>Rejoignez les rangs des clients satisfaits qui ont déjà expérimenté les avantages remarquables de cette pièce et voyez comment notre produit a transformé leur conduite quotidienne pour de meilleures performances sur le long terme.</p><p>Faites un investissement judicieux pour l'avenir de votre véhicule, en veillant à ce qu'il reste en parfait état pour les années à venir. L'écoulement continu de l'huile à travers ces canalisations garantit une lubrification optimale et un fonctionnement plus fluide de votre turbo grâce à une fabrication fiable et éprouvée.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "A quoi sert le tube de graissage pour turbo?",
              content:
                "<p>Le tube de graissage pour turbo joue un rôle crucial dans le fonctionnement d'une voiture. Dans un système turbo, le turbocompresseur comprime l'air et le force dans les cylindres du moteur, ce qui augmente la puissance et les performances. Cependant, au cours de ce processus, les composants rotatifs du turbocompresseur nécessitent une lubrification appropriée afin d’éviter une friction et une usure prématurées.</p><p>Le tuyau d'alimentation en huile est responsable d'amener l'huile du carter d'huile moteur au cœur du turbocompresseur. Par conséquent, il est extrêmement important d'avoir un tuyau exempt de cendres, de saleté ou de tout autre corps étranger, qui pourrait obstruer le passage de l'huile et endommager le turbocompresseur.</p>"
            },
            "dropdown-2": {
              title:
                "Pouvez-vous faire fonctionner un turbo sans conduits d’huile?",
              content:
                "<p>Non, vous ne pouvez pas faire fonctionner un turbocompresseur sans conduits d'huile. Les tuyaux d'alimentation en huile sont essentiels pour son bon fonctionnement et la longévité des composants rotatifs, tels que les roues de la turbine et du compresseur, qui tournent à des vitesses extrêmement élevées et qui peuvent provoquer une usure et des dommages importants s'ils ne sont pas correctement lubrifiés.</p><p>Les conduits d'huile sont chargés de fournir de l'huile sous pression et filtrée au turbocompresseur, garantissant une lubrification et température correct des pièces mobiles lors du fonctionnement.</p>"
            }
          },
          btn_more_info: {
            text: "PLUS D'INFORMATION"
          }
        }
      },
      tubos_egr: {
        titulo: "TUYAUX EGR",
        texto:
          "Ajusa propose des tuyaux EGR de haute qualité qui répondent aux spécifications des principaux fabricants. Nos produits sont conçus pour garantir une longue durée de vie et une performance optimale, contribuant à maintenir votre véhicule dans les normes d’émissions et assurant une conduite plus propre et plus efficace.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "tuyaux egr",
            title: '<h1 class="title title-36">Tuyaux EGR</h1>',
            text:
              '<p>Ajusa propose des <span class="bold">tuyaux EGR</span> de haute qualité qui répondent aux spécifications des principaux fabricants. Nos produits sont conçus pour garantir une longue durée de vie et une performance optimale, contribuant à maintenir votre véhicule dans les normes d’émissions et assurant une conduite plus propre et plus efficace.</p>',
            btn_text: "CATALOGUE EN LIGNE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/tubos-egr-1.webp",
                alt: "tuyau egr ajusa"
              },
              {
                img: "/static/img/products/tubos-egr-2.webp",
                alt: "soupape egr ajusa"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "MAINTENENT L'EFFICACITÉ DU SYSTÈME DE RECIRCULATION DES GAZ D'ÉCHAPPEMENT",
              content:
                '<p>Le <span class="bold">tuyau EGR</span> (Recirculation des Gaz d’Échappement) est un composant clé dans les systèmes de réduction des émissions des moteurs à combustion interne. </p> <p> Ce tuyau fait partie du système EGR, conçu pour <span class="bold">réduire les émissions d’oxydes d’azote (NOx)</span> en renvoyant une partie des gaz d’échappement vers l’admission du moteur.</p>'
            },
            "tip-2": {
              title:
                "TUYAUX DE HAUTE QUALITÉ, CONÇUS POUR UNE INSTALLATION FACILE",
              content:
                '<p>Un <span class="bold">tuyau EGR</span> peut nécessiter un remplacement lorsque les dépôts de carbone sont excessifs et que le nettoyage n’est plus suffisant pour rétablir son fonctionnement.</p><p> En outre, un tuyau fissuré ou endommagé peut provoquer des fuites de gaz d’échappement, ce qui affecte négativement l’efficacité du moteur ainsi que le contrôle des émissions.</p>'
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Qu’est-ce que le système EGR ?",
              content:
                "<p>Le système EGR (Recirculation des Gaz d’Échappement) redirige une partie des gaz d’échappement dans la chambre de combustion pour améliorer les émissions, en particulier en réduisant les polluants tels que les NOx.</p><p>Ces gaz circulent depuis le collecteur d’échappement, à travers le tuyau EGR, jusqu’à l’admission, avec le débit contrôlé par l’ouverture et la fermeture d’une vanne EGR gérée par l’ECU, permettant un passage total, partiel ou nul selon les besoins de conduite.</p><p>Ainsi, le système EGR redirige une partie des gaz d’échappement dans la chambre de combustion via le tube EGR, qui relie le collecteur d’échappement au collecteur d’admission. En introduisant ces gaz d’échappement pauvres en oxygène dans le processus de combustion, on réduit la température dans la chambre de combustion, diminuant ainsi la formation de NOx, qui est l'une des principales causes de pollution de l'air et qui affecte également la santé des personnes.</p>"
            },
            "dropdown-2": {
              title: "Pourquoi le tuyau EGR est-il important?",
              content:
                "<p>Avec le temps, les tuyaux EGR peuvent accumuler des résidus de combustion et d’autres dépôts provenant des gaz d’échappement, ce qui peuvent obstruer partiellement ou complètement le tuyau, réduisant ainsi l’efficacité du système. De plus, ils subissent une fatigue thermique due aux températures élevées des gaz et une fatigue mécanique due aux vibrations du moteur. C’est pourquoi il est important d’effectuer des entretiens réguliers, comprenant l’inspection de cette pièce et même son remplacement si nécessaire.</p><p>Les symptômes d’un tuyau EGR obstrué incluent une perte de puissance, une augmentation de la consommation de carburant et l’activation du témoin lumineux du moteur (MIL).</p><p>Les principales causes d’un tuyau défectueux sont:</p><ol><li><span class='bold'>Obstruction: </span> Les gaz d’échappement, surtout dans les moteurs diesel, contiennent de nombreux éléments de combustion comme la suie, qui peuvent, avec le temps, finir par obstruer complètement le tube, empêchant ainsi le passage des gaz.</li><li><span class='bold'>Rupture: </span>Les cycles fréquents de démarrage et d’arrêt lors de l’utilisation du véhicule, combinés aux températures très élevées des gaz d’échappement et aux vibrations du moteur, peuvent provoquer des fissures ou des ruptures dans le tuyau.</li></ol><p>Un système EGR ne fonctionnera pas correctement avec un tuyau EGR défectueux, ce qui peut entraîner non seulement des problèmes dans le fonctionnement du système anti-pollution, mais aussi dans le fonctionnement même du moteur, avec des conséquences potentiellement plus graves si le remplacement n’est pas effectué à temps.</p><p>Un tuyau EGR peut nécessiter un remplacement lorsque les dépôts de carbone sont excessifs et que le nettoyage n’est plus suffisant pour rétablir son fonctionnement. En outre, un tuyau fissuré ou endommagé peut provoquer des fuites de gaz d’échappement, ce qui affecte négativement l’efficacité du moteur ainsi que le contrôle des émissions.</p><p>Si vous observez certains des symptômes évoqués ou si votre véhicule a parcouru de nombreux kilomètres sans inspection du système EGR, il est recommandé de consulter un professionnel pour une expertise. L’installation d’un nouveau tuyau EGR assure une réparation parfaite, évitant les dysfonctionnements du système et d’autres pannes causées par des tuyaux défectueux.</p>"
            },
            "dropdown-3": {
              title: "Les avantages des tuyaux EGR en bon état",
              content:
                "<ul>  <li><span class='bold'>Réduction des émissions polluantes: </span>Le bon fonctionnement du système diminue la température de combustion, réduisant significativement les émissions de NOx.</li>  <li><span class='bold'>Conformité aux réglementations environnementales: </span> Les véhicules modernes doivent respecter des réglementations strictes en matière d’émissions. LE système EGR aide les moteurs à être conformité selon la réglementation.</li>  <li><span class='bold'>Amélioration de la consommation de carburant: </span>La recirculation des gaz contribue à optimiser le processus de combustion, ce qui favorise une utilisation plus efficace du carburant.</li>  <li><span class='bold'>Durabilité accrue du moteur: </span>En réduisant la température dans la chambre de combustion, le système EGR réduit le stress thermique sur les composants internes du moteur, ce qui peut prolonger leur durée de vie.</li></ul>"
            }
          },
          btn_more_info: {
            text: "PLUS D'INFORMATIONS"
          }
        }
      },
      tubos_refrigeracion: {
        titulo: "TUYAUX DE REFROIDISSEMENT",
        texto:
          "Les conduites de refroidissement du turbo acheminent le liquide de refroidissement entre le moteur et le turbocompresseur, en aller et retour. La gamme de conduites de refroidissement pour turbocompresseurs d’Ajusa couvre plus de 40 modèles de véhicules de marques leaders telles que Ford, VAG, Mercedes, Fiat/Alfa/Jeep, Nissan et Smart.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "tubos de refrigeracion",
            title: '<h1 class="title title-36">Tubos de refrigeracion</h1>',
            text:
              '<p>Les <span class="bold">turbocompresseurs</span> font face à un défi constant : les températures extrêmes. Dans les moteurs modernes, ces composants peuvent atteindre des niveaux de chaleur qui imposent un stress thermique brutal à toutes les pièces internes.</span></p><p>Lorsque la lubrification à l`huile traditionnelle ne suffit plus pour combattre ces températures, une solution vitale entre en jeu: le <span class="bold">refroidissement liquide externe</span>  via des tuyaux de refroidissement dédiés.</p><p>La gamme de tuyaux de refroidissement pour turbocompresseurs couvre plus de 40 modèles de véhicules de grandes marques, notamment Ford, VAG, Mercedes, Fiat/Alfa/Jeep, Nissan et Smart.</p>',
            btn_text: "CATALOGUE EN LIGNE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/tubos-refrigeracion-1.webp",
                alt: "tubo refrigeracion ajusa"
              },
              {
                img: "/static/img/products/tubos-refrigeracion-2.webp",
                alt: "valvula refrigeracion ajusa"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "",
              content:
                "<p>Dans les véhicules modernes, les systèmes de refroidissement ont évolué afin d’améliorer l’efficacité thermique et de gérer un nombre croissant de composants, notamment les turbocompresseurs et les systèmes de dépollution.La complexité accrue du circuit augmente le risque de pannes difficiles à diagnostiquer et coûteuses à réparer. Une mauvaise gestion thermique peut entraîner des dommages graves, en particulier sur les turbos à refroidissement liquide.</p>"
            },
            "tip-2": {
              title: "",
              content:
                "<p>Les conduites de refroidissement du turbocompresseur doivent être utilisées uniquement dans des applications compatibles, en assurant un cheminement correct permettant la dilatation thermique sans générer de contraintes.</p><p>Il est indispensable d’utiliser des matériaux et des joints appropriés, de respecter le couple de serrage spécifié et de maintenir le circuit avec un liquide de refroidissement homologué. Il n’est pas recommandé de réutiliser des conduites endommagées ou vieillies.</p><p>Après toute intervention, l’étanchéité doit être vérifiée et une purge complète du système doit être effectuée afin de garantir un fonctionnement sûr du turbocompresseur.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "QUELLE EST LA FONCTION DES CONDUITES DE REFROIDISSEMENT?",
              content:
                "<p>Les conduites de refroidissement du turbo acheminent le liquide de refroidissement entre le moteur et le turbocompresseur, en aller et retour. Elles doivent résister à des températures élevées, à la pression et aux vibrations, et être fabriquées à partir de matériaux durables.</p><p>Selon l’application, elles peuvent être fabriquées en acier carbone, en acier inoxydable ou en combinaisons de métal et de sections flexibles, sélectionnées pour offrir une haute résistance mécanique et thermique.</p><p>Les conduites intègrent des extrémités formées ou usinées permettant une connexion précise et étanche au moyen de joints, de colliers ou de raccords spécifiques, évitant toute fuite de liquide de refroidissement même dans des conditions de fonctionnement sévères.</p><p>Dans certaines configurations, les conduites de refroidissement intégrées à un circuit auxiliaire avec pompe électrique permettent de maintenir la circulation du liquide après l’arrêt du moteur. Ce système est essentiel pour évacuer la chaleur résiduelle accumulée.</p><p>Ce phénomène, connu sous le nom de heat soak, se produit lorsque la chaleur de la turbine est transmise au corps central en l’absence de circulation de liquide. La circulation forcée limite les pics thermiques et favorise une diminution contrôlée de la température.</p>"
            }
          },
          btn_more_info: {
            text: "PLUS D'INFORMATIONS"
          }
        }
      },
      junta_turbo: {
        titulo: "JEUX DE JOINTS POUR TURBO",
        texto:
          "Nous proposons plus de 1 000 kits de montage différents pour turbocompresseurs. Nos kits couvrent la plupart des applications des principaux fabricants mondiaux.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/application-sealant-ajusil6.pdf",
        details: {
          intro: {
            alt: "jeux de joints pour turbo",
            title: '<h1 class="title title-36">Jeux de joints pour turbo</h1>',
            text:
              "<p>Bienvenue dans votre première destination pour les passionnés de conduite à la recherche d'améliorations de performances. Entrez dans un monde de puissance et de précision avec nos <span class='bold'>jeux de joints pour turbo.</span></p><p>Conçu pour porter votre expérience de conduite vers de nouveaux sommets, ce produit a été pensé en portant une attention aux détails. Il est fabriqué à partir des meilleurs matériaux, garantissant une performance et une fiabilité optimales.</p><p>Ce kit s'intègre parfaitement dans une large gamme de marques et de modèles, optimisant l'efficacité du moteur et libérant une poussée de puissance comme jamais auparavant.</p>",
            btn_text: "CATALOGUE EN LIGNE",
            btn_redirect: "https://web.tecalliance.net/ajusa/fr/home",
            slider: [
              {
                img: "/static/img/products/junta-turbo-1.webp",
                alt: "Kits de montage turbo Ajusa"
              },
              {
                img: "/static/img/products/junta-turbo-2.webp",
                alt: "Joint pour turbo"
              },
              {
                img: "/static/img/products/junta-turbo-3.webp",
                alt: "Kits de montage turbo"
              },
              {
                img: "/static/img/products/junta-turbo-4.webp",
                alt: "Jeu de joints pour turbo"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "Transformez votre expérience de conduite avec un kit de montage turbo",
              content:
                "<p>Conçu pour transcender la performance de votre véhicule, notre kit de montage turbo optimise les capacités de votre moteur tout en vous offrant une fusion de puissance et d'efficacité.</p>"
            },
            "tip-2": {
              title: "Prouesse et précision d'ingénierie",
              content:
                "<p>Chaque élément de notre kit de montage turbo est méticuleusement conçu avec des matériaux minutieusement choisis, de sorte à vous apporter un produit répondant aux normes les plus exigeantes de l’industrie.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Quel turbo correspond à ma voiture?",
              content:
                "<p>Notre <span class='bold'>jeu de joints pour turbo</span> est conçu pour être utilisé sur des véhicules de différentes marques et modèles. Néanmoins, si vous avez un doute sur son intégration, nous vous recommandons de nous fournir des détails spécifiques sur votre voiture, tels que la marque, le modèle, l'année et toute autre spécification pertinente.</p><p>Grâce à ces informations, nos experts automobiles peuvent vous aider à trouver la pièce parfaite, adaptée aux besoins de votre véhicule. N'hésitez pas à nous contacter et nous vous aiderons rapidement à trouver la solution idéale pour améliorer les performances de votre voiture.</p>"
            },
            "dropdown-2": {
              title: "Quels changements vais-je remarquer dans ma conduite?",
              content:
                "<p>Malgré ses puissantes capacités, notre kit de montage turbo promet également une conduite plus verte. Soyez témoin de l'harmonie de la puissance et de l'éco-conscience au fur et à mesure que vous avancez avec chaque plein de carburant, réduisant ainsi votre empreinte carbone.</p><p>Vous sentirez non seulement la différence dans vos performances de conduite, mais ce kit peut également prolonger la durée de vie de votre moteur en réduisant le stress et en favorisant une combustion efficace. Cela contribue à prolonger la durée de vie de votre véhicule.</p>"
            }
          },
          btn_more_info: {
            text: "PLUS D'INFORMATION"
          }
        }
      },
      ajusil: {
        titulo: "<strong>Ajusil</strong> mastic silicone",
        texto:
          "La meilleure solution en ce qui concerne l'étanchéité des systèmes qui n'utilisent pas de joints d'étanchéité. Ce silicone neutre, à faible odeur et sans danger pour le capteur d'oxygène, répond aux exigences les plus élevées en matière de fiabilité, de résistance thermique et de résistance aux fluides. Disponible en deux formats : 200 ml et 75 ml."
      },
      ajusev: {
        titulo:
          "<strong>AjusEV</strong> Mastic silicone pour véhicule électrique",
        texto:
          "Mastic silicone exclusif pour véhicules hybrides et électriques. Il garantit une bonne étanchéité face aux agents atmosphériques externes et protège les composants électroniques du véhicule. Il est conseillé de l'utiliser dans la zone des batteries et dans l'unité de contrôle de puissance (PCU). Disponible en boîtes de 310 ml."
      },
      ajustick: {
        titulo: "<strong>Ajustick</strong> Mastic anaérobie",
        texto:
          "Mastic anaérobie de composants métalliques avec surfaces usinées. Il résiste à une large plage de températures (entre -50º et 150ºC, atteignant 180º ponctuellement). Disponible en boîtes de 50 ml."
      },
      ajulock: {
        titulo: "<strong>Ajulock</strong>  Fixateur de filetage",
        texto:
          "Produit mono composant anaérobie de moyenne résistance. Conçu pour protéger les parties métalliques du moteur (écrous, vis, asperges) du desserrage provoqué par les chocs et les vibrations. Disponible en boîtes de 50 ml."
      },
      ajulube: {
        titulo: "<strong>Ajulube</strong> Lubrifiant montage moteur",
        texto:
          "Huile de montage qui lubrifie et protège les composants mécaniques de l'usure pendant le démarrage initial du moteur. Empêche le contact métal contre métal sur les composants soumis à une pression élevée : arbres à cames, poussoirs hydrauliques, vilebrequins ou pistons. Disponible en boîtes de 100 ml."
      },
      productos_quimicos: {
        titulo: "Ligne de produits chimiques",
        texto:
          "Nous garantissons une fonctionnalité optimale sur tous les types de moteurs avec notre gamme de produits chimiques. Ces produits répondent aux exigences les plus élevées en matière d'utilisabilité et de résistance thermique et sont adaptés aux différents besoins du moteur.",
        ver_mas: "Voir plus",
        details: {
          intro: {
            alt: "ligne de produits chimiques",
            title: '<h1 class="title title-36">Produits chimiques</h1>',
            text:
              "<p>Chez Ajusa, nous portons l'entretien du moteur à un tout autre niveau.</p><p>Si vous êtes un mécanicien professionnel, notre gamme complète de <span class='bold'>produits d'étanchéité, de lubrifiants pour moteur et de freins filets</span> a été soigneusement conçue pour garantir des performances optimales et une fiabilité inégalée pour vos précieux véhicules.</p><p>Entrez dans un royaume d'excellence automobile et découvrez les solutions parfaites pour libérer tout le <span class='bold'>potentiel de vos moteurs.</span></p>",
            btn_text: "CATALOGUE EN LIGNE",
            btn_redirect: "https://web.tecalliance.net/ajusa/fr/home",
            slider: [
              {
                img: "/static/img/productos-quimicos/intro-main-quimicos.webp",
                alt: "mastic silicone"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-0.webp",
                alt: "produits chimiques 200ml"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-1.webp",
                alt: "produits chimiques 75ml"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-2.webp",
                alt: "produits chimiques ajusil"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-0.webp",
                alt: "mastic silicone pour véhicule électrique"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-1.webp",
                alt: "mastic silicone pour véhicule électrique 1"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-2.webp",
                alt: "mastic silicone pour véhicule électrique 2"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-0.webp",
                alt: "mastic anaérobie"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-1.webp",
                alt: "mastic anaérobie 1"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-2.webp",
                alt: "mastic anaérobie 2"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-0.webp",
                alt: "lubrifiant montage moteur"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-1.webp",
                alt: "lubrifiant montage moteur 1"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-2.webp",
                alt: "lubrifiant montage moteur 2"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-0.webp",
                alt: "fixateur de filetage"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-1.webp",
                alt: "fixateur de filetage 1"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-2.webp",
                alt: "fixateur de filetage 2"
              }
            ]
          },
          dropdowns: {
            "dropdown-1": {
              title:
                "Produits et matériaux chimiques pour l'industrie automobile",
              content:
                "<p>Que vous soyez un <span class='bold'>mécanicien professionnel</span>, un passionné d'automobile ou un propriétaire d'entreprise à la recherche de solutions, nous avons ce qu'il vous faut. Des produits d'étanchéité haute performance, aux freins filets anaérobies, en passant par les <span class='bold'>lubrifiants moteurs spécialisés</span>, notre gamme de produits chimiques est conçue pour améliorer vos projets automobiles.</p><p>En mettant l'accent sur la qualité, la performance et la fiabilité, nos solutions sont approuvées par les professionnels de l'industrie dans le monde entier. Quelle que soit l'ampleur de votre projet, nos aurons une solution pour vous.</p><p>Rejoignez les innombrables professionnels qui nous ont fait confiance pour leurs projets automobiles et découvrez la différence que peuvent faire des <span class='bold'>produits chimiques de haute qualité.</span></p>"
            },
            "dropdown-2": {
              title: "Solutions d'étanchéité pour l'industrie automobile",
              content:
                "<p>Nos mastics ont été soigneusement sélectionnés pour créer une barrière étanche et empêcher le desserrage dans les conditions les plus exigeantes. Notre équipe d'experts a méticuleusement testé et affiné chaque produit pour s'assurer qu'il réponde aux normes les plus élevées de l'industrie, vous offrant ainsi la tranquillité d'esprit pour vos projets.</p><p>Ces solutions d'étanchéité sont capables de créer une liaison solide et durable, garantissant que vos <span class='bold'>composants automobiles restent bien en place</span>, qu'il s'agisse d'éviter les fuites, de réduire le desserrage induit par les vibrations ou de résister aux fluctuations de température importantes.</p>"
            },
            "dropdown-3": {
              title:
                "Principes de base de la lubrification du moteur pour les véhicules",
              content:
                "<p>Une bonne <span class='bold'>lubrification est essentielle</span> pour assurer le bon fonctionnement, les performances et la longévité du moteur de votre véhicule. Sans lubrification adéquate, les composants connaîtraient une résistance accrue, entraînant une perte de puissance et une diminution des performances globales.</p><p>De plus, en créant un film protecteur d'huile entre ces pièces mobiles, la <span class='bold'>lubrification minimise le contact direct métal sur métal</span>, empêchant l'usure prématurée et la génération de chaleur. Privilégiez un entretien régulier, choisissez les bons lubrifiants et profitez d'une conduite douce, efficace et fiable.</p>"
            },
            "dropdown-4": {
              title: "Quel est le meilleur frein filet pour voiture?",
              content:
                "<p>Lorsqu'il s'agit de sélectionner le meilleur frein-filet pour les voitures, <span class='bold'>Ajulock</span> se distingue comme un choix de premier ordre pour les passionnés et les professionnels de l'automobile. Ce produit chimique est un frein filet anaérobie mono-composant haute performance qui excelle dans la fourniture de solutions de fixation sûres et fiables pour une large <span class='bold'>gamme d'applications automobiles.</span></p><p>En plus de ses excellentes propriétés de liaison, <span class='bold'>Ajulock agit également comme une barrière fiable contre l'humidité et la corrosion.</span> En scellant les éléments nocifs, ce frein-filet aide à protéger vos composants automobiles, prolongeant leur durée de vie et améliorant leurs performances globales.</p>"
            }
          },
          btn_more_info: {
            text: "PLUS D'INFORMATION"
          }
        }
      },
      nuevo_sellante: {
        titulo: "MASTIC ANAÉROBIE",
        texto:
          "Ajusa lance son nouveau produit : AJUSTICK pour l'étanchéité des composants métalliques avec des surfaces usinées. Mastic anaérobie (pas besoin d'oxygène pour le durcissement final) résistant à une large plage de température (entre -50º et 150ºC, atteignant 180ºC ponctuellement). Disponible en boîtes de 50 ml.",
        enlace_ficha_tecnica:
          "/static/pdf/info-tecnica/info_technique_ajustick_es.pdf"
      },
      taques: {
        titulo: "POUSSOIRS HYDRAULIQUES",
        texto:
          "Précision et qualité pour notre ligne de poussoirs hydrauliques. Nous vérifions l'ensemble du processus de production avec une tolérance de 100 % en microns.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/application-sealant-ajusil9.pdf",
        details: {
          intro: {
            alt: "poussoirs hydrauliques",
            title:
              '<h1 class="title title-36">Poussoirs Hydrauliques chez Ajusa</h1>',
            text:
              "<p>Chez Ajusa, nous sommes leaders dans l'industrie de la fabrication automobile. Un de nos domaines d'expertise réside dans notre section d'usinage avancée, où vous pouvez découvrir notre gamme de <span class='bold'>poussoirs hydrauliques</span> de haute qualité.</p><p>Grâce à notre vaste expérience en usinage, nous avons la capacité de concevoir et de <span class='bold'>produire des poussoirs hydrauliques</span> qui dépassent les normes les plus strictes en termes de qualité, de performance et de fiabilité.</p><p>Ces pièces de moteur jouent un rôle essentiel dans le fonctionnement <span class='bold'>efficace du train de soupapes de tout moteur</span>. Elles garantissent non seulement une action précise des soupapes, mais maintiennent également les jeux optimaux requis et offrent une action hydraulique hautement efficace.</p>",
            btn_text: "CATALOGUE EN LIGNE",
            btn_redirect: "https://web.tecalliance.net/ajusa/fr/home",
            slider: [
              {
                img: "/static/img/products/taques-1.webp",
                alt: "Poussoirs hydrauliques ajusa"
              },
              {
                img: "/static/img/products/taques-2.webp",
                alt: "Poussoirs pour réparation de moteur"
              },
              {
                img: "/static/img/products/taques-3.webp",
                alt: "Poussoirs hydrauliques"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Notre Gamme de Poussoirs Hydrauliques",
              content:
                "<p>Les poussoirs hydrauliques sont des dispositifs essentiels dans le monde de <span class='bold'>l'automobile. Chez Ajusa</span>, nous avons perfectionné leur conception et leur fabrication afin d’offrir des produits de la plus haute qualité.</p><p>Notre large <span class='bold'>gamme de poussoirs hydrauliques</span> est conçue pour répondre à diverses applications de l'industrie automobile. Nos produits sont polyvalents et sûrs.</p>"
            },
            "tip-2": "none"
          },
          dropdowns: {
            "dropdown-1": {
              title: "Caractéristiques Techniques des Poussoirs Hydrauliques",
              content:
                "<p>Les poussoirs hydrauliques fabriqués par Ajusa sont reconnus pour leur excellence en matière de conception et de performance. Ces pièces <span class='bold'>essentielles du moteur</span> intègrent plusieurs caractéristiques techniques clés qui les distinguent :</p><p><span class='bold'>Technologie Hydraulique Avancée:</span><br>Nos poussoirs hydrauliques utilisent une technologie hydraulique de pointe pour garantir un fonctionnement doux et précis, se traduisant par une réponse immédiate et des performances optimales en tout temps.</p><p><span class='bold'>Construction de Haute Qualité:</span><br>Chaque poussoir hydraulique est fabriqué avec des matériaux de haute qualité capables de résister aux conditions les plus exigeantes. La durabilité et la solidité sont des éléments fondamentaux de notre processus de fabrication.</p><p><span class='bold'>Tolérances Précises:</span><br>Nos poussoirs hydrauliques sont fabriqués avec des tolérances extrêmement précises pour garantir un ajustement parfait dans le train de soupapes du moteur. Cela se traduit par une action précise des soupapes et un fonctionnement sans problème.</p><p><span class='bold'>Performance dans Diverses Conditions:</span><br>Nos poussoirs hydrauliques sont conçus pour fonctionner de manière fiable dans diverses conditions, des températures extrêmes aux environnements à haute pression. Leur capacité à maintenir des performances constantes est l'une de leurs caractéristiques distinctives.</p><p><span class='bold'>Facilité d'Installation et d'Entretien:</span><br>Nous accordons une grande importance à la facilité d'installation et d'entretien dans la conception de nos poussoirs hydrauliques. Cela réduit les temps d'arrêt du moteur et garantit un fonctionnement efficace.</p><p><span class='bold'>Conformité Réglementaire: </span><br>Tous nos poussoirs hydrauliques sont conformes aux normes les plus strictes de l'industrie et aux normes de qualité. Cela garantit la sécurité et la fiabilité de chacun de nos produits.</p>"
            },
            "dropdown-2": {
              title: "Comment Choisir les Bons Poussoirs Hydrauliques?",
              content:
                "<p>Choisir les <span class='bold'>bons poussoirs hydrauliques</span> est une décision stratégique pour votre entreprise et peut faire la différence en termes d'efficacité opérationnelle et de sécurité. Chez Ajusa, nous vous fournissons les meilleurs conseils et avis professionnels pour que vous puissiez prendre des décisions éclairées et précises.</p><p>De plus, tous nos poussoirs hydrauliques répondent aux normes et réglementations les plus strictes de l'industrie. Consultez notre catalogue en ligne pour trouver la référence dont votre véhicule a besoin.</p>"
            }
          },
          btn_more_info: {
            text: "PLUS D'INFORMATION"
          }
        }
      },
      arbol_levas: {
        titulo: "ARBRES À CAMES",
        texto:
          "Nous fabriquons des arbres à cames à partir de barres d'acier moulé qui sont façonnées sur des centres d'usinage modernes et des rectifieuses automatiques permettant de garantir un niveau de qualité élevé et constant.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/application-sealant-ajusil10.pdf",
        details: {
          intro: {
            alt: "arboles de levas",
            title: '<h1 class="title title-36">Arbres à cames</h1>',
            text:
              "<p>En plus de notre vaste expérience dans la production de poussoirs hydrauliques, la section d'usinage d'Ajusa est également dédiée à la <span class='bold'>fabrication d'arbres à cames</span> à partir de barres d'acier moulé, en utilisant des machines de rectification de pointe pour atteindre des niveaux optimaux de précision et d'efficacité.</p><p>Les <span class='bold'>arbres à cames</span> représentent des éléments critiques dans le système de distribution des soupapes d'un moteur, étant responsables de la régulation de l'ouverture et de la fermeture des soupapes d'admission et d'échappement du moteur. Par conséquent, ils jouent un rôle essentiel dans l'obtention de performances et d'efficacité exceptionnelles du moteur.</p>",
            btn_text: "CATALOGUE EN LIGNE",
            btn_redirect: "https://web.tecalliance.net/ajusa/fr/home",
            slider: [
              {
                img: "/static/img/products/arbol-levas-1.webp",
                alt: "Arbres à cames Ajusa"
              },
              {
                img: "/static/img/products/arbol-levas-2.webp",
                alt: "Composants moteur Ajusa"
              },
              {
                img: "/static/img/products/arbol-levas-3.webp",
                alt: "Composants pour la réparation de moteurs"
              },
              {
                img: "/static/img/products/arbol-levas-4.webp",
                alt: "Catalogue Arbres à cames"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Arbre à cames Ajusa: Dynamisez votre moteur",
              content:
                "<p>Découvrez la <span class='bold'>gamme complète d'arbres à cames</span> disponibles chez Ajusa pour augmenter les performances de votre moteur. Avec notre vaste expérience dans la fabrication de composants automobiles de haute qualité, nous sommes votre meilleur choix pour optimiser votre véhicule.</p><p>Pour faciliter le montage du produit, Ajusa a développé un manuel complet de remplacement de l'arbre à cames, qui est inclus, avec le lubrifiant de montage Ajulube, dans tous ses arbres à cames.</p>"
            },
            "tip-2": {
              title: "Notre variété d'arbres à cames",
              content:
                "<p>Chez <span class='bold'>Ajusa<span>, nous comprenons que chaque véhicule est unique. C'est pourquoi nous proposons une large gamme d'arbres à cames conçus pour répondre à différents besoins en matière de performances et d'applications. Que vous recherchiez une mise à niveau haute performance ou une pièce de qualité OEM, nous avons la solution parfaite pour vous.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Avantages de choisir nos arbres à cames",
              content:
                "<p><span class='bold'>Qualité inégalée</span>:<br>Tous nos arbres à cames sont fabriqués selon les normes de qualité les plus élevées, garantissant une durabilité et des performances exceptionnelles.</p><p><span class='bold'>Technologie innovante</span><br>: Nous intégrons les dernières innovations techniques dans la conception et la fabrication de nos arbres à cames pour vous assurer d'utiliser le meilleur de la technologie automobile.</p><p><span class='bold'>Performance éprouvée</span><br>: Nos pièces subissent des tests de performance rigoureux pour garantir qu'elles répondent et dépassent les attentes en termes de puissance et d'efficacité. </p><p><span class='bold'>Large compatibilité</span><br>: Nous proposons des arbres à cames pour une large gamme de marques et de modèles de véhicules, ce qui facilite la recherche de la pièce parfaite pour votre voiture.</p><p><span class='bold'>Garantie de confiance</span><br>: Nous élaborons nos arbres à cames avec une solide garantie de performance, vous offrant la tranquillité d'esprit et la confiance dans votre choix.</p><p>Lorsque vous choisissez les arbres à cames Ajusa, vous optez pour l'excellence en ingénierie automobile. Donnez de la puissance à votre moteur et améliorez votre expérience de conduite avec la qualité et les performances qu'AJUSA peut elle seule offrir.</p>"
            },
            "dropdown-2": {
              title: "Manuel de remplacement de l'arbre à cames",
              content:
                "<p><span class='bold'>Ajusa</span> a développé un <span class='bold'>manuel complet de remplacement de l'arbre à cames</span> pour faciliter ce processus dans les moteurs. Ce manuel est inclus, ainsi que le <span class='bold'>lubrifiant d'assemblage Ajulube</span>, dans tous ses arbres à cames.</p><p><span class='bold'>Étapes détaillées pour le démontage et le montage de l'arbre à cames</span></br>Le démontage et le montage de l'arbre à cames sur un moteur se composent de plusieurs étapes qui doivent être suivies avec précision. Tout d'abord, il est nécessaire de placer le cylindre n°1 en position de <span class='bold'>point mort haut (PMH)</span> et de vérifier que l'arbre à cames est en phase.</p><p>Ensuite, le moteur doit être immobilisé avec la courroie de distribution ou la chaîne, le couvercle de la culasse, et les accessoires entraînés par l'arbre à cames, doivent être retirés.</p><p>Puis, il est nécessaire de démonter la poulie de l'arbre à cames et ses supports, suivi du démontage de <span class='bold'>l'arbre à cames</span> et des <span class='bold'>poussoirs</span>. À ce stade, il est important de jeter les poussoirs hydrauliques et de vérifier que les sièges de l'arbre à cames dans la culasse ne sont pas usés.</p><p>Si les sièges de la culasse sont en mauvais état, il est recommandé de remplacer les bagues. De plus, il est suggéré de lubrifier les sièges de l'arbre à cames et les supports avec l'huile fournie.</p><p>Ensuite, les poussoirs et <span class='bold'>l'arbre à cames</span> sont montés sur leurs sièges dans la culasse, en plaçant la poulie et en serrant la vis de fixation selon les spécifications. Puis, la courroie de distribution ou la chaîne est montée, en appliquant la tension appropriée, et il est vérifié manuellement que l'arbre à cames tourne librement lorsque le vilebrequin tourne.</p><p>Enfin, le moteur est à nouveau vérifié et le couvercle de la culasse et les composants sont assemblés dans l'ordre inverse du démontage. Visitez notre <span class='bold'>chaîne de mécanique sur YouTube</span>, vous y trouverez des vidéos sur le montage de ce composant.</p>"
            }
          },
          btn_more_info: {
            text: "PLUS D'INFORMATION"
          }
        }
      },
      otros: {
        titulo: "AUTRES COMPOSANTS",
        texto:
          "Plus de 80.000 références différentes de joints en fibre, caoutchouc et caoutchouc-métal. Les points forts comprennent notre gamme complète de joints de pompe à eau, de vannes EGR et de thermostats. Nous assurons la réparation la plus complète de votre voiture ou de votre véhicule utilitaire.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/application-sealant-ajusil11.pdf",
        details: {
          intro: {
            alt: "otros componentes",
            title: '<h1 class="title title-36">Autres Composants</h1>',
            text:
              "<p>Nous vous proposons des produits d'étanchéité et <span class='bold'>d'autres composants Ajusa</span> conçus pour garantir le bon fonctionnement de votre moteur. Dans notre catalogue, vous trouverez une <span class='bold'>large sélection de joints pour différentes parties du moteur</span>, telles que la pompe à eau, la vanne EGR, le compresseur de frein, le thermostat, entre autres.</p><p>Si vous avez besoin <span class='bold'>d'acheter un autre composant</span> parmi ceux que vous avez vu sur notre site Web pour votre moteur, n'hésitez pas à nous contacter, que vous soyez propriétaire d'un atelier professionnel ou un particulier. Nous sommes là pour répondre à vos questions et vous aider à trouver la pièce dont vous avez besoin.</p>",
            btn_text: "CATALOGUE EN LIGNE",
            btn_redirect: "https://web.tecalliance.net/ajusa/fr/home",
            slider: [
              {
                img: "/static/img/products/otros-1.webp",
                alt: "Pièces de rechange Ajusa"
              },
              {
                img: "/static/img/products/otros-2.webp",
                alt: "Joints en fibre"
              },
              {
                img: "/static/img/products/otros-3.webp",
                alt: "Joints métal-caucho"
              },
              {
                img: "/static/img/products/otros-4.webp",
                alt: "Catalogue de joints"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Autres Composants et Pièces pour Votre Moteur",
              content:
                "<p>Chez Ajusa, nous savons que l'étanchéité est essentielle dans divers composants du moteur. C'est pourquoi nous proposons une large gamme de solutions d'étanchéité et d'autres composants Ajusa couvrant différentes parties du moteur.</p>"
            },
            "tip-2": "none"
          },
          dropdowns: {
            "dropdown-1": {
              title: "Catalogue de Pièces",
              content:
                "<p><span class='bold'>Joints de Pompe à Eau</span><br>Les joints conçus pour la pompe à eau sont essentiels pour éviter les fuites et maintenir un refroidissement adéquat du moteur. Nos joints sont fabriqués avec précision pour assurer une étanchéité parfaite.</p><p><span class='bold'>Joints de Vanne EGR</span><br>Les joints de vanne EGR sont cruciaux pour garantir un flux de gaz contrôlé dans le système d'échappement, réduisant les émissions et améliorant l'efficacité du moteur. Faites confiance à nos joints pour maintenir le bon fonctionnement de votre moteur !</p><p><span class='bold'>Joints de Compresseur de Frein</span><br>Les joints du compresseur de frein sont un autre composant Ajusa pour la sécurité de votre véhicule. Nos joints de haute qualité assurent une étanchéité hermétique, ce qui est essentiel pour un fonctionnement fiable du système de freinage</p>.<p><span class='bold'>Joints de Thermostat</span><br>Le thermostat régule la température du moteur, et nos joints de thermostat garantissent que ce composant fonctionne correctement. Une étanchéité optimale est essentielle pour éviter la surchauffe et les dommages au moteur</p>.<p><span class='bold'>Autres Composants Ajusa Disponibles</span><br>En plus de ces pièces mentionnées ci-dessus, nous proposons une grande variété d'autres composants Ajusa pour différentes applications moteur.Venez les découvrir !</p>"
            },
            "dropdown-2": {
              title: "Caractéristiques et Avantages",
              content:
                "<p>Chez <span class='bold'>Ajusa</span>, nous fournissons des joints et des pièces d'ingénierie de haute qualité. Nos pièces d'étanchéité se distinguent par :</p><p><span class='bold'>- Conception précise</span>: Chaque joint est fabriqué avec précision pour assurer un ajustement parfait et une étanchéité optimale.</p><p><span class='bold'>- Qualité supérieure</span>: Nous utilisons les matériaux de la plus haute qualité qui résistent aux conditions les plus exigeantes et prolongent la durée de vie de votre moteur.</p><p><span class='bold'>- Avantages significatifs</span>: En utilisant nos solutions d'étanchéité, vous obtenez des performances fiables, une efficacité améliorée et une durée de vie prolongée de votre moteur.</p>"
            },
            "dropdown-3": {
              title: "Qualité et Conformité Réglementaire",
              content:
                "<p>Nous nous engageons à l'excellence dans la fabrication <span class='bold'>de pièces d'étanchéité et d'autres composants Ajusa</span> pour votre moteur. Nous respectons rigoureusement les réglementations les plus strictes et les normes de qualité de l'industrie automobile.</p><p>Nos pièces sont synonymes de sécurité et de performances pour votre moteur.</p>"
            }
          },
          btn_more_info: {
            text: "MÁS INFORMACIÓN"
          }
        }
      },
      garantia: {
        titulo:
          "<span class='bold'>Normes de qualité</span> des produits chimiques AJUSA",
        titulo1:
          "<h2 class='title title-36'><span class='bold'>qualité garantie</span> sur tous nos produits</h2>",
        texto:
          "Tous les produits chimiques AJUSA sont certifiés TUV conformément aux réglementations ISO 9001 et IATF 16949.",
        boton: "Retrouvez les certificats ici",
        cumplimiento:
          "Notre engagement envers la santé et la sécurité est primordial. Conformément aux directives énoncées dans le décret royal 396/2006 concernant les réglementations en matière de santé et de sécurité sur les lieux de travail susceptibles d'être exposés à l'amiante, nous vous assurons que nos produits d'étanchéité, lubrifiants moteur et frein-filet sont entièrement sans amiante."
      },
      shared: {
        "junta-turbo": "joint-turbo",
        ajusil: "ajusil",
        "arbol-levas": "arbre-came",
        "junta-culata": "joint-culasse",
        "junta-motor": "joint-moteur",
        otros: "autres",
        retenes: "joints d'étanchéité",
        taques: "poussoirs",
        tornillos: "vis",
        "tubos-engrase": "tubes-graissage",
        "tubos-egr": "tubes-egr",
        nuevo_sellante: "nouveau_joint"
      },
      titulo_banner: "Choisissez la langue",
      idiomas: {
        GE: "Allemand",
        EN: "Anglais",
        ES: "Espagnol",
        FR: "Français",
        HU: "Hongrois",
        IT: "Italien",
        NL: "Holandais",
        PL: "Polonais",
        PT: "Portugais",
        BG: "Bulgare",
        CZ: "Tchèque",
        GR: "Grec",
        SL: "Slovène",
        SK: "Slovaque",
        SE: "Suédois",
        RU: "Russe",
        RO: "Roumain",
        LT: "Lituanien",
        LV: "Letton"
      },
      nav_options: {
        vehiculo_electrico: {
          title: "véhicule électrique",
          category: "vehiculo_electrico",
          href: "vehicule-electrique"
        },
        junta_culata: {
          id: "joints-culasse",
          title: "joints de culasse",
          category: "product"
        },
        junta_motor: {
          id: "joints-moteur",
          title: "JEUX DE JOINTS POUR LE MOTEUR",
          category: "product"
        },
        tornillos: {
          id: "vis",
          title: "VIS DE CULASSE",
          category: "product"
        },
        retenes: {
          id: "etancheite",
          title: "JOINTS D'ÉTANCHÉITÉ",
          category: "product"
        },
        tubos_engrase: {
          id: "tubes-graissage",
          title: "TUBES DE GRAISSAGE",
          category: "product"
        },
        tubos_egr: {
          id: "tubes-egr",
          title: "tubes EGR",
          category: "product"
        },
        tubos_refrigeracion: {
          id: "tuyaux-refroidissement",
          title: "tuyaux de refroidissement",
          category: "product"
        },
        junta_turbo: {
          id: "joints-turbo",
          title: "JEUX DE JOINTS POUR TURBO",
          category: "product"
        },
        productos_quimicos: {
          id: "produits-chimiques",
          title: "produits chimiques",
          category: "productos"
        },
        taques: {
          id: "poussoirs",
          title: "POUSSOIRS HYDRAULIQUES",
          category: "product"
        },
        arbol_levas: {
          id: "arbres-cames",
          title: "ARBRES À CAMES",
          category: "product"
        },
        otros: {
          id: "autres",
          title: "AUTRES COMPOSANTS",
          category: "product"
        }
      },
      alt_images: {
        juntas_culata: "Joints de culasse",
        tornillos: "Vis de culasse",
        tubos_engrase: "Tuyaux de graissage turbo",
        "junta-culata-1": "Joint de culasse Ajusa",
        "junta-culata-2": "Catalogue joints de culasse",
        "junta-culata-3": "Joints de culasse mls",
        "junta-motor-1": "Jeux de joints complets Ajusa",
        "junta-motor-2": "Jeux de joints Ajusa",
        "junta-motor-3": "Pièces de rechange pour moteur",
        "junta-motor-4": "Joints pour véhicules industriels",
        "junta-motor-5": "Pièce pour la réparation de moteur des voitures",
        "tornillos-1": "Vis de culasse Ajusa",
        "tornillos-2": "Vis Ajusa",
        "tornillos-3": "Vis à serrage angulaire",
        "tornillos-4": "Catalogue Vis de culasse",
        "retenes-1": "Joints Ajusa",
        "retenes-2": "Joints spi jusa",
        "retenes-3": "Joints de tige de soupape Ajusa",
        "retenes-4": "Joints spi pour voitures",
        "tubos-engrase-1": "Tuyaux de graissage Ajusa",
        "tubos-engrase-2": "Composants turbo Ajusa",
        "tubos-engrase-3": "Tuyaux de graissage pour turbocompresseur",
        "tubos-engrase-4": "Composants pour turbocompresseur",
        "tubos-egr-1": "tubes egr ajusa",
        "tubos-egr-2": "vanne egr ajusa",
            "tubos-refrigeracion-1": "Tuyaux de refroidissement Ajusa",
        "junta-turbo-1": "Kits de montage turbo Ajusa",
        "junta-turbo-2": "Joint pour turbo",
        "junta-turbo-3": "Kits de montage turbo",
        "junta-turbo-4": "Jeu de joints pour turbo",
        sellantes_lubricantes: "mastic silicone",
        sellante_silicona: "produits chimiques",
        sellante_silicona_electrico: "mastic silicone pour véhicule électrique",
        sellante_anaerobico: "mastic anaérobie",
        lubricante_motor: "fixateur de filetage",
        fijador_roscas: "lubrifiant montage moteur",
        "taques-1": "Poussoirs hydrauliques ajusa",
        "taques-2": "Poussoirs pour réparation de moteur",
        "taques-3": "Poussoirs hydrauliques",
        "arbol-levas-1": "Arbres à cames Ajusa",
        "arbol-levas-2": "Composants moteur Ajusa",
        "arbol-levas-3": "Composants pour la réparation de moteurs",
        "arbol-levas-4": "Catalogue Arbres à cames",
        "otros-1": "Pièces de rechange Ajusa",
        "otros-2": "Joints en fibre",
        "otros-3": "Joints métal-caucho",
        "otros-4": "Catalogue de joints",
        taller_electrico: "atelier véhicule électrique"
      }
    },
    catalogo: {
      intro: {
        titulo: "AJUSA Catalogue",
        texto:
          "Vous trouverez la pièce dont vous avez besoin pour votre véhicule dans le catalogue AJUSA. Le plus grand du secteur automobile avec plus de 200 000 références à votre disposition.",
        catalogo_impreso: "catalogue <br>imprimé",
        catalogo_impreso_texto:
          "Nous facilitons votre travail. Demandez le catalogue général AJUSA sur papier",
        catalogo_impreso_boton: "Demander"
      },
      cat_general: {
        texto:
          "AJUSA met à jour son catalogue tous les deux ans pour assurer la couverture la plus complète des joints de culasse, des vis de culasse, des jeux de joints de moteur et d'autres pièces d'entretien telles que les poussoirs hydrauliques et les arbres à cames."
      },
      buscador: {
        placeholder: "Rechercher par marque de véhicule",
        titulo:
          "Utilisez le moteur de recherche ci-dessus ou sélectionnez l'initiale de la marque qui vous intéresse."
      },
      cat_turbo: {
        titulo: "catalogue turbos",
        texto:
          "La plus large gamme de jeux de joints pour turbo et tubes de graissage se trouve dans le catalogue de turbos d'AJUSA. Vous pouvez rechercher la référence par modèle du véhicule ou marque du turbo.",
        por_vehiculo: "TÉLÉCHARGER PAR MARQUE DE VÉHICULE",
        por_turbo: "télécharger par marque de turbo"
      },
      cat_juntas_compresor: {
        titulo: "CATALOGUE JOINTS DE COMPRESSEUR",
        texto:
          "Consultez ou téléchargez en PDF le catalogue de jeux de joints pour servo-frein exclusivement pour véhicule industriel. Vous pouvez le télécharger par compresseur (KNORR-BREMSE, VOITH et WABCO) ou par marque de véhicule (DAF, IVECO, MAN, MERCEDES (industriel), RVI, SCANIA et VOLVO (industriel).",
        por_vehiculo: "TÉLÉCHARGER PAR MARQUE DE VÉHICULE",
        por_turbo: "Télécharger par compresseur"
      },
      cat_juegoJuntas: {
        idUrl: "joints-spéciaux",
        texto:
          "<strong>14 familles de jeux</strong>  de joints pour différentes parties du moteur dans un seul catalogue. Jeux de joints pour <strong>pompe à eau</strong>, pompe à carburant, pompe hydraulique, pompe à vide, carter de commande, collecteur d'admission, collecteur d'échappement, compresseur, injecteur, radiateur d'huile, système d'échappement, système EGR et <strong>couvercle de culasse de cylindre</strong>. Nous garantissons la couverture la plus complète du marché. Vous pouvez consulter et télécharger le catalogue complet ou le jeu de joints dont vous avez besoin..",
        descarga_completo: "TÉLÉCHARGER LE CATALOGUE COMPLET",
        descarga_juegos: {
          title: "TÉLÉCHARGER PAR JEUX DE JOINTS",
          bombasAgua: "Pompe à eau",
          bombasAgua_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-agua-gasket-water-pump.pdf",
          bombasCombustible: "Pompe à carburant",
          bombasCombustible_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-combustible-fuel-pump.pdf",
          bombaHidraulica: "Pompe hydraulique",
          bombaHidraulica_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-hidraulica-hydraulic-pump.pdf",
          bombaInyeccion: "Pompe d'injection",
          bombaInyeccion_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-inyeccion-injector-pump.pdf",
          bombaVacio: "Pompe à vide",
          bombaVacio_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-vacio-vacuum-pump.pdf",
          juntaCarter: "Carter de commande",
          juntaCarter_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/carter-mando-timing-case.pdf",
          colectorAdminision: "Collecteur d'admission",
          colectorAdminision_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/colector-admision-intake-manifold.pdf",
          colectorEscape: "Collecteur d'échappement",
          colectorEscape_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/colector-escape-exhaust-manifold.pdf",
          comprensor: "Compresseur",
          comprensor_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/compresor-charger.pdf",
          inyector: "Injecteur",
          inyector_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/inyector-injector-nozzle.pdf",
          radiadorAceite: "Radiateur d'huile",
          radiadorAceite_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/radiador-aceite-oil-cooler.pdf",
          sistemaEscape: "Système d’échappement",
          sistemaEscape_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/sistema-escape-exhaust-system.pdf",
          sistemaEGR: "Système EGR",
          sistemaEGR_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/sistema-juntas-EGR-System.pdf",
          tapasCulata: "Couvercle de culasse de cylindre",
          tapasCulata_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/tapa-culata-cilindro-cilinder-head-cover.pdf"
        }
      },
      tec_alliance: {
        intro: "accès au catalogue en ligne",
        titulo: "VOTRE RECHERCHE EN LIGNE",
        texto_1:
          "Trouvez la pièce détachée dont vous avez besoin à tout moment. Le catalogue en ligne AJUSA est disponible 24H/ 24. Vous pouvez effectuer une recherche par véhicule, moteur, VIN, numéro de référence, référence OEM ou données techniques.",
        texto_2:
          "Toutes les références AJUSA sont accompagnées d'informations techniques, de vidéos de montage et de photographies 360º.",
        boton: "accéder"
      },
      ajusa_th: {
        intro: "ÉNERGIES ALTERNATIVES",
        titulo: "POUR ASSURER UN AVENIR DURABLE",
        texto:
          "AJUSA a développé un axe de recherche sur les énergies alternatives et est pionnière dans la fabrication de piles à combustible PEM à hydrogène. Découvrez AJUSA Technologies utilisant l'hydrogène",
        boton: "Découvrir",
        construccion: "Page en construction. Bientôt disponible."
      },
      retenes: {
        titulo: "Catalogue jeu de joints d'étanchéité de distribution",
        texto:
          "Ajusa lance un catalogue spécifique de joints de distribution avec une large couverture pour le remplacement complet de la courroie de distribution du véhicule."
      },
      motorsport: {
        titulo: "Motorsports",
        texto:
          "Consultez le guide des applications Ajusa Motorsport. Un catalogue complet de joints de culasse pour moteurs haute performance. Ces moteurs ont besoin de pièces spécifiques et améliorées en raison des conditions extrêmes auxquelles ils sont exposés. Les joints de performance Ajusa assurent une étanchéité parfaite dans les moteurs sportifs et hautes performances."
      },
      novedad: "Nouveauté",
      nav_options: {
        cat_general: {
          id: "cat-general",
          title: "catalogue général",
          category: "catalogo"
        },
        cat_turbo: {
          id: "cat-turbo",
          title: "catalogue des turbocompresseurs",
          category: "catalogo"
        },
        cat_ve: {
          title: "Catalogue VE",
          category: "vehicule-electrique",
          href: "vehicule-electrique"
        },
        catalogo_online: {
          title: "catalogue en ligne",
          redirect: "https://web.tecalliance.net/ajusa/fr/home"
        },
        catalogo_impreso: {
          title: "Demander un catalogue imprimé",
          category: "catalogo",
          href: "contacter"
        }
      },
      alt_images: {
        catalog: "catalogue ajusa",
        catalog_online: "catalogue en ligne ajusa",
        pila_hidrogeno: "pile à combustible pem"
      }
    },
    area_tecnica: {
      intro: {
        titulo: "AJUSA service technique",
        texto:
          "<strong class='bold'>Bienvenue au service d'assistance technique d'AJUSA!</strong> Nous résolvons vos problèmes et mettons à votre disposition un large éventail de matériel didactique comprenant des <strong class='bold'>rapports techniques, des vidéos de montage et des webinaires. </strong>Nous nous engageons à vos côtés et à la réparation."
      },
      asesoramos: {
        intro: "Nous vous conseillons",
        texto_1:
          "Si vous avez des problèmes avec nos produits, vous êtes au bon endroit. Nous résolvons vos doutes et répondons à vos questions en moins de cinq jours. Envoyez-nous votre message et le service d'assistance technique AJUSA vous proposera une solution.",
        texto_2: "Vous pouvez nous appeler au +34 619 029 273 ou nous écrire à",
        boton: "Envoyer"
      },
      app: {
        texto_1:
          "Téléchargez notre APPLICATION améliorée pour rechercher rapidement et facilement les composants dont votre véhicule a besoin.",
        texto_2: "Et bien plus encore!"
      },
      tips: {
        titulo: "RAPPORTS TECHNIQUES",
        texto_1:
          "Vous cesserez d'avoir des doutes et des problèmes avec le montage et le démontage des produits AJUSA. Vous découvrirez les caractéristiques de chaque composant du moteur et vous apprendrez à reconnaître la pièce dont chaque véhicule a besoin. Tout cela et bien plus encore : voilà ce que vous offre le guide des rapports techniques d'AJUSA. Téléchargez-les!",
        texto_2:
          "Nous publions un nouveau rapport technique tous les 15 jours.",
        filtrar: "Filtrer par catégories",
        por_keyword: "Rechercher par mot-clé",
        resultado: "Résultats de la recherche:",
        mostrando: "Affichage",
        novedades: "NOUVEAUTÉS"
      },
      webinarios: {
        titulo: "webinaires",
        texto:
          "Nous vous formons en ligne. Inscrivez-vous à nos webinaires et apprenez la mécanique sans bouger de chez vous. Des séances gratuites d'une heure qui amélioreront vos connaissances et vous permettront d'acquérir de l'expérience. Anglais et espagnol",
        proximos: "prochains webinaires",
        no_hay: "Aucun webinaire n'est prévu pour le moment",
        anadir_cal: "ajouter au calendrier",
        hasta: "19 h à 21 hde",
        ultimo: "",
        btn: "Demander un webinaire"
      },
      asesoramiento: {
        intro: "conseils",
        titulo: "NOUS PROPOSONS DES SOLUTIONS",
        texto:
          "AJUSA vous accompagne dans la réparation de votre véhicule en mettant à votre disposition un service d'assistance technique pour répondre à vos questions.",
        boton: "En quoi pouvons-nous vous aider?"
      },
      nav_options: {
        ajusa_app: {
          id: "ajusa-app",
          title: "app mobile ajusa",
          category: "area_tecnica"
        },
        tips: {
          id: "tips",
          title: "rapports techniques",
          category: "area_tecnica",
          alert: true
        },
        actualidad_videos: {
          id: "nouvelles-videos",
          title: "vidéos sur la mécanique",
          category: "area_tecnica",
          redirect: "https://www.youtube.com/channel/UCnoYVeFbsPiOVOcf80tW6Bg"
        },
        webinars: {
          id: "webinaires",
          title: "webinaires",
          category: "area_tecnica"
        }
      },
      alt_images: {
        juntas_culata_mls: "joints de culasse mls Ajusa"
      }
    },
    ajusa: {
      intro: {
        titulo: "ÉVOLUONS <span class='bold'>ENSEMBLE</span>",
        texto:
          "Nous sommes une références dans le secteur des composants de moteur parce que nous croyons en ce que nous faisons. Depuis 1972, nous prenons soin de votre véhicule grâce au dévouement et à la technologie appliquée dans le développement de composants moteurs."
      },
      enlaces: {
        calidad: "qualité originale",
        servicio: "service",
        compromiso: "engagement social",
        equipo: "équipe humaine",
        catalogo: "catalogue"
      },
      calidad: {
        titulo: "QUALITÉ ORIGINALE",
        texto:
          "Nous garantissons une qualité d'équipement originale dans toute notre gamme de produits et respectons les normes de qualité les plus élevées. Nous sommes certifiés TÜV selon les normes ISO 9001 et IATF 16949."
      },
      servicio: {
        titulo: "service",
        texto:
          "Nous nous engageons envers nos clients. Où qu'ils soient, nos produits arrivent toujours à l'heure. Nous garantissons un taux de service de 99,5 %."
      },
      compromiso: {
        titulo: "engagement<br>social et environnemental",
        texto:
          "Nous contribuons à une amélioration de notre environnement en collaborant à différentes causes sociales et caritatives. Notre responsabilité envers l'environnement fait également partie de l'engagement social d'AJUSA.",
        texto_btn: "BILAN CARBONE",
        pdf: "/static/pdf/Ajusa_Carbon_Footprint_Report.pdf"
      },
      equipo: {
        titulo: "équipe humaine",
        texto:
          "Nous investissons en permanence dans l'amélioration des talents professionnels et dans le développement de nos employés. Derrière chaque composant AJUSA, il y a une équipe flexible et dynamique, avec un esprit d'amélioration continue."
      },
      catalogo: {
        titulo: "catalogue",
        texto:
          "Le catalogue AJUSA est notre principale marque d'identité et le point de référence des spécialistes du moteur dans le monde entier. Avec plus de 200 000 références, il est le plus complet du marché. Vous y trouverez le composant dont vous avez besoin pour votre véhicule."
      },
      excelencia: {
        titulo: "EXCELLENCE, ÉGALEMENT DANS L'UTILISATION DES RESSOURCES",
        texto:
          "Nous atteignons l'excellence tout en prenant soin de notre environnement. Nous minimisons l'impact environnemental grâce aux économies d'énergie et à l'utilisation d'énergies renouvelables. Nous disposons de la certification TUV selon le",
        enlace_texto: " norme ISO 14001 ",
        texto_2:
          "et plus de <strong class='bold'>8.000 panneaux solaires qui génèrent 40 % de la consommation électrique annuelle</strong> de notre usine de production.",
        boton: "AFFICHER LE CERTIFICAT"
      },
      historia: {
        titulo: "histoire",
        texto:
          "Nous avons une histoire à vous raconter. L'effort et le dépassement marquent les pas de cette entreprise familiale qui a commencé son parcours en 1972, en fabriquant des joints de culasse. Nous avons grandi, nous avons évolué... Découvrez notre histoire!",
        boton: "accéder"
      },
      alt_images: {
        sede_principal: "siège social d'Ajusa",
        fabricante_tubos_engrase: "fabricant de tuyaux d'alimentation en huile",
        social: "ajusa engagement social et environnemental",
        factoria_automocion: "l'usine Ajusa",
        catalog_juntas: "catalogue de Joints Ajusa",
        historia: "histoire d'Ajusa"
      }
    },
    actualidad: {
      noticias: {
        titulo: "dernière nouvelles",
        ir_blog: "Aller sur le blog"
      },
      twitter: {
        titulo: "Ajusa sur les réseaux sociaux",
        acceder: "Accéder"
      },
      videos: {
        titulo: "vidéos",
        texto:
          "Vous verrez, étape par étape, comment les pièces AJUSA sont montées sur un vrai moteur. Le moyen le plus simple et le plus pratique d'apprendre à réaliser le montage parfait d'un joint de culasse et de tous les composants du moteur fabriqués par AJUSA. Tous les 15 jours, nous mettons à jour notre chaîne avec un nouveau véhicule.",
        ultimos: "dernières vidéos",
        ver_todos: "voir toutes les vidéos"
      }
    },
    blog: {
      intro: {
        titulo: "MISE <span>AU POINT</span>",
        subtitulo: "Le blog de"
      },
      categorias_nombres: {
        fairs: "salons",
        products: "produits",
        "our-sector": "Notre secteur",
        "social-commitment": "Engagement social"
      },
      alt_images: {
        ajusa_blog: "ajusa blog",
        puesta_punto: "tunnig",
        ferias: "automechanika stand ajusa",
        productos: "joints de culasse ajusa",
        "nuestro-sector": "notre secteur ajusa",
        "compromiso-social": "engagement social"
      },
      ultimas: "Dernières actualités",
      dejar_comentario: "LAISSER UN COMMENTAIRE",
      titulo_comentarios: "COMMENTAIRES RÉCENTS",
      noticias_relacionadas: "Nouvelles associées",
      compartir: "Partager",
      no_hay_post: "Il n'y a pas de post dans cette catégorie"
    },
    sala_prensa: {
      clipping: {
        titulo: "CLIPPING",
        texto:
          "Les médias du secteur automobile se font l'écho des nouveautés d'AJUSA. Voici le résumé annuel des apparitions d'AJUSA dans la presse.",
        boton: "télécharger",
        logotipo: "logo",
        imagenes: "images"
      },
      ajusa: {
        intro: "à propos d'ajusa",
        titulo: "L'EXCELLENCE DANS LE SECTEUR AUTOMOBILE",
        texto:
          "Nous fabriquons des joints de culasse depuis 1972. Leaders de l'étanchéité des moteurs grâce à la plus large gamme de joints moteur de l'industrie. Également experts dans la fabrication de tubes de graissage pour turbo et d'ensembles de joints pour turbo. Toujours au service de l'automobile."
      }
    },
    historia: {
      texto_intro:
        "Nous sommes une référence mondiale depuis plus de 45 ans. Nous travaillons à l'amélioration constante de nos produits et de nos services.",
      hoy: "Aujourd'hui",
      texto_1972_1:
        "AJUSA voir le jour en 1972. Cette année-là, le premier joint de culasse est fabriqué, en 3 heures et entièrement à la main!",
      texto_1972_2:
        "Nous avons assisté aux premiers salons internationaux et avons agrandi les installations en nous déplaçant au polygone Campollano.",
      texto_1980_1:
        "Nous avons lancé le premier catalogue général avec 600 références. Le catalogue actuel en a 20 fois plus ! Il compte plus de 200 000 références, avec une couverture complète des marques asiatiques et européennes.",
      texto_1980_2:
        "Nous avons réussi à fabriquer une première pour la première équipe : le joint de culasse pour Renault.",
      texto_1990_1:
        "Nous ouvrons le Centre de recherche et d'essais, où nous effectuons les contrôles de qualité les plus exhaustifs de nos produits",
      texto_1990_2:
        "Lancement de 3 nouvelles lignes de produits: vis de culasse, poussoirs hydrauliques et arbres à cames.",
      texto_2000_1:
        "Ajusa se développe à l'international et ouvre des succursales en Russie, en Angleterre, au Mexique et au Brésil. Elle intègre des partenaires stratégiques dans le monde entier.",
      texto_2000_2:
        "Nous déménageons au parc d'affaires auquel nous donnons nom d'Ajusa. Avec plus de 40.000 m2 d'usine de production et 3.000 m2 de bureaux.",
      texto_2010_1:
        "Depuis 2014, nous produisons des tubes de graissage pour turbo et lançons le catalogue de composants turbo les plus référencés sur le marché.",
      texto_2010_2:
        "Depuis 2014, nous produisons des tubes de graissage pour turbo et lançons le catalogue de composants turbo les plus référencés sur le marché."
    },
    contacto: {
      titulo: "SERVICE CLIENT",
      sucursales: "Filiales",
      coords: {
        lat: 45.8049383,
        lng: 1.2731825
      },
      id: "francia",
      delegaciones: {
        espana: {
          nombre: "Espagne",
          titulo: "siège social",
          direccion:
            "Parque Empresarial Ajusa, Calle 1, nº1 · 02008 · ALBACETE (Espagne) · Apdo./P.O. Box 415 (02080)",
          telefono: "Tél.: +34 967 216 212",
          fax: "Fax: +34 967 216 214 - 967 240 499",
          email: "Email: <a href='mailto:ajusa@ajusa.es'>ajusa@ajusa.es</a>"
        },
        // rusia: {
        //     nombre: "Russie",
        //     titulo: "Ajusa-Russie",
        //     direccion: "108803, Москва, п. Воскресенское, пос. Воскресенское, д. 66, а/я 1890",
        //     telefono: "Tél. +7(499) 608-06-81 / +7(916) 060-07-24",
        //     fax: "",
        //     email: "Contact: <a href='mailto: info@ajusa.ru'> info@ajusa.ru</a>"
        // },
        uk: {
          nombre: "Royaume-Uni",
          titulo: "Ajusa UK Ltd",
          direccion: "Unit 25, Hortonwood 33, Telford, TF1 7EX",
          telefono: "Tél. +44 (0)195 2608 771",
          fax: "",
          email:
            "Contact: <a href='mailto:info@ajusa.co.uk'>info@ajusa.co.uk</a>"
        },
        mexico: {
          nombre: "Mexique",
          titulo: "Ajusa México S.A. de C.V",
          direccion:
            "Calle Lago Ladoga, 295-A · Col. Anahuac, Deleg. Miguel Hidalgo · Ciudad de México, D.F. CP 11320 (México)",
          telefono: "Tél. +52-55 5254 2332",
          fax: "Fax +52-55 5254 2332",
          email:
            "Contact: <a href='mailto:ajusamexico@ajusa.com.mx'>ajusamexico@ajusa.com.mx</a>"
        },
        brasil: {
          nombre: "Brésil",
          titulo: "Ajusa do Brasil Ltda.",
          direccion:
            "Rua Santa Francisca, 417 · Bairro Vila Jaguara, 05116-090 · SAO PAULO, SP (Brasil)",
          telefono: "Tél. +55 11 3622-5353",
          fax: "Fax +55 11 3622-5353",
          email:
            "Contact: <a href='mailto:ajusadobrasil@ajusa.com.br'>ajusadobrasil@ajusa.com.br</a>"
        },
        usa: {
          nombre: "ÉTATS-UNIS",
          titulo: "AJUSA USA Corp.",
          direccion:
            "GABLES INTERNATIONAL PLAZA · 2655 S. LE JEUNE ROAD SUITE # 905 · CORAL GABLES, FL 33134",
          telefono: "Tél. +1 310 625 1034",
          fax: null,
          email:
            "Contact: <a href='mailto:ajusausa@ajusa.es'>ajusausa@ajusa.es</a>"
        },
        francia: {
          nombre: "France",
          titulo: "Ajusa France",
          direccion: "64, Rue Paul Claudel, 87000 | Limoges (France)",
          telefono: "Tél. +33 587 14 71 17",
          fax: null,
          email:
            "Contact: <a href='mailto:ajusafrance@ajusa.fr'>ajusafrance@ajusa.fr</a>"
        }
      },
      alt_images: {
        contacto_ajusa: "contacter ajusa",
        trabajar_ajusa: "travailler avec nous ajusa"
      },
      phone: "+33 587 14 71 17",
      email: "ajusafrance@ajusa.fr"
    },
    trabaja_con_nosotros: {
      intro: {
        titulo: "<span class='bold'>travaillez</span> avec nous",
        texto:
          "Au sein d'AJUSA, il y a toujours de la place pour le talent. Nous travaillons chaque jour à notre croissance. Si vous souhaitez faire partie de notre grande famille, remplissez ce formulaire et joignez votre curriculum vitae."
      },
      texto:
        "Chez Ajusa, nous travaillons chaque jour à notre croissance. Si vous souhaitez faire partie de notre grande famille, remplissez ce formulaire et joignez votre curriculum vitae.",
      boton: "envoyer un curriculum vitae"
    },
    formulario: {
      nombre: "Nom",
      nombre_apellidos: "Prénom et nom",
      apellidos: "Nom",
      email: "E-mail",
      mensaje: "Message",
      fecha_nacimiento: "Date de naissance",
      dia: "Jour",
      mes: "Mois",
      anyo: "Année",
      area_interes: "Domaine d'intérêt",
      trabaja_actualmente: "Travaillez-vous actuellement?",
      motivo: "Motif de la consultation",
      si: "Oui",
      no: "Non",
      carta_presentacion: "Lettre de motivation",
      tipos_contacto: {
        general: "Général, contact, succursales",
        comercial: "Commercial",
        formacion: "Formation",
        asistencia_tecnica: "Support Technique",
        catalogo: "Demander un catalogue papier",
        webinar: "Demander un webinaire"
      },
      meses: {
        Enero: "Janvier ",
        Febrero: "Février",
        Marzo: "mars",
        Abril: "avril",
        Mayo: "mai",
        Junio: "juin",
        Julio: "juillet",
        Agosto: "août",
        Septiembre: "septembre",
        Octubre: "octobre",
        Noviembre: "novembre",
        Diciembre: "décembre"
      },
      archivo_adjunto: "Joindre un fichier",
      adjuntar_cv: "Joindre un CV",
      empresa: "Nom de l’entreprise",
      sector: "Secteur",
      formulario: "Adresse complète (indiquer CP et localité)",
      referencia: "Référence du produit",
      introduce_mail: "Saisissez votre e-mail",
      tipo_catalogo: "Type de catalogue",
      pais: "Pays",
      ciudad: "Ville",
      direccion: "Adresse",
      telefono: "Téléphone",
      quiero_recibir:
        "Je souhaite recevoir des nouvelles et des actualités d'Ajusa.",
      acepto_comunicaciones:
        "J'accepte de recevoir la newsletter ou d'autres communications de votre entreprise.",
      otros_procesos:
        "Je souhaite que l'on prenne en compte ma candidature pour d'autres processus de recrutement d'Ajusa qui pourraient m'intéresser.",
      he_leido:
        "Je consens à l'utilisation de mes données aux fins indiquées dans la",
      y_acepto: "Politique de confidentialité",
      enviar_comentario: "Envoyer un commentaire",
      comentario_enviado: "Commentaire envoyé",
      texto_comentario_enviado:
        "Merci pour votre commentaire. Nous l'examinerons et le publierons dans les plus brefs délais.",
      enviar: "Envoyer",
      enviado: "Envoyé",
      popup: {
        claim:
          "Cliquez ici pour consulter et accepter la politique de confidentialité",
        intro: "INFORMATIONS PRINCIPALES SUR LA PROTECTION DES DONNÉES",
        textos: [
          {
            titulo: "Responsable du traitement",
            texto: "Auto Juntas SAU"
          },
          {
            titulo: "Adresse du responsable du traitement",
            texto:
              "Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02008, Albacete (Albacete)"
          },
          {
            titulo: "Finalité",
            texto:
              "Vos données seront utilisées pour répondre à vos demandes et vous fournir nos services."
          },
          {
            titulo: "Publicité",
            texto:
              "Nous ne vous enverrons des publicités qu'avec votre consentement préalable, que vous pouvez nous donner en cochant la case prévue à cet effet."
          },
          {
            titulo: "Légitimation",
            texto:
              "Nous ne traiterons vos données qu'avec votre consentement préalable, que vous pouvez nous donner en cochant la case appropriée prévue à cet effet."
          },
          {
            titulo: "Destinataires",
            texto:
              "En général, seul le personnel dûment autorisé de notre entité peut avoir connaissance des informations que nous demandons."
          },
          {
            titulo: "Droits",
            texto:
              "Vous avez le droit de savoir quelles sont les informations vous concernant que nous détenons, de les corriger et de les supprimer, comme indiqué dans les informations complémentaires disponibles sur notre site web."
          }
        ],
        boton: "Je comprends"
      },
      thank_you: {
        title: "SENT !",
        text:
          "<p>Merci ! Le formulaire a été envoyé avec succès.</p><p>Nous reviendrons vers vous dès que possible.</p>",
        btn_text: "RETOUR À LA PAGE D'ACCUEIL"
      }
    },
    error_404: {
      intro: "<span class='bold'>PAGE</span> INTROUVABLE",
      nombre: "Erreur 404",
      texto:
        "Désolé! La page à laquelle vous essayez d'accéder n'existe plus ou a été déplacée.",
      boton: "Retour en haut de la page"
    },
    newsletter: {
      titulo: "Abonnement newsletter",
      texto:
        "Recevez les nouveautés du secteur automobile et les dernières nouvelles d'AJUSA.",
      suscripcion_ok:
        "Inscription réussie! À partir de maintenant, nous vous tiendrons au courant de toutes les nouvelles d'Ajusa"
    },
    footer: {
      siguenos: "Suivez-nous",
      en_redes: "Suivez-nous sur les réseaux sociaux",
      twitter: "Suivez-nous sur X",
      facebook: "Suivez-nous sur Facebook",
      instagram: "Suivez-nous sur Instagram",
      canal: "Abonnez-vous à la chaîne",
      selecciona_idioma: "Choisissez une langue",
      alt_image: "Certificats ajusa"
    },
    popupApp: {
      title: "Télécharger Ajusa mobile",
      description:
        "Le guide le plus complet du secteur automobile avec toutes les informations sur les produits AJUSA."
    },
    popupretenes: {
      title:
        "Nouveau catalogue<br> de joints d'étanchéité <br>de distribution Ajusa",
      boton: "Consultez-le et téléchargez-le par marque"
    },
    popupjuntas: {
      novedades: "NOUVEAU CATALOGUE",
      title: "JEUX SPÉCIAUX DE JOINTS",
      texto: "pour différentes parties du moteur",
      boton: "VOIR LE CATALOGUE"
    },
    popupajustick: {
      title: "NOUVEAU PRODUIT",
      description: "MASTIC ANAÉROBIE AJUSTICK",
      boton: "VOIR LE PRODUIT"
    },
    otras_secciones: {
      catalogo: {
        titulo: "Catalogue",
        texto:
          "Le moyen le plus simple de trouver la pièce dont votre véhicule a besoin et sa référence. Le catalogue AJUSA contient des utilisations pour toutes les marques de véhicules européens et asiatiques. Vous pouvez réaliser la consultation en ligne ou demander le catalogue imprimé.",
        boton_texto: "Aller au catalogue"
      },
      area_tecnica: {
        titulo: "Conseil",
        texto:
          "Le service d'assistance technique AJUSA est  <span class='bold'>à votre disposition</span>. Nos collègues répondent personnellement à toutes les questions. Par ailleurs, vous pouvez consulter notre <span class='bold'>guide de rapports techniques et nos tutoriels vidéo</span> dans lesquels nous expliquons pas à pas comment assembler nos produits.",
        boton_texto: "Besoin d'aide ?"
      },
      sala_prensa: {
        titulo: "Salle de presse",
        texto:
          "Consultez les documents Ajusa mis à votre disposition ainsi que les actualités et le résumé annuel des apparitions d'AJUSA dans la presse automobile.",
        boton_texto: "VOIR LES MATÉRIAUX"
      },
      solicite_catalogo: {
        titulo: "demandez le catalogue imprimé",
        texto:
          "Nous facilitons la réparation des véhicules. Vous pouvez commander notre catalogue général ou celui des turbos sur papier. Envoyez-nous une demande indiquant le catalogue qui vous intéresse.",
        boton_texto: "demander"
      },
      actualidad: {
        titulo: "Nouveautés",
        texto:
          "Nous voulons vous tenir au courant de notre quotidien et des dernières nouveautés. Visitez notre blog, abonnez-vous à notre newsletter ou suivez-nous sur les réseaux sociaux. Nous partageons des expériences! ",
        boton_texto: "NOUS VOUS ATTENDONS"
      },
      donde_estamos: {
        titulo: "où sommes-nous?",
        texto:
          "Nous sommes là où vous avez besoin de nous. Nous disposons de distributeurs officiels dans le monde entier et de succursales au Mexique, au Brésil, en Russie et en Angleterre. Notre usine et siège principal, d'où nous développons tout le travail, est à Albacete (Espagne).",
        boton_texto: "Contactez-nous"
      }
    },
    banner_cookies:
      "Un cookie est un petit fichier d'informations qui est enregistré dans votre navigateur chaque fois que vous consultez notre site Web. L'objectif des cookies est de stocker l'historique de votre activité sur notre site web afin que, lorsque vous le visitez à nouveau, il puisse vous identifier et configurer le contenu en fonction de vos habitudes de navigation, de votre identité et de vos préférences. Vous pouvez les accepter, les rejeter, les bloquer et les supprimer, comme vous le souhaitez. Si vous les refusez, nous ne serons pas en mesure de vous assurer du bon fonctionnement de notre site Web. Plus d'informations dans la section <router-link to='/politica-de-cookies'>Politique d'utilisation des cookies</router-link>.",
    boton_aceptar: "Accepter",
    historia_infografia: {
      celebracion50:
        '<p>Célébration du</p><p class="second-line">50e anniversaire</p>',
      celebracion50descripcion:
        "Le 11 novembre 2022, on a réuni tous nos employés au Teatro Circo d’Albacete, pour célébrer nos 50 ans d’histoire.",
      video: "VÍDEO",
      galeria: "GALERIE D'IMAGES",
      noticias: "NOUVELLES",
      urlNoticias:
        "https://ajusa.online/en/blog/news/ajusa-celebrates-50-anniversary",
      urlVideoIntro: "/static/img/historia_infografia/intro.mp4",
      Anios50: "<strong>50 </strong>ANS",
      excedencia: "'d’excellence",
      enAutomocion: "DANS L'AUTOMOBILE",
      albacete: "<strong>ALBACETE</strong>",
      laCuidad: "LA VILLE QUI A ÉTÉ TÉMOIN",
      crecer: "de notre évolution",
      mayorAntesDeTiempo: "DÈS LE DÉBUT",
      textMayor:
        "<strong>Il était le cinquième d'une fratrie de six. À l'âge de 9 ans, il devient orphelin de mère et à l'âge de 15 ans de son père, qui a travaillé toute sa vie dans le secteur des transports. </strong>",
      eraseUnaVez: "Il était une fois…",
      textEraseUnaVez:
        "Albacete, le 13 février 1950. Est né José Manuel Martínez Martínez, fondateur d'Ajusa. Sa situation familiale l'a contraint à abandonner l'école et à l'âge de 13 ans, il a commencé à travailler comme assistant dans un magasin de tableaux et dans une charcuterie de son quartier.",
      cuentameMas: "DITES-M'EN PLUS!",
      unGestoInolvidable: "Un geste inoubliable",
      enEsteTrabajo:
        "Grâce à cet emploi, il a pu s'inscrire à la <strong>sécurité sociale</strong>. Ce fait, si rare à l'époque, était très important pour lui.",
      aprendiendoElOficio: "En apprenant le métier…",
      con14Anios:
        "Josema a découvert sa véritable vocation à l'âge de 14 ans lorsqu'il a commencé à travailler chez le concessionnaire Pegaso d'Albacete (COMALBASA), où il a rapidement été nommé responsable du département des pièces détachées.",
      granImplicacion: "Une grande implication",
      fueronAnios:
        "Ce sont des années de grand dévouement et d'apprentissage, au cours desquelles il combine son service militaire à Séville avec son travail chez Auto Martínez, une entreprise de pièces détachées qu'il a fondée avec ses frères en 1969.",
      fueronMeses:
        "Il travaillait de nuit au service militaire pour gérer Auto Martínez pendant la journée. Son implication était telle qu'il dépensait <strong>plus de 50 000 pesetas par mois en appels téléphoniques!</strong>",
      naceAjusa: "Naissance d'Ajusa",
      suEspiritu:
        "Poussé par son esprit d'entreprise et sa passion pour l'industrie automobile, José Manuel Martínez a décidé de créer sa propre entreprise. En 1972, il ouvre un petit établissement où sont fabriqués les premiers joints de moteur de marque espagnole.",
      naceLaCompania:
        "C'est ainsi qu'est fondée l'entreprise industrielle Auto Juntas (aujourd'hui Ajusa), dont il est toujours le président.",
      miguelOliver:
        "Miguel Oliver a été nommé directeur industriel et José Gómez responsable artisan en outillage à la carte.",
      primeraJuntas:
        "Les premiers joints de culasse ont été fabriqués entièrement à la main à l'aide de notre propre outillage, qui était également produit en interne.",
      seTardada:
        "Il fallait autrefois environ 3 heures pour produire un joint de culasse, alors qu'aujourd'hui nous pouvons produire 1000 joints de culasse en 3 heures.",
      primeraEtapa:
        "Dans cette première phase, des matériaux tels que l'amiante ont été utilisés. Ajusa a été le premier fabricant au monde à cesser d'utiliser ce matériau actuellement interdit.",
      contanciaEsfuerzo: "Persévérance et effort",
      josemaRecorrio:
        "<strong>Josema a parcouru presque toutes les villes d'Espagne. Lorsqu'il arrivait sur un site, il prenait l'annuaire téléphonique et appelait un par un tous les ateliers et magasins de pièces détachées jusqu'à ce qu'on le reçoive personnellement pour qu'il puisse présenter le catalogue Ajusa. <br>C'est ainsi que notre marque a commencé à se faire connaître en Espagne.</strong>",
      edicion: "Édition",
      catalogoAjusa: "Catalogue Ajusa",
      infoCatalogo:
        "Le premier catalogue de joints d'étanchéité pour moteur est lancé un an seulement après la naissance d'Ajusa et avec un effectif de 10 employés. À l'époque, il comptait 600 références, alors qu'aujourd'hui, avec un effectif de 800 personnes, il en compte plus de 200.000.",
      verPortadas: "VOIR LES COUVERTURES",
      textInfo1974:
        "C'est ainsi qu'est née l'histoire d'amour entre Josema et Dori, parents de trois enfants : Consuelo, José Manuel et Noelia. Le fondement d'Ajusa repose sur les valeurs familiales et l'engagement.",
      amorAPrimera: "Coup de foudre",
      descriptAmor:
        "La fille sur la photo est Adoración Sánchez, qui a été employée pendant un an par Ajusa dans la section emballage et dans le département administratif. Le jour même où elle a quitté l'entreprise, Josema lui a téléphoné... pour lui proposer un rendez-vous!",
      crecimientoImparable: "Une croissance ininterrompue",
      text1crecimientoImparable:
        "Les années ont passé et avec des efforts, des sacrifices et le même enthousiasme que lors de sa création, Ajusa a poursuivi sa croissance ininterrompue, en déménageant dans la <strong>Zone industrielle Campollano d'Albacete</strong> et en agrandissant sa ligne de production.",
      text2crecimientoImparable:
        "Plus important encore, Josema a su garder intact l'esprit d'entreprise de ses débuts. Alors que le leadership de la marque sur le marché national était en train de s'établir, il visait déjà l'internationalisation.",
      verMas: "VOIR LA SUITE",
      title1978: "D'une entreprise locale…<br>au monde!",
      description1_1978:
        "Une présence précoce aux grands salons internationaux et un plan d'exportation ambitieux pour les années 1970 ont permis à l'entreprise de s'ouvrir aux marchés d'autres pays.",
      description2_1978:
        "Josema a défendu ses critères commerciaux et n'a pas succombé aux exigences des grandes multinationales. Il a même refusé des contrats de plusieurs millions de pesetas!",
      description3_1978:
        "En 1978, Ajusa participe à Automechanika, le plus important <strong>salon international de l'automobile</strong> qui se tient tous les deux ans à Francfort.",
      importanteReconociento: "Une reconnaissance importante!",
      espirituInnovador:
        "L'esprit innovateur et entrepreneurial que José Manuel Martínez a montré très jeune lui a permis d'obtenir la <strong>Médaille d'Or à l'Exportation <strong>Médaille d'Or à l'Exportation</strong> en 1981.",
      title1980: "Les fondements d'une grande entreprise",
      description1_1980:
        "L'expansion des services offerts et l'augmentation de la demande ont rendu nécessaire la mise en place d'installations de plus grande superficie.",
      description2_1980:
        "En 1980, Ajusa pose les fondations de sa première grande usine en agrandissant les installations de Campollano. Il ajoutera successivement des mètres carrés dans le seul but de fournir le meilleur service aux professionnels du secteur automobile.",
      title1992: "Expansion d l'entreprise",
      description1_1992:
        "Le joint de culasse reste le produit phare, mais 1992 est une année stratégique dans l'expansion de l'entreprise avec l'ajout de <strong>jeux complets de joints</strong> de moteur, de vis de culasse et d'une gamme complète de <strong>joints accessoires</strong>. La ligne d'usinage est également ouverte pour la fabrication de poussoirs hydrauliques et d'arbres à cames.",
      calidadGarantizada: "Qualité garantie",
      ajusaEmpresaPionera:
        "Ajusa a été l'une des entreprises avant-gardistes à obtenir les certifications de qualité AENOR selon ISO 9001 et IATF 16949 dans les années 90.",
      primeraEmpresaSector:
        "Elle a également été la <strong>première entreprise du secteur</strong> à offrir au client le kit complet de joints pour un même moteur.",
      title1996: "Nous ouvrons des filiales",
      description1_1996:
        "L'entreprise se consolide et devient un point de référence, en ouvrant plusieurs bureaux dans différents endroits tels que Los Angeles (USA), Sao Paulo (Brésil), Mexico (Mexique), Birmingham (Royaume-Uni) et Limoges (France).",
      eeuuPrimeraSucursal: "Les États-Unis, première succursale",
      sucursalEeuu:
        "La succursale américaine d'Ajusa a été la première à ouvrir ses portes et, comme les autres succursales, elle dispose d'un entrepôt comptant plus de 10 000 articles en stock.",
      comprometidosSostenibilidad: "Engagés en faveur de la durabilité",
      infocomprometidosSostenibilidad:
        "L'entreprise applique également une <strong>politique environnementale</strong> tout au long de sa chaîne de production pour minimiser l'impact sur l'environnement et dispose d'une installation photovoltaïque sur le toit de l'usine, qui fournit 30 % de la consommation des usines de production avec une puissance de 1500 KW.",
      title2002:
        "Pionniers dans le domaine des technologies utilisant l'hydrogène",
      description2002:
        "En 2002, Ajusa a créé une entreprise dédiée à la recherche de l'hydrogène en tant que source d'énergie alternative: <strong>Ajusa Tecnologías del Hidrógeno,</strong><br> qui applique actuellement les technologies les plus pointues dans la mise en œuvre de multiples projets avec la technologie PEM.",
      actualizamosLogo: "Nous actualisons notre logo",
      evolucionG: "Évolution graphique",
      title2008: "Parc d'affaires Ajusa",
      description1_2008:
        "Les locaux de production situés dans le parc d'affaires Ajusa ont été inaugurés en 2008, sans perdre pour autant ses racines locales.",
      description2_2008:
        "Un ensemble de 5 usines avec différentes lignes de production, intégrant la technologie la plus avancée et garantissant une fiabilité maximale de la gamme de produits Ajusa.",
      title2014: "Nouvelles lignes de production",
      description1_2014:
        "L'esprit d'innovation de Josema et de son équipe, associé à l'investissement continu de l'entreprise dans la recherche et le développement de produits, a facilité le lancement de la ligne de production de composants pour turbos, qui comprend à la fois le développement de joints et la production de tuyaux de graissage pour turbos.",
      description2_2014:
        "Cette année-là, la première édition du catalogue de composants pour turbos a également été lancée. Les lignes de production et l'équipe humaine ne cessaient de croître.",
      title2022: "Nous grandissons ensemble",
      description1_2022:
        "50 ans, qui ont apporté de <strong>nouvelles valeurs et de nouveaux produits à l'entreprise,</strong>, lui conférant une identité avec un fort sens de la responsabilité envers l'environnement. Voilà pourquoi Ajusa participe chaque année à divers projets visant à collaborer et à soutenir les actions sociales menées par différentes associations.",
      description2_2022:
        "Cette année, forts de notre passé, nous célébrons en toute responsabilité notre 50e anniversaire, sachant qu'il sera un point de référence dans l'histoire d'Ajusa et dans celle d'un futur où nous évoluons déjà.",
      verVideo: "VOIR LA VIDÉO",
      urlVideoCompl: "/static/img/historia_infografia/video-completo-es.mp4"
    },
    vehiculo_electrico: {
      intro_titulo: "VÉHICULE ÉLECTRIQUE",
      descripcion_intro:
        "Ajusa dispose d'un vaste catalogue de composants pour la réparation de véhicules hybrides et électriques. De plus, elle vous accompagne dans leur réparation grâce à des fiches explicatives de chaque panne que vous pouvez télécharger à partir de cette rubrique, et grâce à des tutoriels vidéo enregistrés par un spécialiste de la réparation de véhicules électriques.</br></br>",
      descripcion_intro2:
        "<img src='/static/img/vehiculo-electrico/triangle-exclamation-duotone.svg' style='height:20px; margin-right: 5px;' alt='icon important'/><strong>Mesures de sécurité et outils de base</strong> pour réparer un véhicule électrique. Cliquez sur la vidéo!",
      catalogo: {
        titulo: "CATALOGUE DE RÉPARATION DE MOTEURS ÉLECTRIQUES",
        descripcion:
          "Dans cette section, vous pouvez consulter le <strong>catalogue de pièces détachées Ajusa pour les véhicules hybrides et électriques</strong> en effectuant une recherche par marque de voiture. Chaque fiche produit du catalogue Ajusa comprend une description des principales pannes de ce modèle et un lien vers un tutoriel vidéo expliquant comment effectuer la réparation. "
      },
      sellado: {
        titulo: "SOLUTIONS D'ÉTANCHÉITÉ POUR VÉHICULE ÉLECTRIQUE",
        descripcion:
          "<strong>Leader mondial dans la fabrication de composants de remplacement pour les véhicules hybrides et électriques</strong>, nous sommes à l'avant-garde de l'industrie automobile. Nous fabriquons des composants pour l'industrie automobile depuis plus de 50 ans."
      },

      material: {
        titulo: "MATÉRIEL DIDACTIQUE AUDIOVISUEL",
        descripcion:
          "Aujourd'hui, il est essentiel de trouver des mécaniciens spécialisés en électromécanique. Le matériel didactique qu'Ajusa propose par le biais de ses tutoriels vidéo répond aux besoins de formation les plus <strong>exigeants en matière de véhicules hybrides et électriques</strong>. Vous apprendrez à réparer le moteur/générateur, les batteries ou les onduleurs/convertisseurs des véhicules électriques. Toutes les vidéos sont disponibles en scannant le code QR figurant sur l'étiquette de chaque produit."
      },
      porqueElegir: {
        titulo: "POURQUOI CHOISIR UN VEHICULE ELECTRIQUE OU HYBRIDE ?",
        descripcion:
          "<p>Chez Ajusa, nous comprenons que choisir un <strong>véhicule électrique (VE)</strong> ou une voiture <strong>hybride (HEV)</strong> va bien au-delà d'une simple décision de transport. C'est une déclaration d'engagement envers l'avenir et un investissement dans la mobilité durable.</p><p> Mais pourquoi devriez-vous acheter l'un de ces véhicules?</p>"
      },
      medioAmbiente: {
        titulo: "Contribuer à l'environnement",
        descripcion:
          "<p>Opter pour un véhicule électrique (VE) ou hybride (HEV) est un moyen concret de réduire votre empreinte carbone. Ces véhicules produisent moins d'émissions nocives et contribuent à la préservation de l'environnement.</p><p>En faisant confiance à Ajusa pour la réparation de composants de voitures électriques et hybrides, vous préservez votre véhicule écologique de la meilleure des façons.</p>"
      },
      ahorro: {
        titulo: "Économies à long terme",
        descripcion:
          "<p>Bien que l'investissement initial puisse être légèrement plus élevé, les véhicules électriques et hybrides offrent des économies significatives sur leur durée de vie. Avec des coûts énergétiques plus bas et un entretien moindre, vous remarquerez une différence substantielle dans vos dépenses.</p>"
      },
      experiencia: {
        titulo: "Expérience de conduite améliorée",
        descripcion:
          "<p>Les voitures électriques et hybrides offrent une expérience de conduite fluide, silencieuse et sans émissions. La dernière technologie de ces véhicules garantit des performances exceptionnelles et un confort inégalé sur la route.</p>"
      },
      innovacion: {
        titulo: "Soutien à l'innovation",
        descripcion:
          "<p>En choisissant une voiture électrique ou hybride, vous soutenez l'innovation dans l'industrie automobile. Ces véhicules stimulent la recherche et le développement de technologies plus propres et plus efficaces, ouvrant la voie à un avenir plus durable.</p>"
      },
      catalogo_vehiculo_hibrido:
        "CATALOGUE DE VÉHICULES HYBRIDES ET ÉLECTRIQUES",
      catalogo_vehiculo_hibrido_kits:
        "Tous nos kits de réparation sont également disponibles sans roulements.",
      catalogo_juntas_compresor:
        "CATALOGUE DE JOINTS DE COMPRESSEUR DE CLIMATISATION",
      renault: "RENAULT",
      modelo: "Modèle",
      ano: "Année",
      codigo_motor: "Code moteur",
      n_comprensor: "N° de compresseur",
      tipo_averia: "Type de panne",
      referencias_disponibles: "Références Ajusa disponibles ",
      otras_referencias: "Autres références",
      manual: "MANUEL DE RÉPARATION",
      videoReparacion: "REPARATION VIDÉO",
      commercialInfo: "SOLICITA INFORMAÇÕES COMERCIAIS",
      accessVideoTut: "ACCESO A TODOS LOS VIDEO TUTORIALES",
      videos: {
        video0: {
          id: "vehiculo-electrico-2",
          videoId: "svouPU4u8jY",
          text:
            "Sais-tu de quoi tu as besoin pour réparer un véhicule électrique ? Dans cette vidéo, nous t'expliquons <strong>les mesures de sécurité et les outils principaux</strong> qu'un atelier mécanique doit avoir.",
          btnText: "VIDÉO"
        },
        EV001900: {
          id: "AUDI",
          modelo: "AUDI E-tron 55",
          año: "2019 - 2023",
          codigoMotor: "EASA",
          referenciasDisponibles: "EV001900",
          videoId: "aM7HnIMiV8s"
        },
        EV001400: {
          id: "BMW",
          modelo: "BMW i3",
          año: "2012 - 2022",
          codigoMotor: "IB1P25B",
          referenciasDisponibles: "EV001400",
          videoId: "_krGGRnVYtI"
        },
        EV000500: {
          id: "Hyundai | Kia",
          modelo:
            "Hyundai Kona, Hyundai Kauai, Kia Niro EV, Kia E-Soul EV (III)",
          año: "2018-2023",
          codigoMotor: "EM16",
          referenciasDisponibles: "EV000500",
          videoId: "gi1Gbs3d9NA"
        },
        EV000700: {
          id: "hyundai",
          modelo: "Hyundai Ionic EV",
          año: "2016-2019",
          codigoMotor: "EM09, 88KW, 120CV",
          referenciasDisponibles: "EV000700",
          videoId: "D5RnWWK1JXM"
        },
        EV000600: {
          id: "kia",
          modelo: "Kia Soul EV (II) 81KW, 110CV",
          año: "2014-2018",
          codigoMotor: "ZD",
          referenciasDisponibles: "EV000600",
          videoId: "YJ82wEmqP5M"
        },
        EV001300: {
          id: "nissan",
          modelo: "Nissan LEAF ZE01",
          año: "2017-2022",
          codigoMotor: "EM57",
          referenciasDisponibles: "EV001300",
          videoId: "Sz-wPyY0To8"
        },
        EV001200: {
          id: "peugeot",
          modelo: "PEUGEOT E-208",
          año: "2020-",
          codigoMotor: "ZK01",
          referenciasDisponibles: "EV001200",
          videoId: "6zXy9dBiqsY"
        },
        EV000100: {
          id: "renault",
          modelo: "Renault Zoe",
          año: "2012-2018",
          codigoMotor: "5M- 450",
          referenciasDisponibles: "EV000100",
          videoId: "cI_eu063pw4"
        },
        EV000200: {
          id: "Renault | Smart",
          modelo: "Renault Zoe, Smart Fortwo W453",
          año: "Renault (2012-2019), Smart (2016-2019)",
          codigoMotor: "Renault (5AQ-601) Smart (5AL)",
          referenciasDisponibles: "EV000200",
          videoId: "ZA93lYHO_T0"
        },
        EV000300: {
          id: "tesla",
          modelo: "Tesla Model 3, Tesla Model Y",
          año: "2017-2021",
          codigoMotor:
            "1120980-00-G / 1120980-17-J / 1120990-00-J / 1672095-00-C / 1672096-00-B /1672096-00-C",
          referenciasDisponibles: "EV000300",
          videoId: "gazCfvf3N9c"
        },
        EV000400: {
          id: "tesla",
          modelo: "Tesla Model S · Tesla Model X",
          año: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          codigoMotor: "1035000-00-J",
          referenciasDisponibles: "EV000400",
          videoId: "CK5OeOPX-sM"
        },
        EV000800: {
          id: "tesla",
          modelo:
            "Tesla Model S · Tesla Model X · Mercedes B-Class B250e · Toyota RAV4 EV",
          año:
            "Tesla Model S (2012 – 2021) · Tesla Model X (2015 – 2021) · Mercedes B-Class B250e (2014 – 2017)  · Toyota RAV4 EV (2012 – 2014)",
          codigoMotor:
            "1002633-00-U / 002633-01-U / 1002633-01-U / 1025598-01-U",
          referenciasDisponibles: "EV000800",
          videoId: "JxbTKXWBRMw"
        },
/*         EV000802: {
          id: "tesla | Mercedes | Toyota",
          producto: "Coolant bypass kit",
          modelo:
            "Tesla Model S, Tesla Model X, Mercedes B-Class, Toyota Rav4 EV",
          año:
            "Tesla Model S (2012-2021), Tesla Model X (2015-2021), Mercedes (2014-2017), Toyota (2012-2014)",
          codigoMotor: "1002633-00-U, 1002633-01-U, 1025598-01-U",
          referenciasDisponibles: "EV000802",
          videoId: "d2gj_aTYW1o"
        }, */
        EV001000: {
          id: "tesla",
          modelo: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          año: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          codigoMotor: "1037000-20-A y 1037000-00-F",
          referenciasDisponibles: "EV001000",
          videoId: "gEr97ru09VQ"
        },
        EV001100: {
          id: "tesla",
          modelo: "Tesla Model 3 (2017-2025) · Tesla Model Y (2020-2025)",
          año: "Tesla Model 3 (2017-2025) · Tesla Model Y (2020-2025)",
          codigoMotor:
            "Dual Motor versions with front motor code 3D3 (also combined with 3D5, 3D6 or 3D7)",
          referenciasDisponibles: "EV001100",
          videoId: "MIVazJrPxOs"
        },
        EV000901: {
          id: "volvo",
          modelo: "Volvo V60",
          año: "2011-2018",
          codigoMotor: "D82PHEV, D87PHEV, D97PHEV y B1APHEV",
          referenciasDisponibles: "EV000901",
          videoId: "0_-WLtUpgm4"
        },
        EV001500: {
          id: "volkswagen",
          modelo: "E-Golf",
          año: "2014-2021",
          codigoMotor: "EBSA",
          referenciasDisponibles: "EV001500",
          videoId: "vv8NSjXvAlk"
        }
      },
      videosComprensor: {
        EVC00100: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012-2019",
          nComprensor: "1063369-00-G",
          referenciasDisponibles: "EVC00100",
          videoId: "A_h7O2TGtEU"
        },
        EVC00200: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012-2017",
          nComprensor: "1028398-00-E",
          referenciasDisponibles: "EVC00200",
          videoId: "71wMqdMsqHg"
        },
        EVC00300: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012",
          nComprensor: "6007380-00-C",
          referenciasDisponibles: "EVC00300",
          videoId: "Ok9Q-mgfJmw"
        },
        EVC00400: {
          id: "tesla",
          modelo: "Tesla Model X",
          año: "2015-2025",
          nComprensor: "1042442-00-D",
          referenciasDisponibles: "EVC00400",
          videoId: "5gOHPBtBtbA"
        }
      },
      hazte_experto: "DEVENEZ EXPERT !",
      reparacion_vehiculos:
        "EN RÉPARATION DE VÉHICULES HYBRIDES ET ÉLECTRIQUES",
      reparacion_vehiculos_descripcion:
        "Seulement 1 % des mécaniciens sont spécialisés dans la réparation des véhicules électriques. <strong>Vous pouvez être l'un d'entre eux</strong> grâce au matériel didactique qu'Ajusa inclut à tous ses composants pour véhicules hybrides et électriques.   ",
      reparacion_vehiculos_descripcion_2:
        "<strong>Scannez le code QR</strong> que vous trouverez sur <strong>l'étiquette de chaque produit</strong> pour accéder à un tutoriel vidéo qui vous guidera étape par étape tout au long du processus de réparation.",
      ajusa_te_lo_pone_facil: "AJUSA VOUS FACILITE LA TÂCHE",
      opiniones_titulo: "AVIS",
      opiniones: {
        opinion1: {
          cliente: "Julián Fernández | Electromecánica",
          descripcion:
            "“Une manière pratique et didactique qui m'a aidé à améliorer mes connaissances en mécanique des véhicules électriques.Également très satisfait de la qualité des composants pour véhicules électriques fabriqués par Ajusa”"
        },
        opinion2: {
          cliente: "Juan Soler | Taller AGR",
          descripcion:
            "“Avec les vidéos d'Ajusa, j'ai appris à réparer des moteurs électriques. Je recommande l'utilisation de ce matériel dans tous les ateliers d'apprentissage sur la mécanique des véhicules électriques.”"
        },
        opinion3: {
          cliente: "Bienvenido Martínez | Talleres El Paso",
          descripcion:
            "“Il suffit de scanner le QR de l'étiquette du produit que vous allez utiliser pour accéder à un tutoriel intéressant sur le montage de toutes les pièces. Très pratique et simple.”"
        },
        opinion4: {
          cliente: "Diego González | Garage Motor",
          descripcion:
            "“J'ai été surpris par le professionnalisme du mécanicien dans les vidéos et par la manière dont il explique pas à pas la réparation et l'assemblage du moteur. Ce sont des vidéos très utiles pour tout mécanicien. Je continuerai à les utiliser lors de futures réparations.”"
        }
      },
      dropdowns: {
        "dropdown-1": {
          title: "COMPOSANTS POUR LES VOITURES ÉLECTRIQUES",
          content:
            "<p> En ce qui concerne la réparation des composants des véhicules électriques (VE), les connaître est essentiel pour garantir un service efficace et de haute qualité. Chez Ajusa, nous avons une vaste expérience dans la réparation de tous les éléments fondamentaux qui font fonctionner une voiture électrique.</p>Moteur électrique Ce composant de votre voiture électrique nécessite uneattention experte en cas de problèmes.<h3><strong>Batterie de traction</strong></h3><p> La batterie de traction est un composant critique des voitures électriques et sa réparation est essentielle pour maintenir l'autonomie et l'efficacité de votre véhicule.</p><h3><strong>Batterie auxiliaire</strong></h3><p> En plus de la batterie principale, les véhicules électriques disposent d'une batterie auxiliaire qui alimente les systèmes essentiels</p><h3><strong>Convertisseur de puissance</strong></h3><p> Le convertisseur de puissance joue un rôle important dans la gestion de l'énergie. Tout problème avec ce composant de votre voiture électrique peut affecter les performances globales.</p><h3><strong> Chargeur embarqué</strong></h3><p> La recharge d'un véhicule électrique est une partie essentielle de son fonctionnement quotidien. Si vous rencontrez des problèmes avec le chargeur embarqué, nous pouvons vous offrir des solutions efficaces pour vous assurer que votre véhicule soit toujours prêt à prendre la route.</p><h3><strong>Transmission</strong></h3><p> Les transmissions des véhicules électriques sont différentes de celles des véhicules à combustion interne et nécessitent des connaissances particulières.</p><h3><strong>Prise de charge</strong></h3><p> La prise de charge est la porte d'entrée énergétique dans votre véhicule électrique. Si vous rencontrez des problèmes avec la prise de charge, nous pouvons vous aider à recharger votre véhicule.</p><h3><strong>Module électronique</strong></h3><p> Les modules électroniques jouent un rôle crucial dans le fonctionnement de votre véhicule.</p>"
        },
        "dropdown-2": {
          title: "COMPOSANTS POUR LES VOITURES HYBRIDES",
          content:
            "<p> Quand il s'agit de véhicules hybrides, il est essentiel de comprendre les éléments fondamentaux qui rendent leur fonctionnement possible.</p><p> Chez Ajusa, nous avons de l’expérience dans la réparation de ces composants, ce qui nous permet de proposer un service de haute qualité et sécurisé.</p><h3><strong>Moteur à combustion</strong></h3><p> Maintenir ce composant de votre voiture hybride en bon état est essentiel. Chez Ajusa, nous fournissons des services de réparation et d'entretien pour garantir une performance efficace et à faibles émissions.</p><h3><strong>Moteur-Alternateur électrique</strong></h3><p> Le moteur-alternateur électrique est un composant essentiel dans une voiture hybride, car il convertit l'énergie cinétique en électricité pour recharger les batteries.</p><h3><strong>Inverseur</strong></h3><p> L'inverseur est responsable de la conversion de l'énergie électrique stockée dans les batteries en énergie utilisable pour le moteur électrique.</p><h3><strong>Batteries</strong></h3><p>Ce composant de votre voiture hybride garantit son bon fonctionnement.</p>"
        }
      },
      solucionesAftermarkert: "SOLUTIONS AFTERMARKET ",
      subtitulo_soluciones: "POUR VÉHICULES HYBRIDES ET ÉLECTRIQUES",
      descripcion_soluciones:
        "Ajusa est le <strong>premier fabricant mondial spécialisé</strong> dans le développement et la fabrication de composants pour la réparation de véhicules hybrides et électriques. Réseau de distribution international dans plus de 80 pays. ",
      solicita_info: "DEMANDE D'INFORMATIONS",
      alt_images: {
        tag_ajusa: "Etiquette Ajusa",
        juntas_electricos: "Joints pour véhicules électriques"
      }
    },
    sobre_nosotros: {
      nav_options: {
        ajusa: {
          title: "ajusa",
          category: "sobre_nosotros",
          href: "ajusa"
        },
        historia: {
          title: "notre histoire",
          category: "aniversario50",
          href: "50e-anniversaire"
        },
        blog: {
          title: "blog",
          category: "blog",
          href: "blog"
        },
        contacto: {
          title: "contact",
          category: "contacto",
          href: "contacter"
        },
        canal_etico: {
          title: "Canal Ethique",
          redirect: "https://ajusa.canales-eticos.com"
        },
        trabaja_con_nosotros: {
          title: "travaillez avec nous",
          href: "travaillez-avec-nous"
        }
      }
    },
    politica_privacidad:
      "<div class=\"container\"><div class=\"block-legal\"><h1 class=\"title title-36\">POLITIQUE DE CONFIDENTIALITÉ</h1><p>La Direction / l'Organe directeur d'AUTO JUNTAS SAU (ci-après, le responsable du traitement des données), assume la responsabilité maximale et s'engage à établir, mettre en œuvre et maintenir la présente politique de protection des données, en veillant à assurer l'amélioration continue du responsable du traitement des données dans le but d'atteindre l'excellence en ce qui concerne le respect du règlement (UE) 2016/679 du Parlement européen et du Conseil, du 27 avril 2016 relatif à la protection des personnes physiques en matière de traitement des données à caractère personnel et à la libre circulation de ces données et abrogeant la directive 95/46/CE (règlement général sur la protection des données) (JOUE L 119/1, 04-05-2016), et la réglementation espagnole en matière de protection des données à caractère personnel (loi organique, législation sectorielle spécifique et ses règles d'application).</p><p>La Direction / l'Organe directeur d'AUTO JUNTAS SAU (ci-après, le responsable du traitement des données), assume la responsabilité maximale et s'engage à établir, mettre en œuvre et maintenir la présente politique de protection des données, en veillant à assurer l'amélioration continue du responsable du traitement des données dans le but d'atteindre l'excellence en ce qui concerne le respect du règlement (UE) 2016/679 du Parlement européen et du Conseil, du 27 avril 2016 relatif à la protection des personnes physiques en matière de traitement des données à caractère personnel et à la libre circulation de ces données et abrogeant la directive 95/46/CE (règlement général sur la protection des données) (JOUE L 119/1, 04-05-2016), et la réglementation espagnole en matière de protection des données à caractère personnel (loi organique, législation sectorielle spécifique et ses règles d'application).</p><p>La Politique de Protection des Données d'AUTO JUNTAS SAU est basée sur le principe de la responsabilité proactive, en vertu duquel le responsable du traitement des données est responsable du respect du cadre réglementaire et jurisprudentiel qui régit cette Politique, et est en mesure de le démontrer aux autorités de contrôle compétentes.</p><p>En ce sens, le responsable du traitement sera régi par les principes suivants qui doivent servir à tout son personnel comme guide et cadre de référence dans le traitement des données à caractère personnel :</p><p><span class=\"bold\">1.</span>Protection des données dès la conception : le responsable du traitement applique, tant au moment de la détermination des moyens de traitement qu'au moment du traitement lui-même, des mesures techniques et organisationnelles appropriées, telles que la pseudonymisation, conçues pour appliquer efficacement les principes de protection des données, tels que la minimisation des données, et intégrer les garanties nécessaires au traitement.</p><p><span class=\"bold\">2.</span>Protection des données par défaut : le responsable du traitement met en œuvre les mesures techniques et organisationnelles appropriées afin de garantir que, par défaut, seules les données à caractère personnel qui sont nécessaires pour chacune des finalités spécifiques du traitement sont traitées.</p><p><span class=\"bold\">3.</span>Protection des données tout au long du cycle de vie de l'information : les mesures garantissant la protection des données à caractère personnel s'appliquent tout au long du cycle de vie de l'information.<p><span class=\"bold\">4.</span>Licéité, loyauté et transparence : les données à caractère personnel seront traitées de manière licite, loyale et transparente par rapport à la personne concernée.</p></p><p><span class=\"bold\">5.</span>Limitation de la finalité : les données à caractère personnel seront collectées à des fins déterminées, explicites et légitimes, et ne seront pas traitées ultérieurement d'une manière incompatible avec ces finalités.</p><p><span class=\"bold\">6.</span>Minimisation des données : les données à caractère personnel seront adéquates, pertinentes et limitées à ce qui est nécessaire par rapport aux finalités pour lesquelles elles sont traitées.</p><p><span class=\"bold\">7.</span>Exactitude : les données à caractère personnel seront exactes et, si nécessaire, mises à jour ; toutes les mesures raisonnables seront prises pour que les données à caractère personnel inexactes au regard des finalités pour lesquelles elles sont traitées soient supprimées ou rectifiées sans délai.</p><p><span class=\"bold\">8.</span>Limitation de la durée de conservation : les données à caractère personnel seront conservées de manière à permettre l'identification des personnes concernées pendant une durée n'excédant pas celle nécessaire aux fins du traitement des données à caractère personnel.</p><p><span class=\"bold\">9.</span>Intégrité et confidentialité : les données à caractère personnel sont traitées de manière à garantir une sécurité adéquate des données à caractère personnel, y compris la protection contre le traitement non autorisé ou illicite et contre la perte, la destruction ou les dommages accidentels, par l'application de mesures techniques ou organisationnelles appropriées.</p><p><span class=\"bold\">10</span>. Information et formation : l'une des clés pour garantir la protection des données à caractère personnel est la formation et l'information fournies au personnel impliqué dans le traitement de ces données. Tout au long du cycle de vie de l'information, tout le personnel ayant accès aux données sera dûment formé et informé de ses obligations en ce qui concerne le respect de la réglementation sur la protection des données. La Politique de Protection des Données d'AUTO JUNTAS SAU est communiquée à tout le personnel du responsable du traitement et mise à disposition de toutes les parties intéressées.</p><p>En conséquence, la présente politique de protection des données implique tout le personnel du responsable du traitement, qui doit la connaître et l'assumer, la considérant comme la sienne, chaque membre étant responsable de son application et de la vérification des règles de protection des données applicables à son activité, ainsi que de l'identification et de la communication des opportunités d'amélioration qu'il juge opportunes afin d'atteindre l'excellence en ce qui concerne leur conformité. Cette Politique sera révisée par la Direction / l'Organe directeur d'AUTO JUNTAS SAU, autant de fois que nécessaire, afin de se conformer, à tout moment, aux dispositions en vigueur en matière de protection des données à caractère personnel.</p></div></div>",
    datos_seguros:
      "<div class=\"container\"><div class=\"block-legal\"><h1 class=\"title title-36\">VOS DONNÉES SONT SÉCURISÉES</h1><p class=\"bold\">En Europe et en Espagne, il existe des réglementations sur la protection des données conçues pour protéger vos informations personnelles, auxquelles notre entreprise est tenue de se conformer.</p><p>Il est donc très important pour nous que vous compreniez parfaitement le traitement que nous allons faire des données à caractère personnel que nous vous demandons.</p><p>C'est pourquoi nous nous engageons à être transparents et à vous laisser le contrôle de vos données, en utilisant un langage simple et des choix clairs qui vous permettront de décider ce que nous faisons de vos informations personnelles.</p><p>N'hésitez pas à nous contacter si vous avez des questions après avoir lu ces informations. Nous vous remercions de votre collaboration.</p><p class=\"bold\">Qui sommes-nous?</p><ul><li>Notre dénomination:<b>AUTO JUNTAS SAU</b></li><li>Notre numéro d'identification fiscale:<b>A02007029</b></li><li>Notre activité principale:<b>METAL</b></li><li><b>Notre adresse:</b> Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02008, Albacete (Albacete), Espagne</li><li><b>Notre téléphone de contact:</b> (+34) 967-216212</li><li>Notre adresse e-mail de contac:<u><b><a href=\"mailto:ajusa@ajusa.es\">ajusa@ajusa.es</a></b></u></li><li>Notre site Web: www.ajusa.online</li></ul><p>Dans un souci de confiance et de sécurité, nous vous informons que nous sommes une entité inscrite au Registre du Commerce / Registre Public suivant : Registro Mercantil de Albacete.</p><p class=\"bold\">Comment allons-nous utiliser vos données ?</p><p>En général, vos données à caractère personnel seront utilisées pour vous contacter et vous fournir nos services.</p><p>Elles peuvent également être utilisées pour d'autres activités, comme l'envoi de publicités ou la promotion de nos activités.</p><p class=\"bold\">Pourquoi avons-nous besoin d'utiliser vos données?</p><p>Vos données à caractère personnel sont nécessaires pour pouvoir vous contacter et vous fournir nos services. À cet égard, nous mettrons à votre disposition une série de cases à cocher qui vous permettront de décider de manière claire et simple de l'utilisation de vos informations personnelles.</p><p class=\"bold\">Qui connaîtra les informations que nous vous demandons?</p><p>En général, seul le personnel dûment autorisé de notre entité peut avoir connaissance des informations que nous demandons.</p><p>De même, vos informations personnelles peuvent être divulguées aux entités qui doivent y avoir accès pour que nous puissions vous fournir nos services. Ainsi, par exemple, notre banque connaîtra vos données si le paiement de nos services est effectué par carte ou virement bancaire.</p><p>Les entités publiques ou privées auxquelles nous sommes tenus de fournir vos données à caractère personnel afin de nous conformer à une loi quelconque auront également connaissance de vos informations. Pour vous donner un exemple, la loi fiscale impose de fournir au centre des impôts certaines informations sur les transactions économiques dépassant un certain montant.</p><p>Dans le cas où, en dehors des cas mentionnés ci-dessus, nous devons divulguer vos informations personnelles à d'autres entités, nous vous demanderons votre autorisation préalable par le biais d'options claires qui vous permettront de prendre une décision à cet égard.</p><p class=\"bold\">Comment allons-nous protéger vos données?</p><p>Nous protégerons vos données au moyen de mesures de sécurité efficaces, proportionnelles aux risques associés à l'utilisation de vos informations.</p><p>À cette fin, nous avons adopté une politique de protection des données ainsi que des contrôles et des audits annuels afin de garantir que vos données à caractère personnel sont protégées à tout moment.</p><p class=\"bold\">Vos données seront-elles envoyées à d'autres pays?</p><p>Il y a des pays dans le monde qui garantissent la sécurité de vos données et d'autres qui n'en font pas autant. Ainsi, par exemple, l'Union européenne est un environnement sûr pour vos données. Notre politique consiste à ne pas envoyer vos informations personnelles vers un pays qui n'est pas sûr du point de vue de la protection des données.</p><p>Dans le cas où, pour vous fournir le service, il est indispensable d'envoyer vos données dans un pays qui n'est pas aussi sûr que l'Espagne, nous vous demanderons toujours votre autorisation préalable et nous mettrons en œuvre des mesures de sécurité efficaces pour réduire les risques liés à l'envoi de vos informations personnelles dans un autre pays.</p><p class=\"bold\">Combien de temps allons-nous conserver vos données à caractère personnel?</p><p>Nous conserverons vos données pendant toute la durée de notre relation et aussi longtemps que la loi nous y oblige. Une fois les délais légaux applicables expirés, nous procéderons à leur élimination de manière sûre et respectueuse de l'environnement.</p><p class=\"bold\">Quels sont vos droits en matière de protection des données?</p><p>Vous pouvez nous contacter à tout moment pour savoir quelles informations nous détenons à votre sujet, les rectifier si elles sont incorrectes et les supprimer une fois notre relation terminée, si cela est légalement possible.</p><p>Vous avez également le droit de demander le transfert de vos informations à une autre entité. Ce droit est appelé « portabilité » et peut être utile dans certaines situations.</p><p>Pour demander l'un de ces droits, vous devez faire une demande écrite à notre adresse, accompagnée d'une photocopie de votre pièce d'identité, afin de pouvoir vous identifier.</p><p>Des formulaires spécifiques sont disponibles dans nos bureaux pour faire valoir ces droits et nous vous offrons notre aide pour les remplir.</p><p>Pour en savoir plus sur vos droits en matière de protection des données, vous pouvez consulter le site Web de l'Agence espagnole de protection des données (www.agpd.es).</p><p class=\"bold\">Pouvez-vous retirer votre consentement si vous changez d'avis ultérieurement?</p><p>Vous pouvez retirer votre consentement si vous changez d'avis sur l'utilisation de vos données à tout moment.</p><p>Ainsi, par exemple, si vous étiez autrefois intéressé par la réception de publicité pour nos produits ou services, mais que vous ne souhaitez plus recevoir de publicité, vous pouvez nous le faire savoir en remplissant le formulaire de rétractation disponible dans nos bureaux.</p><p class=\"bold\">Si vous estimez que vos droits n'ont pas été respectés, où pouvez-vous déposer une plainte?</p><p>Dans le cas où vous estimez que vos droits n'ont pas été respectés par notre entreprise, vous pouvez déposer une plainte auprès de l'Agence espagnole de protection des données, par l'un des moyens suivants :</p><ul><li>Siège électronique : www.agpd.es</li><li>Adresse postale : Agencia Española de Protección de Datos C/ Jorge Juan, 6 28001-Madrid</li><li>Par téléphone :<br>Tél. (+34) 901 100 099<br>Tél. (+34) 91 266 35 17<br></li></ul><p>Formuler une réclamation auprès de l'Agence espagnole de protection des données n'entraîne aucun coût et l'assistance d'un avocat ou d'un procureur n'est pas nécessaire.</p><p class=\"bold\">Allons-nous établir votre profil?</p><p>Notre politique vise à ne pas profiler les utilisateurs de nos services. Cependant, dans certaines situations, nous pouvons avoir besoin de profiler des informations vous concernant à des fins de prestation de services, de marketing ou autres. Un exemple pourrait être l'utilisation de l'historique de vos achats ou services dans le but de pouvoir vous proposer des produits ou services adaptés à vos goûts ou besoins.</p><p>Dans ce cas, nous mettrons en œuvre des mesures de sécurité efficaces pour protéger à tout moment vos informations contre les personnes non autorisées cherchant à les utiliser à leur propre avantage.</p><p class=\"bold\">Utilisons-nous vos données à d'autres fins?</p><p>Notre politique est de ne pas utiliser vos données à d'autres fins que celles que nous vous avons exposées. Si, toutefois, nous devons utiliser vos données pour d'autres activités, nous vous demanderons toujours votre autorisation au préalable en vous proposant des options claires qui vous permettront de prendre une décision.</p></div></div>",
    politica_cookies:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">POLITIQUE DE COOKIES</h1><p class="bold">Informations conformes à la législation sur la protection des données à caractère personnel</p><p class="bold">Que sont les cookies et à quelles fins les utilisons-nous?</p><p>Un cookie est un petit fichier d\'informations qui est enregistré dans votre navigateur chaque fois que vous consultez notre site Web.</p><p>L\'utilité des cookies est de sauvegarder l\'historique de votre activité sur notre site Web, afin de pouvoir vous identifier et en configurer le contenu en fonction de vos habitudes de navigation, de votre identité et de vos préférences lorsque vous le consultez à nouveau.</p><p>Un cookie est inoffensif, il ne contient pas de code malveillant ou malware (ex : virus, chevaux de Troie, vers, etc.) qui pourrait endommager votre terminal (ordinateur, smartphone, tablette, etc.). Cependant, il a un certain impact sur votre droit à la protection de vos données, car il recueille certaines informations vous concernant (habitudes de navigation, identité, préférences, etc.).</p><p class="bold">Quelles informations un cookie enregistre-t-il?</p><p>Les cookies ne collectent généralement pas de catégories spéciales de données à caractère personnel (données sensibles). Les données qu\'ils conservent sont de nature technique, les préférences personnelles, la personnalisation du contenu, etc.</p><p class="bold">Quels sont les différents types de cookies?</p><p>En général, il existe cinq types de cookies :</p><ul><li><p class="bold">Cookies techniques :</p><p>il s\'agit des cookies les plus basiques. Ils permettent à l’utilisateur de naviguer sur une page Internet, une plateforme ou une application et d’en utiliser les différentes options ou les différents services tels que le contrôle du trafic et de la communication des données, l’identification de la session, l’accès à des parties restreintes, le rappel d’éléments d’une commande, la validation d’un achat, la demande d’inscription ou de participation à un événement, l’utilisation de fonctions de sécurité pendant la navigation, le stockage de contenus pour la diffusion de vidéos ou fichiers audio, ou le partage de contenus sur les réseaux sociaux.</p></li><li><p class="bold">Cookies de personnalisation :</p><p>Ils permettent à l’utilisateur d’accéder au service en appliquant quelques caractéristiques générales définies en fonction de plusieurs critères obtenus à partir du terminal de l’utilisateur comme par exemple la langue, le type de navigateur utilisé, les paramètres régionaux etc.</p></li><li><p class="bold">Cookies d’analyse :</p><p>ils permettent à la personne qui en est responsable de surveiller et d\'analyser le comportement des utilisateurs des sites Web auxquels ils sont liés. Les informations collectées par ce type de cookies sont utilisées pour mesurer l\'activité des sites, applications ou plateformes et pour élaborer des profils de navigation des utilisateurs de ces sites, applications et plateformes, afin d\'introduire des améliorations basées sur l\'analyse des données d\'utilisation faite par les utilisateurs du service.</p></li><li><p class="bold">Cookies publicitaires :</p><p>Ils permettent de gérer, de la manière la plus efficace possible, les espaces publicitaires que, le cas échéant, le responsable a intégrés sur un site Web, une application ou une plateforme à partir desquels le service demandé est fourni, sur la base de critères tels que le contenu édité ou la fréquence d\'affichage des publicités.</p></li><li><p class="bold">Cookies de publicité comportementale :</p><p>Ils permettent de gérer, de la manière la plus efficace possible, les espaces publicitaires que, le cas échéant, le responsable a intégrés sur un site Web, une application ou une plateforme à partir desquels le service demandé est fourni. Ces cookies collectent des informations sur le comportement des utilisateurs obtenues grâce à l’observation continue de leurs habitudes de navigation, ce qui permet ainsi de développer un profil spécifique et d’afficher des publicités pertinentes.</p></li></ul><p class="bold">Qu\'entend-on par cookies propres et de tiers?</p><ul><li><p class="bold">Cookies de première partie :</p><p>Les cookies de première partie sont ceux qui sont générés et gérés par la partie responsable de la fourniture du service demandé par l\'utilisateur.</p></li><li><p class="bold">Cookies de tiers :</p><p>Ils sont générés par des entités autres que la personne responsable (services ou fournisseurs externes, tels que Google).</p></li></ul><p class="bold">Quel type de cookies notre site Web stocke-t-il?</p>Vous trouverez ci-dessous une liste des types de cookies stockés sur notre site Web et leur finalité : The following is a list of the types of cookies stored on our website and their purpose:</p><ul><li class="no-disc"><p class="bold">- Type de cookie</p><p>Cookies de tiers, d\'analyse : Google Analytics</p></li><li class="no-disc"><p class="bold">- Finalité</p><p>Suivi et analyse du comportement des utilisateurs sur le site Web. Les informations recueillies par ce type de cookies sont utilisées pour mesurer l\'activité des sites Web, pour l\'élaboration de profils de navigation des utilisateurs de ces sites, applications et plateformes, afin de réaliser des améliorations basées sur l\'analyse des données relatives à l\'utilisation faite par les utilisateurs du service.</p></li><li class="no-disc"><p class="bold">- Quand et comment ils sont stockés</p><p>Le cookie enregistre l\'activité de navigation en temps réel de l\'utilisateur et les données sont stockées dans l\'application « Google Analytics ».</p></li></ul><p>Le site Web d\'AJUSA fonctionne également avec l\'application Local Storage.</p><p class="bold">Que puis-je faire avec les cookies?</p><p>Les cookies peuvent être supprimés, acceptés ou bloqués, comme vous le souhaitez. Pour ce faire, il vous suffit de configurer le navigateur Web de façon appropriée.</p><p>À tout moment, vous pouvez empêcher l\'installation de cookies (blocage) sur votre ordinateur en utilisant l\'option correspondante de votre navigateur ; mais dans ce cas, nous ne pouvons pas garantir le bon fonctionnement des différentes fonctionnalités de notre site Web.</p><p>Nous vous fournissons ci-dessous les liens pour gérer et bloquer les cookies en fonction du navigateur que vous utilisez :</p><p>Internet Explorer : <a href="http://https://support.microsoft.com/fr-fr/windows/supprimer-et-g%C3%A9rer-les-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-10" target="_blank" rel="noopener noreferrer">https://support.microsoft.com/fr-fr/windows/supprimer-et-g%C3%A9rer-les-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-10</a></p><p>FireFox : <a href="http://https://support.mozilla.org/fr/kb/effacer-cookies-donnees-site-firefox" target="_blank" rel="noopener noreferrer">https://support.mozilla.org/fr/kb/effacer-cookies-donnees-site-firefox</a></p><p>Chrome : <a href="http://https://support.google.com/chrome/answer/95647?hl=fr" target="_blank" rel="noopener noreferrer">https://support.google.com/chrome/answer/95647?hl=fr</a></p><p>Safari : <a href="http://https://www.apple.com/legal/privacy/fr/cookies/" target="_blank" rel="noopener noreferrer">https://www.apple.com/legal/privacy/fr/cookies/</a></p>Vous pouvez également supprimer les cookies stockés dans votre navigateur en accédant aux paramètres de ce dernier.</div></div>',
    aviso_legal:
      "<div class=\"container\"><div class=\"block-legal\"><h1 class=\"title title-36\">AVIS LÉGAL</h1><p class=\"bold\">CONDITIONS GÉNÉRALES</p><p><span class=\"bold\">I.- L'utilisation,</span>la consultation et/ou la souscription des services présentés sur notre site Web www.ajusa.online implique l'acceptation pleine et sans réserve par les utilisateurs et/ou les clients des Conditions Générales, qui régulent la relation juridique dérivée des processus contractuels réalisés entre les utilisateurs et/ou les clients du site Web www.ajusa.online appartenant à Auto Juntas, S.A. (ci-après Ajusa). Les Clients acceptent les Conditions Générales dès qu'ils utilisent ou achètent un produit. Ce document peut être imprimé pour être lu et stocké par les Clients, préalablement à son acceptation.</p><p><span class=\"bold\">II.- Les présentes conditions générales</span>sont soumises aux dispositions de la loi 7/1998, du 13 avril, relative aux conditions générales des contrats, au décret royal législatif 1/2007 du 16 novembre, portant approbation du texte consolidé de la loi générale pour la défense des consommateurs et des utilisateurs et autres lois complémentaires, au décret royal 1906/1999, du 17 décembre 1999, qui réglemente les contrats téléphoniques ou électroniques avec des conditions générales, la loi organique 15/1999, du 13 décembre, sur la protection des données à caractère personnel, et son règlement d'application, la loi 7/1996, du 15 janvier, sur la réglementation du commerce de détail, et la loi 34/2002, du 11 juillet, sur les services de la société de l'information et le commerce électronique.</p><p><span class=\"bold\">III.- Modification des conditions générales.</span>Ajusa peut modifier les Conditions Générales en informant les Clients dans un délai suffisant, afin d'améliorer les services et produits offerts par Ajusa. Par la modification des Conditions Générales exposées sur le site Web d'Ajusa, on entend l'accomplissement de cette obligation de notification. Dans tous les cas, avant d'utiliser les services ou de contracter des produits, veuillez consulter les Conditions générales.</p><p><span class=\"bold\">IV.- Propriété intellectuelle.</span>Tous les contenus de ce site Web (y compris le code source, les images, les textes, les graphiques, etc.) sont protégés par la réglementation nationale et internationale en vigueur sur la propriété intellectuelle, et tous les droits sont réservés. Il est strictement interdit de reproduire tout contenu du site Web sans le consentement exprès de Ajusa et des titulaires des droits.</p><p>En acquérant un produit, Ajusa n'accorde à l'acheteur aucun droit de modification, d'exploitation, de reproduction, de distribution ou de communication publique de celui-ci, Ajusa se réservant tous ces droits. La cession des droits susmentionnés nécessitera le consentement écrit préalable d'Ajusa. L'utilisation non autorisée des informations contenues sur ce site Web, leur revente, ainsi que la violation des droits de propriété intellectuelle ou industrielle entraîneront les responsabilités légalement établies.</p><p><span class=\"bold\">V.- Utilisation du service et responsabilités.</span> Ajusa ne garantit pas la disponibilité permanente des services, se dégageant de toute responsabilité en cas de dommages éventuels causés par l'indisponibilité du service pour cause de force majeure ou d'erreurs dans les réseaux de transfert de données, échappant à son contrôle. Ajusa n'est pas responsable du contenu des liens vers d'autres pages Web qui ne sont pas sa propriété et qui ne peuvent donc pas être contrôlées par elle.</p><p><span class=\"bold\">VI.- Protection des données.</span>Conformément aux dispositions de l'article 5 de la loi organique 15/1999, du 13 décembre, sur la protection des données à caractère personnel, et de la loi 34/2002, du 11 juillet, sur les services de la société de l'information et le commerce électronique, Auto Juntas, S.A. (ci-après Ajusa) vous informe que les données à caractère personnel fournies dans les formulaires d'inscription électronique contenus sur ce site, ainsi que les données auxquelles Ajusa accède suite à votre navigation, consultation, demande, requête et utilisation de ce site Web, seront seront stockées dans un fichier conforme aux exigences de la législation applicable en vigueur et dont le responsable est : Auto Juntas, S.A., Parque Empresarial Ajusa. Ctra. De Ayora Km 2.2. 02008. Albacete. Espagne. <a href=\"mailto:social@ajusa.es\">social@ajusa.es</a>.</p><p>La collecte et le traitement automatisé des données à caractère personnel par le biais des formulaires et des contacts e-mail fournis sur ce site Web ont pour but de faciliter la prestation des services que Ajusa fournit par le biais de ces pages, ainsi que de fournir des informations sur les activités et les actualités qui peuvent vous intéresser.</p><p>L'envoi de données à caractère personnel, par le biais de l'utilisation des formulaires électroniques de ce site Web ou, le cas échéant, l'envoi de messages électroniques demandant des informations ou des services, implique le consentement exprès de l'Utilisateur au traitement automatisé des données incluses, ainsi que l'envoi de communications électroniques comprenant des informations sur nos activités.</p><p>Par conséquent, l'utilisateur donne son consentement exprès pour que les données à caractère personnel soient incluses dans le fichier de données à caractère personnel et fassent l'objet d'un traitement automatisé par Ajusa aux fins susmentionnées. De même, l'utilisateur exprime l'acceptation et l'autorisation pour Ajusa de transférer les données à caractère personnel à des sociétés qui fournissent des services à Ajusa, telles que des banques et des compagnies d'assurance.</p><p>L'utilisateur garantit que les données à caractère personnel fournies à Ajusa sont véridiques et est responsable de la communication de toute modification de celles-ci.</p><p>Ajusa met à la disposition des utilisateurs l'adresse e-mail<a href=\"mailto:social@ajusa.es\">social@ajusa.es</a>et le numéro de téléphone (+34) 967 216 212, afin qu'ils puissent révoquer leur consentement. Ajusa déclare respecter la réglementation en vigueur en matière de protection des données, notamment la loi organique 15/1999, du 13 décembre, sur la protection des données à caractère personnel et le décret royal 1720/2007, du 21 décembre, qui développe la loi organique précitée, et met à la disposition des Clients les moyens de contact visés au paragraphe précédent afin qu'ils puissent exercer leurs droits d'accès, de rectification, d'annulation et d'opposition garantis par la législation en vigueur.</p><p><span class=\"bold\">VII.- Sécurité.</span>Ajusa garantit qu'elle a adopté les mesures de sécurité appropriées dans ses installations, systèmes et fichiers, ainsi que le traitement confidentiel des Données Personnelles conformément à la législation en vigueur et vous informe qu'elle a mis en œuvre les mesures de sécurité techniques et organisationnelles nécessaires pour garantir la sécurité de vos données à caractère personnel et éviter leur altération, perte et traitement et/ou accès non autorisé, en tenant compte de l'état de la technologie, de la nature des données stockées et des risques auxquels elles sont exposées, qu'ils proviennent de l'action humaine ou de l'environnement physique ou naturel. Tout ce qui précède, conformément aux dispositions de l'article 9 de la LOPD et du décret royal 1720/2007, du 21 décembre, qui approuve le règlement de développement de la loi organique et de la loi 34/2002, du 11 juillet, la loi sur les services de la société de l'information et le commerce électronique.</p><p>Ajusa s'engage à traiter les données à caractère personnel dans la plus stricte confidentialité et à les utiliser exclusivement aux fins indiquées.</p><p><span class=\"bold\">VIII.- Communications électroniques commerciales. </span>Ajusa met à la disposition des utilisateurs qui en ont fait la demande préalable, par le biais des formulaires d'abonnement activés à cet effet, le service d'envoi de nouvelles, d'activités et d'informations. L'utilisateur peut se désinscrire de ce service à tout moment en envoyant un e-mail à :<a href=\"mailto:social@ajusa.es\">social@ajusa.es</a>.</p><p><span class=\"bold\">IX.- Renseignements généraux.</span>Conformément à la loi 34/2.002, du 11 juillet, sur les services de la société de l'information et le commerce électronique, Ajusa déclare avoir procédé au respect du devoir d'information dans les termes établis par le présent règlement, afin de permettre, tant aux destinataires du service qu'aux organismes compétents, un accès permanent, facile, direct et gratuit aux informations suivantes : Auto Juntas, S.A., Parque Empresarial Ajusa. Ctra. De Ayora Km 2.2. 02008. Albacete. Espagne. www.ajusa.online. N° de téléphone : (+34) 967 216 212 Fax : (+34) 967 216 214. Données d'inscription au Registre du Commerce d'Albacete : Volume : 311, FOLIO : 186 FEUILLE : AB-1504, Numéro d'identification fiscale : A-02007029</p><p><span class=\"bold\">X.- Informations concernant l'utilisation des cookies.</span>Ce site Web utilise des cookies, de petits fichiers de données qui sont générés sur l'ordinateur de l'utilisateur et qui nous permettent d'obtenir les informations suivantes : la date et l'heure de la dernière visite de l'utilisateur sur notre site Web, le contenu que l'utilisateur a choisi lors de sa première visite sur notre site Web, etc. La finalité est de réaliser des statistiques d'accès global. L'Utilisateur consent à l'utilisation de ces cookies, qui ne permettront en aucun cas d'identifier l'Utilisateur, dans le seul but de faciliter la navigation sur les différentes pages de ce site Web. Dans tous les cas, l'Utilisateur peut refuser ou empêcher l'installation de ces cookies en modifiant la configuration de son navigateur.</p><p><span class=\"bold\">XI.- Responsabilité.</span>L'utilisation du site Web relève de la seule et unique responsabilité de l'étend à l'utilisation, par l'utilisateur ou tout autre tiers, de tout mot de passe ou équivalent attribué pour accéder au site Web ou à l'un de ses services.</p><p>Ajusa n'assume aucune responsabilité dérivée des contenus liés à partir du site Web, à condition qu'ils lui soient étrangers, et ne garantit pas non plus l'absence de virus ou d'autres éléments qui pourraient provoquer des altérations dans le système informatique (matériel et logiciel), dans les documents ou les fichiers de l'utilisateur, et se dégage de toute responsabilité quant aux dommages de toute nature causés à l'utilisateur pour cette raison. Ajusa décline toute responsabilité découlant de la mauvaise utilisation des contenus affichés sur ces pages et se réserve le droit de les mettre à jour, de les supprimer, d'établir des limitations ou de restreindre leur accès à tout moment, de manière temporaire ou permanente.</p><p><span class=\"bold\">XII.- La nullité et l'inefficacité des clauses.</span> Si une clause incluse dans les présentes Conditions générales est déclarée nulle ou inefficace en tout ou en partie, cette nullité ou inefficacité n'affectera que cette disposition ou la partie de celle-ci qui est nulle ou inefficace, et les Conditions générales garderont leur validité à tous les autres égards, et cette disposition ou la partie de celle-ci qui est affectée sera réputée ne pas avoir été incluse dans les présentes Conditions générales.</p><p><span class=\"bold\">XIII.- Conflits. </span>Pour tout litige ou différend qui pourrait survenir, la législation espagnole sera applicable, et les Cours et Tribunaux d'Albacete seront compétents pour la résolution de tous les conflits qui en découlent ou qui y sont liés.</p><p>L'accès aux pages Web de ce site implique l'acceptation de toutes les conditions exprimées sur cette page d'information légale. Ajusa peut modifier, sans préavis, la structure et le design du site Web, ainsi que modifier ou éliminer les services, les contenus et les conditions d'accès et d'utilisation du site Web et l'adapter aux changements législatifs qui peuvent survenir.</p></div></div>",
    popupCocheElectrico: {
      title:
        "ET MAINTENANT...<strong>DES COMPOSANTS POUR LES VÉHICULES ÉLECTRIQUES !</strong>",
      btnText: "VISITE"
    }
  },
  us: {
    alt_images: {
      logo_ajusa: "Ajusa",
      app_movil: "Ajusa mobile app",
      google_play: "Download the app on Google Play",
      app_store: "Download the app on the App Store",
      telefono: "Call Ajusa by phone",
      email: "Send an email to Ajusa",
      vehiculo_electrico: "Ajusa Electric Vehicle Line",
      cerrar: "Close",
      retenes: "Ajusa oil seals",
      ver_video: "Watch the video",
      ajustick: "Ajustick, Ajusa anaerobic sealant",
    },
    cookieEyes: "045d3ec4b8d29118370163bd",
    recaptchaId: "6Lee-m8fAAAAABTeuBvigSTzmj9MGBqTtnldUAo8",
    isotag: "en-US",
    enlaces: {
      home: "/",
      productos: "products",
      product: "product",
      productos_quimicos: "chemical-products",
      catalogo: "catalog",
      area_tecnica: "technical-area",
      asesoramiento: "consultancy",
      ajusa: "ajusa",
      actualidad: "breaking-news",
      contacto: "contact",
      trabaja_con_nosotros: "work-with-us",
      donde_estamos: "contact",
      solicite_catalogo: "contact#catalogo",
      blog: "blog",
      blog_noticia: "blog/news",
      noticia: "news",
      blog_categoria: "blog/category",
      categoria: "category",
      ferias: "trade-fairs",
      historia: "history",
      productos: "products",
      nuestro_sector: "our-sector",
      compromiso_social: "social-commitment",
      sala_prensa: "press-room",
      mapa_web: "web-map",
      politica: "privacy-policy",
      politica_cookies: "cookies-policy",
      datos_seguros: "your-data-secure",
      aviso_legal: "legal-notice",
      aniversario50: "50-anniversary",
      vehiculo_electrico: "electric-vehicle",
      sobre_nosotros: "ajusa",
      productos_certificados: "/static/pdf/environment-certificate.pdf",
      productos_certificados_calidad: "/static/pdf/quality-certifications.pdf",
      condiciones_venta: "/static/pdf/condiciones-de-venta-en.pdf",
      catalogo_online: "https://web.tecalliance.net/ajusa-us/qa/home/ap",
      thank_you_page: "thank-you",
      newsletter_thank: "newsletter/thank-you",
      online_store: "https://ev-customers.ajusa.online/",
      certificado_IATF_16949: "/static/pdf/IATF-16949-en.pdf",
      certificado_ISO_9001: "/static/pdf/ISO-9001-en.pdf",
      certificado_ISO_14001: "/static/pdf/ISO-14001-en.pdf",
      textos: {
        inicio: "Home",
        productos: "Products",
        catalogo: "Catalog",
        otrosCatalogos: "Other Catalogs",
        area_tecnica: "Technical Area",
        ajusa: "Ajusa",
        actualidad: "Breaking news",
        contacto: "Contact",
        sala_prensa: "Press room",
        blog: "Blog",
        historia: "History",
        tecnologias_hidrogeno: "Hydrogen Technologies ",
        contacto: "Contact",
        trabaja_con_nosotros: "Work with us",
        mapa_web: "Web Map",
        condiciones_venta: "Terms and conditions of sales",
        politica_privacidad: "Privacy policy",
        datos_seguros: "Your data secure",
        politica_cookies: "Cookies policy",
        aviso_legal: "Legal notice",
        catalogo_general: "General catalog",
        catalogo_turbos: "Turbo components catalog",
        catalogo_juntas_compresor: "BRAKE COMPRESSOR GASKET CATALOG ",
        catalogo_retenes: "Shaft Seal kits catalog",
        catalogo_juegosJuntas: "SPECIAL GASKET SET CATALOG",
        tec_alliance: "ONLINE CATALOG",
        catalogo_impreso: "Request a printed catalog",
        newsletter: "Home",
        catalogo_arandelas: "COPPER WASHER CATALOG",
        catalogo_motor_electrico: "EV Catalogue",
        catalogo_comprensorAC: "EV A/C compressor catalogue​",
        catalogo_toricas: "O-RINGS CATALOG",
        catalogo_retenes: "OIL SEALS CATALOG",
        aniversario50: "50th anniversary",
        vehiculo_electrico: "Electric vehicle",
        sobre_nosotros: "About us",
        online_store: "EV CUSTOMER AREA",
        certificado_IATF_16949: "IATF 16949",
        certificado_ISO_9001: "ISO 9001",
        certificado_ISO_14001: "ISO 14001"
      },
      seo: {
        home: {
          title: "Ajusa Gaskets | Engine Sealing Solutions",
          description:
            "Ajusa is a leading provider of head gaskets. With over 50 years of experience in the automotive industry, we guarantee quality products and reliable.",
          keyword: "Ajusa / ajusa manufacturers"
        },
        productos: {
          title: "Products | Ajusa Gaskets",
          description:
            "Shop the best selection of auto parts from ajusa.online. Our high-quality parts and accessories are designed to help you get the most out of your vehicle.",
          keyword: "Ajusa products / engine parts"
        },
        catalogo: {
          title: "Catalog | Ajusa Gaskets",
          description:
            "Get the top-quality gaskets, seals, and parts you need with Ajusa. Browse our catalog OEM parts and find the perfect replacement part for your vehicle.",
          keyword: "Ajusa Catalog"
        },
        area_tecnica: {
          title: "Technical Area | Ajusa Gaskets",
          description:
            "Ajusa offers a range of gasket options and solutions for sealing. Find the perfect gasket for your needs with our technical area guides and products."
        },
        sobre_nosotros: {
          title: "About us | Quality, service and people behind Ajusa",
          description:
            "Ajusa is a leading provider of premium quality gaskets and seals for the automotive aftermarket. We offer an extensive selection of gaskets and spare parts."
        },
        aniversario50: {
          title: "Our History | Ajusa Gaskets",
          description:
            "Get to know the story behind Ajusa Gaskets - how it all started, how it evolved, and where we are now. 50 years of experience in the automotive gasket industry."
        },
        ajusa: {
          title: "About us | Ajusa Gaskets",
          description:
            "Ajusa is a leading provider of premium quality gaskets and seals for the automotive aftermarket. We offer an extensive selection of gaskets and spare parts."
        },
        actualidad: {
          title: "Breaking News | Ajusa Gaskets",
          description:
            "Get the latest news on gaskets from Ajusa. We cover all the latest developments in our industry, from product launches to technology advancements."
        },
        contacto: {
          title: "Contact | Ajusa Gaskets",
          description:
            "Need help with gaskets or seals? Reach out to Ajusa Gaskets for the best service and support. Our experienced team is ready to answer any questions you have."
        },
        blog: {
          title: "Blog | Ajusa Gaskets",
          description:
            "AJUSA’s blog is a space for professionals and experts of the automotive industry, and for mechanics and workshops. Here we tell you the latest news about AJUSA and everything that is happening in the spare parts industry.",
          toblog: true
        },
        sala_prensa: {
          title: "Press Room | Ajusa Gaskets",
          description:
            "Stay up-to-date on all the latest news and product launches from Ajusa. Explore our press room to read our press releases, product descriptions and more."
        },
        trabaja_con_nosotros: {
          title: "Work with us | Ajusa Gaskets",
          description:
            "Ajusa Gaskets is always looking for motivated, hardworking professionals to join our team. We want to hear from you. Send us your resume today."
        },
        historia: {
          title: "Our history | Over 50 years in the automotive industry",
          description:
            "AJUSA was founded in 1972 in Albacete (Spain). It originally started manufacturing head gaskets and now it develops a complete range of engine components and spare parts."
        },
        bonos_ajusa: {
          title: "Ajusa vouchers | Get 20% off for your repair workshop",
          description:
            "Ajusa vouchers give your repair workshop a 20% discount on our engine components. Call us or fill in the form and we will explain how to redeem them today."
        },
        mapa_web: {
          title: "web map | Ajusa Gaskets",
          description: "Ajusa web map: reach every section of our site from a single index, including all our products, catalogs, technical area, press room and legal information."
        },
        politica: {
          title: "Privacy Policy | Ajusa Gaskets",
          description:
            "AUTO JUNTAS SAU’s Data Protection Policy is based on the principle of proactive responsibility, according to which the controller is responsible for compliance with the regulatory and jurisprudential framework that governs said policy."
        },
        politica_cookies: {
          title: "Cookies Policy | Ajusa Gaskets",
          description: "Find out which cookies the Ajusa website uses, what each of them is for and how you can configure, accept or reject them from your own browser at any time."
        },
        aviso_legal: {
          title: "Legal Notice | Ajusa Gaskets",
          description:
            "Access to the web pages of this site implies acceptance of all conditions expressed in this legal information. AJUSA may modify the structure and design of the website, as well as change or remove contents and conditions for access."
        },
        datos_seguros: {
          title: "Your Data Secure | Ajusa Gaskets",
          description:
            "In general, your personal data that is provided through the AJUSA website will be used to relate to that person and be able to provide a better service. It may also be used to send adverts or promote our activities."
        },
        taques: {
          title: "Hydraulic lifters and tappets for all engines | Ajusa",
          description:
            "At Ajusa we offer you a wide variety of hydraulic lifters so you can find the perfect device for your case. Contact us today!",
          keyword: "hydraulic tappets, hydraulic lifters"
        },
        arbol_levas: {
          title: "Camshafts for passenger and industrial vehicles | Ajusa",
          description:
            "Discover the full range of camshafts available at Ajusa! Increase the performance of your engine with our high quality components, we are your best choice to optimize your vehicle.",
          keyword: "camshafts"
        },
        otros: {
          title: "Other engine components and spare parts | Ajusa Gaskets",
          description:
            "Are you looking for other components Ajusa? In our catalog you will find a wide range of gaskets for other engine parts such as water pump, EGR valve, thermostat, etc.",
          keyword: "other components ajusa, gaskets"
        },
        vehiculo_electrico: {
          title: "Electric Vehicle",
          description:
            "Ajusa boasts an extensive catalog of spare parts for hybrid and electric vehicles. Furthermore, Ajusa also helps you to carry out repairs by providing explanations of each failure that you can download here and video tutorials recorded by a vehicle repair specialist."
        },
        blog_categoria: {
          fairs: {
            title: "Trade Fairs | Ajusa Gaskets",
            description:
              "Ajusa Gaskets offers a wide range of gaskets solutions for trade fairs and other events. Our expert team provides quality products and excellent customer service."
          },
          products: {
            title: "Blog Products | Ajusa Gaskets",
            descripcion: ""
          },
          "our-sector": {
            title: "Our Sector | Ajusa Gaskets",
            description: ""
          },
          "social-commitment": {
            title: "Social Commitment | Ajusa Gaskets",
            description:
              "At Ajusa Gaskets, we believe in doing more than manufacturing quality products. Explore our initiatives and learn how you can help us make a difference."
          }
        },
        junta_culata: {
          title: "Cylinder head gaskets: MLS, FiberMax and rubber-metal",
          description:
            "Specialized in cylinder head gaskets manufacturing since 1972. Find more than 200,000 products for light and industrial vehicles in our online catalog.",
          keyword: "cylinder head gaskets"
        },
        junta_motor: {
          title: "Full gasket sets for every engine type | Ajusa Gaskets",
          description:
            "Our gasket sets provide a full replacement option to mechanics and individuals. Find here all the pieces you need to perform a complete repair of vehicles.",
          keyword: "gasket sets"
        },
        tornillos: {
          title: "Cylinder head bolts | Complete sets | Ajusa Gaskets",
          description:
            "Discover and order online our Cylinder Head Bolts for vehicle engines of premium craftsmanship. Boost your engine's performance today with our products.",
          keyword: "cylinder head bolts"
        },
        retenes: {
          title: "Oil seals and valve stem seals for engines | Ajusa Gaskets",
          description:
            "Boost engine longevity with our premium Oil Seals. Explore now for leak-proof performance and secure your vehicle's efficiency with this piece.",
          keyword: "oil seals"
        },
        tubos_engrase: {
          title: "Oil feed pipes for turbochargers and engines | Ajusa",
          description:
            "Upgrade your vehicle’s machinery with high-quality Oil Feed Pipes. Maximize its performance and durability. Order online for peak efficiency!",
          keyword: "oil feed pipes"
        },
        tubos_egr: {
          title: "EGR valve pipes for exhaust gas recirculation | Ajusa",
          description:
            "Reduce nitrogen oxide (NOx) emissions from internal combustion of your vehicle with Ajusa EGR valve pipes.",
          keyword: "EGR valve pipes, obstruction"
        },
        tubos_refrigeracion: {
          title: "Coolant pipes for the engine cooling system | Ajusa",
          description:
            "Enhance turbo performance and reliability with Ajusa turbo cooling pipes, designed to carry coolant between the engine and the turbocharger in both supply and return circuits.",
          keyword: "coolant pipes, cooling system"
        },
        junta_turbo: {
          title: "Turbo fitting kits and turbo gasket sets | Ajusa Gaskets",
          description:
            "Unlock your vehicle's true potential with our Turbo Fitting Kit! Boost performance and unleash the speed. Shop now and experience unmatched power.",
          keyword: "turbo fitting kit"
        },
        productos_quimicos: {
          title: "Chemical products | Sealants and lubricants | Ajusa",
          description:
            "Explore our wide range of chemical products for vehicles. Sealants, engine lubricants, and powerful threadlockers to keep your engine in optimal condition.",
          keyword:
            "chemical products, sealants, engine lubricants, threadlockers"
        },
        vehiculo_electrico: {
          title: "Electric vehicle | EV parts and components by Ajusa",
          description:
            "Ajusa has a wide range of components for hybrid and electric cars. In addition, Ajusa also helps you to carry out repairs by providing explanations of each breakdown! ",
          keyword: "components for hybrid cars, components for electric cars"
        }
      }
    },
    genericos: {
      no_resultados: "No results found",
      leer_mas: "READ MORE",
      paginador: {
        siguiente: "Next",
        anterior: "Back"
      }
    },
    home: {
      intro: {
        titulo: "Engine sealing solutions",
        texto:
          "Ajusa is a Spanish company specialized in the manufacture of internal combustion engine components for both automobiles and industrial vehicles.",
        boton: "Corporate video",
        video: "vjFYe_seVTk"
      },
      excelencia: {
        intro:
          "<h1 class='title title-36 bold'>Ajusa Gaskets</h1><h2 class='title title-36'>Engine Gaskets Manufacturers</h2>",
        texto:
          "<p>Welcome to <span class='bold'>Ajusa</span>, the site where you'll find a world of premium engine components and solutions.</p><p>As specialized European manufacturers, we offer a wide range of high-quality products that are essential for the repair, maintenance and performance optimization of internal combustion engines for both cars, industrial applications and electric vehicle.</p>"
      },
      calidad: {
        titulo: {
          first: "OEM",
          second: "",
          third: "",
          fourth: "<strong>products</strong>"
        },
        texto:
          "<p class='calidad-1-text'>Our activity began back in 1972 and, over the years, in Ajusa we have expanded our operations and established ourselves as a global leader in the industry. We now have a production center of more than 350,000 m2 in the city of Albacete (Spain).</p><p class='calidad-1-text'>As a testament to our global reach, <strong class='bold'>we proudly export our products to more than 80 countries worldwide </strong> and we have subsidiaries in the United States, Mexico, Brazil, Great Britain and France, so that you can rely on Ajusa to deliver premium engine components that meet your specific requirements.</p>"
      },
      ajusa_app: {
        title: "AJUSA MOBILE APP",
        text:
          "<p>Here you can find all the information associated with <strong class='bold'>Ajusa manufacturers</strong> and all the products that we can provide you: video tutorials about assembly, technical reports, tightening procedures, product photographs, 3D images, new applications, news and much more.</p>"
      },
      calidad_2: {
        texto_1:
          "The Ajusa catalog is permanently updated in its digital version and every two years in printed format. Currently, with <strong class='bold'>more than 200,000 references </strong>, we offer you the widest range of products for cars of European, Asian and American production.",
        texto_2:
          "In Ajusa, we guarantee <strong class='bold'>original first-equipment quality</strong>  in our entire line of products and complies with the highest quality standards. We count with all the <strong class='bold'>AENOR certifications </strong> required according to ISO 9001 and AITF 16949 regulations, which demonstrate our dedication to quality management and our commitment to continuously improving our processes and products.",
        texto_3:
          "We understand the importance of providing components that meet the highest standards of excellence and reliability. That's why we are dedicated to upholding stringent quality control measures to ensure the satisfaction and confidence of our customers."
      },
      calidad_3: {
        titulo:
          "<h2 class='title title-36'>Growing together with Ajusa manufacturers</h2>",
        texto:
          "To certify that you get the most out of every part of our product catalog, in Ajusa we offer online technical training to our customers. Our team conducts seminars on the features and installation of all the Ajusa engine components.</p><p>In addition, in the technical area of ​​this website, you can also find technical reports and didactic mechanical videos on the installation of our products, which are available to any user. <a class='link' href='{link}' target='_blank'>Request Webinar</a>"
      },
      productos: {
        titulo: "<h2 class='title title-26 bold'>Products line</h2>",
        text:
          "<p>Get to know more about our engine components and how they can help you on the repair, maintenance and performance optimization of cars and industrial vehicles.</p>"
      },
      destacados: {
        titulo: "HIGHLIGHTS"
      },
      alt_images: {
        fabricante: "manufacturer spare parts",
        junta_culata: "cylinder head gasket",
        mobile_app: "ajusa mobile APP",
        tubos_engrase: "oil feed pipes",
        junta_motor: "ajusa spare parts"
      }
    },
    productos: {
      keys: {
        "chemical-products-line": "productos_quimicos",
        "cylinder-head-gaskets": "junta_culata",
        "full-gasket-sets": "junta_motor",
        "cylinder-head-bolts": "tornillos",
        "oil-seals": "retenes",
        "oil-feed-pipes": "tubos_engrase",
        "egr-pipes": "tubos_egr",
        "coolant-pipes": "tubos_refrigeracion",
        "turbo-fitting-kits": "junta_turbo",
        "chemical-products": "productos_quimicos",
        "hidraulic-lifters": "taques",
        camshafts: "arbol_levas",
        "other-components": "otros"
      },
      intro: {
        titulo: "<h1 class='title title-52'>Ajusa Products</h1>",
        texto:
          "<p>Discover a comprehensive range of engine parts and components proudly manufactured in Europe. As a trusted supplier, we have established a strong presence in the United States through our network of official distributors. All the <span class='bold'>Ajusa products</span> cover any sealing needs that your engine requires.</p><p>At Ajusa, we understand the critical role that <span class='bold'>engine parts</span> play in maintaining optimal performance and reliability. Therefore, we prioritize the highest quality materials and cutting-edge manufacturing processes in the production of our components. Each part is meticulously crafted to ensure a precise fit and exceptional durability, allowing your engine to operate at its best.</p>"
      },
      btn_ficha_tecnica: "TECHNICAL INFORMATION",
      btn_ficha_seguridad: "SAFETY INFORMATION",
      junta_culata: {
        titulo: "CYLINDER HEAD GASKET",
        texto:
          "<p>Since our inception in 1972, Ajusa has been at the forefront of manufacturing top-quality cylinder head gaskets. With decades of expertise in the industry, we take great pride in offering the most extensive catalog of engine parts available in the online market.</p><p>Our dedication to providing a comprehensive range of options has resulted in over 200,000 references for both light and industrial vehicles, ensuring that you can find the perfect Ajusa product for your specific needs.</p><p>We can provide you with different models, such as MLS, FiberMax and Rubber-Metal gaskets.</p>",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil.pdf",
        details: {
          intro: {
            alt: "cylinder hear gasket",
            title: '<h1 class="title title-36">Cylinder Head Gaskets</h1>',
            text:
              "<p>Introducing Ajusa's high-quality <span class='bold'>cylinder head gaskets:</span> unleashing optimal engine performance.</p><p>Engineered with precision and crafted with expertise, our cylinder head gaskets are designed to provide <span class='bold'>superior performance and reliability.</span> This is a critical component that seals the cylinder head to the engine block, ensuring efficient combustion and preserving the integrity of the combustion chamber.</p><p>This vital seal plays a pivotal role in preventing the leakage of gasses, oil and coolant, thus <span class='bold'>optimizing overall engine performance.</span> The pieces are meticulously crafted to withstand extreme temperatures, pressure differentials, and various chemical environments, making them ideal for both standard and high-performance engines of light and industrial vehicles.</p>",
            btn_text: "ONLINE CATALOG",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/junta-culata-1.webp",
                alt: "ajusa cylinder head gasket"
              },
              {
                img: "/static/img/products/junta-culata-2.webp",
                alt: "head gaskets catalog"
              },
              {
                img: "/static/img/products/junta-culata-3.webp",
                alt: "mls cylinder head gaskets"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Get to know more about the manufacturing materials",
              content:
                "<p>Our cylinder head gaskets are manufactured using high-quality materials, such as multi-layer steel (MLS), graphite or elastomer, tailored to meet the specific requirements of each engine. These materials possess excellent sealing properties, <span class='bold'>effectively sealing the combustion chamber</span>and minimizing the risk of leakage.</p><p>Engine compatibility is paramount, which is why our gaskets are designed to match both gasoline or diesel engines, ensuring optimal performance and reliability.</p>"
            },
            "tip-2": {
              title: "Long-lasting Cylinder Head Gaskets",
              content:
                "<p>Durability is a key characteristic of all our products. We understand the demands placed on modern engines, and our cylinder head gaskets are built to withstand extreme conditions. With exceptional <span class='bold'>resistance to heat, pressure and chemical exposure, </span>they are suitable for maintaining their integrity over prolonged periods, reducing the need for frequent replacements.</p><p>By providing an airtight seal between the cylinder head and engine block, our gaskets contribute to improved combustion efficiency, which translates into enhanced fuel economy, reduced emissions and overall better engine performance.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "What are the symptoms of bad cylinder gasket?",
              content:
                "<p>A faulty cylinder head gasket can give rise to a range of symptoms that indicate potential problems within a vehicle's engine.</p><p>One of the primary indications of a problematic piece is <span class='bold'>engine overheating.</span> When the gasket fails, it can cause coolant to leak into the combustion chamber, disrupting the engine's cooling system and leading to overheating, which can result in significant damage if not addressed promptly.</p><p>Another symptom to watch out for is a<span class='bold'> loss of coolant</span> without any visible leaks. If you find yourself frequently needing to refill the coolant reservoir or notice a decrease in coolant levels over time, it may indicate a compromised cylinder head gasket.</p><p>A blown piece can also manifest as <span class='bold'>white or grayish exhaust smoke.</span> This occurs when coolant seeps into the combustion chamber and gets burned along with the fuel. The resulting smoke may have a distinct sweet odor and can be particularly noticeable during acceleration or when starting the engine.</p><p><span class='bold'>Engine misfires</span> are another significant symptom that you should take care of. As the gasket's integrity is compromised, the combustion process may be disrupted, leading to rough idling, hesitation or a noticeable decrease in engine power during acceleration.</p><p>Last, put an eye on the <span class='bold'>loss of compression between cylinders,</span> as this can lead to diminished engine performance, reduced power and even misfires in individual cylinders.</p>"
            },
            "dropdown-2": {
              title: "Can you drive with a blown cylinder head gasket?",
              content:
                "<p>Definitely, <span class='bold'>we do not recommend</span> driving with a blown cylinder head gasket at all because it can have significant consequences for your vehicle's engine and overall performance. It is important to address the issue promptly to prevent further damage.</p><p>When a cylinder head gasket is blown, it may lead to several problems that can compromise the engine's operation. Coolant can leak into the combustion chamber, causing overheating and potentially damaging engine components. The coolant can also mix with the engine oil, reducing its lubricating properties and potentially causing damage to bearings, pistons, and other vital parts.</p><p>If you suspect a blown gasket or experience any of the associated symptoms, it is advisable to <span class='bold'>have your vehicle inspected</span> by a qualified mechanic as soon as possible. We totally recommend avoiding driving the vehicle until the piece is replaced or repaired to prevent further damage and ensure the longevity of your engine.</p>"
            },
            "dropdown-3": {
              title: "Is it worth replacing a cylinder head gasket?",
              content:
                "<p>Replacing a damaged cylinder head gasket can be a worthwhile decision considering the potential consequences of ignoring the issue. As we have seen before, it can cause a range of problems that can adversely affect your vehicle's performance and reliability.</p><p>While this replacement does involve an investment, it is generally more cost-effective than dealing with extensive engine repairs. Addressing the blown gasket early on can help you avoid further damage and the associated expenses.</p><p>Furthermore, ensuring the safety of your vehicle is crucial. A blown cylinder head gasket can lead to engine overheating, which can cause the engine to stall or result in breakdowns at inconvenient or even dangerous times. By replacing the piece, you can restore safe and reliable vehicle operation.</p>"
            },
            "dropdown-4": {
              title:
                "How long will a car last after replacing the head gasket?",
              content:
                "<p>When the cylinder head gasket is replaced promptly and the necessary repairs are performed correctly, it is possible for the vehicle to continue running for many more years. However, it is important to note that the lifespan of a vehicle is influenced by various factors beyond just the replacement of this concrete piece.</p><p>While there is no definitive timeframe, it is possible for a car to last for a long time after replacing the blown part, especially when coupled with proper maintenance and care. Regularly servicing the vehicle, addressing any issues promptly and practicing good driving habits are key to maximizing its lifespan.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      junta_motor: {
        titulo: "GASKET SETS",
        texto:
          "<p>We understand the importance of a seamless and efficient repair process for both professional mechanics and individuals who prefer to tackle engine repairs themselves. And as a means to cater to these needs, we offer comprehensive sets of Ajusa products that provide everything you require to conduct a complete, fast, and efficient engine repair.</p><p>By opting for our repair sets, you can save valuable time and effort, as you won't have to search for individual parts or worry about missing components.</p>",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil2.pdf",
        details: {
          intro: {
            alt: "gasket sets",
            title: '<h1 class="title title-36">Gasket Sets</h1>',
            text:
              '<p>Welcome to our comprehensive collection of <span class="bold">gasket sets</span>, where we offer high-quality engine sealing solutions for a wide range of vehicles. As a leading manufacturer of engine components, we understand the critical role that these pieces play in maintaining the optimal performance and longevity of engines.</p><p>At Ajusa, we pride ourselves on our commitment to excellence, delivering engine parts that are engineered with precision and <span class="bold">manufactured using top-grade materials.</span> Each of the gasket sets in our collection is meticulously crafted to provide a perfect fit and seal for your engine, ensuring optimal performance and durability.</p>',
            btn_text: "ONLINE CATALOG",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/junta-motor-1.webp",
                alt: "ajusa full gasket sets"
              },
              {
                img: "/static/img/products/junta-motor-2.webp",
                alt: "gasket sets ajusa"
              },
              {
                img: "/static/img/products/junta-motor-3.webp",
                alt: "gaskets for cars"
              },
              {
                img: "/static/img/products/junta-motor-4.webp",
                alt: "gaskets for industrial vehicles"
              },
              {
                img: "/static/img/products/junta-motor-5.webp",
                alt: "auto parts for engine car repair"
              }
            ]
          },
          dropdowns: {
            "dropdown-1": {
              title: "A wide variety of gasket sets for your engine",
              content:
                '<p>Our <span class="bold">gasket sets</span> category encompasses a wide range of pieces, which are carefully curated to include all the necessary items for a specific engine application, streamlining the repair or rebuild process and ensuring that you have everything you need in one convenient package.</p><p>By choosing our products, you can have peace of mind knowing that you are investing in <span class="bold">premium engine sealing solutions</span> that are built to last. We are dedicated to providing products that deliver exceptional performance, durability and value, making us the trusted choice for engine builders and automotive enthusiasts alike.</p><p>Should you have any questions or need assistance in finding the right gasket set for your <span class="bold">specific application</span>, our knowledgeable team is always ready to provide <span class="bold">expert guidance and support.</span></p>'
            },
            "dropdown-2": {
              title: "Order a full engine gasket set online",
              content:
                '<p>In Ajusa, we develop complete gasket sets with over <span class="bold">200,000 references</span> to cater to a wide range of vehicle makes and models. All of them are designed under a meticulous process and <span class="bold">manufactured in fiber, rubber and rubber-metal</span> compounds, which are the strongest and most effective <span class="bold">materials for installation in vehicle engines.</span></p><p>Precision and durability are really important for us, and that’s why our products undergo a rigorous design and development process, adhering to strict quality standards. Our experienced team of engineers leverages their expertise to create gaskets that deliver exceptional sealing performance and maintain the integrity of engine components.</p>'
            },
            "dropdown-3": {
              title: "What does a gasket kit consist of?",
              content:
                "<p>Our extensive <span class='bold'>catalog of gasket sets</span> covers various items, including cylinder head gaskets and bolts, oil seals, rocker cover gasket, manifolds and many more products. Each set is carefully curated to include all the necessary gaskets required for a complete engine overhaul or repair.</p><p>Invest in the reliability and <span class='bold'>performance of your engine</span> by ordering a full engine gasket set online from Ajusa today. Should you have any questions or need assistance, our experienced customer support team will be always available to provide you guidance and support.</p><p>Experience the difference that our meticulously <span class='bold'>developed gasket sets</span> can make in your engine's performance and longevity.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      tornillos: {
        titulo: "CYLINDER HEAD BOLTS",
        texto:
          "<p>To further enhance your repair experience, we are proud to offer a range of cylinder head bolts that are essential for ensuring a safe and reliable repair of your damaged engine. All cylinder head gaskets include the bolt set tightening manual to guarantee a proper installation and secure fastening.</p><p>This serves as a valuable resource, providing you with detailed instructions on the proper torque specifications and tightening sequences for the component. Following these guidelines is crucial to ensure the correct clamping force and uniform distribution of pressure across the gasket, thereby promoting a tight and reliable seal.</p>",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil3.pdf",
        details: {
          intro: {
            alt: "cylinder head bolts",
            title: '<h1 class="title title-36">Cylinder Head Bolts</h1>',
            text:
              "<p>Welcome to our exclusive collection of <span class='bold'>Cylinder Head Bolts</span> for vehicle engines.</p><p>In AJUSA we count with an extensive selection of meticulously crafted bolts, designed to provide optimal performance and durability. These components play a crucial role in creating a tight seal between the cylinder head and the engine block, <span class='bold'>ensuring proper compression and preventing any leaks</span> of combustion gasses or coolant.</p><p>By maintaining a strong and reliable connection, Cylinder Head Bolts contribute to the overall <span class='bold'>efficiency, performance and longevity</span> of the engine. They are essential components in maintaining the structural integrity and optimal operation of the engine's combustion chamber.</p>",
            btn_text: "ONLINE CATALOG",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/tornillos-1.webp",
                alt: "ajusa cylinder head bolts"
              },
              {
                img: "/static/img/products/tornillos-2.webp",
                alt: "ajusa bolts"
              },
              {
                img: "/static/img/products/tornillos-3.webp",
                alt: "angular tightening of screws"
              },
              {
                img: "/static/img/products/tornillos-4.webp",
                alt: "cylinder head bolts catalog"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Premium materials for exceptional durability",
              content:
                "<p>We source our materials from trusted suppliers, selecting alloys and compositions that meet stringent industry standards. Whether it's high-strength steel, forged aluminum, or other advanced materials, our <span class='bold'>Cylinder Head Bolts are built to withstand the most demanding conditions.</span></p> <p>With these premium materials, you can rest assured that your engine's critical components will remain securely fastened, preventing leaks and optimizing compression.</p>"
            },
            "tip-2": {
              title: "Trusted performance Cylinder Head Bolts",
              content:
                "<p>Backed by a legacy of proven results and a loyal customer base, these products have earned their reputation as <span class='bold'>the go-to choice for professionals</span> and enthusiasts alike. Countless engines have been elevated to new heights of efficiency and power, all thanks to the precision fit and tight seal provided by these exceptional bolts.</p><p>Experience peace of mind knowing that our Cylinder Head Bolts are designed to go the distance, providing the robustness necessary for your engine's peak operation.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Why should you replace cylinder head bolts?",
              content:
                "<p>Replacing cylinder head bolts is a critical aspect of engine maintenance and repair. Over time, these pieces can experience wear and stress and temperature variations, leading to gradual wear and fatigue. As they lose their elasticity and clamping force, the risk of developing issues such as <span class='bold'>cylinder head gasket leaks increases</span>.</p> <p>To ensure the continued integrity and safety of your engine, <span class='bold'>timely replacement of cylinder head bolts is essential</span>. By installing new, high-quality complements in your vehicle, <span class='bold'>you restore the necessary clamping force between the cylinder head and engine block</span>, thereby re-establishing a tight seal.</p>"
            },
            "dropdown-2": {
              title: "What causes head bolts to break?",
              content:
                "<p>The breaking of cylinder head bolts can be attributed to various factors, primarily related to the stresses and conditions they endure during engine operation. Some common causes include excessive or <span class='bold'>uneven application of torque during bolt installation</span>, fluctuations in engine temperature, the exposure to corrosive chemicals or even engine overheating.</p> <p>Regular inspection and <span class='bold'>replacement of head bolts during engine rebuilds or major repairs</span> can help identify potential issues and mitigate the risk of breakage, contributing to a reliable and long-lasting engine performance.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      retenes: {
        titulo: "OIL SEALS",
        texto:
          "<p>Ajusa oil seals and valve seals meet the highest sealing performance for your engine. We understand the critical role these seals play in effectively preventing the leakage of oil from the crankshaft, camshaft, and other rotating components.</p><p>By utilizing premium materials and employing advanced sealing technologies, our oil seals offer exceptional resistance to high temperatures, pressure, and the harsh operating conditions of the engine environment.</p>",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil4.pdf",
        details: {
          intro: {
            alt: "oil seals",
            title: "<h1 class='title title-52'>Oil Seals</h1>",
            text:
              "<p>Discover the essential function of <span class='bold'>Oil Seals</span> in vehicles, a critical component that <span class='bold'>maintains smooth operations and prevents leaks</span>.These specialized seals create a tight barrier, ensuring that lubricants and fluids stay contained, safeguarding vital engine parts from harmful friction and extending the overall lifespan of your vehicle.</p> <p>At AJUSA, you'll find a <span class='bold'>wide selection of high-quality pieces</span>, meticulously designed for various vehicle applications, allowing you to drive with confidence and peace of mind. Experience the difference our premium products make in enhancing your vehicle's performance and protecting your investment for the long haul.</p>",
            btn_text: "ONLINE CATALOG",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/retenes-1.webp",
                alt: "ajusa seals"
              },
              {
                img: "/static/img/products/retenes-2.webp",
                alt: "ajusa oil seals"
              },
              {
                img: "/static/img/products/retenes-3.webp",
                alt: "valve stem seals ajusa"
              },
              {
                img: "/static/img/products/retenes-4.webp",
                alt: "oil seals for cars"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Order the right Oil Seals for your vehicle",
              content:
                "<p>Crafted from durable materials that meet or exceed industry standards, <span class='bold'>our seals are rigorously tested to withstand the toughest conditions</span>, ensuring they perform flawlessly even under extreme temperatures and pressures.We can ensure that your vehicle's engine and other critical components will stay protected and function optimally.</p><p>Our team of automotive experts will be pleased to help you find the perfect oil seals for your specific vehicle needs. Whether you're dealing with a compact car, a heavy- duty truck, or anything in between, we have the expertise to guide you towards the ideal piece.</p> "
            },
            "tip-2": {
              title: "Enhance a long-lasting car performance",
              content:
                "<p>It’s no secret that your <span class='bold'>car's performance and durability</span> depend on the quality of its essential components. With our seals in place, your engine will experience reduced friction, leading to smoother operation, increased fuel efficiency and, ultimately, enhanced overall performance.</p><p>Having a car is a significant investment, and protecting it is mandatory. Make sure to shield your vehicle parts from premature wear and damage finding the <span class='bold'>right oil seals</span>, extending their lifespan and saving you from costly repairs down the road.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Discover our extensive oil seals catalogue",
              content:
                "<p>Our product inventory is the widest you can find in our area, as we have <span class='bold'>parts for all makes and models of vehicles on the market today</span>.Simply give us all the necessary information regarding your car, and we will search for Oil Seals in stock so that you can always have a <span class='bold'>spare part on hand</span>.</p><p>Backed by years of <span class='bold'>industry expertise</span>, our team is dedicated to providing <span class='bold'>exceptional customer service</span>. From selecting the right oil seals to answering your technical questions, we are here to support you at every step of the process.</p><p>Find <span class='bold'>online multiple oil seals</span> types of different sizes to cater to various vehicle models and applications. If needed, contact us for a custom customer attention.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      tubos_engrase: {
        titulo: "OIL FEED PIPE ",
        texto:
          "<p>When it comes to turbocharged engines, Ajusa products are dedicated to providing premium engine parts that meet the unique demands of these high-performance powerhouses.</p><p>By utilizing high-quality materials and advanced manufacturing techniques, our lubrication tubes offer excellent resistance to heat, pressure, and vibrations, ensuring long-lasting performance in turbocharged applications.</p>",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "oil feed pipes",
            title: '<h1 class="title title-36">Oil Feed Pipes</h1>',
            text:
              "<p>Designed to optimize your machinery's performance, efficiency and durability, these top-of-the-line <span class='bold'>oil feed pipes</span> are engineered with precision and care. It’s the right time to forget about frequent maintenance in the turbo system on your car and welcome a smoother, uninterrupted workflow.</p><p>Quality and innovation are fully guaranteed, as these pipes are built to withstand the most demanding environments and ensure a continuous and <span class='bold'>consistent oil supply</span>, safeguarding your equipment from potential breakdowns. Don't settle for less, invest in the best and unlock the <span class='bold'>true potential</span> of your driving.</p>",
            btn_text: "ONLINE CATALOG",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/tubos-engrase-1.webp",
                alt: "ajusa oil feed pipes"
              },
              {
                img: "/static/img/products/tubos-engrase-2.webp",
                alt: "turbo components ajusa"
              },
              {
                img: "/static/img/products/tubos-engrase-3.webp",
                alt: "oil feed pipes for turbocharger"
              },
              {
                img: "/static/img/products/tubos-engrase-4.webp",
                alt: "turbocharger components"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Order highly efficient Oil Feed Pipes",
              content:
                "<p>Are you tired of dealing with engine slowdowns and costly repairs due to inefficient oil supply? Look no further. We will provide you with the ultimate solution to streamline your car's performance on the road.</p><p>These <span class='bold'>oil feed pipes</span> ensure a smooth and continuous oil flow to vital components, reducing friction and wear, so that you can experience a significant improvement, resulting in enhanced output and minimized downtime.</p>"
            },
            "tip-2": {
              title: "Invest in long-lasting performance and reliability",
              content:
                "<p>Join the ranks of satisfied customers who have already experienced the remarkable benefits of this piece and see how our product has transformed their day-to-day driving for better performance and long-term success.</p><p>Make a wise investment for your vehicle's future, ensuring it remains in top-notch condition for years to come. The seamless flow of oil through these pipes guarantees optimal lubrication and the smoother performance of your turbo thanks to the reliable and tested manufacturing.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "What does the turbo oil feed pipe do?",
              content:
                "<p>The <span class='bold'>turbo oil feed pipe</span> plays a crucial role in the functioning of a car.In a turbo system, the <span class='bold'>turbocharger compresses air</span> and forces it into the engine's cylinders, resulting in increased power and performance. But during this process, <span class='bold'>the turbocharger's rotating components require proper lubrication</span> to prevent excessive friction and wear.</p> <p>The oil feed pipe is responsible for taking the oil from the engine oil pan to the core of the turbo charger. Therefore, it is extremely important to have a pipe free of cinder, dirt or any other strange objects, that <span class='bold'>may obstruct the pass of the oil and cause damage to the turbocharger.</span></p>"
            },
            "dropdown-2": {
              title: "Can you run a turbo without oil lines?",
              content:
                "<p>No, you cannot run a turbocharger without oil lines. oil feed pipes are essential for its proper functioning and longevity of the rotating components, such as the turbine and compressor wheels, which spin at extremely high speeds and can cause rapid wear and damage if not properly lubricated.</p><p>The oil lines are responsible for supplying pressurized and filtered oil to the turbocharger, ensuring that its moving parts remain adequately lubricated and cooled during operation.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      tubos_egr: {
        titulo: "PIPES EGR",
        texto:
          "Ajusa offers high-quality EGR valve pipes that meet the specifications of leading manufacturers. Our products are designed to ensure long service life and optimal performance, helping keep your vehicle within emission standards and ensuring cleaner and more efficient driving.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "EGR valve pipes",
            title: '<h1 class="title title-36">EGR valve pipes</h1>',
            text:
              '<p>Ajusa offers high-quality <span class="bold">EGR valve pipes </span>that meet the specifications of leading manufacturers. Our products are designed to ensure long service life and optimal performance, helping keep your vehicle within emission standards and ensuring cleaner and more efficient driving.</p>',
            btn_text: "ONLINE CATALOGUE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/tubos-egr-1.webp",
                alt: "EGR valve pipe ajusa"
              },
              {
                img: "/static/img/products/tubos-egr-2.webp",
                alt: "egr valve ajusa"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "THESE PIPES MAINTAIN THE EFFICIENCY OF THE EXHAUST GAS RECIRCULATION SYSTEM",
              content:
                '<p>The EGR valve pipe (Exhaust Gas Recirculation) is a key component in <span class="bold">emission reduction </span>systems of internal combustion engines.</p> <p>This tube is part of the EGR system, designed to <span class="bold">reduce nitrogen oxide (NOx) emissions</span> by recirculating a portion of the exhaust gases back into the engine intake.</p>'
            },
            "tip-2": {
              title: "HIGH-QUALITY PIPES, DESIGNED FOR EASY INSTALLATION",
              content:
                '<p>An <span class="bold">EGR valve pipe</span> may require replacement when carbon deposits are excessive and cleaning is no longer sufficient.</p><p> Additionally, a cracked or damaged tube can cause exhaust gas leaks, negatively affecting both engine efficiency and emissions control.</p>'
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "What is the EGR system?",
              content:
                "<p>The EGR (Exhaust Gas Recirculation) system directs part of the exhaust gases back into the combustion chamber to improve emissions, particularly reducing pollutants like NOx.  </p><p>These gases flow from the exhaust manifold, through the EGR valve pipe, and into the intake, with the flow managed by the opening and closing of an EGR valve controlled by the ECU, allowing full, partial, or no flow as needed.  </p><p>Thus, the EGR system redirects some exhaust gases back to the combustion chamber through the EGR valve pipe, which connects the exhaust and intake manifolds. Introducing these oxygen-poor exhaust gases into the combustion process lowers the combustion chamber temperature, thus reducing the formation of NOx—one of the main contributors to air pollution, which also impacts human health.</p>"
            },
            "dropdown-2": {
              title: "Why is the EGR tube important?",
              content:
                "<p>Over time, EGR valve pipes can accumulate combustion residues and other deposits from exhaust gases, often partially or fully clogging the tube and reducing system efficiency. Additionally, they endure thermal fatigue from high gas temperatures and mechanical fatigue from engine vibrations. This is why regular maintenance, including inspection and possible replacement of this part, is crucial.</p><p>Symptoms of a clogged EGR valve pipe include power loss, increased fuel consumption, and the activation of the engine warning light (MIL).</p><p>The main causes of a defective tube are:</p><ol><li><span class='bold'>Obstruction: </span>Exhaust gases, especially in diesel engines, contain many combustion by-products like soot, which can eventually clog the tube completely, blocking gas flow.</li><li><span class='bold'>Breakage: </span>Due to frequent start-stop cycles and high temperatures from exhaust gases, combined with engine-induced vibrations, cracks or breaks may form in the pipe.</li></ol><p>An EGR system cannot function properly with a defective EGR valve pipe, leading not only to malfunction in the anti-pollution system but also in the engine itself, potentially causing more serious issues if not replaced in time.</p><p>An EGR valve pipe may require replacement when carbon deposits are excessive and cleaning is no longer sufficient. Additionally, a cracked or damaged tube can cause exhaust gas leaks, negatively affecting both engine efficiency and emissions control.</p><p>If you experience any of these symptoms or if your vehicle has driven many miles without an EGR system check, it is advisable to seek a professional evaluation. Installing a new EGR valve pipe ensures a perfect repair, preventing system malfunctions and other breakdowns caused by defective tubes.</p>"
            },
            "dropdown-3": {
              title: "Benefits of Well-Maintained EGR valve pipes",
              content:
                "<ul>  <li><span class='bold'>Reduced Pollutant Emissions: </span>Proper system function lowers combustion temperatures, significantly reducing NOx emissions.</li>  <li><span class='bold'>Compliance with Environmental Regulations: </span>Modern vehicles must meet strict emissions regulations, and the EGR system helps engines comply with these standards.</li>  <li><span class='bold'>Improved Fuel Economy: </span>Gas recirculation optimizes the combustion process, contributing to more efficient fuel use.</li>  <li><span class='bold'>Extended Engine Durability: </span>By reducing combustion chamber temperatures, the EGR system decreases thermal stress on internal engine components, which can extend their lifespan.</li></ul>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      tubos_refrigeracion: {
        titulo: "COOLANT PIPES",
        texto:
          "Turbo cooling pipes carry coolant between the engine and the turbocharger, in both supply and return directions. Ajusa’s turbocharger cooling pipe range covers more than 40 vehicle models from leading brands such as Ford, VAG, Mercedes, Fiat/Alfa/Jeep, Nissan and Smart.",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil5.pdf",
        details: {
          intro: {
            alt: "coolant pipes",
            title: '<h1 class="title title-36">Coolant Pipes</h1>',
            text:
              '<p><span class="bold">Turbochargers </span>face a constant challenge: extreme temperatures. In modern engines, these components can reach heat levels that place brutal thermal stress on all internal parts.</p><p>When traditional oil lubrication is no longer enough to combat these temperatures, a vital solution comes into play: external liquid cooling via dedicated coolant pipes.</p><p>The turbocharger coolant pipes covers more than 40 vehicle models from leading brands, including Ford, VAG, Mercedes, Fiat/Alfa/Jeep, Nissan, and Smart.</p>',
            btn_text: "ONLINE CATALOGUE",
            btn_redirect: "https://web.tecalliance.net/ajusa/es/home",
            slider: [
              {
                img: "/static/img/products/tubos-refrigeracion-1.webp",
                alt: "tubo refrigeracion ajusa"
              },
              {
                img: "/static/img/products/tubos-refrigeracion-2.webp",
                alt: "valvula refrigeracion ajusa"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "",
              content:
                "<p>In modern vehicles, cooling systems have evolved to improve thermal efficiency and manage an increasing number of components, including turbochargers and emission control systems. The greater complexity of the circuit increases the risk of faults that are difficult to diagnose and expensive to repair. Poor thermal management can cause serious damage, especially in liquid-cooled turbos.</p>"
            },
            "tip-2": {
              title: "",
              content:
                "<p>Turbocharger cooling pipes must only be used in compatible applications, ensuring correct routing that allows thermal expansion without generating stress.</p><p>It is essential to use suitable materials and gaskets, respect the specified tightening torque, and maintain the circuit with approved coolant. Reusing damaged or aged pipes is not recommended.</p><p>After any intervention, leak tightness must be verified and the system must be completely bled to ensure safe turbocharger operation.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "WHAT IS THE FUNCTION OF COOLANT PIPES?",
              content:
                "<p>Turbo cooling pipes carry coolant between the engine and the turbocharger, in both supply and return directions. They must withstand high temperatures, pressure and vibrations, and must be manufactured from durable materials. Depending on the application, they may be made of carbon steel, stainless steel or combinations of metal and flexible sections, selected to provide high mechanical and thermal resistance.</p><p>The pipes incorporate formed or machined ends that allow precise and leak-tight connections using specific gaskets, clamps or fittings, preventing coolant leaks even under severe operating conditions.</p><p>In certain configurations, cooling pipes integrated into an auxiliary circuit with an electric pump allow coolant circulation to continue after the engine is switched off. This system is essential to dissipate accumulated residual heat.</p><p>This phenomenon, known as heat soak, occurs when heat from the turbine is transferred to the center housing in the absence of coolant flow. Forced circulation limits thermal peaks and promotes a controlled temperature decrease. This solution is especially relevant in vehicles operating under severe conditions and in those equipped with Start&Stop systems, as it reduces oil thermal degradation, carbon deposit formation and premature turbocharger wear.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      junta_turbo: {
        titulo: "TURBO FITTING KIT",
        texto:
          "<p>At Ajusa, our dedication to providing comprehensive solutions for turbocharged engines goes beyond lubrication tubes. We are proud to manufacture complete gasket sets for turbocharger manufacturers, ensuring that all necessary gaskets are available to support your turbocharger installation or repair.</p><p>These kinds of Ajusa products are designed to meet the exacting standards of turbocharger manufacturers, offering a reliable and efficient solution for sealing critical components. All of them include all the necessary components to ensure a thorough and precise installation or repair process.</p>",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil6.pdf",
        details: {
          intro: {
            alt: "turbo fitting kit",
            title: '<h1 class="title title-36">Turbo Fitting Kit</h1>',
            text:
              "<p>Welcome to our premier destination for driving enthusiasts seeking top-notch performance upgrades. Step into a world of power and precision with our cutting-edge <span class='bold'>Turbo Fitting Kit.</span></p><p>Designed to take your driving experience to new heights, this product is engineered with meticulous attention to detail and crafted <span class='bold'>using the finest materials</span>, ensuring uncompromising <span class='bold'>performance and reliability.</span></p><p>This kit seamlessly integrates into a wide range of makes and models, optimizing engine efficiency and unleashing a surge of power like never before. Embrace the thrill of accelerated acceleration and improved torque, all while enjoying <span class='bold'>enhanced fuel economy.</span></p>",
            btn_text: "ONLINE CATALOG",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/junta-turbo-1.webp",
                alt: "ajusa turbo fitting kits"
              },
              {
                img: "/static/img/products/junta-turbo-2.webp",
                alt: "spare parts for turbo"
              },
              {
                img: "/static/img/products/junta-turbo-3.webp",
                alt: "turbo fitting kits"
              },
              {
                img: "/static/img/products/junta-turbo-4.webp",
                alt: "auto parts for turbocharged"
              }
            ]
          },
          tips: {
            "tip-1": {
              title:
                "Transform your driving experience with a Turbo Fitting Kit",
              content:
                "<p>Engineered to transform your vehicle into a powerhouse of performance and excitement, our Turbo Fitting Kit optimizes your engine's capabilities providing you a fusion of power and efficiency, propelling you to new heights of exhilaration on the open road.</p><p>Feel the confidence coursing through your veins as you tackle every twist and turn with grace and precision. It’s the right time to boost your driving experience like never before, as reduced turbo lag ensures instantaneous response to your commands.</p>"
            },
            "tip-2": {
              title: "Engineering prowess and precision",
              content:
                "<p>Every element of our <span class='bold'>Turbo Fitting Kit</span> is meticulously engineered with a passion for perfection, from the intricate design to the selection of premium materials in order to surpass the highest industry standards and your most demanding expectations.</p> <p>The pieces that make up this kit your engine will roar with a newfound vigor and each turn of the wheel will become a masterstroke. Discover and experience first hand the ultimate upgrade to <span class='bold'>join the elite ranks of high-performance driving</span>.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "What turbo fits my car?",
              content:
                "<p>Our <span class='bold'>Turbo Fitting Kit is designed for use on vehicles of different brands and models</span>.Nevertheless, should you have any doubt about its integration, we recommend you provide us specific details about your car, such as the make, model, year and any other relevant specifications.</p> <p>With this information, our automotive experts can assist you in finding the perfect piece, tailored to your vehicle's needs. Feel free to get in touch with us and we'll shortly help you find the ideal match for your car's performance enhancement.</p>"
            },
            "dropdown-2": {
              title: "What changes will I notice in my driving?",
              content:
                "<p>Despite its powerful capabilities, our Turbo Fitting Kit also boosts a greener drive. Witness the harmony of power and eco-consciousness as you go further with each tank of fuel, reducing your carbon footprint.</p><p>And not only will you feel the difference in your driving performance, but this Kit can also extend the life of your engine by reducing stress and promoting efficient combustion, which <span class='bold'>contributes to the longevity of your vehicle.</span></p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },

      ajusil: {
        titulo: "<strong>Ajusil</strong> Silicone sealant",
        texto:
          "<p>This high-performance, neutral silicone formula offers a multitude of advantages, ensuring a reliable and long-lasting seal for various applications. Experience the benefits of its low odor composition and oxygen sensor safe formulation, making it ideal for use in enclosed spaces.</p><p>Whether you're dealing with extreme temperatures or harsh fluids, rest assured that these sealants will rise to the challenge. Their advanced formulation ensures superior adhesion, preventing leaks and providing a secure seal for your valuable equipment and components.</p><p>Available in convenient packs of 75 ml and 200 ml, Ajusil Silicone Sealant offers both precision and flexibility in application.</p>"
      },

      ajusev: {
        titulo:
          "<strong>AjusEV</strong> Silicone sealant for electric vehicles",
        texto:
          "<p>Designed to meet the specialized needs of modern automotive technology, these cutting-edge silicone sealants offer unmatched performance and protection, ensuring your vehicle's longevity and safety.</p><p>Engineered to create an impenetrable barrier against external atmospheric agents, including moisture, rain, and humidity, these chemical products will safeguard your vehicle's sensitive electronic components.</p><p>With a user-friendly 310 ml container, application becomes a breeze.</p>"
      },

      ajustick: {
        titulo: "<strong>Ajustick</strong> Anaerobic sealant",
        texto:
          "<p>the specially curated chemical product designed to cater to metal components with machined surfaces. Engineered to perfection, this anaerobic sealant offers unparalleled performance, ensuring a secure and lasting bond for a wide variety of applications.</p><p>Capable of withstanding extreme temperature ranges, from as low as -50°C to as high as 150°C, with momentary peaks of up to 180°C, this sealant is a true performer even in the most demanding environments.</p><p>Also, it comes in convenient 50 ml packs, allowing for easy and accurate dispensing.</p>"
      },

      ajulock: {
        titulo: "<strong>Ajulock</strong> Threadlocker",
        texto:
          "<p>Ajulock is the perfect mono-component, anaerobic chemical product engineered to safeguard metallic motor parts from the adverse effects of temperature variations and vibrations. Specifically curated for motor parts such as nuts, bolts and studs.</p><p>With 50 ml containers, you have the right amount of product, allowing for effortless dispensing and precise application to optimize your work efficiency.</p>"
      },

      ajulube: {
        titulo: "<strong>Ajulube</strong> Engine assembly lubricant",
        texto:
          "<p>The expertly crafted assembly engine lubricant that goes above and beyond to ensure a smooth and wear-free initial motor startup. Designed to provide exceptional protection, this product safeguards your engine's vital mechanical components during the critical moments of ignition.</p><p>Its exceptional capability to prevent metal-to-metal contact in components subjected to high pressure is highly remarkable. From camshafts to hydraulic lifters, crankshafts and pistons, it works to reduce the potential for damage.</p><p>In user-friendly 100 ml containers, for simple and precise application.</p>"
      },

      productos_quimicos: {
        titulo: "CHEMICAL PRODUCTS",
        texto:
          "<p>In addition to our extensive range of engine parts and components, Ajusa proudly offers a line of high-quality chemical products designed to complement and enhance your engine maintenance and repair processes.</p><p>Our chemical section includes sealants (Ajusil, AjusEV and Ajustick), engine lubricants (Ajulube) and threadlockers (Ajulock) that are engineered to deliver exceptional performance and provide long-lasting solutions.</p>",
        ver_mas: "See more",
        details: {
          intro: {
            alt: "chemical products",
            title: '<h1 class="title title-36">Chemical Products</h1>',
            text:
              "<p>Introducing our top-quality <span class='bold'>chemical products</span> designed exclusively for vehicle enthusiasts. At AJUSA, we take engine care to a whole new level.</p><p>Should you're a professional mechanic, our comprehensive range of <span class='bold'>sealants, engine lubricants</span> and <span class='bold'>threadlockers</span> has been carefully curated to ensure peak performance and unmatched reliability for your prized vehicles.</p><p>Step into a realm of automotive excellence and discover the perfect solutions to unleash the full potential of your engines.</p>",
            btn_text: "ONLINE CATALOG",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/productos-quimicos/intro-main-quimicos.webp",
                alt: "sealants and engine lubricants"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-0.webp",
                alt: "silicone sealant 200ml"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-1.webp",
                alt: "silicone sealant 75ml"
              },
              {
                img: "/static/img/productos-quimicos/ajusil-2.webp",
                alt: "silicone sealant"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-0.webp",
                alt: "silicone sealant for electric vehicle"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-1.webp",
                alt: "silicone sealant for electric vehicle 1"
              },
              {
                img: "/static/img/productos-quimicos/ajusev-2.webp",
                alt: "silicone sealant for electric vehicle 2"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-0.webp",
                alt: "anaerobic sealant"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-1.webp",
                alt: "anaerobic sealant 1"
              },
              {
                img: "/static/img/productos-quimicos/ajustick-2.webp",
                alt: "anaerobic sealant 2"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-0.webp",
                alt: "thread locker"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-1.webp",
                alt: "thread locker 1"
              },
              {
                img: "/static/img/productos-quimicos/ajulock-2.webp",
                alt: "thread locker 2"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-0.webp",
                alt: "engine assembly lube"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-1.webp",
                alt: "engine assembly lube 1"
              },
              {
                img: "/static/img/productos-quimicos/ajulube-2.webp",
                alt: "engine assembly lube 2"
              }
            ]
          },
          dropdowns: {
            "dropdown-1": {
              title:
                "Chemical products and materials for the automotive industry",
              content:
                "<p>Whether you're a professional mechanic, an automotive enthusiast, or a business owner seeking top-notch solutions, we've got you covered. From high-performance sealants and anaerobic threadlockers to specialized engine lubricants, our range of <span class='bold'>chemical products is designed to elevate your automotive projects.</p></span><p>With a focus on quality, performance and reliability, our solutions are trusted by industry professionals worldwide. No matter the scope of your project, our solutions are versatile, designed to tackle a wide array of applications, and backed by cutting-edge technology.</p><p>Join the countless professionals who have trusted us with their automotive projects and experience the difference that <span class='bold'>top-quality chemical products can make.</span></p>"
            },
            "dropdown-2": {
              title: "Sealing Solutions for automotive industry",
              content:
                "<p>Our <span class='bold'>sealants have been carefully curated</span> to create a waterproof barrier and prevent loosening under the most demanding conditions.Our team of experts has meticulously tested and refined each product to ensure they meet the highest industry standards, providing you with peace of mind and confidence in your projects.</p> <p>These sealing solutions are able to create a strong, lasting bond, ensuring that your automotive components stay securely in place, whether it's preventing leaks, reducing vibration-induced loosening or withstanding extreme temperature fluctuations.</p>"
            },
            "dropdown-3": {
              title: "Engine Lubrication basics for vehicles",
              content:
                "<p>Proper lubrication plays a vital role in ensuring the smooth operation, performance and longevity of your vehicles’ engine. Without <span class='bold'>adequate lubrication</span>, the components would experience increased resistance, leading to power loss and decreased overall performance.</p> <p>Moreover, by creating a protective film of oil between these moving parts, lubrication minimizes direct metal-to-metal contact, <span class='bold'>preventing excessive wear and heat generation.</span>Prioritize regular maintenance, choose the right lubricants and enjoy the smooth, efficient and reliable ride.</p>"
            },
            "dropdown-4": {
              title: "What is the best threadlocker for cars?",
              content:
                "<p>When it comes to selecting the best <span class='bold'>threadlocker for cars, Ajulock</span> stands out as a top- notch choice for automotive enthusiasts and professionals alike.This chemical product is a high- performance, mono- component anaerobic threadlocker that excels in providing secure and <span class='bold'>reliable fastening solutions for a wide range of automotive applications.</span></p> <p>In addition to its excellent bonding properties, Ajulock also acts as a reliable barrier against moisture and corrosion. By sealing out harmful elements, this <span class='bold'>threadlocker helps protect your automotive components</span>, extending their lifespan and enhancing their overall performance.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      nuevo_sellante: {
        titulo: "ANAEROBIC SEALANT",
        texto:
          "Ajusa has launched its new product AJUSTICK for sealing metal components with machined surfaces. Anaerobic sealant: (requiring no oxygen for final curing) capable of working in a broad temperature range (between -50ºC and 150ºC, occasionally reaching 180ºC). Available in 50 ml packs.",
        enlace_ficha_tecnica:
          "/static/pdf/info-tecnica/info_tecnica_ajustick_en.pdf"
      },
      taques: {
        titulo: "HYDRAULIC LIFTERS",
        texto:
          "<p>At the Ajusa products factory, we pride ourselves on our comprehensive capabilities, and this includes a dedicated machining section where we develop a wide range of hydraulic tappets. Our expertise in machining allows us to create hydraulic tappets that meet the highest standards of quality, performance and reliability.</p><p>These engine parts play a crucial role in the proper operation of an engine's valvetrain. They ensure precise valve actuation by maintaining optimal clearance and providing efficient hydraulic lif.</p>",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil9.pdf",
        details: {
          intro: {
            alt: "hydraulic lifters",
            title: '<h1 class="title title-36">Hydraulic lifters</h1>',
            text:
              "<p>At Ajusa, we are leaders in the automotive manufacturing industry. One of our fields of expertise lies in our advanced machining section, where you can find our range of top quality <span class='bold'>hydraulic lifters</span>. </p><p>Thanks to our extensive machining experience, we have the capability to <span class='bold'>design and produce hydraulic lifters</span> that exceed the most rigorous standards in terms of quality, performance and reliability.</p><p>These engine parts play a critical role in the <span class='bold'>efficient operation of any engine's valve train</span>. They not only ensure precise valve actuation, but also maintain the optimum clearance required and provide highly effective hydraulic lifters.</p>",
            btn_text: "ONLINE CATALOGUE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/taques-1.webp",
                alt: "ajusa hydraulic lifters"
              },
              {
                img: "/static/img/products/taques-2.webp",
                alt: "lifters for engine repair"
              },
              {
                img: "/static/img/products/taques-3.webp",
                alt: "hydraulic lifters"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Our range of hydraulic lifters",
              content:
                "<p>Hydraulic tappets are essential devices in the <span class='bold'>automotive world</span>. At Ajusa, we have perfected their design and manufacture to offer the highest quality products.</p><p>Our wide <span class='bold'>range of hydraulic lifters</span> is designed to suit various applications in the automotive industry. Our products are versatile and safe. </p>"
            },
            "tip-2": "none"
          },
          dropdowns: {
            "dropdown-1": {
              title: "Hydraulic lifters Technical Characteristics",
              content:
                "<p> Hydraulic tappets manufactured by Ajusa are recognized for their excellence in design and performance. These <span class='bold'>essential engine parts</span> incorporate a number of key technical features that set them apart:</p><p> <span class='bold'>Advanced hydraulic</span><br>technology Our <span class='bold'>hydraulic lifters</span> use state-of-the-art hydraulic technology to ensure smooth and precise operation. This translates into immediate response and optimum performance at all times.</p><p> <span class='bold'>High-quality construction</span><br>Each hydraulic tappet is constructed with high quality materials that withstand the most demanding conditions. Durability and strength are fundamental elements of our manufacturing.</p><p> <span class='bold'>Precise tolerances</span><br>Our <span class='bold'>hydraulic lifters are manufactured to extremely tight tolerances</span> to ensure a perfect fit in the engine valve train. This results in precise valve actuation and trouble-free operation.</p><p> <span class='bold'>Performance in a variety</span><br>of conditions Our hydraulic tappets are designed to perform reliably in a variety of conditions, from extreme temperatures to high-pressure environments. Their ability to maintain consistent performance is one of their distinguishing features.</p><p> <span class='bold'>Easy installation and maintenance</span><br>Ease of installation and maintenance is a priority in the design of our hydraulic lifters. This reduces engine downtime and ensures efficient operation.</p><p> <span class='bold'>Regulatory compliance</span><br>All of our hydraulic tappets comply with the most stringent industry regulations and quality standards. This ensures safety and reliability in each of our products.</p>"
            },
            "dropdown-2": {
              title: "How to choose the right hydraulic tappets?",
              content:
                "<p>Choosing <span class='bold'>the right hydraulic lifters</span> is a strategic decision for your business and can make the difference in terms of operational efficiency and safety. At Ajusa, we provide you with the best guidance and professional advice for you to make informed and accurate decisions.</p><p>In addition, all of our hydraulic lifts meet the most rigorous industry standards and regulations. Check our online catalog to find the reference your vehicle needs.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      arbol_levas: {
        titulo: "CAMSHAFTS",
        texto:
          "<p>In addition to our expertise in hydraulic lifters production, Ajusa's hydraulic lifters production section also includes the manufacturing of camshafts from cast steel bars, utilizing modern grinding machines for precision and efficiency.</p><p>Camshafts are essential components of an engine's valvetrain system, responsible for controlling the opening and closing of the engine's intake and exhaust valves. Therefore, they play a critical role in achieving optimal engine performance and efficiency.</p>",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil10.pdf",
        details: {
          intro: {
            alt: "camshafts",
            title: '<h1 class="title title-36">Camshafts</h1>',
            text:
              "<p>In addition to our extensive experience in the production of hydraulic tappets, Ajusa´s machining section is also dedicated to the <span class='bold'>manufacture of camshafts</span> from cast steel bars, using state-of-the-art grinding machinery to achieve optimum levels of precision and efficiency.</p><p><span class='bold'>Camshafts </span> represent critical elements in an engine's valve train system, being responsible for regulating the opening and closing of the engine's intake and exhaust valves. Consequently, they play an essential role in achieving outstanding engine performance and efficiency.</p>",
            btn_text: "ONLINE CATALOGUE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/arbol-levas-1.webp",
                alt: "ajusa camshafts"
              },
              {
                img: "/static/img/products/arbol-levas-2.webp",
                alt: "engine components ajusa"
              },
              {
                img: "/static/img/products/arbol-levas-3.webp",
                alt: "components for engine repair"
              },
              {
                img: "/static/img/products/arbol-levas-4.webp",
                alt: "camshafts catalog"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Ajusa Camshaft: Power up your engine",
              content:
                "<p>Discover the full <span class='bold'>range of camshafts</span> available at Ajusa to boost your engine's performance. With our extensive experience in manufacturing high quality automotive components, we are your best choice to optimize your vehicle.</p><p>To facilitate the product assembly, Ajusa has developed a complete camshaft replacement manual, which is included, along with the assembly lubricant Ajulube, in all its camshafts.</p>"
            },
            "tip-2": {
              title: "Our variety of camshafts",
              content:
                "<p>At <span class='bold'>Ajusa</span>, we understand that every vehicle is unique. That's why we offer a wide range of camshafts designed to fit various performance needs and applications. Whether you're looking for a high-performance upgrade or an OEM quality part, we have the perfect solution for you.</p>"
            }
          },
          dropdowns: {
            "dropdown-1": {
              title: "Advantages of choosing our camshafts",
              content:
                "<p><span class='bold'>Unmatched Quality</span>:<br>All of our camshafts are manufactured to the highest quality standards, ensuring exceptional durability and performance.</p><p><span class='bold'>Innovative Technology</span>:<br>We incorporate the latest technical innovations in the design and manufacture of our camshafts to ensure that you are using the best in automotive technology</p>.<p><spanclass ='bold'>Proven Performance</span>:<br>Our parts undergo rigorous performance testing to ensure they meet and exceed expectations in terms of power and efficiency</p>.<p><span class='bold'>Broad Compatibility</span>:<br>We offer camshafts for a wide range of vehicle makes and models, making it easy to find the perfect part for your car.</p><p><span class='bold'>Confidence Guarantee</span>:<br>We back our camshafts with a solid performance guarantee, giving you peace of mind and confidence in your choice.</p><p>When you choose Ajusa camshafts, you are opting for excellence in automotive engineering. Power your engine and enhance your driving experience with the quality and performance that only Ajusa can deliver.</p>"
            },
            "dropdown-2": {
              title: "Camshaft replacement manual",
              content:
                "<p>Ajusa has developed a <span class='bold'>complete camshaft replacement manual</span> to facilitate this process in engines. This manual is included, along with the assembly lubricant Ajulube, in all its camshafts.</p><p class='span bold'>Detailed steps for camshaft disassembly and assembly</p><p>The disassembly and assembly of the camshaft on an engine consists of several steps that must be followed precisely. First of all, it is necessary to place cylinder #1 in <span class='bold'>Top Dead Center</span> (TDC) and check that the camshaft is in phase. </p><p>Then, the engine must be immobilized and the timing belt or chain, the cylinder head cover and the accessories driven by the camshaft must be removed.</p><p>Subsequently, it is necessary to disassemble the camshaft pulley and its supports, followed by disassembly of the <span class='bold'>camshaft</span> and <span class='bold'>tappets</span>. At this point, it is important to discard the hydraulic tappets and verify that the camshaft seats in the cylinder head are not worn.</p><p>In case the cylinder head seats are in bad condition, it is recommended to replace the bushings. In addition, it is suggested to lubricate the camshaft seats and supports with the oil provided.</p><p>Then, the tappets and the <span class='bold'>camshaft</span> are mounted on their seats in the cylinder head, placing the pulley and tightening the fixing screw according to the specifications. Subsequently, the timing belt or chain is mounted, applying the appropriate tension, and it is manually verified that the camshaft turns freely when the crankshaft rotates.</p><p>Finally, the engine is checked again and the cylinder head cover and components are assembled in the reverse order of disassembly. Visit our <span class='bold'>YouTube mechanics channel</span>, you will find some videos about the assembly of this component</p>."
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      otros: {
        titulo: "Other Components",
        texto:
          "<p>Ajusa products and sealing solutions ensure a complete repair of your engine. For this, we also include in our catalog a wide variety of gaskets for other parts of the engine such as the water pump, the EGR valve, the brake compressor, the thermostat, etc.</p><p>Feel free to contact us and ask about any engine part that you need to buy, whether you are the owner of a professional garage or a private individual.</p>",
        enlace_ficha_tecnica:
          "archivos/ajusatips/aplicacion-sellante-ajusil10.pdf",
        details: {
          intro: {
            alt: "other engine parts",
            title: '<h1 class="title title-36">Other Components</h1>',
            text:
              "<p>We offer you sealing products and other <span class='bold'>components Ajusa</span> designed to ensure that your engine runs smoothly. In our catalog, you will find a <span class='bold'>wide selection of gaskets for different parts of the engine</span>, such as the water pump, EGR valve, brake compressor, thermostat, among others.</p><p>If you need to <span class='bold'>buy another component</span> of those you have seen on our website for your engine, do not hesitate to contact us, whether you are the owner of a professional workshop or an individual. We are here to answer your questions and help you find the part you need.</p>",
            btn_text: "ONLINE CATALOGUE",
            btn_redirect: "https://web.tecalliance.net/ajusa/en/home",
            slider: [
              {
                img: "/static/img/products/otros-1.webp",
                alt: "ajusa spare parts"
              },
              {
                img: "/static/img/products/otros-2.webp",
                alt: "fiber gaskets"
              },
              {
                img: "/static/img/products/otros-3.webp",
                alt: "metal-caucho gaskets"
              },
              {
                img: "/static/img/products/otros-4.webp",
                alt: "gaskets catalog"
              }
            ]
          },
          tips: {
            "tip-1": {
              title: "Other Components and parts for your engine",
              content:
                "<p>At Ajusa, we know that sealing is essential in a <span class='bold'>variety of engine components</span>. That's why we offer a wide range of sealing solutions and other components Ajusa covering different engine parts. </p>"
            },
            "tip-2": "none"
          },
          dropdowns: {
            "dropdown-1": {
              title: "Parts Catalog",
              content:
                "<p><span class='bold'>Water Pump Gaskets</span><br>Gaskets designed for the water pump are essential to prevent leaks and maintain proper engine cooling. Our gaskets are precision manufactured to ensure a perfect seal.</p><p><span class='bold'>EGR Valve Gaskets</span><br>EGR valve gaskets are crucial to ensure controlled gas flow in the exhaust system, reducing emissions and improving engine efficiency. Rely on our gaskets to keep your engine running smoothly!</p><p><span class='bold'>Brake Compressor Gaskets</span><br>Other component Ajusa is the gaskets in the brake compressor for the safety of your vehicle. Our high quality gaskets ensure a tight seal, which is essential for a reliable operation of the brake system.</p><p><span class='bold'>Thermostat Gaskets</span><br>The thermostat regulates the engine temperature, and our thermostat gaskets ensure that this component functions properly. An optimal seal here is essential to prevent overheating and engine damage.</p><p><span class='bold'>Other components Ajusa available</span><br>In addition to these parts mentioned above, we offer a wide variety of other components Ajusa for different engine applications.</p><p>Come and discover them!</p>"
            },
            "dropdown-2": {
              title: "Features and Benefits",
              content:
                "<p>At <span class='bold'>Ajusa</span>, we provide high quality gaskets and engineered parts. Our sealing parts are distinguished by:</p><p><span class='bold'>Precise design:</span> Each gasket is precision manufactured to ensure a perfect fit and optimal sealing.</p><p><span class='bold'>Superior quality:</span> We use the highest quality materials that withstand the most demanding conditions and extend the life of your engine.</p><p><span class='bold'>Significant advantages:</span> By using our sealing solutions, you get reliable performance, improved efficiency and longer engine life.</p>"
            },
            "dropdown-3": {
              title: "Quality and Regulatory Compliance",
              content:
                "<p>We are committed to excellence in the manufacture of <span class='bold'>sealing parts</span> and <span class='bold'>other components Ajusa</span> for your engine. We rigorously comply with the most demanding regulations and quality standards in the automotive industry. </p><p>Our parts are synonymous with safety and performance for your engine.</p>"
            }
          },
          btn_more_info: {
            text: "MORE INFORMATION"
          }
        }
      },
      garantia: {
        titulo:
          "<span class='bold'>Quality standards of AJUSA chemical products</span>",
        titulo1:
          "<h2 class='title title-36'><span class='bold'>Quality standards of Ajusa products</span></h2>",
        texto:
          "All the AJUSA Chemical Products count with TUV certifications according to the ISO 9001 and IATF 16949 regulations.",
        boton: "Find the certificates here",
        cumplimiento:
          "Our commitment to health and safety is paramount. As per the guidelines outlined in Royal Decree 396/2006 regarding health and safety regulations in workplaces dealing with potential asbestos exposure, we can proudly confirm that our sealants, engine lubricants and threadlockers are entirely asbestos-free."
      },
      shared: {
        "junta-turbo": "turbo-fitting",
        ajusil: "ajusil-en",
        "arbol-levas": "camshafts",
        "junta-culata": "cylinder-head",
        "junta-motor": "full-gasket-sets",
        otros: "others",
        retenes: "oils-seals",
        taques: "hydraulic-lifers",
        tornillos: "cylinder-head-bolts",
        "tubos-engrase": "oil-feed-pipes",
        "tubos-egr": "egr-pipes",
        nuevo_sellante: "anaerobic-sealant"
      },
      titulo_banner: "Select language",
      idiomas: {
        GE: "German",
        EN: "English",
        ES: "Spanish",
        FR: "French",
        HU: "Hungarian",
        IT: "Italian",
        NL: "Dutch",
        PL: "Polish",
        PT: "Portuguese",
        BG: "Bulgarian",
        CZ: "Czech",
        GR: "Greek",
        LV: "Latvian",
        SL: "Slovak",
        SE: "Swedish",
        LT: "Lithuanian",
        SL: "Slovenian",
        SK: "Slovak",
        RU: "Russian",
        RO: "Romanian",
        LT: "Lithuanian"
      },
      nav_options: {
        vehiculo_electrico: {
          title: "Electric vehicle",
          category: "vehiculo_electrico",
          href: "electric-vehicle"
        },
        junta_culata: {
          id: "cylinder-head-gaskets",
          title: "cylinder head gaskets",
          category: "product"
        },
        junta_motor: {
          id: "full-gasket-sets",
          title: "FULL GASKET SETS",
          category: "product"
        },
        tornillos: {
          id: "cylinder-head-bolts",
          title: "CYLINDER HEAD BOLTS",
          category: "product"
        },
        retenes: {
          id: "oil-seals",
          title: "OIL SEALS",
          category: "product"
        },
        tubos_engrase: {
          id: "oil-feed-pipes",
          title: "OIL FEED PIPES",
          category: "product"
        },
        tubos_egr: {
          id: "egr-pipes",
          title: "EGR valve pipes",
          category: "product"
        },
        tubos_refrigeracion: {
          id: "coolant-pipes",
          title: "Coolant Pipes",
          category: "product"
        },
        junta_turbo: {
          id: "turbo-fitting-kits",
          title: "TURBO FITTING KITS",
          category: "product"
        },
        productos_quimicos: {
          id: "chemical-products-line",
          title: "Chemical products line",
          category: "productos"
        },
        taques: {
          id: "hidraulic-lifters",
          title: "HYDRAULIC LIFTERS",
          category: "product"
        },
        arbol_levas: {
          id: "camshafts",
          title: "CAMSHAFTS",
          category: "product"
        },
        otros: {
          id: "other-components",
          title: "OTHER COMPONENTS",
          category: "product"
        }
      },
      alt_images: {
        juntas_culata: "cylinders head gaskets",
        tornillos: "cylinder head bolts",
        tubos_engrase: "oil feed pipes turbo components",
        "junta-culata-1": "ajusa cylinder head gasket",
        "junta-culata-2": "head gaskets catalog",
        "junta-culata-3": "mls cylinder head gaskets",
        "junta-motor-1": "ajusa full gasket sets",
        "junta-motor-2": "gasket sets ajusa",
        "junta-motor-3": "gaskets for cars",
        "junta-motor-4": "gaskets for industrial vehicles",
        "junta-motor-5": "auto parts for engine car repair",
        "tornillos-1": "ajusa cylinder head bolts",
        "tornillos-2": "ajusa bolts",
        "tornillos-3": "angular tightening of screws",
        "tornillos-4": "cylinder head bolts catalog",
        "retenes-1": "ajusa seals",
        "retenes-2": "ajusa oil seals",
        "retenes-3": "valve stem seals ajusa",
        "retenes-4": "oil seals for cars",
        "tubos-engrase-1": "ajusa oil feed pipes",
        "tubos-engrase-2": "turbo components ajusa",
        "tubos-engrase-3": "oil feed pipes for turbocharger",
        "tubos-engrase-4": "turbocharger components",
        "tubos-egr-1": "egr egr ajusa",
        "tubos-egr-2": "egr valve ajusa",
            "tubos-refrigeracion-1": "ajusa coolant pipes",
        "junta-turbo-1": "ajusa turbo fitting kits",
        "junta-turbo-2": "spare parts for turbo",
        "junta-turbo-3": "turbo fitting kits",
        "junta-turbo-4": "auto parts for turbocharged",
        sellantes_lubricantes: "sealants and engine lubricants",
        sellante_silicona: "silicone sealant",
        sellante_silicona_electrico: "silicone sealant for electric vehicle",
        sellante_anaerobico: "anaerobic sealant",
        lubricante_motor: "engine assembly lube",
        fijador_roscas: "thread locker",
        "taques-1": "ajusa hydraulic lifters",
        "taques-2": "lifters for engine repair",
        "taques-3": "hydraulic lifters",
        "arbol-levas-1": "ajusa camshafts",
        "arbol-levas-2": "engine components ajusa",
        "arbol-levas-3": "components for engine repair",
        "arbol-levas-4": "camshafts catalog",
        "otros-1": "ajusa spare parts",
        "otros-2": "fiber gaskets",
        "otros-3": "metal-caucho gaskets",
        "otros-4": "gaskets catalog",
        taller_electrico: "electric vehicle workshop"
      }
    },
    catalogo: {
      intro: {
        titulo: "AJUSA CATALOG",
        texto:
          "Discover the <strong>Ajusa catalog</strong> and find the best parts for your vehicle.</br> Power your driving with quality parts!",
        catalogo_impreso: "printed<br>catalog",
        catalogo_impreso_texto:
          "We send you the printed Ajusa catalog at no cost. Request it here.",
        catalogo_impreso_boton: "Request it now"
      },
      cat_general: {
        texto:
          "We are proud to present our <strong>Ajusa Catalog</strong>, an essential tool for any professional in the <strong>automotive industry</strong>. This catalog is constantly updated online and an updated printed edition is published every two years. With more than 200,000 references in <strong>engine sealing components</strong>, we offer a wide range of solutions to meet your needs."
      },
      buscador: {
        placeholder: "Search by vehicle makes",
        titulo:
          "Use the search engine above or select the initial of the brand of your interest."
      },
      cat_turbo: {
        titulo: "TURBO COMPONENTS CATALOG",
        texto:
          "If you are looking for quality turbocharger components, our <strong>Turbo Components Catalog</strong> is your reliable source. You can browse Ajusa's part numbers by turbo brand or vehicle model reference, allowing you to easily find the right components for your application.",
        por_vehiculo: "DOWNLOAD BY VEHICLE MAKE",
        por_turbo: "download by turbo part number"
      },
      cat_juntas_compresor: {
        titulo: "BRAKE COMPRESSOR GASKET CATALOG ",
        texto:
          "<p>For commercial vehicles, we offer an exclusive <strong>Brake Compressor Gasket Catalog</strong>. Here, you can download the catalog by compressor (Voith, Wabco and Knorr-Bremse) or by vehicle brand (Scania, Iveco, Man, DAF, Volvo (industrial) and Mercedes (industrial)). </p><p>Our <strong>Ajusa catalog</strong> gives you quick access to the seals you need to keep your commercial vehicles in top condition.</p>",
        por_vehiculo: "DOWNLOAD BY VEHICLE MAKE",
        por_turbo: "Download by compressor"
      },
      tec_alliance: {
        intro: "ONLINE CATALOG",
        titulo: "MAKE YOUR SEARCH!",
        texto_1:
          "Our <strong>Ajusa Catalog</strong> gives you immediate access to a wide range of options for finding the precise part your vehicle needs. Whether you are searching by the make and model of your car, the specifications of your engine, the vehicle identification number (VIN) for an even more precise search, a specific part number, OEM part number or even advanced technical details, we are here to simplify your selection process.",
        texto_2:
          "Each part number in our Ajusa catalog is accompanied by detailed technical data. In addition, we offer assembly videos that allow you to visualize how the part is installed on your vehicle and 360° photographs that give you a complete view of the product.",
        boton: "ACCESS"
      },
      cat_juegoJuntas: {
        idUrl: "gasket-set",
        intro: "SPECIAL GASKET SET CATALOG",
        texto:
          "Our Specialty <strong>Gasket Sets Catalog</strong> offers 14 families of gasket sets designed for various engine parts. From water pumps to exhaust systems and <strong>cylinder head covers</strong>, we offer the most complete coverage on the market. You can download the complete catalog Ajusa or select the specific gasket set you need for your repairs.",
        descarga_completo: "DOWNLOAD FULL CATALOG",
        descarga_juegos: {
          title: "DOWNLOAD BY GASKET SET",
          bombasAgua: "Water pump",
          bombasAgua_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-agua-gasket-water-pump.pdf",
          bombasCombustible: "Fuel pump",
          bombasCombustible_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-combustible-fuel-pump.pdf",
          bombaHidraulica: "Hydraulic pump",
          bombaHidraulica_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-hidraulica-hydraulic-pump.pdf",
          bombaInyeccion: "Injector pump",
          bombaInyeccion_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-inyeccion-injector-pump.pdf",
          bombaVacio: "Vacuum pump",
          bombaVacio_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/bomba-vacio-vacuum-pump.pdf",
          juntaCarter: "Timing case",
          juntaCarter_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/carter-mando-timing-case.pdf",
          colectorAdminision: "Intake manifold",
          colectorAdminision_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/colector-admision-intake-manifold.pdf",
          colectorEscape: "Exhaust manifold",
          colectorEscape_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/colector-escape-exhaust-manifold.pdf",
          comprensor: "Charger",
          comprensor_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/compresor-charger.pdf",
          inyector: "Injector nozzle",
          inyector_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/inyector-injector-nozzle.pdf",
          radiadorAceite: "Oil cooler",
          radiadorAceite_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/radiador-aceite-oil-cooler.pdf",
          sistemaEscape: "Exhaust system",
          sistemaEscape_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/sistema-escape-exhaust-system.pdf",
          sistemaEGR: "EGR System",
          sistemaEGR_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/sistema-juntas-EGR-System.pdf",
          tapasCulata: "Cylinder head cover",
          tapasCulata_enlace:
            "/bundles/prensa/descargables/public/pdfs/juntasEspeciales/tapa-culata-cilindro-cilinder-head-cover.pdf"
        }
      },
      ajusa_th: {
        intro: "RENEWABLE ENERGY",
        titulo: "SUSTAINABLE FUTURE ",
        texto:
          "<p>At Ajusa we are not only dedicated to excellence in the automotive industry, but we are also committed to a sustainable future. We have developed a line of research in alternative energies and are pioneers in the manufacture of hydrogen-based PEM fuel cells.</p><p>Discover more about Ajusa Hydrogen Technologies and our commitment to renewable energy.</p>",
        boton: "DISCOVER",
        construccion: "Page under construction. Available shortly."
      },
      retenes: {
        titulo: "Catalog shaft seal kits",
        texto:
          "Ajusa is launching a specific catalog for shaft seal kits. It has the most complete coverage of seal kits to carry out a full cambelt change on the vehicle."
      },
      motorsport: {
        titulo: "Motorsports",
        texto:
          "<p>In the world of high-performance engines, the demands are extreme, and this is where Ajusa <strong>High Performance Gaskets</strong> come into play. Check out our <strong>Ajusa Motorsport</strong> application guide, which offers a complete catalog of cylinder head gaskets designed for high-performance engines.</p><p>Our high performance gaskets are manufactured to ensure the perfect sealing required in these extreme conditions.</p>"
      },
      novedad: "new",
      nav_options: {
        cat_general: {
          id: "general-cat",
          title: "general catalog",
          category: "catalogo"
        },
        cat_turbo: {
          id: "turbocharger-cat",
          title: "turbocharger catalog",
          category: "catalogo"
        },
        cat_ve: {
          title: "ev catalogue",
          category: "electric-vehicle",
          href: "electric-vehicle"
        },
        catalogo_online: {
          title: "online catalog",
          redirect: "https://web.tecalliance.net/ajusa-us/qa/home/ap"
        },
        catalogo_impreso: {
          title: "Request printed catalog",
          category: "catalogo",
          href: "contact"
        }
      },
      alt_images: {
        catalog: "ajusa catalog",
        catalog_online: "ajusa catalog online",
        pila_hidrogeno: "pem fuel cell"
      }
    },
    area_tecnica: {
      intro: {
        titulo: "AJUSA technical area",
        texto:
          "Ajusa technical assistance service. Improve your mechanical knowledge with the<strong class='bold'> technical reports, assembly videos and webinars</strong> available in this section."
      },
      asesoramos: {
        intro: "We offer solutions",
        texto_1:
          "We are at your disposal to answer your questions. Contact our technical assistance department by e-mail or WhatsApp.",
        texto_2: "+34 619 029 273",
        boton: "Send"
      },
      app: {
        texto_1:
          "Download our improved APP to perform a quick and easy search for the components your vehicle needs.",
        texto_2: "And much more!"
      },
      tips: {
        titulo: "TECHNICAL REPORTS ",
        texto_1:
          "Report new every month about Ajusa products. Prepared by a team of experts that Download them!",
        texto_2: "We publish a new technical report every 15 days.",
        filtrar: "Sort by category",
        por_keyword: "Search by keyword",
        resultado: "Results of your search:",
        mostrando: "Displaying",
        novedades: "NOVELTIES"
      },
      webinarios: {
        titulo: "WEBINARS",
        texto:
          "Sign up for our webinars and learn mechanics from the comfort of your own home. Free educational sessions lasting one hour each to improve your knowledge and make you an even better expert. In English and Spanish. ",
        proximos: "UPCOMING WEBINARS",
        no_hay: "No webinars scheduled at the moment",
        anadir_cal: "add to the calendar",
        hasta: "19:00h until 21:00h",
        ultimo: "",
        btn: "Request Webinar"
      },
      asesoramiento: {
        intro: "CONSULTANCY",
        titulo: "WE OFFER SOLUTIONS",
        texto:
          "The Ajusa technical assistance department is waiting to hear from you. Our colleagues handle all your questions personally. In addition, you can consult our technical report guides and our video tutorials to see step-by-step explanations on how to fit our products. ",
        boton: "NEED SOME HELP"
      },
      nav_options: {
        ajusa_app: {
          id: "ajusa-app",
          title: "ajusa mobile app",
          category: "area_tecnica"
        },
        tips: {
          id: "tips",
          title: "technical reports",
          category: "area_tecnica",
          alert: true
        },
        actualidad_videos: {
          id: "mechanics-videos",
          title: "mechanics videos",
          category: "area_tecnica",
          redirect: "https://www.youtube.com/channel/UCnoYVeFbsPiOVOcf80tW6Bg"
        },
        webinars: {
          id: "webinars",
          title: "webinars",
          category: "area_tecnica"
        }
      },
      alt_images: {
        juntas_culata_mls: "mls head gaskets ajusa"
      }
    },
    ajusa: {
      intro: {
        titulo: "The automotive <span class='bold'>excellence </span>",
        texto:
          "Ajusa, a Spanish company with more than 50 years of history, has been operating in the US market since 1986. With several official distributors throughout the country, Ajusa is a leading brand in the United States."
      },
      enlaces: {
        calidad: "OEM",
        servicio: "SHIPMENTS",
        compromiso: "SOCIAL RESPONSABILITY",
        equipo: "INNOVATION",
        catalogo: "CATALOG"
      },
      calidad: {
        titulo: "OEM",
        texto:
          "We improve the original quality of the first equipment with parts for the engine guaranteed by the TÜV quality certificates according to the ISO 9001 and AIF 16949 regulations."
      },
      servicio: {
        titulo: "SHIPMENTS",
        texto:
          "Our fulfillment centers in Florida and California allow us to deliver nationwide with a 99.5% service ratio."
      },
      compromiso: {
        titulo: "SOCIAL<br>RESPONSABILITY",
        texto:
          "Ajusa works in various international social projects to help the most needy communities.",
        texto_btn: "CARBON FOOTPRINT REPORT",
        pdf: "/static/pdf/Ajusa_Carbon_Footprint_Report.pdf"
      },
      equipo: {
        titulo: "INNOVATION",
        texto:
          "Constant innovation. Ajusa incorporates the latest technology into its production processes and its facilities are equipped with the most sophisticated machinery."
      },
      catalogo: {
        titulo: "CATALOG",
        texto:
          "The most complete in the aftermarket sector. The AJUSA general catalog has more than 200,000 references and can be consulted on the web. You can also request the printed version that is updated every two years."
      },
      excelencia: {
        titulo: "COMMITMENT TO THE ENVIRONMENT",
        texto:
          "Our factory located in Spain has the TUV certification according to the ISO14001 standard.",
        enlace_texto: "ISO 14001 standard",
        texto_2:
          " and over <strong class='bold'>8,000 solar panels generate 40% of our annual power  consumption</strong> at our production plant.",
        boton: "View report"
      },
      historia: {
        titulo: "WE ARE 50 YEARS OLD IN 2022",
        texto:
          "Check our 50 years of history as manufacturers of engine components.",
        boton: "access"
      },
      alt_images: {
        sede_principal: "ajusa headquarters",
        fabricante_tubos_engrase: "oil feed pipes manufacturer",
        factoria_automocion: "ajusa factory automotive industry",
        social: "ajusa social and environmental commitment",
        catalog_juntas: "ajusa gaskets catalog",
        historia: "ajusa history"
      }
    },
    actualidad: {
      noticias: {
        titulo: "breaking news",
        ir_blog: "Go to the blog"
      },
      twitter: {
        titulo: "Aware on social networks",
        acceder: "Access"
      },
      videos: {
        titulo: "VIDEOS",
        texto:
          "Learning mechanics is easy with the videos of Ajusa. Our mechanic explains all the steps you must follow to repair your vehicle and correctly assemble the engine components.",
        ultimos: "latest videos",
        ver_todos: "view all the videos"
      }
    },
    blog: {
      intro: {
        titulo: "<span>TUNING</span>",
        subtitulo: "The blog of"
      },
      categorias_nombres: {
        fairs: "Trade fairs",
        products: "Products",
        "our-sector": "Our sector",
        "social-commitment": "Social Commitment"
      },
      alt_images: {
        ajusa_blog: "ajusa blog",
        puesta_punto: "tunnig",
        ferias: "stand automechanika ajusa",
        productos: "ajusa head gaskets",
        "nuestro-sector": "our sector ajusa",
        "compromiso-social": "social commitment"
      },
      ultimas: "Breaking news",
      dejar_comentario: "LEAVE A COMMENT",
      titulo_comentarios: "RECENT COMMENTS ",
      noticias_relacionadas: "Related News",
      compartir: "Share",
      no_hay_post: "No posts in that category"
    },
    sala_prensa: {
      clipping: {
        titulo: "CLIPPINGS",
        texto:
          "The media in the automobile sector reflect the latest announcements from AJUSA. This is the annual round-up of AJUSA media appearances.",
        boton: "download",
        logotipo: "logo",
        imagenes: "images"
      },
      ajusa: {
        intro: "about ajusa",
        titulo: "THE AUTOMOTIVE EXCELLENCE",
        texto:
          "We have been manufacturing cylinder head gaskets since 1972. Leaders in engine sealings with the most extensive catalog of engine seals in the sector. We are also experts in the production of oil feed pipes and turbo fitting kits for engine turbo. Always at the service of the automobile industry."
      }
    },
    historia: {
      texto_intro:
        "We have been a global reference for over 45 years. Working in search of constant improvement in both our products and our services.",
      hoy: "Today",
      texto_1972_1:
        "AJUSA started up in 1972. That year saw the manufacture of the first cylinder head gasket. It took 3 hours and everything was done totally by hand!",
      texto_1972_2:
        "We attended the first international trade fairs and extended our facilities by moving to the Campollano industrial estate.",
      texto_1980_1:
        "We launched our first general catalog with 600 references. The current catalog has 20 times more! We have surpassed 200,000 references, providing complete coverage for Asian and European makes.",
      texto_1980_2:
        "We managed to produce our first OEM-quality part: a cylinder head gasket for Renault.",
      texto_1990_1:
        "We opened our Research and Testing Centre where we perform the most exhaustive quality assurance checks on our products.",
      texto_1990_2:
        "Launch of 3 new product lines: cylinder head bolts, hydraulic lifters and camshafts.",
      texto_2000_1:
        "Ajusa grows internationally and opens branches in Russia, United Kingdom, Mexico and Brazil, incorporating strategic partners around the globe.",
      texto_2000_2:
        "We move into the business park that bears our name: Ajusa. With over 40,000 m2 in our production plant and 3,000 m2 for offices.",
      texto_2010_1:
        "Since 2014, we produce oil feed pipes and we have launched our catalog of turbo components with the most references in the market.",
      texto_2010_2:
        "We apply the latest technology to ensure the maximum quality in our product lines."
    },
    contacto: {
      titulo: "CUSTOMER SERVICE",
      sucursales: "Branches",
      coords: {
        lat: 25.74785930888482,
        lng: -80.26214470369948
      },
      id: "usa",
      delegaciones: {
        espana: {
          nombre: "Spain",
          titulo: "head office",
          direccion:
            "Parque Empresarial Ajusa, Calle 1, nº1 · 02008 · ALBACETE (Spain) · Apdo./P.O. Box 415 (02080)",
          telefono: "Ph.: +34 967 216 212",
          fax: "Fax: +34 967 216 214 - 967 240 499",
          email: "Mail: <a href='mailto:ajusa@ajusa.es'>ajusa@ajusa.es</a>"
        },
        uk: {
          nombre: "United Kingdom",
          titulo: "Ajusa United Kingdom",
          direccion:
            "Premier House, Hortonwood 7 · Telford, Shropshire · TF1 7GP",
          telefono: "Ph. +44 (0)195 2608 771",
          fax: "",
          email:
            "Contact: <a href='mailto:info@ajusa.co.uk'>info@ajusa.co.uk</a>"
        },
        mexico: {
          nombre: "Mexico",
          titulo: "Ajusa México S.A. de C.V",
          direccion:
            "Calle Lago Ladoga, 295-A · Col. Anahuac, Deleg. Miguel Hidalgo · Ciudad de México, D.F. CP 11320 (Mexico)",
          telefono: "Ph. +52-55 5254 2332",
          fax: "Fax +52-55 5254 2332",
          email:
            "Contact: <a href='mailto:ajusamexico@ajusa.com.mx'>ajusamexico@ajusa.com.mx</a>"
        },
        brasil: {
          nombre: "Brazil",
          titulo: "Ajusa do Brasil Ltda.",
          direccion:
            "Rua Santa Francisca, 417 · Bairro Vila Jaguara, 05116-090 · SÃO PAULO, SP (Brazil)",
          telefono: "Ph. +55 11 3622-5353",
          fax: "Fax +55 11 3622-5353",
          email:
            "Contact: <a href='mailto:ajusadobrasil@ajusa.com.br'>ajusadobrasil@ajusa.com.br</a>"
        },
        usa: {
          nombre: "USA",
          titulo: "AJUSA USA Corp.",
          direccion:
            "GABLES INTERNATIONAL PLAZA · 2655 S. LE JEUNE ROAD SUITE # 905 · CORAL GABLES, FL 33134",
          telefono: "Ph. +1 310 625 1034",
          fax: null,
          email:
            "Contact: <a href='mailto:ajusausa@ajusa.es'>ajusausa@ajusa.es</a>"
        },
        francia: {
          nombre: "France",
          titulo: "Ajusa France",
          direccion: "64, Rue Paul Claudel, 87000 | Limoges (France)",
          telefono: "Ph. +33 587 14 71 17",
          fax: null,
          email:
            "Contact: <a href='mailto:ajusafrance@ajusa.fr'>ajusafrance@ajusa.fr</a>"
        }
      },
      alt_images: {
        contacto_ajusa: "ajusa contact",
        trabajar_ajusa: "work with us ajusa"
      },
      phone: "+1 310 625 1034",
      email: "ajusa@ajusa.us"
    },
    trabaja_con_nosotros: {
      intro: {
        titulo: "<span class='bold'>SEND US </span> YOUR CV",
        texto:
          "Do you want to work with us? Fill out this form and attach your CV. We will contact you if your profile matches one of our vacancies."
      },
      texto:
        "At Ajusa, we work to grow every day, if you want to form part of our ever larger family, fill in this form and attach your curriculum.",
      boton: "submit curriculum"
    },
    formulario: {
      nombre: "Given name(s)",
      nombre_apellidos: "First and last name",
      apellidos: "Surname(s)",
      email: "Email",
      mensaje: "Message",
      fecha_nacimiento: "Date of birth",
      dia: "Day",
      mes: "Month",
      anyo: "Year",
      area_interes: "Area of interest",
      trabaja_actualmente: "Are you currently employed?",
      motivo: "Choose one of the following",
      si: "Yes",
      no: "No",
      carta_presentacion: "Covering letter",
      tipos_contacto: {
        general: "General, contact, branches",
        comercial: "Commercial",
        formacion: "Training",
        asistencia_tecnica: "Technical Assistance",
        catalogo: "Request a printed catalog",
        webinar: "Request Webinar"
      },
      meses: {
        enero: "January",
        febrero: "February",
        marzo: "March",
        abril: "April",
        mayo: "May",
        junio: "June",
        julio: "July",
        agosto: "August",
        septiembre: "September",
        octubre: "October",
        noviembre: "November",
        diciembre: "December"
      },
      archivo_adjunto: "Attach file",
      adjuntar_cv: "Attach CV",
      empresa: "Company name",
      sector: "Sector",
      formulario: "Complete address (indicate town and postcode)",
      referencia: "Product reference ",
      introduce_mail: "Indicate your email address",
      tipo_catalogo: "Type of catalog",
      pais: "Country",
      ciudad: "City",
      telefono: "Telephone",
      direccion: "Address",
      quiero_recibir:
        "I would like to receive news and information about Ajusa.",
      acepto_comunicaciones:
        "I agree to receive the newsletter or other communications from your company.",
      otros_procesos:
        "I would like to be kept in mind for other selection processes at Ajusa that might be of interest",
      he_leido:
        "I consent to the use my data for the purposes indicated in the",
      y_acepto: "Privacy Policy",
      enviar_comentario: "Send your comment",
      comentario_enviado: "Comment sent",
      enviar: "Send",
      enviado: "Sent",
      popup: {
        claim: "Click here to view and agree to the privacy policy",
        intro: "BASIC DATA PROTECTION INFORMATION",
        textos: [
          {
            titulo: "Data controller",
            texto: "Auto Juntas SAU"
          },
          {
            titulo: "Address of the data controller",
            texto:
              "Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02008, Albacete (Albacete)"
          },
          {
            titulo: "Purpose",
            texto:
              "Your details will be used to process your requests and provide you with our services."
          },
          {
            titulo: "Advertising",
            texto:
              "We will only send you advertising if you authorize it in advance. You can do this by marking the corresponding box on the form."
          },
          {
            titulo: "Legal Authority",
            texto:
              "We will only process your details with your prior consent. You can do this by marking the corresponding box on the form."
          },
          {
            titulo: "Intended recipients",
            texto:
              "Generally speaking, only duly authorized personnel at our company will be able to access the information we request from you."
          },
          {
            titulo: "Rights",
            texto:
              "You are entitled to know what information we hold about you, correct it and have it deleted, as explained in the additional information available on our web site."
          },
          {
            titulo: "Additional Information",
            texto:
              "Further information is available in the “YOUR DATA SECURE” section of our web site."
          }
        ],
        boton: "Understood"
      },
      thank_you: {
        title: "SENT!",
        text:
          "<p>Thank you! The form has been sent successfully.</p><p>We will contact you as soon as possible.</p><p>",
        btn_text: "RETURN TO HOME PAGE"
      }
    },
    error_404: {
      intro: "<span class='bold'>PAGE</span> NOT FOUND",
      nombre: "Error 404",
      texto:
        "Sorry! The page you are trying to access is no longer available or has been moved.",
      boton: "Back to home page"
    },
    newsletter: {
      titulo: "Subscribe to our newsletter",
      texto:
        "Receive all the latest news about the automobile sector and AJUSA's announcements.",
      suscripcion_ok:
        "You have been signed up correctly! From now on you will be kept up to date with all the latest news from Ajusa"
    },
    footer: {
      siguenos: "Follow us",
      en_redes: "Follow us on social media",
      twitter: "Follow us on X",
      facebook: "Follow us on Facebook",
      instagram: "Follow us on Instagram",
      canal: "Sign up for our channel",
      selecciona_idioma: "Select a language",
      alt_image: "ajusa certificates"
    },
    popupApp: {
      title: "Download AJUSA Mobile",
      description: "All information about our products."
    },
    popupretenes: {
      title: "New catalog shaft seal kits",
      boton: "Download it!  "
    },
    popupjuntas: {
      novedades: "NOVELTY",
      title: "SPECIAL GASKET SET CATALOG",
      texto: "for different engine parts",
      boton: "CATALOG"
    },
    popupajustick: {
      title: "NEW PRODUCT",
      description: "ANAEROBIC SEALANT AJUSTICK",
      boton: "PRODUCT"
    },
    otras_secciones: {
      catalogo: {
        titulo: "catalog",
        texto:
          "The easiest way to find the part you need for your vehicle and its reference. The AJUSA catalog contains applications for all European and Asian vehicles manufacturers. You can consult it online or request a printed catalog.",
        boton_texto: "Go to the catalog"
      },
      area_tecnica: {
        titulo: "Consultancy",
        texto:
          "We value customer satisfaction and offer an <strong>Ajusa Technical Assistance</strong> department to answer all your questions and needs. Our colleagues are available to provide you with personalized advice. In addition, you can consult our technical report guides and video tutorials for step-by-step explanations on the assembly of our products.",
        boton_texto: "Need some help?"
      },
      sala_prensa: {
        titulo: "Press room",
        texto:
          "Consult the materials Ajusa has placed at your disposal as well as the latest news and the annual round-up of AJUSA's media appearances in the automobile sector.",
        boton_texto: "VIEW MATERIALS"
      },
      solicite_catalogo: {
        titulo: "Request a printed catalog",
        texto:
          "We facilitate the repair of vehicles. If you prefer a printed copy of our General Catalog or our Bathtub Catalog, please feel free to send us your request indicating which one you are interested in. We are here to help you in every step of your automotive repair journey.",
        boton_texto: "request"
      },
      actualidad: {
        titulo: "Latest news",
        texto:
          "Visit our blog, sign up for our newsletter or follow us on the social media. We share our experiences! ",
        boton_texto: "LOOKING FORWARD TO SEEING YOU"
      },
      donde_estamos: {
        titulo: "where to find us",
        texto:
          "We are wherever you need us. We have official distributors located around the globe and branch offices in Mexico, Brazil, Russia and Great Britain. Our factory and main headquarters, where we carry out all the development work, is in Albacete (Spain). ",
        boton_texto: "Contact us"
      }
    },
    banner_cookies:
      "A cookie is a small data file that is stored in your browser each time you visit our website. Cookies are useful to save the history of your activity on our website so that when you visit it again, it can identify you and display its content based on your browsing habits, identity and preferences. Cookies can be accepted, rejected, blocked and deleted as desired. If you decide to reject them, we cannot guarantee the correct operation of our website. More information in the section <router-link to='/cookies-policy'>cookies policy</router-link>.",
    boton_aceptar: "Allow",
    historia_infografia: {
      celebracion50:
        '<p>50th Anniversary</p><p class="second-line">Celebration </p>',
      celebracion50descripcion:
        "On November 11th, 2022, we gathered all our employees in the Teatro Circo of Albacete to celebrate our 50 years of history.",
      video: "VIDEO",
      galeria: "IMAGE GALLERY",
      noticias: "NEWS",
      urlNoticias:
        "https://ajusa.online/en/blog/news/ajusa-celebrates-50-anniversary",
      urlVideoIntro: "/static/img/historia_infografia/intro.mp4",
      Anios50: "<strong>50 </strong> YEARS",
      excedencia: "excellence",
      enAutomocion: "of automotive",
      albacete: "<strong>ALBACETE,</strong>",
      laCuidad: "the city that saw ",
      crecer: "us thrive",
      mayorAntesDeTiempo: "Old before his time",
      textMayor:
        "<strong>He was the fifth of six siblings. At the age of 9 he lost his mother and at 15 his father, a lorry driver by profession.</strong>",
      eraseUnaVez: "Once upon a time…",
      textEraseUnaVez:
        "Albacete, February 13, 1950. José Manuel Martínez Martínez, founder of Ajusa was born. His family situation forced him to drop out of school and he started working at the age of 13 as a sales assistant in a picture store and in a delicatessen in his neighbourhood.",
      cuentameMas: "TELL ME MORE!",
      unGestoInolvidable: "An unforgettable gesture",
      enEsteTrabajo:
        "In this job he was registered with the <strong>Social Security</strong>. This fact, something so unusual at that time, was very important for him.",
      aprendiendoElOficio: "Learning the trade…",
      con14Anios:
        "Josema discovered his true vocation at the age of 14 when he started working at the Pegaso dealership in Albacete (COMALBASA), where he was soon appointed head of the spare parts department.",
      granImplicacion: "A great commitment",
      fueronAnios:
        "These were years entailed a great deal of dedication and learning, in which he combined his military service in Seville with his work at Auto Martínez, spare parts company than he founded with his brothers.",
      fueronMeses:
        "In Seville he worked night shifts to dedicate time to Auto Martínez during the day. Such was his involvement that he spent over than <strong>50,000 pesetas a month on phone calls!</strong>",
      naceAjusa: "Ajusa is founded",
      suEspiritu:
        "His entrepreneurial spirit was fostered by his passion for the automotive industry and he decided to go that one step further by starting his own business. In 1972, he opened a small establishment where he started to manufacture the first engine gaskets of the Marca España (Brand Spain) trademark. ",
      naceLaCompania:
        "And just like that the industrial company (now Ajusa) was founded, a company that José Manuel Martínez presides until today.",
      miguelOliver:
        "Miguel Oliver was appointed industrial director and José Gómez the head of custom tooling craftsmanship.",
      primeraJuntas:
        "The first cylinder head gaskets were manufactured entirely by hand and with our own tooling also produced in our facilities.",
      seTardada:
        "It took approximately 3 hours to manufacture a cylinder head gasket, while nowadays approximately 1000 cylinder head gaskets can be produced in 3 hours.",
      primeraEtapa:
        "During this first stage, materials such as asbestos were used. Ajusa was the first manufacturer in the world to stop using this now banned material.",
      contanciaEsfuerzo: "Perseverance and hard work",
      josemaRecorrio:
        "<strong>Josema visited practically every city in Spain. Upon his arrival somewhere he would pick up the telephone directory and call all the workshops and spare parts stores one by one until he could personally present the Ajusa catalog.<br>This is how our brand became known in Spain.</strong>",
      edicion: "Edition",
      catalogoAjusa: "Ajusa Catalog",
      infoCatalogo:
        "Just one year after the founding of Ajusa and with a staff of 10 workers, the first engine gaskets catalog was launched. At that time the catalog only had 600 product references while today, with a staff of 800 people, it has over 200,000. ",
      verPortadas: "SEE COVERS",
      textInfo1974:
        "And just like that began the love story of Josema and Dori, who were the parents of three children: Consuelo, José Manuel y Noelia. The essence of Ajusa is based on family values and commitment.",
      amorAPrimera: "Love at first sight",
      descriptAmor:
        "The woman of this picture is Adoración Sánchez, who worked for a year in the packaging section and in the administration department. The same day she left the company, Josema called her on the phone... to ask her out on a date!",
      crecimientoImparable: "An unstoppable growth",
      text1crecimientoImparable:
        "Years went by and with hard work, sacrifice and the same enthusiasm with which it was founded, Ajusa continued its unstoppable growth, relocating to the <strong>Polígono Campollano (Campollano Industrial Estate) in Albacete</strong> and expanding its production line.",
      text2crecimientoImparable:
        "And more importantly, Josema kept intact the entrepreneurial spirit of his beginnings. While the brand's leadership in the nationa market was being established, his sights were alreadyset on internationalisation.",
      verMas: "SEE MORE",
      title1978: "From a local company...<br>to the world stage!",
      description1_1978:
        "Its early presence in the main international trade shows and ambitious export plan for the 70s enabled the company to open markets in other countries.",
      description2_1978:
        "Josema advocated and upheld his business judgement and criteria and did not succumb to the dictates of major multinationals, even turning down contracts worth millions of pesetas!",
      description3_1978:
        "In 1978, Ajusa participated in Automechanika, <strong>the most important international automobile trade show</strong> which is held every two years in Frankfurt.",
      importanteReconociento: "Major recognition!",
      espirituInnovador:
        "The innovative and entrepreneurial spirit which José Manuel Martínez showed from an incredibly young age resulted in obtaining the <strong>Gold Medal for Exports</strong> in 1981. ",
      title1980: "The cornerstones of a great company",
      description1_1980:
        "The expansion of the services offered and the increase in demand resulted in the need to have larger facilities.",
      description2_1980:
        "In 1980, Ajusa laid the foundations of its first major factory by expanding the Campollano facilities. Successively, adding square metres with the sole objective of providing the best service to professionals in the automotive sector.",
      title1992: "Business expansion",
      description1_1992:
        "The cylinder head gasket continued to be the star product, but 1992 was a strategic year in the expansion of the business with the incorporation of <strong>complete gasket sets</strong> for engines, cylinder head bolts and a comprehensive <strong>range of accessory gaskets</strong>. The machining line was also launched to manufacture hydraulic tappets and camshafts. ",
      calidadGarantizada: "Guaranteed quality",
      ajusaEmpresaPionera:
        "Ajusa was one of the pioneering companies to obtain AENOR quality certifications as per the ISO 9001 and IATF 16949 Standards in the 1990s.",
      primeraEmpresaSector:
        "It was likewise the <strong>first company in the sector</strong> to offer the customer a comprehensive kit of gaskets for the same engine.",
      title1996: "Opening of branches",
      description1_1996:
        "With the consolidation of the company, it became a reference benchmark and several branches were opened in various locations such as Los Angeles (USA), Sao Paulo (Brazil), Mexico City (Mexico), Birmingham (UK) and Limoges (France) .",
      eeuuPrimeraSucursal: "USA, first branch",
      sucursalEeuu:
        "Ajusa's branch in the United States was the first to open its doors and, like the other branches, has a warehouse with over 10,000 items in stock.",
      comprometidosSostenibilidad: "Committed to sustainability",
      infocomprometidosSostenibilidad:
        "Ajusa set up in 2002 a company dedicated to the research of hydrogen as an alternative energy: Ajusa Tecnologías del Hidrógeno (Ajusa Hydrogen Technologies). Currently, it applies the most cutting-edge technologies in the implementation of multiple projects using PEM technology.",
      title2002: "Pioneers in hydrogen technologies",
      description2002:
        "Ajusa set up in 2002 a company dedicated to the research of hydrogen as an alternative energy: <strong>Ajusa Tecnologías del Hidrógeno (Ajusa Hydrogen Technologies)</strong>.<br> Currently, it applies the most cutting-edge technologies in the implementation of multiple projects using PEM technology.",
      actualizamosLogo: "An updated logo",
      evolucionG: "Graphic evolution",
      title2008: "Ajusa Industrial Estate",
      description1_2008:
        "In 2008, without losing sight of its local roots, the production facilities located in Parque Empresarial Ajusa, were inaugurated. ",
      description2_2008:
        "A complex of 5 factories which include the different production lines and that facilitates the integration of the latest technology to ensure utmost reliability in the Ajusa product range.",
      title2014: "New production lines",
      description1_2014:
        "Ajusa's team innovative drive and the company's continuous investment in research and product development facilitated the start-up of the turbo components production line, which includes both the development of gaskets as well as the manufacture of turbo lubrication pipes.",
      description2_2014:
        "This year also saw the launch of the first edition of the turbo components catalog. Both the production lines as well as the staff continued to grow steadily.",
      title2022: "Growing together",
      description1_2022:
        "50 years have brought <strong>new values and new products<strong> to the company, conferring it an identity with a keen sense of responsibility towards its environment. For this reason, Ajusa participates annually in various projects to collaborate and support social actions carried out by numerous associations.  ",
      description2_2022:
        "This year, with the history which precedes us, we celebrate with great responsibility our 50th anniversary, in the belief that it will be a point of reference in the history of Ajusa and likewise to that of growing together in the future.",
      verVideo: "SEE VIDEO",
      urlVideoCompl: "/static/img/historia_infografia/video-compl-ingles.mp4"
    },
    vehiculo_electrico: {
      intro_titulo: "ELECTRIC VEHICLE",
      descripcion_intro:
        "The Ajusa catalog of <strong>components for hybrid and electric cars</strong> offers a wide coverage of kits with the necessary parts to repair this type of engines. Each kit includes a mechanics video in which a professional explains how to repair.</br></br>",
      descripcion_intro2:
        "<img src='/static/img/vehiculo-electrico/triangle-exclamation-duotone.svg' style='height:20px; margin-right: 5px;' alt='icon important'/><strong>Safety measures and basic tools</strong> for repairing an electric vehicle. Click on the video!",
      catalogo: {
        titulo: "KIT TO REPAIR HYBRID AND ELECTRIC MOTORS ",
        descripcion:
          "Our innovative range of hybrid and electric motor repair kits are the key to keeping your vehicle efficient and on the move."
      },
      sellado: {
        titulo: "SPARE PARTS FOR ELECTRIC VEHICLE ",
        descripcion:
          "We offer a wide selection of high quality spare parts designed for electric vehicle components, ensuring optimal performance and sustainability."
      },

      material: {
        titulo: "ENGINE FAULT REPAIR ",
        descripcion:
          "<p>Rely on our team of experts to quickly fix any engine failure in your electric and hybrid car, keeping it in excellent running condition.</p><p>In Ajusa's <strong>catalog of components for hybrid and electric cars</strong>, you can search the kit you need by vehicle brand. Each components kit includes a description of the most common faults of that model with a link to a video about the repair of the engine.</p>"
      },
      porqueElegir: {
        titulo: "WHY AN ELECTRIC VEHICLE OR A HYBRID VEHICLE?",
        descripcion:
          "<p>At Ajusa, we understand that choosing an electric vehicle (EV) or a hybrid car (HEV) is much more than a simple transportation decision. It is a statement of commitment to the future and an investment in sustainable mobility. </p><p> But why should you buy one of these vehicles?</p>"
      },

      medioAmbiente: {
        titulo: "Contribute to the environment",
        descripcion:
          "<p>Opting for an EV or HEV is a tangible way to reduce your carbon footprint. These vehicles produce fewer harmful emissions and contribute to the preservation of the environment.</p><p>By relying on Ajusa for the repair of <strong>components for electric and hybrid cars</strong>, you are keeping your eco- friendly vehicle in top condition.</p>"
      },
      ahorro: {
        titulo: "Long-Term Savings",
        descripcion:
          "<p>Although the initial investment may be slightly higher, electric and hybrid vehicles offer significant savings over their lifetime. With lower energy costs and less need for maintenance, you'll notice a substantial difference in your driving expenses.</p>"
      },
      experiencia: {
        titulo: "Advanced Driving Experience",
        descripcion:
          "<p>Electric and hybrid cars offer a smooth, quiet and emission-free driving experience. The latest technology in these vehicles ensures exceptional performance and unmatched comfort on the road.</p>"
      },
      innovacion: {
        titulo: "Supporting Innovation",
        descripcion:
          "<p>By choosing an electric or hybrid car, you are supporting innovation in the automotive industry. These vehicles drive research and development of cleaner, more efficient technologies, paving the way for a more sustainable future.</p>"
      },
      catalogo_vehiculo_hibrido: "HYBRID AND ELECTRIC VEHICLE CATALOG",
      catalogo_vehiculo_hibrido_kits:
        "All our repair kits are also available without bearings.",
      catalogo_juntas_compresor: "EV A/C COMPRESSOR CATALOG GASKET SET",
      renault: "RENAULT",
      modelo: "Model",
      ano: "Year",
      codigo_motor: "Engine Code",
      n_comprensor: "Compressor No.",
      tipo_averia: "Type of Failure",
      referencias_disponibles: "Available Ajusa References",
      otras_referencias: "Other references",
      manual: "REPAIR MANUAL",
      videoReparacion: "REPAIR VIDEO",
      commercialInfo: "REQUEST COMMERCIAL INFORMATION",
      accessVideoTut: "ACCESS TO ALL VIDEO TUTORIALS",
      videos: {
        video0: {
          id: "vehiculo-electrico-2",
          videoId: "svouPU4u8jY",
          text:
            "Do you know what you need to repair an electric vehicle? In this video, we explain <strong>the safety measures and the main tools</strong> that a mechanic's workshop should have.",
          btnText: "VIDEO"
        },
        EV001900: {
          id: "AUDI",
          modelo: "AUDI E-tron 55",
          año: "2019 - 2023",
          codigoMotor: "EASA",
          referenciasDisponibles: "EV001900",
          videoId: "aM7HnIMiV8s"
        },
        EV001400: {
          id: "BMW",
          modelo: "BMW i3",
          año: "2012 - 2022",
          codigoMotor: "IB1P25B",
          referenciasDisponibles: "EV001400",
          videoId: "_krGGRnVYtI"
        },
        EV000500: {
          id: "Hyundai | Kia",
          modelo:
            "Hyundai Kona, Hyundai Kauai, Kia Niro EV, Kia E-Soul EV (III)",
          año: "2018-2023",
          codigoMotor: "EM16",
          referenciasDisponibles: "EV000500",
          videoId: "gi1Gbs3d9NA"
        },
        EV000700: {
          id: "hyundai",
          modelo: "Hyundai Ionic EV",
          año: "2016-2019",
          codigoMotor: "EM09, 88KW, 120CV",
          referenciasDisponibles: "EV000700",
          videoId: "D5RnWWK1JXM"
        },
        EV000600: {
          id: "kia",
          modelo: "Kia Soul EV (II) 81KW, 110CV",
          año: "2014-2018",
          codigoMotor: "ZD",
          referenciasDisponibles: "EV000600",
          videoId: "YJ82wEmqP5M"
        },
        EV001300: {
          id: "nissan",
          modelo: "Nissan LEAF ZE01",
          año: "2017-2022",
          codigoMotor: "EM57",
          referenciasDisponibles: "EV001300",
          videoId: "Sz-wPyY0To8"
        },
        EV001200: {
          id: "peugeot",
          modelo: "PEUGEOT E-208",
          año: "2020-",
          codigoMotor: "ZK01",
          referenciasDisponibles: "EV001200",
          videoId: "6zXy9dBiqsY"
        },
        EV000100: {
          id: "renault",
          modelo: "Renault Zoe",
          año: "2012-2018",
          codigoMotor: "5M- 450",
          referenciasDisponibles: "EV000100",
          videoId: "cI_eu063pw4"
        },
        EV000200: {
          id: "Renault | Smart",
          modelo: "Renault Zoe, Smart Fortwo W453",
          año: "Renault (2012-2019), Smart (2016-2019)",
          codigoMotor: "Renault (5AQ-601) Smart (5AL)",
          referenciasDisponibles: "EV000200",
          videoId: "ZA93lYHO_T0"
        },
        EV000300: {
          id: "tesla",
          modelo: "Tesla Model 3, Tesla Model Y",
          año: "2017-2021",
          codigoMotor:
            "1120980-00-G / 1120980-17-J / 1120990-00-J / 1672095-00-C / 1672096-00-B /1672096-00-C",
          referenciasDisponibles: "EV000300",
          videoId: "gazCfvf3N9c"
        },
        EV000400: {
          id: "tesla",
          modelo: "Tesla Model S · Tesla Model X",
          año: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          codigoMotor: "1035000-00-J",
          referenciasDisponibles: "EV000400",
          videoId: "CK5OeOPX-sM"
        },
        EV000800: {
          id: "tesla",
          modelo:
            "Tesla Model S · Tesla Model X · Mercedes B-Class B250e · Toyota RAV4 EV",
          año:
            "Tesla Model S (2012 – 2021) · Tesla Model X (2015 – 2021) · Mercedes B-Class B250e (2014 – 2017)  · Toyota RAV4 EV (2012 – 2014)",
          codigoMotor:
            "1002633-00-U / 002633-01-U / 1002633-01-U / 1025598-01-U",
          referenciasDisponibles: "EV000800",
          videoId: "JxbTKXWBRMw"
        },
/*         EV000802: {
          id: "tesla | Mercedes | Toyota",
          producto: "Coolant bypass kit",
          modelo:
            "Tesla Model S, Tesla Model X, Mercedes B-Class, Toyota Rav4 EV",
          año:
            "Tesla Model S (2012-2021), Tesla Model X (2015-2021), Mercedes (2014-2017), Toyota (2012-2014)",
          codigoMotor: "1002633-00-U, 1002633-01-U, 1025598-01-U",
          referenciasDisponibles: "EV000802",
          videoId: "d2gj_aTYW1o"
        }, */
        EV001000: {
          id: "tesla",
          modelo: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          año: "Tesla Model S (2012 - 2021) · Tesla Model X (2015 - 2021)",
          codigoMotor: "1037000-20-A y 1037000-00-F",
          referenciasDisponibles: "EV001000",
          videoId: "gEr97ru09VQ"
        },
        EV001100: {
          id: "tesla",
          modelo: "Tesla Model 3 (2017-2025) · Tesla Model Y (2020-2025)",
          año: "Tesla Model 3 (2017-2025) · Tesla Model Y (2020-2025)",
          codigoMotor:
            "Dual Motor versions with front motor code 3D3 (also combined with 3D5, 3D6 or 3D7)",
          referenciasDisponibles: "EV001100",
          videoId: "MIVazJrPxOs"
        },
        EV000901: {
          id: "volvo",
          modelo: "Volvo V60",
          año: "2011-2018",
          codigoMotor: "D82PHEV, D87PHEV, D97PHEV y B1APHEV",
          referenciasDisponibles: "EV000901",
          videoId: "0_-WLtUpgm4"
        },
        EV001500: {
          id: "volkswagen",
          modelo: "E-Golf",
          año: "2014-2021",
          codigoMotor: "EBSA",
          referenciasDisponibles: "EV001500",
          videoId: "vv8NSjXvAlk"
        }
      },
      videosComprensor: {
        EVC00100: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012-2019",
          nComprensor: "1063369-00-G",
          referenciasDisponibles: "EVC00100",
          videoId: "A_h7O2TGtEU"
        },
        EVC00200: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012-2017",
          nComprensor: "1028398-00-E",
          referenciasDisponibles: "EVC00200",
          videoId: "71wMqdMsqHg"
        },
        EVC00300: {
          id: "tesla",
          modelo: "Tesla Model S ",
          año: "2012",
          nComprensor: "6007380-00-C",
          referenciasDisponibles: "EVC00300",
          videoId: "Ok9Q-mgfJmw"
        },
        EVC00400: {
          id: "tesla",
          modelo: "Tesla Model X",
          año: "2015-2025",
          nComprensor: "1042442-00-D",
          referenciasDisponibles: "EVC00400",
          videoId: "5gOHPBtBtbA"
        }
      },
      hazte_experto: "IMPROVE YOUR KNOWLEDGE",
      reparacion_vehiculos: "ABOUT HYBRID AND ELECTRIC VEHICLE",
      reparacion_vehiculos_descripcion:
        "<strong>Hybrid and electric car repair</strong> is a new job opportunity for mechanics. The mechanical videos associated with each Ajusa component kit are useful and practical material for mechanics.",
      reparacion_vehiculos_descripcion_2:
        "You only have to scan the QR code of the label of each product to access the video.",
      ajusa_te_lo_pone_facil: "AT YOUR FINGERTIPS",
      opiniones_titulo: "OPINIONS",
      opiniones: {
        opinion1: {
          cliente: "Julián Fernández | Talleres Machín",
          descripcion:
            "“A practical, instructional method that helped improve my knowledge about electric vehicle mechanics. I'm also very happy with the quality of the electric vehicle components that Ajusa manufactures.”"
        },
        opinion2: {
          cliente: "Juan Soler | Talleres Soria",
          descripcion:
            "“With Ajusa's video tutorials, I've learnt to carry out repairs on electric motors. I recommend these training materials to any workshop looking to learn about electric vehicle mechanics.”"
        },
        opinion3: {
          cliente: "Bienvenido Martínez | Mechanic Garage",
          descripcion:
            "“All you need to do is scan the QR code on the product label and you can access an interesting tutorial that explains how the parts are assembled. It's very simple and practical.”"
        },
        opinion4: {
          cliente: "Steve Taylor | Motor Repair",
          descripcion:
            "“I was surprised by the professionalism of the mechanic that appears in the videos and how he was able to easily explain the motor repair and assembly step by step. These videos are very useful for any mechanic, and I will use them again for future repairs.”"
        }
      },
      dropdowns: {
        "dropdown-1": {
          title: "COMPONENTS FOR ELECTRIC CARS",
          content:
            "<p>When it comes to the <strong>repair of electric vehicle (EV) components</strong>, knowing them is essential to guarantee an efficient and high quality service. At Ajusa, we have extensive experience in repairing all the fundamental elements that make an electric car work.</p><h3><strong>Electric motor</strong></h3><p> This component of your electric car requires expert attention in case of problems. Our trained technicians are ready to diagnose and repair any electric motor failure, ensuring optimal performance.</p><h3><strong>Traction battery</strong></h3><p> The traction battery is a critical component in electric cars and its repair is essential to maintain your vehicle's range and efficiency. At Ajusa, we are equipped to handle the repair and replacement of traction batteries, extending the life of your vehicle.</p><h3><strong>Auxiliary Battery</strong></h3><p> In addition to the main battery, electric vehicles have an auxiliary battery that powers critical systems. If you need assistance with the auxiliary battery, our team is ready to help.</p><h3><strong>Power converter</strong></h3><p> The power converter plays an important role in power management. Any problems in this component of your electric car can affect overall performance. At Ajusa, we have the parts to troubleshoot the power converter efficiently.</p><h3><strong>On-board charger</strong></h3><p> Charging an electric vehicle is a key part of its daily operation. If you experience problems with the on-board charger, we can offer effective solutions to ensure your vehicle is always ready for the road</p>.<h3><strong>Transmission</strong></h3><p> Transmissions in electric vehicles are different from those in internal combustion vehicles and require specialized knowledge. At Ajusa, we are experts in this type of components and we are prepared to solve any problem you may face with this part.</p><h3><strong>Charging socket</strong></h3><p> The charging socket is the entrance door for the energy in your electric vehicle. If you have problems with the charging socket, we can help you to charge your vehicle without worries.</p><h3><strong>Electronic module</strong></h3><p> Electronic modules play a crucial role in your operation. At Ajusa, we have the expertise to repair and maintain these modules for optimal performance.</p>"
        },
        "dropdown-2": {
          title: "COMPONENTS FOR HYBRID CARS",
          content:
            "<p> When we talk about <strong>hybrid vehicles</strong>, it is essential to understand the fundamental elements that make their efficient operation possible.</p><p> At <strong>Ajusa</strong>, we have accumulated extensive experience in the repair of these components, which allows us to offer a high quality and safe service.</p><h3><strong>Combustion engine</strong></h3><p> Keeping this component of your hybrid car in good condition is essential. At Ajusa, we provide repair and maintenance services to ensure that its performance is efficient and low in emissions.</p><h3><strong>Electric motor-generator</strong></h3><p> The electric motor-generator is an essential component in a hybrid car, since it converts kinetic energy into electricity to charge the batteries.</p><h3><strong>Inverter</strong></h3><p> The inverter is responsible for converting the electrical energy stored in the batteries into usable energy for the electric motor. If you experience problems with the inverter, we are prepared to provide you with a solution for any necessary repairs.</p><h3><strong>Batteries</strong></h3><p> This component of your hybrid car guarantees its correct operation. Therefore, at Ajusa, we offer repair and replacement services to maintain the autonomy of your vehicle.</p>"
        }
      },
      solucionesAftermarkert: "EUROPEAN MANUFACTURERS",
      subtitulo_soluciones: "FOR HYBRID AND ELECTRIC VEHICLES",
      descripcion_soluciones:
        "Ajusa distributes its engine <strong>component kits for hybrid and electric vehicles</strong> in the United States through a wide network of distributors in all states. ",
      solicita_info: "DO YOU WANT TO BE A DEALER?",
      alt_images: {
        tag_ajusa: "ajusa label",
        juntas_electricos: "gaskets for electric vehicles"
      }
    },
    sobre_nosotros: {
      nav_options: {
        ajusa: {
          title: "ajusa",
          category: "sobre_nosotros",
          href: "ajusa"
        },
        historia: {
          title: "our history",
          category: "aniversario50",
          href: "50-anniversary"
        },
        blog: {
          title: "blog",
          category: "blog",
          href: "blog"
        },
        contacto: {
          title: "contact",
          category: "contacto",
          href: "contact"
        },
        canal_etico: {
          title: "Ethical Channel",
          redirect: "https://ajusa.canales-eticos.com"
        },
        trabaja_con_nosotros: {
          title: "work with us",
          href: "work-with-us"
        }
      }
    },
    politica_privacidad:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">DATA PROTECTION POLICY</h1><p>The Direction / Governing Body of AUTO JUNTAS SAU (hereinafter, the person responsible for the treatment), assumes the maximum responsibility and commitment to the establishment, implementation and maintenance of this Data Protection Policy, guaranteeing the continuous improvement of the data controller. the objective of achieving excellence in relation to compliance with Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and the free circulation of these data and repealing Directive 95/46 / EC (General Data Protection Regulation) (OJEU L 119/1, 04-05-2016), and Spanish legislation on the protection of personal data (Organic Law, specific sector legislation and its development regulations).</p><br><p>The Data Protection Policy of AUTO JUNTAS SAU relies on the principle of proactive responsibility, according to which the controller is responsible for compliance with the regulatory and jurisprudential framework that governs said Policy and is able to demonstrate it to the competent control authorities.</p><br><p>In this sense, the person responsible for the treatment will be governed by the following principles that should serve all its personnel as a guide and frame of reference in the processing of personal data:</p><p>1. Protection of data the design: the controller will apply, both at the time of determining the means of treatment and at the time of the treatment itself, appropriate technical and organizational measures, such as pseudonymization, designed to effectively apply the principles of data protection, such as data minimization, and integrate the necessary guarantees in the treatment.</p><p>2. Protection of data by default: the data controller will apply the appropriate technical and organizational measures in order to guarantee that, by default, only the personal data necessary for each of the specific purposes of the processing will be processed.</p><p>3. Data protection in the information life cycle: the measures that guarantee the protection of personal data will be applicable during the entire life cycle of the information.</p><p>4. Lawfulness, loyalty and transparency: personal data will be treated in a lawful, fair and transparent manner in relation to the interested party.</p><p>5. Limitation of the purpose: personal data will be collected for specific, explicit and legitimate purposes, and will not be further processed in a manner incompatible with said purposes.</p><p>6. Minimization of data: personal data will be adequate, relevant and limited to what is necessary in relation to the purposes for which they are treated.</p><p>7. Accuracy: personal data will be accurate and, if necessary, d; All reasonable measures shall be taken so that personal data that are inaccurate with respect to the purposes for which they are treated are d or rectified without delay.</p><p>8. Limitation of the conservation period: the personal data will be maintained in a way that allows the identification of the interested parties during no more time than necessary for the purposes of processing personal data.</p><p>9. Integrity and confidentiality: personal data will be treated in such a way as to ensure adequate security of personal data, including protection against unauthorized or illegal treatment and against loss, destruction or accidental damage, through the application of measures appropriate technical or organizational.</p><p>10. Information and training: one of the keys to guarantee the protection of personal data is the training and information provided to the personnel involved in their treatment. During the information life cycle, all personnel with access to data will be properly trained and informed about their obligations in relation to compliance with data protection regulations.</p><br><p>The Data Protection Policy of AUTO JUNTAS SAU is communicated to all the personnel of the data controller and made available to all interested parties.</p><br><p>As a consequence, this Data Protection Policy involves all the personnel of the data controller, who must know and assume it, considering it as their own, with each member responsible for applying it and verifying the data protection rules applicable to their activity, as well as identifying and contributing the improvement opportunities that it deems appropriate with the objective of achieving excellence in relation to compliance.</p><br><p>This Policy will be reviewed by the Directorate / Governing Body of AUTO JUNTAS SAU, as many times as deemed necessary, to adapt, at all times, to the current provisions on the protection of personal data.</p></div></div>',
    datos_seguros:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">YOUR DATA IS SECURE</h1><p class="bold">Information in compliance with the regulation of personal data protection</p><p>In Europe and Spain there are data protection rules designed to protect your personal information that is mandatory for our entity.</p><p>For this reason, it is very important for us that understand perfectly what we are going to do with the personal data we ask for.</p><p>Thus, we will be transparent and we will give you control of your data, with a simple language and clear options that will allow you to decide what we will do with your personal information.</p><p>Please, if after reading this information you have any questions, do not hesitate to ask us.</p><p>Thank you very much for your collaboration</p><p class="bold">Who are we?</p><ul><li>Legal name:<b>AUTO JUNTAS SAU</b></li><li>VAT:<b>A02007029</b></li><li>Main activity:<b>METAL</b></li><li>Our address:<b>Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02008, Albacete (Albacete)</b></li><li>Telephone:<b>967-216212</b></li><li>Email:<u><b><a href="mailto:ajusa@ajusa.es">ajusa@ajusa.es</a></b></u></li><li>Web site: www.ajusa.online</li></ul><p>For your confidence and security, we inform you that we are an entity registered in the following Commercial Register / Public Registry.</p><p>Our main activity is subject to a regime of prior administrative authorization. For your confidence and security, we provide you with the data related to this authorization and the identification of the competent body of our supervision.</p><p class="bold">What are we going to use your data for?</p><p>In general, your personal data will be used to be able to relate to you and be able to provide you with our services.</p><p>Likewise, they can also be used for other activities, such as advertising or promoting our activities.</p><p class="bold">Why do we need your data?</p><p>Your personal data is necessary to be able to relate to you and be able to provide our services. In this sense, we will put at your disposal a series of boxes that will allow you to decide in a clear and simple way about the use of your personal information.</p><p class="bold">Who Will know the information we ask?</p><p>In general, only the personnel of our entity that is duly authorized may have knowledge of the information that we request.</p><p>Similarly, may be aware of your personal information those entities that need to have access to it so that we can provide our services. For example, our bank will know your data if the payment of our services is made by card or bank transfer.</p><p>Likewise, your information will be known by public or private entities to which we are obliged to provide your personal data due to compliance with any law. To give you an example, the Tax Law requires to provide the Tax Agency with certain information about economic operations that exceed a certain amount.</p><p>In the event that, regardless of the aforementioned assumptions, we need to disclose your personal information to other entities, we will request your permission in advance through clear options that will allow you to decide in this regard.</p><p class="bold">How are we going to protect your data?</p><p>We will protect your data with effective security measures based on the risks involved in the use of your information.</p><p>For this, our entity has approved a Data Protection Policy and annual controls and audits are carried out to verify that your personal data is safe at all times.</p><p class="bold">Will we send your data to other countries?</p><p>In the world there are countries that are safe for their data and others that are not so secure. For example, the European Union is a secure environment for your data. Our policy is not to send your personal information to any country that is not safe the point of view of protecting your data.<p>In the event that, in order to provide the service, it is essential to send your data to a country that is not as safe as Spain, we will always request your permission and apply effective security measures that reduce the risks of sending your information. personal to another country.</p><p class="bold">For how long are we going to keep your data?</p><p>We will keep your data during our relationship and as long as the laws force us. Once the applicable legal deadlines have been finalized, we will proceed to eliminate them in a safe and environmentally friendly manner.</p><p class="bold">What are your data protection rights?</p><p>At any time you can contact us to know what information we have about you, rectify it if it is incorrect and eliminate it once our relationship is finished, in case this is legally possible.</p><p>You also have the right to request the transfer of your information to another entity. This right is called "portability" and may be useful in certain situations.</p><p>To request any of these rights, you must make a written request to our address, along with a photocopy of your ID, to be able to identify you.</p><p>In the offices of our entity we have specific forms to request these rights and we offer our help to complete them.</p><p>To learn more about your data protection rights, you can consult the website of the Spanish Agency for Data Protection (www.agpd.es).</p><p class="bold">Can you withdraw your consent if you change your mind at a later time?</p><p>You can withdraw your consent if you change your mind about the use of your data at any time.</p><p>For example, if you were interested in receiving advertising for our products or services, but no longer wish to receive more publicity, you can let us know through the form of opposition to the treatment available in the offices of our entity.</p><p class="bold">In case you understand that your rights have been neglected, can you file a claim?</p><p>In case you understand that your rights have been ignored by our entity, you can file a claim with the Spanish Agency for Data Protection, through one of the following means:</p><ul><li>Electronic office: www.agpd.es</li><li>Postal address: Agencia Española de Protección de Datos C/ Jorge Juan, 6 28001-Madrid</li><li>Telephone::<br>Telf. 901 100 099<br>Telf. 91 266 35 17<br></li></ul><p>To file a claim in the Spanish Agency for Data Protection does not entail any cost and the assistance of lawyer or attorney is not necessary.</p><p class="bold">Will we elaborate profiles about you?</p><p>Our policy is not to profiles about the users of our services. However, there may be situations in which, for the purpose of providing the service, commercial or otherwise, we need to develop profiles of information about you. An example could be the use of your purchase or service history to be able to offer you products or services adapted to your tastes or needs.</p><p>In this case, we will apply effective security measures that protect your information at all times unauthorized persons who intend to use it for their own benefit.</p><p class="bold">Will we use your data for other purposes?</p><p>Our policy is not to use your data for other purposes than those we have explained to you. If, however, we need to use your data for different activities, we will always request your permission in advance through clear options that will allow you to decide about it.</p></div></div>',
    politica_cookies:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">COOKIE POLICY</h1><p class="bold">Information in compliance with personal data protection regulations</p><p class="bold">- What are cookies and what do we use them for?</p><p>A cookie is a small data file that is stored in your browser every time you visit our website.</p><p>La utilidad de las cookies es guardar el historial de su actividad en nuestra página web, de manera que, cuando la visite nuevamente, ésta pueda identificarle y configurar el contenido de la misma en base a sus hábitos de navegación, identidad y preferencias.</p><p>Cookies are useful for keeping track of your activity on our website so that when you visit it again, it can identify you and set the content of your visit based on your browsing habits, identity and preferences.<br>A cookie is harmless, it does not contain any malware or malicious code (e.g. viruses, Trojans, worms, etc.) that could damage your terminal (computer, smartphone, tablet, etc.), but it does have some impact on your right to data protection, as it collects certain information concerning you (browsing habits, identity, preferences, etc.).</p><p class="bold">What information does a cookie store?</p><p>Cookies do not usually collect special categories of personal data (sensitive data). The data they store is of a technical nature, personal preferences, personalization of contents, etc.</p><p class="bold">What kind of cookies are there?</p><p>Generally speaking, there are five types of cookies:</p><ul><li><p class="bold">Technical Cookies:</p><p>These are the most basic cookies. They allow the user to navigate through a web page, platform or application and use the different options or services available, such as, for example, controlling traffic and data communication, identifying the session, accessing restricted areas, remembering the items making up an order, processing the purchase of an order, requesting registration or participation in an event, using security elements during navigation, storing content for the dissemination of videos or sound or sharing content through social media.</p></li><li><p class="bold">Customization Cookies:</p><p>These are cookies that allow the user to access the service with certain general characteristics predefined according to a series of criteria in the user\'s terminal, such as the language, the type of browser used to access the service, the regional configuration from which the service is accessed, etc.</p></li><li><p class="bold">Analytical Cookies:</p><p>These are cookies allowing the party responsible for them to monitor and analyse the behaviour of users on the websites they are linked to. The information collected through these cookies is used to measure the activity of the websites, application or platform, and for the preparation of browsing profiles for the users of these websites, applications and platforms, in order to introduce improvements based on the analysis of the data used by the users of the service.</p></li><li><p class="bold">Advertising Cookies:</p><p>These cookies allow the most efficient management possible of the advertising spaces, if any, that the party responsible has included on a web page, application or platform from which he or she provides the requested service based on criteria such as the content published or the frequency with which advertisements are displayed.</p></li><li><p class="bold">Behavioral advertising cookies:</p><p>These cookies allow the most efficient management possible of the advertising spaces, if any, that the party responsible has included on a web page, application or platform from which the requested service is provided. These cookies store information on the behavior of users, obtained through the continuous observation of their browsing habits, thus enabling them to develop a specific profile in order to display advertising based on it.</p></li></ul><p class="bold">What are own and third-party cookies?</p><ul><li><p class="bold">Own cookies:</p><p>Own cookies are those generated and managed by the party responsible for providing the service requested by the user.</p></li><li><p class="bold">Third Party Cookies:</p><p>These are generated by entities other than the party responsible (external services or suppliers, such as Google).</p></li></ul><p class="bold">What kind of cookies does our website store?</p><p>The following is a list of the types of cookies stored on our website and their purpose:</p><ul><li class="no-disc"><p class="bold">- Type of cookie</p><p>Third Party Cookies, Analytical Cookies: Google Analytics</p></li><li class="no-disc"><p class="bold">- Purpose</p><p>Monitoring and analysis of user behavior on the website. The information collected through this type of cookie is used to measure activity on websites, create browsing profiles for the users of these sites, applications and platforms, in order to make improvements based on the analysis of the data on how visitors use the service.</p></li><li class="no-disc"><p class="bold">- When and how it is stored</p><p>The cookie records the user\'s activity in real time while browsing and the data is stored in Google Analytics\' application.</p></li></ul><p>The AJUSA website also works with the Local Storage application.</p><p class="bold">What can I do with cookies?</p><p>Cookies can be deleted, accepted or blocked as you wish; for this you only need to set up your web browser accordingly.</p><p>At any time, you can prevent the installation of cookies on your computer by using the corresponding option on your browser, but in this case we cannot guarantee the correct operation of the various features on our website.</p><p>Below, we provide you with links to manage and block cookies depending on the browser you use:</p><p>Internet Explorer:<u><a href="http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10">http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10</a></u></p><p>FireFox:<u><a href="http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we">http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we</a></u></p><p>Chrome:<u><a href="https://support.google.com/chrome/answer/95647?hl=es">https://support.google.com/chrome/answer/95647?hl=es</a></u></p><p>Safari:<u><a href="https://www.apple.com/legal/privacy/es/cookies/">https://www.apple.com/legal/privacy/es/cookies/</a></u></p>You can also delete the cookies you have stored in your browser by going into the set-up options.</div></div>',
    aviso_legal:
      '<div class="container"><div class="block-legal"><h1 class="title title-36">LEGAL ADVISE</h1><p class="bold">TERMS AND CONDITIONS</p><p>I.-<span class="bold">The use,</span>search and/or contracting of any service set forth in our Site www.ajusa.online implies the complete acceptance, without any reservations of these General Conditions, which regulate the legal relationship arising dealing processes made between users and/or customers of the Site www.ajusa.online property of Auto Juntas S.A. (hereinafter Ajusa). Customers accept these General Conditions the moment they use or purchase any product. This document may be printed to be read or saved by the customers before acceptance.</p><p>II.-<span class="bold">The present General Conditions,</span>are subject to the enforcement of the following Spanish legislation: Act 7/1998 on April 13 on Contractual General Conditions, Royal Decree-Law 1/2007 on November 16 passing a Rewritten Text on Consumers and Users Protection Act and other supplementary acts, Royal Decree 1906/1999 on the 17th of December 1999 regulating Telephone or Electronic Contracting with general conditions, Personal Data Protection Organic Law 15/1999 on December 13, and its Implementing Regulation, Retail Commerce Management Act 7/1996 on January 15, Information Society and Electronic Commerce Services Act 34/2002 on July 11.</p><p>III.-<span class="bold">Amendment of the General Conditions.</span>Ajusa shall amend these General Conditions upon reasonable notice to its customers for the purpose of improving the services and products offered through Ajusa. The amendment of the General Conditions set forth in Ajusas Site shall be understood as a notice. At all events, these General Conditions may be consulted before using any service or purchasing products.</p><p>IV.-<span class="bold">Intellectual Property</span>. All the content in this Site (including source code, images, texts, graphics, etc.) are protected by local and foreign legislation on intellectual property in force, being all rights reserved. It is strictly forbidden to reproduce any content on the Site without expressed authorization of Ajusa and right holders.</p><p>By means of purchasing any product, Ajusa doesn’t grant any right of alteration, exploitation, reproduction, distribution or public communication over such product, and reserve all these rights. The transfer of these rights shall require previous written authorization of Ajusa. Unauthorized use of the information within this Site, its resale, as well as the violation of rights over intellectual or industrial property will result in the legally established liabilities.</p><p>V.-<span class="bold">Use of the service and Liabilities.</span>Ajusa doesn’t guarantee the permanent availability of the services, being exempted any liability for damages arising the unavailability of the product due to force majeure or errors in transfer networks beyond its control. Ajusa won’t assume liability for the content of the links to Sites which are property of third parties and therefore are beyond its control.</p><p>VI.-<span class="bold">Data protection.</span>In accordance with section 5 of the Spanish Personal Data Protection Organic Law 15/1999 on December 13, Information Society and Electronic Commerce Service Act 34/2002 on July 11, Auto Juntas, S.A. (hereinafter Ajusa) informs that the personal data given in registration forms included in this site, as well as data accessed by Ajusa as a consequence of your browsing; search, request or contracting or any transaction or action made this Site will be collected and stored under legislation in force and the liability of: Auto Juntas, S.A., Parque Empresarial Ajusa. Ctra. De Ayora Km 2.2 02008. Albacete. Spain.<u><a href="mailto:social@ajusa.es.">social@ajusa.es.</a></u></p><p>The purpose of collecting and processing Personal Data through forms and contact by email on this site is to facilitate the provision of services by Ajusa through these sites, as well as providing you with information about activities and news which may be of interest.</p><p>The remittance of personal data through the forms on this Site or via email messages requiring information or services implies expressed consent of the User to process such data as well as electronic remittance of communications with information about our activities.</p><p>Therefore, the User shows expressed consent to the incorporation of Personal Data to Personal Data Files and these data to be processed by Ajusa for the purposes afore mentioned. User likewise expresses acceptance and authorization so that Ajusa may transfer Personal Data to those companies which provide services to Ajusa such as banks and insurance companies.</p><p>User guarantees that the personal data provided to Ajusa are real and assume liability of communicating any modification.</p><p>Ajusa makes available for Users the email address social@ajusa.es and the telephone (+34) 967 216 212 so that they revoke this consent. Ajusa confirms the enforcement of the regulation in force in relation to data protection, particularly Spanish Personal Data Protection Act 15/1999 on December 13 and Spanish Royal Decree 1720/2007 on December 21 implementing such law and Ajusa makes available of Customers the contact means mentioned on the last paragraph so that they exercise their rights of access, rectification, cancellation and opposition granted by the legislation in force.</p><p>VII.-<span class="bold">Security.</span>. Ajusa guarantees taken the appropriate security measures for its premises, systems and files as well as confidential processing of Personal Data under applicable legislation in force, and informs of the implementation of security measures of technical and organizational nature in order to guarantee the security of its personal data and to avoid their alteration, loss and unauthorized processing or access, taking into account the technology status, nature of the data stored and that they may face risks arising both human action and physical or natural environment. This is made under section 9 of the Spanish Personal Data Protection Organic Law and Spanish Royal Decree 1720/2007 on December 21 passing the Implementing Regulation of the Organic Law and the Spanish Information Society and Electronic Commerce Act 34/2002 on July 11.</p><p>Ajusa is committed to treat personal data confidentially and use it exclusively for the mentioned purposes.</p><p>VIII.-<span class="bold">Electronic Commerce Communications.</span>Ajusa makes available for Users, on their request through subscriptions forms for that purpose, the news, activities and information. The User may unsubscribe this communication service at any time by sending an email to:<u><a href="mailto:social@ajusa.es.">social@ajusa.es.</a></u></p><p>IX.<span class="bold">General Information.</span>Under Information Society and Electronic Commerce Services Act 34/2002 on July 11, Ajusa confirms the enforcement of the information duty under the terms provided in this regulation in order to enable both service purchasers and authorized bodies to access in a permanent, easy, direct and free way to the following information: Auto Juntas, S.A., Parque Empresarial Ajusa. Crta. De Ayora Km 2.2. 02008 Albacete. España. www.ajusa.online. Telephone: (+34) 967 216 212 Fax: 967 216 214. Registration Information in the Companies Registry: Book:311, FOLIO: 186, PAGE: AB-1504, FISCAL IDENTITY NUMBER: A-02007029.</p><p>X.<span class="bold">Information about the use of cookies.</span>The use of this site will be made at the sole and exclusive liability of User. Such liability will be extended to the use by the user or any third party, of any password o similar assigned to access the Site or any of its services.</p><p>Ajusa assumes no liability arising the content linked the Site, as long as they are not related to it and doesn’t guarantee the absence of virus or other elements which may produce alterations on hardware and software, on the documents or files of the user excluding any liability for damages to the user arising this reason.</p><p>Ajusa refuses any liability arising the wrong use of the content on these sites and reserves the right to them, erase them, establish restrictions or constrain access at any moment in a temporary or permanent way.</p><p>XII.-<span class="bold">Nullity and inefficacy of the clauses.</span>If any clause included in these General Conditions is declared null or ineffective totally or partially such nullity or inefficacy will only affect to such clause or the null or ineffective part, substituting the rest of General Conditions, considering such clause or part as erased.</p><p>XIII.-<span class="bold">Conflicts.</span>The Spanish legislation will apply to any dispute or conflict, being the Courts and Tribunals in Albacete authorized to solve all conflicts arising it.</p><p>The access to this site implies the acceptance of every condition expressed in this legal information. Ajusa shall modify or without prior notice the structure and design of the Site as well as changing or eliminating the services, contents and access and use conditions of the Site and adapt it to any legal change.</p></div></div>',
    popupCocheElectrico: {
      title: "AND NOW...<strong>COMPONENTS FOR ELECTRIC VEHICLES!</strong>",
      btnText: "VISIT"
    }
  }
};



// WEBPACK FOOTER //
// ./src/translations/index.js